(function() {
  "use strict";
  var _documentCurrentScript = typeof document !== "undefined" ? document.currentScript : null;
  /**
  * @vue/shared v3.5.42
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/
  // @__NO_SIDE_EFFECTS__
  function makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(",")) map[key] = 1;
    return (val) => val in map;
  }
  const EMPTY_OBJ = {};
  const EMPTY_ARR = [];
  const NOOP = () => {
  };
  const NO = () => false;
  const isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
  (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
  const isModelListener = (key) => key.startsWith("onUpdate:");
  const extend$1 = Object.assign;
  const remove = (arr, el) => {
    const i = arr.indexOf(el);
    if (i > -1) {
      arr.splice(i, 1);
    }
  };
  const hasOwnProperty$2 = Object.prototype.hasOwnProperty;
  const hasOwn = (val, key) => hasOwnProperty$2.call(val, key);
  const isArray$1 = Array.isArray;
  const isMap = (val) => toTypeString(val) === "[object Map]";
  const isSet$1 = (val) => toTypeString(val) === "[object Set]";
  const isDate$1 = (val) => toTypeString(val) === "[object Date]";
  const isFunction$2 = (val) => typeof val === "function";
  const isString$1 = (val) => typeof val === "string";
  const isSymbol = (val) => typeof val === "symbol";
  const isObject$1 = (val) => val !== null && typeof val === "object";
  const isPromise = (val) => {
    return (isObject$1(val) || isFunction$2(val)) && isFunction$2(val.then) && isFunction$2(val.catch);
  };
  const objectToString = Object.prototype.toString;
  const toTypeString = (value) => objectToString.call(value);
  const toRawType = (value) => {
    return toTypeString(value).slice(8, -1);
  };
  const isPlainObject$3 = (val) => toTypeString(val) === "[object Object]";
  const isIntegerKey = (key) => isString$1(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
  const isReservedProp = /* @__PURE__ */ makeMap(
    // the leading comma is intentional so empty string "" is also included
    ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
  );
  const cacheStringFunction = (fn) => {
    const cache = /* @__PURE__ */ Object.create(null);
    return ((str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    });
  };
  const camelizeRE = /-\w/g;
  const camelize = cacheStringFunction(
    (str) => {
      return str.replace(camelizeRE, (c) => c.slice(1).toUpperCase());
    }
  );
  const hyphenateRE = /\B([A-Z])/g;
  const hyphenate = cacheStringFunction(
    (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
  );
  const capitalize = cacheStringFunction((str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  const toHandlerKey = cacheStringFunction(
    (str) => {
      const s = str ? `on${capitalize(str)}` : ``;
      return s;
    }
  );
  const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
  const invokeArrayFns = (fns, ...arg) => {
    for (let i = 0; i < fns.length; i++) {
      fns[i](...arg);
    }
  };
  const def = (obj, key, value, writable = false) => {
    Object.defineProperty(obj, key, {
      configurable: true,
      enumerable: false,
      writable,
      value
    });
  };
  const looseToNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
  };
  const toNumber = (val) => {
    const n = isString$1(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
  };
  let _globalThis;
  const getGlobalThis = () => {
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof window !== "undefined" ? window : {});
  };
  function normalizeStyle(value) {
    if (isArray$1(value)) {
      const res = {};
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        const normalized = isString$1(item) ? parseStringStyle(item) : normalizeStyle(item);
        if (normalized) {
          for (const key in normalized) {
            res[key] = normalized[key];
          }
        }
      }
      return res;
    } else if (isString$1(value) || isObject$1(value)) {
      return value;
    }
  }
  const listDelimiterRE = /;(?![^(]*\))/g;
  const propertyDelimiterRE = /:([^]+)/;
  const styleCommentRE = /\/\*[^]*?\*\//g;
  function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
      if (item) {
        const tmp = item.split(propertyDelimiterRE);
        tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return ret;
  }
  function normalizeClass(value) {
    let res = "";
    if (isString$1(value)) {
      res = value;
    } else if (isArray$1(value)) {
      for (let i = 0; i < value.length; i++) {
        const normalized = normalizeClass(value[i]);
        if (normalized) {
          res += normalized + " ";
        }
      }
    } else if (isObject$1(value)) {
      for (const name in value) {
        if (value[name]) {
          res += name + " ";
        }
      }
    }
    return res.trim();
  }
  const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
  function includeBooleanAttr(value) {
    return !!value || value === "";
  }
  function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for (let i = 0; equal && i < a.length; i++) {
      equal = looseEqual(a[i], b[i]);
    }
    return equal;
  }
  function looseCompareCollections(a, b) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a) {
      let index = -1;
      for (let i = 0; i < candidates.length; i++) {
        if (!matched[i] && looseEqual(item, candidates[i])) {
          index = i;
          break;
        }
      }
      if (index < 0) return false;
      matched[index] = 1;
    }
    return true;
  }
  function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate$1(a);
    let bValidType = isDate$1(b);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    }
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) {
      return a === b;
    }
    aValidType = isArray$1(a);
    bValidType = isArray$1(b);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    }
    aValidType = isObject$1(a);
    bValidType = isObject$1(b);
    if (aValidType || bValidType) {
      if (!aValidType || !bValidType) {
        return false;
      }
      aValidType = isMap(a);
      bValidType = isMap(b);
      if (aValidType || bValidType) {
        return aValidType && bValidType ? looseCompareCollections(a, b) : false;
      }
      aValidType = isSet$1(a);
      bValidType = isSet$1(b);
      if (aValidType || bValidType) {
        return aValidType && bValidType ? looseCompareCollections(a, b) : false;
      }
      const aKeysCount = Object.keys(a).length;
      const bKeysCount = Object.keys(b).length;
      if (aKeysCount !== bKeysCount) {
        return false;
      }
      for (const key in a) {
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) {
          return false;
        }
      }
    }
    return String(a) === String(b);
  }
  function looseIndexOf(arr, val) {
    return arr.findIndex((item) => looseEqual(item, val));
  }
  const isRef$1 = (val) => {
    return !!(val && val["__v_isRef"] === true);
  };
  const toDisplayString = (val) => {
    return isString$1(val) ? val : val == null ? "" : isArray$1(val) || isObject$1(val) && (val.toString === objectToString || !isFunction$2(val.toString)) ? isRef$1(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
  };
  const replacer = (_key, val) => {
    if (isRef$1(val)) {
      return replacer(_key, val.value);
    } else if (isMap(val)) {
      return {
        [`Map(${val.size})`]: [...val.entries()].reduce(
          (entries, [key, val2], i) => {
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
          },
          {}
        )
      };
    } else if (isSet$1(val)) {
      return {
        [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
      };
    } else if (isSymbol(val)) {
      return stringifySymbol(val);
    } else if (isObject$1(val) && !isArray$1(val) && !isPlainObject$3(val)) {
      return String(val);
    }
    return val;
  };
  const stringifySymbol = (v, i = "") => {
    var _a;
    return (
      // Symbol.description in es2019+ so we need to cast here to pass
      // the lib: es2016 check
      isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v
    );
  };
  /**
  * @vue/reactivity v3.5.42
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/
  let activeEffectScope;
  class EffectScope {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false) {
      this.detached = detached;
      this._active = true;
      this._on = 0;
      this.effects = [];
      this.cleanups = [];
      this._isPaused = false;
      this._warnOnRun = true;
      this.__v_skip = true;
      if (!detached && activeEffectScope) {
        if (activeEffectScope.active) {
          this.parent = activeEffectScope;
          this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
            this
          ) - 1;
        } else {
          this._active = false;
          this._warnOnRun = false;
        }
      }
    }
    get active() {
      return this._active;
    }
    pause() {
      if (this._active) {
        this._isPaused = true;
        let i, l;
        if (this.scopes) {
          const scopes = this.scopes.slice();
          for (i = 0, l = scopes.length; i < l; i++) {
            scopes[i].pause();
          }
        }
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].pause();
        }
      }
    }
    /**
     * Resumes the effect scope, including all child scopes and effects.
     */
    resume() {
      if (this._active) {
        if (this._isPaused) {
          this._isPaused = false;
          let i, l;
          if (this.scopes) {
            const scopes = this.scopes.slice();
            for (i = 0, l = scopes.length; i < l; i++) {
              scopes[i].resume();
            }
          }
          const effects = this.effects.slice();
          for (i = 0, l = effects.length; i < l; i++) {
            effects[i].resume();
          }
        }
      }
    }
    run(fn) {
      if (this._active) {
        const currentEffectScope = activeEffectScope;
        try {
          activeEffectScope = this;
          return fn();
        } finally {
          activeEffectScope = currentEffectScope;
        }
      }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    on() {
      if (++this._on === 1) {
        this.prevScope = activeEffectScope;
        activeEffectScope = this;
      }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    off() {
      if (this._on > 0 && --this._on === 0) {
        if (activeEffectScope === this) {
          activeEffectScope = this.prevScope;
        } else {
          let current = activeEffectScope;
          while (current) {
            if (current.prevScope === this) {
              current.prevScope = this.prevScope;
              break;
            }
            current = current.prevScope;
          }
        }
        this.prevScope = void 0;
      }
    }
    stop(fromParent) {
      if (this._active) {
        this._active = false;
        let i, l;
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].stop();
        }
        this.effects.length = 0;
        for (i = 0, l = this.cleanups.length; i < l; i++) {
          this.cleanups[i]();
        }
        this.cleanups.length = 0;
        if (this.scopes) {
          const scopes = this.scopes.slice();
          for (i = 0, l = scopes.length; i < l; i++) {
            scopes[i].stop(true);
          }
          this.scopes.length = 0;
        }
        if (!this.detached && this.parent && !fromParent) {
          const last = this.parent.scopes.pop();
          if (last && last !== this) {
            this.parent.scopes[this.index] = last;
            last.index = this.index;
          }
        }
        this.parent = void 0;
      }
    }
  }
  function effectScope(detached) {
    return new EffectScope(detached);
  }
  function getCurrentScope() {
    return activeEffectScope;
  }
  function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) {
      activeEffectScope.cleanups.push(fn);
    }
  }
  let activeSub;
  const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
  class ReactiveEffect {
    constructor(fn) {
      this.fn = fn;
      this.deps = void 0;
      this.depsTail = void 0;
      this.flags = 1 | 4;
      this.next = void 0;
      this.cleanup = void 0;
      this.scheduler = void 0;
      if (activeEffectScope) {
        if (activeEffectScope.active) {
          activeEffectScope.effects.push(this);
        } else {
          this.flags &= -2;
        }
      }
    }
    pause() {
      this.flags |= 64;
    }
    resume() {
      if (this.flags & 64) {
        this.flags &= -65;
        if (pausedQueueEffects.has(this)) {
          pausedQueueEffects.delete(this);
          this.trigger();
        }
      }
    }
    /**
     * @internal
     */
    notify() {
      if (this.flags & 2 && !(this.flags & 32)) {
        return;
      }
      if (!(this.flags & 8)) {
        batch(this);
      }
    }
    run() {
      if (!(this.flags & 1)) {
        return this.fn();
      }
      this.flags |= 2;
      cleanupEffect(this);
      prepareDeps(this);
      const prevEffect = activeSub;
      const prevShouldTrack = shouldTrack;
      activeSub = this;
      shouldTrack = true;
      try {
        return this.fn();
      } finally {
        cleanupDeps(this);
        activeSub = prevEffect;
        shouldTrack = prevShouldTrack;
        this.flags &= -3;
      }
    }
    stop() {
      if (this.flags & 1) {
        for (let link = this.deps; link; link = link.nextDep) {
          removeSub(link);
        }
        this.deps = this.depsTail = void 0;
        cleanupEffect(this);
        this.onStop && this.onStop();
        this.flags &= -2;
      }
    }
    trigger() {
      if (this.flags & 64) {
        pausedQueueEffects.add(this);
      } else if (this.scheduler) {
        this.scheduler();
      } else {
        this.runIfDirty();
      }
    }
    /**
     * @internal
     */
    runIfDirty() {
      if (isDirty(this)) {
        this.run();
      }
    }
    get dirty() {
      return isDirty(this);
    }
  }
  let batchDepth = 0;
  let batchedSub;
  let batchedComputed;
  function batch(sub, isComputed2 = false) {
    sub.flags |= 8;
    if (isComputed2) {
      sub.next = batchedComputed;
      batchedComputed = sub;
      return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
  }
  function startBatch() {
    batchDepth++;
  }
  function endBatch() {
    if (--batchDepth > 0) {
      return;
    }
    if (batchedComputed) {
      let e = batchedComputed;
      batchedComputed = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= -9;
        e = next;
      }
    }
    let error;
    while (batchedSub) {
      let e = batchedSub;
      batchedSub = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= -9;
        if (e.flags & 1) {
          try {
            ;
            e.trigger();
          } catch (err) {
            if (!error) error = err;
          }
        }
        e = next;
      }
    }
    if (error) throw error;
  }
  function prepareDeps(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      link.version = -1;
      link.prevActiveLink = link.dep.activeLink;
      link.dep.activeLink = link;
    }
  }
  function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while (link) {
      const prev = link.prevDep;
      if (link.version === -1) {
        if (link === tail) tail = prev;
        removeSub(link);
        removeDep(link);
      } else {
        head = link;
      }
      link.dep.activeLink = link.prevActiveLink;
      link.prevActiveLink = void 0;
      link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
  }
  function isDirty(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
        return true;
      }
    }
    if (sub._dirty) {
      return true;
    }
    return false;
  }
  function refreshComputed(computed2) {
    if (computed2.flags & 4 && !(computed2.flags & 16)) {
      return;
    }
    computed2.flags &= -17;
    if (computed2.globalVersion === globalVersion) {
      return;
    }
    computed2.globalVersion = globalVersion;
    if (!computed2.isSSR && computed2.flags & 128 && (!computed2.deps && !computed2._dirty || !isDirty(computed2))) {
      return;
    }
    computed2.flags |= 2;
    const dep = computed2.dep;
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed2;
    shouldTrack = true;
    try {
      prepareDeps(computed2);
      const value = computed2.fn(computed2._value);
      if (dep.version === 0 || hasChanged(value, computed2._value)) {
        computed2.flags |= 128;
        computed2._value = value;
        dep.version++;
      }
    } catch (err) {
      dep.version++;
      throw err;
    } finally {
      activeSub = prevSub;
      shouldTrack = prevShouldTrack;
      cleanupDeps(computed2);
      computed2.flags &= -3;
    }
  }
  function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
      prevSub.nextSub = nextSub;
      link.prevSub = void 0;
    }
    if (nextSub) {
      nextSub.prevSub = prevSub;
      link.nextSub = void 0;
    }
    if (dep.subs === link) {
      dep.subs = prevSub;
      if (!prevSub && dep.computed) {
        dep.computed.flags &= -5;
        for (let l = dep.computed.deps; l; l = l.nextDep) {
          removeSub(l, true);
        }
      }
    }
    if (!soft && !--dep.sc && dep.map) {
      dep.map.delete(dep.key);
    }
  }
  function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
      prevDep.nextDep = nextDep;
      link.prevDep = void 0;
    }
    if (nextDep) {
      nextDep.prevDep = prevDep;
      link.nextDep = void 0;
    }
  }
  let shouldTrack = true;
  const trackStack = [];
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
      const prevSub = activeSub;
      activeSub = void 0;
      try {
        cleanup();
      } finally {
        activeSub = prevSub;
      }
    }
  }
  let globalVersion = 0;
  class Link {
    constructor(sub, dep) {
      this.sub = sub;
      this.dep = dep;
      this.version = dep.version;
      this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
  }
  class Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed2) {
      this.computed = computed2;
      this.version = 0;
      this.activeLink = void 0;
      this.subs = void 0;
      this.map = void 0;
      this.key = void 0;
      this.sc = 0;
      this.__v_skip = true;
    }
    track(debugInfo) {
      if (!activeSub || !shouldTrack || activeSub === this.computed) {
        return;
      }
      let link = this.activeLink;
      if (link === void 0 || link.sub !== activeSub) {
        link = this.activeLink = new Link(activeSub, this);
        if (!activeSub.deps) {
          activeSub.deps = activeSub.depsTail = link;
        } else {
          link.prevDep = activeSub.depsTail;
          activeSub.depsTail.nextDep = link;
          activeSub.depsTail = link;
        }
        addSub(link);
      } else if (link.version === -1) {
        link.version = this.version;
        if (link.nextDep) {
          const next = link.nextDep;
          next.prevDep = link.prevDep;
          if (link.prevDep) {
            link.prevDep.nextDep = next;
          }
          link.prevDep = activeSub.depsTail;
          link.nextDep = void 0;
          activeSub.depsTail.nextDep = link;
          activeSub.depsTail = link;
          if (activeSub.deps === link) {
            activeSub.deps = next;
          }
        }
      }
      return link;
    }
    trigger(debugInfo) {
      this.version++;
      globalVersion++;
      this.notify(debugInfo);
    }
    notify(debugInfo) {
      startBatch();
      try {
        if (false) ;
        for (let link = this.subs; link; link = link.prevSub) {
          if (link.sub.notify()) {
            ;
            link.sub.dep.notify();
          }
        }
      } finally {
        endBatch();
      }
    }
  }
  function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
      const computed2 = link.dep.computed;
      if (computed2 && !link.dep.subs) {
        computed2.flags |= 4 | 16;
        for (let l = computed2.deps; l; l = l.nextDep) {
          addSub(l);
        }
      }
      const currentTail = link.dep.subs;
      if (currentTail !== link) {
        link.prevSub = currentTail;
        if (currentTail) currentTail.nextSub = link;
      }
      link.dep.subs = link;
    }
  }
  const targetMap = /* @__PURE__ */ new WeakMap();
  const ITERATE_KEY = /* @__PURE__ */ Symbol(
    ""
  );
  const MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol(
    ""
  );
  const ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol(
    ""
  );
  function track(target, type, key) {
    if (shouldTrack && activeSub) {
      let depsMap = targetMap.get(target);
      if (!depsMap) {
        targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
      }
      let dep = depsMap.get(key);
      if (!dep) {
        depsMap.set(key, dep = new Dep());
        dep.map = depsMap;
        dep.key = key;
      }
      {
        dep.track();
      }
    }
  }
  function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
      globalVersion++;
      return;
    }
    const run = (dep) => {
      if (dep) {
        {
          dep.trigger();
        }
      }
    };
    startBatch();
    if (type === "clear") {
      depsMap.forEach(run);
    } else {
      const targetIsArray = isArray$1(target);
      const isArrayIndex = targetIsArray && isIntegerKey(key);
      if (targetIsArray && key === "length") {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2) => {
          if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
            run(dep);
          }
        });
      } else {
        if (key !== void 0 || depsMap.has(void 0)) {
          run(depsMap.get(key));
        }
        if (isArrayIndex) {
          run(depsMap.get(ARRAY_ITERATE_KEY));
        }
        switch (type) {
          case "add":
            if (!targetIsArray) {
              run(depsMap.get(ITERATE_KEY));
              if (isMap(target)) {
                run(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            } else if (isArrayIndex) {
              run(depsMap.get("length"));
            }
            break;
          case "delete":
            if (!targetIsArray) {
              run(depsMap.get(ITERATE_KEY));
              if (isMap(target)) {
                run(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            }
            break;
          case "set":
            if (isMap(target)) {
              run(depsMap.get(ITERATE_KEY));
            }
            break;
        }
      }
    }
    endBatch();
  }
  function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
  }
  function reactiveReadArray(array) {
    const raw = /* @__PURE__ */ toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return /* @__PURE__ */ isShallow(array) ? raw : raw.map(toReactive);
  }
  function shallowReadArray(arr) {
    track(arr = /* @__PURE__ */ toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
  }
  function toWrapped(target, item) {
    if (/* @__PURE__ */ isReadonly(target)) {
      return /* @__PURE__ */ isReactive(target) ? toReadonly(toReactive(item)) : toReadonly(item);
    }
    return toReactive(item);
  }
  const arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator]() {
      return iterator$1(this, Symbol.iterator, (item) => toWrapped(this, item));
    },
    concat(...args) {
      return reactiveReadArray(this).concat(
        ...args.map((x) => isArray$1(x) ? reactiveReadArray(x) : x)
      );
    },
    entries() {
      return iterator$1(this, "entries", (value) => {
        value[1] = toWrapped(this, value[1]);
        return value;
      });
    },
    every(fn, thisArg) {
      return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter(fn, thisArg) {
      return apply(
        this,
        "filter",
        fn,
        thisArg,
        (v) => v.map((item) => toWrapped(this, item)),
        arguments
      );
    },
    find(fn, thisArg) {
      return apply(
        this,
        "find",
        fn,
        thisArg,
        (item) => toWrapped(this, item),
        arguments
      );
    },
    findIndex(fn, thisArg) {
      return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast(fn, thisArg) {
      return apply(
        this,
        "findLast",
        fn,
        thisArg,
        (item) => toWrapped(this, item),
        arguments
      );
    },
    findLastIndex(fn, thisArg) {
      return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach(fn, thisArg) {
      return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes(...args) {
      return searchProxy(this, "includes", args);
    },
    indexOf(...args) {
      return searchProxy(this, "indexOf", args);
    },
    join(separator) {
      return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf(...args) {
      return searchProxy(this, "lastIndexOf", args);
    },
    map(fn, thisArg) {
      return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop() {
      return noTracking(this, "pop");
    },
    push(...args) {
      return noTracking(this, "push", args);
    },
    reduce(fn, ...args) {
      return reduce(this, "reduce", fn, args);
    },
    reduceRight(fn, ...args) {
      return reduce(this, "reduceRight", fn, args);
    },
    shift() {
      return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some(fn, thisArg) {
      return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice(...args) {
      return noTracking(this, "splice", args);
    },
    toReversed() {
      return reactiveReadArray(this).toReversed();
    },
    toSorted(comparer) {
      return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced(...args) {
      return reactiveReadArray(this).toSpliced(...args);
    },
    unshift(...args) {
      return noTracking(this, "unshift", args);
    },
    values() {
      return iterator$1(this, "values", (item) => toWrapped(this, item));
    }
  };
  function iterator$1(self2, method, wrapValue) {
    const arr = shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !/* @__PURE__ */ isShallow(self2)) {
      iter._next = iter.next;
      iter.next = () => {
        const result = iter._next();
        if (!result.done) {
          result.value = wrapValue(result.value);
        }
        return result;
      };
    }
    return iter;
  }
  const arrayProto = Array.prototype;
  function apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self2);
    const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
      const result2 = methodFn.apply(self2, args);
      return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
      if (needsWrap) {
        wrappedFn = function(item, index) {
          return fn.call(this, toWrapped(self2, item), index, self2);
        };
      } else if (fn.length > 2) {
        wrappedFn = function(item, index) {
          return fn.call(this, item, index, self2);
        };
      }
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
  }
  function reduce(self2, method, fn, args) {
    const arr = shallowReadArray(self2);
    const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
      if (needsWrap) {
        wrapInitialAccumulator = args.length === 0;
        wrappedFn = function(acc, item, index) {
          if (wrapInitialAccumulator) {
            wrapInitialAccumulator = false;
            acc = toWrapped(self2, acc);
          }
          return fn.call(this, acc, toWrapped(self2, item), index, self2);
        };
      } else if (fn.length > 3) {
        wrappedFn = function(acc, item, index) {
          return fn.call(this, acc, item, index, self2);
        };
      }
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? toWrapped(self2, result) : result;
  }
  function searchProxy(self2, method, args) {
    const arr = /* @__PURE__ */ toRaw(self2);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && /* @__PURE__ */ isProxy(args[0])) {
      args[0] = /* @__PURE__ */ toRaw(args[0]);
      return arr[method](...args);
    }
    return res;
  }
  function noTracking(self2, method, args = []) {
    pauseTracking();
    startBatch();
    const res = (/* @__PURE__ */ toRaw(self2))[method].apply(self2, args);
    endBatch();
    resetTracking();
    return res;
  }
  const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
  const builtInSymbols = new Set(
    /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
  );
  function hasOwnProperty$1(key) {
    if (!isSymbol(key)) key = String(key);
    const obj = /* @__PURE__ */ toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
  }
  class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false) {
      this._isReadonly = _isReadonly;
      this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
      if (key === "__v_skip") return target["__v_skip"];
      const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_isShallow") {
        return isShallow2;
      } else if (key === "__v_raw") {
        if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
        // this means the receiver is a user proxy of the reactive proxy
        Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) {
          return target;
        }
        return;
      }
      const targetIsArray = isArray$1(target);
      if (!isReadonly2) {
        let fn;
        if (targetIsArray && (fn = arrayInstrumentations[key])) {
          return fn;
        }
        if (key === "hasOwnProperty") {
          return hasOwnProperty$1;
        }
      }
      const res = Reflect.get(
        target,
        key,
        // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        /* @__PURE__ */ isRef(target) ? target : receiver
      );
      if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
        return res;
      }
      if (!isReadonly2) {
        track(target, "get", key);
      }
      if (isShallow2) {
        return res;
      }
      if (/* @__PURE__ */ isRef(res)) {
        const value = targetIsArray && isIntegerKey(key) ? res : res.value;
        return isReadonly2 && isObject$1(value) ? /* @__PURE__ */ readonly(value) : value;
      }
      if (isObject$1(res)) {
        return isReadonly2 ? /* @__PURE__ */ readonly(res) : /* @__PURE__ */ reactive(res);
      }
      return res;
    }
  }
  class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false) {
      super(false, isShallow2);
    }
    set(target, key, value, receiver) {
      let oldValue = target[key];
      const isArrayWithIntegerKey = isArray$1(target) && isIntegerKey(key);
      if (!this._isShallow) {
        const isOldValueReadonly = /* @__PURE__ */ isReadonly(oldValue);
        if (!/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
          oldValue = /* @__PURE__ */ toRaw(oldValue);
          value = /* @__PURE__ */ toRaw(value);
        }
        if (!isArrayWithIntegerKey && /* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
          if (isOldValueReadonly) {
            return true;
          } else {
            oldValue.value = value;
            return true;
          }
        }
      }
      const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : hasOwn(target, key);
      const result = Reflect.set(
        target,
        key,
        value,
        /* @__PURE__ */ isRef(target) ? target : receiver
      );
      if (target === /* @__PURE__ */ toRaw(receiver) && result) {
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value);
        }
      }
      return result;
    }
    deleteProperty(target, key) {
      const hadKey = hasOwn(target, key);
      target[key];
      const result = Reflect.deleteProperty(target, key);
      if (result && hadKey) {
        trigger(target, "delete", key, void 0);
      }
      return result;
    }
    has(target, key) {
      const result = Reflect.has(target, key);
      if (!isSymbol(key) || !builtInSymbols.has(key)) {
        track(target, "has", key);
      }
      return result;
    }
    ownKeys(target) {
      track(
        target,
        "iterate",
        isArray$1(target) ? "length" : ITERATE_KEY
      );
      return Reflect.ownKeys(target);
    }
  }
  class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false) {
      super(true, isShallow2);
    }
    set(target, key) {
      return true;
    }
    deleteProperty(target, key) {
      return true;
    }
  }
  const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
  const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
  const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
  const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
  const toShallow = (value) => value;
  const getProto = (v) => Reflect.getPrototypeOf(v);
  function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
      const target = this["__v_raw"];
      const rawTarget = /* @__PURE__ */ toRaw(target);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
      !isReadonly2 && track(
        rawTarget,
        "iterate",
        isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
      );
      return extend$1(
        // inheriting all iterator properties
        Object.create(innerIterator),
        {
          // iterator protocol
          next() {
            const { value, done } = innerIterator.next();
            return done ? { value, done } : {
              value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
              done
            };
          }
        }
      );
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
  }
  function createInstrumentations(readonly2, shallow) {
    const instrumentations = {
      get(key) {
        const target = this["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const rawKey = /* @__PURE__ */ toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "get", key);
          }
          track(rawTarget, "get", rawKey);
        }
        const { has } = getProto(rawTarget);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        if (has.call(rawTarget, key)) {
          return wrap(target.get(key));
        } else if (has.call(rawTarget, rawKey)) {
          return wrap(target.get(rawKey));
        } else if (target !== rawTarget) {
          target.get(key);
        }
      },
      get size() {
        const target = this["__v_raw"];
        !readonly2 && track(/* @__PURE__ */ toRaw(target), "iterate", ITERATE_KEY);
        return target.size;
      },
      has(key) {
        const target = this["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const rawKey = /* @__PURE__ */ toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "has", key);
          }
          track(rawTarget, "has", rawKey);
        }
        return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
      },
      forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
        return target.forEach((value, key) => {
          return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
      }
    };
    extend$1(
      instrumentations,
      readonly2 ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
      } : {
        add(value) {
          const target = /* @__PURE__ */ toRaw(this);
          const proto = getProto(target);
          const rawValue = /* @__PURE__ */ toRaw(value);
          const valueToAdd = !shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value) ? rawValue : value;
          const hadKey = proto.has.call(target, valueToAdd) || hasChanged(value, valueToAdd) && proto.has.call(target, value) || hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
          if (!hadKey) {
            target.add(valueToAdd);
            trigger(target, "add", valueToAdd, valueToAdd);
          }
          return this;
        },
        set(key, value) {
          if (!shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
            value = /* @__PURE__ */ toRaw(value);
          }
          const target = /* @__PURE__ */ toRaw(this);
          const { has, get } = getProto(target);
          let hadKey = has.call(target, key);
          if (!hadKey) {
            key = /* @__PURE__ */ toRaw(key);
            hadKey = has.call(target, key);
          }
          const oldValue = get.call(target, key);
          target.set(key, value);
          if (!hadKey) {
            trigger(target, "add", key, value);
          } else if (hasChanged(value, oldValue)) {
            trigger(target, "set", key, value);
          }
          return this;
        },
        delete(key) {
          const target = /* @__PURE__ */ toRaw(this);
          const { has, get } = getProto(target);
          let hadKey = has.call(target, key);
          if (!hadKey) {
            key = /* @__PURE__ */ toRaw(key);
            hadKey = has.call(target, key);
          }
          get ? get.call(target, key) : void 0;
          const result = target.delete(key);
          if (hadKey) {
            trigger(target, "delete", key, void 0);
          }
          return result;
        },
        clear() {
          const target = /* @__PURE__ */ toRaw(this);
          const hadItems = target.size !== 0;
          const result = target.clear();
          if (hadItems) {
            trigger(
              target,
              "clear",
              void 0,
              void 0
            );
          }
          return result;
        }
      }
    );
    const iteratorMethods = [
      "keys",
      "values",
      "entries",
      Symbol.iterator
    ];
    iteratorMethods.forEach((method) => {
      instrumentations[method] = createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
  }
  function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw") {
        return target;
      }
      return Reflect.get(
        hasOwn(instrumentations, key) && key in target ? instrumentations : target,
        key,
        receiver
      );
    };
  }
  const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
  };
  const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
  };
  const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
  };
  const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
  };
  const reactiveMap = /* @__PURE__ */ new WeakMap();
  const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
  const readonlyMap = /* @__PURE__ */ new WeakMap();
  const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  // @__NO_SIDE_EFFECTS__
  function reactive(target) {
    if (/* @__PURE__ */ isReadonly(target)) {
      return target;
    }
    return createReactiveObject(
      target,
      false,
      mutableHandlers,
      mutableCollectionHandlers,
      reactiveMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function shallowReactive(target) {
    return createReactiveObject(
      target,
      false,
      shallowReactiveHandlers,
      shallowCollectionHandlers,
      shallowReactiveMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function readonly(target) {
    return createReactiveObject(
      target,
      true,
      readonlyHandlers,
      readonlyCollectionHandlers,
      readonlyMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function shallowReadonly(target) {
    return createReactiveObject(
      target,
      true,
      shallowReadonlyHandlers,
      shallowReadonlyCollectionHandlers,
      shallowReadonlyMap
    );
  }
  function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject$1(target)) {
      return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
      return target;
    }
    if (target["__v_skip"] || !Object.isExtensible(target)) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = targetTypeMap(toRawType(target));
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(
      target,
      targetType === 2 ? collectionHandlers : baseHandlers
    );
    proxyMap.set(target, proxy);
    return proxy;
  }
  // @__NO_SIDE_EFFECTS__
  function isReactive(value) {
    if (/* @__PURE__ */ isReadonly(value)) {
      return /* @__PURE__ */ isReactive(value["__v_raw"]);
    }
    return !!(value && value["__v_isReactive"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
  }
  // @__NO_SIDE_EFFECTS__
  function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ toRaw(raw) : observed;
  }
  function markRaw(value) {
    if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
      def(value, "__v_skip", true);
    }
    return value;
  }
  const toReactive = (value) => isObject$1(value) ? /* @__PURE__ */ reactive(value) : value;
  const toReadonly = (value) => isObject$1(value) ? /* @__PURE__ */ readonly(value) : value;
  // @__NO_SIDE_EFFECTS__
  function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
  }
  // @__NO_SIDE_EFFECTS__
  function ref(value) {
    return createRef(value, false);
  }
  function createRef(rawValue, shallow) {
    if (/* @__PURE__ */ isRef(rawValue)) {
      return rawValue;
    }
    return new RefImpl(rawValue, shallow);
  }
  class RefImpl {
    constructor(value, isShallow2) {
      this.dep = new Dep();
      this["__v_isRef"] = true;
      this["__v_isShallow"] = false;
      this._rawValue = isShallow2 ? value : /* @__PURE__ */ toRaw(value);
      this._value = isShallow2 ? value : toReactive(value);
      this["__v_isShallow"] = isShallow2;
    }
    get value() {
      {
        this.dep.track();
      }
      return this._value;
    }
    set value(newValue) {
      const oldValue = this._rawValue;
      const useDirectValue = this["__v_isShallow"] || /* @__PURE__ */ isShallow(newValue) || /* @__PURE__ */ isReadonly(newValue);
      newValue = useDirectValue ? newValue : /* @__PURE__ */ toRaw(newValue);
      if (hasChanged(newValue, oldValue)) {
        this._rawValue = newValue;
        this._value = useDirectValue ? newValue : toReactive(newValue);
        {
          this.dep.trigger();
        }
      }
    }
  }
  function unref(ref2) {
    return /* @__PURE__ */ isRef(ref2) ? ref2.value : ref2;
  }
  const shallowUnwrapHandlers = {
    get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver) => {
      const oldValue = target[key];
      if (/* @__PURE__ */ isRef(oldValue) && !/* @__PURE__ */ isRef(value)) {
        oldValue.value = value;
        return true;
      } else {
        return Reflect.set(target, key, value, receiver);
      }
    }
  };
  function proxyRefs(objectWithRefs) {
    return /* @__PURE__ */ isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
  }
  // @__NO_SIDE_EFFECTS__
  function toRefs(object) {
    const ret = isArray$1(object) ? new Array(object.length) : {};
    for (const key in object) {
      ret[key] = propertyToRef(object, key);
    }
    return ret;
  }
  class ObjectRefImpl {
    constructor(_object, key, _defaultValue) {
      this._object = _object;
      this._defaultValue = _defaultValue;
      this["__v_isRef"] = true;
      this._value = void 0;
      this._key = isSymbol(key) ? key : String(key);
      this._raw = /* @__PURE__ */ toRaw(_object);
      let shallow = true;
      let obj = _object;
      if (!isArray$1(_object) || isSymbol(this._key) || !isIntegerKey(this._key)) {
        do {
          shallow = !/* @__PURE__ */ isProxy(obj) || /* @__PURE__ */ isShallow(obj);
        } while (shallow && (obj = obj["__v_raw"]));
      }
      this._shallow = shallow;
    }
    get value() {
      let val = this._object[this._key];
      if (this._shallow) {
        val = unref(val);
      }
      return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
      if (this._shallow && /* @__PURE__ */ isRef(this._raw[this._key])) {
        const nestedRef = this._object[this._key];
        if (/* @__PURE__ */ isRef(nestedRef)) {
          nestedRef.value = newVal;
          return;
        }
      }
      this._object[this._key] = newVal;
    }
    get dep() {
      return getDepFromReactive(this._raw, this._key);
    }
  }
  function propertyToRef(source, key, defaultValue) {
    return new ObjectRefImpl(source, key, defaultValue);
  }
  class ComputedRefImpl {
    constructor(fn, setter, isSSR) {
      this.fn = fn;
      this.setter = setter;
      this._value = void 0;
      this.dep = new Dep(this);
      this.__v_isRef = true;
      this.deps = void 0;
      this.depsTail = void 0;
      this.flags = 16;
      this.globalVersion = globalVersion - 1;
      this.next = void 0;
      this.effect = this;
      this["__v_isReadonly"] = !setter;
      this.isSSR = isSSR;
    }
    /**
     * @internal
     */
    notify() {
      this.flags |= 16;
      if (!(this.flags & 8) && // avoid infinite self recursion
      activeSub !== this) {
        batch(this, true);
        return true;
      }
    }
    get value() {
      const link = this.dep.track();
      refreshComputed(this);
      if (link) {
        link.version = this.dep.version;
      }
      return this._value;
    }
    set value(newValue) {
      if (this.setter) {
        this.setter(newValue);
      }
    }
  }
  // @__NO_SIDE_EFFECTS__
  function computed$1(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if (isFunction$2(getterOrOptions)) {
      getter = getterOrOptions;
    } else {
      getter = getterOrOptions.get;
      setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
  }
  const INITIAL_WATCHER_VALUE = {};
  const cleanupMap = /* @__PURE__ */ new WeakMap();
  let activeWatcher = void 0;
  function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
      let cleanups = cleanupMap.get(owner);
      if (!cleanups) cleanupMap.set(owner, cleanups = []);
      cleanups.push(cleanupFn);
    }
  }
  function watch$1(source, cb, options = EMPTY_OBJ) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const reactiveGetter = (source2) => {
      if (deep) return source2;
      if (/* @__PURE__ */ isShallow(source2) || deep === false || deep === 0)
        return traverse(source2, 1);
      return traverse(source2);
    };
    let effect2;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (/* @__PURE__ */ isRef(source)) {
      getter = () => source.value;
      forceTrigger = /* @__PURE__ */ isShallow(source);
    } else if (/* @__PURE__ */ isReactive(source)) {
      getter = () => reactiveGetter(source);
      forceTrigger = true;
    } else if (isArray$1(source)) {
      isMultiSource = true;
      forceTrigger = source.some((s) => /* @__PURE__ */ isReactive(s) || /* @__PURE__ */ isShallow(s));
      getter = () => source.map((s) => {
        if (/* @__PURE__ */ isRef(s)) {
          return s.value;
        } else if (/* @__PURE__ */ isReactive(s)) {
          return reactiveGetter(s);
        } else if (isFunction$2(s)) {
          return call ? call(s, 2) : s();
        } else ;
      });
    } else if (isFunction$2(source)) {
      if (cb) {
        getter = call ? () => call(source, 2) : source;
      } else {
        getter = () => {
          if (cleanup) {
            pauseTracking();
            try {
              cleanup();
            } finally {
              resetTracking();
            }
          }
          const currentEffect = activeWatcher;
          activeWatcher = effect2;
          try {
            return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
          } finally {
            activeWatcher = currentEffect;
          }
        };
      }
    } else {
      getter = NOOP;
    }
    if (cb && deep) {
      const baseGetter = getter;
      const depth = deep === true ? Infinity : deep;
      getter = () => traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = () => {
      effect2.stop();
      if (scope && scope.active) {
        remove(scope.effects, effect2);
      }
    };
    if (once && cb) {
      const _cb = cb;
      cb = (...args) => {
        const res = _cb(...args);
        watchHandle();
        return res;
      };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun) => {
      if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
        return;
      }
      if (cb) {
        const newValue = effect2.run();
        if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
          if (cleanup) {
            cleanup();
          }
          const currentWatcher = activeWatcher;
          activeWatcher = effect2;
          try {
            const args = [
              newValue,
              // pass undefined as the old value when it's changed for the first time
              oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
              boundCleanup
            ];
            oldValue = newValue;
            call ? call(cb, 3, args) : (
              // @ts-expect-error
              cb(...args)
            );
          } finally {
            activeWatcher = currentWatcher;
          }
        }
      } else {
        effect2.run();
      }
    };
    if (augmentJob) {
      augmentJob(job);
    }
    effect2 = new ReactiveEffect(getter);
    effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
    boundCleanup = (fn) => onWatcherCleanup(fn, false, effect2);
    cleanup = effect2.onStop = () => {
      const cleanups = cleanupMap.get(effect2);
      if (cleanups) {
        if (call) {
          call(cleanups, 4);
        } else {
          for (const cleanup2 of cleanups) cleanup2();
        }
        cleanupMap.delete(effect2);
      }
    };
    if (cb) {
      if (immediate) {
        job(true);
      } else {
        oldValue = effect2.run();
      }
    } else if (scheduler) {
      scheduler(job.bind(null, true), true);
    } else {
      effect2.run();
    }
    watchHandle.pause = effect2.pause.bind(effect2);
    watchHandle.resume = effect2.resume.bind(effect2);
    watchHandle.stop = watchHandle;
    return watchHandle;
  }
  function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !isObject$1(value) || value["__v_skip"]) {
      return value;
    }
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) {
      return value;
    }
    seen.set(value, depth);
    depth--;
    if (/* @__PURE__ */ isRef(value)) {
      traverse(value.value, depth, seen);
    } else if (isArray$1(value)) {
      for (let i = 0; i < value.length; i++) {
        traverse(value[i], depth, seen);
      }
    } else if (isSet$1(value) || isMap(value)) {
      value.forEach((v) => {
        traverse(v, depth, seen);
      });
    } else if (isPlainObject$3(value)) {
      for (const key in value) {
        traverse(value[key], depth, seen);
      }
      for (const key of Object.getOwnPropertySymbols(value)) {
        if (Object.prototype.propertyIsEnumerable.call(value, key)) {
          traverse(value[key], depth, seen);
        }
      }
    }
    return value;
  }
  /**
  * @vue/runtime-core v3.5.42
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/
  const stack = [];
  let isWarning = false;
  function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    pauseTracking();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) {
      callWithErrorHandling(
        appWarnHandler,
        instance,
        11,
        [
          // eslint-disable-next-line no-restricted-syntax
          msg + args.map((a) => {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
          }).join(""),
          instance && instance.proxy,
          trace.map(
            ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
          ).join("\n"),
          trace
        ]
      );
    } else {
      const warnArgs = [`[Vue warn]: ${msg}`, ...args];
      if (trace.length && // avoid spamming console during tests
      true) {
        warnArgs.push(`
`, ...formatTrace(trace));
      }
      console.warn(...warnArgs);
    }
    resetTracking();
    isWarning = false;
  }
  function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
      return [];
    }
    const normalizedStack = [];
    while (currentVNode) {
      const last = normalizedStack[0];
      if (last && last.vnode === currentVNode) {
        last.recurseCount++;
      } else {
        normalizedStack.push({
          vnode: currentVNode,
          recurseCount: 0
        });
      }
      const parentInstance = currentVNode.component && currentVNode.component.parent;
      currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
  }
  function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i) => {
      logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
    });
    return logs;
  }
  function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(
      vnode.component,
      vnode.type,
      isRoot
    )}`;
    const close = `>` + postfix;
    return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
  }
  function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key) => {
      res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) {
      res.push(` ...`);
    }
    return res;
  }
  function formatProp(key, value, raw) {
    if (isString$1(value)) {
      value = JSON.stringify(value);
      return raw ? value : [`${key}=${value}`];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
      return raw ? value : [`${key}=${value}`];
    } else if (/* @__PURE__ */ isRef(value)) {
      value = formatProp(key, /* @__PURE__ */ toRaw(value.value), true);
      return raw ? value : [`${key}=Ref<`, value, `>`];
    } else if (isFunction$2(value)) {
      return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
    } else {
      value = /* @__PURE__ */ toRaw(value);
      return raw ? value : [`${key}=`, value];
    }
  }
  function callWithErrorHandling(fn, instance, type, args) {
    try {
      return args ? fn(...args) : fn();
    } catch (err) {
      handleError(err, instance, type);
    }
  }
  function callWithAsyncErrorHandling(fn, instance, type, args) {
    if (isFunction$2(fn)) {
      const res = callWithErrorHandling(fn, instance, type, args);
      if (res && isPromise(res)) {
        res.catch((err) => {
          handleError(err, instance, type);
        });
      }
      return res;
    }
    if (isArray$1(fn)) {
      const values = [];
      for (let i = 0; i < fn.length; i++) {
        values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
      }
      return values;
    }
  }
  function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
    if (instance) {
      let cur = instance.parent;
      const exposedInstance = instance.proxy;
      const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
      while (cur) {
        const errorCapturedHooks = cur.ec;
        if (errorCapturedHooks) {
          for (let i = 0; i < errorCapturedHooks.length; i++) {
            if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
              return;
            }
          }
        }
        cur = cur.parent;
      }
      if (errorHandler) {
        pauseTracking();
        callWithErrorHandling(errorHandler, null, 10, [
          err,
          exposedInstance,
          errorInfo
        ]);
        resetTracking();
        return;
      }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
  }
  function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) {
      throw err;
    } else {
      console.error(err);
    }
  }
  const queue = [];
  let flushIndex = -1;
  const pendingPostFlushCbs = [];
  let activePostFlushCbs = null;
  let postFlushIndex = 0;
  const resolvedPromise = /* @__PURE__ */ Promise.resolve();
  let currentFlushPromise = null;
  function nextTick(fn) {
    const p2 = currentFlushPromise || resolvedPromise;
    return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
  }
  function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while (start < end) {
      const middle = start + end >>> 1;
      const middleJob = queue[middle];
      const middleJobId = getId(middleJob);
      if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
        start = middle + 1;
      } else {
        end = middle;
      }
    }
    return start;
  }
  function queueJob(job) {
    if (!(job.flags & 1)) {
      const jobId = getId(job);
      const lastJob = queue[queue.length - 1];
      if (!lastJob || // fast path when the job id is larger than the tail
      !(job.flags & 2) && jobId >= getId(lastJob)) {
        queue.push(job);
      } else {
        queue.splice(findInsertionIndex(jobId), 0, job);
      }
      job.flags |= 1;
      queueFlush();
    }
  }
  function queueFlush() {
    if (!currentFlushPromise) {
      currentFlushPromise = resolvedPromise.then(flushJobs);
    }
  }
  function queuePostFlushCb(cb) {
    if (!isArray$1(cb)) {
      if (activePostFlushCbs && cb.id === -1) {
        activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
      } else if (!(cb.flags & 1)) {
        pendingPostFlushCbs.push(cb);
        cb.flags |= 1;
      }
    } else {
      for (let i = 0; i < cb.length; i++) {
        pendingPostFlushCbs.push(cb[i]);
      }
    }
    queueFlush();
  }
  function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
    for (; i < queue.length; i++) {
      const cb = queue[i];
      if (cb && cb.flags & 2) {
        if (instance && cb.id !== instance.uid) {
          continue;
        }
        queue.splice(i, 1);
        i--;
        if (cb.flags & 4) {
          cb.flags &= -2;
        }
        cb();
        if (!(cb.flags & 4)) {
          cb.flags &= -2;
        }
      }
    }
  }
  function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
      const deduped = [...new Set(pendingPostFlushCbs)].sort(
        (a, b) => getId(a) - getId(b)
      );
      pendingPostFlushCbs.length = 0;
      if (activePostFlushCbs) {
        for (let i = 0; i < deduped.length; i++) {
          activePostFlushCbs.push(deduped[i]);
        }
        return;
      }
      activePostFlushCbs = deduped;
      for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
        const cb = activePostFlushCbs[postFlushIndex];
        if (cb.flags & 4) {
          cb.flags &= -2;
        }
        if (!(cb.flags & 8)) cb();
        cb.flags &= -2;
      }
      activePostFlushCbs = null;
      postFlushIndex = 0;
    }
  }
  const getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
  function flushJobs(seen) {
    try {
      for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job && !(job.flags & 8)) {
          if (false) ;
          if (job.flags & 4) {
            job.flags &= ~1;
          }
          callWithErrorHandling(
            job,
            job.i,
            job.i ? 15 : 14
          );
          if (!(job.flags & 4)) {
            job.flags &= ~1;
          }
        }
      }
    } finally {
      for (; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job) {
          job.flags &= -2;
        }
      }
      flushIndex = -1;
      queue.length = 0;
      flushPostFlushCbs();
      currentFlushPromise = null;
      if (queue.length || pendingPostFlushCbs.length) {
        flushJobs();
      }
    }
  }
  let currentRenderingInstance = null;
  let currentScopeId = null;
  function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
  }
  function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) {
      return fn;
    }
    const renderFnWithContext = (...args) => {
      if (renderFnWithContext._d) {
        setBlockTracking(-1);
      }
      const prevInstance = setCurrentRenderingInstance(ctx);
      const prevStackSize = blockStack.length;
      let res;
      try {
        res = fn(...args);
      } finally {
        for (let i = blockStack.length; i > prevStackSize; i--) closeBlock();
        setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) {
          setBlockTracking(1);
        }
      }
      return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
  }
  function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) {
      return vnode;
    }
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for (let i = 0; i < directives.length; i++) {
      let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
      if (dir) {
        if (isFunction$2(dir)) {
          dir = {
            mounted: dir,
            updated: dir
          };
        }
        if (dir.deep) {
          traverse(value);
        }
        bindings.push({
          dir,
          instance,
          value,
          oldValue: void 0,
          arg,
          modifiers
        });
      }
    }
    return vnode;
  }
  function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for (let i = 0; i < bindings.length; i++) {
      const binding = bindings[i];
      if (oldBindings) {
        binding.oldValue = oldBindings[i].value;
      }
      let hook = binding.dir[name];
      if (hook) {
        pauseTracking();
        callWithAsyncErrorHandling(hook, instance, 8, [
          vnode.el,
          binding,
          vnode,
          prevVNode
        ]);
        resetTracking();
      }
    }
  }
  function provide(key, value) {
    if (currentInstance) {
      let provides = currentInstance.provides;
      const parentProvides = currentInstance.parent && currentInstance.parent.provides;
      if (parentProvides === provides) {
        provides = currentInstance.provides = Object.create(parentProvides);
      }
      provides[key] = value;
    }
  }
  function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = getCurrentInstance();
    if (instance || currentApp) {
      let provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
      if (provides && key in provides) {
        return provides[key];
      } else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction$2(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
      } else ;
    }
  }
  function hasInjectionContext() {
    return !!(getCurrentInstance() || currentApp);
  }
  const ssrContextKey = /* @__PURE__ */ Symbol.for("v-scx");
  const useSSRContext = () => {
    {
      const ctx = inject(ssrContextKey);
      return ctx;
    }
  };
  function watch(source, cb, options) {
    return doWatch(source, cb, options);
  }
  function doWatch(source, cb, options = EMPTY_OBJ) {
    const { immediate, deep, flush, once } = options;
    const baseWatchOptions = extend$1({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
      if (flush === "sync") {
        const ctx = useSSRContext();
        ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
      } else if (!runsImmediately) {
        const watchStopHandle = () => {
        };
        watchStopHandle.stop = NOOP;
        watchStopHandle.resume = NOOP;
        watchStopHandle.pause = NOOP;
        return watchStopHandle;
      }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") {
      baseWatchOptions.scheduler = (job) => {
        queuePostRenderEffect(job, instance && instance.suspense);
      };
    } else if (flush !== "sync") {
      isPre = true;
      baseWatchOptions.scheduler = (job, isFirstRun) => {
        if (isFirstRun) {
          job();
        } else {
          queueJob(job);
        }
      };
    }
    baseWatchOptions.augmentJob = (job) => {
      if (cb) {
        job.flags |= 4;
      }
      if (isPre) {
        job.flags |= 2;
        if (instance) {
          job.id = instance.uid;
          job.i = instance;
        }
      }
    };
    const watchHandle = watch$1(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
      if (ssrCleanup) {
        ssrCleanup.push(watchHandle);
      } else if (runsImmediately) {
        watchHandle();
      }
    }
    return watchHandle;
  }
  function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = isString$1(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if (isFunction$2(value)) {
      cb = value;
    } else {
      cb = value.handler;
      options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
  }
  function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return () => {
      let cur = ctx;
      for (let i = 0; i < segments.length && cur; i++) {
        cur = cur[segments[i]];
      }
      return cur;
    };
  }
  const pendingMounts = /* @__PURE__ */ new WeakMap();
  const TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
  const isTeleport = (type) => type.__isTeleport;
  const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
  const isTeleportDeferred = (props) => props && (props.defer || props.defer === "");
  const isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
  const isTargetMathML = (target) => typeof MathMLElement === "function" && target instanceof MathMLElement;
  const resolveTarget = (props, select) => {
    const targetSelector = props && props.to;
    if (isString$1(targetSelector)) {
      if (!select) {
        return null;
      } else {
        const target = select(targetSelector);
        return target;
      }
    } else {
      return targetSelector;
    }
  };
  const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
      const {
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        o: { insert, querySelector, createText, createComment, parentNode }
      } = internals;
      const disabled = isTeleportDisabled(n2.props);
      let { dynamicChildren } = n2;
      const mount = (vnode, container2, anchor2) => {
        if (vnode.shapeFlag & 16) {
          mountChildren(
            vnode.children,
            container2,
            anchor2,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      };
      const mountToTarget = (vnode = n2) => {
        const disabled2 = isTeleportDisabled(vnode.props);
        const target = vnode.target = resolveTarget(vnode.props, querySelector);
        const targetAnchor = prepareAnchor(target, vnode, createText, insert);
        if (target) {
          if (namespace !== "svg" && isTargetSVG(target)) {
            namespace = "svg";
          } else if (namespace !== "mathml" && isTargetMathML(target)) {
            namespace = "mathml";
          }
          if (parentComponent && parentComponent.isCE) {
            (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
          }
          if (!disabled2) {
            mount(vnode, target, targetAnchor);
            updateCssVars(vnode, false);
          }
        }
      };
      const queuePendingMount = (vnode) => {
        const mountJob = () => {
          if (pendingMounts.get(vnode) !== mountJob) return;
          pendingMounts.delete(vnode);
          if (isTeleportDisabled(vnode.props)) {
            const mountContainer = parentNode(vnode.el) || container;
            mount(vnode, mountContainer, vnode.anchor);
            updateCssVars(vnode, true);
          }
          mountToTarget(vnode);
        };
        pendingMounts.set(vnode, mountJob);
        queuePostRenderEffect(mountJob, parentSuspense);
      };
      if (n1 == null) {
        const placeholder = n2.el = createText("");
        const mainAnchor = n2.anchor = createText("");
        insert(placeholder, container, anchor);
        insert(mainAnchor, container, anchor);
        if (isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
          queuePendingMount(n2);
          return;
        }
        if (disabled) {
          mount(n2, container, mainAnchor);
          updateCssVars(n2, true);
        }
        mountToTarget();
      } else {
        n2.el = n1.el;
        const mainAnchor = n2.anchor = n1.anchor;
        const pendingMount = pendingMounts.get(n1);
        if (pendingMount) {
          pendingMount.flags |= 8;
          pendingMounts.delete(n1);
          queuePendingMount(n2);
          return;
        }
        n2.targetStart = n1.targetStart;
        const target = n2.target = n1.target;
        const targetAnchor = n2.targetAnchor = n1.targetAnchor;
        const wasDisabled = isTeleportDisabled(n1.props);
        const currentContainer = wasDisabled ? container : target;
        const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
        if (namespace === "svg" || isTargetSVG(target)) {
          namespace = "svg";
        } else if (namespace === "mathml" || isTargetMathML(target)) {
          namespace = "mathml";
        }
        if (dynamicChildren) {
          patchBlockChildren(
            n1.dynamicChildren,
            dynamicChildren,
            currentContainer,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds
          );
          traverseStaticChildren(n1, n2, true);
        } else if (!optimized) {
          patchChildren(
            n1,
            n2,
            currentContainer,
            currentAnchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            false
          );
        }
        if (disabled) {
          if (!wasDisabled) {
            moveTeleport(
              n2,
              container,
              mainAnchor,
              internals,
              1
            );
          } else {
            if (n2.props && n1.props && n2.props.to !== n1.props.to) {
              n2.props.to = n1.props.to;
            }
          }
        } else {
          if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
            const nextTarget = resolveTarget(n2.props, querySelector);
            if (nextTarget) {
              n2.target = nextTarget;
              moveTeleport(
                n2,
                nextTarget,
                null,
                internals,
                0
              );
            }
          } else if (wasDisabled) {
            moveTeleport(
              n2,
              target,
              targetAnchor,
              internals,
              1
            );
          }
        }
        updateCssVars(n2, disabled);
      }
    },
    remove(vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
      const {
        shapeFlag,
        children,
        anchor,
        targetStart,
        targetAnchor,
        target,
        props
      } = vnode;
      const disabled = isTeleportDisabled(props);
      const shouldRemove = doRemove || !disabled;
      const pendingMount = pendingMounts.get(vnode);
      if (pendingMount) {
        pendingMount.flags |= 8;
        pendingMounts.delete(vnode);
      }
      if (target) {
        hostRemove(targetStart);
        hostRemove(targetAnchor);
      }
      doRemove && hostRemove(anchor);
      if (!pendingMount && (disabled || target) && shapeFlag & 16) {
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          unmount(
            child,
            parentComponent,
            parentSuspense,
            shouldRemove,
            !!child.dynamicChildren
          );
        }
      }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
  };
  function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
      insert(vnode.targetAnchor, container, parentAnchor);
    }
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) {
      insert(el, container, parentAnchor);
    }
    if (!pendingMounts.has(vnode) && (!isReorder || isTeleportDisabled(props))) {
      if (shapeFlag & 16) {
        for (let i = 0; i < children.length; i++) {
          move(
            children[i],
            container,
            parentAnchor,
            2
          );
        }
      }
    }
    if (isReorder) {
      insert(anchor, container, parentAnchor);
    }
  }
  function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, {
    o: { nextSibling, parentNode, querySelector, insert, createText }
  }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
      let targetAnchor = targetNode;
      while (targetAnchor) {
        if (targetAnchor && targetAnchor.nodeType === 8) {
          if (targetAnchor.data === "teleport start anchor") {
            vnode.targetStart = targetAnchor;
          } else if (targetAnchor.data === "teleport anchor") {
            vnode.targetAnchor = targetAnchor;
            target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
            break;
          }
        }
        targetAnchor = nextSibling(targetAnchor);
      }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
      vnode2.anchor = hydrateChildren(
        nextSibling(node2),
        vnode2,
        parentNode(node2),
        parentComponent,
        parentSuspense,
        slotScopeIds,
        optimized
      );
    }
    const target = vnode.target = resolveTarget(
      vnode.props,
      querySelector
    );
    const disabled = isTeleportDisabled(vnode.props);
    if (target) {
      const targetNode = target._lpa || target.firstChild;
      if (vnode.shapeFlag & 16) {
        if (disabled) {
          hydrateDisabledTeleport(node, vnode);
          hydrateAnchor(target, targetNode);
          if (!vnode.targetAnchor) {
            prepareAnchor(
              target,
              vnode,
              createText,
              insert,
              // if target is the same as the main view, insert anchors before current node
              // to avoid hydrating mismatch
              parentNode(node) === target ? node : null
            );
          }
        } else {
          vnode.anchor = nextSibling(node);
          hydrateAnchor(target, targetNode);
          if (!vnode.targetAnchor) {
            prepareAnchor(target, vnode, createText, insert);
          }
          hydrateChildren(
            targetNode && nextSibling(targetNode),
            vnode,
            target,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
        }
      }
      updateCssVars(vnode, disabled);
    } else if (disabled) {
      if (vnode.shapeFlag & 16) {
        hydrateDisabledTeleport(node, vnode);
        vnode.targetStart = node;
        vnode.targetAnchor = nextSibling(node);
      }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
  }
  const Teleport = TeleportImpl;
  function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
      let node, anchor;
      if (isDisabled) {
        node = vnode.el;
        anchor = vnode.anchor;
      } else {
        node = vnode.targetStart;
        anchor = vnode.targetAnchor;
      }
      while (node && node !== anchor) {
        if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
        node = node.nextSibling;
      }
      ctx.ut();
    }
  }
  function prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
      insert(targetStart, target, anchor);
      insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
  }
  const leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
  const enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
  function useTransitionState() {
    const state = {
      isMounted: false,
      isLeaving: false,
      isUnmounting: false,
      leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(() => {
      state.isMounted = true;
    });
    onBeforeUnmount(() => {
      state.isUnmounting = true;
    });
    return state;
  }
  const TransitionHookValidator = [Function, Array];
  const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
  };
  const recursiveGetSubtree = (instance) => {
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
  };
  const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const state = useTransitionState();
      return () => {
        const children = slots.default && getTransitionRawChildren(slots.default(), true);
        const child = children && children.length ? findNonCommentChild(children) : (
          // Keep explicit default-slot conditionals on the same transition path
          // as regular v-if branches, which render a comment placeholder.
          instance.subTree ? createCommentVNode() : void 0
        );
        if (!child) {
          return;
        }
        const rawProps = /* @__PURE__ */ toRaw(props);
        const { mode } = rawProps;
        if (state.isLeaving) {
          return emptyPlaceholder(child);
        }
        const innerChild = getInnerChild$1(child);
        if (!innerChild) {
          return emptyPlaceholder(child);
        }
        let enterHooks = resolveTransitionHooks(
          innerChild,
          rawProps,
          state,
          instance,
          // #11061, ensure enterHooks is fresh after clone
          (hooks) => enterHooks = hooks
        );
        if (innerChild.type !== Comment) {
          setTransitionHooks(innerChild, enterHooks);
        }
        let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
        if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(oldInnerChild, innerChild) && recursiveGetSubtree(instance).type !== Comment) {
          let leavingHooks = resolveTransitionHooks(
            oldInnerChild,
            rawProps,
            state,
            instance
          );
          setTransitionHooks(oldInnerChild, leavingHooks);
          if (mode === "out-in" && innerChild.type !== Comment) {
            state.isLeaving = true;
            leavingHooks.afterLeave = () => {
              state.isLeaving = false;
              if (!(instance.job.flags & 8)) {
                instance.update();
              }
              delete leavingHooks.afterLeave;
              oldInnerChild = void 0;
            };
            return emptyPlaceholder(child);
          } else if (mode === "in-out" && innerChild.type !== Comment) {
            leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
              const leavingVNodesCache = getLeavingNodesForType(
                state,
                oldInnerChild
              );
              leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
              el[leaveCbKey] = () => {
                earlyRemove();
                el[leaveCbKey] = void 0;
                delete enterHooks.delayedLeave;
                oldInnerChild = void 0;
              };
              enterHooks.delayedLeave = () => {
                delayedLeave();
                delete enterHooks.delayedLeave;
                oldInnerChild = void 0;
              };
            };
          } else {
            oldInnerChild = void 0;
          }
        } else if (oldInnerChild) {
          oldInnerChild = void 0;
        }
        return child;
      };
    }
  };
  function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
      for (const c of children) {
        if (c.type !== Comment) {
          child = c;
          break;
        }
      }
    }
    return child;
  }
  const BaseTransition = BaseTransitionImpl;
  function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
      leavingVNodesCache = /* @__PURE__ */ Object.create(null);
      leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
  }
  function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const {
      appear,
      mode,
      persisted = false,
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onEnterCancelled,
      onBeforeLeave,
      onLeave,
      onAfterLeave,
      onLeaveCancelled,
      onBeforeAppear,
      onAppear,
      onAfterAppear,
      onAppearCancelled
    } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook2 = (hook, args) => {
      hook && callWithAsyncErrorHandling(
        hook,
        instance,
        9,
        args
      );
    };
    const callAsyncHook = (hook, args) => {
      const done = args[1];
      callHook2(hook, args);
      if (isArray$1(hook)) {
        if (hook.every((hook2) => hook2.length <= 1)) done();
      } else if (hook.length <= 1) {
        done();
      }
    };
    const hooks = {
      mode,
      persisted,
      beforeEnter(el) {
        let hook = onBeforeEnter;
        if (!state.isMounted) {
          if (appear) {
            hook = onBeforeAppear || onBeforeEnter;
          } else {
            return;
          }
        }
        if (el[leaveCbKey]) {
          el[leaveCbKey](
            true
            /* cancelled */
          );
        }
        const leavingVNode = leavingVNodesCache[key];
        if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) {
          leavingVNode.el[leaveCbKey]();
        }
        callHook2(hook, [el]);
      },
      enter(el) {
        if (leavingVNodesCache[key] === vnode) return;
        let hook = onEnter;
        let afterHook = onAfterEnter;
        let cancelHook = onEnterCancelled;
        if (!state.isMounted) {
          if (appear) {
            hook = onAppear || onEnter;
            afterHook = onAfterAppear || onAfterEnter;
            cancelHook = onAppearCancelled || onEnterCancelled;
          } else {
            return;
          }
        }
        let called = false;
        el[enterCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          if (cancelled) {
            callHook2(cancelHook, [el]);
          } else {
            callHook2(afterHook, [el]);
          }
          if (hooks.delayedLeave) {
            hooks.delayedLeave();
          }
          el[enterCbKey] = void 0;
        };
        const done = el[enterCbKey].bind(null, false);
        if (hook) {
          callAsyncHook(hook, [el, done]);
        } else {
          done();
        }
      },
      leave(el, remove2) {
        const key2 = String(vnode.key);
        if (el[enterCbKey]) {
          el[enterCbKey](
            true
            /* cancelled */
          );
        }
        if (state.isUnmounting) {
          return remove2();
        }
        callHook2(onBeforeLeave, [el]);
        let called = false;
        el[leaveCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          remove2();
          if (cancelled) {
            callHook2(onLeaveCancelled, [el]);
          } else {
            callHook2(onAfterLeave, [el]);
          }
          el[leaveCbKey] = void 0;
          if (leavingVNodesCache[key2] === vnode) {
            delete leavingVNodesCache[key2];
          }
        };
        const done = el[leaveCbKey].bind(null, false);
        leavingVNodesCache[key2] = vnode;
        if (onLeave) {
          callAsyncHook(onLeave, [el, done]);
        } else {
          done();
        }
      },
      clone(vnode2) {
        const hooks2 = resolveTransitionHooks(
          vnode2,
          props,
          state,
          instance,
          postClone
        );
        if (postClone) postClone(hooks2);
        return hooks2;
      }
    };
    return hooks;
  }
  function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
      vnode = cloneVNode(vnode);
      vnode.children = null;
      return vnode;
    }
  }
  function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
      if (isTeleport(vnode.type) && vnode.children) {
        return findNonCommentChild(vnode.children);
      }
      return vnode;
    }
    if (vnode.component) {
      return vnode.component.subTree;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
      if (shapeFlag & 16) {
        return children[0];
      }
      if (shapeFlag & 32 && isFunction$2(children.default)) {
        return children.default();
      }
    }
  }
  function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
      vnode.transition = hooks;
      const subTree = vnode.component.subTree;
      setTransitionHooks(
        isTeleport(subTree.type) ? getInnerChild$1(subTree) || subTree : subTree,
        hooks
      );
    } else if (vnode.shapeFlag & 128) {
      vnode.ssContent.transition = hooks.clone(vnode.ssContent);
      vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
      vnode.transition = hooks;
    }
  }
  function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
      if (child.type === Fragment) {
        if (child.patchFlag & 128) keyedFragmentCount++;
        ret = ret.concat(
          getTransitionRawChildren(child.children, keepComment, key)
        );
      } else if (keepComment || child.type !== Comment) {
        ret.push(key != null ? cloneVNode(child, { key }) : child);
      }
    }
    if (keyedFragmentCount > 1) {
      for (let i = 0; i < ret.length; i++) {
        ret[i].patchFlag = -2;
      }
    }
    return ret;
  }
  function markAsyncBoundary(instance) {
    instance.ids = [instance.ids[0] + instance.ids[2]++ + "-", 0, 0];
  }
  function isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
  }
  const pendingSetRefMap = /* @__PURE__ */ new WeakMap();
  function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if (isArray$1(rawRef)) {
      rawRef.forEach(
        (r, i) => setRef(
          r,
          oldRawRef && (isArray$1(oldRawRef) ? oldRawRef[i] : oldRawRef),
          parentSuspense,
          vnode,
          isUnmount
        )
      );
      return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
      if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) {
        setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
      }
      return;
    }
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref3 } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = /* @__PURE__ */ toRaw(setupState);
    const canSetSetupRef = setupState === EMPTY_OBJ ? NO : (key) => {
      if (isTemplateRefKey(refs, key)) {
        return false;
      }
      return hasOwn(rawSetupState, key);
    };
    const canSetRef = (ref22, key) => {
      if (key && isTemplateRefKey(refs, key)) {
        return false;
      }
      return true;
    };
    if (oldRef != null && oldRef !== ref3) {
      invalidatePendingSetRef(oldRawRef);
      if (isString$1(oldRef)) {
        refs[oldRef] = null;
        if (canSetSetupRef(oldRef)) {
          setupState[oldRef] = null;
        }
      } else if (/* @__PURE__ */ isRef(oldRef)) {
        const oldRawRefAtom = oldRawRef;
        if (canSetRef(oldRef, oldRawRefAtom.k)) {
          oldRef.value = null;
        }
        if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
      }
    }
    if (isFunction$2(ref3)) {
      callWithErrorHandling(ref3, owner, 12, [value, refs]);
    } else {
      const _isString = isString$1(ref3);
      const _isRef = /* @__PURE__ */ isRef(ref3);
      if (_isString || _isRef) {
        const doSet = () => {
          if (rawRef.f) {
            const existing = _isString ? canSetSetupRef(ref3) ? setupState[ref3] : refs[ref3] : canSetRef() || !rawRef.k ? ref3.value : refs[rawRef.k];
            if (isUnmount) {
              isArray$1(existing) && remove(existing, refValue);
            } else {
              if (!isArray$1(existing)) {
                if (_isString) {
                  refs[ref3] = [refValue];
                  if (canSetSetupRef(ref3)) {
                    setupState[ref3] = refs[ref3];
                  }
                } else {
                  const newVal = [refValue];
                  if (canSetRef(ref3, rawRef.k)) {
                    ref3.value = newVal;
                  }
                  if (rawRef.k) refs[rawRef.k] = newVal;
                }
              } else if (!existing.includes(refValue)) {
                existing.push(refValue);
              }
            }
          } else if (_isString) {
            refs[ref3] = value;
            if (canSetSetupRef(ref3)) {
              setupState[ref3] = value;
            }
          } else if (_isRef) {
            if (canSetRef(ref3, rawRef.k)) {
              ref3.value = value;
            }
            if (rawRef.k) refs[rawRef.k] = value;
          } else ;
        };
        if (value) {
          const job = () => {
            doSet();
            pendingSetRefMap.delete(rawRef);
          };
          job.id = -1;
          pendingSetRefMap.set(rawRef, job);
          queuePostRenderEffect(job, parentSuspense);
        } else {
          invalidatePendingSetRef(rawRef);
          doSet();
        }
      }
    }
  }
  function invalidatePendingSetRef(rawRef) {
    const pendingSetRef = pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
      pendingSetRef.flags |= 8;
      pendingSetRefMap.delete(rawRef);
    }
  }
  getGlobalThis().requestIdleCallback || ((cb) => setTimeout(cb, 1));
  getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
  const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
  const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
  function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
  }
  function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
  }
  function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = () => {
      let current = target;
      while (current) {
        if (current.isDeactivated) {
          return;
        }
        current = current.parent;
      }
      return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
      let current = target.parent;
      while (current && current.parent) {
        if (isKeepAlive(current.parent.vnode)) {
          injectToKeepAliveRoot(wrappedHook, type, target, current);
        }
        current = current.parent;
      }
    }
  }
  function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(
      type,
      hook,
      keepAliveRoot,
      true
      /* prepend */
    );
    onUnmounted(() => {
      remove(keepAliveRoot[type], injected);
    }, target);
  }
  function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
      const hooks = target[type] || (target[type] = []);
      const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
        pauseTracking();
        const reset = setCurrentInstance(target);
        const res = callWithAsyncErrorHandling(hook, target, type, args);
        reset();
        resetTracking();
        return res;
      });
      if (prepend) {
        hooks.unshift(wrappedHook);
      } else {
        hooks.push(wrappedHook);
      }
      return wrappedHook;
    }
  }
  const createHook = (lifecycle) => (hook, target = currentInstance) => {
    if (!isInSSRComponentSetup || lifecycle === "sp") {
      injectHook(lifecycle, (...args) => hook(...args), target);
    }
  };
  const onBeforeMount = createHook("bm");
  const onMounted = createHook("m");
  const onBeforeUpdate = createHook(
    "bu"
  );
  const onUpdated = createHook("u");
  const onBeforeUnmount = createHook(
    "bum"
  );
  const onUnmounted = createHook("um");
  const onServerPrefetch = createHook(
    "sp"
  );
  const onRenderTriggered = createHook("rtg");
  const onRenderTracked = createHook("rtc");
  function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
  }
  const COMPONENTS = "components";
  function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
  }
  const NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
  function resolveDynamicComponent(component) {
    if (isString$1(component)) {
      return resolveAsset(COMPONENTS, component, false) || component;
    } else {
      return component || NULL_DYNAMIC_COMPONENT;
    }
  }
  function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
      const Component = instance.type;
      {
        const selfName = getComponentName$1(
          Component,
          false
        );
        if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
          return Component;
        }
      }
      const res = (
        // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name)
      );
      if (!res && maybeSelfReference) {
        return Component;
      }
      return res;
    }
  }
  function resolve(registry, name) {
    return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
  }
  function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache;
    const sourceIsArray = isArray$1(source);
    if (sourceIsArray || isString$1(source)) {
      const sourceIsReactiveArray = sourceIsArray && /* @__PURE__ */ isReactive(source);
      let needsWrap = false;
      let isReadonlySource = false;
      if (sourceIsReactiveArray) {
        needsWrap = !/* @__PURE__ */ isShallow(source);
        isReadonlySource = /* @__PURE__ */ isReadonly(source);
        source = shallowReadArray(source);
      }
      ret = new Array(source.length);
      for (let i = 0, l = source.length; i < l; i++) {
        ret[i] = renderItem(
          needsWrap ? isReadonlySource ? toReadonly(toReactive(source[i])) : toReactive(source[i]) : source[i],
          i,
          void 0,
          cached
        );
      }
    } else if (typeof source === "number") {
      {
        ret = new Array(source);
        for (let i = 0; i < source; i++) {
          ret[i] = renderItem(i + 1, i, void 0, cached);
        }
      }
    } else if (isObject$1(source)) {
      if (source[Symbol.iterator]) {
        ret = Array.from(
          source,
          (item, i) => renderItem(item, i, void 0, cached)
        );
      } else {
        const keys = Object.keys(source);
        ret = new Array(keys.length);
        for (let i = 0, l = keys.length; i < l; i++) {
          const key = keys[i];
          ret[i] = renderItem(source[key], key, i, cached);
        }
      }
    } else {
      ret = [];
    }
    return ret;
  }
  function renderSlot(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
      const slotProps = props;
      const hasProps = Object.keys(slotProps).length > 0;
      return openBlock(), createBlock(
        Fragment,
        null,
        [createVNode("slot", slotProps, fallback && fallback())],
        hasProps ? -2 : 64
      );
    }
    let slot = slots[name];
    if (slot && slot._c) {
      slot._d = false;
    }
    const prevStackSize = blockStack.length;
    openBlock();
    let rendered;
    try {
      const validSlotContent = slot && ensureValidVNode(slot(props));
      const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      validSlotContent && validSlotContent.key;
      rendered = createBlock(
        Fragment,
        {
          key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
          (!validSlotContent && fallback ? "_fb" : "")
        },
        validSlotContent || (fallback ? fallback() : []),
        validSlotContent && slots._ === 1 ? 64 : -2
      );
    } catch (err) {
      for (let i = blockStack.length; i > prevStackSize; i--) closeBlock();
      throw err;
    } finally {
      if (slot && slot._c) {
        slot._d = true;
      }
    }
    return rendered;
  }
  function ensureValidVNode(vnodes) {
    return vnodes.some((child) => {
      if (!isVNode(child)) return true;
      if (child.type === Comment) return false;
      if (child.type === Fragment && !ensureValidVNode(child.children))
        return false;
      return true;
    }) ? vnodes : null;
  }
  const getPublicInstance = (i) => {
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
  };
  const publicPropertiesMap = (
    // Move PURE marker to new line to workaround compiler discarding it
    // due to type annotation
    /* @__PURE__ */ extend$1(/* @__PURE__ */ Object.create(null), {
      $: (i) => i,
      $el: (i) => i.vnode.el,
      $data: (i) => i.data,
      $props: (i) => i.props,
      $attrs: (i) => i.attrs,
      $slots: (i) => i.slots,
      $refs: (i) => i.refs,
      $parent: (i) => getPublicInstance(i.parent),
      $root: (i) => getPublicInstance(i.root),
      $host: (i) => i.ce,
      $emit: (i) => i.emit,
      $options: (i) => resolveMergedOptions(i),
      $forceUpdate: (i) => i.f || (i.f = () => {
        queueJob(i.update);
      }),
      $nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
      $watch: (i) => instanceWatch.bind(i)
    })
  );
  const hasSetupBinding = (state, key) => state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key);
  const PublicInstanceProxyHandlers = {
    get({ _: instance }, key) {
      if (key === "__v_skip") {
        return true;
      }
      const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
      if (key[0] !== "$") {
        const n = accessCache[key];
        if (n !== void 0) {
          switch (n) {
            case 1:
              return setupState[key];
            case 2:
              return data[key];
            case 4:
              return ctx[key];
            case 3:
              return props[key];
          }
        } else if (hasSetupBinding(setupState, key)) {
          accessCache[key] = 1;
          return setupState[key];
        } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
          accessCache[key] = 2;
          return data[key];
        } else if (hasOwn(props, key)) {
          accessCache[key] = 3;
          return props[key];
        } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
          accessCache[key] = 4;
          return ctx[key];
        } else if (shouldCacheAccess) {
          accessCache[key] = 0;
        }
      }
      const publicGetter = publicPropertiesMap[key];
      let cssModule, globalProperties;
      if (publicGetter) {
        if (key === "$attrs") {
          track(instance.attrs, "get", "");
        }
        return publicGetter(instance);
      } else if (
        // css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])
      ) {
        return cssModule;
      } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (
        // global properties
        globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)
      ) {
        {
          return globalProperties[key];
        }
      } else ;
    },
    set({ _: instance }, key, value) {
      const { data, setupState, ctx } = instance;
      if (hasSetupBinding(setupState, key)) {
        setupState[key] = value;
        return true;
      } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
        data[key] = value;
        return true;
      } else if (hasOwn(instance.props, key)) {
        return false;
      }
      if (key[0] === "$" && key.slice(1) in instance) {
        return false;
      } else {
        {
          ctx[key] = value;
        }
      }
      return true;
    },
    has({
      _: { data, setupState, accessCache, ctx, appContext, props, type }
    }, key) {
      let cssModules;
      return !!(accessCache[key] || data !== EMPTY_OBJ && key[0] !== "$" && hasOwn(data, key) || hasSetupBinding(setupState, key) || hasOwn(props, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty(target, key, descriptor) {
      if (descriptor.get != null) {
        target._.accessCache[key] = 0;
      } else if (hasOwn(descriptor, "value")) {
        this.set(target, key, descriptor.value, null);
      }
      return Reflect.defineProperty(target, key, descriptor);
    }
  };
  function normalizePropsOrEmits(props) {
    return isArray$1(props) ? props.reduce(
      (normalized, p2) => (normalized[p2] = null, normalized),
      {}
    ) : props;
  }
  let shouldCacheAccess = true;
  function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) {
      callHook$1(options.beforeCreate, instance, "bc");
    }
    const {
      // state
      data: dataOptions,
      computed: computedOptions,
      methods,
      watch: watchOptions,
      provide: provideOptions,
      inject: injectOptions,
      // lifecycle
      created,
      beforeMount,
      mounted,
      beforeUpdate,
      updated,
      activated,
      deactivated,
      beforeDestroy,
      beforeUnmount,
      destroyed,
      unmounted,
      render,
      renderTracked,
      renderTriggered,
      errorCaptured,
      serverPrefetch,
      // public API
      expose,
      inheritAttrs,
      // assets
      components,
      directives,
      filters
    } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) {
      resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    }
    if (methods) {
      for (const key in methods) {
        const methodHandler = methods[key];
        if (isFunction$2(methodHandler)) {
          {
            ctx[key] = methodHandler.bind(publicThis);
          }
        }
      }
    }
    if (dataOptions) {
      const data = dataOptions.call(publicThis, publicThis);
      if (!isObject$1(data)) ;
      else {
        instance.data = /* @__PURE__ */ reactive(data);
      }
    }
    shouldCacheAccess = true;
    if (computedOptions) {
      for (const key in computedOptions) {
        const opt = computedOptions[key];
        const get = isFunction$2(opt) ? opt.bind(publicThis, publicThis) : isFunction$2(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
        const set = !isFunction$2(opt) && isFunction$2(opt.set) ? opt.set.bind(publicThis) : NOOP;
        const c = computed({
          get,
          set
        });
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => c.value,
          set: (v) => c.value = v
        });
      }
    }
    if (watchOptions) {
      for (const key in watchOptions) {
        createWatcher(watchOptions[key], ctx, publicThis, key);
      }
    }
    if (provideOptions) {
      const provides = isFunction$2(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
      Reflect.ownKeys(provides).forEach((key) => {
        provide(key, provides[key]);
      });
    }
    if (created) {
      callHook$1(created, instance, "c");
    }
    function registerLifecycleHook(register, hook) {
      if (isArray$1(hook)) {
        hook.forEach((_hook) => register(_hook.bind(publicThis)));
      } else if (hook) {
        register(hook.bind(publicThis));
      }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if (isArray$1(expose)) {
      if (expose.length) {
        const exposed = instance.exposed || (instance.exposed = {});
        expose.forEach((key) => {
          Object.defineProperty(exposed, key, {
            get: () => publicThis[key],
            set: (val) => publicThis[key] = val,
            enumerable: true
          });
        });
      } else if (!instance.exposed) {
        instance.exposed = {};
      }
    }
    if (render && instance.render === NOOP) {
      instance.render = render;
    }
    if (inheritAttrs != null) {
      instance.inheritAttrs = inheritAttrs;
    }
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) {
      markAsyncBoundary(instance);
    }
  }
  function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
    if (isArray$1(injectOptions)) {
      injectOptions = normalizeInject(injectOptions);
    }
    for (const key in injectOptions) {
      const opt = injectOptions[key];
      let injected;
      if (isObject$1(opt)) {
        if ("default" in opt) {
          injected = inject(
            opt.from || key,
            opt.default,
            true
          );
        } else {
          injected = inject(opt.from || key);
        }
      } else {
        injected = inject(opt);
      }
      if (/* @__PURE__ */ isRef(injected)) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v) => injected.value = v
        });
      } else {
        ctx[key] = injected;
      }
    }
  }
  function callHook$1(hook, instance, type) {
    callWithAsyncErrorHandling(
      isArray$1(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy),
      instance,
      type
    );
  }
  function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
    if (isString$1(raw)) {
      const handler = ctx[raw];
      if (isFunction$2(handler)) {
        {
          watch(getter, handler);
        }
      }
    } else if (isFunction$2(raw)) {
      {
        watch(getter, raw.bind(publicThis));
      }
    } else if (isObject$1(raw)) {
      if (isArray$1(raw)) {
        raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
      } else {
        const handler = isFunction$2(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
        if (isFunction$2(handler)) {
          watch(getter, handler, raw);
        }
      }
    } else ;
  }
  function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const {
      mixins: globalMixins,
      optionsCache: cache,
      config: { optionMergeStrategies }
    } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) {
      resolved = cached;
    } else if (!globalMixins.length && !mixins && !extendsOptions) {
      {
        resolved = base;
      }
    } else {
      resolved = {};
      if (globalMixins.length) {
        globalMixins.forEach(
          (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
        );
      }
      mergeOptions(resolved, base, optionMergeStrategies);
    }
    if (isObject$1(base)) {
      cache.set(base, resolved);
    }
    return resolved;
  }
  function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) {
      mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
      mixins.forEach(
        (m) => mergeOptions(to, m, strats, true)
      );
    }
    for (const key in from) {
      if (asMixin && key === "expose") ;
      else {
        const strat = internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
      }
    }
    return to;
  }
  const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
  };
  function mergeDataFn(to, from) {
    if (!from) {
      return to;
    }
    if (!to) {
      return from;
    }
    return function mergedDataFn() {
      return extend$1(
        isFunction$2(to) ? to.call(this, this) : to,
        isFunction$2(from) ? from.call(this, this) : from
      );
    };
  }
  function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
  }
  function normalizeInject(raw) {
    if (isArray$1(raw)) {
      const res = {};
      for (let i = 0; i < raw.length; i++) {
        res[raw[i]] = raw[i];
      }
      return res;
    }
    return raw;
  }
  function mergeAsArray(to, from) {
    return to ? [...new Set([].concat(to, from))] : from;
  }
  function mergeObjectOptions(to, from) {
    return to ? extend$1(/* @__PURE__ */ Object.create(null), to, from) : from;
  }
  function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
      if (isArray$1(to) && isArray$1(from)) {
        return [.../* @__PURE__ */ new Set([...to, ...from])];
      }
      return extend$1(
        /* @__PURE__ */ Object.create(null),
        normalizePropsOrEmits(to),
        normalizePropsOrEmits(from != null ? from : {})
      );
    } else {
      return from;
    }
  }
  function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = extend$1(/* @__PURE__ */ Object.create(null), to);
    for (const key in from) {
      merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
  }
  function createAppContext() {
    return {
      app: null,
      config: {
        isNativeTag: NO,
        performance: false,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: /* @__PURE__ */ Object.create(null),
      optionsCache: /* @__PURE__ */ new WeakMap(),
      propsCache: /* @__PURE__ */ new WeakMap(),
      emitsCache: /* @__PURE__ */ new WeakMap()
    };
  }
  let uid$1 = 0;
  function createAppAPI(render, hydrate) {
    return function createApp2(rootComponent, rootProps = null) {
      if (!isFunction$2(rootComponent)) {
        rootComponent = extend$1({}, rootComponent);
      }
      if (rootProps != null && !isObject$1(rootProps)) {
        rootProps = null;
      }
      const context = createAppContext();
      const installedPlugins = /* @__PURE__ */ new WeakSet();
      const pluginCleanupFns = [];
      let isMounted = false;
      const app = context.app = {
        _uid: uid$1++,
        _component: rootComponent,
        _props: rootProps,
        _container: null,
        _context: context,
        _instance: null,
        version,
        get config() {
          return context.config;
        },
        set config(v) {
        },
        use(plugin, ...options) {
          if (installedPlugins.has(plugin)) ;
          else if (plugin && isFunction$2(plugin.install)) {
            installedPlugins.add(plugin);
            plugin.install(app, ...options);
          } else if (isFunction$2(plugin)) {
            installedPlugins.add(plugin);
            plugin(app, ...options);
          } else ;
          return app;
        },
        mixin(mixin) {
          {
            if (!context.mixins.includes(mixin)) {
              context.mixins.push(mixin);
            }
          }
          return app;
        },
        component(name, component) {
          if (!component) {
            return context.components[name];
          }
          context.components[name] = component;
          return app;
        },
        directive(name, directive) {
          if (!directive) {
            return context.directives[name];
          }
          context.directives[name] = directive;
          return app;
        },
        mount(rootContainer, isHydrate, namespace) {
          if (!isMounted) {
            const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
            vnode.appContext = context;
            if (namespace === true) {
              namespace = "svg";
            } else if (namespace === false) {
              namespace = void 0;
            }
            {
              render(vnode, rootContainer, namespace);
            }
            isMounted = true;
            app._container = rootContainer;
            rootContainer.__vue_app__ = app;
            return getComponentPublicInstance(vnode.component);
          }
        },
        onUnmount(cleanupFn) {
          pluginCleanupFns.push(cleanupFn);
        },
        unmount() {
          if (isMounted) {
            callWithAsyncErrorHandling(
              pluginCleanupFns,
              app._instance,
              16
            );
            render(null, app._container);
            delete app._container.__vue_app__;
          }
        },
        provide(key, value) {
          context.provides[key] = value;
          return app;
        },
        runWithContext(fn) {
          const lastApp = currentApp;
          currentApp = app;
          try {
            return fn();
          } finally {
            currentApp = lastApp;
          }
        }
      };
      return app;
    };
  }
  let currentApp = null;
  const getModelModifiers = (props, modelName) => {
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
  };
  function emit(instance, event2, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || EMPTY_OBJ;
    let args = rawArgs;
    const isModelListener2 = event2.startsWith("update:");
    const modifiers = isModelListener2 && getModelModifiers(props, event2.slice(7));
    if (modifiers) {
      if (modifiers.trim) {
        args = rawArgs.map((a) => isString$1(a) ? a.trim() : a);
      }
      if (modifiers.number) {
        args = args.map(looseToNumber);
      }
    }
    let handlerName;
    let handler = props[handlerName = toHandlerKey(event2)] || // also try camelCase event handler (#2249)
    props[handlerName = toHandlerKey(camelize(event2))];
    if (!handler && isModelListener2) {
      handler = props[handlerName = toHandlerKey(hyphenate(event2))];
    }
    if (handler) {
      callWithAsyncErrorHandling(
        handler,
        instance,
        6,
        args
      );
    }
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
      if (!instance.emitted) {
        instance.emitted = {};
      } else if (instance.emitted[handlerName]) {
        return;
      }
      instance.emitted[handlerName] = true;
      callWithAsyncErrorHandling(
        onceHandler,
        instance,
        6,
        args
      );
    }
  }
  const mixinEmitsCache = /* @__PURE__ */ new WeakMap();
  function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = asMixin ? mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) {
      return cached;
    }
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (!isFunction$2(comp)) {
      const extendEmits = (raw2) => {
        const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
        if (normalizedFromExtend) {
          hasExtends = true;
          extend$1(normalized, normalizedFromExtend);
        }
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendEmits);
      }
      if (comp.extends) {
        extendEmits(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendEmits);
      }
    }
    if (!raw && !hasExtends) {
      if (isObject$1(comp)) {
        cache.set(comp, null);
      }
      return null;
    }
    if (isArray$1(raw)) {
      raw.forEach((key) => normalized[key] = null);
    } else {
      extend$1(normalized, raw);
    }
    if (isObject$1(comp)) {
      cache.set(comp, normalized);
    }
    return normalized;
  }
  function isEmitListener(options, key) {
    if (!options || !isOn(key)) {
      return false;
    }
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
  }
  function markAttrsAccessed() {
  }
  function renderComponentRoot(instance) {
    const {
      type: Component,
      vnode,
      proxy,
      withProxy,
      propsOptions: [propsOptions],
      slots,
      attrs,
      emit: emit2,
      render,
      renderCache,
      props,
      data,
      setupState,
      ctx,
      inheritAttrs
    } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
      if (vnode.shapeFlag & 4) {
        const proxyToUse = withProxy || proxy;
        const thisProxy = false ? new Proxy(proxyToUse, {
          get(target, key, receiver) {
            warn$1(
              `Property '${String(
                key
              )}' was accessed via 'this'. Avoid using 'this' in templates.`
            );
            return Reflect.get(target, key, receiver);
          }
        }) : proxyToUse;
        result = normalizeVNode(
          render.call(
            thisProxy,
            proxyToUse,
            renderCache,
            false ? /* @__PURE__ */ shallowReadonly(props) : props,
            setupState,
            data,
            ctx
          )
        );
        fallthroughAttrs = attrs;
      } else {
        const render2 = Component;
        if (false) ;
        result = normalizeVNode(
          render2.length > 1 ? render2(
            false ? /* @__PURE__ */ shallowReadonly(props) : props,
            false ? {
              get attrs() {
                markAttrsAccessed();
                return /* @__PURE__ */ shallowReadonly(attrs);
              },
              slots,
              emit: emit2
            } : { attrs, slots, emit: emit2 }
          ) : render2(
            false ? /* @__PURE__ */ shallowReadonly(props) : props,
            null
          )
        );
        fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
      }
    } catch (err) {
      blockStack.length = 0;
      handleError(err, instance, 1);
      result = createVNode(Comment);
    }
    let root = result;
    if (fallthroughAttrs && inheritAttrs !== false) {
      const keys = Object.keys(fallthroughAttrs);
      const { shapeFlag } = root;
      if (keys.length) {
        if (shapeFlag & (1 | 6)) {
          if (propsOptions && keys.some(isModelListener)) {
            fallthroughAttrs = filterModelListeners(
              fallthroughAttrs,
              propsOptions
            );
          }
          root = cloneVNode(root, fallthroughAttrs, false, true);
        }
      }
    }
    if (vnode.dirs) {
      root = cloneVNode(root, null, false, true);
      root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
      const child = isTeleport(root.type) ? getInnerChild$1(root) || root : root;
      setTransitionHooks(child, vnode.transition);
    }
    {
      result = root;
    }
    setCurrentRenderingInstance(prev);
    return result;
  }
  const getFunctionalFallthrough = (attrs) => {
    let res;
    for (const key in attrs) {
      if (key === "class" || key === "style" || isOn(key)) {
        (res || (res = {}))[key] = attrs[key];
      }
    }
    return res;
  };
  const filterModelListeners = (attrs, props) => {
    const res = {};
    for (const key in attrs) {
      if (!isModelListener(key) || !(key.slice(9) in props)) {
        res[key] = attrs[key];
      }
    }
    return res;
  };
  function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) {
      return true;
    }
    if (optimized && patchFlag >= 0) {
      if (patchFlag & 1024) {
        return true;
      }
      if (patchFlag & 16) {
        if (!prevProps) {
          return !!nextProps;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
      } else if (patchFlag & 8) {
        const dynamicProps = nextVNode.dynamicProps;
        for (let i = 0; i < dynamicProps.length; i++) {
          const key = dynamicProps[i];
          if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emits, key)) {
            return true;
          }
        }
      }
    } else {
      if (prevChildren || nextChildren) {
        if (!nextChildren || !nextChildren.$stable) {
          return true;
        }
      }
      if (prevProps === nextProps) {
        return false;
      }
      if (!prevProps) {
        return !!nextProps;
      }
      if (!nextProps) {
        return true;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
  }
  function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
      return true;
    }
    for (let i = 0; i < nextKeys.length; i++) {
      const key = nextKeys[i];
      if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emitsOptions, key)) {
        return true;
      }
    }
    return false;
  }
  function hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && isObject$1(nextProp) && isObject$1(prevProp)) {
      return !looseEqual(nextProp, prevProp);
    }
    return nextProp !== prevProp;
  }
  function updateHOCHostEl({ vnode, parent, suspense }, el) {
    while (parent) {
      const root = parent.subTree;
      if (root.suspense && root.suspense.activeBranch === vnode) {
        root.suspense.vnode.el = root.el = el;
        vnode = root;
      }
      if (root === vnode) {
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
      } else {
        break;
      }
    }
    if (suspense && suspense.activeBranch === vnode) {
      suspense.vnode.el = el;
    }
  }
  const internalObjectProto = {};
  const createInternalObject = () => Object.create(internalObjectProto);
  const isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
  function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for (const key in instance.propsOptions[0]) {
      if (!(key in props)) {
        props[key] = void 0;
      }
    }
    if (isStateful) {
      instance.props = isSSR ? props : /* @__PURE__ */ shallowReactive(props);
    } else {
      if (!instance.type.props) {
        instance.props = attrs;
      } else {
        instance.props = props;
      }
    }
    instance.attrs = attrs;
  }
  function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const {
      props,
      attrs,
      vnode: { patchFlag }
    } = instance;
    const rawCurrentProps = /* @__PURE__ */ toRaw(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (
      // always force full diff in dev
      // - #1942 if hmr is enabled with sfc component
      // - vite#872 non-sfc component used by sfc component
      (optimized || patchFlag > 0) && !(patchFlag & 16)
    ) {
      if (patchFlag & 8) {
        const propsToUpdate = instance.vnode.dynamicProps;
        for (let i = 0; i < propsToUpdate.length; i++) {
          let key = propsToUpdate[i];
          if (isEmitListener(instance.emitsOptions, key)) {
            continue;
          }
          const value = rawProps[key];
          if (options) {
            if (hasOwn(attrs, key)) {
              if (value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
              }
            } else {
              const camelizedKey = camelize(key);
              props[camelizedKey] = resolvePropValue(
                options,
                rawCurrentProps,
                camelizedKey,
                value,
                instance,
                false
              );
            }
          } else {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          }
        }
      }
    } else {
      if (setFullProps(instance, rawProps, props, attrs)) {
        hasAttrsChanged = true;
      }
      let kebabKey;
      for (const key in rawCurrentProps) {
        if (!rawProps || // for camelCase
        !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
          if (options) {
            if (rawPrevProps && // for camelCase
            (rawPrevProps[key] !== void 0 || // for kebab-case
            rawPrevProps[kebabKey] !== void 0)) {
              props[key] = resolvePropValue(
                options,
                rawCurrentProps,
                key,
                void 0,
                instance,
                true
              );
            }
          } else {
            delete props[key];
          }
        }
      }
      if (attrs !== rawCurrentProps) {
        for (const key in attrs) {
          if (!rawProps || !hasOwn(rawProps, key) && true) {
            delete attrs[key];
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (hasAttrsChanged) {
      trigger(instance.attrs, "set", "");
    }
  }
  function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) {
      for (let key in rawProps) {
        if (isReservedProp(key)) {
          continue;
        }
        const value = rawProps[key];
        let camelKey;
        if (options && hasOwn(options, camelKey = camelize(key))) {
          if (!needCastKeys || !needCastKeys.includes(camelKey)) {
            props[camelKey] = value;
          } else {
            (rawCastValues || (rawCastValues = {}))[camelKey] = value;
          }
        } else if (!isEmitListener(instance.emitsOptions, key)) {
          if (!(key in attrs) || value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (needCastKeys) {
      const rawCurrentProps = /* @__PURE__ */ toRaw(props);
      const castValues = rawCastValues || EMPTY_OBJ;
      for (let i = 0; i < needCastKeys.length; i++) {
        const key = needCastKeys[i];
        props[key] = resolvePropValue(
          options,
          rawCurrentProps,
          key,
          castValues[key],
          instance,
          !hasOwn(castValues, key)
        );
      }
    }
    return hasAttrsChanged;
  }
  function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
      const hasDefault = hasOwn(opt, "default");
      if (hasDefault && value === void 0) {
        const defaultValue = opt.default;
        if (opt.type !== Function && !opt.skipFactory && isFunction$2(defaultValue)) {
          const { propsDefaults } = instance;
          if (key in propsDefaults) {
            value = propsDefaults[key];
          } else {
            const reset = setCurrentInstance(instance);
            value = propsDefaults[key] = defaultValue.call(
              null,
              props
            );
            reset();
          }
        } else {
          value = defaultValue;
        }
        if (instance.ce) {
          instance.ce._setProp(key, value);
        }
      }
      if (opt[
        0
        /* shouldCast */
      ]) {
        if (isAbsent && !hasDefault) {
          value = false;
        } else if (opt[
          1
          /* shouldCastTrue */
        ] && (value === "" || value === hyphenate(key))) {
          value = true;
        }
      }
    }
    return value;
  }
  const mixinPropsCache = /* @__PURE__ */ new WeakMap();
  function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) {
      return cached;
    }
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (!isFunction$2(comp)) {
      const extendProps = (raw2) => {
        hasExtends = true;
        const [props, keys] = normalizePropsOptions(raw2, appContext, true);
        extend$1(normalized, props);
        if (keys) needCastKeys.push(...keys);
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendProps);
      }
      if (comp.extends) {
        extendProps(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendProps);
      }
    }
    if (!raw && !hasExtends) {
      if (isObject$1(comp)) {
        cache.set(comp, EMPTY_ARR);
      }
      return EMPTY_ARR;
    }
    if (isArray$1(raw)) {
      for (let i = 0; i < raw.length; i++) {
        const normalizedKey = camelize(raw[i]);
        if (validatePropName(normalizedKey)) {
          normalized[normalizedKey] = EMPTY_OBJ;
        }
      }
    } else if (raw) {
      for (const key in raw) {
        const normalizedKey = camelize(key);
        if (validatePropName(normalizedKey)) {
          const opt = raw[key];
          const prop = normalized[normalizedKey] = isArray$1(opt) || isFunction$2(opt) ? { type: opt } : extend$1({}, opt);
          const propType = prop.type;
          let shouldCast = false;
          let shouldCastTrue = true;
          if (isArray$1(propType)) {
            for (let index = 0; index < propType.length; ++index) {
              const type = propType[index];
              const typeName = isFunction$2(type) && type.name;
              if (typeName === "Boolean") {
                shouldCast = true;
                break;
              } else if (typeName === "String") {
                shouldCastTrue = false;
              }
            }
          } else {
            shouldCast = isFunction$2(propType) && propType.name === "Boolean";
          }
          prop[
            0
            /* shouldCast */
          ] = shouldCast;
          prop[
            1
            /* shouldCastTrue */
          ] = shouldCastTrue;
          if (shouldCast || hasOwn(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
    const res = [normalized, needCastKeys];
    if (isObject$1(comp)) {
      cache.set(comp, res);
    }
    return res;
  }
  function validatePropName(key) {
    if (key[0] !== "$" && !isReservedProp(key)) {
      return true;
    }
    return false;
  }
  const isInternalKey = (key) => key === "_" || key === "_ctx" || key === "$stable";
  const normalizeSlotValue = (value) => isArray$1(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
  const normalizeSlot = (key, rawSlot, ctx) => {
    if (rawSlot._n) {
      return rawSlot;
    }
    const normalized = withCtx((...args) => {
      if (false) ;
      return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
  };
  const normalizeObjectSlots = (rawSlots, slots, instance) => {
    const ctx = rawSlots._ctx;
    for (const key in rawSlots) {
      if (isInternalKey(key)) continue;
      const value = rawSlots[key];
      if (isFunction$2(value)) {
        slots[key] = normalizeSlot(key, value, ctx);
      } else if (value != null) {
        const normalized = normalizeSlotValue(value);
        slots[key] = () => normalized;
      }
    }
  };
  const normalizeVNodeSlots = (instance, children) => {
    const normalized = normalizeSlotValue(children);
    instance.slots.default = () => normalized;
  };
  const assignSlots = (slots, children, optimized) => {
    for (const key in children) {
      if (optimized || !isInternalKey(key)) {
        slots[key] = children[key];
      }
    }
  };
  const initSlots = (instance, children, optimized) => {
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
      const type = children._;
      if (type) {
        assignSlots(slots, children, optimized);
        if (optimized) {
          def(slots, "_", type, true);
        }
      } else {
        normalizeObjectSlots(children, slots);
      }
    } else if (children) {
      normalizeVNodeSlots(instance, children);
    }
  };
  const updateSlots = (instance, children, optimized) => {
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = EMPTY_OBJ;
    if (vnode.shapeFlag & 32) {
      const type = children._;
      if (type) {
        if (optimized && type === 1) {
          needDeletionCheck = false;
        } else {
          assignSlots(slots, children, optimized);
        }
      } else {
        needDeletionCheck = !children.$stable;
        normalizeObjectSlots(children, slots);
      }
      deletionComparisonTarget = children;
    } else if (children) {
      normalizeVNodeSlots(instance, children);
      deletionComparisonTarget = { default: 1 };
    }
    if (needDeletionCheck) {
      for (const key in slots) {
        if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
          delete slots[key];
        }
      }
    }
  };
  const queuePostRenderEffect = queueEffectWithSuspense;
  function createRenderer(options) {
    return baseCreateRenderer(options);
  }
  function baseCreateRenderer(options, createHydrationFns) {
    const target = getGlobalThis();
    target.__VUE__ = true;
    const {
      insert: hostInsert,
      remove: hostRemove,
      patchProp: hostPatchProp,
      createElement: hostCreateElement,
      createText: hostCreateText,
      createComment: hostCreateComment,
      setText: hostSetText,
      setElementText: hostSetElementText,
      parentNode: hostParentNode,
      nextSibling: hostNextSibling,
      setScopeId: hostSetScopeId = NOOP,
      insertStaticContent: hostInsertStaticContent
    } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
      if (n1 === n2) {
        return;
      }
      if (n1 && !isSameVNodeType(n1, n2)) {
        anchor = getNextHostNode(n1);
        unmount(n1, parentComponent, parentSuspense, true);
        n1 = null;
      }
      if (n2.patchFlag === -2) {
        optimized = false;
        n2.dynamicChildren = null;
      }
      const { type, ref: ref3, shapeFlag } = n2;
      switch (type) {
        case Text:
          processText(n1, n2, container, anchor);
          break;
        case Comment:
          processCommentNode(n1, n2, container, anchor);
          break;
        case Static:
          if (n1 == null) {
            mountStaticNode(n2, container, anchor, namespace);
          }
          break;
        case Fragment:
          processFragment(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          break;
        default:
          if (shapeFlag & 1) {
            processElement(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 6) {
            processComponent(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 64) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else if (shapeFlag & 128) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else ;
      }
      if (ref3 != null && parentComponent) {
        setRef(ref3, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
      } else if (ref3 == null && n1 && n1.ref != null) {
        setRef(n1.ref, null, parentSuspense, n1, true);
      }
    };
    const processText = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateText(n2.children),
          container,
          anchor
        );
      } else {
        const el = n2.el = n1.el;
        if (n2.children !== n1.children) {
          hostSetText(el, n2.children);
        }
      }
    };
    const processCommentNode = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateComment(n2.children || ""),
          container,
          anchor
        );
      } else {
        n2.el = n1.el;
      }
    };
    const mountStaticNode = (n2, container, anchor, namespace) => {
      [n2.el, n2.anchor] = hostInsertStaticContent(
        n2.children,
        container,
        anchor,
        namespace,
        n2.el,
        n2.anchor
      );
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostInsert(el, container, nextSibling);
        el = next;
      }
      hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor }) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostRemove(el);
        el = next;
      }
      hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      if (n2.type === "svg") {
        namespace = "svg";
      } else if (n2.type === "math") {
        namespace = "mathml";
      }
      if (n1 == null) {
        mountElement(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
        try {
          if (customElement) {
            customElement._beginPatch();
          }
          patchElement(
            n1,
            n2,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } finally {
          if (customElement) {
            customElement._endPatch();
          }
        }
      }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let el;
      let vnodeHook;
      const { props, shapeFlag, transition, dirs } = vnode;
      el = vnode.el = hostCreateElement(
        vnode.type,
        namespace,
        props && props.is,
        props
      );
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(
          vnode.children,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(vnode, namespace),
          slotScopeIds,
          optimized
        );
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
      if (props) {
        for (const key in props) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props[key], namespace, parentComponent);
          }
        }
        if ("value" in props) {
          hostPatchProp(el, "value", null, props.value, namespace);
        }
        if (vnodeHook = props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
      }
      const needCallTransitionHooks = needTransition(parentSuspense, transition);
      if (needCallTransitionHooks) {
        transition.beforeEnter(el);
      }
      hostInsert(el, container, anchor);
      if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
        queuePostRenderEffect(() => {
          try {
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
          } finally {
          }
        }, parentSuspense);
      }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
      if (scopeId) {
        hostSetScopeId(el, scopeId);
      }
      if (slotScopeIds) {
        for (let i = 0; i < slotScopeIds.length; i++) {
          hostSetScopeId(el, slotScopeIds[i]);
        }
      }
      if (parentComponent) {
        let subTree = parentComponent.subTree;
        if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
          const parentVNode = parentComponent.vnode;
          setScopeId(
            el,
            parentVNode,
            parentVNode.scopeId,
            parentVNode.slotScopeIds,
            parentComponent.parent
          );
        }
      }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
      for (let i = start; i < children.length; i++) {
        const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
        patch(
          null,
          child,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const el = n2.el = n1.el;
      let { patchFlag, dynamicChildren, dirs } = n2;
      patchFlag |= n1.patchFlag & 16;
      const oldProps = n1.props || EMPTY_OBJ;
      const newProps = n2.props || EMPTY_OBJ;
      let vnodeHook;
      parentComponent && toggleRecurse(parentComponent, false);
      if (vnodeHook = newProps.onVnodeBeforeUpdate) {
        invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
      }
      if (dirs) {
        invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
      }
      parentComponent && toggleRecurse(parentComponent, true);
      if (
        // #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)
      ) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) {
        hostSetElementText(el, "");
      }
      if (dynamicChildren) {
        patchBlockChildren(
          n1.dynamicChildren,
          dynamicChildren,
          el,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds
        );
      } else if (!optimized) {
        patchChildren(
          n1,
          n2,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds,
          false
        );
      }
      if (patchFlag > 0) {
        if (patchFlag & 16) {
          patchProps(el, oldProps, newProps, parentComponent, namespace);
        } else {
          if (patchFlag & 2) {
            if (oldProps.class !== newProps.class) {
              hostPatchProp(el, "class", null, newProps.class, namespace);
            }
          }
          if (patchFlag & 4) {
            hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
          }
          if (patchFlag & 8) {
            const propsToUpdate = n2.dynamicProps;
            for (let i = 0; i < propsToUpdate.length; i++) {
              const key = propsToUpdate[i];
              const prev = oldProps[key];
              const next = newProps[key];
              if (next !== prev || key === "value") {
                hostPatchProp(el, key, prev, next, namespace, parentComponent);
              }
            }
          }
        }
        if (patchFlag & 1) {
          if (n1.children !== n2.children) {
            hostSetElementText(el, n2.children);
          }
        }
      } else if (!optimized && dynamicChildren == null) {
        patchProps(el, oldProps, newProps, parentComponent, namespace);
      }
      if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
          dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
      }
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
      for (let i = 0; i < newChildren.length; i++) {
        const oldVNode = oldChildren[i];
        const newVNode = newChildren[i];
        const container = (
          // oldVNode may be an errored async setup() component inside Suspense
          // which will not have a mounted element
          oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
          // of the Fragment itself so it can move its children.
          (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
          // which also requires the correct parent container
          !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
          oldVNode.shapeFlag & (6 | 64 | 128)) ? hostParentNode(oldVNode.el) : (
            // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer
          )
        );
        patch(
          oldVNode,
          newVNode,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          true
        );
      }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
      if (oldProps !== newProps) {
        if (oldProps !== EMPTY_OBJ) {
          for (const key in oldProps) {
            if (!isReservedProp(key) && !(key in newProps)) {
              hostPatchProp(
                el,
                key,
                oldProps[key],
                null,
                namespace,
                parentComponent
              );
            }
          }
        }
        for (const key in newProps) {
          if (isReservedProp(key)) continue;
          const next = newProps[key];
          const prev = oldProps[key];
          if (next !== prev && key !== "value") {
            hostPatchProp(el, key, prev, next, namespace, parentComponent);
          }
        }
        if ("value" in newProps) {
          hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
      }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
      const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
      let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      if (n1 == null) {
        hostInsert(fragmentStartAnchor, container, anchor);
        hostInsert(fragmentEndAnchor, container, anchor);
        mountChildren(
          // #10007
          // such fragment like `<></>` will be compiled into
          // a fragment which doesn't have a children.
          // In this case fallback to an empty array
          n2.children || [],
          container,
          fragmentEndAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
          patchBlockChildren(
            n1.dynamicChildren,
            dynamicChildren,
            container,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds
          );
          if (
            // #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree
          ) {
            traverseStaticChildren(
              n1,
              n2,
              true
              /* shallow */
            );
          }
        } else {
          patchChildren(
            n1,
            n2,
            container,
            fragmentEndAnchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      }
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      n2.slotScopeIds = slotScopeIds;
      if (n1 == null) {
        if (n2.shapeFlag & 512) {
          parentComponent.ctx.activate(
            n2,
            container,
            anchor,
            namespace,
            optimized
          );
        } else {
          mountComponent(
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            optimized
          );
        }
      } else {
        updateComponent(n1, n2, optimized);
      }
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
      const instance = initialVNode.component = createComponentInstance(
        initialVNode,
        parentComponent,
        parentSuspense
      );
      if (isKeepAlive(initialVNode)) {
        instance.ctx.renderer = internals;
      }
      {
        setupComponent(instance, false, optimized);
      }
      if (instance.asyncDep) {
        parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
        if (!initialVNode.el) {
          const placeholder = instance.subTree = createVNode(Comment);
          processCommentNode(null, placeholder, container, anchor);
          initialVNode.placeholder = placeholder.el;
        }
      } else {
        setupRenderEffect(
          instance,
          initialVNode,
          container,
          anchor,
          parentSuspense,
          namespace,
          optimized
        );
      }
    };
    const updateComponent = (n1, n2, optimized) => {
      const instance = n2.component = n1.component;
      if (shouldUpdateComponent(n1, n2, optimized)) {
        if (instance.asyncDep && !instance.asyncResolved) {
          updateComponentPreRender(instance, n2, optimized);
          return;
        } else {
          instance.next = n2;
          instance.update();
        }
      } else {
        n2.el = n1.el;
        instance.vnode = n2;
      }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
      const componentUpdateFn = () => {
        if (!instance.isMounted) {
          let vnodeHook;
          const { el, props } = initialVNode;
          const { bm, m, parent, root, type } = instance;
          const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
          toggleRecurse(instance, false);
          if (bm) {
            invokeArrayFns(bm);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
            invokeVNodeHook(vnodeHook, parent, initialVNode);
          }
          toggleRecurse(instance, true);
          {
            if (root.ce && root.ce._hasShadowRoot()) {
              root.ce._injectChildStyle(
                type,
                instance.parent ? instance.parent.type : void 0
              );
            }
            const subTree = instance.subTree = renderComponentRoot(instance);
            patch(
              null,
              subTree,
              container,
              anchor,
              instance,
              parentSuspense,
              namespace
            );
            initialVNode.el = subTree.el;
          }
          if (m) {
            queuePostRenderEffect(m, parentSuspense);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
            const scopedInitialVNode = initialVNode;
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode),
              parentSuspense
            );
          }
          if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) {
            instance.a && queuePostRenderEffect(instance.a, parentSuspense);
          }
          instance.isMounted = true;
          initialVNode = container = anchor = null;
        } else {
          let { next, bu, u, parent, vnode } = instance;
          {
            const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
            if (nonHydratedAsyncRoot) {
              if (next) {
                next.el = vnode.el;
                updateComponentPreRender(instance, next, optimized);
              }
              nonHydratedAsyncRoot.asyncDep.then(() => {
                queuePostRenderEffect(() => {
                  if (!instance.isUnmounted) update();
                }, parentSuspense);
              });
              return;
            }
          }
          let originNext = next;
          let vnodeHook;
          toggleRecurse(instance, false);
          if (next) {
            next.el = vnode.el;
            updateComponentPreRender(instance, next, optimized);
          } else {
            next = vnode;
          }
          if (bu) {
            invokeArrayFns(bu);
          }
          if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
            invokeVNodeHook(vnodeHook, parent, next, vnode);
          }
          toggleRecurse(instance, true);
          const nextTree = renderComponentRoot(instance);
          const prevTree = instance.subTree;
          instance.subTree = nextTree;
          patch(
            prevTree,
            nextTree,
            // parent may have changed if it's in a teleport
            hostParentNode(prevTree.el),
            // anchor may have changed if it's in a fragment
            getNextHostNode(prevTree),
            instance,
            parentSuspense,
            namespace
          );
          next.el = nextTree.el;
          if (originNext === null) {
            updateHOCHostEl(instance, nextTree.el);
          }
          if (u) {
            queuePostRenderEffect(u, parentSuspense);
          }
          if (vnodeHook = next.props && next.props.onVnodeUpdated) {
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent, next, vnode),
              parentSuspense
            );
          }
        }
      };
      instance.scope.on();
      const effect2 = instance.effect = new ReactiveEffect(componentUpdateFn);
      instance.scope.off();
      const update = instance.update = effect2.run.bind(effect2);
      const job = instance.job = effect2.runIfDirty.bind(effect2);
      job.i = instance;
      job.id = instance.uid;
      effect2.scheduler = () => queueJob(job);
      toggleRecurse(instance, true);
      update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized) => {
      nextVNode.component = instance;
      const prevProps = instance.vnode.props;
      instance.vnode = nextVNode;
      instance.next = null;
      updateProps(instance, nextVNode.props, prevProps, optimized);
      updateSlots(instance, nextVNode.children, optimized);
      pauseTracking();
      flushPreFlushCbs(instance);
      resetTracking();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
      const c1 = n1 && n1.children;
      const prevShapeFlag = n1 ? n1.shapeFlag : 0;
      const c2 = n2.children;
      const { patchFlag, shapeFlag } = n2;
      if (patchFlag > 0) {
        if (patchFlag & 128) {
          patchKeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        } else if (patchFlag & 256) {
          patchUnkeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        }
      }
      if (shapeFlag & 8) {
        if (prevShapeFlag & 16) {
          unmountChildren(c1, parentComponent, parentSuspense);
        }
        if (c2 !== c1) {
          hostSetElementText(container, c2);
        }
      } else {
        if (prevShapeFlag & 16) {
          if (shapeFlag & 16) {
            patchKeyedChildren(
              c1,
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else {
            unmountChildren(c1, parentComponent, parentSuspense, true);
          }
        } else {
          if (prevShapeFlag & 8) {
            hostSetElementText(container, "");
          }
          if (shapeFlag & 16) {
            mountChildren(
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          }
        }
      }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      c1 = c1 || EMPTY_ARR;
      c2 = c2 || EMPTY_ARR;
      const oldLength = c1.length;
      const newLength = c2.length;
      const commonLength = Math.min(oldLength, newLength);
      let i;
      for (i = 0; i < commonLength; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        patch(
          c1[i],
          nextChild,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
      if (oldLength > newLength) {
        unmountChildren(
          c1,
          parentComponent,
          parentSuspense,
          true,
          false,
          commonLength
        );
      } else {
        mountChildren(
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized,
          commonLength
        );
      }
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let i = 0;
      const l2 = c2.length;
      let e1 = c1.length - 1;
      let e2 = l2 - 1;
      while (i <= e1 && i <= e2) {
        const n1 = c1[i];
        const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        i++;
      }
      while (i <= e1 && i <= e2) {
        const n1 = c1[e1];
        const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        e1--;
        e2--;
      }
      if (i > e1) {
        if (i <= e2) {
          const nextPos = e2 + 1;
          const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
          while (i <= e2) {
            patch(
              null,
              c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]),
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            i++;
          }
        }
      } else if (i > e2) {
        while (i <= e1) {
          unmount(c1[i], parentComponent, parentSuspense, true);
          i++;
        }
      } else {
        const s1 = i;
        const s2 = i;
        const keyToNewIndexMap = /* @__PURE__ */ new Map();
        for (i = s2; i <= e2; i++) {
          const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
          if (nextChild.key != null) {
            keyToNewIndexMap.set(nextChild.key, i);
          }
        }
        let j;
        let patched = 0;
        const toBePatched = e2 - s2 + 1;
        let moved = false;
        let maxNewIndexSoFar = 0;
        const newIndexToOldIndexMap = new Array(toBePatched);
        for (i = 0; i < toBePatched; i++) newIndexToOldIndexMap[i] = 0;
        for (i = s1; i <= e1; i++) {
          const prevChild = c1[i];
          if (patched >= toBePatched) {
            unmount(prevChild, parentComponent, parentSuspense, true);
            continue;
          }
          let newIndex;
          if (prevChild.key != null) {
            newIndex = keyToNewIndexMap.get(prevChild.key);
          } else {
            for (j = s2; j <= e2; j++) {
              if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                newIndex = j;
                break;
              }
            }
          }
          if (newIndex === void 0) {
            unmount(prevChild, parentComponent, parentSuspense, true);
          } else {
            newIndexToOldIndexMap[newIndex - s2] = i + 1;
            if (newIndex >= maxNewIndexSoFar) {
              maxNewIndexSoFar = newIndex;
            } else {
              moved = true;
            }
            patch(
              prevChild,
              c2[newIndex],
              container,
              null,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            patched++;
          }
        }
        const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
        j = increasingNewIndexSequence.length - 1;
        for (i = toBePatched - 1; i >= 0; i--) {
          const nextIndex = s2 + i;
          const nextChild = c2[nextIndex];
          const anchorVNode = c2[nextIndex + 1];
          const anchor = nextIndex + 1 < l2 ? (
            // #13559, #14173 fallback to el placeholder for unresolved async component
            anchorVNode.el || resolveAsyncComponentPlaceholder(anchorVNode)
          ) : parentAnchor;
          if (newIndexToOldIndexMap[i] === 0) {
            patch(
              null,
              nextChild,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (moved) {
            if (j < 0 || i !== increasingNewIndexSequence[j]) {
              move(nextChild, container, anchor, 2);
            } else {
              j--;
            }
          }
        }
      }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
      const { el, type, transition, children, shapeFlag } = vnode;
      if (shapeFlag & 6) {
        move(vnode.component.subTree, container, anchor, moveType);
        return;
      }
      if (shapeFlag & 128) {
        vnode.suspense.move(container, anchor, moveType);
        return;
      }
      if (shapeFlag & 64) {
        type.move(vnode, container, anchor, internals);
        return;
      }
      if (type === Fragment) {
        hostInsert(el, container, anchor);
        for (let i = 0; i < children.length; i++) {
          move(children[i], container, anchor, moveType);
        }
        hostInsert(vnode.anchor, container, anchor);
        return;
      }
      if (type === Static) {
        moveStaticNode(vnode, container, anchor);
        return;
      }
      const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
      if (needTransition2) {
        if (moveType === 0) {
          if (transition.persisted && !el[leaveCbKey]) {
            hostInsert(el, container, anchor);
          } else {
            transition.beforeEnter(el);
            hostInsert(el, container, anchor);
            queuePostRenderEffect(() => transition.enter(el), parentSuspense);
          }
        } else {
          const { leave, delayLeave, afterLeave } = transition;
          const remove22 = () => {
            if (vnode.ctx.isUnmounted) {
              hostRemove(el);
            } else {
              hostInsert(el, container, anchor);
            }
          };
          const performLeave = () => {
            const wasLeaving = el._isLeaving || !!el[leaveCbKey];
            if (el._isLeaving) {
              el[leaveCbKey](
                true
                /* cancelled */
              );
            }
            if (transition.persisted && !wasLeaving) {
              remove22();
            } else {
              leave(el, () => {
                remove22();
                afterLeave && afterLeave();
              });
            }
          };
          if (delayLeave) {
            delayLeave(el, remove22, performLeave);
          } else {
            performLeave();
          }
        }
      } else {
        hostInsert(el, container, anchor);
      }
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
      const {
        type,
        props,
        ref: ref3,
        children,
        dynamicChildren,
        shapeFlag,
        patchFlag,
        dirs,
        cacheIndex,
        memo
      } = vnode;
      if (patchFlag === -2) {
        optimized = false;
      }
      if (ref3 != null) {
        pauseTracking();
        setRef(ref3, null, parentSuspense, vnode, true);
        resetTracking();
      }
      if (cacheIndex != null) {
        parentComponent.renderCache[cacheIndex] = void 0;
      }
      if (shapeFlag & 256) {
        parentComponent.ctx.deactivate(vnode);
        return;
      }
      const shouldInvokeDirs = shapeFlag & 1 && dirs;
      const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
      let vnodeHook;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
      if (shapeFlag & 6) {
        unmountComponent(vnode.component, parentSuspense, doRemove);
      } else {
        if (shapeFlag & 128) {
          vnode.suspense.unmount(parentSuspense, doRemove);
          return;
        }
        if (shouldInvokeDirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
        }
        if (shapeFlag & 64) {
          vnode.type.remove(
            vnode,
            parentComponent,
            parentSuspense,
            internals,
            doRemove
          );
        } else if (dynamicChildren && // #5154
        // when v-once is used inside a block, setBlockTracking(-1) marks the
        // parent block with hasOnce: true
        // so that it doesn't take the fast path during unmount - otherwise
        // components nested in v-once are never unmounted.
        !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
        (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
          unmountChildren(
            dynamicChildren,
            parentComponent,
            parentSuspense,
            false,
            true
          );
        } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
          unmountChildren(children, parentComponent, parentSuspense);
        }
        if (doRemove) {
          remove2(vnode);
        }
      }
      const shouldInvalidateMemo = memo != null && cacheIndex == null;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
          if (shouldInvalidateMemo) {
            vnode.el = null;
          }
        }, parentSuspense);
      }
    };
    const remove2 = (vnode) => {
      const { type, el, anchor, transition } = vnode;
      if (type === Fragment) {
        {
          removeFragment(el, anchor);
        }
        return;
      }
      if (type === Static) {
        removeStaticNode(vnode);
        return;
      }
      const performRemove = () => {
        hostRemove(el);
        if (transition && !transition.persisted && transition.afterLeave) {
          transition.afterLeave();
        }
      };
      if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
        const { leave, delayLeave } = transition;
        const performLeave = () => leave(el, performRemove);
        if (delayLeave) {
          delayLeave(vnode.el, performRemove, performLeave);
        } else {
          performLeave();
        }
      } else {
        performRemove();
      }
    };
    const removeFragment = (cur, end) => {
      let next;
      while (cur !== end) {
        next = hostNextSibling(cur);
        hostRemove(cur);
        cur = next;
      }
      hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove) => {
      const { bum, scope, job, subTree, um, m, a } = instance;
      invalidateMount(m);
      invalidateMount(a);
      if (bum) {
        invokeArrayFns(bum);
      }
      scope.stop();
      if (job) {
        job.flags |= 8;
        unmount(subTree, instance, parentSuspense, doRemove);
      }
      if (um) {
        queuePostRenderEffect(um, parentSuspense);
      }
      queuePostRenderEffect(() => {
        instance.isUnmounted = true;
      }, parentSuspense);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
      for (let i = start; i < children.length; i++) {
        unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
      }
    };
    const getNextHostNode = (vnode) => {
      if (vnode.shapeFlag & 6) {
        return getNextHostNode(vnode.component.subTree);
      }
      if (vnode.shapeFlag & 128) {
        return vnode.suspense.next();
      }
      const el = hostNextSibling(vnode.anchor || vnode.el);
      const teleportEnd = el && el[TeleportEndKey];
      return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace) => {
      let instance;
      if (vnode == null) {
        if (container._vnode) {
          unmount(container._vnode, null, null, true);
          instance = container._vnode.component;
        }
      } else {
        patch(
          container._vnode || null,
          vnode,
          container,
          null,
          null,
          null,
          namespace
        );
      }
      container._vnode = vnode;
      if (!isFlushing) {
        isFlushing = true;
        flushPreFlushCbs(instance);
        flushPostFlushCbs();
        isFlushing = false;
      }
    };
    const internals = {
      p: patch,
      um: unmount,
      m: move,
      r: remove2,
      mt: mountComponent,
      mc: mountChildren,
      pc: patchChildren,
      pbc: patchBlockChildren,
      n: getNextHostNode,
      o: options
    };
    let hydrate;
    return {
      render,
      hydrate,
      createApp: createAppAPI(render)
    };
  }
  function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
  }
  function toggleRecurse({ effect: effect2, job }, allowed) {
    if (allowed) {
      effect2.flags |= 32;
      job.flags |= 4;
    } else {
      effect2.flags &= -33;
      job.flags &= -5;
    }
  }
  function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
  }
  function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if (isArray$1(ch1) && isArray$1(ch2)) {
      for (let i = 0; i < ch1.length; i++) {
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
          if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
            c2 = ch2[i] = cloneIfMounted(ch2[i]);
            c2.el = c1.el;
          }
          if (!shallow && c2.patchFlag !== -2)
            traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) {
          if (c2.patchFlag === -1) {
            c2 = ch2[i] = cloneIfMounted(c2);
          }
          c2.el = c1.el;
        }
        if (c2.type === Comment && !c2.el) {
          c2.el = c1.el;
        }
      }
    }
  }
  function getSequence(arr) {
    const p2 = arr.slice();
    const result = [0];
    let i, j, u, v, c;
    const len = arr.length;
    for (i = 0; i < len; i++) {
      const arrI = arr[i];
      if (arrI !== 0) {
        j = result[result.length - 1];
        if (arr[j] < arrI) {
          p2[i] = j;
          result.push(i);
          continue;
        }
        u = 0;
        v = result.length - 1;
        while (u < v) {
          c = u + v >> 1;
          if (arr[result[c]] < arrI) {
            u = c + 1;
          } else {
            v = c;
          }
        }
        if (arrI < arr[result[u]]) {
          if (u > 0) {
            p2[i] = result[u - 1];
          }
          result[u] = i;
        }
      }
    }
    u = result.length;
    v = result[u - 1];
    while (u-- > 0) {
      result[u] = v;
      v = p2[v];
    }
    return result;
  }
  function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
      if (subComponent.asyncDep && !subComponent.asyncResolved) {
        return subComponent;
      } else {
        return locateNonHydratedAsyncRoot(subComponent);
      }
    }
  }
  function invalidateMount(hooks) {
    if (hooks) {
      for (let i = 0; i < hooks.length; i++)
        hooks[i].flags |= 8;
    }
  }
  function resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) {
      return anchorVnode.placeholder;
    }
    const instance = anchorVnode.component;
    if (instance) {
      return resolveAsyncComponentPlaceholder(instance.subTree);
    }
    return null;
  }
  const isSuspense = (type) => type.__isSuspense;
  function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
      if (isArray$1(fn)) {
        suspense.effects.push(...fn);
      } else {
        suspense.effects.push(fn);
      }
    } else {
      queuePostFlushCb(fn);
    }
  }
  const Fragment = /* @__PURE__ */ Symbol.for("v-fgt");
  const Text = /* @__PURE__ */ Symbol.for("v-txt");
  const Comment = /* @__PURE__ */ Symbol.for("v-cmt");
  const Static = /* @__PURE__ */ Symbol.for("v-stc");
  const blockStack = [];
  let currentBlock = null;
  function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
  }
  function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
  }
  let isBlockTreeEnabled = 1;
  function setBlockTracking(value, inVOnce = false) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock && inVOnce) {
      currentBlock.hasOnce = true;
    }
  }
  function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(
      createBaseVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        shapeFlag,
        true
      )
    );
  }
  function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(
      createVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        true
      )
    );
  }
  function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
  }
  function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
  }
  const normalizeKey = ({ key }) => key != null ? key : null;
  const normalizeRef = ({
    ref: ref3,
    ref_key,
    ref_for
  }) => {
    if (typeof ref3 === "number") {
      ref3 = "" + ref3;
    }
    return ref3 != null ? isString$1(ref3) || /* @__PURE__ */ isRef(ref3) || isFunction$2(ref3) ? { i: currentRenderingInstance, r: ref3, k: ref_key, f: !!ref_for } : ref3 : null;
  };
  function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
      __v_isVNode: true,
      __v_skip: true,
      type,
      props,
      key: props && normalizeKey(props),
      ref: props && normalizeRef(props),
      scopeId: currentScopeId,
      slotScopeIds: null,
      children,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag,
      patchFlag,
      dynamicProps,
      dynamicChildren: null,
      appContext: null,
      ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
      normalizeChildren(vnode, children);
      if (shapeFlag & 128) {
        type.normalize(vnode);
      }
    } else if (children) {
      vnode.shapeFlag |= isString$1(children) ? 8 : 16;
    }
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  const createVNode = _createVNode;
  function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
      type = Comment;
    }
    if (isVNode(type)) {
      const cloned = cloneVNode(
        type,
        props,
        true
        /* mergeRef: true */
      );
      if (children) {
        normalizeChildren(cloned, children);
      }
      if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
        if (cloned.shapeFlag & 6) {
          currentBlock[currentBlock.indexOf(type)] = cloned;
        } else {
          currentBlock.push(cloned);
        }
      }
      cloned.patchFlag = -2;
      return cloned;
    }
    if (isClassComponent(type)) {
      type = type.__vccOpts;
    }
    if (props) {
      props = guardReactiveProps(props);
      let { class: klass, style } = props;
      if (klass && !isString$1(klass)) {
        props.class = normalizeClass(klass);
      }
      if (isObject$1(style)) {
        if (/* @__PURE__ */ isProxy(style) && !isArray$1(style)) {
          style = extend$1({}, style);
        }
        props.style = normalizeStyle(style);
      }
    }
    const shapeFlag = isString$1(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$1(type) ? 4 : isFunction$2(type) ? 2 : 0;
    return createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      isBlockNode,
      true
    );
  }
  function guardReactiveProps(props) {
    if (!props) return null;
    return /* @__PURE__ */ isProxy(props) || isInternalObject(props) ? extend$1({}, props) : props;
  }
  function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref: ref3, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
      __v_isVNode: true,
      __v_skip: true,
      type: vnode.type,
      props: mergedProps,
      key: mergedProps && normalizeKey(mergedProps),
      ref: extraProps && extraProps.ref ? (
        // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref3 ? isArray$1(ref3) ? ref3.concat(normalizeRef(extraProps)) : [ref3, normalizeRef(extraProps)] : normalizeRef(extraProps)
      ) : ref3,
      scopeId: vnode.scopeId,
      slotScopeIds: vnode.slotScopeIds,
      children,
      target: vnode.target,
      targetStart: vnode.targetStart,
      targetAnchor: vnode.targetAnchor,
      staticCount: vnode.staticCount,
      shapeFlag: vnode.shapeFlag,
      // if the vnode is cloned with extra props, we can no longer assume its
      // existing patch flag to be reliable and need to add the FULL_PROPS flag.
      // note: preserve flag for fragments since they use the flag for children
      // fast paths only.
      patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
      dynamicProps: vnode.dynamicProps,
      dynamicChildren: vnode.dynamicChildren,
      appContext: vnode.appContext,
      dirs: vnode.dirs,
      transition,
      // These should technically only be non-null on mounted VNodes. However,
      // they *should* be copied for kept-alive vnodes. So we just always copy
      // them since them being non-null during a mount doesn't affect the logic as
      // they will simply be overwritten.
      component: vnode.component,
      suspense: vnode.suspense,
      ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
      ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
      placeholder: vnode.placeholder,
      el: vnode.el,
      anchor: vnode.anchor,
      ctx: vnode.ctx,
      ce: vnode.ce
    };
    if (transition && cloneTransition) {
      setTransitionHooks(
        cloned,
        transition.clone(cloned)
      );
    }
    return cloned;
  }
  function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
  }
  function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
  }
  function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
  }
  function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") {
      return createVNode(Comment);
    } else if (isArray$1(child)) {
      return createVNode(
        Fragment,
        null,
        // #3666, avoid reference pollution when reusing vnode
        child.slice()
      );
    } else if (isVNode(child)) {
      return cloneIfMounted(child);
    } else {
      return createVNode(Text, null, String(child));
    }
  }
  function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
  }
  function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) {
      children = null;
    } else if (isArray$1(children)) {
      type = 16;
    } else if (typeof children === "object") {
      if (shapeFlag & (1 | 64)) {
        const slot = children.default;
        if (slot) {
          slot._c && (slot._d = false);
          normalizeChildren(vnode, slot());
          slot._c && (slot._d = true);
        }
        return;
      } else {
        type = 32;
        const slotFlag = children._;
        if (!slotFlag && !isInternalObject(children)) {
          children._ctx = currentRenderingInstance;
        } else if (slotFlag === 3 && currentRenderingInstance) {
          if (currentRenderingInstance.slots._ === 1) {
            children._ = 1;
          } else {
            children._ = 2;
            vnode.patchFlag |= 1024;
          }
        }
      }
    } else if (isFunction$2(children)) {
      if (shapeFlag & (1 | 64)) {
        normalizeChildren(vnode, { default: children });
        return;
      }
      children = { default: children, _ctx: currentRenderingInstance };
      type = 32;
    } else {
      children = String(children);
      if (shapeFlag & 64) {
        type = 16;
        children = [createTextVNode(children)];
      } else {
        type = 8;
      }
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
  }
  function mergeProps(...args) {
    const ret = {};
    for (let i = 0; i < args.length; i++) {
      const toMerge = args[i];
      for (const key in toMerge) {
        if (key === "class") {
          if (ret.class !== toMerge.class) {
            ret.class = normalizeClass([ret.class, toMerge.class]);
          }
        } else if (key === "style") {
          ret.style = normalizeStyle([ret.style, toMerge.style]);
        } else if (isOn(key)) {
          const existing = ret[key];
          const incoming = toMerge[key];
          if (incoming && existing !== incoming && !(isArray$1(existing) && existing.includes(incoming))) {
            ret[key] = existing ? [].concat(existing, incoming) : incoming;
          } else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
          // the model listener.
          !isModelListener(key)) {
            ret[key] = incoming;
          }
        } else if (key !== "") {
          ret[key] = toMerge[key];
        }
      }
    }
    return ret;
  }
  function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
      vnode,
      prevVNode
    ]);
  }
  const emptyAppContext = createAppContext();
  let uid = 0;
  function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
      uid: uid++,
      vnode,
      type,
      parent,
      appContext,
      root: null,
      // to be immediately set
      next: null,
      subTree: null,
      // will be set synchronously right after creation
      effect: null,
      update: null,
      // will be set synchronously right after creation
      job: null,
      scope: new EffectScope(
        true
        /* detached */
      ),
      render: null,
      proxy: null,
      exposed: null,
      exposeProxy: null,
      withProxy: null,
      provides: parent ? parent.provides : Object.create(appContext.provides),
      ids: parent ? parent.ids : ["", 0, 0],
      accessCache: null,
      renderCache: [],
      // local resolved assets
      components: null,
      directives: null,
      // resolved props and emits options
      propsOptions: normalizePropsOptions(type, appContext),
      emitsOptions: normalizeEmitsOptions(type, appContext),
      // emit
      emit: null,
      // to be set immediately
      emitted: null,
      // props default value
      propsDefaults: EMPTY_OBJ,
      // inheritAttrs
      inheritAttrs: type.inheritAttrs,
      // state
      ctx: EMPTY_OBJ,
      data: EMPTY_OBJ,
      props: EMPTY_OBJ,
      attrs: EMPTY_OBJ,
      slots: EMPTY_OBJ,
      refs: EMPTY_OBJ,
      setupState: EMPTY_OBJ,
      setupContext: null,
      // suspense related
      suspense,
      suspenseId: suspense ? suspense.pendingId : 0,
      asyncDep: null,
      asyncResolved: false,
      // lifecycle hooks
      // not using enums here because it results in computed properties
      isMounted: false,
      isUnmounted: false,
      isDeactivated: false,
      bc: null,
      c: null,
      bm: null,
      m: null,
      bu: null,
      u: null,
      um: null,
      bum: null,
      da: null,
      a: null,
      rtg: null,
      rtc: null,
      ec: null,
      sp: null
    };
    {
      instance.ctx = { _: instance };
    }
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) {
      vnode.ce(instance);
    }
    return instance;
  }
  let currentInstance = null;
  const getCurrentInstance = () => currentInstance || currentRenderingInstance;
  let internalSetCurrentInstance;
  let setInSSRSetupState;
  {
    const g = getGlobalThis();
    const registerGlobalSetter = (key, setter) => {
      let setters;
      if (!(setters = g[key])) setters = g[key] = [];
      setters.push(setter);
      return (v) => {
        if (setters.length > 1) setters.forEach((set) => set(v));
        else setters[0](v);
      };
    };
    internalSetCurrentInstance = registerGlobalSetter(
      `__VUE_INSTANCE_SETTERS__`,
      (v) => currentInstance = v
    );
    setInSSRSetupState = registerGlobalSetter(
      `__VUE_SSR_SETTERS__`,
      (v) => isInSSRComponentSetup = v
    );
  }
  const setCurrentInstance = (instance) => {
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return () => {
      instance.scope.off();
      internalSetCurrentInstance(prev);
    };
  };
  const unsetCurrentInstance = () => {
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
  };
  function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
  }
  let isInSSRComponentSetup = false;
  function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
  }
  function setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
      pauseTracking();
      const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
      const reset = setCurrentInstance(instance);
      const setupResult = callWithErrorHandling(
        setup,
        instance,
        0,
        [
          instance.props,
          setupContext
        ]
      );
      const isAsyncSetup = isPromise(setupResult);
      resetTracking();
      reset();
      if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) {
        markAsyncBoundary(instance);
      }
      if (isAsyncSetup) {
        setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
        if (isSSR) {
          return setupResult.then((resolvedResult) => {
            setInSSRSetupState(true);
            try {
              handleSetupResult(instance, resolvedResult, isSSR);
            } finally {
              setInSSRSetupState(false);
            }
          }).catch((e) => {
            handleError(e, instance, 0);
          });
        } else {
          instance.asyncDep = setupResult;
        }
      } else {
        handleSetupResult(instance, setupResult);
      }
    } else {
      finishComponentSetup(instance);
    }
  }
  function handleSetupResult(instance, setupResult, isSSR) {
    if (isFunction$2(setupResult)) {
      if (instance.type.__ssrInlineRender) {
        instance.ssrRender = setupResult;
      } else {
        instance.render = setupResult;
      }
    } else if (isObject$1(setupResult)) {
      instance.setupState = proxyRefs(setupResult);
    } else ;
    finishComponentSetup(instance);
  }
  function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
      instance.render = Component.render || NOOP;
    }
    {
      const reset = setCurrentInstance(instance);
      pauseTracking();
      try {
        applyOptions(instance);
      } finally {
        resetTracking();
        reset();
      }
    }
  }
  const attrsProxyHandlers = {
    get(target, key) {
      track(target, "get", "");
      return target[key];
    }
  };
  function createSetupContext(instance) {
    const expose = (exposed) => {
      instance.exposed = exposed || {};
    };
    {
      return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
      };
    }
  }
  function getComponentPublicInstance(instance) {
    if (instance.exposed) {
      return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
        get(target, key) {
          if (key in target) {
            return target[key];
          } else if (key in publicPropertiesMap) {
            return publicPropertiesMap[key](instance);
          }
        },
        has(target, key) {
          return key in target || key in publicPropertiesMap;
        }
      }));
    } else {
      return instance.proxy;
    }
  }
  const classifyRE = /(?:^|[-_])\w/g;
  const classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
  function getComponentName$1(Component, includeInferred = true) {
    return isFunction$2(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
  }
  function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName$1(Component);
    if (!name && Component.__file) {
      const match = Component.__file.match(/([^/\\]+)\.\w+$/);
      if (match) {
        name = match[1];
      }
    }
    if (!name && instance) {
      const inferFromRegistry = (registry) => {
        for (const key in registry) {
          if (registry[key] === Component) {
            return key;
          }
        }
      };
      name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(
        instance.parent.type.components
      ) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
  }
  function isClassComponent(value) {
    return isFunction$2(value) && "__vccOpts" in value;
  }
  const computed = (getterOrOptions, debugOptions) => {
    const c = /* @__PURE__ */ computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
  };
  function h(type, propsOrChildren, children) {
    try {
      setBlockTracking(-1);
      const l = arguments.length;
      if (l === 2) {
        if (isObject$1(propsOrChildren) && !isArray$1(propsOrChildren)) {
          if (isVNode(propsOrChildren)) {
            return createVNode(type, null, [propsOrChildren]);
          }
          return createVNode(type, propsOrChildren);
        } else {
          return createVNode(type, null, propsOrChildren);
        }
      } else {
        if (l > 3) {
          children = Array.prototype.slice.call(arguments, 2);
        } else if (l === 3 && isVNode(children)) {
          children = [children];
        }
        return createVNode(type, propsOrChildren, children);
      }
    } finally {
      setBlockTracking(1);
    }
  }
  const version = "3.5.42";
  /**
  * @vue/runtime-dom v3.5.42
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/
  let policy = void 0;
  const tt = typeof window !== "undefined" && window.trustedTypes;
  if (tt) {
    try {
      policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val) => val
      });
    } catch (e) {
    }
  }
  const unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
  const svgNS = "http://www.w3.org/2000/svg";
  const mathmlNS = "http://www.w3.org/1998/Math/MathML";
  const doc = typeof document !== "undefined" ? document : null;
  const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
  const nodeOps = {
    insert: (child, parent, anchor) => {
      parent.insertBefore(child, anchor || null);
    },
    remove: (child) => {
      const parent = child.parentNode;
      if (parent) {
        parent.removeChild(child);
      }
    },
    createElement: (tag, namespace, is, props) => {
      const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, { is }) : doc.createElement(tag);
      if (tag === "select" && props && props.multiple != null) {
        el.setAttribute("multiple", props.multiple);
      }
      return el;
    },
    createText: (text) => doc.createTextNode(text),
    createComment: (text) => doc.createComment(text),
    setText: (node, text) => {
      node.nodeValue = text;
    },
    setElementText: (el, text) => {
      el.textContent = text;
    },
    parentNode: (node) => node.parentNode,
    nextSibling: (node) => node.nextSibling,
    querySelector: (selector) => doc.querySelector(selector),
    setScopeId(el, id) {
      el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent(content, parent, anchor, namespace, start, end) {
      const before = anchor ? anchor.previousSibling : parent.lastChild;
      if (start && (start === end || start.nextSibling)) {
        while (true) {
          parent.insertBefore(start.cloneNode(true), anchor);
          if (start === end || !(start = start.nextSibling)) break;
        }
      } else {
        templateContainer.innerHTML = unsafeToTrustedHTML(
          namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content
        );
        const template = templateContainer.content;
        if (namespace === "svg" || namespace === "mathml") {
          const wrapper = template.firstChild;
          while (wrapper.firstChild) {
            template.appendChild(wrapper.firstChild);
          }
          template.removeChild(wrapper);
        }
        parent.insertBefore(template, anchor);
      }
      return [
        // first
        before ? before.nextSibling : parent.firstChild,
        // last
        anchor ? anchor.previousSibling : parent.lastChild
      ];
    }
  };
  const TRANSITION = "transition";
  const ANIMATION = "animation";
  const vtcKey = /* @__PURE__ */ Symbol("_vtc");
  const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
      type: Boolean,
      default: true
    },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
  };
  const TransitionPropsValidators = /* @__PURE__ */ extend$1(
    {},
    BaseTransitionPropsValidators,
    DOMTransitionPropsValidators
  );
  const decorate$1 = (t) => {
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
  };
  const Transition = /* @__PURE__ */ decorate$1(
    (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots)
  );
  const callHook = (hook, args = []) => {
    if (isArray$1(hook)) {
      hook.forEach((h2) => h2(...args));
    } else if (hook) {
      hook(...args);
    }
  };
  const hasExplicitCallback = (hook) => {
    return hook ? isArray$1(hook) ? hook.some((h2) => h2.length > 1) : hook.length > 1 : false;
  };
  function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for (const key in rawProps) {
      if (!(key in DOMTransitionPropsValidators)) {
        baseProps[key] = rawProps[key];
      }
    }
    if (rawProps.css === false) {
      return baseProps;
    }
    const {
      name = "v",
      type,
      duration,
      enterFromClass = `${name}-enter-from`,
      enterActiveClass = `${name}-enter-active`,
      enterToClass = `${name}-enter-to`,
      appearFromClass = enterFromClass,
      appearActiveClass = enterActiveClass,
      appearToClass = enterToClass,
      leaveFromClass = `${name}-leave-from`,
      leaveActiveClass = `${name}-leave-active`,
      leaveToClass = `${name}-leave-to`
    } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const {
      onBeforeEnter,
      onEnter,
      onEnterCancelled,
      onLeave,
      onLeaveCancelled,
      onBeforeAppear = onBeforeEnter,
      onAppear = onEnter,
      onAppearCancelled = onEnterCancelled
    } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled) => {
      el._enterCancelled = isCancelled;
      removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
      removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
      done && done();
    };
    const finishLeave = (el, done) => {
      el._isLeaving = false;
      removeTransitionClass(el, leaveFromClass);
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
      done && done();
    };
    const makeEnterHook = (isAppear) => {
      return (el, done) => {
        const hook = isAppear ? onAppear : onEnter;
        const resolve2 = () => finishEnter(el, isAppear, done);
        callHook(hook, [el, resolve2]);
        nextFrame(() => {
          removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
          addTransitionClass(el, isAppear ? appearToClass : enterToClass);
          if (!hasExplicitCallback(hook)) {
            whenTransitionEnds(el, type, enterDuration, resolve2);
          }
        });
      };
    };
    return extend$1(baseProps, {
      onBeforeEnter(el) {
        callHook(onBeforeEnter, [el]);
        addTransitionClass(el, enterFromClass);
        addTransitionClass(el, enterActiveClass);
      },
      onBeforeAppear(el) {
        callHook(onBeforeAppear, [el]);
        addTransitionClass(el, appearFromClass);
        addTransitionClass(el, appearActiveClass);
      },
      onEnter: makeEnterHook(false),
      onAppear: makeEnterHook(true),
      onLeave(el, done) {
        el._isLeaving = true;
        const resolve2 = () => finishLeave(el, done);
        addTransitionClass(el, leaveFromClass);
        if (!el._enterCancelled) {
          forceReflow(el);
          addTransitionClass(el, leaveActiveClass);
        } else {
          addTransitionClass(el, leaveActiveClass);
          forceReflow(el);
        }
        nextFrame(() => {
          if (!el._isLeaving) {
            return;
          }
          removeTransitionClass(el, leaveFromClass);
          addTransitionClass(el, leaveToClass);
          if (!hasExplicitCallback(onLeave)) {
            whenTransitionEnds(el, type, leaveDuration, resolve2);
          }
        });
        callHook(onLeave, [el, resolve2]);
      },
      onEnterCancelled(el) {
        finishEnter(el, false, void 0, true);
        callHook(onEnterCancelled, [el]);
      },
      onAppearCancelled(el) {
        finishEnter(el, true, void 0, true);
        callHook(onAppearCancelled, [el]);
      },
      onLeaveCancelled(el) {
        finishLeave(el);
        callHook(onLeaveCancelled, [el]);
      }
    });
  }
  function normalizeDuration(duration) {
    if (duration == null) {
      return null;
    } else if (isObject$1(duration)) {
      return [NumberOf(duration.enter), NumberOf(duration.leave)];
    } else {
      const n = NumberOf(duration);
      return [n, n];
    }
  }
  function NumberOf(val) {
    const res = toNumber(val);
    return res;
  }
  function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
  }
  function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
      _vtc.delete(cls);
      if (!_vtc.size) {
        el[vtcKey] = void 0;
      }
    }
  }
  function nextFrame(cb) {
    requestAnimationFrame(() => {
      requestAnimationFrame(cb);
    });
  }
  let endId = 0;
  function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = () => {
      if (id === el._endId) {
        resolve2();
      }
    };
    if (explicitTimeout != null) {
      return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) {
      return resolve2();
    }
    const endEvent = type + "end";
    let ended = 0;
    const end = () => {
      el.removeEventListener(endEvent, onEnd);
      resolveIfNotStale();
    };
    const onEnd = (e) => {
      if (e.target === el && ++ended >= propCount) {
        end();
      }
    };
    setTimeout(() => {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
  }
  function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key) => (styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(?:transform|all)(?:,|$)/.test(
      getStyleProperties(`${TRANSITION}Property`).toString()
    );
    return {
      type,
      timeout,
      propCount,
      hasTransform
    };
  }
  function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }
    return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
  }
  function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
  }
  function forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
  }
  function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) {
      value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
    }
    if (value == null) {
      el.removeAttribute("class");
    } else if (isSVG) {
      el.setAttribute("class", value);
    } else {
      el.className = value;
    }
  }
  const vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
  const vShowHidden = /* @__PURE__ */ Symbol("_vsh");
  const vShow = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount(el, { value }, { transition }) {
      el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
      if (transition && value) {
        transition.beforeEnter(el);
      } else {
        setDisplay(el, value);
      }
    },
    mounted(el, { value }, { transition }) {
      if (transition && value) {
        transition.enter(el);
      }
    },
    updated(el, { value, oldValue }, { transition }) {
      if (!value === !oldValue) return;
      if (transition) {
        if (value) {
          transition.beforeEnter(el);
          setDisplay(el, true);
          transition.enter(el);
        } else {
          transition.leave(el, () => {
            setDisplay(el, false);
          });
        }
      } else {
        setDisplay(el, value);
      }
    },
    beforeUnmount(el, { value }) {
      setDisplay(el, value);
    }
  };
  function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
  }
  const CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
  const displayRE = /(?:^|;)\s*display\s*:/;
  function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = isString$1(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
      if (prev) {
        if (!isString$1(prev)) {
          for (const key in prev) {
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        } else {
          for (const prevStyle of prev.split(";")) {
            const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        }
      }
      for (const key in next) {
        if (key === "display") {
          hasControlledDisplay = true;
        }
        const value = next[key];
        if (value != null) {
          if (!shouldPreserveTextareaResizeStyle(
            el,
            key,
            !isString$1(prev) && prev ? prev[key] : void 0,
            value
          )) {
            setStyle(style, key, value);
          }
        } else {
          setStyle(style, key, "");
        }
      }
    } else {
      if (isCssString) {
        if (prev !== next) {
          const cssVarText = style[CSS_VAR_TEXT];
          if (cssVarText) {
            next += ";" + cssVarText;
          }
          style.cssText = next;
          hasControlledDisplay = displayRE.test(next);
        }
      } else if (prev) {
        el.removeAttribute("style");
      }
    }
    if (vShowOriginalDisplay in el) {
      el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
      if (el[vShowHidden]) {
        style.display = "none";
      }
    }
  }
  const importantRE = /\s*!important$/;
  function setStyle(style, name, val) {
    if (isArray$1(val)) {
      val.forEach((v) => setStyle(style, name, v));
    } else {
      if (val == null) val = "";
      if (name.startsWith("--")) {
        if (importantRE.test(val)) {
          style.setProperty(name, val.replace(importantRE, ""), "important");
        } else {
          style.setProperty(name, val);
        }
      } else {
        const prefixed = autoPrefix(style, name);
        if (importantRE.test(val)) {
          style.setProperty(
            hyphenate(prefixed),
            val.replace(importantRE, ""),
            "important"
          );
        } else {
          style[prefixed] = val;
        }
      }
    }
  }
  const prefixes = ["Webkit", "Moz", "ms"];
  const prefixCache = {};
  function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) {
      return cached;
    }
    let name = camelize(rawName);
    if (name !== "filter" && name in style) {
      return prefixCache[rawName] = name;
    }
    name = capitalize(name);
    for (let i = 0; i < prefixes.length; i++) {
      const prefixed = prefixes[i] + name;
      if (prefixed in style) {
        return prefixCache[rawName] = prefixed;
      }
    }
    return rawName;
  }
  function shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && isString$1(next) && prev === next;
  }
  const xlinkNS = "http://www.w3.org/1999/xlink";
  function patchAttr(el, key, value, isSVG, instance, isBoolean2 = isSpecialBooleanAttr(key)) {
    if (isSVG && key.startsWith("xlink:")) {
      if (value == null) {
        el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
        el.removeAttribute(key);
      } else {
        el.setAttribute(
          key,
          isBoolean2 ? "" : isSymbol(value) ? String(value) : value
        );
      }
    }
  }
  function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
      if (value != null) {
        el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
      }
      return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
      const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
      const newValue = value == null ? (
        // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : ""
      ) : String(value);
      if (oldValue !== newValue || !("_value" in el)) {
        el.value = newValue;
      }
      if (value == null) {
        el.removeAttribute(key);
      }
      el._value = value;
      return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
      const type = typeof el[key];
      if (type === "boolean") {
        value = includeBooleanAttr(value);
      } else if (value == null && type === "string") {
        value = "";
        needRemove = true;
      } else if (type === "number") {
        value = 0;
        needRemove = true;
      }
    }
    try {
      el[key] = value;
    } catch (e) {
    }
    needRemove && el.removeAttribute(attrName || key);
  }
  function addEventListener(el, event2, handler, options) {
    el.addEventListener(event2, handler, options);
  }
  function removeEventListener(el, event2, handler, options) {
    el.removeEventListener(event2, handler, options);
  }
  const veiKey = /* @__PURE__ */ Symbol("_vei");
  function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
      existingInvoker.value = nextValue;
    } else {
      const [name, options] = parseName(rawName);
      if (nextValue) {
        const invoker = invokers[rawName] = createInvoker(
          nextValue,
          instance
        );
        addEventListener(el, name, invoker, options);
      } else if (existingInvoker) {
        removeEventListener(el, name, existingInvoker, options);
        invokers[rawName] = void 0;
      }
    }
  }
  const optionsModifierRE = /(Once|Passive|Capture)$/;
  const optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
  function parseName(name) {
    let options;
    let m;
    while ((m = name.match(optionsModifierRE)) && !optionsModifierEventRE.test(name)) {
      if (!options) options = {};
      name = name.slice(0, name.length - m[1].length);
      options[m[1].toLowerCase()] = true;
    }
    const event2 = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
    return [event2, options];
  }
  let cachedNow = 0;
  const p = /* @__PURE__ */ Promise.resolve();
  const getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
  function createInvoker(initialValue, instance) {
    const invoker = (e) => {
      if (!e._vts) {
        e._vts = Date.now();
      } else if (e._vts <= invoker.attached) {
        return;
      }
      const value = invoker.value;
      if (isArray$1(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = () => {
          originalStop.call(e);
          e._stopped = true;
        };
        const handlers = value.slice();
        const args = [e];
        for (let i = 0; i < handlers.length; i++) {
          if (e._stopped) {
            break;
          }
          const handler = handlers[i];
          if (handler) {
            callWithAsyncErrorHandling(
              handler,
              instance,
              5,
              args
            );
          }
        }
      } else {
        callWithAsyncErrorHandling(
          value,
          instance,
          5,
          [e]
        );
      }
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
  }
  const isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
  key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
  const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
    const isSVG = namespace === "svg";
    if (key === "class") {
      patchClass(el, nextValue, isSVG);
    } else if (key === "style") {
      patchStyle(el, prevValue, nextValue);
    } else if (isOn(key)) {
      if (!isModelListener(key)) {
        patchEvent(el, key, prevValue, nextValue, parentComponent);
      }
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
      patchDOMProp(el, key, nextValue);
      if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) {
        patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
      }
    } else if (
      // #11081 force set props for possible async custom element
      el._isVueCE && // #12408 check if it's declared prop or it's async custom element
      (shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
      el._def.__asyncLoader && (/[A-Z]/.test(key) || !isString$1(nextValue)))
    ) {
      patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
    } else {
      if (key === "true-value") {
        el._trueValue = nextValue;
      } else if (key === "false-value") {
        el._falseValue = nextValue;
      }
      patchAttr(el, key, nextValue, isSVG);
    }
  };
  function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
      if (key === "innerHTML" || key === "textContent") {
        return true;
      }
      if (key in el && isNativeOn(key) && isFunction$2(value)) {
        return true;
      }
      return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") {
      return false;
    }
    if (key === "sandbox" && el.tagName === "IFRAME") {
      return false;
    }
    if (key === "form") {
      return false;
    }
    if (key === "list" && el.tagName === "INPUT") {
      return false;
    }
    if (key === "type" && el.tagName === "TEXTAREA") {
      return false;
    }
    if (key === "width" || key === "height") {
      const tag = el.tagName;
      if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
        return false;
      }
    }
    if (isNativeOn(key) && isString$1(value)) {
      return false;
    }
    return key in el;
  }
  function shouldSetAsPropForVueCE(el, key) {
    const props = (
      // @ts-expect-error _def is private
      el._def.props
    );
    if (!props) {
      return false;
    }
    const camelKey = camelize(key);
    return Array.isArray(props) ? props.some((prop) => camelize(prop) === camelKey) : Object.keys(props).some((prop) => camelize(prop) === camelKey);
  }
  const getModelAssigner = (vnode) => {
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return isArray$1(fn) ? (value) => invokeArrayFns(fn, value) : fn;
  };
  function onCompositionStart(e) {
    e.target.composing = true;
  }
  function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
      target.composing = false;
      target.dispatchEvent(new Event("input"));
    }
  }
  const assignKey = /* @__PURE__ */ Symbol("_assign");
  const initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
  function castValue(value, trim2, number) {
    if (trim2) value = value.trim();
    if (number) value = looseToNumber(value);
    return value;
  }
  const vModelText = {
    created(el, { modifiers: { lazy, trim: trim2, number } }, vnode) {
      if (el.parentNode) {
        if (el.type === "text") {
          el[initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
        } else if (el.type === "textarea") {
          el[initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
      }
      el[assignKey] = getModelAssigner(vnode);
      const castToNumber = number || vnode.props && vnode.props.type === "number";
      addEventListener(el, lazy ? "change" : "input", (e) => {
        if (e.target.composing) return;
        el[assignKey](castValue(el.value, trim2, castToNumber));
      });
      if (trim2 || castToNumber) {
        addEventListener(el, "change", () => {
          el.value = castValue(el.value, trim2, castToNumber);
        });
      }
      if (!lazy) {
        addEventListener(el, "compositionstart", onCompositionStart);
        addEventListener(el, "compositionend", onCompositionEnd);
        addEventListener(el, "change", onCompositionEnd);
      }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted(el, { value, modifiers: { trim: trim2, number } }) {
      const newValue = value == null ? "" : value;
      const initialValue = el[initialValueKey];
      delete el[initialValueKey];
      if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) {
        el[assignKey](castValue(el.value, trim2, number));
      } else {
        el.value = newValue;
      }
    },
    beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim: trim2, number } }, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      if (el.composing) return;
      const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
      const newValue = value == null ? "" : value;
      if (elValue === newValue) {
        return;
      }
      const rootNode = el.getRootNode();
      if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
        if (lazy && value === oldValue) {
          return;
        }
        if (trim2 && el.value.trim() === newValue) {
          return;
        }
      }
      el.value = newValue;
    }
  };
  const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created(el, { value, modifiers: { number } }, vnode) {
      el._modelValue = value;
      addEventListener(el, "change", () => {
        const selectedVal = Array.prototype.filter.call(el.options, (o) => o.selected).map(
          (o) => number ? looseToNumber(getValue(o)) : getValue(o)
        );
        const multiple = el.multiple;
        const assignedValue = multiple ? isSet$1(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
        const pending2 = el._pendingValue = [
          multiple,
          multiple ? isArray$1(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
        ];
        try {
          el[assignKey](assignedValue);
        } finally {
          nextTick(() => {
            if (el._pendingValue === pending2) {
              el._pendingValue = void 0;
            }
          });
        }
      });
      el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted(el, { value }) {
      setSelected(el, value);
    },
    beforeUpdate(el, { value }, vnode) {
      el._modelValue = value;
      el[assignKey] = getModelAssigner(vnode);
    },
    updated(el, { value }) {
      const pending2 = el._pendingValue;
      el._pendingValue = void 0;
      if (!pending2 || pending2[0] !== el.multiple || !isSameSelectValue(value, pending2[1], pending2[0])) {
        setSelected(el, value);
      }
    }
  };
  function isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return looseEqual(value, assignedValue);
    if (isArray$1(value)) return looseEqual(value, assignedValue);
    if (isSet$1(value)) {
      if (value.size !== assignedValue.length) return false;
      for (const item of assignedValue) {
        if (!value.has(item)) return false;
      }
      return true;
    }
    return false;
  }
  function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = isArray$1(value);
    if (isMultiple && !isArrayValue && !isSet$1(value)) {
      return;
    }
    for (let i = 0, l = el.options.length; i < l; i++) {
      const option = el.options[i];
      const optionValue = getValue(option);
      if (isMultiple) {
        if (isArrayValue) {
          const optionType = typeof optionValue;
          if (optionType === "string" || optionType === "number") {
            option.selected = value.some((v) => String(v) === String(optionValue));
          } else {
            option.selected = looseIndexOf(value, optionValue) > -1;
          }
        } else {
          option.selected = value.has(optionValue);
        }
      } else if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) el.selectedIndex = i;
        return;
      }
    }
    if (!isMultiple && el.selectedIndex !== -1) {
      el.selectedIndex = -1;
    }
  }
  function getValue(el) {
    return "_value" in el ? el._value : el.value;
  }
  const systemModifiers = ["ctrl", "shift", "alt", "meta"];
  const modifierGuards = {
    stop: (e) => e.stopPropagation(),
    prevent: (e) => e.preventDefault(),
    self: (e) => e.target !== e.currentTarget,
    ctrl: (e) => !e.ctrlKey,
    shift: (e) => !e.shiftKey,
    alt: (e) => !e.altKey,
    meta: (e) => !e.metaKey,
    left: (e) => "button" in e && e.button !== 0,
    middle: (e) => "button" in e && e.button !== 1,
    right: (e) => "button" in e && e.button !== 2,
    exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
  };
  const withModifiers = (fn, modifiers) => {
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = ((event2, ...args) => {
      for (let i = 0; i < modifiers.length; i++) {
        const guard = modifierGuards[modifiers[i]];
        if (guard && guard(event2, modifiers)) return;
      }
      return fn(event2, ...args);
    }));
  };
  const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
  };
  const withKeys = (fn, modifiers) => {
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = ((event2) => {
      if (!("key" in event2)) {
        return;
      }
      const eventKey = hyphenate(event2.key);
      if (modifiers.some(
        (k) => k === eventKey || keyNames[k] === eventKey
      )) {
        return fn(event2);
      }
    }));
  };
  const rendererOptions = /* @__PURE__ */ extend$1({ patchProp }, nodeOps);
  let renderer;
  function ensureRenderer() {
    return renderer || (renderer = createRenderer(rendererOptions));
  }
  const createApp = ((...args) => {
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector) => {
      const container = normalizeContainer(containerOrSelector);
      if (!container) return;
      const component = app._component;
      if (!isFunction$2(component) && !component.render && !component.template) {
        component.template = container.innerHTML;
      }
      if (container.nodeType === 1) {
        container.textContent = "";
      }
      const proxy = mount(container, false, resolveRootNamespace(container));
      if (container instanceof Element) {
        container.removeAttribute("v-cloak");
        container.setAttribute("data-v-app", "");
      }
      return proxy;
    };
    return app;
  });
  function resolveRootNamespace(container) {
    if (container instanceof SVGElement) {
      return "svg";
    }
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
      return "mathml";
    }
  }
  function normalizeContainer(container) {
    if (isString$1(container)) {
      const res = document.querySelector(container);
      return res;
    }
    return container;
  }
  /*!
   * pinia v3.0.4
   * (c) 2025 Eduardo San Martin Morote
   * @license MIT
   */
  let activePinia;
  const setActivePinia = (pinia) => activePinia = pinia;
  const piniaSymbol = (
    /* istanbul ignore next */
    Symbol()
  );
  function isPlainObject$2(o) {
    return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
  }
  var MutationType;
  (function(MutationType2) {
    MutationType2["direct"] = "direct";
    MutationType2["patchObject"] = "patch object";
    MutationType2["patchFunction"] = "patch function";
  })(MutationType || (MutationType = {}));
  function createPinia() {
    const scope = effectScope(true);
    const state = scope.run(() => /* @__PURE__ */ ref({}));
    let _p = [];
    let toBeInstalled = [];
    const pinia = markRaw({
      install(app) {
        setActivePinia(pinia);
        pinia._a = app;
        app.provide(piniaSymbol, pinia);
        app.config.globalProperties.$pinia = pinia;
        toBeInstalled.forEach((plugin) => _p.push(plugin));
        toBeInstalled = [];
      },
      use(plugin) {
        if (!this._a) {
          toBeInstalled.push(plugin);
        } else {
          _p.push(plugin);
        }
        return this;
      },
      _p,
      // it's actually undefined here
      // @ts-expect-error
      _a: null,
      _e: scope,
      _s: /* @__PURE__ */ new Map(),
      state
    });
    return pinia;
  }
  const noop$1 = () => {
  };
  function addSubscription(subscriptions, callback, detached, onCleanup = noop$1) {
    subscriptions.add(callback);
    const removeSubscription = () => {
      const isDel = subscriptions.delete(callback);
      isDel && onCleanup();
    };
    if (!detached && getCurrentScope()) {
      onScopeDispose(removeSubscription);
    }
    return removeSubscription;
  }
  function triggerSubscriptions(subscriptions, ...args) {
    subscriptions.forEach((callback) => {
      callback(...args);
    });
  }
  const fallbackRunWithContext = (fn) => fn();
  const ACTION_MARKER = Symbol();
  const ACTION_NAME = Symbol();
  function mergeReactiveObjects(target, patchToApply) {
    if (target instanceof Map && patchToApply instanceof Map) {
      patchToApply.forEach((value, key) => target.set(key, value));
    } else if (target instanceof Set && patchToApply instanceof Set) {
      patchToApply.forEach(target.add, target);
    }
    for (const key in patchToApply) {
      if (!patchToApply.hasOwnProperty(key))
        continue;
      const subPatch = patchToApply[key];
      const targetValue = target[key];
      if (isPlainObject$2(targetValue) && isPlainObject$2(subPatch) && target.hasOwnProperty(key) && !/* @__PURE__ */ isRef(subPatch) && !/* @__PURE__ */ isReactive(subPatch)) {
        target[key] = mergeReactiveObjects(targetValue, subPatch);
      } else {
        target[key] = subPatch;
      }
    }
    return target;
  }
  const skipHydrateSymbol = (
    /* istanbul ignore next */
    Symbol()
  );
  function shouldHydrate(obj) {
    return !isPlainObject$2(obj) || !Object.prototype.hasOwnProperty.call(obj, skipHydrateSymbol);
  }
  const { assign } = Object;
  function isComputed(o) {
    return !!(/* @__PURE__ */ isRef(o) && o.effect);
  }
  function createOptionsStore(id, options, pinia, hot) {
    const { state, actions, getters } = options;
    const initialState = pinia.state.value[id];
    let store2;
    function setup() {
      if (!initialState && true) {
        pinia.state.value[id] = state ? state() : {};
      }
      const localState = /* @__PURE__ */ toRefs(pinia.state.value[id]);
      return assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
        computedGetters[name] = markRaw(computed(() => {
          setActivePinia(pinia);
          const store22 = pinia._s.get(id);
          return getters[name].call(store22, store22);
        }));
        return computedGetters;
      }, {}));
    }
    store2 = createSetupStore(id, setup, options, pinia, hot, true);
    return store2;
  }
  function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = assign({ actions: {} }, options);
    const $subscribeOptions = { deep: true };
    let isListening;
    let isSyncListening;
    let subscriptions = /* @__PURE__ */ new Set();
    let actionSubscriptions = /* @__PURE__ */ new Set();
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    if (!isOptionsStore && !initialState && true) {
      pinia.state.value[$id] = {};
    }
    let activeListener;
    function $patch(partialStateOrMutator) {
      let subscriptionMutation;
      isListening = isSyncListening = false;
      if (typeof partialStateOrMutator === "function") {
        partialStateOrMutator(pinia.state.value[$id]);
        subscriptionMutation = {
          type: MutationType.patchFunction,
          storeId: $id,
          events: debuggerEvents
        };
      } else {
        mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
        subscriptionMutation = {
          type: MutationType.patchObject,
          payload: partialStateOrMutator,
          storeId: $id,
          events: debuggerEvents
        };
      }
      const myListenerId = activeListener = Symbol();
      nextTick().then(() => {
        if (activeListener === myListenerId) {
          isListening = true;
        }
      });
      isSyncListening = true;
      triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset2() {
      const { state } = options;
      const newState = state ? state() : {};
      this.$patch(($state) => {
        assign($state, newState);
      });
    } : (
      /* istanbul ignore next */
      noop$1
    );
    function $dispose() {
      scope.stop();
      subscriptions.clear();
      actionSubscriptions.clear();
      pinia._s.delete($id);
    }
    const action = (fn, name = "") => {
      if (ACTION_MARKER in fn) {
        fn[ACTION_NAME] = name;
        return fn;
      }
      const wrappedAction = function() {
        setActivePinia(pinia);
        const args = Array.from(arguments);
        const afterCallbackSet = /* @__PURE__ */ new Set();
        const onErrorCallbackSet = /* @__PURE__ */ new Set();
        function after(callback) {
          afterCallbackSet.add(callback);
        }
        function onError(callback) {
          onErrorCallbackSet.add(callback);
        }
        triggerSubscriptions(actionSubscriptions, {
          args,
          name: wrappedAction[ACTION_NAME],
          store: store2,
          after,
          onError
        });
        let ret;
        try {
          ret = fn.apply(this && this.$id === $id ? this : store2, args);
        } catch (error) {
          triggerSubscriptions(onErrorCallbackSet, error);
          throw error;
        }
        if (ret instanceof Promise) {
          return ret.then((value) => {
            triggerSubscriptions(afterCallbackSet, value);
            return value;
          }).catch((error) => {
            triggerSubscriptions(onErrorCallbackSet, error);
            return Promise.reject(error);
          });
        }
        triggerSubscriptions(afterCallbackSet, ret);
        return ret;
      };
      wrappedAction[ACTION_MARKER] = true;
      wrappedAction[ACTION_NAME] = name;
      return wrappedAction;
    };
    const partialStore = {
      _p: pinia,
      // _s: scope,
      $id,
      $onAction: addSubscription.bind(null, actionSubscriptions),
      $patch,
      $reset,
      $subscribe(callback, options2 = {}) {
        const removeSubscription = addSubscription(subscriptions, callback, options2.detached, () => stopWatcher());
        const stopWatcher = scope.run(() => watch(() => pinia.state.value[$id], (state) => {
          if (options2.flush === "sync" ? isSyncListening : isListening) {
            callback({
              storeId: $id,
              type: MutationType.direct,
              events: debuggerEvents
            }, state);
          }
        }, assign({}, $subscribeOptions, options2)));
        return removeSubscription;
      },
      $dispose
    };
    const store2 = /* @__PURE__ */ reactive(partialStore);
    pinia._s.set($id, store2);
    const runWithContext = pinia._a && pinia._a.runWithContext || fallbackRunWithContext;
    const setupStore = runWithContext(() => pinia._e.run(() => (scope = effectScope()).run(() => setup({ action }))));
    for (const key in setupStore) {
      const prop = setupStore[key];
      if (/* @__PURE__ */ isRef(prop) && !isComputed(prop) || /* @__PURE__ */ isReactive(prop)) {
        if (!isOptionsStore) {
          if (initialState && shouldHydrate(prop)) {
            if (/* @__PURE__ */ isRef(prop)) {
              prop.value = initialState[key];
            } else {
              mergeReactiveObjects(prop, initialState[key]);
            }
          }
          pinia.state.value[$id][key] = prop;
        }
      } else if (typeof prop === "function") {
        const actionValue = action(prop, key);
        setupStore[key] = actionValue;
        optionsForPlugin.actions[key] = prop;
      } else ;
    }
    assign(store2, setupStore);
    assign(/* @__PURE__ */ toRaw(store2), setupStore);
    Object.defineProperty(store2, "$state", {
      get: () => pinia.state.value[$id],
      set: (state) => {
        $patch(($state) => {
          assign($state, state);
        });
      }
    });
    pinia._p.forEach((extender) => {
      {
        assign(store2, scope.run(() => extender({
          store: store2,
          app: pinia._a,
          pinia,
          options: optionsForPlugin
        })));
      }
    });
    if (initialState && isOptionsStore && options.hydrate) {
      options.hydrate(store2.$state, initialState);
    }
    isListening = true;
    isSyncListening = true;
    return store2;
  }
  /*! #__NO_SIDE_EFFECTS__ */
  // @__NO_SIDE_EFFECTS__
  function defineStore(id, setup, setupOptions) {
    let options;
    const isSetupStore = typeof setup === "function";
    options = isSetupStore ? setupOptions : setup;
    function useStore(pinia, hot) {
      const hasContext = hasInjectionContext();
      pinia = // in test mode, ignore the argument provided as we can always retrieve a
      // pinia instance with getActivePinia()
      pinia || (hasContext ? inject(piniaSymbol, null) : null);
      if (pinia)
        setActivePinia(pinia);
      pinia = activePinia;
      if (!pinia._s.has(id)) {
        if (isSetupStore) {
          createSetupStore(id, setup, options, pinia);
        } else {
          createOptionsStore(id, options, pinia);
        }
      }
      const store2 = pinia._s.get(id);
      return store2;
    }
    useStore.$id = id;
    return useStore;
  }
  function bind(fn, thisArg) {
    return function wrap() {
      return fn.apply(thisArg, arguments);
    };
  }
  const { toString } = Object.prototype;
  const { getPrototypeOf } = Object;
  const { iterator, toStringTag } = Symbol;
  const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
  const isUnsafeObjectKey = (prop) => typeof prop === "string" && (prop === "__proto__" || prop === "constructor" || prop === "prototype");
  const isPrototypeBoundary = (obj, prototype2, source) => obj === Object.prototype || !source && prototype2 === null;
  const isSafeAndFullyMutable = (obj) => {
    if (!Object.isExtensible(obj)) {
      return false;
    }
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) {
      props.push(...Object.getOwnPropertySymbols(obj));
    }
    return props.every((prop) => {
      if (isUnsafeObjectKey(prop)) {
        return false;
      }
      const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
      return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
  };
  const hasOwnInPrototypeChain = (thing, prop) => {
    let obj = thing;
    const seen = [];
    while (obj != null) {
      if (seen.indexOf(obj) !== -1) {
        return false;
      }
      seen.push(obj);
      const prototype2 = getPrototypeOf(obj);
      if (isPrototypeBoundary(obj, prototype2, obj === thing)) {
        return false;
      }
      if (hasOwnProperty(obj, prop)) {
        return true;
      }
      obj = prototype2;
    }
    return false;
  };
  const getSafeProp = (obj, prop) => obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : void 0;
  const toSafeFlatObject = (thing) => {
    if (thing == null || typeof thing !== "object" && typeof thing !== "function") {
      return thing;
    }
    const sourcePrototype = getPrototypeOf(thing);
    if (sourcePrototype === null && isSafeAndFullyMutable(thing)) {
      return thing;
    }
    const result = /* @__PURE__ */ Object.create(null);
    const merged = /* @__PURE__ */ Object.create(null);
    const seen = [];
    let current = thing;
    while (current != null) {
      if (seen.indexOf(current) !== -1) {
        break;
      }
      seen.push(current);
      const prototype2 = current === thing ? sourcePrototype : getPrototypeOf(current);
      if (isPrototypeBoundary(current, prototype2, current === thing)) {
        break;
      }
      const props = Object.getOwnPropertyNames(current);
      if (Object.getOwnPropertySymbols) {
        props.push(...Object.getOwnPropertySymbols(current));
      }
      for (const prop of props) {
        if (isUnsafeObjectKey(prop)) {
          continue;
        }
        if (!hasOwnProperty(merged, prop)) {
          result[prop] = thing[prop];
          merged[prop] = true;
        }
      }
      current = prototype2;
    }
    return result;
  };
  const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null));
  const kindOfTest = (type) => {
    type = type.toLowerCase();
    return (thing) => kindOf(thing) === type;
  };
  const typeOfTest = (type) => (thing) => typeof thing === type;
  const { isArray } = Array;
  const isUndefined = typeOfTest("undefined");
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction$1(val.constructor.isBuffer) && val.constructor.isBuffer(val);
  }
  const isArrayBuffer = kindOfTest("ArrayBuffer");
  function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer(val.buffer);
    }
    return result;
  }
  const isString = typeOfTest("string");
  const isFunction$1 = typeOfTest("function");
  const isNumber = typeOfTest("number");
  const isObject = (thing) => thing !== null && typeof thing === "object";
  const isBoolean = (thing) => thing === true || thing === false;
  const isPlainObject$1 = (val) => {
    if (!isObject(val)) {
      return false;
    }
    const prototype2 = getPrototypeOf(val);
    return (prototype2 === null || prototype2 === Object.prototype || getPrototypeOf(prototype2) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !hasOwnInPrototypeChain(val, toStringTag) && !hasOwnInPrototypeChain(val, iterator);
  };
  const isEmptyObject = (val) => {
    if (!isObject(val) || isBuffer(val)) {
      return false;
    }
    try {
      return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
      return false;
    }
  };
  const isDate = kindOfTest("Date");
  const isFile = kindOfTest("File");
  const isReactNativeBlob = (value) => {
    return !!(value && typeof value.uri !== "undefined");
  };
  const isReactNative = (formData) => formData && typeof formData.getParts !== "undefined";
  const isBlob = kindOfTest("Blob");
  const isFileList = kindOfTest("FileList");
  const isSet = kindOfTest("Set");
  const isStream = (val) => isObject(val) && isFunction$1(val.pipe);
  function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof window !== "undefined") return window;
    return {};
  }
  const G = getGlobal();
  const FormDataCtor = typeof G.FormData !== "undefined" ? G.FormData : void 0;
  const isFormData = (thing) => {
    if (!thing) return false;
    if (FormDataCtor && thing instanceof FormDataCtor) return true;
    const proto = getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!isFunction$1(thing.append)) return false;
    const kind = kindOf(thing);
    return kind === "formdata" || // detect form-data instance
    kind === "object" && isFunction$1(thing.toString) && thing.toString() === "[object FormData]";
  };
  const isURLSearchParams = kindOfTest("URLSearchParams");
  const [isReadableStream, isRequest, isResponse, isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
  ].map(kindOfTest);
  const trim = (str) => {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  };
  function forEach(obj, fn, { allOwnKeys = false } = {}) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    let i;
    let l;
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray(obj)) {
      for (i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      if (isBuffer(obj)) {
        return;
      }
      const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
      const len = keys.length;
      let key;
      for (i = 0; i < len; i++) {
        key = keys[i];
        fn.call(null, obj[key], key, obj);
      }
    }
  }
  function findKey(obj, key) {
    if (isBuffer(obj)) {
      return null;
    }
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while (i-- > 0) {
      _key = keys[i];
      if (key === _key.toLowerCase()) {
        return _key;
      }
    }
    return null;
  }
  const _global = (() => {
    if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : window;
  })();
  const isContextDefined = (context) => !isUndefined(context) && context !== _global;
  function merge(...objs) {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key) => {
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return;
      }
      const targetKey = caseless && typeof key === "string" && findKey(result, key) || key;
      const existing = hasOwnProperty(result, targetKey) ? result[targetKey] : void 0;
      if (isPlainObject$1(existing) && isPlainObject$1(val)) {
        result[targetKey] = merge(existing, val);
      } else if (isPlainObject$1(val)) {
        result[targetKey] = merge({}, val);
      } else if (isArray(val)) {
        result[targetKey] = val.slice();
      } else if (!skipUndefined || !isUndefined(val)) {
        result[targetKey] = val;
      }
    };
    for (let i = 0, l = objs.length; i < l; i++) {
      const source = objs[i];
      if (!source || isBuffer(source)) {
        continue;
      }
      forEach(source, assignValue);
      if (typeof source !== "object" || isArray(source)) {
        continue;
      }
      const symbols = Object.getOwnPropertySymbols(source);
      for (let j = 0; j < symbols.length; j++) {
        const symbol = symbols[j];
        if (propertyIsEnumerable.call(source, symbol)) {
          assignValue(source[symbol], symbol);
        }
      }
    }
    return result;
  }
  const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
    forEach(
      b,
      (val, key) => {
        if (thisArg && isFunction$1(val)) {
          Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: bind(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
          });
        } else {
          Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
          });
        }
      },
      { allOwnKeys }
    );
    return a;
  };
  const stripBOM = (content) => {
    if (content.charCodeAt(0) === 65279) {
      content = content.slice(1);
    }
    return content;
  };
  const inherits = (constructor, superConstructor, props, descriptors) => {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
      __proto__: null,
      value: constructor,
      writable: true,
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(constructor, "super", {
      __proto__: null,
      value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
  };
  const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    if (sourceObj == null) return destObj;
    do {
      props = Object.getOwnPropertyNames(sourceObj);
      i = props.length;
      while (i-- > 0) {
        prop = props[i];
        if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
          destObj[prop] = sourceObj[prop];
          merged[prop] = true;
        }
      }
      sourceObj = filter !== false && getPrototypeOf(sourceObj);
    } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
  };
  const endsWith = (str, searchString, position) => {
    str = String(str);
    if (position === void 0 || position > str.length) {
      position = str.length;
    }
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
  const toArray = (thing) => {
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while (i-- > 0) {
      arr[i] = thing[i];
    }
    return arr;
  };
  const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
    return (thing) => {
      return TypedArray && thing instanceof TypedArray;
    };
  })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
  const forEachEntry = (obj, fn) => {
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while ((result = _iterator.next()) && !result.done) {
      const pair = result.value;
      fn.call(obj, pair[0], pair[1]);
    }
  };
  const matchAll = (regExp, str) => {
    let matches;
    const arr = [];
    while ((matches = regExp.exec(str)) !== null) {
      arr.push(matches);
    }
    return arr;
  };
  const isHTMLForm = kindOfTest("HTMLFormElement");
  const toCamelCase = (str) => {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer2(m, p1, p2) {
      return p1.toUpperCase() + p2;
    });
  };
  const { propertyIsEnumerable } = Object.prototype;
  const isRegExp = kindOfTest("RegExp");
  const reduceDescriptors = (obj, reducer) => {
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name) => {
      let ret;
      if ((ret = reducer(descriptor, name, obj)) !== false) {
        reducedDescriptors[name] = ret || descriptor;
      }
    });
    Object.defineProperties(obj, reducedDescriptors);
  };
  const freezeMethods = (obj) => {
    reduceDescriptors(obj, (descriptor, name) => {
      if (isFunction$1(obj) && ["arguments", "caller", "callee"].includes(name)) {
        return false;
      }
      const value = obj[name];
      if (!isFunction$1(value)) return;
      descriptor.enumerable = false;
      if ("writable" in descriptor) {
        descriptor.writable = false;
        return;
      }
      if (!descriptor.set) {
        descriptor.set = () => {
          throw Error("Can not rewrite read-only method '" + name + "'");
        };
      }
    });
  };
  const toObjectSet = (arrayOrString, delimiter) => {
    const obj = {};
    const define = (arr) => {
      arr.forEach((value) => {
        obj[value] = true;
      });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
  };
  const noop = () => {
  };
  const toFiniteNumber = (value, defaultValue) => {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
  };
  function isSpecCompliantForm(thing) {
    return !!(thing && isFunction$1(thing.append) && thing[toStringTag] === "FormData" && thing[iterator]);
  }
  const toJSONObject = (obj) => {
    const visited = /* @__PURE__ */ new WeakSet();
    const visit = (source) => {
      if (isObject(source)) {
        if (visited.has(source)) {
          return;
        }
        if (isBuffer(source)) {
          return source;
        }
        if (!("toJSON" in source)) {
          visited.add(source);
          let target;
          if (isSet(source)) {
            target = [];
            for (const value of source) {
              const reducedValue = visit(value);
              !isUndefined(reducedValue) && target.push(reducedValue);
            }
          } else {
            target = isArray(source) ? [] : {};
            forEach(source, (value, key) => {
              const reducedValue = visit(value);
              !isUndefined(reducedValue) && (target[key] = reducedValue);
            });
          }
          visited.delete(source);
          return target;
        }
      }
      return source;
    };
    return visit(obj);
  };
  const isAsyncFn = kindOfTest("AsyncFunction");
  const isThenable = (thing) => thing && (isObject(thing) || isFunction$1(thing)) && isFunction$1(thing.then) && isFunction$1(thing.catch);
  const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
    if (setImmediateSupported) {
      return setImmediate;
    }
    return postMessageSupported ? ((token, callbacks) => {
      _global.addEventListener(
        "message",
        ({ source, data }) => {
          if (source === _global && data === token) {
            callbacks.length && callbacks.shift()();
          }
        },
        false
      );
      return (cb) => {
        callbacks.push(cb);
        _global.postMessage(token, "*");
      };
    })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
  })(typeof setImmediate === "function", isFunction$1(_global.postMessage));
  const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
  const isIterable = (thing) => thing != null && isFunction$1(thing[iterator]);
  const isSafeIterable = (thing) => thing != null && hasOwnInPrototypeChain(thing, iterator) && isIterable(thing);
  const utils$1 = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject: isPlainObject$1,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isReactNativeBlob,
    isReactNative,
    isBlob,
    isRegExp,
    isFunction: isFunction$1,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    // an alias to avoid ESLint no-prototype-builtins detection
    hasOwnInPrototypeChain,
    getSafeProp,
    toSafeFlatObject,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable,
    isSafeIterable
  };
  const ignoreDuplicateOf = utils$1.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  const parseHeaders = (rawHeaders) => {
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
      i = line.indexOf(":");
      key = line.substring(0, i).trim().toLowerCase();
      val = line.substring(i + 1).trim();
      const hasKey = utils$1.hasOwnProp(parsed, key);
      if (!key || hasKey && utils$1.hasOwnProp(ignoreDuplicateOf, key)) {
        return;
      }
      if (key === "set-cookie") {
        if (hasKey) {
          parsed[key].push(val);
        } else {
          parsed[key] = [val];
        }
      } else {
        parsed[key] = hasKey ? parsed[key] + ", " + val : val;
      }
    });
    return parsed;
  };
  function trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while (start < end) {
      const code = str.charCodeAt(start);
      if (code !== 9 && code !== 32) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      const code = str.charCodeAt(end - 1);
      if (code !== 9 && code !== 32) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
  }
  const INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
  const INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
  function sanitizeValue(value, invalidChars) {
    if (utils$1.isArray(value)) {
      return value.map((item) => sanitizeValue(item, invalidChars));
    }
    return trimSPorHTAB(String(value).replace(invalidChars, ""));
  }
  const sanitizeHeaderValue = (value) => sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
  const sanitizeByteStringHeaderValue = (value) => sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
  function toByteStringHeaderObject(headers) {
    const byteStringHeaders = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(headers.toJSON(), (value, header) => {
      byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
  }
  const $internals$1 = Symbol("internals");
  function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
  }
  function normalizeValue(value) {
    if (value === false || value == null) {
      return value;
    }
    return utils$1.isArray(value) ? value.map(normalizeValue) : sanitizeHeaderValue(String(value));
  }
  function parseTokens(str) {
    const tokens = /* @__PURE__ */ Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while (match = tokensRE.exec(str)) {
      tokens[match[1]] = match[2];
    }
    return tokens;
  }
  const parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
  function trimOWS(value) {
    let start = 0;
    let end = value.length;
    while (start < end) {
      const code = value.charCodeAt(start);
      if (code !== 9 && code !== 32) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      const code = value.charCodeAt(end - 1);
      if (code !== 9 && code !== 32) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
  }
  function decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 34 || value.charCodeAt(last) !== 34) {
      return value;
    }
    let decoded = "";
    for (let i = 1; i < last; i++) {
      const code = value.charCodeAt(i);
      if (code === 34) {
        return value;
      }
      if (code === 92) {
        i += 1;
        if (i >= last) {
          return value;
        }
      }
      decoded += value[i];
    }
    return decoded;
  }
  function parseParameters(value) {
    const parameters = /* @__PURE__ */ Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
      const part = trimOWS(str.slice(start, end));
      const equals = part.indexOf("=");
      if (equals < 1) {
        return;
      }
      const name = trimOWS(part.slice(0, equals));
      if (!parameterNameRE.test(name)) {
        return;
      }
      const normalizedName = name.toLowerCase();
      if (normalizedName === "__proto__" || normalizedName === "constructor" || normalizedName === "prototype") {
        return;
      }
      const parameterValue = trimOWS(part.slice(equals + 1));
      parameters[normalizedName] = decodeQuotedString(parameterValue);
    }
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (quoted) {
        if (escaped) {
          escaped = false;
        } else if (code === 92) {
          escaped = true;
        } else if (code === 34) {
          quoted = false;
        }
      } else if (code === 34) {
        quoted = true;
      } else if (code === 44 || code === 59) {
        parseParameter(i);
        start = i + 1;
      }
    }
    parseParameter(str.length);
    return parameters;
  }
  const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
  function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if (utils$1.isFunction(filter)) {
      return filter.call(this, value, header);
    }
    if (isHeaderNameFilter) {
      value = header;
    }
    if (!utils$1.isString(value)) return;
    if (utils$1.isString(filter)) {
      return value.indexOf(filter) !== -1;
    }
    if (utils$1.isRegExp(filter)) {
      return filter.test(value);
    }
  }
  function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
  }
  function buildAccessors(obj, header) {
    const accessorName = utils$1.toCamelCase(" " + header);
    ["get", "set", "has"].forEach((methodName) => {
      Object.defineProperty(obj, methodName + accessorName, {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: function(arg1, arg2, arg3) {
          return this[methodName].call(this, header, arg1, arg2, arg3);
        },
        configurable: true
      });
    });
  }
  let AxiosHeaders$1 = class AxiosHeaders {
    constructor(headers) {
      headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
      const self2 = this;
      function setHeader(_value, _header, _rewrite) {
        const lHeader = normalizeHeader(_header);
        if (!lHeader) {
          return;
        }
        const key = utils$1.findKey(self2, lHeader);
        if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
          self2[key || _header] = normalizeValue(_value);
        }
      }
      const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
      if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
        setHeaders(header, valueOrRewrite);
      } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
        setHeaders(parseHeaders(header), valueOrRewrite);
      } else if (utils$1.isObject(header) && utils$1.isSafeIterable(header)) {
        let obj = /* @__PURE__ */ Object.create(null), dest, key;
        for (const entry of header) {
          if (!utils$1.isArray(entry)) {
            throw new TypeError("Object iterator must return a key-value pair");
          }
          key = entry[0];
          if (utils$1.hasOwnProp(obj, key)) {
            dest = obj[key];
            obj[key] = utils$1.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]];
          } else {
            obj[key] = entry[1];
          }
        }
        setHeaders(obj, valueOrRewrite);
      } else {
        header != null && setHeader(valueOrRewrite, header, rewrite);
      }
      return this;
    }
    get(header, parser) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils$1.findKey(this, header);
        if (key) {
          const value = this[key];
          if (!parser) {
            return value;
          }
          if (parser === true) {
            return parseTokens(value);
          }
          if (utils$1.isFunction(parser)) {
            return parser.call(this, value, key);
          }
          if (utils$1.isRegExp(parser)) {
            return parser.exec(value);
          }
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(header, matcher) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils$1.findKey(this, header);
        return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
      }
      return false;
    }
    delete(header, matcher) {
      const self2 = this;
      let deleted = false;
      function deleteHeader(_header) {
        _header = normalizeHeader(_header);
        if (_header) {
          const key = utils$1.findKey(self2, _header);
          if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
            delete self2[key];
            deleted = true;
          }
        }
      }
      if (utils$1.isArray(header)) {
        header.forEach(deleteHeader);
      } else {
        deleteHeader(header);
      }
      return deleted;
    }
    clear(matcher) {
      const keys = Object.keys(this);
      let i = keys.length;
      let deleted = false;
      while (i--) {
        const key = keys[i];
        if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
          delete this[key];
          deleted = true;
        }
      }
      return deleted;
    }
    normalize(format) {
      const self2 = this;
      const headers = {};
      utils$1.forEach(this, (value, header) => {
        const key = utils$1.findKey(headers, header);
        if (key) {
          self2[key] = normalizeValue(value);
          delete self2[header];
          return;
        }
        const normalized = format ? formatHeader(header) : String(header).trim();
        if (normalized !== header) {
          delete self2[header];
        }
        self2[normalized] = normalizeValue(value);
        headers[normalized] = true;
      });
      return this;
    }
    concat(...targets) {
      return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
      const obj = /* @__PURE__ */ Object.create(null);
      utils$1.forEach(this, (value, header) => {
        value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
      });
      return obj;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
    }
    getSetCookie() {
      const value = this.get("set-cookie");
      return utils$1.isArray(value) ? value : value == null || value === false ? [] : [value];
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(thing) {
      return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
      return parseParameters(value);
    }
    static concat(first, ...targets) {
      const computed2 = new this(first);
      targets.forEach((target) => computed2.set(target));
      return computed2;
    }
    static accessor(header) {
      const internals = this[$internals$1] = this[$internals$1] = {
        accessors: {}
      };
      const accessors = internals.accessors;
      const prototype2 = this.prototype;
      function defineAccessor(_header) {
        const lHeader = normalizeHeader(_header);
        if (!accessors[lHeader]) {
          buildAccessors(prototype2, _header);
          accessors[lHeader] = true;
        }
      }
      utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
      return this;
    }
  };
  AxiosHeaders$1.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
  ]);
  utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value }, key) => {
    let mapped = key[0].toUpperCase() + key.slice(1);
    return {
      get: () => value,
      set(headerValue) {
        this[mapped] = headerValue;
      }
    };
  });
  utils$1.freezeMethods(AxiosHeaders$1);
  const REDACTED = "[REDACTED ****]";
  function hasOwnOrPrototypeToJSON(source) {
    if (utils$1.hasOwnProp(source, "toJSON")) {
      return true;
    }
    let prototype2 = Object.getPrototypeOf(source);
    while (prototype2 && prototype2 !== Object.prototype) {
      if (utils$1.hasOwnProp(prototype2, "toJSON")) {
        return true;
      }
      prototype2 = Object.getPrototypeOf(prototype2);
    }
    return false;
  }
  function redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k) => String(k).toLowerCase()));
    const seen = [];
    const visit = (source) => {
      if (source === null || typeof source !== "object") return source;
      if (utils$1.isBuffer(source)) return source;
      if (seen.indexOf(source) !== -1) return void 0;
      if (source instanceof AxiosHeaders$1) {
        source = source.toJSON();
      }
      seen.push(source);
      let result;
      if (utils$1.isArray(source)) {
        result = [];
        source.forEach((v, i) => {
          const reducedValue = visit(v);
          if (!utils$1.isUndefined(reducedValue)) {
            result[i] = reducedValue;
          }
        });
      } else {
        if (!utils$1.isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
          seen.pop();
          return source;
        }
        result = /* @__PURE__ */ Object.create(null);
        for (const [key, value] of Object.entries(source)) {
          const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
          if (!utils$1.isUndefined(reducedValue)) {
            result[key] = reducedValue;
          }
        }
      }
      seen.pop();
      return result;
    };
    return visit(config);
  }
  function stringifySafely$1(value) {
    try {
      return String(value);
    } catch (err) {
      return "";
    }
  }
  function aggregateErrorMessage(error) {
    const message2 = error.errors.map((entry) => {
      try {
        return entry && entry.message ? stringifySafely$1(entry.message) : stringifySafely$1(entry);
      } catch (err) {
        return "";
      }
    }).filter(Boolean).join("; ");
    return message2 || error.name || "AggregateError";
  }
  let AxiosError$1 = class AxiosError2 extends Error {
    static from(error, code, config, request, response, customProps) {
      let message2 = error.message;
      if (!message2 && utils$1.isArray(error.errors) && error.errors.length) {
        message2 = aggregateErrorMessage(error);
      }
      const axiosError = new AxiosError2(message2, code || error.code, config, request, response);
      Object.defineProperty(axiosError, "cause", {
        __proto__: null,
        value: error,
        writable: true,
        enumerable: false,
        configurable: true
      });
      axiosError.name = error.name;
      if (error.status != null && axiosError.status == null) {
        axiosError.status = error.status;
      }
      customProps && Object.assign(axiosError, customProps);
      return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */
    constructor(message2, code, config, request, response) {
      super(message2);
      Object.defineProperty(this, "message", {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: message2,
        enumerable: true,
        writable: true,
        configurable: true
      });
      this.name = "AxiosError";
      this.isAxiosError = true;
      code && (this.code = code);
      config && (this.config = config);
      request && (this.request = request);
      if (response) {
        this.response = response;
        this.status = response.status;
      }
    }
    toJSON() {
      const config = this.config;
      const redactKeys = config && utils$1.hasOwnProp(config, "redact") ? config.redact : void 0;
      const serializedConfig = utils$1.isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : utils$1.toJSONObject(config);
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: serializedConfig,
        code: this.code,
        status: this.status
      };
    }
  };
  AxiosError$1.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
  AxiosError$1.ERR_BAD_OPTION = "ERR_BAD_OPTION";
  AxiosError$1.ECONNABORTED = "ECONNABORTED";
  AxiosError$1.ETIMEDOUT = "ETIMEDOUT";
  AxiosError$1.ECONNREFUSED = "ECONNREFUSED";
  AxiosError$1.ERR_NETWORK = "ERR_NETWORK";
  AxiosError$1.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
  AxiosError$1.ERR_DEPRECATED = "ERR_DEPRECATED";
  AxiosError$1.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
  AxiosError$1.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
  AxiosError$1.ERR_CANCELED = "ERR_CANCELED";
  AxiosError$1.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
  AxiosError$1.ERR_INVALID_URL = "ERR_INVALID_URL";
  AxiosError$1.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
  const httpAdapter = null;
  const DEFAULT_FORM_DATA_MAX_DEPTH = 100;
  function isVisitable(thing) {
    return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
  }
  function removeBrackets(key) {
    return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
  }
  function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
      token = removeBrackets(token);
      return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
  }
  function isFlatArray(arr) {
    return utils$1.isArray(arr) && !arr.some(isVisitable);
  }
  const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
  });
  function toFormData$1(obj, formData, options) {
    if (!utils$1.isObject(obj)) {
      throw new TypeError("target must be an object");
    }
    formData = formData || new FormData();
    const option = (name, fallback) => {
      const value = utils$1.getSafeProp(options, name);
      return utils$1.isUndefined(value) ? fallback : value;
    };
    const metaTokens = option("metaTokens", true);
    const visitor = option("visitor") || defaultVisitor;
    const dots = option("dots", false);
    const indexes = option("indexes", false);
    const _Blob = option("Blob") || typeof Blob !== "undefined" && Blob;
    const maxDepth = option("maxDepth", DEFAULT_FORM_DATA_MAX_DEPTH);
    const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
    const stack2 = [];
    if (!utils$1.isFunction(visitor)) {
      throw new TypeError("visitor must be a function");
    }
    function convertValue(value) {
      if (value === null) return "";
      if (utils$1.isDate(value)) {
        return value.toISOString();
      }
      if (utils$1.isBoolean(value)) {
        return value.toString();
      }
      if (!useBlob && utils$1.isBlob(value)) {
        throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
      }
      if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
        if (useBlob && typeof _Blob === "function") {
          return new _Blob([value]);
        }
        throw new AxiosError$1(
          "Blob is not supported. Use a Buffer instead.",
          AxiosError$1.ERR_NOT_SUPPORT
        );
      }
      return value;
    }
    function throwIfMaxDepthExceeded(depth) {
      if (depth > maxDepth) {
        throw new AxiosError$1(
          "Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth,
          AxiosError$1.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      }
    }
    function stringifyWithDepthLimit(value, depth) {
      if (maxDepth === Infinity) {
        return JSON.stringify(value);
      }
      const ancestors = [];
      return JSON.stringify(value, function limitDepth(_key, currentValue) {
        if (!utils$1.isObject(currentValue)) {
          return currentValue;
        }
        while (ancestors.length && ancestors[ancestors.length - 1] !== this) {
          ancestors.pop();
        }
        ancestors.push(currentValue);
        throwIfMaxDepthExceeded(depth + ancestors.length - 1);
        return currentValue;
      });
    }
    function defaultVisitor(value, key, path) {
      let arr = value;
      if (utils$1.isReactNative(formData) && utils$1.isReactNativeBlob(value)) {
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
      }
      if (value && !path && typeof value === "object") {
        if (utils$1.endsWith(key, "{}")) {
          key = metaTokens ? key : key.slice(0, -2);
          value = stringifyWithDepthLimit(value, 1);
        } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
          key = removeBrackets(key);
          arr.forEach(function each(el, index) {
            !(utils$1.isUndefined(el) || el === null) && formData.append(
              // eslint-disable-next-line no-nested-ternary
              indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
              convertValue(el)
            );
          });
          return false;
        }
      }
      if (isVisitable(value)) {
        return true;
      }
      formData.append(renderKey(path, key, dots), convertValue(value));
      return false;
    }
    const exposedHelpers = Object.assign(predicates, {
      defaultVisitor,
      convertValue,
      isVisitable
    });
    function build(value, path, depth = 0) {
      if (utils$1.isUndefined(value)) return;
      throwIfMaxDepthExceeded(depth);
      if (stack2.indexOf(value) !== -1) {
        throw new Error("Circular reference detected in " + path.join("."));
      }
      stack2.push(value);
      utils$1.forEach(value, function each(el, key) {
        const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers);
        if (result === true) {
          build(el, path ? path.concat(key) : [key], depth + 1);
        }
      });
      stack2.pop();
    }
    if (!utils$1.isObject(obj)) {
      throw new TypeError("data must be an object");
    }
    build(obj);
    return formData;
  }
  function encode$1(str) {
    const charMap = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer2(match) {
      return charMap[match];
    });
  }
  function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && toFormData$1(params, this, options);
  }
  const prototype = AxiosURLSearchParams.prototype;
  prototype.append = function append(name, value) {
    this._pairs.push([name, value]);
  };
  prototype.toString = function toString2(encoder) {
    const _encode = encoder ? (value) => encoder.call(this, value, encode$1) : encode$1;
    return this._pairs.map(function each(pair) {
      return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
  };
  function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
  }
  function buildURL(url, params, options) {
    if (!params) {
      return url;
    }
    url = url || "";
    const _options = utils$1.isFunction(options) ? {
      serialize: options
    } : options;
    const _encode = utils$1.getSafeProp(_options, "encode") || encode;
    const serializeFn = utils$1.getSafeProp(_options, "serialize");
    let serializedParams;
    if (serializeFn) {
      serializedParams = serializeFn(params, _options);
    } else {
      serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, _options).toString(_encode);
    }
    if (serializedParams) {
      const hashmarkIndex = url.indexOf("#");
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
  }
  const $internals = Symbol("internals");
  function countHandlers(handlers) {
    return handlers ? handlers.length : 0;
  }
  function trimHandlers(handlers) {
    if (!handlers) {
      return;
    }
    while (handlers.length && handlers[handlers.length - 1] === null) {
      handlers.pop();
    }
  }
  function syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
      internals.handlersRef = handlers;
      internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
      if (!length) {
        internals.handlerEntries.clear();
      } else {
        internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
          if (handlers[entry.index] !== entry.handler) {
            internals.handlerEntries.delete(id);
          }
        });
      }
    }
    internals.handlersLength = length;
  }
  class InterceptorManager {
    constructor() {
      this.handlers = [];
      this[$internals] = {
        handlersRef: this.handlers,
        handlersLength: this.handlers.length,
        handlerEntries: /* @__PURE__ */ new Map(),
        iterationDepth: 0,
        nextId: 0
      };
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     * @param {Object} options The options for the interceptor, synchronous and runWhen
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(fulfilled, rejected, options) {
      const handler = {
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      };
      const internals = this[$internals];
      if (this.handlers == null) {
        this.handlers = [];
      }
      syncHandlerEntries(this, internals);
      const id = internals.nextId++;
      this.handlers.push(handler);
      internals.handlerEntries.set(id, {
        handler,
        index: this.handlers.length - 1
      });
      internals.handlersLength = this.handlers.length;
      return id;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {void}
     */
    eject(id) {
      const internals = this[$internals];
      syncHandlerEntries(this, internals);
      const entry = internals.handlerEntries.get(id);
      if (entry) {
        internals.handlerEntries.delete(id);
        if (this.handlers[entry.index] !== entry.handler) {
          return;
        }
        this.handlers[entry.index] = null;
        if (!internals.iterationDepth) {
          trimHandlers(this.handlers);
          internals.handlersLength = this.handlers.length;
        }
      }
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      if (this.handlers) {
        this.handlers = [];
        syncHandlerEntries(this, this[$internals]);
      }
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(fn) {
      const internals = this[$internals];
      syncHandlerEntries(this, internals);
      internals.iterationDepth++;
      try {
        utils$1.forEach(this.handlers, function forEachHandler(h2) {
          if (h2 !== null) {
            fn(h2);
          }
        });
      } finally {
        if (!--internals.iterationDepth) {
          syncHandlerEntries(this, internals);
          trimHandlers(this.handlers);
          internals.handlersLength = countHandlers(this.handlers);
        }
      }
    }
  }
  const transitionalDefaults = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
  };
  const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
  const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
  const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
  const platform$1 = {
    isBrowser: true,
    classes: {
      URLSearchParams: URLSearchParams$1,
      FormData: FormData$1,
      Blob: Blob$1
    },
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };
  const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
  const _navigator = typeof navigator === "object" && navigator || void 0;
  const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
  const hasStandardBrowserWebWorkerEnv = (() => {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
  })();
  const origin = hasBrowserEnv && window.location.href || "http://localhost";
  const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    hasBrowserEnv,
    hasStandardBrowserEnv,
    hasStandardBrowserWebWorkerEnv,
    navigator: _navigator,
    origin
  }, Symbol.toStringTag, { value: "Module" }));
  const platform = {
    ...utils,
    ...platform$1
  };
  function toURLEncodedForm(data, options) {
    return toFormData$1(data, new platform.classes.URLSearchParams(), {
      visitor: function(value, key, path, helpers) {
        if (platform.isNode && utils$1.isBuffer(value)) {
          this.append(key, value.toString("base64"));
          return false;
        }
        return helpers.defaultVisitor.apply(this, arguments);
      },
      ...options
    });
  }
  const MAX_DEPTH = DEFAULT_FORM_DATA_MAX_DEPTH;
  function throwIfDepthExceeded(index) {
    if (index > MAX_DEPTH) {
      throw new AxiosError$1(
        "FormData field is too deeply nested (" + index + " levels). Max depth: " + MAX_DEPTH,
        AxiosError$1.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
    }
  }
  function parsePropPath(name) {
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while ((match = pattern.exec(name)) !== null) {
      throwIfDepthExceeded(path.length);
      path.push(match[0] === "[]" ? "" : match[1] || match[0]);
    }
    return path;
  }
  function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      obj[key] = arr[key];
    }
    return obj;
  }
  function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
      throwIfDepthExceeded(index);
      let name = path[index++];
      if (name === "__proto__") return true;
      const isNumericKey = Number.isFinite(+name);
      const isLast = index >= path.length;
      name = !name && utils$1.isArray(target) ? target.length : name;
      if (isLast) {
        if (utils$1.hasOwnProp(target, name)) {
          target[name] = utils$1.isArray(target[name]) ? target[name].concat(value) : [target[name], value];
        } else {
          target[name] = value;
        }
        return !isNumericKey;
      }
      if (!utils$1.hasOwnProp(target, name) || !utils$1.isObject(target[name])) {
        target[name] = [];
      }
      const result = buildPath(path, value, target[name], index);
      if (result && utils$1.isArray(target[name])) {
        target[name] = arrayToObject(target[name]);
      }
      return !isNumericKey;
    }
    if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
      const obj = {};
      utils$1.forEachEntry(formData, (name, value) => {
        buildPath(parsePropPath(name), value, obj, 0);
      });
      return obj;
    }
    return null;
  }
  const methodList = Object.freeze([
    "get",
    "delete",
    "head",
    "options",
    "post",
    "put",
    "patch",
    "purge",
    "link",
    "unlink",
    "query"
  ]);
  const own = (obj, key) => obj != null && utils$1.hasOwnProp(obj, key) ? obj[key] : void 0;
  function stringifySafely(rawValue, parser, encoder) {
    if (utils$1.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils$1.trim(rawValue);
      } catch (e) {
        if (e.name !== "SyntaxError") {
          throw e;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  const defaults = {
    transitional: transitionalDefaults,
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [
      function transformRequest(data, headers) {
        const contentType = headers.getContentType() || "";
        const hasJSONContentType = contentType.indexOf("application/json") > -1;
        const isObjectPayload = utils$1.isObject(data);
        if (isObjectPayload && utils$1.isHTMLForm(data)) {
          data = new FormData(data);
        }
        const isFormData2 = utils$1.isFormData(data);
        if (isFormData2) {
          return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
        }
        if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
          return data;
        }
        if (utils$1.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils$1.isURLSearchParams(data)) {
          headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
          return data.toString();
        }
        let isFileList2;
        if (isObjectPayload) {
          const formSerializer = own(this, "formSerializer");
          if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
            return toURLEncodedForm(data, formSerializer).toString();
          }
          if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
            const env = own(this, "env");
            const _FormData = env && env.FormData;
            return toFormData$1(
              isFileList2 ? { "files[]": data } : data,
              _FormData && new _FormData(),
              formSerializer
            );
          }
        }
        if (isObjectPayload || hasJSONContentType) {
          headers.setContentType("application/json", false);
          return stringifySafely(data);
        }
        return data;
      }
    ],
    transformResponse: [
      function transformResponse(data) {
        const transitional = own(this, "transitional") || defaults.transitional;
        const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        const responseType = own(this, "responseType");
        const JSONRequested = responseType === "json";
        if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
          return data;
        }
        if (data && utils$1.isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
          const silentJSONParsing = transitional && transitional.silentJSONParsing;
          const strictJSONParsing = !silentJSONParsing && JSONRequested;
          try {
            return JSON.parse(data, own(this, "parseReviver"));
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, own(this, "response"));
              }
              throw e;
            }
          }
        }
        return data;
      }
    ],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: platform.classes.FormData,
      Blob: platform.classes.Blob
    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": void 0
      }
    }
  };
  utils$1.forEach(methodList, (method) => {
    defaults.headers[method] = {};
  });
  function transformData(fns, response) {
    const config = this || defaults;
    const context = response || config;
    const headers = AxiosHeaders$1.from(context.headers);
    let data = context.data;
    utils$1.forEach(fns, function transform(fn) {
      data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
    });
    headers.normalize();
    return data;
  }
  function isCancel$1(value) {
    return !!(value && value.__CANCEL__);
  }
  let CanceledError$1 = class CanceledError extends AxiosError$1 {
    /**
     * A `CanceledError` is an object that is thrown when an operation is canceled.
     *
     * @param {string=} message The message.
     * @param {Object=} config The config.
     * @param {Object=} request The request.
     *
     * @returns {CanceledError} The created error.
     */
    constructor(message2, config, request) {
      super(message2 == null ? "canceled" : message2, AxiosError$1.ERR_CANCELED, config, request);
      this.name = "CanceledError";
      this.__CANCEL__ = true;
    }
  };
  function settle(resolve2, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve2(response);
    } else {
      reject(new AxiosError$1(
        "Request failed with status code " + response.status,
        response.status >= 400 && response.status < 500 ? AxiosError$1.ERR_BAD_REQUEST : AxiosError$1.ERR_BAD_RESPONSE,
        response.config,
        response.request,
        response
      ));
    }
  }
  const urlParserControlCharacters = /[\t\n\r]/g;
  function normalizeURLForProtocolCheck(url) {
    if (typeof url !== "string") {
      return url;
    }
    let start = 0;
    while (start < url.length && url.charCodeAt(start) <= 32) {
      start++;
    }
    return url.slice(start).replace(urlParserControlCharacters, "");
  }
  function parseProtocol(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || "";
  }
  function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== void 0 ? min : 1e3;
    return function push(chunkLength) {
      const now = Date.now();
      const startedAt = timestamps[tail];
      if (!firstSampleTS) {
        firstSampleTS = now;
      }
      bytes[head] = chunkLength;
      timestamps[head] = now;
      let i = tail;
      let bytesCount = 0;
      while (i !== head) {
        bytesCount += bytes[i++];
        i = i % samplesCount;
      }
      head = (head + 1) % samplesCount;
      if (head === tail) {
        tail = (tail + 1) % samplesCount;
      }
      if (now - firstSampleTS < min) {
        return;
      }
      const passed = startedAt && now - startedAt;
      return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
    };
  }
  function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1e3 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now()) => {
      timestamp = now;
      lastArgs = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      fn(...args);
    };
    const throttled = (...args) => {
      const now = Date.now();
      const passed = now - timestamp;
      if (passed >= threshold) {
        invoke(args, now);
      } else {
        lastArgs = args;
        if (!timer) {
          timer = setTimeout(() => {
            timer = null;
            invoke(lastArgs);
          }, threshold - passed);
        }
      }
    };
    const flush = () => lastArgs && invoke(lastArgs);
    const flushWith = (...args) => invoke(args);
    return [throttled, flush, flushWith];
  }
  const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
    let bytesNotified = 0;
    const _speedometer = speedometer(50, 250);
    return throttle((e) => {
      if (!e || !utils$1.isNumber(e.loaded)) {
        return;
      }
      const rawLoaded = e.loaded;
      const total = e.lengthComputable ? e.total : void 0;
      const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
      const progressBytes = Math.max(0, loaded - bytesNotified);
      const rate = _speedometer(progressBytes);
      bytesNotified = Math.max(bytesNotified, loaded);
      const data = {
        loaded,
        total,
        progress: total ? loaded / total : void 0,
        bytes: progressBytes,
        rate: rate ? rate : void 0,
        estimated: rate && total ? (total - loaded) / rate : void 0,
        event: e,
        lengthComputable: total != null,
        [isDownloadStream ? "download" : "upload"]: true
      };
      listener(data);
    }, freq);
  };
  const progressEventDecorator = (total, throttled) => {
    const lengthComputable = total != null;
    return [
      (loaded) => throttled[0]({
        lengthComputable,
        total,
        loaded
      }),
      throttled[1]
    ];
  };
  const asyncDecorator = (fn, scheduler = utils$1.asap) => (...args) => scheduler(() => fn(...args));
  const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
    url = new URL(url, platform.origin);
    return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
  })(
    new URL(platform.origin),
    platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
  ) : () => true;
  const cookies = platform.hasStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    {
      write(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === "undefined") return;
        const cookie = [`${name}=${encodeURIComponent(value)}`];
        if (utils$1.isNumber(expires)) {
          cookie.push(`expires=${new Date(expires).toUTCString()}`);
        }
        if (utils$1.isString(path)) {
          cookie.push(`path=${path}`);
        }
        if (utils$1.isString(domain)) {
          cookie.push(`domain=${domain}`);
        }
        if (secure === true) {
          cookie.push("secure");
        }
        if (utils$1.isString(sameSite)) {
          cookie.push(`SameSite=${sameSite}`);
        }
        document.cookie = cookie.join("; ");
      },
      read(name) {
        if (typeof document === "undefined") return null;
        const cookies2 = document.cookie.split(";");
        for (let i = 0; i < cookies2.length; i++) {
          const cookie = cookies2[i].replace(/^\s+/, "");
          const eq = cookie.indexOf("=");
          if (eq !== -1 && cookie.slice(0, eq) === name) {
            try {
              return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
              return cookie.slice(eq + 1);
            }
          }
        }
        return null;
      },
      remove(name) {
        this.write(name, "", Date.now() - 864e5, "/");
      }
    }
  ) : (
    // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {
      },
      read() {
        return null;
      },
      remove() {
      }
    }
  );
  function isAbsoluteURL(url) {
    if (typeof url !== "string") {
      return false;
    }
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  }
  function combineURLs(baseURL, relativeURL) {
    if (!relativeURL) {
      return baseURL;
    }
    let end = baseURL.length;
    while (end > 0 && baseURL.charCodeAt(end - 1) === 47) {
      end--;
    }
    return baseURL.slice(0, end) + "/" + relativeURL.replace(/^\/+/, "");
  }
  const malformedHttpProtocol = /^https?:(?!\/\/)/i;
  function redactFragment(fragment) {
    if (!fragment) {
      return fragment;
    }
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = "") => {
      return `${separator}${parameterName}${REDACTED}`;
    });
  }
  function redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${REDACTED}@`);
    const fragmentIndex = redactedURL.indexOf("#");
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(
      /([?&][^=&#]*=)[^&#]*/g,
      `$1${REDACTED}`
    );
    if (fragmentIndex === -1) {
      return redactedURLWithoutFragment;
    }
    return `${redactedURLWithoutFragment}#${redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
  }
  function assertValidHttpProtocolURL(url, config) {
    if (typeof url === "string") {
      const normalizedURL = normalizeURLForProtocolCheck(url);
      if (malformedHttpProtocol.test(normalizedURL)) {
        throw new AxiosError$1(
          `Invalid URL ${JSON.stringify(redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`,
          AxiosError$1.ERR_INVALID_URL,
          config
        );
      }
    }
  }
  function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !isAbsoluteURL(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
      assertValidHttpProtocolURL(baseURL, config);
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  }
  const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;
  const ownEnumerableKeys = (thing) => {
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) {
      return Object.keys(thing).concat(
        Object.getOwnPropertySymbols(thing).filter(
          (symbol) => Object.getOwnPropertyDescriptor(thing, symbol).enumerable
        )
      );
    }
    return Object.keys(thing);
  };
  function mergeConfig$1(config1, config2) {
    config1 = config1 || {};
    config2 = config2 || {};
    const config = /* @__PURE__ */ Object.create(null);
    Object.defineProperty(config, "hasOwnProperty", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: Object.prototype.hasOwnProperty,
      enumerable: false,
      writable: true,
      configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
      if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
        return utils$1.merge.call({ caseless }, target, source);
      } else if (utils$1.isPlainObject(source)) {
        return utils$1.merge({}, source);
      } else if (utils$1.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
      if (!utils$1.isUndefined(b)) {
        return getMergedValue(a, b, prop, caseless);
      } else if (!utils$1.isUndefined(a)) {
        return getMergedValue(void 0, a, prop, caseless);
      }
    }
    function valueFromConfig2(a, b) {
      if (!utils$1.isUndefined(b)) {
        return getMergedValue(void 0, b);
      }
    }
    function defaultToConfig2(a, b) {
      if (!utils$1.isUndefined(b)) {
        return getMergedValue(void 0, b);
      } else if (!utils$1.isUndefined(a)) {
        return getMergedValue(void 0, a);
      }
    }
    function getMergedTransitionalOption(prop) {
      const transitional2 = utils$1.hasOwnProp(config2, "transitional") ? config2.transitional : void 0;
      if (!utils$1.isUndefined(transitional2)) {
        if (utils$1.isPlainObject(transitional2)) {
          if (utils$1.hasOwnProp(transitional2, prop)) {
            return transitional2[prop];
          }
        } else {
          return void 0;
        }
      }
      const transitional1 = utils$1.hasOwnProp(config1, "transitional") ? config1.transitional : void 0;
      if (utils$1.isPlainObject(transitional1) && utils$1.hasOwnProp(transitional1, prop)) {
        return transitional1[prop];
      }
      return void 0;
    }
    function mergeDirectKeys(a, b, prop) {
      if (utils$1.hasOwnProp(config2, prop)) {
        return getMergedValue(a, b);
      } else if (utils$1.hasOwnProp(config1, prop)) {
        return getMergedValue(void 0, a);
      }
    }
    const mergeMap = {
      url: valueFromConfig2,
      method: valueFromConfig2,
      data: valueFromConfig2,
      baseURL: defaultToConfig2,
      transformRequest: defaultToConfig2,
      transformResponse: defaultToConfig2,
      paramsSerializer: defaultToConfig2,
      timeout: defaultToConfig2,
      timeoutErrorMessage: defaultToConfig2,
      withCredentials: defaultToConfig2,
      withXSRFToken: defaultToConfig2,
      adapter: defaultToConfig2,
      responseType: defaultToConfig2,
      xsrfCookieName: defaultToConfig2,
      xsrfHeaderName: defaultToConfig2,
      onUploadProgress: defaultToConfig2,
      onDownloadProgress: defaultToConfig2,
      decompress: defaultToConfig2,
      maxContentLength: defaultToConfig2,
      maxBodyLength: defaultToConfig2,
      beforeRedirect: defaultToConfig2,
      transport: defaultToConfig2,
      httpAgent: defaultToConfig2,
      httpsAgent: defaultToConfig2,
      cancelToken: defaultToConfig2,
      socketPath: defaultToConfig2,
      allowedSocketPaths: defaultToConfig2,
      responseEncoding: defaultToConfig2,
      validateStatus: mergeDirectKeys,
      headers: (a, b, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    utils$1.forEach(ownEnumerableKeys({ ...config1, ...config2 }), function computeConfigValue(prop) {
      if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
      const merge2 = utils$1.hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
      const a = utils$1.hasOwnProp(config1, prop) ? config1[prop] : void 0;
      const b = utils$1.hasOwnProp(config2, prop) ? config2[prop] : void 0;
      const configValue = merge2(a, b, prop);
      utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
    });
    if (utils$1.hasOwnProp(config2, "validateStatus") && utils$1.isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
      if (utils$1.hasOwnProp(config1, "validateStatus")) {
        config.validateStatus = getMergedValue(void 0, config1.validateStatus);
      } else {
        delete config.validateStatus;
      }
    }
    return config;
  }
  const FORM_DATA_CONTENT_HEADERS = ["content-type", "content-length"];
  function setFormDataHeaders(headers, formHeaders, policy2) {
    if (policy2 !== "content-only") {
      headers.set(formHeaders);
      return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val]) => {
      if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) {
        headers.set(key, val);
      }
    });
  }
  const encodeUTF8$1 = (str) => encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/gi,
    (_, hex) => String.fromCharCode(parseInt(hex, 16))
  );
  function resolveConfig$1(config) {
    const newConfig = mergeConfig$1({}, config);
    const own2 = (key) => utils$1.hasOwnProp(newConfig, key) ? newConfig[key] : void 0;
    const data = own2("data");
    let withXSRFToken = own2("withXSRFToken");
    const xsrfHeaderName = own2("xsrfHeaderName");
    const xsrfCookieName = own2("xsrfCookieName");
    let headers = own2("headers");
    const auth = own2("auth");
    const baseURL = own2("baseURL");
    const allowAbsoluteUrls = own2("allowAbsoluteUrls");
    const url = own2("url");
    newConfig.headers = headers = AxiosHeaders$1.from(headers);
    newConfig.url = buildURL(
      buildFullPath(baseURL, url, allowAbsoluteUrls, newConfig),
      own2("params"),
      own2("paramsSerializer")
    );
    if (auth) {
      const username = utils$1.getSafeProp(auth, "username") || "";
      const password = utils$1.getSafeProp(auth, "password") || "";
      try {
        headers.set(
          "Authorization",
          "Basic " + btoa(username + ":" + (password ? encodeUTF8$1(password) : ""))
        );
      } catch (e) {
        throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_OPTION_VALUE, config);
      }
    }
    if (utils$1.isFormData(data)) {
      const getHeaders = utils$1.getSafeProp(data, "getHeaders");
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv || utils$1.isReactNative(data)) {
        headers.setContentType(void 0);
      } else if (utils$1.isFunction(getHeaders)) {
        setFormDataHeaders(headers, getHeaders.call(data), own2("formDataHeaderPolicy"));
      }
    }
    if (platform.hasStandardBrowserEnv) {
      if (utils$1.isFunction(withXSRFToken)) {
        withXSRFToken = withXSRFToken(newConfig);
      }
      const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && isURLSameOrigin(newConfig.url);
      if (shouldSendXSRF) {
        const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
        if (xsrfValue) {
          headers.set(xsrfHeaderName, xsrfValue);
        }
      }
    }
    return newConfig;
  }
  const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
  const xhrAdapter = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve2, reject) {
      const _config = resolveConfig$1(config);
      let requestData = _config.data;
      const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
      let { responseType, onUploadProgress, onDownloadProgress } = _config;
      let onCanceled;
      let uploadThrottled, downloadThrottled;
      let flushUpload, flushDownload, flushDownloadWithEvent;
      function done() {
        flushUpload && flushUpload();
        flushDownload && flushDownload();
        _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
        _config.signal && _config.signal.removeEventListener("abort", onCanceled);
      }
      let request = new XMLHttpRequest();
      request.open(_config.method.toUpperCase(), _config.url, true);
      request.timeout = _config.timeout;
      function onloadend(event2) {
        if (!request) {
          return;
        }
        if (request.status === 0 && (parseProtocol(normalizeURLForProtocolCheck(_config.url)) || parseProtocol(platform.origin)) !== "file" && !(request.responseURL && request.responseURL.startsWith("file:"))) {
          reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
          done();
          request = null;
          return;
        }
        try {
          if (event2) {
            flushDownloadWithEvent && flushDownloadWithEvent(event2);
          } else {
            flushDownload && flushDownload();
          }
        } catch (err) {
          setTimeout(() => {
            throw err;
          });
        }
        if (!request) {
          return;
        }
        const responseHeaders = AxiosHeaders$1.from(
          "getAllResponseHeaders" in request && request.getAllResponseHeaders()
        );
        const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
        const response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config,
          request
        };
        settle(
          function _resolve(value) {
            resolve2(value);
            done();
          },
          function _reject(err) {
            reject(err);
            done();
          },
          response
        );
        request = null;
      }
      if ("onloadend" in request) {
        request.onloadend = onloadend;
      } else {
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }
          if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }
        reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
        done();
        request = null;
      };
      request.onerror = function handleError2(event2) {
        const msg = event2 && event2.message ? event2.message : "Network Error";
        const err = new AxiosError$1(msg, AxiosError$1.ERR_NETWORK, config, request);
        err.event = event2 || null;
        reject(err);
        done();
        request = null;
      };
      request.ontimeout = function handleTimeout() {
        let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
        const transitional = _config.transitional || transitionalDefaults;
        if (_config.timeoutErrorMessage) {
          timeoutErrorMessage = _config.timeoutErrorMessage;
        }
        reject(
          new AxiosError$1(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
            config,
            request
          )
        );
        done();
        request = null;
      };
      requestData === void 0 && requestHeaders.setContentType(null);
      if ("setRequestHeader" in request) {
        utils$1.forEach(toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
          request.setRequestHeader(key, val);
        });
      }
      if (!utils$1.isUndefined(_config.withCredentials)) {
        request.withCredentials = !!_config.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request.responseType = _config.responseType;
      }
      if (onDownloadProgress) {
        [downloadThrottled, flushDownload, flushDownloadWithEvent] = progressEventReducer(
          onDownloadProgress,
          true
        );
        request.addEventListener("progress", downloadThrottled);
      }
      if (onUploadProgress && request.upload) {
        [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
        request.upload.addEventListener("progress", uploadThrottled);
        request.upload.addEventListener("loadend", flushUpload);
      }
      if (_config.cancelToken || _config.signal) {
        onCanceled = (cancel) => {
          if (!request) {
            return;
          }
          reject(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
          request.abort();
          done();
          request = null;
        };
        _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
        if (_config.signal) {
          _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
      }
      const protocol = parseProtocol(_config.url);
      if (protocol && !platform.protocols.includes(protocol)) {
        reject(
          new AxiosError$1(
            "Unsupported protocol " + protocol + ":",
            AxiosError$1.ERR_BAD_REQUEST,
            config
          )
        );
        done();
        return;
      }
      request.send(requestData || null);
    });
  };
  const composeSignals = (signals, timeout) => {
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) {
      return;
    }
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(
          err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err)
        );
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError$1(`timeout of ${timeout}ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (!signals) {
        return;
      }
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach((signal2) => {
        signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
      });
      signals = null;
    };
    signals.forEach((signal2) => {
      if (aborted) {
        return;
      }
      if (signal2.aborted) {
        onabort.call(signal2);
        return;
      }
      signal2.addEventListener("abort", onabort, { once: true });
    });
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  };
  const streamChunk = function* (chunk, chunkSize) {
    let len = chunk.byteLength;
    if (len < chunkSize) {
      yield chunk;
      return;
    }
    let pos = 0;
    let end;
    while (pos < len) {
      end = pos + chunkSize;
      yield chunk.slice(pos, end);
      pos = end;
    }
  };
  const readBytes = async function* (iterable, chunkSize) {
    for await (const chunk of readStream(iterable)) {
      yield* streamChunk(chunk, chunkSize);
    }
  };
  const readStream = async function* (stream) {
    if (stream[Symbol.asyncIterator]) {
      yield* stream;
      return;
    }
    const reader = stream.getReader();
    try {
      for (; ; ) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }
        yield value;
      }
    } finally {
      await reader.cancel();
    }
  };
  const trackStream = (stream, chunkSize, onProgress, onFinish) => {
    const iterator2 = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e) => {
      if (!done) {
        done = true;
        onFinish && onFinish(e);
      }
    };
    return new ReadableStream(
      {
        async pull(controller) {
          try {
            const { done: done2, value } = await iterator2.next();
            if (done2) {
              _onFinish();
              controller.close();
              return;
            }
            let len = value.byteLength;
            if (onProgress) {
              let loadedBytes = bytes += len;
              onProgress(loadedBytes);
            }
            controller.enqueue(new Uint8Array(value));
          } catch (err) {
            _onFinish(err);
            throw err;
          }
        },
        cancel(reason) {
          _onFinish(reason);
          return iterator2.return();
        }
      },
      {
        highWaterMark: 2
      }
    );
  };
  const isHexDigit = (charCode) => charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
  const isPercentEncodedByte = (str, i, len) => i + 2 < len && isHexDigit(str.charCodeAt(i + 1)) && isHexDigit(str.charCodeAt(i + 2));
  const hexValue = (charCode) => charCode <= 57 ? charCode - 48 : (charCode & 223) - 55;
  const isBase64Char = (charCode) => charCode >= 65 && charCode <= 90 || // A-Z
  charCode >= 97 && charCode <= 122 || // a-z
  charCode >= 48 && charCode <= 57 || // 0-9
  charCode === 43 || // +
  charCode === 47 || // /
  charCode === 45 || // - (base64url)
  charCode === 95;
  const isBase64Whitespace = (charCode) => charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
  const base64Bytes = (significant) => {
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
  };
  const estimateBase64BufferAllocation = (body) => {
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61) {
      padding++;
      if (len > 1 && body.charCodeAt(len - 2) === 61) {
        padding++;
      }
    }
    return Math.floor((len - padding) * 3 / 4);
  };
  const estimatePercentDecodedBase64Bytes = (body) => {
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for (let i = 0; i < len; i++) {
      let code = body.charCodeAt(i);
      if (code === 37 && isPercentEncodedByte(body, i, len)) {
        code = hexValue(body.charCodeAt(i + 1)) * 16 + hexValue(body.charCodeAt(i + 2));
        i += 2;
      }
      if (isBase64Whitespace(code)) {
        continue;
      }
      if (code === 61) {
        padding++;
        continue;
      }
      if (!isBase64Char(code) || padding > 0) {
        invalid = true;
        continue;
      }
      significant++;
    }
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) {
      return estimateBase64BufferAllocation(body);
    }
    return base64Bytes(significant);
  };
  const estimateDataURLBytes = (url, estimateBase64) => {
    if (!url || typeof url !== "string") return 0;
    if (!url.startsWith("data:")) return 0;
    const comma = url.indexOf(",");
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
      return estimateBase64(body);
    }
    let bytes = 0;
    for (let i = 0, len = body.length; i < len; i++) {
      const c = body.charCodeAt(i);
      if (c === 37 && isPercentEncodedByte(body, i, len)) {
        bytes += 1;
        i += 2;
      } else if (c < 128) {
        bytes += 1;
      } else if (c < 2048) {
        bytes += 2;
      } else if (c >= 55296 && c <= 56319 && i + 1 < len) {
        const next = body.charCodeAt(i + 1);
        if (next >= 56320 && next <= 57343) {
          bytes += 4;
          i++;
        } else {
          bytes += 3;
        }
      } else {
        bytes += 3;
      }
    }
    return bytes;
  };
  function estimateDataURLDecodedBytes(url) {
    const fragmentIndex = typeof url === "string" ? url.indexOf("#") : -1;
    return estimateDataURLBytes(
      fragmentIndex === -1 ? url : url.slice(0, fragmentIndex),
      estimatePercentDecodedBase64Bytes
    );
  }
  const VERSION$1 = "1.20.0";
  const DEFAULT_CHUNK_SIZE = 64 * 1024;
  const DEFAULT_REQUEST_OPTIONS = {
    cache: "default",
    redirect: "follow",
    referrer: "about:client",
    referrerPolicy: "",
    mode: "cors",
    integrity: "",
    keepalive: false,
    priority: "auto",
    window: null
  };
  const { isFunction } = utils$1;
  const encodeUTF8 = (str) => encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/gi,
    (_, hex) => String.fromCharCode(parseInt(hex, 16))
  );
  const decodeURIComponentSafe = (value) => {
    if (!utils$1.isString(value)) {
      return value;
    }
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  };
  const test = (fn, ...args) => {
    try {
      return !!fn(...args);
    } catch (e) {
      return false;
    }
  };
  const maybeWithAuthCredentials = (url) => {
    const protocolIndex = url.indexOf("://");
    let urlToCheck = url;
    if (protocolIndex !== -1) {
      urlToCheck = urlToCheck.slice(protocolIndex + 3);
    }
    return urlToCheck.includes("@") || urlToCheck.includes(":");
  };
  const factory = (env) => {
    const globalObject = utils$1.global !== void 0 && utils$1.global !== null ? utils$1.global : globalThis;
    const { ReadableStream: ReadableStream2, TextEncoder } = globalObject;
    env = utils$1.merge.call(
      {
        skipUndefined: true
      },
      {
        Request: globalObject.Request,
        Response: globalObject.Response
      },
      env
    );
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === "function";
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) {
      return false;
    }
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream2);
    const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(() => {
      let duplexAccessed = false;
      const request = new Request(platform.origin, {
        body: new ReadableStream2(),
        method: "POST",
        get duplex() {
          duplexAccessed = true;
          return "half";
        }
      });
      const hasContentType = request.headers.has("Content-Type");
      if (request.body != null) {
        request.body.cancel();
      }
      return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
    const resolvers = {
      stream: supportsResponseStream && ((res) => res.body)
    };
    isFetchSupported && (() => {
      ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
        !resolvers[type] && (resolvers[type] = (res, config) => {
          let method = res && res[type];
          if (method) {
            return method.call(res);
          }
          throw new AxiosError$1(
            `Response type '${type}' is not supported`,
            AxiosError$1.ERR_NOT_SUPPORT,
            config
          );
        });
      });
    })();
    const getBodyLength = async (body) => {
      if (body == null) {
        return 0;
      }
      if (utils$1.isBlob(body)) {
        return body.size;
      }
      if (utils$1.isSpecCompliantForm(body)) {
        const _request = new Request(platform.origin, {
          method: "POST",
          body
        });
        return (await _request.arrayBuffer()).byteLength;
      }
      if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
        return body.byteLength;
      }
      if (utils$1.isURLSearchParams(body)) {
        body = body + "";
      }
      if (utils$1.isString(body)) {
        return (await encodeText(body)).byteLength;
      }
    };
    const resolveBodyLength = async (headers, body) => {
      const length = utils$1.toFiniteNumber(headers.getContentLength());
      return length == null ? getBodyLength(body) : length;
    };
    return async (config) => {
      let {
        url,
        method,
        data,
        signal,
        cancelToken,
        timeout,
        onDownloadProgress,
        onUploadProgress,
        responseType,
        headers,
        withCredentials = "same-origin",
        fetchOptions,
        maxContentLength,
        maxBodyLength,
        maxRedirects
      } = resolveConfig$1(config);
      const hasMaxContentLength = utils$1.isNumber(maxContentLength) && maxContentLength > -1;
      const hasMaxBodyLength = utils$1.isNumber(maxBodyLength) && maxBodyLength > -1;
      const own2 = (key) => utils$1.hasOwnProp(config, key) ? config[key] : void 0;
      let _fetch = envFetch || fetch;
      responseType = responseType ? (responseType + "").toLowerCase() : "text";
      let composedSignal = composeSignals(
        [signal, cancelToken && cancelToken.toAbortSignal()],
        timeout
      );
      let request = null;
      const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
        composedSignal.unsubscribe();
      });
      let requestContentLength;
      let pendingBodyError = null;
      const maxBodyLengthError = () => new AxiosError$1(
        "Request body larger than maxBodyLength limit",
        AxiosError$1.ERR_BAD_REQUEST,
        config,
        request
      );
      try {
        let auth = void 0;
        const configAuth = own2("auth");
        if (configAuth) {
          const username = utils$1.getSafeProp(configAuth, "username") || "";
          const password = utils$1.getSafeProp(configAuth, "password") || "";
          auth = {
            username,
            password
          };
        }
        if (maybeWithAuthCredentials(url)) {
          const parsedURL = new URL(url, platform.origin);
          if (!auth && (parsedURL.username || parsedURL.password)) {
            const urlUsername = decodeURIComponentSafe(parsedURL.username);
            const urlPassword = decodeURIComponentSafe(parsedURL.password);
            auth = {
              username: urlUsername,
              password: urlPassword
            };
          }
          if (parsedURL.username || parsedURL.password) {
            parsedURL.username = "";
            parsedURL.password = "";
            url = parsedURL.href;
          }
        }
        if (auth) {
          headers.delete("authorization");
          headers.set(
            "Authorization",
            "Basic " + btoa(encodeUTF8((auth.username || "") + ":" + (auth.password || "")))
          );
        }
        if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
          const estimated = estimateDataURLDecodedBytes(url);
          if (estimated > maxContentLength) {
            throw new AxiosError$1(
              "maxContentLength size of " + maxContentLength + " exceeded",
              AxiosError$1.ERR_BAD_RESPONSE,
              config,
              request
            );
          }
        }
        if (hasMaxBodyLength && method !== "get" && method !== "head") {
          const outboundLength = await getBodyLength(data);
          if (typeof outboundLength === "number" && isFinite(outboundLength)) {
            requestContentLength = outboundLength;
            if (outboundLength > maxBodyLength) {
              throw maxBodyLengthError();
            }
          }
        }
        const mustEnforceStreamBody = hasMaxBodyLength && (utils$1.isReadableStream(data) || utils$1.isStream(data));
        const trackRequestStream = (stream, onProgress, flush) => trackStream(
          stream,
          DEFAULT_CHUNK_SIZE,
          (loadedBytes) => {
            if (hasMaxBodyLength && loadedBytes > maxBodyLength) {
              throw pendingBodyError = maxBodyLengthError();
            }
            onProgress && onProgress(loadedBytes);
          },
          flush
        );
        if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
          requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
          if (requestContentLength !== 0 || mustEnforceStreamBody) {
            let _request = new Request(url, {
              method: "POST",
              body: data,
              duplex: "half"
            });
            let contentTypeHeader;
            if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
              headers.setContentType(contentTypeHeader);
            }
            if (_request.body) {
              const [onProgress, flush] = onUploadProgress && progressEventDecorator(
                requestContentLength,
                progressEventReducer(asyncDecorator(onUploadProgress))
              ) || [];
              data = trackRequestStream(_request.body, onProgress, flush);
            }
          }
        } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") {
          data = trackRequestStream(data);
        } else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") {
          throw new AxiosError$1(
            "Stream request bodies are not supported by the current fetch implementation",
            AxiosError$1.ERR_NOT_SUPPORT,
            config,
            request
          );
        }
        if (!utils$1.isString(withCredentials)) {
          withCredentials = withCredentials ? "include" : "omit";
        }
        const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
        if (utils$1.isFormData(data)) {
          const contentType = headers.getContentType();
          if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) {
            headers.delete("content-type");
          }
        }
        headers.set("User-Agent", "axios/" + VERSION$1, false);
        const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(/* @__PURE__ */ Object.create(null), fetchOptions);
        if (safeFetchOptions) {
          delete safeFetchOptions.body;
          delete safeFetchOptions.headers;
          delete safeFetchOptions.method;
          delete safeFetchOptions.signal;
          delete safeFetchOptions.duplex;
          delete safeFetchOptions.credentials;
        }
        const resolvedOptions = Object.assign(/* @__PURE__ */ Object.create(null), safeFetchOptions, {
          signal: composedSignal,
          method: method.toUpperCase(),
          headers: toByteStringHeaderObject(headers.normalize()),
          body: data,
          duplex: "half",
          credentials: isCredentialsSupported ? withCredentials : void 0
        });
        if (isRequestSupported) {
          utils$1.forEach(DEFAULT_REQUEST_OPTIONS, (value, key) => {
            if (resolvedOptions[key] === void 0) {
              resolvedOptions[key] = value;
            }
          });
          if (resolvedOptions.signal === void 0) {
            resolvedOptions.signal = null;
          }
          if (resolvedOptions.body === void 0) {
            resolvedOptions.body = null;
          }
        }
        if (maxRedirects === 0) {
          resolvedOptions.redirect = "manual";
          if (safeFetchOptions) {
            safeFetchOptions.redirect = "manual";
          }
        }
        request = isRequestSupported && new Request(url, resolvedOptions);
        let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
        const responseHeaders = AxiosHeaders$1.from(response.headers);
        if (hasMaxContentLength) {
          const declaredLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
          if (declaredLength != null && declaredLength > maxContentLength) {
            throw new AxiosError$1(
              "maxContentLength size of " + maxContentLength + " exceeded",
              AxiosError$1.ERR_BAD_RESPONSE,
              config,
              request
            );
          }
        }
        const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
        if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
          const options = {};
          ["status", "statusText", "headers"].forEach((prop) => {
            options[prop] = response[prop];
          });
          const responseContentLength = utils$1.toFiniteNumber(responseHeaders.getContentLength());
          const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
            responseContentLength,
            progressEventReducer(asyncDecorator(onDownloadProgress), true)
          ) || [];
          let bytesRead = 0;
          const onChunkProgress = (loadedBytes) => {
            if (hasMaxContentLength) {
              bytesRead = loadedBytes;
              if (bytesRead > maxContentLength) {
                throw new AxiosError$1(
                  "maxContentLength size of " + maxContentLength + " exceeded",
                  AxiosError$1.ERR_BAD_RESPONSE,
                  config,
                  request
                );
              }
            }
            onProgress && onProgress(loadedBytes);
          };
          response = new Response(
            trackStream(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, () => {
              flush && flush();
              unsubscribe && unsubscribe();
            }),
            options
          );
        }
        responseType = responseType || "text";
        let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](
          response,
          config
        );
        if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
          let materializedSize;
          if (responseData != null) {
            if (typeof responseData.byteLength === "number") {
              materializedSize = responseData.byteLength;
            } else if (typeof responseData.size === "number") {
              materializedSize = responseData.size;
            } else if (typeof responseData === "string") {
              materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
            }
          }
          if (typeof materializedSize === "number" && materializedSize > maxContentLength) {
            throw new AxiosError$1(
              "maxContentLength size of " + maxContentLength + " exceeded",
              AxiosError$1.ERR_BAD_RESPONSE,
              config,
              request
            );
          }
        }
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve2, reject) => {
          settle(resolve2, reject, {
            data: responseData,
            headers: AxiosHeaders$1.from(response.headers),
            status: response.status,
            statusText: response.statusText,
            config,
            request
          });
        });
      } catch (err) {
        unsubscribe && unsubscribe();
        if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof AxiosError$1) {
          const canceledError = composedSignal.reason;
          canceledError.config = config;
          request && (canceledError.request = request);
          if (err !== canceledError) {
            Object.defineProperty(canceledError, "cause", {
              __proto__: null,
              value: err,
              writable: true,
              enumerable: false,
              configurable: true
            });
          }
          throw canceledError;
        }
        if (pendingBodyError) {
          request && !pendingBodyError.request && (pendingBodyError.request = request);
          throw pendingBodyError;
        }
        if (err instanceof AxiosError$1) {
          request && !err.request && (err.request = request);
          throw err;
        }
        if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
          const networkError = new AxiosError$1(
            "Network Error",
            AxiosError$1.ERR_NETWORK,
            config,
            request,
            err && err.response
          );
          Object.defineProperty(networkError, "cause", {
            __proto__: null,
            value: err.cause || err,
            writable: true,
            enumerable: false,
            configurable: true
          });
          throw networkError;
        }
        throw AxiosError$1.from(err, err && err.code, config, request, err && err.response);
      }
    };
  };
  const seedCache = /* @__PURE__ */ new Map();
  const getFetch = (config) => {
    let env = config && config.env || {};
    const { fetch: fetch2, Request, Response } = env;
    const seeds = [Request, Response, fetch2];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while (i--) {
      seed = seeds[i];
      target = map.get(seed);
      target === void 0 && map.set(seed, target = i ? /* @__PURE__ */ new Map() : factory(env));
      map = target;
    }
    return target;
  };
  getFetch();
  const knownAdapters = {
    http: httpAdapter,
    xhr: xhrAdapter,
    fetch: {
      get: getFetch
    }
  };
  utils$1.forEach(knownAdapters, (fn, value) => {
    if (fn) {
      try {
        Object.defineProperty(fn, "name", { __proto__: null, value });
      } catch (e) {
      }
      Object.defineProperty(fn, "adapterName", { __proto__: null, value });
    }
  });
  const renderReason = (reason) => `- ${reason}`;
  const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
  function getAdapter$1(adapters2, config) {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError$1(`Unknown adapter '${id}'`);
        }
      }
      if (adapter && (utils$1.isFunction(adapter) || (adapter = adapter.get(config)))) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError$1(
        `There is no suitable adapter to dispatch the request ` + s,
        AxiosError$1.ERR_NOT_SUPPORT
      );
    }
    return adapter;
  }
  const adapters = {
    /**
     * Resolve an adapter from a list of adapter names or functions.
     * @type {Function}
     */
    getAdapter: getAdapter$1,
    /**
     * Exposes all known adapters
     * @type {Object<string, Function|Object>}
     */
    adapters: knownAdapters
  };
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new CanceledError$1(null, config);
    }
  }
  function dispatchRequest(_config) {
    const config = utils$1.toSafeFlatObject(_config);
    throwIfCancellationRequested(config);
    config.headers = AxiosHeaders$1.from(utils$1.getSafeProp(config, "headers"));
    config.data = transformData.call(config, config.transformRequest);
    if (["post", "put", "patch"].indexOf(config.method) !== -1) {
      config.headers.setContentType("application/x-www-form-urlencoded", false);
    }
    const adapter = adapters.getAdapter(config.adapter || defaults.adapter, config);
    return adapter(config).then(
      function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        config.response = response;
        try {
          response.data = transformData.call(config, config.transformResponse, response);
        } finally {
          delete config.response;
        }
        response.headers = AxiosHeaders$1.from(response.headers);
        return response;
      },
      function onAdapterRejection(reason) {
        if (!isCancel$1(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            config.response = reason.response;
            try {
              reason.response.data = transformData.call(
                config,
                config.transformResponse,
                reason.response
              );
            } finally {
              delete config.response;
            }
            reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
          }
        }
        return Promise.reject(reason);
      }
    );
  }
  const validators$1 = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
    validators$1[type] = function validator2(thing) {
      return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
  });
  const deprecatedWarnings = {};
  validators$1.transitional = function transitional(validator2, version2, message2) {
    function formatMessage(opt, desc) {
      return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
    }
    return (value, opt, opts) => {
      if (validator2 === false) {
        throw new AxiosError$1(
          formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
          AxiosError$1.ERR_DEPRECATED
        );
      }
      if (version2 && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        console.warn(
          formatMessage(
            opt,
            " has been deprecated since v" + version2 + " and will be removed in the near future"
          )
        );
      }
      return validator2 ? validator2(value, opt, opts) : true;
    };
  };
  validators$1.spelling = function spelling(correctSpelling) {
    return (value, opt) => {
      console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
      return true;
    };
  };
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object" || options === null) {
      throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
    }
    const keys = Object.keys(options);
    let i = keys.length;
    while (i-- > 0) {
      const opt = keys[i];
      const validator2 = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : void 0;
      if (validator2) {
        const value = options[opt];
        const result = value === void 0 || validator2(value, opt, options);
        if (result !== true) {
          throw new AxiosError$1(
            "option " + opt + " must be " + result,
            AxiosError$1.ERR_BAD_OPTION_VALUE
          );
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
      }
    }
  }
  const validator = {
    assertOptions,
    validators: validators$1
  };
  const validators = validator.validators;
  let Axios$1 = class Axios {
    constructor(instanceConfig) {
      this.defaults = instanceConfig || {};
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    async request(configOrUrl, config) {
      try {
        return await this._request(configOrUrl, config);
      } catch (err) {
        if (err instanceof Error) {
          try {
            let dummy = {};
            Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
            const dummyStack = dummy.stack;
            let stack2 = "";
            if (typeof dummyStack === "string") {
              const firstNewlineIndex = dummyStack.indexOf("\n");
              stack2 = firstNewlineIndex === -1 ? "" : dummyStack.slice(firstNewlineIndex + 1);
            }
            if (!err.stack) {
              err.stack = stack2;
            } else if (stack2) {
              const firstNewlineIndex = stack2.indexOf("\n");
              const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack2.indexOf("\n", firstNewlineIndex + 1);
              const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack2.slice(secondNewlineIndex + 1);
              if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) {
                err.stack += "\n" + stack2;
              }
            }
          } catch (e) {
          }
        }
        throw err;
      }
    }
    _request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig$1(this.defaults, config);
      const { transitional, paramsSerializer, headers } = config;
      if (transitional !== void 0) {
        validator.assertOptions(
          transitional,
          {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean),
            legacyInterceptorReqResOrdering: validators.transitional(validators.boolean),
            advertiseZstdAcceptEncoding: validators.transitional(validators.boolean),
            validateStatusUndefinedResolves: validators.transitional(validators.boolean)
          },
          false
        );
      }
      if (paramsSerializer != null) {
        if (utils$1.isFunction(paramsSerializer)) {
          config.paramsSerializer = {
            serialize: paramsSerializer
          };
        } else {
          validator.assertOptions(
            paramsSerializer,
            {
              encode: validators.function,
              serialize: validators.function
            },
            true
          );
        }
      }
      if (config.allowAbsoluteUrls !== void 0) ;
      else if (this.defaults.allowAbsoluteUrls !== void 0) {
        config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
      } else {
        config.allowAbsoluteUrls = true;
      }
      validator.assertOptions(
        config,
        {
          baseUrl: validators.spelling("baseURL"),
          withXsrfToken: validators.spelling("withXSRFToken")
        },
        true
      );
      config.method = (utils$1.getSafeProp(config, "method") || utils$1.getSafeProp(this.defaults, "method") || "get").toLowerCase();
      let contextHeaders = headers && utils$1.merge(headers.common, headers[config.method]);
      headers && utils$1.forEach(methodList.concat("common"), (method) => {
        delete headers[method];
      });
      config.headers = AxiosHeaders$1.concat(contextHeaders, headers);
      const requestInterceptorChain = [];
      let synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        const transitional2 = config.transitional || transitionalDefaults;
        const legacyInterceptorReqResOrdering = transitional2 && transitional2.legacyInterceptorReqResOrdering;
        if (legacyInterceptorReqResOrdering) {
          requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        } else {
          requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        }
      });
      const responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      let promise;
      let i = 0;
      let len;
      if (!synchronousRequestInterceptors) {
        const chain = [dispatchRequest.bind(this), void 0];
        chain.unshift(...requestInterceptorChain);
        chain.push(...responseInterceptorChain);
        len = chain.length;
        promise = Promise.resolve(config);
        while (i < len) {
          promise = promise.then(chain[i++], chain[i++]);
        }
        return promise;
      }
      len = requestInterceptorChain.length;
      let newConfig = config;
      while (i < len) {
        const onFulfilled = requestInterceptorChain[i++];
        const onRejected = requestInterceptorChain[i++];
        try {
          newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
        } catch (error) {
          if (!onRejected) {
            promise = Promise.reject(error);
            break;
          }
          try {
            const rejectedResult = onRejected.call(this, error);
            if (utils$1.isThenable(rejectedResult)) {
              promise = Promise.resolve(rejectedResult).then(
                () => dispatchRequest.call(this, newConfig)
              );
            }
          } catch (rejectedError) {
            promise = Promise.reject(rejectedError);
          }
          break;
        }
      }
      if (!promise) {
        try {
          promise = dispatchRequest.call(this, newConfig);
        } catch (error) {
          promise = Promise.reject(error);
        }
      }
      i = 0;
      len = responseInterceptorChain.length;
      while (i < len) {
        promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
      }
      return promise;
    }
    getUri(config) {
      config = mergeConfig$1(this.defaults, config);
      const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls, config);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    }
  };
  utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
    Axios$1.prototype[method] = function(url, config) {
      return this.request(
        mergeConfig$1(config || {}, {
          method,
          url,
          data: config && utils$1.hasOwnProp(config, "data") ? config.data : void 0
        })
      );
    };
  });
  utils$1.forEach(["post", "put", "patch", "query"], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
      return function httpMethod(url, data, config) {
        return this.request(
          mergeConfig$1(config || {}, {
            method,
            headers: isForm ? {
              "Content-Type": "multipart/form-data"
            } : {},
            url,
            data
          })
        );
      };
    }
    Axios$1.prototype[method] = generateHTTPMethod();
    if (method !== "query") {
      Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
    }
  });
  let CancelToken$1 = class CancelToken2 {
    constructor(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      let resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve2) {
        resolvePromise = resolve2;
      });
      const token = this;
      this.promise.then((cancel) => {
        if (!token._listeners) return;
        let i = token._listeners.length;
        while (i-- > 0) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = (onfulfilled) => {
        let _resolve;
        const promise = new Promise((resolve2) => {
          token.subscribe(resolve2);
          _resolve = resolve2;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message2, config, request) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError$1(message2, config, request);
        resolvePromise(token.reason);
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      const index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    }
    toAbortSignal() {
      const controller = new AbortController();
      const abort = (err) => {
        controller.abort(err);
      };
      this.subscribe(abort);
      controller.signal.unsubscribe = () => this.unsubscribe(abort);
      return controller.signal;
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let cancel;
      const token = new CancelToken2(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    }
  };
  function spread$1(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  }
  function isAxiosError$1(payload) {
    return utils$1.isObject(payload) && payload.isAxiosError === true;
  }
  const HttpStatusCode$1 = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
     * @deprecated Use `ContentTooLarge` instead.
     */
    PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
     * @deprecated Use `UnprocessableContent` instead.
     */
    UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
  };
  Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
    if (HttpStatusCode$1[value] === void 0) {
      HttpStatusCode$1[value] = key;
    }
  });
  function createInstance(defaultConfig) {
    const context = new Axios$1(defaultConfig);
    const instance = bind(Axios$1.prototype.request, context);
    utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
    utils$1.extend(instance, context, null, { allOwnKeys: true });
    instance.create = function create2(instanceConfig) {
      return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
    };
    return instance;
  }
  const axios = createInstance(defaults);
  axios.Axios = Axios$1;
  axios.CanceledError = CanceledError$1;
  axios.CancelToken = CancelToken$1;
  axios.isCancel = isCancel$1;
  axios.VERSION = VERSION$1;
  axios.toFormData = toFormData$1;
  axios.AxiosError = AxiosError$1;
  axios.Cancel = axios.CanceledError;
  axios.all = function all2(promises) {
    return Promise.all(promises);
  };
  axios.spread = spread$1;
  axios.isAxiosError = isAxiosError$1;
  axios.mergeConfig = mergeConfig$1;
  axios.AxiosHeaders = AxiosHeaders$1;
  axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
  axios.getAdapter = adapters.getAdapter;
  axios.HttpStatusCode = HttpStatusCode$1;
  axios.default = axios;
  const {
    Axios,
    AxiosError,
    CanceledError,
    isCancel,
    CancelToken,
    VERSION,
    all,
    Cancel,
    isAxiosError,
    spread,
    toFormData,
    AxiosHeaders,
    HttpStatusCode,
    formToJSON,
    getAdapter,
    mergeConfig,
    create
  } = axios;
  const store = /* @__PURE__ */ reactive(
    {
      specialPrice: {
        byImprintMethods: {},
        // {isImprintMethodSpecial: false, }
        isProductSpecial: false,
        value: null,
        dateStart: null,
        dateEnd: null,
        tier: []
      },
      imprintStep: {
        applyToAll: {
          id: null,
          selectedColor: null,
          index: null,
          randID: null
        }
      },
      isCustomerGuest: false,
      calendar: {
        productPageTitle: "",
        productImage: "",
        productList: [],
        IsCalendar: {
          title: "Is Calendar",
          value: "Yes"
        },
        qtyVal: 25
      },
      isCustomBundlePage: false,
      storeID: "mlp_us",
      sizesQty: {},
      application_type: "default",
      // 'calendar'|'calendar_single'
      lastMaxInitedStep: 1,
      // !!!! output selected by user data
      // slectedColor currently 31.05.2023 used from colorSizeLines[]
      slectedColor: {
        id: null,
        title: "",
        img_src: ""
      },
      // TODO improve
      upchargesLines: {},
      /* TODO logic changed check to remove both variable - Should be used only one variable selectedColorsList or availableColorsList*/
      selectedColorsList: [],
      availableColorsList: [],
      hasFullSizeNames: false,
      fullSizeNameToShort: {},
      colorSizeLines: [],
      selectedLastStep: /* @__PURE__ */ Object.create(null),
      imprintMessageColorLines: [],
      totalSizesQty: {},
      mainVariantId: "",
      // 31.05.2023 currently not seted
      selectedImprint: {
        id: null,
        tabName: "",
        sku: null,
        data: null
      },
      prices: {
        // set after change imprint tab
        tier: null,
        tierMSRP: null,
        b2bTier: null,
        // resolved B2B tier array for current imprint SKU, or null
        // set if change qty, and in imprintAppSummary as we need update if imprint tab changed
        priceByQty: null,
        // if size has the upcharge prise
        priceSizeUpcharge: 0,
        priceColorUpcharge: 0,
        setup_fee: 0,
        // implement prices.setup_fee instead setupFee
        proof_fee: 0,
        image_fee: 0,
        customColourFee: 0,
        running_fee: 0
      },
      setupFee: 0,
      customColourFee: {},
      perItemFee: {
        setupFee: 0,
        customColourFee: 0,
        proof_fee: 0,
        running_fee: 0,
        image_fee: 0
      },
      // TODO can be added also imprint sku and removed from before data
      sku: {
        fee: {
          setup_fee: {
            title: "",
            val: null
          },
          custom_colour_fee: {
            title: "",
            val: null
          },
          proof_fee: {
            title: "",
            val: null
          },
          running_fee: {
            title: "",
            val: null
          },
          image_fee: {
            title: "",
            val: null
          }
        },
        imprint: {
          method: {
            title: "",
            val: null
          },
          location: {
            title: "",
            val: null
          },
          line_colors: []
        },
        color_code: false
      },
      properties: {
        product_weight: {
          title: "Product Weight",
          val: null
        }
      },
      // will be used in future, for save user information, for every imprint tabs
      historyByImprint: [
        {
          // check and rename sky to sku
          sky: null,
          totalQty: null
        }
      ],
      // !!!! input income data
      productType: "",
      inputProuctIds: {
        mainProductID: ""
      },
      inputProductData: {
        fullJson: null,
        colorVariants: {
          handle: null,
          data: null
        },
        sizeVariants: {
          handle: null,
          data: null
        },
        sizeUpcharge: {},
        colorUpcharge: {},
        imprintVariants: {
          handle: null,
          data: null
        },
        /* by default 1, seted after done init*/
        qtyIncrement: null,
        minOrderQty: null,
        associatedIds: null
      },
      disabledAddToCart: false,
      qtyError: null,
      imprintKey: null,
      disableButtonFirsStep: true,
      runningFeePerItem: 0,
      // //(uniqueColorsCount - 1) * this.store.perItemFee.running_fee; sets at src/components/imprintAppSummary.vue
      isEnvelopProduct: false
    }
  );
  const _export_sfc = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
      target[key] = val;
    }
    return target;
  };
  const _sfc_main$H = {
    props: {
      textCardTitle: String,
      textCardBody: String,
      additionalText: String,
      cStep: Number,
      isCustomBundlePage: Boolean
    },
    methods: {
      back() {
        this.$emit("backToParent");
      }
    },
    computed: {
      isComda() {
        return store.storeID.includes("comda");
      },
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      },
      customFont() {
        return this.$getCustomFontClass(store.storeID);
      },
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      }
    }
  };
  const _hoisted_1$H = { class: "c-text-card" };
  const _hoisted_2$A = { key: 0 };
  const _hoisted_3$x = ["innerHTML"];
  const _hoisted_4$u = ["innerHTML"];
  const _hoisted_5$r = {
    key: 1,
    class: "mobile-title c-text-card__title"
  };
  function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$H, [
      createBaseVNode("div", {
        class: normalizeClass(["c-text-card__title", $props.cStep >= 4 ? "c-d-between" : "", $options.customColor]),
        style: normalizeStyle(
          "font-family: " + ($options.isComda ? "Open Sans" : "museo") + ", serif;color: " + ($options.isComda ? "#0a72ba" : "#009444") + ";"
        )
      }, [
        createBaseVNode("div", null, toDisplayString($props.textCardTitle), 1),
        $props.cStep >= 4 ? (openBlock(), createElementBlock("div", _hoisted_2$A, [
          createBaseVNode("button", {
            class: normalizeClass(["cbtn-imprint-comeback", $options.customBackground]),
            onClick: _cache[0] || (_cache[0] = ($event) => $options.back())
          }, "Back to Imprint Selection", 2)
        ])) : createCommentVNode("", true)
      ], 6),
      createBaseVNode("div", {
        class: normalizeClass(["c-text-card__body", $props.cStep == 1 || $props.cStep == 3 || $props.cStep == 4 || $props.cStep == 2 && $props.isCustomBundlePage ? "add-line" : ""]),
        style: normalizeStyle($props.cStep === 2 && !$props.isCustomBundlePage ? "border-bottom: 0" : "")
      }, [
        createBaseVNode("p", {
          innerHTML: $props.textCardBody,
          class: "imprint-text"
        }, null, 8, _hoisted_3$x),
        $props.additionalText ? (openBlock(), createElementBlock("p", {
          key: 0,
          innerHTML: $props.additionalText,
          class: "imprint-text additional"
        }, null, 8, _hoisted_4$u)) : createCommentVNode("", true),
        $props.cStep == 2 ? (openBlock(), createElementBlock("div", _hoisted_5$r, toDisplayString($props.textCardTitle.replace("Choose", "")), 1)) : createCommentVNode("", true)
      ], 6)
    ]);
  }
  const CTextCard = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$D]]);
  const _sfc_main$G = {
    props: {
      cStep: Number,
      tabName: String
    },
    data() {
      return {
        store
      };
    },
    methods: {
      back() {
        this.$emit("backToParent");
      }
    },
    created() {
      console.error("++++++++++++++Requirenment component created+++++++++++++++++++++");
      console.log(this.store);
      console.log(this.store.application_type);
    },
    mounted() {
      console.error("++++++++++++++Requirenment component Mounted+++++++++++++++++++++");
      console.log(this.store);
      console.log(this.store.application_type);
    },
    computed: {
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      }
    }
  };
  const _hoisted_1$G = { key: 0 };
  const _hoisted_2$z = {
    key: 0,
    style: { "color": "red", "font-weight": "700" }
  };
  function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
    return $data.store.application_type != "calendar" && $data.store.application_type != "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_1$G, [
      $props.cStep != 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $data.store.totalSizesQty[$props.tabName] < $data.store.inputProductData.minOrderQty ? (openBlock(), createElementBlock("div", _hoisted_2$z, toDisplayString($data.store.inputProductData.minOrderQty - $data.store.totalSizesQty[$props.tabName]) + " more items until minimum quantity ", 1)) : createCommentVNode("", true),
        $data.store.totalSizesQty >= $data.store.inputProductData.minOrderQty ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass([$options.customColor]),
          style: { "font-weight": "700" }
        }, "Minimum quantity reached!", 2)) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true),
      createBaseVNode("div", null, " Minimum Order Quantity of " + toDisplayString($data.store.inputProductData.minOrderQty) + " | Mix-n-Match in Increments of " + toDisplayString($data.store.inputProductData.qtyIncrement), 1)
    ])) : createCommentVNode("", true);
  }
  const CTextCardRequrenmentRules = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$C]]);
  function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
  }
  var jquery$1 = { exports: {} };
  /*!
   * jQuery JavaScript Library v3.7.1
   * https://jquery.com/
   *
   * Copyright OpenJS Foundation and other contributors
   * Released under the MIT license
   * https://jquery.org/license
   *
   * Date: 2023-08-28T13:37Z
   */
  var jquery = jquery$1.exports;
  var hasRequiredJquery;
  function requireJquery() {
    if (hasRequiredJquery) return jquery$1.exports;
    hasRequiredJquery = 1;
    (function(module) {
      (function(global, factory2) {
        {
          module.exports = global.document ? factory2(global, true) : function(w) {
            if (!w.document) {
              throw new Error("jQuery requires a window with a document");
            }
            return factory2(w);
          };
        }
      })(typeof window !== "undefined" ? window : jquery, function(window2, noGlobal) {
        var arr = [];
        var getProto2 = Object.getPrototypeOf;
        var slice = arr.slice;
        var flat = arr.flat ? function(array) {
          return arr.flat.call(array);
        } : function(array) {
          return arr.concat.apply([], array);
        };
        var push = arr.push;
        var indexOf = arr.indexOf;
        var class2type = {};
        var toString2 = class2type.toString;
        var hasOwn2 = class2type.hasOwnProperty;
        var fnToString = hasOwn2.toString;
        var ObjectFunctionString = fnToString.call(Object);
        var support = {};
        var isFunction2 = function isFunction22(obj) {
          return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
        };
        var isWindow = function isWindow2(obj) {
          return obj != null && obj === obj.window;
        };
        var document2 = window2.document;
        var preservedScriptAttributes = {
          type: true,
          src: true,
          nonce: true,
          noModule: true
        };
        function DOMEval(code, node, doc2) {
          doc2 = doc2 || document2;
          var i, val, script = doc2.createElement("script");
          script.text = code;
          if (node) {
            for (i in preservedScriptAttributes) {
              val = node[i] || node.getAttribute && node.getAttribute(i);
              if (val) {
                script.setAttribute(i, val);
              }
            }
          }
          doc2.head.appendChild(script).parentNode.removeChild(script);
        }
        function toType(obj) {
          if (obj == null) {
            return obj + "";
          }
          return typeof obj === "object" || typeof obj === "function" ? class2type[toString2.call(obj)] || "object" : typeof obj;
        }
        var version2 = "3.7.1", rhtmlSuffix = /HTML$/i, jQuery = function(selector, context) {
          return new jQuery.fn.init(selector, context);
        };
        jQuery.fn = jQuery.prototype = {
          // The current version of jQuery being used
          jquery: version2,
          constructor: jQuery,
          // The default length of a jQuery object is 0
          length: 0,
          toArray: function() {
            return slice.call(this);
          },
          // Get the Nth element in the matched element set OR
          // Get the whole matched element set as a clean array
          get: function(num) {
            if (num == null) {
              return slice.call(this);
            }
            return num < 0 ? this[num + this.length] : this[num];
          },
          // Take an array of elements and push it onto the stack
          // (returning the new matched element set)
          pushStack: function(elems) {
            var ret = jQuery.merge(this.constructor(), elems);
            ret.prevObject = this;
            return ret;
          },
          // Execute a callback for every element in the matched set.
          each: function(callback) {
            return jQuery.each(this, callback);
          },
          map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
              return callback.call(elem, i, elem);
            }));
          },
          slice: function() {
            return this.pushStack(slice.apply(this, arguments));
          },
          first: function() {
            return this.eq(0);
          },
          last: function() {
            return this.eq(-1);
          },
          even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
              return (i + 1) % 2;
            }));
          },
          odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
              return i % 2;
            }));
          },
          eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
          },
          end: function() {
            return this.prevObject || this.constructor();
          },
          // For internal use only.
          // Behaves like an Array's method, not like a jQuery method.
          push,
          sort: arr.sort,
          splice: arr.splice
        };
        jQuery.extend = jQuery.fn.extend = function() {
          var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
          if (typeof target === "boolean") {
            deep = target;
            target = arguments[i] || {};
            i++;
          }
          if (typeof target !== "object" && !isFunction2(target)) {
            target = {};
          }
          if (i === length) {
            target = this;
            i--;
          }
          for (; i < length; i++) {
            if ((options = arguments[i]) != null) {
              for (name in options) {
                copy = options[name];
                if (name === "__proto__" || target === copy) {
                  continue;
                }
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                  src = target[name];
                  if (copyIsArray && !Array.isArray(src)) {
                    clone = [];
                  } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                    clone = {};
                  } else {
                    clone = src;
                  }
                  copyIsArray = false;
                  target[name] = jQuery.extend(deep, clone, copy);
                } else if (copy !== void 0) {
                  target[name] = copy;
                }
              }
            }
          }
          return target;
        };
        jQuery.extend({
          // Unique for each copy of jQuery on the page
          expando: "jQuery" + (version2 + Math.random()).replace(/\D/g, ""),
          // Assume jQuery is ready without the ready module
          isReady: true,
          error: function(msg) {
            throw new Error(msg);
          },
          noop: function() {
          },
          isPlainObject: function(obj) {
            var proto, Ctor;
            if (!obj || toString2.call(obj) !== "[object Object]") {
              return false;
            }
            proto = getProto2(obj);
            if (!proto) {
              return true;
            }
            Ctor = hasOwn2.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
          },
          isEmptyObject: function(obj) {
            var name;
            for (name in obj) {
              return false;
            }
            return true;
          },
          // Evaluates a script in a provided context; falls back to the global one
          // if not specified.
          globalEval: function(code, options, doc2) {
            DOMEval(code, { nonce: options && options.nonce }, doc2);
          },
          each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
              length = obj.length;
              for (; i < length; i++) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break;
                }
              }
            } else {
              for (i in obj) {
                if (callback.call(obj[i], i, obj[i]) === false) {
                  break;
                }
              }
            }
            return obj;
          },
          // Retrieve the text value of an array of DOM nodes
          text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) {
              while (node = elem[i++]) {
                ret += jQuery.text(node);
              }
            }
            if (nodeType === 1 || nodeType === 11) {
              return elem.textContent;
            }
            if (nodeType === 9) {
              return elem.documentElement.textContent;
            }
            if (nodeType === 3 || nodeType === 4) {
              return elem.nodeValue;
            }
            return ret;
          },
          // results is for internal usage only
          makeArray: function(arr2, results) {
            var ret = results || [];
            if (arr2 != null) {
              if (isArrayLike(Object(arr2))) {
                jQuery.merge(
                  ret,
                  typeof arr2 === "string" ? [arr2] : arr2
                );
              } else {
                push.call(ret, arr2);
              }
            }
            return ret;
          },
          inArray: function(elem, arr2, i) {
            return arr2 == null ? -1 : indexOf.call(arr2, elem, i);
          },
          isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
          },
          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for (; j < len; j++) {
              first[i++] = second[j];
            }
            first.length = i;
            return first;
          },
          grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            for (; i < length; i++) {
              callbackInverse = !callback(elems[i], i);
              if (callbackInverse !== callbackExpect) {
                matches.push(elems[i]);
              }
            }
            return matches;
          },
          // arg is for internal usage only
          map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            if (isArrayLike(elems)) {
              length = elems.length;
              for (; i < length; i++) {
                value = callback(elems[i], i, arg);
                if (value != null) {
                  ret.push(value);
                }
              }
            } else {
              for (i in elems) {
                value = callback(elems[i], i, arg);
                if (value != null) {
                  ret.push(value);
                }
              }
            }
            return flat(ret);
          },
          // A global GUID counter for objects
          guid: 1,
          // jQuery.support is not used in Core but other projects attach their
          // properties to it so it needs to exist.
          support
        });
        if (typeof Symbol === "function") {
          jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
        }
        jQuery.each(
          "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
          function(_i, name) {
            class2type["[object " + name + "]"] = name.toLowerCase();
          }
        );
        function isArrayLike(obj) {
          var length = !!obj && "length" in obj && obj.length, type = toType(obj);
          if (isFunction2(obj) || isWindow(obj)) {
            return false;
          }
          return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
        }
        function nodeName(elem, name) {
          return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
        }
        var pop = arr.pop;
        var sort = arr.sort;
        var splice = arr.splice;
        var whitespace = "[\\x20\\t\\r\\n\\f]";
        var rtrimCSS = new RegExp(
          "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
          "g"
        );
        jQuery.contains = function(a, b) {
          var bup = b && b.parentNode;
          return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
          // IE doesn't have `contains` on SVG.
          (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        };
        var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
        function fcssescape(ch, asCodePoint) {
          if (asCodePoint) {
            if (ch === "\0") {
              return "�";
            }
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
          }
          return "\\" + ch;
        }
        jQuery.escapeSelector = function(sel) {
          return (sel + "").replace(rcssescape, fcssescape);
        };
        var preferredDoc = document2, pushNative = push;
        (function() {
          var i, Expr, outermostContext, sortInput, hasDuplicate, push2 = pushNative, document22, documentElement2, documentIsHTML, rbuggyQSA, matches, expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) {
              hasDuplicate = true;
            }
            return 0;
          }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
          "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
          `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp(
              "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)",
              "i"
            ),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
          }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 65536;
            if (nonHex) {
              return nonHex;
            }
            return high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
          }, unloadHandler = function() {
            setDocument();
          }, inDisabledFieldset = addCombinator(
            function(elem) {
              return elem.disabled === true && nodeName(elem, "fieldset");
            },
            { dir: "parentNode", next: "legend" }
          );
          function safeActiveElement() {
            try {
              return document22.activeElement;
            } catch (err) {
            }
          }
          try {
            push2.apply(
              arr = slice.call(preferredDoc.childNodes),
              preferredDoc.childNodes
            );
            arr[preferredDoc.childNodes.length].nodeType;
          } catch (e) {
            push2 = {
              apply: function(target, els) {
                pushNative.apply(target, slice.call(els));
              },
              call: function(target) {
                pushNative.apply(target, slice.call(arguments, 1));
              }
            };
          }
          function find(selector, context, results, seed) {
            var m, i2, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, nodeType = context ? context.nodeType : 9;
            results = results || [];
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
              return results;
            }
            if (!seed) {
              setDocument(context);
              context = context || document22;
              if (documentIsHTML) {
                if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
                  if (m = match[1]) {
                    if (nodeType === 9) {
                      if (elem = context.getElementById(m)) {
                        if (elem.id === m) {
                          push2.call(results, elem);
                          return results;
                        }
                      } else {
                        return results;
                      }
                    } else {
                      if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                        push2.call(results, elem);
                        return results;
                      }
                    }
                  } else if (match[2]) {
                    push2.apply(results, context.getElementsByTagName(selector));
                    return results;
                  } else if ((m = match[3]) && context.getElementsByClassName) {
                    push2.apply(results, context.getElementsByClassName(m));
                    return results;
                  }
                }
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                  newSelector = selector;
                  newContext = context;
                  if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                    newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                    if (newContext != context || !support.scope) {
                      if (nid = context.getAttribute("id")) {
                        nid = jQuery.escapeSelector(nid);
                      } else {
                        context.setAttribute("id", nid = expando);
                      }
                    }
                    groups = tokenize(selector);
                    i2 = groups.length;
                    while (i2--) {
                      groups[i2] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i2]);
                    }
                    newSelector = groups.join(",");
                  }
                  try {
                    push2.apply(
                      results,
                      newContext.querySelectorAll(newSelector)
                    );
                    return results;
                  } catch (qsaError) {
                    nonnativeSelectorCache(selector, true);
                  } finally {
                    if (nid === expando) {
                      context.removeAttribute("id");
                    }
                  }
                }
              }
            }
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
          }
          function createCache() {
            var keys = [];
            function cache(key, value) {
              if (keys.push(key + " ") > Expr.cacheLength) {
                delete cache[keys.shift()];
              }
              return cache[key + " "] = value;
            }
            return cache;
          }
          function markFunction(fn) {
            fn[expando] = true;
            return fn;
          }
          function assert(fn) {
            var el = document22.createElement("fieldset");
            try {
              return !!fn(el);
            } catch (e) {
              return false;
            } finally {
              if (el.parentNode) {
                el.parentNode.removeChild(el);
              }
              el = null;
            }
          }
          function createInputPseudo(type) {
            return function(elem) {
              return nodeName(elem, "input") && elem.type === type;
            };
          }
          function createButtonPseudo(type) {
            return function(elem) {
              return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
          }
          function createDisabledPseudo(disabled) {
            return function(elem) {
              if ("form" in elem) {
                if (elem.parentNode && elem.disabled === false) {
                  if ("label" in elem) {
                    if ("label" in elem.parentNode) {
                      return elem.parentNode.disabled === disabled;
                    } else {
                      return elem.disabled === disabled;
                    }
                  }
                  return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                  elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
              } else if ("label" in elem) {
                return elem.disabled === disabled;
              }
              return false;
            };
          }
          function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
              argument = +argument;
              return markFunction(function(seed, matches2) {
                var j, matchIndexes = fn([], seed.length, argument), i2 = matchIndexes.length;
                while (i2--) {
                  if (seed[j = matchIndexes[i2]]) {
                    seed[j] = !(matches2[j] = seed[j]);
                  }
                }
              });
            });
          }
          function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
          }
          function setDocument(node) {
            var subWindow, doc2 = node ? node.ownerDocument || node : preferredDoc;
            if (doc2 == document22 || doc2.nodeType !== 9 || !doc2.documentElement) {
              return document22;
            }
            document22 = doc2;
            documentElement2 = document22.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document22);
            matches = documentElement2.matches || documentElement2.webkitMatchesSelector || documentElement2.msMatchesSelector;
            if (documentElement2.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document22 && (subWindow = document22.defaultView) && subWindow.top !== subWindow) {
              subWindow.addEventListener("unload", unloadHandler);
            }
            support.getById = assert(function(el) {
              documentElement2.appendChild(el).id = jQuery.expando;
              return !document22.getElementsByName || !document22.getElementsByName(jQuery.expando).length;
            });
            support.disconnectedMatch = assert(function(el) {
              return matches.call(el, "*");
            });
            support.scope = assert(function() {
              return document22.querySelectorAll(":scope");
            });
            support.cssHas = assert(function() {
              try {
                document22.querySelector(":has(*,:jqfake)");
                return false;
              } catch (e) {
                return true;
              }
            });
            if (support.getById) {
              Expr.filter.ID = function(id) {
                var attrId = id.replace(runescape, funescape);
                return function(elem) {
                  return elem.getAttribute("id") === attrId;
                };
              };
              Expr.find.ID = function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                  var elem = context.getElementById(id);
                  return elem ? [elem] : [];
                }
              };
            } else {
              Expr.filter.ID = function(id) {
                var attrId = id.replace(runescape, funescape);
                return function(elem) {
                  var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                  return node2 && node2.value === attrId;
                };
              };
              Expr.find.ID = function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                  var node2, i2, elems, elem = context.getElementById(id);
                  if (elem) {
                    node2 = elem.getAttributeNode("id");
                    if (node2 && node2.value === id) {
                      return [elem];
                    }
                    elems = context.getElementsByName(id);
                    i2 = 0;
                    while (elem = elems[i2++]) {
                      node2 = elem.getAttributeNode("id");
                      if (node2 && node2.value === id) {
                        return [elem];
                      }
                    }
                  }
                  return [];
                }
              };
            }
            Expr.find.TAG = function(tag, context) {
              if (typeof context.getElementsByTagName !== "undefined") {
                return context.getElementsByTagName(tag);
              } else {
                return context.querySelectorAll(tag);
              }
            };
            Expr.find.CLASS = function(className, context) {
              if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
                return context.getElementsByClassName(className);
              }
            };
            rbuggyQSA = [];
            assert(function(el) {
              var input;
              documentElement2.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a><select id='" + expando + "-\r\\' disabled='disabled'><option selected=''></option></select>";
              if (!el.querySelectorAll("[selected]").length) {
                rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
              }
              if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                rbuggyQSA.push("~=");
              }
              if (!el.querySelectorAll("a#" + expando + "+*").length) {
                rbuggyQSA.push(".#.+[+~]");
              }
              if (!el.querySelectorAll(":checked").length) {
                rbuggyQSA.push(":checked");
              }
              input = document22.createElement("input");
              input.setAttribute("type", "hidden");
              el.appendChild(input).setAttribute("name", "D");
              documentElement2.appendChild(el).disabled = true;
              if (el.querySelectorAll(":disabled").length !== 2) {
                rbuggyQSA.push(":enabled", ":disabled");
              }
              input = document22.createElement("input");
              input.setAttribute("name", "");
              el.appendChild(input);
              if (!el.querySelectorAll("[name='']").length) {
                rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + `*(?:''|"")`);
              }
            });
            if (!support.cssHas) {
              rbuggyQSA.push(":has");
            }
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            sortOrder = function(a, b) {
              if (a === b) {
                hasDuplicate = true;
                return 0;
              }
              var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
              if (compare) {
                return compare;
              }
              compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : (
                // Otherwise we know they are disconnected
                1
              );
              if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                if (a === document22 || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
                  return -1;
                }
                if (b === document22 || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
                  return 1;
                }
                return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
              }
              return compare & 4 ? -1 : 1;
            };
            return document22;
          }
          find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
          };
          find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
              try {
                var ret = matches.call(elem, expr);
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) {
                  return ret;
                }
              } catch (e) {
                nonnativeSelectorCache(expr, true);
              }
            }
            return find(expr, document22, null, [elem]).length > 0;
          };
          find.contains = function(context, elem) {
            if ((context.ownerDocument || context) != document22) {
              setDocument(context);
            }
            return jQuery.contains(context, elem);
          };
          find.attr = function(elem, name) {
            if ((elem.ownerDocument || elem) != document22) {
              setDocument(elem);
            }
            var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn2.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : void 0;
            if (val !== void 0) {
              return val;
            }
            return elem.getAttribute(name);
          };
          find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
          };
          jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i2 = 0;
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
              while (elem = results[i2++]) {
                if (elem === results[i2]) {
                  j = duplicates.push(i2);
                }
              }
              while (j--) {
                splice.call(results, duplicates[j], 1);
              }
            }
            sortInput = null;
            return results;
          };
          jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
          };
          Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
              ">": { dir: "parentNode", first: true },
              " ": { dir: "parentNode" },
              "+": { dir: "previousSibling", first: true },
              "~": { dir: "previousSibling" }
            },
            preFilter: {
              ATTR: function(match) {
                match[1] = match[1].replace(runescape, funescape);
                match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                if (match[2] === "~=") {
                  match[3] = " " + match[3] + " ";
                }
                return match.slice(0, 4);
              },
              CHILD: function(match) {
                match[1] = match[1].toLowerCase();
                if (match[1].slice(0, 3) === "nth") {
                  if (!match[3]) {
                    find.error(match[0]);
                  }
                  match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                  match[5] = +(match[7] + match[8] || match[3] === "odd");
                } else if (match[3]) {
                  find.error(match[0]);
                }
                return match;
              },
              PSEUDO: function(match) {
                var excess, unquoted = !match[6] && match[2];
                if (matchExpr.CHILD.test(match[0])) {
                  return null;
                }
                if (match[3]) {
                  match[2] = match[4] || match[5] || "";
                } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                  match[0] = match[0].slice(0, excess);
                  match[2] = unquoted.slice(0, excess);
                }
                return match.slice(0, 3);
              }
            },
            filter: {
              TAG: function(nodeNameSelector) {
                var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                  return true;
                } : function(elem) {
                  return nodeName(elem, expectedNodeName);
                };
              },
              CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
                  return pattern.test(
                    typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || ""
                  );
                });
              },
              ATTR: function(name, operator, check) {
                return function(elem) {
                  var result = find.attr(elem, name);
                  if (result == null) {
                    return operator === "!=";
                  }
                  if (!operator) {
                    return true;
                  }
                  result += "";
                  if (operator === "=") {
                    return result === check;
                  }
                  if (operator === "!=") {
                    return result !== check;
                  }
                  if (operator === "^=") {
                    return check && result.indexOf(check) === 0;
                  }
                  if (operator === "*=") {
                    return check && result.indexOf(check) > -1;
                  }
                  if (operator === "$=") {
                    return check && result.slice(-check.length) === check;
                  }
                  if (operator === "~=") {
                    return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                  }
                  if (operator === "|=") {
                    return result === check || result.slice(0, check.length + 1) === check + "-";
                  }
                  return false;
                };
              },
              CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? (
                  // Shortcut for :nth-*(n)
                  (function(elem) {
                    return !!elem.parentNode;
                  })
                ) : function(elem, _context, xml) {
                  var cache, outerCache, node, nodeIndex, start, dir2 = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                  if (parent) {
                    if (simple) {
                      while (dir2) {
                        node = elem;
                        while (node = node[dir2]) {
                          if (ofType ? nodeName(node, name) : node.nodeType === 1) {
                            return false;
                          }
                        }
                        start = dir2 = type === "only" && !start && "nextSibling";
                      }
                      return true;
                    }
                    start = [forward ? parent.firstChild : parent.lastChild];
                    if (forward && useCache) {
                      outerCache = parent[expando] || (parent[expando] = {});
                      cache = outerCache[type] || [];
                      nodeIndex = cache[0] === dirruns && cache[1];
                      diff = nodeIndex && cache[2];
                      node = nodeIndex && parent.childNodes[nodeIndex];
                      while (node = ++nodeIndex && node && node[dir2] || // Fallback to seeking `elem` from the start
                      (diff = nodeIndex = 0) || start.pop()) {
                        if (node.nodeType === 1 && ++diff && node === elem) {
                          outerCache[type] = [dirruns, nodeIndex, diff];
                          break;
                        }
                      }
                    } else {
                      if (useCache) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        cache = outerCache[type] || [];
                        nodeIndex = cache[0] === dirruns && cache[1];
                        diff = nodeIndex;
                      }
                      if (diff === false) {
                        while (node = ++nodeIndex && node && node[dir2] || (diff = nodeIndex = 0) || start.pop()) {
                          if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                            if (useCache) {
                              outerCache = node[expando] || (node[expando] = {});
                              outerCache[type] = [dirruns, diff];
                            }
                            if (node === elem) {
                              break;
                            }
                          }
                        }
                      }
                    }
                    diff -= last;
                    return diff === first || diff % first === 0 && diff / first >= 0;
                  }
                };
              },
              PSEUDO: function(pseudo, argument) {
                var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                if (fn[expando]) {
                  return fn(argument);
                }
                if (fn.length > 1) {
                  args = [pseudo, pseudo, "", argument];
                  return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
                    var idx, matched = fn(seed, argument), i2 = matched.length;
                    while (i2--) {
                      idx = indexOf.call(seed, matched[i2]);
                      seed[idx] = !(matches2[idx] = matched[i2]);
                    }
                  }) : function(elem) {
                    return fn(elem, 0, args);
                  };
                }
                return fn;
              }
            },
            pseudos: {
              // Potentially complex pseudos
              not: markFunction(function(selector) {
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[expando] ? markFunction(function(seed, matches2, _context, xml) {
                  var elem, unmatched = matcher(seed, null, xml, []), i2 = seed.length;
                  while (i2--) {
                    if (elem = unmatched[i2]) {
                      seed[i2] = !(matches2[i2] = elem);
                    }
                  }
                }) : function(elem, _context, xml) {
                  input[0] = elem;
                  matcher(input, null, xml, results);
                  input[0] = null;
                  return !results.pop();
                };
              }),
              has: markFunction(function(selector) {
                return function(elem) {
                  return find(selector, elem).length > 0;
                };
              }),
              contains: markFunction(function(text) {
                text = text.replace(runescape, funescape);
                return function(elem) {
                  return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
              }),
              // "Whether an element is represented by a :lang() selector
              // is based solely on the element's language value
              // being equal to the identifier C,
              // or beginning with the identifier C immediately followed by "-".
              // The matching of C against the element's language value is performed case-insensitively.
              // The identifier C does not have to be a valid language name."
              // https://www.w3.org/TR/selectors/#lang-pseudo
              lang: markFunction(function(lang) {
                if (!ridentifier.test(lang || "")) {
                  find.error("unsupported lang: " + lang);
                }
                lang = lang.replace(runescape, funescape).toLowerCase();
                return function(elem) {
                  var elemLang;
                  do {
                    if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                      elemLang = elemLang.toLowerCase();
                      return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                  } while ((elem = elem.parentNode) && elem.nodeType === 1);
                  return false;
                };
              }),
              // Miscellaneous
              target: function(elem) {
                var hash = window2.location && window2.location.hash;
                return hash && hash.slice(1) === elem.id;
              },
              root: function(elem) {
                return elem === documentElement2;
              },
              focus: function(elem) {
                return elem === safeActiveElement() && document22.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
              },
              // Boolean properties
              enabled: createDisabledPseudo(false),
              disabled: createDisabledPseudo(true),
              checked: function(elem) {
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
              },
              selected: function(elem) {
                if (elem.parentNode) {
                  elem.parentNode.selectedIndex;
                }
                return elem.selected === true;
              },
              // Contents
              empty: function(elem) {
                for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                  if (elem.nodeType < 6) {
                    return false;
                  }
                }
                return true;
              },
              parent: function(elem) {
                return !Expr.pseudos.empty(elem);
              },
              // Element/input types
              header: function(elem) {
                return rheader.test(elem.nodeName);
              },
              input: function(elem) {
                return rinputs.test(elem.nodeName);
              },
              button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
              },
              text: function(elem) {
                var attr;
                return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                // New HTML5 attribute values (e.g., "search") appear
                // with elem.type === "text"
                ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
              },
              // Position-in-collection
              first: createPositionalPseudo(function() {
                return [0];
              }),
              last: createPositionalPseudo(function(_matchIndexes, length) {
                return [length - 1];
              }),
              eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [argument < 0 ? argument + length : argument];
              }),
              even: createPositionalPseudo(function(matchIndexes, length) {
                var i2 = 0;
                for (; i2 < length; i2 += 2) {
                  matchIndexes.push(i2);
                }
                return matchIndexes;
              }),
              odd: createPositionalPseudo(function(matchIndexes, length) {
                var i2 = 1;
                for (; i2 < length; i2 += 2) {
                  matchIndexes.push(i2);
                }
                return matchIndexes;
              }),
              lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i2;
                if (argument < 0) {
                  i2 = argument + length;
                } else if (argument > length) {
                  i2 = length;
                } else {
                  i2 = argument;
                }
                for (; --i2 >= 0; ) {
                  matchIndexes.push(i2);
                }
                return matchIndexes;
              }),
              gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i2 = argument < 0 ? argument + length : argument;
                for (; ++i2 < length; ) {
                  matchIndexes.push(i2);
                }
                return matchIndexes;
              })
            }
          };
          Expr.pseudos.nth = Expr.pseudos.eq;
          for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
            Expr.pseudos[i] = createInputPseudo(i);
          }
          for (i in { submit: true, reset: true }) {
            Expr.pseudos[i] = createButtonPseudo(i);
          }
          function setFilters() {
          }
          setFilters.prototype = Expr.filters = Expr.pseudos;
          Expr.setFilters = new setFilters();
          function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) {
              return parseOnly ? 0 : cached.slice(0);
            }
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while (soFar) {
              if (!matched || (match = rcomma.exec(soFar))) {
                if (match) {
                  soFar = soFar.slice(match[0].length) || soFar;
                }
                groups.push(tokens = []);
              }
              matched = false;
              if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                  value: matched,
                  // Cast descendant combinators to space
                  type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
              }
              for (type in Expr.filter) {
                if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                  matched = match.shift();
                  tokens.push({
                    value: matched,
                    type,
                    matches: match
                  });
                  soFar = soFar.slice(matched.length);
                }
              }
              if (!matched) {
                break;
              }
            }
            if (parseOnly) {
              return soFar.length;
            }
            return soFar ? find.error(selector) : (
              // Cache the tokens
              tokenCache(selector, groups).slice(0)
            );
          }
          function toSelector(tokens) {
            var i2 = 0, len = tokens.length, selector = "";
            for (; i2 < len; i2++) {
              selector += tokens[i2].value;
            }
            return selector;
          }
          function addCombinator(matcher, combinator, base) {
            var dir2 = combinator.dir, skip = combinator.next, key = skip || dir2, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? (
              // Check against closest ancestor/preceding element
              (function(elem, context, xml) {
                while (elem = elem[dir2]) {
                  if (elem.nodeType === 1 || checkNonElements) {
                    return matcher(elem, context, xml);
                  }
                }
                return false;
              })
            ) : (
              // Check against all ancestor/preceding elements
              (function(elem, context, xml) {
                var oldCache, outerCache, newCache = [dirruns, doneName];
                if (xml) {
                  while (elem = elem[dir2]) {
                    if (elem.nodeType === 1 || checkNonElements) {
                      if (matcher(elem, context, xml)) {
                        return true;
                      }
                    }
                  }
                } else {
                  while (elem = elem[dir2]) {
                    if (elem.nodeType === 1 || checkNonElements) {
                      outerCache = elem[expando] || (elem[expando] = {});
                      if (skip && nodeName(elem, skip)) {
                        elem = elem[dir2] || elem;
                      } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                        return newCache[2] = oldCache[2];
                      } else {
                        outerCache[key] = newCache;
                        if (newCache[2] = matcher(elem, context, xml)) {
                          return true;
                        }
                      }
                    }
                  }
                }
                return false;
              })
            );
          }
          function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
              var i2 = matchers.length;
              while (i2--) {
                if (!matchers[i2](elem, context, xml)) {
                  return false;
                }
              }
              return true;
            } : matchers[0];
          }
          function multipleContexts(selector, contexts, results) {
            var i2 = 0, len = contexts.length;
            for (; i2 < len; i2++) {
              find(selector, contexts[i2], results);
            }
            return results;
          }
          function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i2 = 0, len = unmatched.length, mapped = map != null;
            for (; i2 < len; i2++) {
              if (elem = unmatched[i2]) {
                if (!filter || filter(elem, context, xml)) {
                  newUnmatched.push(elem);
                  if (mapped) {
                    map.push(i2);
                  }
                }
              }
            }
            return newUnmatched;
          }
          function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) {
              postFilter = setMatcher(postFilter);
            }
            if (postFinder && !postFinder[expando]) {
              postFinder = setMatcher(postFinder, postSelector);
            }
            return markFunction(function(seed, results, context, xml) {
              var temp, i2, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(
                selector || "*",
                context.nodeType ? [context] : context,
                []
              ), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
              if (matcher) {
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? (
                  // ...intermediate processing is necessary
                  []
                ) : (
                  // ...otherwise use results directly
                  results
                );
                matcher(matcherIn, matcherOut, context, xml);
              } else {
                matcherOut = matcherIn;
              }
              if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                i2 = temp.length;
                while (i2--) {
                  if (elem = temp[i2]) {
                    matcherOut[postMap[i2]] = !(matcherIn[postMap[i2]] = elem);
                  }
                }
              }
              if (seed) {
                if (postFinder || preFilter) {
                  if (postFinder) {
                    temp = [];
                    i2 = matcherOut.length;
                    while (i2--) {
                      if (elem = matcherOut[i2]) {
                        temp.push(matcherIn[i2] = elem);
                      }
                    }
                    postFinder(null, matcherOut = [], temp, xml);
                  }
                  i2 = matcherOut.length;
                  while (i2--) {
                    if ((elem = matcherOut[i2]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i2]) > -1) {
                      seed[temp] = !(results[temp] = elem);
                    }
                  }
                }
              } else {
                matcherOut = condense(
                  matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
                );
                if (postFinder) {
                  postFinder(null, results, matcherOut, xml);
                } else {
                  push2.apply(results, matcherOut);
                }
              }
            });
          }
          function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i2 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
              return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
              return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [function(elem, context, xml) {
              var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
              checkContext = null;
              return ret;
            }];
            for (; i2 < len; i2++) {
              if (matcher = Expr.relative[tokens[i2].type]) {
                matchers = [addCombinator(elementMatcher(matchers), matcher)];
              } else {
                matcher = Expr.filter[tokens[i2].type].apply(null, tokens[i2].matches);
                if (matcher[expando]) {
                  j = ++i2;
                  for (; j < len; j++) {
                    if (Expr.relative[tokens[j].type]) {
                      break;
                    }
                  }
                  return setMatcher(
                    i2 > 1 && elementMatcher(matchers),
                    i2 > 1 && toSelector(
                      // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                      tokens.slice(0, i2 - 1).concat({ value: tokens[i2 - 2].type === " " ? "*" : "" })
                    ).replace(rtrimCSS, "$1"),
                    matcher,
                    i2 < j && matcherFromTokens(tokens.slice(i2, j)),
                    j < len && matcherFromTokens(tokens = tokens.slice(j)),
                    j < len && toSelector(tokens)
                  );
                }
                matchers.push(matcher);
              }
            }
            return elementMatcher(matchers);
          }
          function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
              var elem, j, matcher, matchedCount = 0, i2 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
              if (outermost) {
                outermostContext = context == document22 || context || outermost;
              }
              for (; i2 !== len && (elem = elems[i2]) != null; i2++) {
                if (byElement && elem) {
                  j = 0;
                  if (!context && elem.ownerDocument != document22) {
                    setDocument(elem);
                    xml = !documentIsHTML;
                  }
                  while (matcher = elementMatchers[j++]) {
                    if (matcher(elem, context || document22, xml)) {
                      push2.call(results, elem);
                      break;
                    }
                  }
                  if (outermost) {
                    dirruns = dirrunsUnique;
                  }
                }
                if (bySet) {
                  if (elem = !matcher && elem) {
                    matchedCount--;
                  }
                  if (seed) {
                    unmatched.push(elem);
                  }
                }
              }
              matchedCount += i2;
              if (bySet && i2 !== matchedCount) {
                j = 0;
                while (matcher = setMatchers[j++]) {
                  matcher(unmatched, setMatched, context, xml);
                }
                if (seed) {
                  if (matchedCount > 0) {
                    while (i2--) {
                      if (!(unmatched[i2] || setMatched[i2])) {
                        setMatched[i2] = pop.call(results);
                      }
                    }
                  }
                  setMatched = condense(setMatched);
                }
                push2.apply(results, setMatched);
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
                  jQuery.uniqueSort(results);
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
              }
              return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
          }
          function compile(selector, match) {
            var i2, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
              if (!match) {
                match = tokenize(selector);
              }
              i2 = match.length;
              while (i2--) {
                cached = matcherFromTokens(match[i2]);
                if (cached[expando]) {
                  setMatchers.push(cached);
                } else {
                  elementMatchers.push(cached);
                }
              }
              cached = compilerCache(
                selector,
                matcherFromGroupMatchers(elementMatchers, setMatchers)
              );
              cached.selector = selector;
            }
            return cached;
          }
          function select(selector, context, results, seed) {
            var i2, tokens, token, type, find2, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            if (match.length === 1) {
              tokens = match[0] = match[0].slice(0);
              if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                context = (Expr.find.ID(
                  token.matches[0].replace(runescape, funescape),
                  context
                ) || [])[0];
                if (!context) {
                  return results;
                } else if (compiled) {
                  context = context.parentNode;
                }
                selector = selector.slice(tokens.shift().value.length);
              }
              i2 = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
              while (i2--) {
                token = tokens[i2];
                if (Expr.relative[type = token.type]) {
                  break;
                }
                if (find2 = Expr.find[type]) {
                  if (seed = find2(
                    token.matches[0].replace(runescape, funescape),
                    rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
                  )) {
                    tokens.splice(i2, 1);
                    selector = seed.length && toSelector(tokens);
                    if (!selector) {
                      push2.apply(results, seed);
                      return results;
                    }
                    break;
                  }
                }
              }
            }
            (compiled || compile(selector, match))(
              seed,
              context,
              !documentIsHTML,
              results,
              !context || rsibling.test(selector) && testContext(context.parentNode) || context
            );
            return results;
          }
          support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
          setDocument();
          support.sortDetached = assert(function(el) {
            return el.compareDocumentPosition(document22.createElement("fieldset")) & 1;
          });
          jQuery.find = find;
          jQuery.expr[":"] = jQuery.expr.pseudos;
          jQuery.unique = jQuery.uniqueSort;
          find.compile = compile;
          find.select = select;
          find.setDocument = setDocument;
          find.tokenize = tokenize;
          find.escape = jQuery.escapeSelector;
          find.getText = jQuery.text;
          find.isXML = jQuery.isXMLDoc;
          find.selectors = jQuery.expr;
          find.support = jQuery.support;
          find.uniqueSort = jQuery.uniqueSort;
        })();
        var dir = function(elem, dir2, until) {
          var matched = [], truncate = until !== void 0;
          while ((elem = elem[dir2]) && elem.nodeType !== 9) {
            if (elem.nodeType === 1) {
              if (truncate && jQuery(elem).is(until)) {
                break;
              }
              matched.push(elem);
            }
          }
          return matched;
        };
        var siblings = function(n, elem) {
          var matched = [];
          for (; n; n = n.nextSibling) {
            if (n.nodeType === 1 && n !== elem) {
              matched.push(n);
            }
          }
          return matched;
        };
        var rneedsContext = jQuery.expr.match.needsContext;
        var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function winnow(elements, qualifier, not) {
          if (isFunction2(qualifier)) {
            return jQuery.grep(elements, function(elem, i) {
              return !!qualifier.call(elem, i, elem) !== not;
            });
          }
          if (qualifier.nodeType) {
            return jQuery.grep(elements, function(elem) {
              return elem === qualifier !== not;
            });
          }
          if (typeof qualifier !== "string") {
            return jQuery.grep(elements, function(elem) {
              return indexOf.call(qualifier, elem) > -1 !== not;
            });
          }
          return jQuery.filter(qualifier, elements, not);
        }
        jQuery.filter = function(expr, elems, not) {
          var elem = elems[0];
          if (not) {
            expr = ":not(" + expr + ")";
          }
          if (elems.length === 1 && elem.nodeType === 1) {
            return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
          }
          return jQuery.find.matches(expr, jQuery.grep(elems, function(elem2) {
            return elem2.nodeType === 1;
          }));
        };
        jQuery.fn.extend({
          find: function(selector) {
            var i, ret, len = this.length, self2 = this;
            if (typeof selector !== "string") {
              return this.pushStack(jQuery(selector).filter(function() {
                for (i = 0; i < len; i++) {
                  if (jQuery.contains(self2[i], this)) {
                    return true;
                  }
                }
              }));
            }
            ret = this.pushStack([]);
            for (i = 0; i < len; i++) {
              jQuery.find(selector, self2[i], ret);
            }
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
          },
          filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
          },
          not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
          },
          is: function(selector) {
            return !!winnow(
              this,
              // If this is a positional/relative selector, check membership in the returned set
              // so $("p:first").is("p:last") won't return true for a doc with two "p".
              typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [],
              false
            ).length;
          }
        });
        var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
          var match, elem;
          if (!selector) {
            return this;
          }
          root = root || rootjQuery;
          if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
              match = [null, selector, null];
            } else {
              match = rquickExpr.exec(selector);
            }
            if (match && (match[1] || !context)) {
              if (match[1]) {
                context = context instanceof jQuery ? context[0] : context;
                jQuery.merge(this, jQuery.parseHTML(
                  match[1],
                  context && context.nodeType ? context.ownerDocument || context : document2,
                  true
                ));
                if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                  for (match in context) {
                    if (isFunction2(this[match])) {
                      this[match](context[match]);
                    } else {
                      this.attr(match, context[match]);
                    }
                  }
                }
                return this;
              } else {
                elem = document2.getElementById(match[2]);
                if (elem) {
                  this[0] = elem;
                  this.length = 1;
                }
                return this;
              }
            } else if (!context || context.jquery) {
              return (context || root).find(selector);
            } else {
              return this.constructor(context).find(selector);
            }
          } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
          } else if (isFunction2(selector)) {
            return root.ready !== void 0 ? root.ready(selector) : (
              // Execute immediately if ready is not present
              selector(jQuery)
            );
          }
          return jQuery.makeArray(selector, this);
        };
        init.prototype = jQuery.fn;
        rootjQuery = jQuery(document2);
        var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
          children: true,
          contents: true,
          next: true,
          prev: true
        };
        jQuery.fn.extend({
          has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
              var i = 0;
              for (; i < l; i++) {
                if (jQuery.contains(this, targets[i])) {
                  return true;
                }
              }
            });
          },
          closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            if (!rneedsContext.test(selectors)) {
              for (; i < l; i++) {
                for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
                  if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : (
                    // Don't pass non-elements to jQuery#find
                    cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors)
                  ))) {
                    matched.push(cur);
                    break;
                  }
                }
              }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
          },
          // Determine the position of an element within the set
          index: function(elem) {
            if (!elem) {
              return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            }
            if (typeof elem === "string") {
              return indexOf.call(jQuery(elem), this[0]);
            }
            return indexOf.call(
              this,
              // If it receives a jQuery object, the first element is used
              elem.jquery ? elem[0] : elem
            );
          },
          add: function(selector, context) {
            return this.pushStack(
              jQuery.uniqueSort(
                jQuery.merge(this.get(), jQuery(selector, context))
              )
            );
          },
          addBack: function(selector) {
            return this.add(
              selector == null ? this.prevObject : this.prevObject.filter(selector)
            );
          }
        });
        function sibling(cur, dir2) {
          while ((cur = cur[dir2]) && cur.nodeType !== 1) {
          }
          return cur;
        }
        jQuery.each({
          parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
          },
          parents: function(elem) {
            return dir(elem, "parentNode");
          },
          parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
          },
          next: function(elem) {
            return sibling(elem, "nextSibling");
          },
          prev: function(elem) {
            return sibling(elem, "previousSibling");
          },
          nextAll: function(elem) {
            return dir(elem, "nextSibling");
          },
          prevAll: function(elem) {
            return dir(elem, "previousSibling");
          },
          nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
          },
          prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
          },
          siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
          },
          children: function(elem) {
            return siblings(elem.firstChild);
          },
          contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto2(elem.contentDocument)) {
              return elem.contentDocument;
            }
            if (nodeName(elem, "template")) {
              elem = elem.content || elem;
            }
            return jQuery.merge([], elem.childNodes);
          }
        }, function(name, fn) {
          jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") {
              selector = until;
            }
            if (selector && typeof selector === "string") {
              matched = jQuery.filter(selector, matched);
            }
            if (this.length > 1) {
              if (!guaranteedUnique[name]) {
                jQuery.uniqueSort(matched);
              }
              if (rparentsprev.test(name)) {
                matched.reverse();
              }
            }
            return this.pushStack(matched);
          };
        });
        var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
        function createOptions(options) {
          var object = {};
          jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
          });
          return object;
        }
        jQuery.Callbacks = function(options) {
          options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
          var firing, memory, fired, locked, list = [], queue2 = [], firingIndex = -1, fire = function() {
            locked = locked || options.once;
            fired = firing = true;
            for (; queue2.length; firingIndex = -1) {
              memory = queue2.shift();
              while (++firingIndex < list.length) {
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                  firingIndex = list.length;
                  memory = false;
                }
              }
            }
            if (!options.memory) {
              memory = false;
            }
            firing = false;
            if (locked) {
              if (memory) {
                list = [];
              } else {
                list = "";
              }
            }
          }, self2 = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
              if (list) {
                if (memory && !firing) {
                  firingIndex = list.length - 1;
                  queue2.push(memory);
                }
                (function add(args) {
                  jQuery.each(args, function(_, arg) {
                    if (isFunction2(arg)) {
                      if (!options.unique || !self2.has(arg)) {
                        list.push(arg);
                      }
                    } else if (arg && arg.length && toType(arg) !== "string") {
                      add(arg);
                    }
                  });
                })(arguments);
                if (memory && !firing) {
                  fire();
                }
              }
              return this;
            },
            // Remove a callback from the list
            remove: function() {
              jQuery.each(arguments, function(_, arg) {
                var index;
                while ((index = jQuery.inArray(arg, list, index)) > -1) {
                  list.splice(index, 1);
                  if (index <= firingIndex) {
                    firingIndex--;
                  }
                }
              });
              return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
              return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
              if (list) {
                list = [];
              }
              return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
              locked = queue2 = [];
              list = memory = "";
              return this;
            },
            disabled: function() {
              return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
              locked = queue2 = [];
              if (!memory && !firing) {
                list = memory = "";
              }
              return this;
            },
            locked: function() {
              return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
              if (!locked) {
                args = args || [];
                args = [context, args.slice ? args.slice() : args];
                queue2.push(args);
                if (!firing) {
                  fire();
                }
              }
              return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
              self2.fireWith(this, arguments);
              return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
              return !!fired;
            }
          };
          return self2;
        };
        function Identity(v) {
          return v;
        }
        function Thrower(ex) {
          throw ex;
        }
        function adoptValue(value, resolve2, reject, noValue) {
          var method;
          try {
            if (value && isFunction2(method = value.promise)) {
              method.call(value).done(resolve2).fail(reject);
            } else if (value && isFunction2(method = value.then)) {
              method.call(value, resolve2, reject);
            } else {
              resolve2.apply(void 0, [value].slice(noValue));
            }
          } catch (value2) {
            reject.apply(void 0, [value2]);
          }
        }
        jQuery.extend({
          Deferred: function(func) {
            var tuples = [
              // action, add listener, callbacks,
              // ... .then handlers, argument index, [final state]
              [
                "notify",
                "progress",
                jQuery.Callbacks("memory"),
                jQuery.Callbacks("memory"),
                2
              ],
              [
                "resolve",
                "done",
                jQuery.Callbacks("once memory"),
                jQuery.Callbacks("once memory"),
                0,
                "resolved"
              ],
              [
                "reject",
                "fail",
                jQuery.Callbacks("once memory"),
                jQuery.Callbacks("once memory"),
                1,
                "rejected"
              ]
            ], state = "pending", promise = {
              state: function() {
                return state;
              },
              always: function() {
                deferred.done(arguments).fail(arguments);
                return this;
              },
              "catch": function(fn) {
                return promise.then(null, fn);
              },
              // Keep pipe for back-compat
              pipe: function() {
                var fns = arguments;
                return jQuery.Deferred(function(newDefer) {
                  jQuery.each(tuples, function(_i, tuple) {
                    var fn = isFunction2(fns[tuple[4]]) && fns[tuple[4]];
                    deferred[tuple[1]](function() {
                      var returned = fn && fn.apply(this, arguments);
                      if (returned && isFunction2(returned.promise)) {
                        returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                      } else {
                        newDefer[tuple[0] + "With"](
                          this,
                          fn ? [returned] : arguments
                        );
                      }
                    });
                  });
                  fns = null;
                }).promise();
              },
              then: function(onFulfilled, onRejected, onProgress) {
                var maxDepth = 0;
                function resolve2(depth, deferred2, handler, special) {
                  return function() {
                    var that = this, args = arguments, mightThrow = function() {
                      var returned, then;
                      if (depth < maxDepth) {
                        return;
                      }
                      returned = handler.apply(that, args);
                      if (returned === deferred2.promise()) {
                        throw new TypeError("Thenable self-resolution");
                      }
                      then = returned && // Support: Promises/A+ section 2.3.4
                      // https://promisesaplus.com/#point-64
                      // Only check objects and functions for thenability
                      (typeof returned === "object" || typeof returned === "function") && returned.then;
                      if (isFunction2(then)) {
                        if (special) {
                          then.call(
                            returned,
                            resolve2(maxDepth, deferred2, Identity, special),
                            resolve2(maxDepth, deferred2, Thrower, special)
                          );
                        } else {
                          maxDepth++;
                          then.call(
                            returned,
                            resolve2(maxDepth, deferred2, Identity, special),
                            resolve2(maxDepth, deferred2, Thrower, special),
                            resolve2(
                              maxDepth,
                              deferred2,
                              Identity,
                              deferred2.notifyWith
                            )
                          );
                        }
                      } else {
                        if (handler !== Identity) {
                          that = void 0;
                          args = [returned];
                        }
                        (special || deferred2.resolveWith)(that, args);
                      }
                    }, process2 = special ? mightThrow : function() {
                      try {
                        mightThrow();
                      } catch (e) {
                        if (jQuery.Deferred.exceptionHook) {
                          jQuery.Deferred.exceptionHook(
                            e,
                            process2.error
                          );
                        }
                        if (depth + 1 >= maxDepth) {
                          if (handler !== Thrower) {
                            that = void 0;
                            args = [e];
                          }
                          deferred2.rejectWith(that, args);
                        }
                      }
                    };
                    if (depth) {
                      process2();
                    } else {
                      if (jQuery.Deferred.getErrorHook) {
                        process2.error = jQuery.Deferred.getErrorHook();
                      } else if (jQuery.Deferred.getStackHook) {
                        process2.error = jQuery.Deferred.getStackHook();
                      }
                      window2.setTimeout(process2);
                    }
                  };
                }
                return jQuery.Deferred(function(newDefer) {
                  tuples[0][3].add(
                    resolve2(
                      0,
                      newDefer,
                      isFunction2(onProgress) ? onProgress : Identity,
                      newDefer.notifyWith
                    )
                  );
                  tuples[1][3].add(
                    resolve2(
                      0,
                      newDefer,
                      isFunction2(onFulfilled) ? onFulfilled : Identity
                    )
                  );
                  tuples[2][3].add(
                    resolve2(
                      0,
                      newDefer,
                      isFunction2(onRejected) ? onRejected : Thrower
                    )
                  );
                }).promise();
              },
              // Get a promise for this deferred
              // If obj is provided, the promise aspect is added to the object
              promise: function(obj) {
                return obj != null ? jQuery.extend(obj, promise) : promise;
              }
            }, deferred = {};
            jQuery.each(tuples, function(i, tuple) {
              var list = tuple[2], stateString = tuple[5];
              promise[tuple[1]] = list.add;
              if (stateString) {
                list.add(
                  function() {
                    state = stateString;
                  },
                  // rejected_callbacks.disable
                  // fulfilled_callbacks.disable
                  tuples[3 - i][2].disable,
                  // rejected_handlers.disable
                  // fulfilled_handlers.disable
                  tuples[3 - i][3].disable,
                  // progress_callbacks.lock
                  tuples[0][2].lock,
                  // progress_handlers.lock
                  tuples[0][3].lock
                );
              }
              list.add(tuple[3].fire);
              deferred[tuple[0]] = function() {
                deferred[tuple[0] + "With"](this === deferred ? void 0 : this, arguments);
                return this;
              };
              deferred[tuple[0] + "With"] = list.fireWith;
            });
            promise.promise(deferred);
            if (func) {
              func.call(deferred, deferred);
            }
            return deferred;
          },
          // Deferred helper
          when: function(singleValue) {
            var remaining = arguments.length, i = remaining, resolveContexts = Array(i), resolveValues = slice.call(arguments), primary = jQuery.Deferred(), updateFunc = function(i2) {
              return function(value) {
                resolveContexts[i2] = this;
                resolveValues[i2] = arguments.length > 1 ? slice.call(arguments) : value;
                if (!--remaining) {
                  primary.resolveWith(resolveContexts, resolveValues);
                }
              };
            };
            if (remaining <= 1) {
              adoptValue(
                singleValue,
                primary.done(updateFunc(i)).resolve,
                primary.reject,
                !remaining
              );
              if (primary.state() === "pending" || isFunction2(resolveValues[i] && resolveValues[i].then)) {
                return primary.then();
              }
            }
            while (i--) {
              adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            }
            return primary.promise();
          }
        });
        var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        jQuery.Deferred.exceptionHook = function(error, asyncError) {
          if (window2.console && window2.console.warn && error && rerrorNames.test(error.name)) {
            window2.console.warn(
              "jQuery.Deferred exception: " + error.message,
              error.stack,
              asyncError
            );
          }
        };
        jQuery.readyException = function(error) {
          window2.setTimeout(function() {
            throw error;
          });
        };
        var readyList = jQuery.Deferred();
        jQuery.fn.ready = function(fn) {
          readyList.then(fn).catch(function(error) {
            jQuery.readyException(error);
          });
          return this;
        };
        jQuery.extend({
          // Is the DOM ready to be used? Set to true once it occurs.
          isReady: false,
          // A counter to track how many items to wait for before
          // the ready event fires. See trac-6781
          readyWait: 1,
          // Handle when the DOM is ready
          ready: function(wait) {
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
              return;
            }
            jQuery.isReady = true;
            if (wait !== true && --jQuery.readyWait > 0) {
              return;
            }
            readyList.resolveWith(document2, [jQuery]);
          }
        });
        jQuery.ready.then = readyList.then;
        function completed() {
          document2.removeEventListener("DOMContentLoaded", completed);
          window2.removeEventListener("load", completed);
          jQuery.ready();
        }
        if (document2.readyState === "complete" || document2.readyState !== "loading" && !document2.documentElement.doScroll) {
          window2.setTimeout(jQuery.ready);
        } else {
          document2.addEventListener("DOMContentLoaded", completed);
          window2.addEventListener("load", completed);
        }
        var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
          var i = 0, len = elems.length, bulk = key == null;
          if (toType(key) === "object") {
            chainable = true;
            for (i in key) {
              access(elems, fn, i, key[i], true, emptyGet, raw);
            }
          } else if (value !== void 0) {
            chainable = true;
            if (!isFunction2(value)) {
              raw = true;
            }
            if (bulk) {
              if (raw) {
                fn.call(elems, value);
                fn = null;
              } else {
                bulk = fn;
                fn = function(elem, _key, value2) {
                  return bulk.call(jQuery(elem), value2);
                };
              }
            }
            if (fn) {
              for (; i < len; i++) {
                fn(
                  elems[i],
                  key,
                  raw ? value : value.call(elems[i], i, fn(elems[i], key))
                );
              }
            }
          }
          if (chainable) {
            return elems;
          }
          if (bulk) {
            return fn.call(elems);
          }
          return len ? fn(elems[0], key) : emptyGet;
        };
        var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
        function fcamelCase(_all, letter) {
          return letter.toUpperCase();
        }
        function camelCase(string) {
          return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        }
        var acceptData = function(owner) {
          return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
        };
        function Data() {
          this.expando = jQuery.expando + Data.uid++;
        }
        Data.uid = 1;
        Data.prototype = {
          cache: function(owner) {
            var value = owner[this.expando];
            if (!value) {
              value = {};
              if (acceptData(owner)) {
                if (owner.nodeType) {
                  owner[this.expando] = value;
                } else {
                  Object.defineProperty(owner, this.expando, {
                    value,
                    configurable: true
                  });
                }
              }
            }
            return value;
          },
          set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            if (typeof data === "string") {
              cache[camelCase(data)] = value;
            } else {
              for (prop in data) {
                cache[camelCase(prop)] = data[prop];
              }
            }
            return cache;
          },
          get: function(owner, key) {
            return key === void 0 ? this.cache(owner) : (
              // Always use camelCase key (gh-2257)
              owner[this.expando] && owner[this.expando][camelCase(key)]
            );
          },
          access: function(owner, key, value) {
            if (key === void 0 || key && typeof key === "string" && value === void 0) {
              return this.get(owner, key);
            }
            this.set(owner, key, value);
            return value !== void 0 ? value : key;
          },
          remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === void 0) {
              return;
            }
            if (key !== void 0) {
              if (Array.isArray(key)) {
                key = key.map(camelCase);
              } else {
                key = camelCase(key);
                key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
              }
              i = key.length;
              while (i--) {
                delete cache[key[i]];
              }
            }
            if (key === void 0 || jQuery.isEmptyObject(cache)) {
              if (owner.nodeType) {
                owner[this.expando] = void 0;
              } else {
                delete owner[this.expando];
              }
            }
          },
          hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== void 0 && !jQuery.isEmptyObject(cache);
          }
        };
        var dataPriv = new Data();
        var dataUser = new Data();
        var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
        function getData(data) {
          if (data === "true") {
            return true;
          }
          if (data === "false") {
            return false;
          }
          if (data === "null") {
            return null;
          }
          if (data === +data + "") {
            return +data;
          }
          if (rbrace.test(data)) {
            return JSON.parse(data);
          }
          return data;
        }
        function dataAttr(elem, key, data) {
          var name;
          if (data === void 0 && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
              try {
                data = getData(data);
              } catch (e) {
              }
              dataUser.set(elem, key, data);
            } else {
              data = void 0;
            }
          }
          return data;
        }
        jQuery.extend({
          hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
          },
          data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
          },
          removeData: function(elem, name) {
            dataUser.remove(elem, name);
          },
          // TODO: Now that all calls to _data and _removeData have been replaced
          // with direct calls to dataPriv methods, these can be deprecated.
          _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
          },
          _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
          }
        });
        jQuery.fn.extend({
          data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            if (key === void 0) {
              if (this.length) {
                data = dataUser.get(elem);
                if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                  i = attrs.length;
                  while (i--) {
                    if (attrs[i]) {
                      name = attrs[i].name;
                      if (name.indexOf("data-") === 0) {
                        name = camelCase(name.slice(5));
                        dataAttr(elem, name, data[name]);
                      }
                    }
                  }
                  dataPriv.set(elem, "hasDataAttrs", true);
                }
              }
              return data;
            }
            if (typeof key === "object") {
              return this.each(function() {
                dataUser.set(this, key);
              });
            }
            return access(this, function(value2) {
              var data2;
              if (elem && value2 === void 0) {
                data2 = dataUser.get(elem, key);
                if (data2 !== void 0) {
                  return data2;
                }
                data2 = dataAttr(elem, key);
                if (data2 !== void 0) {
                  return data2;
                }
                return;
              }
              this.each(function() {
                dataUser.set(this, key, value2);
              });
            }, null, value, arguments.length > 1, null, true);
          },
          removeData: function(key) {
            return this.each(function() {
              dataUser.remove(this, key);
            });
          }
        });
        jQuery.extend({
          queue: function(elem, type, data) {
            var queue2;
            if (elem) {
              type = (type || "fx") + "queue";
              queue2 = dataPriv.get(elem, type);
              if (data) {
                if (!queue2 || Array.isArray(data)) {
                  queue2 = dataPriv.access(elem, type, jQuery.makeArray(data));
                } else {
                  queue2.push(data);
                }
              }
              return queue2 || [];
            }
          },
          dequeue: function(elem, type) {
            type = type || "fx";
            var queue2 = jQuery.queue(elem, type), startLength = queue2.length, fn = queue2.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
              jQuery.dequeue(elem, type);
            };
            if (fn === "inprogress") {
              fn = queue2.shift();
              startLength--;
            }
            if (fn) {
              if (type === "fx") {
                queue2.unshift("inprogress");
              }
              delete hooks.stop;
              fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) {
              hooks.empty.fire();
            }
          },
          // Not public - generate a queueHooks object, or return the current one
          _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
              empty: jQuery.Callbacks("once memory").add(function() {
                dataPriv.remove(elem, [type + "queue", key]);
              })
            });
          }
        });
        jQuery.fn.extend({
          queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
              data = type;
              type = "fx";
              setter--;
            }
            if (arguments.length < setter) {
              return jQuery.queue(this[0], type);
            }
            return data === void 0 ? this : this.each(function() {
              var queue2 = jQuery.queue(this, type, data);
              jQuery._queueHooks(this, type);
              if (type === "fx" && queue2[0] !== "inprogress") {
                jQuery.dequeue(this, type);
              }
            });
          },
          dequeue: function(type) {
            return this.each(function() {
              jQuery.dequeue(this, type);
            });
          },
          clearQueue: function(type) {
            return this.queue(type || "fx", []);
          },
          // Get a promise resolved when queues of a certain type
          // are emptied (fx is the type by default)
          promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve2 = function() {
              if (!--count) {
                defer.resolveWith(elements, [elements]);
              }
            };
            if (typeof type !== "string") {
              obj = type;
              type = void 0;
            }
            type = type || "fx";
            while (i--) {
              tmp = dataPriv.get(elements[i], type + "queueHooks");
              if (tmp && tmp.empty) {
                count++;
                tmp.empty.add(resolve2);
              }
            }
            resolve2();
            return defer.promise(obj);
          }
        });
        var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
        var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
        var cssExpand = ["Top", "Right", "Bottom", "Left"];
        var documentElement = document2.documentElement;
        var isAttached = function(elem) {
          return jQuery.contains(elem.ownerDocument, elem);
        }, composed = { composed: true };
        if (documentElement.getRootNode) {
          isAttached = function(elem) {
            return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
          };
        }
        var isHiddenWithinTree = function(elem, el) {
          elem = el || elem;
          return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
          // Support: Firefox <=43 - 45
          // Disconnected elements can have computed display: none, so first confirm that elem is
          // in the document.
          isAttached(elem) && jQuery.css(elem, "display") === "none";
        };
        function adjustCSS(elem, prop, valueParts, tween) {
          var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
          } : function() {
            return jQuery.css(elem, prop, "");
          }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
          if (initialInUnit && initialInUnit[3] !== unit) {
            initial = initial / 2;
            unit = unit || initialInUnit[3];
            initialInUnit = +initial || 1;
            while (maxIterations--) {
              jQuery.style(elem, prop, initialInUnit + unit);
              if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
                maxIterations = 0;
              }
              initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            valueParts = valueParts || [];
          }
          if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
              tween.unit = unit;
              tween.start = initialInUnit;
              tween.end = adjusted;
            }
          }
          return adjusted;
        }
        var defaultDisplayMap = {};
        function getDefaultDisplay(elem) {
          var temp, doc2 = elem.ownerDocument, nodeName2 = elem.nodeName, display = defaultDisplayMap[nodeName2];
          if (display) {
            return display;
          }
          temp = doc2.body.appendChild(doc2.createElement(nodeName2));
          display = jQuery.css(temp, "display");
          temp.parentNode.removeChild(temp);
          if (display === "none") {
            display = "block";
          }
          defaultDisplayMap[nodeName2] = display;
          return display;
        }
        function showHide(elements, show2) {
          var display, elem, values = [], index = 0, length = elements.length;
          for (; index < length; index++) {
            elem = elements[index];
            if (!elem.style) {
              continue;
            }
            display = elem.style.display;
            if (show2) {
              if (display === "none") {
                values[index] = dataPriv.get(elem, "display") || null;
                if (!values[index]) {
                  elem.style.display = "";
                }
              }
              if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                values[index] = getDefaultDisplay(elem);
              }
            } else {
              if (display !== "none") {
                values[index] = "none";
                dataPriv.set(elem, "display", display);
              }
            }
          }
          for (index = 0; index < length; index++) {
            if (values[index] != null) {
              elements[index].style.display = values[index];
            }
          }
          return elements;
        }
        jQuery.fn.extend({
          show: function() {
            return showHide(this, true);
          },
          hide: function() {
            return showHide(this);
          },
          toggle: function(state) {
            if (typeof state === "boolean") {
              return state ? this.show() : this.hide();
            }
            return this.each(function() {
              if (isHiddenWithinTree(this)) {
                jQuery(this).show();
              } else {
                jQuery(this).hide();
              }
            });
          }
        });
        var rcheckableType = /^(?:checkbox|radio)$/i;
        var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
        (function() {
          var fragment = document2.createDocumentFragment(), div = fragment.appendChild(document2.createElement("div")), input = document2.createElement("input");
          input.setAttribute("type", "radio");
          input.setAttribute("checked", "checked");
          input.setAttribute("name", "t");
          div.appendChild(input);
          support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
          div.innerHTML = "<textarea>x</textarea>";
          support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
          div.innerHTML = "<option></option>";
          support.option = !!div.lastChild;
        })();
        var wrapMap = {
          // XHTML parsers do not magically insert elements in the
          // same way that tag soup parsers do. So we cannot shorten
          // this by omitting <tbody> or other required elements.
          thead: [1, "<table>", "</table>"],
          col: [2, "<table><colgroup>", "</colgroup></table>"],
          tr: [2, "<table><tbody>", "</tbody></table>"],
          td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
          _default: [0, "", ""]
        };
        wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
        wrapMap.th = wrapMap.td;
        if (!support.option) {
          wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
        }
        function getAll(context, tag) {
          var ret;
          if (typeof context.getElementsByTagName !== "undefined") {
            ret = context.getElementsByTagName(tag || "*");
          } else if (typeof context.querySelectorAll !== "undefined") {
            ret = context.querySelectorAll(tag || "*");
          } else {
            ret = [];
          }
          if (tag === void 0 || tag && nodeName(context, tag)) {
            return jQuery.merge([context], ret);
          }
          return ret;
        }
        function setGlobalEval(elems, refElements) {
          var i = 0, l = elems.length;
          for (; i < l; i++) {
            dataPriv.set(
              elems[i],
              "globalEval",
              !refElements || dataPriv.get(refElements[i], "globalEval")
            );
          }
        }
        var rhtml = /<|&#?\w+;/;
        function buildFragment(elems, context, scripts, selection, ignored) {
          var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
          for (; i < l; i++) {
            elem = elems[i];
            if (elem || elem === 0) {
              if (toType(elem) === "object") {
                jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
              } else if (!rhtml.test(elem)) {
                nodes.push(context.createTextNode(elem));
              } else {
                tmp = tmp || fragment.appendChild(context.createElement("div"));
                tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                wrap = wrapMap[tag] || wrapMap._default;
                tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                j = wrap[0];
                while (j--) {
                  tmp = tmp.lastChild;
                }
                jQuery.merge(nodes, tmp.childNodes);
                tmp = fragment.firstChild;
                tmp.textContent = "";
              }
            }
          }
          fragment.textContent = "";
          i = 0;
          while (elem = nodes[i++]) {
            if (selection && jQuery.inArray(elem, selection) > -1) {
              if (ignored) {
                ignored.push(elem);
              }
              continue;
            }
            attached = isAttached(elem);
            tmp = getAll(fragment.appendChild(elem), "script");
            if (attached) {
              setGlobalEval(tmp);
            }
            if (scripts) {
              j = 0;
              while (elem = tmp[j++]) {
                if (rscriptType.test(elem.type || "")) {
                  scripts.push(elem);
                }
              }
            }
          }
          return fragment;
        }
        var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
        function returnTrue() {
          return true;
        }
        function returnFalse() {
          return false;
        }
        function on(elem, types, selector, data, fn, one) {
          var origFn, type;
          if (typeof types === "object") {
            if (typeof selector !== "string") {
              data = data || selector;
              selector = void 0;
            }
            for (type in types) {
              on(elem, type, selector, data, types[type], one);
            }
            return elem;
          }
          if (data == null && fn == null) {
            fn = selector;
            data = selector = void 0;
          } else if (fn == null) {
            if (typeof selector === "string") {
              fn = data;
              data = void 0;
            } else {
              fn = data;
              data = selector;
              selector = void 0;
            }
          }
          if (fn === false) {
            fn = returnFalse;
          } else if (!fn) {
            return elem;
          }
          if (one === 1) {
            origFn = fn;
            fn = function(event2) {
              jQuery().off(event2);
              return origFn.apply(this, arguments);
            };
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
          }
          return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
          });
        }
        jQuery.event = {
          global: {},
          add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            if (!acceptData(elem)) {
              return;
            }
            if (handler.handler) {
              handleObjIn = handler;
              handler = handleObjIn.handler;
              selector = handleObjIn.selector;
            }
            if (selector) {
              jQuery.find.matchesSelector(documentElement, selector);
            }
            if (!handler.guid) {
              handler.guid = jQuery.guid++;
            }
            if (!(events = elemData.events)) {
              events = elemData.events = /* @__PURE__ */ Object.create(null);
            }
            if (!(eventHandle = elemData.handle)) {
              eventHandle = elemData.handle = function(e) {
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : void 0;
              };
            }
            types = (types || "").match(rnothtmlwhite) || [""];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || "").split(".").sort();
              if (!type) {
                continue;
              }
              special = jQuery.event.special[type] || {};
              type = (selector ? special.delegateType : special.bindType) || type;
              special = jQuery.event.special[type] || {};
              handleObj = jQuery.extend({
                type,
                origType,
                data,
                handler,
                guid: handler.guid,
                selector,
                needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                namespace: namespaces.join(".")
              }, handleObjIn);
              if (!(handlers = events[type])) {
                handlers = events[type] = [];
                handlers.delegateCount = 0;
                if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                  if (elem.addEventListener) {
                    elem.addEventListener(type, eventHandle);
                  }
                }
              }
              if (special.add) {
                special.add.call(elem, handleObj);
                if (!handleObj.handler.guid) {
                  handleObj.handler.guid = handler.guid;
                }
              }
              if (selector) {
                handlers.splice(handlers.delegateCount++, 0, handleObj);
              } else {
                handlers.push(handleObj);
              }
              jQuery.event.global[type] = true;
            }
          },
          // Detach an event or set of events from an element
          remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) {
              return;
            }
            types = (types || "").match(rnothtmlwhite) || [""];
            t = types.length;
            while (t--) {
              tmp = rtypenamespace.exec(types[t]) || [];
              type = origType = tmp[1];
              namespaces = (tmp[2] || "").split(".").sort();
              if (!type) {
                for (type in events) {
                  jQuery.event.remove(elem, type + types[t], handler, selector, true);
                }
                continue;
              }
              special = jQuery.event.special[type] || {};
              type = (selector ? special.delegateType : special.bindType) || type;
              handlers = events[type] || [];
              tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
              origCount = j = handlers.length;
              while (j--) {
                handleObj = handlers[j];
                if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                  handlers.splice(j, 1);
                  if (handleObj.selector) {
                    handlers.delegateCount--;
                  }
                  if (special.remove) {
                    special.remove.call(elem, handleObj);
                  }
                }
              }
              if (origCount && !handlers.length) {
                if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
                  jQuery.removeEvent(elem, type, elemData.handle);
                }
                delete events[type];
              }
            }
            if (jQuery.isEmptyObject(events)) {
              dataPriv.remove(elem, "handle events");
            }
          },
          dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), event2 = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || /* @__PURE__ */ Object.create(null))[event2.type] || [], special = jQuery.event.special[event2.type] || {};
            args[0] = event2;
            for (i = 1; i < arguments.length; i++) {
              args[i] = arguments[i];
            }
            event2.delegateTarget = this;
            if (special.preDispatch && special.preDispatch.call(this, event2) === false) {
              return;
            }
            handlerQueue = jQuery.event.handlers.call(this, event2, handlers);
            i = 0;
            while ((matched = handlerQueue[i++]) && !event2.isPropagationStopped()) {
              event2.currentTarget = matched.elem;
              j = 0;
              while ((handleObj = matched.handlers[j++]) && !event2.isImmediatePropagationStopped()) {
                if (!event2.rnamespace || handleObj.namespace === false || event2.rnamespace.test(handleObj.namespace)) {
                  event2.handleObj = handleObj;
                  event2.data = handleObj.data;
                  ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                  if (ret !== void 0) {
                    if ((event2.result = ret) === false) {
                      event2.preventDefault();
                      event2.stopPropagation();
                    }
                  }
                }
              }
            }
            if (special.postDispatch) {
              special.postDispatch.call(this, event2);
            }
            return event2.result;
          },
          handlers: function(event2, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event2.target;
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event2.type === "click" && event2.button >= 1)) {
              for (; cur !== this; cur = cur.parentNode || this) {
                if (cur.nodeType === 1 && !(event2.type === "click" && cur.disabled === true)) {
                  matchedHandlers = [];
                  matchedSelectors = {};
                  for (i = 0; i < delegateCount; i++) {
                    handleObj = handlers[i];
                    sel = handleObj.selector + " ";
                    if (matchedSelectors[sel] === void 0) {
                      matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
                    }
                    if (matchedSelectors[sel]) {
                      matchedHandlers.push(handleObj);
                    }
                  }
                  if (matchedHandlers.length) {
                    handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                  }
                }
              }
            }
            cur = this;
            if (delegateCount < handlers.length) {
              handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
            }
            return handlerQueue;
          },
          addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
              enumerable: true,
              configurable: true,
              get: isFunction2(hook) ? function() {
                if (this.originalEvent) {
                  return hook(this.originalEvent);
                }
              } : function() {
                if (this.originalEvent) {
                  return this.originalEvent[name];
                }
              },
              set: function(value) {
                Object.defineProperty(this, name, {
                  enumerable: true,
                  configurable: true,
                  writable: true,
                  value
                });
              }
            });
          },
          fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
          },
          special: {
            load: {
              // Prevent triggered image.load events from bubbling to window.load
              noBubble: true
            },
            click: {
              // Utilize native event to ensure correct state for checkable inputs
              setup: function(data) {
                var el = this || data;
                if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
                  leverageNative(el, "click", true);
                }
                return false;
              },
              trigger: function(data) {
                var el = this || data;
                if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
                  leverageNative(el, "click");
                }
                return true;
              },
              // For cross-browser consistency, suppress native .click() on links
              // Also prevent it if we're currently inside a leveraged native-event stack
              _default: function(event2) {
                var target = event2.target;
                return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
              }
            },
            beforeunload: {
              postDispatch: function(event2) {
                if (event2.result !== void 0 && event2.originalEvent) {
                  event2.originalEvent.returnValue = event2.result;
                }
              }
            }
          }
        };
        function leverageNative(el, type, isSetup) {
          if (!isSetup) {
            if (dataPriv.get(el, type) === void 0) {
              jQuery.event.add(el, type, returnTrue);
            }
            return;
          }
          dataPriv.set(el, type, false);
          jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event2) {
              var result, saved = dataPriv.get(this, type);
              if (event2.isTrigger & 1 && this[type]) {
                if (!saved) {
                  saved = slice.call(arguments);
                  dataPriv.set(this, type, saved);
                  this[type]();
                  result = dataPriv.get(this, type);
                  dataPriv.set(this, type, false);
                  if (saved !== result) {
                    event2.stopImmediatePropagation();
                    event2.preventDefault();
                    return result;
                  }
                } else if ((jQuery.event.special[type] || {}).delegateType) {
                  event2.stopPropagation();
                }
              } else if (saved) {
                dataPriv.set(this, type, jQuery.event.trigger(
                  saved[0],
                  saved.slice(1),
                  this
                ));
                event2.stopPropagation();
                event2.isImmediatePropagationStopped = returnTrue;
              }
            }
          });
        }
        jQuery.removeEvent = function(elem, type, handle) {
          if (elem.removeEventListener) {
            elem.removeEventListener(type, handle);
          }
        };
        jQuery.Event = function(src, props) {
          if (!(this instanceof jQuery.Event)) {
            return new jQuery.Event(src, props);
          }
          if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === void 0 && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
          } else {
            this.type = src;
          }
          if (props) {
            jQuery.extend(this, props);
          }
          this.timeStamp = src && src.timeStamp || Date.now();
          this[jQuery.expando] = true;
        };
        jQuery.Event.prototype = {
          constructor: jQuery.Event,
          isDefaultPrevented: returnFalse,
          isPropagationStopped: returnFalse,
          isImmediatePropagationStopped: returnFalse,
          isSimulated: false,
          preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) {
              e.preventDefault();
            }
          },
          stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) {
              e.stopPropagation();
            }
          },
          stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) {
              e.stopImmediatePropagation();
            }
            this.stopPropagation();
          }
        };
        jQuery.each({
          altKey: true,
          bubbles: true,
          cancelable: true,
          changedTouches: true,
          ctrlKey: true,
          detail: true,
          eventPhase: true,
          metaKey: true,
          pageX: true,
          pageY: true,
          shiftKey: true,
          view: true,
          "char": true,
          code: true,
          charCode: true,
          key: true,
          keyCode: true,
          button: true,
          buttons: true,
          clientX: true,
          clientY: true,
          offsetX: true,
          offsetY: true,
          pointerId: true,
          pointerType: true,
          screenX: true,
          screenY: true,
          targetTouches: true,
          toElement: true,
          touches: true,
          which: true
        }, jQuery.event.addProp);
        jQuery.each({ focus: "focusin", blur: "focusout" }, function(type, delegateType) {
          function focusMappedHandler(nativeEvent) {
            if (document2.documentMode) {
              var handle = dataPriv.get(this, "handle"), event2 = jQuery.event.fix(nativeEvent);
              event2.type = nativeEvent.type === "focusin" ? "focus" : "blur";
              event2.isSimulated = true;
              handle(nativeEvent);
              if (event2.target === event2.currentTarget) {
                handle(event2);
              }
            } else {
              jQuery.event.simulate(
                delegateType,
                nativeEvent.target,
                jQuery.event.fix(nativeEvent)
              );
            }
          }
          jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
              var attaches;
              leverageNative(this, type, true);
              if (document2.documentMode) {
                attaches = dataPriv.get(this, delegateType);
                if (!attaches) {
                  this.addEventListener(delegateType, focusMappedHandler);
                }
                dataPriv.set(this, delegateType, (attaches || 0) + 1);
              } else {
                return false;
              }
            },
            trigger: function() {
              leverageNative(this, type);
              return true;
            },
            teardown: function() {
              var attaches;
              if (document2.documentMode) {
                attaches = dataPriv.get(this, delegateType) - 1;
                if (!attaches) {
                  this.removeEventListener(delegateType, focusMappedHandler);
                  dataPriv.remove(this, delegateType);
                } else {
                  dataPriv.set(this, delegateType, attaches);
                }
              } else {
                return false;
              }
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event2) {
              return dataPriv.get(event2.target, type);
            },
            delegateType
          };
          jQuery.event.special[delegateType] = {
            setup: function() {
              var doc2 = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc2, attaches = dataPriv.get(dataHolder, delegateType);
              if (!attaches) {
                if (document2.documentMode) {
                  this.addEventListener(delegateType, focusMappedHandler);
                } else {
                  doc2.addEventListener(type, focusMappedHandler, true);
                }
              }
              dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
              var doc2 = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc2, attaches = dataPriv.get(dataHolder, delegateType) - 1;
              if (!attaches) {
                if (document2.documentMode) {
                  this.removeEventListener(delegateType, focusMappedHandler);
                } else {
                  doc2.removeEventListener(type, focusMappedHandler, true);
                }
                dataPriv.remove(dataHolder, delegateType);
              } else {
                dataPriv.set(dataHolder, delegateType, attaches);
              }
            }
          };
        });
        jQuery.each({
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout"
        }, function(orig, fix) {
          jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event2) {
              var ret, target = this, related = event2.relatedTarget, handleObj = event2.handleObj;
              if (!related || related !== target && !jQuery.contains(target, related)) {
                event2.type = handleObj.origType;
                ret = handleObj.handler.apply(this, arguments);
                event2.type = fix;
              }
              return ret;
            }
          };
        });
        jQuery.fn.extend({
          on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
          },
          one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
          },
          off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
              handleObj = types.handleObj;
              jQuery(types.delegateTarget).off(
                handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
                handleObj.selector,
                handleObj.handler
              );
              return this;
            }
            if (typeof types === "object") {
              for (type in types) {
                this.off(type, selector, types[type]);
              }
              return this;
            }
            if (selector === false || typeof selector === "function") {
              fn = selector;
              selector = void 0;
            }
            if (fn === false) {
              fn = returnFalse;
            }
            return this.each(function() {
              jQuery.event.remove(this, types, fn, selector);
            });
          }
        });
        var rnoInnerhtml = /<script|<style|<link/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
        function manipulationTarget(elem, content) {
          if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
            return jQuery(elem).children("tbody")[0] || elem;
          }
          return elem;
        }
        function disableScript(elem) {
          elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
          return elem;
        }
        function restoreScript(elem) {
          if ((elem.type || "").slice(0, 5) === "true/") {
            elem.type = elem.type.slice(5);
          } else {
            elem.removeAttribute("type");
          }
          return elem;
        }
        function cloneCopyEvent(src, dest) {
          var i, l, type, pdataOld, udataOld, udataCur, events;
          if (dest.nodeType !== 1) {
            return;
          }
          if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
              dataPriv.remove(dest, "handle events");
              for (type in events) {
                for (i = 0, l = events[type].length; i < l; i++) {
                  jQuery.event.add(dest, type, events[type][i]);
                }
              }
            }
          }
          if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
          }
        }
        function fixInput(src, dest) {
          var nodeName2 = dest.nodeName.toLowerCase();
          if (nodeName2 === "input" && rcheckableType.test(src.type)) {
            dest.checked = src.checked;
          } else if (nodeName2 === "input" || nodeName2 === "textarea") {
            dest.defaultValue = src.defaultValue;
          }
        }
        function domManip(collection, args, callback, ignored) {
          args = flat(args);
          var fragment, first, scripts, hasScripts, node, doc2, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction2(value);
          if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
            return collection.each(function(index) {
              var self2 = collection.eq(index);
              if (valueIsFunction) {
                args[0] = value.call(this, index, self2.html());
              }
              domManip(self2, args, callback, ignored);
            });
          }
          if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) {
              fragment = first;
            }
            if (first || ignored) {
              scripts = jQuery.map(getAll(fragment, "script"), disableScript);
              hasScripts = scripts.length;
              for (; i < l; i++) {
                node = fragment;
                if (i !== iNoClone) {
                  node = jQuery.clone(node, true, true);
                  if (hasScripts) {
                    jQuery.merge(scripts, getAll(node, "script"));
                  }
                }
                callback.call(collection[i], node, i);
              }
              if (hasScripts) {
                doc2 = scripts[scripts.length - 1].ownerDocument;
                jQuery.map(scripts, restoreScript);
                for (i = 0; i < hasScripts; i++) {
                  node = scripts[i];
                  if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc2, node)) {
                    if (node.src && (node.type || "").toLowerCase() !== "module") {
                      if (jQuery._evalUrl && !node.noModule) {
                        jQuery._evalUrl(node.src, {
                          nonce: node.nonce || node.getAttribute("nonce")
                        }, doc2);
                      }
                    } else {
                      DOMEval(node.textContent.replace(rcleanScript, ""), node, doc2);
                    }
                  }
                }
              }
            }
          }
          return collection;
        }
        function remove2(elem, selector, keepData) {
          var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
          for (; (node = nodes[i]) != null; i++) {
            if (!keepData && node.nodeType === 1) {
              jQuery.cleanData(getAll(node));
            }
            if (node.parentNode) {
              if (keepData && isAttached(node)) {
                setGlobalEval(getAll(node, "script"));
              }
              node.parentNode.removeChild(node);
            }
          }
          return elem;
        }
        jQuery.extend({
          htmlPrefilter: function(html) {
            return html;
          },
          clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
              destElements = getAll(clone);
              srcElements = getAll(elem);
              for (i = 0, l = srcElements.length; i < l; i++) {
                fixInput(srcElements[i], destElements[i]);
              }
            }
            if (dataAndEvents) {
              if (deepDataAndEvents) {
                srcElements = srcElements || getAll(elem);
                destElements = destElements || getAll(clone);
                for (i = 0, l = srcElements.length; i < l; i++) {
                  cloneCopyEvent(srcElements[i], destElements[i]);
                }
              } else {
                cloneCopyEvent(elem, clone);
              }
            }
            destElements = getAll(clone, "script");
            if (destElements.length > 0) {
              setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            }
            return clone;
          },
          cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for (; (elem = elems[i]) !== void 0; i++) {
              if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                  if (data.events) {
                    for (type in data.events) {
                      if (special[type]) {
                        jQuery.event.remove(elem, type);
                      } else {
                        jQuery.removeEvent(elem, type, data.handle);
                      }
                    }
                  }
                  elem[dataPriv.expando] = void 0;
                }
                if (elem[dataUser.expando]) {
                  elem[dataUser.expando] = void 0;
                }
              }
            }
          }
        });
        jQuery.fn.extend({
          detach: function(selector) {
            return remove2(this, selector, true);
          },
          remove: function(selector) {
            return remove2(this, selector);
          },
          text: function(value) {
            return access(this, function(value2) {
              return value2 === void 0 ? jQuery.text(this) : this.empty().each(function() {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                  this.textContent = value2;
                }
              });
            }, null, value, arguments.length);
          },
          append: function() {
            return domManip(this, arguments, function(elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.appendChild(elem);
              }
            });
          },
          prepend: function() {
            return domManip(this, arguments, function(elem) {
              if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                var target = manipulationTarget(this, elem);
                target.insertBefore(elem, target.firstChild);
              }
            });
          },
          before: function() {
            return domManip(this, arguments, function(elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this);
              }
            });
          },
          after: function() {
            return domManip(this, arguments, function(elem) {
              if (this.parentNode) {
                this.parentNode.insertBefore(elem, this.nextSibling);
              }
            });
          },
          empty: function() {
            var elem, i = 0;
            for (; (elem = this[i]) != null; i++) {
              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.textContent = "";
              }
            }
            return this;
          },
          clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
              return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
          },
          html: function(value) {
            return access(this, function(value2) {
              var elem = this[0] || {}, i = 0, l = this.length;
              if (value2 === void 0 && elem.nodeType === 1) {
                return elem.innerHTML;
              }
              if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
                value2 = jQuery.htmlPrefilter(value2);
                try {
                  for (; i < l; i++) {
                    elem = this[i] || {};
                    if (elem.nodeType === 1) {
                      jQuery.cleanData(getAll(elem, false));
                      elem.innerHTML = value2;
                    }
                  }
                  elem = 0;
                } catch (e) {
                }
              }
              if (elem) {
                this.empty().append(value2);
              }
            }, null, value, arguments.length);
          },
          replaceWith: function() {
            var ignored = [];
            return domManip(this, arguments, function(elem) {
              var parent = this.parentNode;
              if (jQuery.inArray(this, ignored) < 0) {
                jQuery.cleanData(getAll(this));
                if (parent) {
                  parent.replaceChild(elem, this);
                }
              }
            }, ignored);
          }
        });
        jQuery.each({
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith"
        }, function(name, original) {
          jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for (; i <= last; i++) {
              elems = i === last ? this : this.clone(true);
              jQuery(insert[i])[original](elems);
              push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
          };
        });
        var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
        var rcustomProp = /^--/;
        var getStyles = function(elem) {
          var view = elem.ownerDocument.defaultView;
          if (!view || !view.opener) {
            view = window2;
          }
          return view.getComputedStyle(elem);
        };
        var swap = function(elem, options, callback) {
          var ret, name, old = {};
          for (name in options) {
            old[name] = elem.style[name];
            elem.style[name] = options[name];
          }
          ret = callback.call(elem);
          for (name in options) {
            elem.style[name] = old[name];
          }
          return ret;
        };
        var rboxStyle = new RegExp(cssExpand.join("|"), "i");
        (function() {
          function computeStyleTests() {
            if (!div) {
              return;
            }
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window2.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            div = null;
          }
          function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
          }
          var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document2.createElement("div"), div = document2.createElement("div");
          if (!div.style) {
            return;
          }
          div.style.backgroundClip = "content-box";
          div.cloneNode(true).style.backgroundClip = "";
          support.clearCloneStyle = div.style.backgroundClip === "content-box";
          jQuery.extend(support, {
            boxSizingReliable: function() {
              computeStyleTests();
              return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
              computeStyleTests();
              return pixelBoxStylesVal;
            },
            pixelPosition: function() {
              computeStyleTests();
              return pixelPositionVal;
            },
            reliableMarginLeft: function() {
              computeStyleTests();
              return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
              computeStyleTests();
              return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
              var table, tr, trChild, trStyle;
              if (reliableTrDimensionsVal == null) {
                table = document2.createElement("table");
                tr = document2.createElement("tr");
                trChild = document2.createElement("div");
                table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                tr.style.cssText = "box-sizing:content-box;border:1px solid";
                tr.style.height = "1px";
                trChild.style.height = "9px";
                trChild.style.display = "block";
                documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                trStyle = window2.getComputedStyle(tr);
                reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                documentElement.removeChild(table);
              }
              return reliableTrDimensionsVal;
            }
          });
        })();
        function curCSS(elem, name, computed2) {
          var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), style = elem.style;
          computed2 = computed2 || getStyles(elem);
          if (computed2) {
            ret = computed2.getPropertyValue(name) || computed2[name];
            if (isCustomProp && ret) {
              ret = ret.replace(rtrimCSS, "$1") || void 0;
            }
            if (ret === "" && !isAttached(elem)) {
              ret = jQuery.style(elem, name);
            }
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
              width = style.width;
              minWidth = style.minWidth;
              maxWidth = style.maxWidth;
              style.minWidth = style.maxWidth = style.width = ret;
              ret = computed2.width;
              style.width = width;
              style.minWidth = minWidth;
              style.maxWidth = maxWidth;
            }
          }
          return ret !== void 0 ? (
            // Support: IE <=9 - 11 only
            // IE returns zIndex value as an integer.
            ret + ""
          ) : ret;
        }
        function addGetHookIf(conditionFn, hookFn) {
          return {
            get: function() {
              if (conditionFn()) {
                delete this.get;
                return;
              }
              return (this.get = hookFn).apply(this, arguments);
            }
          };
        }
        var cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document2.createElement("div").style, vendorProps = {};
        function vendorPropName(name) {
          var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
          while (i--) {
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) {
              return name;
            }
          }
        }
        function finalPropName(name) {
          var final = jQuery.cssProps[name] || vendorProps[name];
          if (final) {
            return final;
          }
          if (name in emptyStyle) {
            return name;
          }
          return vendorProps[name] = vendorPropName(name) || name;
        }
        var rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
          letterSpacing: "0",
          fontWeight: "400"
        };
        function setPositiveNumber(_elem, value, subtract) {
          var matches = rcssNum.exec(value);
          return matches ? (
            // Guard against undefined "subtract", e.g., when used as in cssHooks
            Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
          ) : value;
        }
        function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
          var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
          if (box === (isBorderBox ? "border" : "content")) {
            return 0;
          }
          for (; i < 4; i += 2) {
            if (box === "margin") {
              marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            }
            if (!isBorderBox) {
              delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
              if (box !== "padding") {
                delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
              } else {
                extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
              }
            } else {
              if (box === "content") {
                delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
              }
              if (box !== "margin") {
                delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
              }
            }
          }
          if (!isBorderBox && computedVal >= 0) {
            delta += Math.max(0, Math.ceil(
              elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
              // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
              // Use an explicit zero to avoid NaN (gh-3964)
            )) || 0;
          }
          return delta + marginDelta;
        }
        function getWidthOrHeight(elem, dimension, extra) {
          var styles = getStyles(elem), boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
          if (rnumnonpx.test(val)) {
            if (!extra) {
              return val;
            }
            val = "auto";
          }
          if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
          // IE/Edge misreport `getComputedStyle` of table rows with width/height
          // set in CSS while `offset*` properties report correct values.
          // Interestingly, in some cases IE 9 doesn't suffer from this issue.
          !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
          // This happens for inline elements with no explicit setting (gh-3571)
          val === "auto" || // Support: Android <=4.1 - 4.3 only
          // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
          !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
          elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) {
              val = elem[offsetProp];
            }
          }
          val = parseFloat(val) || 0;
          return val + boxModelAdjustment(
            elem,
            dimension,
            extra || (isBorderBox ? "border" : "content"),
            valueIsBorderBox,
            styles,
            // Provide the current computed size to request scroll gutter calculation (gh-3589)
            val
          ) + "px";
        }
        jQuery.extend({
          // Add in style property hooks for overriding the default
          // behavior of getting and setting a style property
          cssHooks: {
            opacity: {
              get: function(elem, computed2) {
                if (computed2) {
                  var ret = curCSS(elem, "opacity");
                  return ret === "" ? "1" : ret;
                }
              }
            }
          },
          // Don't automatically add "px" to these possibly-unitless properties
          cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
          },
          // Add in properties whose names you wish to fix before
          // setting or getting the value
          cssProps: {},
          // Get and set the style property on a DOM Node
          style: function(elem, name, value, extra) {
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
              return;
            }
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            if (!isCustomProp) {
              name = finalPropName(origName);
            }
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            if (value !== void 0) {
              type = typeof value;
              if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                value = adjustCSS(elem, name, ret);
                type = "number";
              }
              if (value == null || value !== value) {
                return;
              }
              if (type === "number" && !isCustomProp) {
                value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
              }
              if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
                style[name] = "inherit";
              }
              if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== void 0) {
                if (isCustomProp) {
                  style.setProperty(name, value);
                } else {
                  style[name] = value;
                }
              }
            } else {
              if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== void 0) {
                return ret;
              }
              return style[name];
            }
          },
          css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            if (!isCustomProp) {
              name = finalPropName(origName);
            }
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            if (hooks && "get" in hooks) {
              val = hooks.get(elem, true, extra);
            }
            if (val === void 0) {
              val = curCSS(elem, name, styles);
            }
            if (val === "normal" && name in cssNormalTransform) {
              val = cssNormalTransform[name];
            }
            if (extra === "" || extra) {
              num = parseFloat(val);
              return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
          }
        });
        jQuery.each(["height", "width"], function(_i, dimension) {
          jQuery.cssHooks[dimension] = {
            get: function(elem, computed2, extra) {
              if (computed2) {
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                  return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
              }
            },
            set: function(elem, value, extra) {
              var matches, styles = getStyles(elem), scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(
                elem,
                dimension,
                extra,
                isBorderBox,
                styles
              ) : 0;
              if (isBorderBox && scrollboxSizeBuggy) {
                subtract -= Math.ceil(
                  elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5
                );
              }
              if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                elem.style[dimension] = value;
                value = jQuery.css(elem, dimension);
              }
              return setPositiveNumber(elem, value, subtract);
            }
          };
        });
        jQuery.cssHooks.marginLeft = addGetHookIf(
          support.reliableMarginLeft,
          function(elem, computed2) {
            if (computed2) {
              return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function() {
                return elem.getBoundingClientRect().left;
              })) + "px";
            }
          }
        );
        jQuery.each({
          margin: "",
          padding: "",
          border: "Width"
        }, function(prefix, suffix) {
          jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
              var i = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
              for (; i < 4; i++) {
                expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
              }
              return expanded;
            }
          };
          if (prefix !== "margin") {
            jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
          }
        });
        jQuery.fn.extend({
          css: function(name, value) {
            return access(this, function(elem, name2, value2) {
              var styles, len, map = {}, i = 0;
              if (Array.isArray(name2)) {
                styles = getStyles(elem);
                len = name2.length;
                for (; i < len; i++) {
                  map[name2[i]] = jQuery.css(elem, name2[i], false, styles);
                }
                return map;
              }
              return value2 !== void 0 ? jQuery.style(elem, name2, value2) : jQuery.css(elem, name2);
            }, name, value, arguments.length > 1);
          }
        });
        function Tween(elem, options, prop, end, easing) {
          return new Tween.prototype.init(elem, options, prop, end, easing);
        }
        jQuery.Tween = Tween;
        Tween.prototype = {
          constructor: Tween,
          init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
          },
          cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
          },
          run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) {
              this.pos = eased = jQuery.easing[this.easing](
                percent,
                this.options.duration * percent,
                0,
                1,
                this.options.duration
              );
            } else {
              this.pos = eased = percent;
            }
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) {
              this.options.step.call(this.elem, this.now, this);
            }
            if (hooks && hooks.set) {
              hooks.set(this);
            } else {
              Tween.propHooks._default.set(this);
            }
            return this;
          }
        };
        Tween.prototype.init.prototype = Tween.prototype;
        Tween.propHooks = {
          _default: {
            get: function(tween) {
              var result;
              if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
                return tween.elem[tween.prop];
              }
              result = jQuery.css(tween.elem, tween.prop, "");
              return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
              if (jQuery.fx.step[tween.prop]) {
                jQuery.fx.step[tween.prop](tween);
              } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
                jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
              } else {
                tween.elem[tween.prop] = tween.now;
              }
            }
          }
        };
        Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
          set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) {
              tween.elem[tween.prop] = tween.now;
            }
          }
        };
        jQuery.easing = {
          linear: function(p2) {
            return p2;
          },
          swing: function(p2) {
            return 0.5 - Math.cos(p2 * Math.PI) / 2;
          },
          _default: "swing"
        };
        jQuery.fx = Tween.prototype.init;
        jQuery.fx.step = {};
        var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
        function schedule() {
          if (inProgress) {
            if (document2.hidden === false && window2.requestAnimationFrame) {
              window2.requestAnimationFrame(schedule);
            } else {
              window2.setTimeout(schedule, jQuery.fx.interval);
            }
            jQuery.fx.tick();
          }
        }
        function createFxNow() {
          window2.setTimeout(function() {
            fxNow = void 0;
          });
          return fxNow = Date.now();
        }
        function genFx(type, includeWidth) {
          var which, i = 0, attrs = { height: type };
          includeWidth = includeWidth ? 1 : 0;
          for (; i < 4; i += 2 - includeWidth) {
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
          }
          if (includeWidth) {
            attrs.opacity = attrs.width = type;
          }
          return attrs;
        }
        function createTween(value, prop, animation) {
          var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
          for (; index < length; index++) {
            if (tween = collection[index].call(animation, prop, value)) {
              return tween;
            }
          }
        }
        function defaultPrefilter(elem, props, opts) {
          var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
          if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
              hooks.unqueued = 0;
              oldfire = hooks.empty.fire;
              hooks.empty.fire = function() {
                if (!hooks.unqueued) {
                  oldfire();
                }
              };
            }
            hooks.unqueued++;
            anim.always(function() {
              anim.always(function() {
                hooks.unqueued--;
                if (!jQuery.queue(elem, "fx").length) {
                  hooks.empty.fire();
                }
              });
            });
          }
          for (prop in props) {
            value = props[prop];
            if (rfxtypes.test(value)) {
              delete props[prop];
              toggle = toggle || value === "toggle";
              if (value === (hidden ? "hide" : "show")) {
                if (value === "show" && dataShow && dataShow[prop] !== void 0) {
                  hidden = true;
                } else {
                  continue;
                }
              }
              orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
          }
          propTween = !jQuery.isEmptyObject(props);
          if (!propTween && jQuery.isEmptyObject(orig)) {
            return;
          }
          if (isBox && elem.nodeType === 1) {
            opts.overflow = [style.overflow, style.overflowX, style.overflowY];
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) {
              restoreDisplay = dataPriv.get(elem, "display");
            }
            display = jQuery.css(elem, "display");
            if (display === "none") {
              if (restoreDisplay) {
                display = restoreDisplay;
              } else {
                showHide([elem], true);
                restoreDisplay = elem.style.display || restoreDisplay;
                display = jQuery.css(elem, "display");
                showHide([elem]);
              }
            }
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
              if (jQuery.css(elem, "float") === "none") {
                if (!propTween) {
                  anim.done(function() {
                    style.display = restoreDisplay;
                  });
                  if (restoreDisplay == null) {
                    display = style.display;
                    restoreDisplay = display === "none" ? "" : display;
                  }
                }
                style.display = "inline-block";
              }
            }
          }
          if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
              style.overflow = opts.overflow[0];
              style.overflowX = opts.overflow[1];
              style.overflowY = opts.overflow[2];
            });
          }
          propTween = false;
          for (prop in orig) {
            if (!propTween) {
              if (dataShow) {
                if ("hidden" in dataShow) {
                  hidden = dataShow.hidden;
                }
              } else {
                dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
              }
              if (toggle) {
                dataShow.hidden = !hidden;
              }
              if (hidden) {
                showHide([elem], true);
              }
              anim.done(function() {
                if (!hidden) {
                  showHide([elem]);
                }
                dataPriv.remove(elem, "fxshow");
                for (prop in orig) {
                  jQuery.style(elem, prop, orig[prop]);
                }
              });
            }
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
              dataShow[prop] = propTween.start;
              if (hidden) {
                propTween.end = propTween.start;
                propTween.start = 0;
              }
            }
          }
        }
        function propFilter(props, specialEasing) {
          var index, name, easing, value, hooks;
          for (index in props) {
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
              easing = value[1];
              value = props[index] = value[0];
            }
            if (index !== name) {
              props[name] = value;
              delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
              value = hooks.expand(value);
              delete props[name];
              for (index in value) {
                if (!(index in props)) {
                  props[index] = value[index];
                  specialEasing[index] = easing;
                }
              }
            } else {
              specialEasing[name] = easing;
            }
          }
        }
        function Animation(elem, properties, options) {
          var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            delete tick.elem;
          }), tick = function() {
            if (stopped) {
              return false;
            }
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp = remaining / animation.duration || 0, percent = 1 - temp, index2 = 0, length2 = animation.tweens.length;
            for (; index2 < length2; index2++) {
              animation.tweens[index2].run(percent);
            }
            deferred.notifyWith(elem, [animation, percent, remaining]);
            if (percent < 1 && length2) {
              return remaining;
            }
            if (!length2) {
              deferred.notifyWith(elem, [animation, 1, 0]);
            }
            deferred.resolveWith(elem, [animation]);
            return false;
          }, animation = deferred.promise({
            elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
              specialEasing: {},
              easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
              var tween = jQuery.Tween(
                elem,
                animation.opts,
                prop,
                end,
                animation.opts.specialEasing[prop] || animation.opts.easing
              );
              animation.tweens.push(tween);
              return tween;
            },
            stop: function(gotoEnd) {
              var index2 = 0, length2 = gotoEnd ? animation.tweens.length : 0;
              if (stopped) {
                return this;
              }
              stopped = true;
              for (; index2 < length2; index2++) {
                animation.tweens[index2].run(1);
              }
              if (gotoEnd) {
                deferred.notifyWith(elem, [animation, 1, 0]);
                deferred.resolveWith(elem, [animation, gotoEnd]);
              } else {
                deferred.rejectWith(elem, [animation, gotoEnd]);
              }
              return this;
            }
          }), props = animation.props;
          propFilter(props, animation.opts.specialEasing);
          for (; index < length; index++) {
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
              if (isFunction2(result.stop)) {
                jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
              }
              return result;
            }
          }
          jQuery.map(props, createTween, animation);
          if (isFunction2(animation.opts.start)) {
            animation.opts.start.call(elem, animation);
          }
          animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
          jQuery.fx.timer(
            jQuery.extend(tick, {
              elem,
              anim: animation,
              queue: animation.opts.queue
            })
          );
          return animation;
        }
        jQuery.Animation = jQuery.extend(Animation, {
          tweeners: {
            "*": [function(prop, value) {
              var tween = this.createTween(prop, value);
              adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
              return tween;
            }]
          },
          tweener: function(props, callback) {
            if (isFunction2(props)) {
              callback = props;
              props = ["*"];
            } else {
              props = props.match(rnothtmlwhite);
            }
            var prop, index = 0, length = props.length;
            for (; index < length; index++) {
              prop = props[index];
              Animation.tweeners[prop] = Animation.tweeners[prop] || [];
              Animation.tweeners[prop].unshift(callback);
            }
          },
          prefilters: [defaultPrefilter],
          prefilter: function(callback, prepend) {
            if (prepend) {
              Animation.prefilters.unshift(callback);
            } else {
              Animation.prefilters.push(callback);
            }
          }
        });
        jQuery.speed = function(speed, easing, fn) {
          var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction2(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction2(easing) && easing
          };
          if (jQuery.fx.off) {
            opt.duration = 0;
          } else {
            if (typeof opt.duration !== "number") {
              if (opt.duration in jQuery.fx.speeds) {
                opt.duration = jQuery.fx.speeds[opt.duration];
              } else {
                opt.duration = jQuery.fx.speeds._default;
              }
            }
          }
          if (opt.queue == null || opt.queue === true) {
            opt.queue = "fx";
          }
          opt.old = opt.complete;
          opt.complete = function() {
            if (isFunction2(opt.old)) {
              opt.old.call(this);
            }
            if (opt.queue) {
              jQuery.dequeue(this, opt.queue);
            }
          };
          return opt;
        };
        jQuery.fn.extend({
          fadeTo: function(speed, to, easing, callback) {
            return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
          },
          animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
              var anim = Animation(this, jQuery.extend({}, prop), optall);
              if (empty || dataPriv.get(this, "finish")) {
                anim.stop(true);
              }
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
          },
          stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
              var stop = hooks.stop;
              delete hooks.stop;
              stop(gotoEnd);
            };
            if (typeof type !== "string") {
              gotoEnd = clearQueue;
              clearQueue = type;
              type = void 0;
            }
            if (clearQueue) {
              this.queue(type || "fx", []);
            }
            return this.each(function() {
              var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
              if (index) {
                if (data[index] && data[index].stop) {
                  stopQueue(data[index]);
                }
              } else {
                for (index in data) {
                  if (data[index] && data[index].stop && rrun.test(index)) {
                    stopQueue(data[index]);
                  }
                }
              }
              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                  timers[index].anim.stop(gotoEnd);
                  dequeue = false;
                  timers.splice(index, 1);
                }
              }
              if (dequeue || !gotoEnd) {
                jQuery.dequeue(this, type);
              }
            });
          },
          finish: function(type) {
            if (type !== false) {
              type = type || "fx";
            }
            return this.each(function() {
              var index, data = dataPriv.get(this), queue2 = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue2 ? queue2.length : 0;
              data.finish = true;
              jQuery.queue(this, type, []);
              if (hooks && hooks.stop) {
                hooks.stop.call(this, true);
              }
              for (index = timers.length; index--; ) {
                if (timers[index].elem === this && timers[index].queue === type) {
                  timers[index].anim.stop(true);
                  timers.splice(index, 1);
                }
              }
              for (index = 0; index < length; index++) {
                if (queue2[index] && queue2[index].finish) {
                  queue2[index].finish.call(this);
                }
              }
              delete data.finish;
            });
          }
        });
        jQuery.each(["toggle", "show", "hide"], function(_i, name) {
          var cssFn = jQuery.fn[name];
          jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
          };
        });
        jQuery.each({
          slideDown: genFx("show"),
          slideUp: genFx("hide"),
          slideToggle: genFx("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" }
        }, function(name, props) {
          jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
          };
        });
        jQuery.timers = [];
        jQuery.fx.tick = function() {
          var timer, i = 0, timers = jQuery.timers;
          fxNow = Date.now();
          for (; i < timers.length; i++) {
            timer = timers[i];
            if (!timer() && timers[i] === timer) {
              timers.splice(i--, 1);
            }
          }
          if (!timers.length) {
            jQuery.fx.stop();
          }
          fxNow = void 0;
        };
        jQuery.fx.timer = function(timer) {
          jQuery.timers.push(timer);
          jQuery.fx.start();
        };
        jQuery.fx.interval = 13;
        jQuery.fx.start = function() {
          if (inProgress) {
            return;
          }
          inProgress = true;
          schedule();
        };
        jQuery.fx.stop = function() {
          inProgress = null;
        };
        jQuery.fx.speeds = {
          slow: 600,
          fast: 200,
          // Default speed
          _default: 400
        };
        jQuery.fn.delay = function(time, type) {
          time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
          type = type || "fx";
          return this.queue(type, function(next, hooks) {
            var timeout = window2.setTimeout(next, time);
            hooks.stop = function() {
              window2.clearTimeout(timeout);
            };
          });
        };
        (function() {
          var input = document2.createElement("input"), select = document2.createElement("select"), opt = select.appendChild(document2.createElement("option"));
          input.type = "checkbox";
          support.checkOn = input.value !== "";
          support.optSelected = opt.selected;
          input = document2.createElement("input");
          input.value = "t";
          input.type = "radio";
          support.radioValue = input.value === "t";
        })();
        var boolHook, attrHandle = jQuery.expr.attrHandle;
        jQuery.fn.extend({
          attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
          },
          removeAttr: function(name) {
            return this.each(function() {
              jQuery.removeAttr(this, name);
            });
          }
        });
        jQuery.extend({
          attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            if (nType === 3 || nType === 8 || nType === 2) {
              return;
            }
            if (typeof elem.getAttribute === "undefined") {
              return jQuery.prop(elem, name, value);
            }
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : void 0);
            }
            if (value !== void 0) {
              if (value === null) {
                jQuery.removeAttr(elem, name);
                return;
              }
              if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
                return ret;
              }
              elem.setAttribute(name, value + "");
              return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret;
            }
            ret = jQuery.find.attr(elem, name);
            return ret == null ? void 0 : ret;
          },
          attrHooks: {
            type: {
              set: function(elem, value) {
                if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                  var val = elem.value;
                  elem.setAttribute("type", value);
                  if (val) {
                    elem.value = val;
                  }
                  return value;
                }
              }
            }
          },
          removeAttr: function(elem, value) {
            var name, i = 0, attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) {
              while (name = attrNames[i++]) {
                elem.removeAttribute(name);
              }
            }
          }
        });
        boolHook = {
          set: function(elem, value, name) {
            if (value === false) {
              jQuery.removeAttr(elem, name);
            } else {
              elem.setAttribute(name, name);
            }
            return name;
          }
        };
        jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
          var getter = attrHandle[name] || jQuery.find.attr;
          attrHandle[name] = function(elem, name2, isXML) {
            var ret, handle, lowercaseName = name2.toLowerCase();
            if (!isXML) {
              handle = attrHandle[lowercaseName];
              attrHandle[lowercaseName] = ret;
              ret = getter(elem, name2, isXML) != null ? lowercaseName : null;
              attrHandle[lowercaseName] = handle;
            }
            return ret;
          };
        });
        var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
        jQuery.fn.extend({
          prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
          },
          removeProp: function(name) {
            return this.each(function() {
              delete this[jQuery.propFix[name] || name];
            });
          }
        });
        jQuery.extend({
          prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            if (nType === 3 || nType === 8 || nType === 2) {
              return;
            }
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
              name = jQuery.propFix[name] || name;
              hooks = jQuery.propHooks[name];
            }
            if (value !== void 0) {
              if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
                return ret;
              }
              return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
              return ret;
            }
            return elem[name];
          },
          propHooks: {
            tabIndex: {
              get: function(elem) {
                var tabindex = jQuery.find.attr(elem, "tabindex");
                if (tabindex) {
                  return parseInt(tabindex, 10);
                }
                if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
                  return 0;
                }
                return -1;
              }
            }
          },
          propFix: {
            "for": "htmlFor",
            "class": "className"
          }
        });
        if (!support.optSelected) {
          jQuery.propHooks.selected = {
            get: function(elem) {
              var parent = elem.parentNode;
              if (parent && parent.parentNode) {
                parent.parentNode.selectedIndex;
              }
              return null;
            },
            set: function(elem) {
              var parent = elem.parentNode;
              if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
              }
            }
          };
        }
        jQuery.each([
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable"
        ], function() {
          jQuery.propFix[this.toLowerCase()] = this;
        });
        function stripAndCollapse(value) {
          var tokens = value.match(rnothtmlwhite) || [];
          return tokens.join(" ");
        }
        function getClass(elem) {
          return elem.getAttribute && elem.getAttribute("class") || "";
        }
        function classesToArray(value) {
          if (Array.isArray(value)) {
            return value;
          }
          if (typeof value === "string") {
            return value.match(rnothtmlwhite) || [];
          }
          return [];
        }
        jQuery.fn.extend({
          addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction2(value)) {
              return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
              });
            }
            classNames = classesToArray(value);
            if (classNames.length) {
              return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                  for (i = 0; i < classNames.length; i++) {
                    className = classNames[i];
                    if (cur.indexOf(" " + className + " ") < 0) {
                      cur += className + " ";
                    }
                  }
                  finalValue = stripAndCollapse(cur);
                  if (curValue !== finalValue) {
                    this.setAttribute("class", finalValue);
                  }
                }
              });
            }
            return this;
          },
          removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction2(value)) {
              return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
              });
            }
            if (!arguments.length) {
              return this.attr("class", "");
            }
            classNames = classesToArray(value);
            if (classNames.length) {
              return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                  for (i = 0; i < classNames.length; i++) {
                    className = classNames[i];
                    while (cur.indexOf(" " + className + " ") > -1) {
                      cur = cur.replace(" " + className + " ", " ");
                    }
                  }
                  finalValue = stripAndCollapse(cur);
                  if (curValue !== finalValue) {
                    this.setAttribute("class", finalValue);
                  }
                }
              });
            }
            return this;
          },
          toggleClass: function(value, stateVal) {
            var classNames, className, i, self2, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction2(value)) {
              return this.each(function(i2) {
                jQuery(this).toggleClass(
                  value.call(this, i2, getClass(this), stateVal),
                  stateVal
                );
              });
            }
            if (typeof stateVal === "boolean" && isValidValue) {
              return stateVal ? this.addClass(value) : this.removeClass(value);
            }
            classNames = classesToArray(value);
            return this.each(function() {
              if (isValidValue) {
                self2 = jQuery(this);
                for (i = 0; i < classNames.length; i++) {
                  className = classNames[i];
                  if (self2.hasClass(className)) {
                    self2.removeClass(className);
                  } else {
                    self2.addClass(className);
                  }
                }
              } else if (value === void 0 || type === "boolean") {
                className = getClass(this);
                if (className) {
                  dataPriv.set(this, "__className__", className);
                }
                if (this.setAttribute) {
                  this.setAttribute(
                    "class",
                    className || value === false ? "" : dataPriv.get(this, "__className__") || ""
                  );
                }
              }
            });
          },
          hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while (elem = this[i++]) {
              if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
                return true;
              }
            }
            return false;
          }
        });
        var rreturn = /\r/g;
        jQuery.fn.extend({
          val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
              if (elem) {
                hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== void 0) {
                  return ret;
                }
                ret = elem.value;
                if (typeof ret === "string") {
                  return ret.replace(rreturn, "");
                }
                return ret == null ? "" : ret;
              }
              return;
            }
            valueIsFunction = isFunction2(value);
            return this.each(function(i) {
              var val;
              if (this.nodeType !== 1) {
                return;
              }
              if (valueIsFunction) {
                val = value.call(this, i, jQuery(this).val());
              } else {
                val = value;
              }
              if (val == null) {
                val = "";
              } else if (typeof val === "number") {
                val += "";
              } else if (Array.isArray(val)) {
                val = jQuery.map(val, function(value2) {
                  return value2 == null ? "" : value2 + "";
                });
              }
              hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
              if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === void 0) {
                this.value = val;
              }
            });
          }
        });
        jQuery.extend({
          valHooks: {
            option: {
              get: function(elem) {
                var val = jQuery.find.attr(elem, "value");
                return val != null ? val : (
                  // Support: IE <=10 - 11 only
                  // option.text throws exceptions (trac-14686, trac-14858)
                  // Strip and collapse whitespace
                  // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                  stripAndCollapse(jQuery.text(elem))
                );
              }
            },
            select: {
              get: function(elem) {
                var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                if (index < 0) {
                  i = max;
                } else {
                  i = one ? index : 0;
                }
                for (; i < max; i++) {
                  option = options[i];
                  if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                  !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                    value = jQuery(option).val();
                    if (one) {
                      return value;
                    }
                    values.push(value);
                  }
                }
                return values;
              },
              set: function(elem, value) {
                var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                while (i--) {
                  option = options[i];
                  if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                    optionSet = true;
                  }
                }
                if (!optionSet) {
                  elem.selectedIndex = -1;
                }
                return values;
              }
            }
          }
        });
        jQuery.each(["radio", "checkbox"], function() {
          jQuery.valHooks[this] = {
            set: function(elem, value) {
              if (Array.isArray(value)) {
                return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
              }
            }
          };
          if (!support.checkOn) {
            jQuery.valHooks[this].get = function(elem) {
              return elem.getAttribute("value") === null ? "on" : elem.value;
            };
          }
        });
        var location2 = window2.location;
        var nonce = { guid: Date.now() };
        var rquery = /\?/;
        jQuery.parseXML = function(data) {
          var xml, parserErrorElem;
          if (!data || typeof data !== "string") {
            return null;
          }
          try {
            xml = new window2.DOMParser().parseFromString(data, "text/xml");
          } catch (e) {
          }
          parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
          if (!xml || parserErrorElem) {
            jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
              return el.textContent;
            }).join("\n") : data));
          }
          return xml;
        };
        var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
          e.stopPropagation();
        };
        jQuery.extend(jQuery.event, {
          trigger: function(event2, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document2], type = hasOwn2.call(event2, "type") ? event2.type : event2, namespaces = hasOwn2.call(event2, "namespace") ? event2.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document2;
            if (elem.nodeType === 3 || elem.nodeType === 8) {
              return;
            }
            if (rfocusMorph.test(type + jQuery.event.triggered)) {
              return;
            }
            if (type.indexOf(".") > -1) {
              namespaces = type.split(".");
              type = namespaces.shift();
              namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            event2 = event2[jQuery.expando] ? event2 : new jQuery.Event(type, typeof event2 === "object" && event2);
            event2.isTrigger = onlyHandlers ? 2 : 3;
            event2.namespace = namespaces.join(".");
            event2.rnamespace = event2.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            event2.result = void 0;
            if (!event2.target) {
              event2.target = elem;
            }
            data = data == null ? [event2] : jQuery.makeArray(data, [event2]);
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
              return;
            }
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
              bubbleType = special.delegateType || type;
              if (!rfocusMorph.test(bubbleType + type)) {
                cur = cur.parentNode;
              }
              for (; cur; cur = cur.parentNode) {
                eventPath.push(cur);
                tmp = cur;
              }
              if (tmp === (elem.ownerDocument || document2)) {
                eventPath.push(tmp.defaultView || tmp.parentWindow || window2);
              }
            }
            i = 0;
            while ((cur = eventPath[i++]) && !event2.isPropagationStopped()) {
              lastElement = cur;
              event2.type = i > 1 ? bubbleType : special.bindType || type;
              handle = (dataPriv.get(cur, "events") || /* @__PURE__ */ Object.create(null))[event2.type] && dataPriv.get(cur, "handle");
              if (handle) {
                handle.apply(cur, data);
              }
              handle = ontype && cur[ontype];
              if (handle && handle.apply && acceptData(cur)) {
                event2.result = handle.apply(cur, data);
                if (event2.result === false) {
                  event2.preventDefault();
                }
              }
            }
            event2.type = type;
            if (!onlyHandlers && !event2.isDefaultPrevented()) {
              if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
                if (ontype && isFunction2(elem[type]) && !isWindow(elem)) {
                  tmp = elem[ontype];
                  if (tmp) {
                    elem[ontype] = null;
                  }
                  jQuery.event.triggered = type;
                  if (event2.isPropagationStopped()) {
                    lastElement.addEventListener(type, stopPropagationCallback);
                  }
                  elem[type]();
                  if (event2.isPropagationStopped()) {
                    lastElement.removeEventListener(type, stopPropagationCallback);
                  }
                  jQuery.event.triggered = void 0;
                  if (tmp) {
                    elem[ontype] = tmp;
                  }
                }
              }
            }
            return event2.result;
          },
          // Piggyback on a donor event to simulate a different one
          // Used only for `focus(in | out)` events
          simulate: function(type, elem, event2) {
            var e = jQuery.extend(
              new jQuery.Event(),
              event2,
              {
                type,
                isSimulated: true
              }
            );
            jQuery.event.trigger(e, null, elem);
          }
        });
        jQuery.fn.extend({
          trigger: function(type, data) {
            return this.each(function() {
              jQuery.event.trigger(type, data, this);
            });
          },
          triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) {
              return jQuery.event.trigger(type, data, elem, true);
            }
          }
        });
        var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
        function buildParams(prefix, obj, traditional, add) {
          var name;
          if (Array.isArray(obj)) {
            jQuery.each(obj, function(i, v) {
              if (traditional || rbracket.test(prefix)) {
                add(prefix, v);
              } else {
                buildParams(
                  prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
                  v,
                  traditional,
                  add
                );
              }
            });
          } else if (!traditional && toType(obj) === "object") {
            for (name in obj) {
              buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
            }
          } else {
            add(prefix, obj);
          }
        }
        jQuery.param = function(a, traditional) {
          var prefix, s = [], add = function(key, valueOrFunction) {
            var value = isFunction2(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
          };
          if (a == null) {
            return "";
          }
          if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
            jQuery.each(a, function() {
              add(this.name, this.value);
            });
          } else {
            for (prefix in a) {
              buildParams(prefix, a[prefix], traditional, add);
            }
          }
          return s.join("&");
        };
        jQuery.fn.extend({
          serialize: function() {
            return jQuery.param(this.serializeArray());
          },
          serializeArray: function() {
            return this.map(function() {
              var elements = jQuery.prop(this, "elements");
              return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
              var type = this.type;
              return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
              var val = jQuery(this).val();
              if (val == null) {
                return null;
              }
              if (Array.isArray(val)) {
                return jQuery.map(val, function(val2) {
                  return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
                });
              }
              return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
            }).get();
          }
        });
        var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, prefilters = {}, transports = {}, allTypes = "*/".concat("*"), originAnchor = document2.createElement("a");
        originAnchor.href = location2.href;
        function addToPrefiltersOrTransports(structure) {
          return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
              func = dataTypeExpression;
              dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction2(func)) {
              while (dataType = dataTypes[i++]) {
                if (dataType[0] === "+") {
                  dataType = dataType.slice(1) || "*";
                  (structure[dataType] = structure[dataType] || []).unshift(func);
                } else {
                  (structure[dataType] = structure[dataType] || []).push(func);
                }
              }
            }
          };
        }
        function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
          var inspected = {}, seekingTransport = structure === transports;
          function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
              var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
              if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                options.dataTypes.unshift(dataTypeOrTransport);
                inspect(dataTypeOrTransport);
                return false;
              } else if (seekingTransport) {
                return !(selected = dataTypeOrTransport);
              }
            });
            return selected;
          }
          return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
        }
        function ajaxExtend(target, src) {
          var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
          for (key in src) {
            if (src[key] !== void 0) {
              (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
            }
          }
          if (deep) {
            jQuery.extend(true, target, deep);
          }
          return target;
        }
        function ajaxHandleResponses(s, jqXHR, responses) {
          var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
          while (dataTypes[0] === "*") {
            dataTypes.shift();
            if (ct === void 0) {
              ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
            }
          }
          if (ct) {
            for (type in contents) {
              if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
              }
            }
          }
          if (dataTypes[0] in responses) {
            finalDataType = dataTypes[0];
          } else {
            for (type in responses) {
              if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                finalDataType = type;
                break;
              }
              if (!firstDataType) {
                firstDataType = type;
              }
            }
            finalDataType = finalDataType || firstDataType;
          }
          if (finalDataType) {
            if (finalDataType !== dataTypes[0]) {
              dataTypes.unshift(finalDataType);
            }
            return responses[finalDataType];
          }
        }
        function ajaxConvert(s, response, jqXHR, isSuccess) {
          var conv2, current, conv, tmp, prev, converters = {}, dataTypes = s.dataTypes.slice();
          if (dataTypes[1]) {
            for (conv in s.converters) {
              converters[conv.toLowerCase()] = s.converters[conv];
            }
          }
          current = dataTypes.shift();
          while (current) {
            if (s.responseFields[current]) {
              jqXHR[s.responseFields[current]] = response;
            }
            if (!prev && isSuccess && s.dataFilter) {
              response = s.dataFilter(response, s.dataType);
            }
            prev = current;
            current = dataTypes.shift();
            if (current) {
              if (current === "*") {
                current = prev;
              } else if (prev !== "*" && prev !== current) {
                conv = converters[prev + " " + current] || converters["* " + current];
                if (!conv) {
                  for (conv2 in converters) {
                    tmp = conv2.split(" ");
                    if (tmp[1] === current) {
                      conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                      if (conv) {
                        if (conv === true) {
                          conv = converters[conv2];
                        } else if (converters[conv2] !== true) {
                          current = tmp[0];
                          dataTypes.unshift(tmp[1]);
                        }
                        break;
                      }
                    }
                  }
                }
                if (conv !== true) {
                  if (conv && s.throws) {
                    response = conv(response);
                  } else {
                    try {
                      response = conv(response);
                    } catch (e) {
                      return {
                        state: "parsererror",
                        error: conv ? e : "No conversion from " + prev + " to " + current
                      };
                    }
                  }
                }
              }
            }
          }
          return { state: "success", data: response };
        }
        jQuery.extend({
          // Counter for holding the number of active queries
          active: 0,
          // Last-Modified header cache for next request
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: location2.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location2.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
            timeout: 0,
            data: null,
            dataType: null,
            username: null,
            password: null,
            cache: null,
            throws: false,
            traditional: false,
            headers: {},
            */
            accepts: {
              "*": allTypes,
              text: "text/plain",
              html: "text/html",
              xml: "application/xml, text/xml",
              json: "application/json, text/javascript"
            },
            contents: {
              xml: /\bxml\b/,
              html: /\bhtml/,
              json: /\bjson\b/
            },
            responseFields: {
              xml: "responseXML",
              text: "responseText",
              json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
              // Convert anything to text
              "* text": String,
              // Text to html (true = no transformation)
              "text html": true,
              // Evaluate text as a json expression
              "text json": JSON.parse,
              // Parse text as xml
              "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
              url: true,
              context: true
            }
          },
          // Creates a full fledged settings object into target
          // with both ajaxSettings and settings fields.
          // If target is omitted, writes into ajaxSettings.
          ajaxSetup: function(target, settings) {
            return settings ? (
              // Building a settings object
              ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
            ) : (
              // Extending ajaxSettings
              ajaxExtend(jQuery.ajaxSettings, target)
            );
          },
          ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
          ajaxTransport: addToPrefiltersOrTransports(transports),
          // Main method
          ajax: function(url, options) {
            if (typeof url === "object") {
              options = url;
              url = void 0;
            }
            options = options || {};
            var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed2, fireGlobals, i, uncached, s = jQuery.ajaxSetup({}, options), callbackContext = s.context || s, globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), statusCode = s.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, strAbort = "canceled", jqXHR = {
              readyState: 0,
              // Builds headers hashtable if needed
              getResponseHeader: function(key) {
                var match;
                if (completed2) {
                  if (!responseHeaders) {
                    responseHeaders = {};
                    while (match = rheaders.exec(responseHeadersString)) {
                      responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                    }
                  }
                  match = responseHeaders[key.toLowerCase() + " "];
                }
                return match == null ? null : match.join(", ");
              },
              // Raw string
              getAllResponseHeaders: function() {
                return completed2 ? responseHeadersString : null;
              },
              // Caches the header
              setRequestHeader: function(name, value) {
                if (completed2 == null) {
                  name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                  requestHeaders[name] = value;
                }
                return this;
              },
              // Overrides response content-type header
              overrideMimeType: function(type) {
                if (completed2 == null) {
                  s.mimeType = type;
                }
                return this;
              },
              // Status-dependent callbacks
              statusCode: function(map) {
                var code;
                if (map) {
                  if (completed2) {
                    jqXHR.always(map[jqXHR.status]);
                  } else {
                    for (code in map) {
                      statusCode[code] = [statusCode[code], map[code]];
                    }
                  }
                }
                return this;
              },
              // Cancel the request
              abort: function(statusText) {
                var finalText = statusText || strAbort;
                if (transport) {
                  transport.abort(finalText);
                }
                done(0, finalText);
                return this;
              }
            };
            deferred.promise(jqXHR);
            s.url = ((url || s.url || location2.href) + "").replace(rprotocol, location2.protocol + "//");
            s.type = options.method || options.type || s.method || s.type;
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
            if (s.crossDomain == null) {
              urlAnchor = document2.createElement("a");
              try {
                urlAnchor.href = s.url;
                urlAnchor.href = urlAnchor.href;
                s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
              } catch (e) {
                s.crossDomain = true;
              }
            }
            if (s.data && s.processData && typeof s.data !== "string") {
              s.data = jQuery.param(s.data, s.traditional);
            }
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            if (completed2) {
              return jqXHR;
            }
            fireGlobals = jQuery.event && s.global;
            if (fireGlobals && jQuery.active++ === 0) {
              jQuery.event.trigger("ajaxStart");
            }
            s.type = s.type.toUpperCase();
            s.hasContent = !rnoContent.test(s.type);
            cacheURL = s.url.replace(rhash, "");
            if (!s.hasContent) {
              uncached = s.url.slice(cacheURL.length);
              if (s.data && (s.processData || typeof s.data === "string")) {
                cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                delete s.data;
              }
              if (s.cache === false) {
                cacheURL = cacheURL.replace(rantiCache, "$1");
                uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
              }
              s.url = cacheURL + uncached;
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
              s.data = s.data.replace(r20, "+");
            }
            if (s.ifModified) {
              if (jQuery.lastModified[cacheURL]) {
                jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
              }
              if (jQuery.etag[cacheURL]) {
                jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
              }
            }
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
              jqXHR.setRequestHeader("Content-Type", s.contentType);
            }
            jqXHR.setRequestHeader(
              "Accept",
              s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]
            );
            for (i in s.headers) {
              jqXHR.setRequestHeader(i, s.headers[i]);
            }
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed2)) {
              return jqXHR.abort();
            }
            strAbort = "abort";
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            if (!transport) {
              done(-1, "No Transport");
            } else {
              jqXHR.readyState = 1;
              if (fireGlobals) {
                globalEventContext.trigger("ajaxSend", [jqXHR, s]);
              }
              if (completed2) {
                return jqXHR;
              }
              if (s.async && s.timeout > 0) {
                timeoutTimer = window2.setTimeout(function() {
                  jqXHR.abort("timeout");
                }, s.timeout);
              }
              try {
                completed2 = false;
                transport.send(requestHeaders, done);
              } catch (e) {
                if (completed2) {
                  throw e;
                }
                done(-1, e);
              }
            }
            function done(status, nativeStatusText, responses, headers) {
              var isSuccess, success, error, response, modified, statusText = nativeStatusText;
              if (completed2) {
                return;
              }
              completed2 = true;
              if (timeoutTimer) {
                window2.clearTimeout(timeoutTimer);
              }
              transport = void 0;
              responseHeadersString = headers || "";
              jqXHR.readyState = status > 0 ? 4 : 0;
              isSuccess = status >= 200 && status < 300 || status === 304;
              if (responses) {
                response = ajaxHandleResponses(s, jqXHR, responses);
              }
              if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
                s.converters["text script"] = function() {
                };
              }
              response = ajaxConvert(s, response, jqXHR, isSuccess);
              if (isSuccess) {
                if (s.ifModified) {
                  modified = jqXHR.getResponseHeader("Last-Modified");
                  if (modified) {
                    jQuery.lastModified[cacheURL] = modified;
                  }
                  modified = jqXHR.getResponseHeader("etag");
                  if (modified) {
                    jQuery.etag[cacheURL] = modified;
                  }
                }
                if (status === 204 || s.type === "HEAD") {
                  statusText = "nocontent";
                } else if (status === 304) {
                  statusText = "notmodified";
                } else {
                  statusText = response.state;
                  success = response.data;
                  error = response.error;
                  isSuccess = !error;
                }
              } else {
                error = statusText;
                if (status || !statusText) {
                  statusText = "error";
                  if (status < 0) {
                    status = 0;
                  }
                }
              }
              jqXHR.status = status;
              jqXHR.statusText = (nativeStatusText || statusText) + "";
              if (isSuccess) {
                deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
              } else {
                deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
              }
              jqXHR.statusCode(statusCode);
              statusCode = void 0;
              if (fireGlobals) {
                globalEventContext.trigger(
                  isSuccess ? "ajaxSuccess" : "ajaxError",
                  [jqXHR, s, isSuccess ? success : error]
                );
              }
              completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
              if (fireGlobals) {
                globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
                if (!--jQuery.active) {
                  jQuery.event.trigger("ajaxStop");
                }
              }
            }
            return jqXHR;
          },
          getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
          },
          getScript: function(url, callback) {
            return jQuery.get(url, void 0, callback, "script");
          }
        });
        jQuery.each(["get", "post"], function(_i, method) {
          jQuery[method] = function(url, data, callback, type) {
            if (isFunction2(data)) {
              type = type || callback;
              callback = data;
              data = void 0;
            }
            return jQuery.ajax(jQuery.extend({
              url,
              type: method,
              dataType: type,
              data,
              success: callback
            }, jQuery.isPlainObject(url) && url));
          };
        });
        jQuery.ajaxPrefilter(function(s) {
          var i;
          for (i in s.headers) {
            if (i.toLowerCase() === "content-type") {
              s.contentType = s.headers[i] || "";
            }
          }
        });
        jQuery._evalUrl = function(url, options, doc2) {
          return jQuery.ajax({
            url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
              "text script": function() {
              }
            },
            dataFilter: function(response) {
              jQuery.globalEval(response, options, doc2);
            }
          });
        };
        jQuery.fn.extend({
          wrapAll: function(html) {
            var wrap;
            if (this[0]) {
              if (isFunction2(html)) {
                html = html.call(this[0]);
              }
              wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
              if (this[0].parentNode) {
                wrap.insertBefore(this[0]);
              }
              wrap.map(function() {
                var elem = this;
                while (elem.firstElementChild) {
                  elem = elem.firstElementChild;
                }
                return elem;
              }).append(this);
            }
            return this;
          },
          wrapInner: function(html) {
            if (isFunction2(html)) {
              return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
              });
            }
            return this.each(function() {
              var self2 = jQuery(this), contents = self2.contents();
              if (contents.length) {
                contents.wrapAll(html);
              } else {
                self2.append(html);
              }
            });
          },
          wrap: function(html) {
            var htmlIsFunction = isFunction2(html);
            return this.each(function(i) {
              jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
          },
          unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
              jQuery(this).replaceWith(this.childNodes);
            });
            return this;
          }
        });
        jQuery.expr.pseudos.hidden = function(elem) {
          return !jQuery.expr.pseudos.visible(elem);
        };
        jQuery.expr.pseudos.visible = function(elem) {
          return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };
        jQuery.ajaxSettings.xhr = function() {
          try {
            return new window2.XMLHttpRequest();
          } catch (e) {
          }
        };
        var xhrSuccessStatus = {
          // File protocol always yields status code 0, assume 200
          0: 200,
          // Support: IE <=9 only
          // trac-1450: sometimes IE returns 1223 when it should be 204
          1223: 204
        }, xhrSupported = jQuery.ajaxSettings.xhr();
        support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
        support.ajax = xhrSupported = !!xhrSupported;
        jQuery.ajaxTransport(function(options) {
          var callback, errorCallback;
          if (support.cors || xhrSupported && !options.crossDomain) {
            return {
              send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(
                  options.type,
                  options.url,
                  options.async,
                  options.username,
                  options.password
                );
                if (options.xhrFields) {
                  for (i in options.xhrFields) {
                    xhr[i] = options.xhrFields[i];
                  }
                }
                if (options.mimeType && xhr.overrideMimeType) {
                  xhr.overrideMimeType(options.mimeType);
                }
                if (!options.crossDomain && !headers["X-Requested-With"]) {
                  headers["X-Requested-With"] = "XMLHttpRequest";
                }
                for (i in headers) {
                  xhr.setRequestHeader(i, headers[i]);
                }
                callback = function(type) {
                  return function() {
                    if (callback) {
                      callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                      if (type === "abort") {
                        xhr.abort();
                      } else if (type === "error") {
                        if (typeof xhr.status !== "number") {
                          complete(0, "error");
                        } else {
                          complete(
                            // File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status,
                            xhr.statusText
                          );
                        }
                      } else {
                        complete(
                          xhrSuccessStatus[xhr.status] || xhr.status,
                          xhr.statusText,
                          // Support: IE <=9 only
                          // IE9 has no XHR2 but throws on binary (trac-11426)
                          // For XHR2 non-text, let the caller handle it (gh-2498)
                          (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText },
                          xhr.getAllResponseHeaders()
                        );
                      }
                    }
                  };
                };
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                if (xhr.onabort !== void 0) {
                  xhr.onabort = errorCallback;
                } else {
                  xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                      window2.setTimeout(function() {
                        if (callback) {
                          errorCallback();
                        }
                      });
                    }
                  };
                }
                callback = callback("abort");
                try {
                  xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                  if (callback) {
                    throw e;
                  }
                }
              },
              abort: function() {
                if (callback) {
                  callback();
                }
              }
            };
          }
        });
        jQuery.ajaxPrefilter(function(s) {
          if (s.crossDomain) {
            s.contents.script = false;
          }
        });
        jQuery.ajaxSetup({
          accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
          },
          contents: {
            script: /\b(?:java|ecma)script\b/
          },
          converters: {
            "text script": function(text) {
              jQuery.globalEval(text);
              return text;
            }
          }
        });
        jQuery.ajaxPrefilter("script", function(s) {
          if (s.cache === void 0) {
            s.cache = false;
          }
          if (s.crossDomain) {
            s.type = "GET";
          }
        });
        jQuery.ajaxTransport("script", function(s) {
          if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
              send: function(_, complete) {
                script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", callback = function(evt) {
                  script.remove();
                  callback = null;
                  if (evt) {
                    complete(evt.type === "error" ? 404 : 200, evt.type);
                  }
                });
                document2.head.appendChild(script[0]);
              },
              abort: function() {
                if (callback) {
                  callback();
                }
              }
            };
          }
        });
        var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
        jQuery.ajaxSetup({
          jsonp: "callback",
          jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
          }
        });
        jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
          var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
          if (jsonProp || s.dataTypes[0] === "jsonp") {
            callbackName = s.jsonpCallback = isFunction2(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            if (jsonProp) {
              s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            } else if (s.jsonp !== false) {
              s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            }
            s.converters["script json"] = function() {
              if (!responseContainer) {
                jQuery.error(callbackName + " was not called");
              }
              return responseContainer[0];
            };
            s.dataTypes[0] = "json";
            overwritten = window2[callbackName];
            window2[callbackName] = function() {
              responseContainer = arguments;
            };
            jqXHR.always(function() {
              if (overwritten === void 0) {
                jQuery(window2).removeProp(callbackName);
              } else {
                window2[callbackName] = overwritten;
              }
              if (s[callbackName]) {
                s.jsonpCallback = originalSettings.jsonpCallback;
                oldCallbacks.push(callbackName);
              }
              if (responseContainer && isFunction2(overwritten)) {
                overwritten(responseContainer[0]);
              }
              responseContainer = overwritten = void 0;
            });
            return "script";
          }
        });
        support.createHTMLDocument = (function() {
          var body = document2.implementation.createHTMLDocument("").body;
          body.innerHTML = "<form></form><form></form>";
          return body.childNodes.length === 2;
        })();
        jQuery.parseHTML = function(data, context, keepScripts) {
          if (typeof data !== "string") {
            return [];
          }
          if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
          }
          var base, parsed, scripts;
          if (!context) {
            if (support.createHTMLDocument) {
              context = document2.implementation.createHTMLDocument("");
              base = context.createElement("base");
              base.href = document2.location.href;
              context.head.appendChild(base);
            } else {
              context = document2;
            }
          }
          parsed = rsingleTag.exec(data);
          scripts = !keepScripts && [];
          if (parsed) {
            return [context.createElement(parsed[1])];
          }
          parsed = buildFragment([data], context, scripts);
          if (scripts && scripts.length) {
            jQuery(scripts).remove();
          }
          return jQuery.merge([], parsed.childNodes);
        };
        jQuery.fn.load = function(url, params, callback) {
          var selector, type, response, self2 = this, off = url.indexOf(" ");
          if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
          }
          if (isFunction2(params)) {
            callback = params;
            params = void 0;
          } else if (params && typeof params === "object") {
            type = "POST";
          }
          if (self2.length > 0) {
            jQuery.ajax({
              url,
              // If "type" variable is undefined, then "GET" method will be used.
              // Make value of this field explicit since
              // user can override it through ajaxSetup method
              type: type || "GET",
              dataType: "html",
              data: params
            }).done(function(responseText) {
              response = arguments;
              self2.html(selector ? (
                // If a selector was specified, locate the right elements in a dummy div
                // Exclude scripts to avoid IE 'Permission Denied' errors
                jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector)
              ) : (
                // Otherwise use the full result
                responseText
              ));
            }).always(callback && function(jqXHR, status) {
              self2.each(function() {
                callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
              });
            });
          }
          return this;
        };
        jQuery.expr.pseudos.animated = function(elem) {
          return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
          }).length;
        };
        jQuery.offset = {
          setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            if (position === "static") {
              elem.style.position = "relative";
            }
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            if (calculatePosition) {
              curPosition = curElem.position();
              curTop = curPosition.top;
              curLeft = curPosition.left;
            } else {
              curTop = parseFloat(curCSSTop) || 0;
              curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction2(options)) {
              options = options.call(elem, i, jQuery.extend({}, curOffset));
            }
            if (options.top != null) {
              props.top = options.top - curOffset.top + curTop;
            }
            if (options.left != null) {
              props.left = options.left - curOffset.left + curLeft;
            }
            if ("using" in options) {
              options.using.call(elem, props);
            } else {
              curElem.css(props);
            }
          }
        };
        jQuery.fn.extend({
          // offset() relates an element's border box to the document origin
          offset: function(options) {
            if (arguments.length) {
              return options === void 0 ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
              });
            }
            var rect, win, elem = this[0];
            if (!elem) {
              return;
            }
            if (!elem.getClientRects().length) {
              return { top: 0, left: 0 };
            }
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
              top: rect.top + win.pageYOffset,
              left: rect.left + win.pageXOffset
            };
          },
          // position() relates an element's margin box to its offset parent's padding box
          // This corresponds to the behavior of CSS absolute positioning
          position: function() {
            if (!this[0]) {
              return;
            }
            var offsetParent, offset, doc2, elem = this[0], parentOffset = { top: 0, left: 0 };
            if (jQuery.css(elem, "position") === "fixed") {
              offset = elem.getBoundingClientRect();
            } else {
              offset = this.offset();
              doc2 = elem.ownerDocument;
              offsetParent = elem.offsetParent || doc2.documentElement;
              while (offsetParent && (offsetParent === doc2.body || offsetParent === doc2.documentElement) && jQuery.css(offsetParent, "position") === "static") {
                offsetParent = offsetParent.parentNode;
              }
              if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                parentOffset = jQuery(offsetParent).offset();
                parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
              }
            }
            return {
              top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
              left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
          },
          // This method will return documentElement in the following cases:
          // 1) For the element inside the iframe without offsetParent, this method will return
          //    documentElement of the parent window
          // 2) For the hidden or detached element
          // 3) For body or html element, i.e. in case of the html node - it will return itself
          //
          // but those exceptions were never presented as a real life use-cases
          // and might be considered as more preferable results.
          //
          // This logic, however, is not guaranteed and can change at any point in the future
          offsetParent: function() {
            return this.map(function() {
              var offsetParent = this.offsetParent;
              while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
                offsetParent = offsetParent.offsetParent;
              }
              return offsetParent || documentElement;
            });
          }
        });
        jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
          var top = "pageYOffset" === prop;
          jQuery.fn[method] = function(val) {
            return access(this, function(elem, method2, val2) {
              var win;
              if (isWindow(elem)) {
                win = elem;
              } else if (elem.nodeType === 9) {
                win = elem.defaultView;
              }
              if (val2 === void 0) {
                return win ? win[prop] : elem[method2];
              }
              if (win) {
                win.scrollTo(
                  !top ? val2 : win.pageXOffset,
                  top ? val2 : win.pageYOffset
                );
              } else {
                elem[method2] = val2;
              }
            }, method, val, arguments.length);
          };
        });
        jQuery.each(["top", "left"], function(_i, prop) {
          jQuery.cssHooks[prop] = addGetHookIf(
            support.pixelPosition,
            function(elem, computed2) {
              if (computed2) {
                computed2 = curCSS(elem, prop);
                return rnumnonpx.test(computed2) ? jQuery(elem).position()[prop] + "px" : computed2;
              }
            }
          );
        });
        jQuery.each({ Height: "height", Width: "width" }, function(name, type) {
          jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
          }, function(defaultExtra, funcName) {
            jQuery.fn[funcName] = function(margin, value) {
              var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
              return access(this, function(elem, type2, value2) {
                var doc2;
                if (isWindow(elem)) {
                  return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                }
                if (elem.nodeType === 9) {
                  doc2 = elem.documentElement;
                  return Math.max(
                    elem.body["scroll" + name],
                    doc2["scroll" + name],
                    elem.body["offset" + name],
                    doc2["offset" + name],
                    doc2["client" + name]
                  );
                }
                return value2 === void 0 ? (
                  // Get width or height on the element, requesting but not forcing parseFloat
                  jQuery.css(elem, type2, extra)
                ) : (
                  // Set width or height on the element
                  jQuery.style(elem, type2, value2, extra)
                );
              }, type, chainable ? margin : void 0, chainable);
            };
          });
        });
        jQuery.each([
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend"
        ], function(_i, type) {
          jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
          };
        });
        jQuery.fn.extend({
          bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
          },
          unbind: function(types, fn) {
            return this.off(types, null, fn);
          },
          delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
          },
          undelegate: function(selector, types, fn) {
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
          },
          hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
          }
        });
        jQuery.each(
          "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
          function(_i, name) {
            jQuery.fn[name] = function(data, fn) {
              return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
            };
          }
        );
        var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
        jQuery.proxy = function(fn, context) {
          var tmp, args, proxy;
          if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
          }
          if (!isFunction2(fn)) {
            return void 0;
          }
          args = slice.call(arguments, 2);
          proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
          };
          proxy.guid = fn.guid = fn.guid || jQuery.guid++;
          return proxy;
        };
        jQuery.holdReady = function(hold) {
          if (hold) {
            jQuery.readyWait++;
          } else {
            jQuery.ready(true);
          }
        };
        jQuery.isArray = Array.isArray;
        jQuery.parseJSON = JSON.parse;
        jQuery.nodeName = nodeName;
        jQuery.isFunction = isFunction2;
        jQuery.isWindow = isWindow;
        jQuery.camelCase = camelCase;
        jQuery.type = toType;
        jQuery.now = Date.now;
        jQuery.isNumeric = function(obj) {
          var type = jQuery.type(obj);
          return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
          // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
          // subtraction forces infinities to NaN
          !isNaN(obj - parseFloat(obj));
        };
        jQuery.trim = function(text) {
          return text == null ? "" : (text + "").replace(rtrim, "$1");
        };
        var _jQuery = window2.jQuery, _$ = window2.$;
        jQuery.noConflict = function(deep) {
          if (window2.$ === jQuery) {
            window2.$ = _$;
          }
          if (deep && window2.jQuery === jQuery) {
            window2.jQuery = _jQuery;
          }
          return jQuery;
        };
        if (typeof noGlobal === "undefined") {
          window2.jQuery = window2.$ = jQuery;
        }
        return jQuery;
      });
    })(jquery$1);
    return jquery$1.exports;
  }
  var jqueryExports = requireJquery();
  const $ = /* @__PURE__ */ getDefaultExportFromCjs(jqueryExports);
  const functions = {
    /**
     * Check if current date is within the valid range
     * @param {string} startDate - Start date in format "YYYY-MM-DD"
     * @param {string} endDate - End date in format "YYYY-MM-DD"
     * @returns {boolean} - True if current date is within range
     */
    isCurrentDateActive(startDate, endDate) {
      if (!startDate || !endDate) {
        console.warn("[functions] Sale price missing dates, returning false");
        return false;
      }
      console.log("[functions] Checking date validity:", {
        startDate,
        endDate
      });
      let currentDate = /* @__PURE__ */ new Date();
      currentDate.setHours(0, 0, 0, 0);
      let effectiveDate = new Date(startDate);
      effectiveDate.setHours(0, 0, 0, 0);
      let terminationDate = new Date(endDate);
      terminationDate.setHours(23, 59, 59, 999);
      const isValid = currentDate >= effectiveDate && currentDate <= terminationDate;
      console.log("[functions] Date check result:", {
        today: currentDate.toISOString().split("T")[0],
        effectiveDate: startDate,
        terminationDate: endDate,
        isValid
      });
      return isValid;
    },
    /**
     * Check if tier has valid sale price with active dates
     * @param {Object} tierLine - Tier price object
     * @returns {boolean} - True if sale price is valid and active
     */
    isValidatedSpecialPrice(tierLine) {
      if (!tierLine || typeof tierLine !== "object") {
        console.warn("[functions] Invalid tierLine object");
        return false;
      }
      if (!Object.prototype.hasOwnProperty.call(tierLine, "sale_price")) {
        return false;
      }
      if (!Object.prototype.hasOwnProperty.call(tierLine, "sale_price_effectivedate") || !Object.prototype.hasOwnProperty.call(tierLine, "sale_price_terminationdate")) {
        console.warn("[functions] Sale price missing dates, using regular price", tierLine);
        return false;
      }
      const isActiveDate = this.isCurrentDateActive(
        tierLine["sale_price_effectivedate"],
        tierLine["sale_price_terminationdate"]
      );
      return isActiveDate;
    },
    getStepText() {
      let stepThreeText = "Add your imprint here. You can choose to add Text, an Image or both! To start, choose where you would like to imprint your product and fill in the required info.";
      if (window.PXUTheme.theme_settings.project_store_name == "comda") {
        stepThreeText = "Add your imprint here. You can choose to add Text, an Image or both! To start, choose where you would like to imprint your product and fill in the required info. You can add one imprint per product online; to add additional imprints please contact us at 800-387-7702.";
      }
      return stepThreeText;
    },
    getB2BPriceForTier(tier, b2bTiers) {
      if (!b2bTiers) return null;
      const entry = b2bTiers.find((t) => Number(t.QtyMin) === Number(tier.QtyMin));
      return entry ? Number(entry.price) : null;
    },
    isCheckboxChecked(jqueryPath = "") {
      let isChecked = false;
      let checkboxes = $(jqueryPath);
      if (jqueryPath) {
        for (const checkbox of checkboxes) {
          if (checkbox.checked) {
            isChecked = true;
          }
        }
      }
      return isChecked;
    }
  };
  const _sfc_main$F = {
    name: "PriceMatrixComponent",
    data() {
      return {
        store,
        functions,
        specialPriceBannerImageUrl: window.PXUTheme.theme_settings.image_special_pricing
        //'https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/banners/special-pricing.png'
      };
    },
    props: {
      applicationType: String,
      isSpecial: Boolean
    },
    computed: {
      hasB2BPricing() {
        return this.store.prices.b2bTier !== null && this.store.prices.b2bTier.length > 0;
      },
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      },
      checkIfSpecial() {
        if (this.hasB2BPricing) return true;
        return Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
      },
      customFont() {
        return this.$getCustomFontClass(store.storeID);
      },
      isComda() {
        return store.storeID.includes("comda");
      },
      getPriceName() {
        let result = "All-In price";
        if (this.isComda) {
          result = this.applicationType == "calendar_single" || this.store.isEnvelopProduct ? "Our Price" : "Price";
        }
        return result;
      }
    },
    methods: {
      isCurrentDateActive(startDate, endDate) {
        let currentDate = /* @__PURE__ */ new Date();
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        console.error("isCurrentDateActive matrix");
        console.warn(startDate);
        console.warn(endDate);
        return currentDate >= startDate && currentDate <= endDate;
      },
      isValidatedSpecialPrice(tierLine) {
        let isActiveDate = false;
        if (Object.prototype.hasOwnProperty.call(tierLine, "sale_price_effectivedate") && Object.prototype.hasOwnProperty.call(tierLine, "sale_price_terminationdate") && Object.prototype.hasOwnProperty.call(tierLine, "sale_price")) {
          isActiveDate = this.isCurrentDateActive(tierLine["sale_price_effectivedate"], tierLine["sale_price_terminationdate"]);
        }
        return isActiveDate;
      },
      isTierColumnSpecial(tierItem) {
        console.log("is special matrix");
        console.warn(this.isValidatedSpecialPrice(tierItem));
        return this.isValidatedSpecialPrice(tierItem);
      }
    },
    created() {
      console.warn("is Special from pricematrix");
      console.log(Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku));
      console.error(this.isSpecial);
      console.log("imprint Tabs data pricematrix");
      console.warn(this.store.prices.tier);
      console.log(this.store.selectedImprint.tabName);
      console.log(this.store.imprintKey);
      console.log(this.store.specialPrice);
    }
  };
  const _hoisted_1$F = { class: "price-matrix__line" };
  const _hoisted_2$y = { class: "price-matrix__line price" };
  const _hoisted_3$w = { class: "price-matrix__line" };
  const _hoisted_4$t = { class: "price-matrix__line" };
  const _hoisted_5$q = { class: "price-matrix__line price" };
  const _hoisted_6$p = { class: "price-matrix__line" };
  const _hoisted_7$m = { class: "price-matrix__line" };
  const _hoisted_8$k = { class: "price-matrix__line" };
  const _hoisted_9$i = { class: "price-matrix__line" };
  const _hoisted_10$i = { class: "price-matrix__line" };
  const _hoisted_11$h = { class: "price-matrix__line price" };
  const _hoisted_12$g = { class: "price-matrix__line special" };
  const _hoisted_13$f = {
    key: 4,
    class: "retail-price banner-included-section"
  };
  const _hoisted_14$d = {
    key: 0,
    class: "product-special-price-section"
  };
  const _hoisted_15$c = { key: 1 };
  const _hoisted_16$c = { class: "retail-price__inline retail-price__inline--special-price" };
  const _hoisted_17$b = { class: "tooltip-icon-wrap" };
  const _hoisted_18$b = {
    key: 5,
    class: "retail-price banner-included-section"
  };
  const _hoisted_19$b = {
    key: 0,
    class: "product-special-price-section"
  };
  const _hoisted_20$b = { key: 1 };
  const _hoisted_21$b = { class: "retail-price__inline retail-price__inline--special-price" };
  const _hoisted_22$a = { class: "tooltip-icon-wrap" };
  function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: normalizeClass(["price-wrap", $data.store.isEnvelopProduct ? "envelop-product" : ""])
    }, [
      $options.isComda && $options.checkIfSpecial ? (openBlock(), createElementBlock("table", {
        key: 0,
        class: normalizeClass(["price-matrix", "price-matrix--table", "price-matrix--special-price", $options.customFont])
      }, [
        createBaseVNode("tr", _hoisted_1$F, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Quantity", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                style: normalizeStyle({ "font-family": $options.isComda ? "Montserrat" : "museo-sans" })
              }, toDisplayString(tier.QtyMin) + "+", 5)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_2$y, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, [
                createBaseVNode("span", {
                  class: normalizeClass([$options.isComda ? "all-in-price_comda" : "all-in-price"])
                }, toDisplayString($options.getPriceName), 3)
              ], 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(
                  $data.functions.isValidatedSpecialPrice(tier) || $data.functions.getB2BPriceForTier(tier, $data.store.prices.b2bTier) !== null ? ["price-matrix__col", "price-matrix__col--price", "special-col", $options.customColor] : ["price-matrix__col", "price-matrix__col--price", $options.customColor]
                ),
                style: normalizeStyle({
                  "font-size": ($options.isComda ? 14 : 12) + "px",
                  "font-weight": ($options.isComda ? 800 : 700) + "!important",
                  "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important"
                })
              }, " $" + toDisplayString(tier.price.toFixed(2)), 7)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_3$w, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Sale Price", 2)) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList([$data.functions.getB2BPriceForTier(tier, $data.store.prices.b2bTier)], (b2bPrice) => {
                return openBlock(), createElementBlock("td", {
                  key: "b2b",
                  class: normalizeClass(["price-matrix__col", $options.isComda ? "price-matrix__col--your-save_comda" : "price-matrix__col--your-save"])
                }, [
                  b2bPrice !== null ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createTextVNode(" $" + toDisplayString(b2bPrice.toFixed(2)), 1)
                  ], 64)) : $data.functions.isValidatedSpecialPrice(tier) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(" $" + toDisplayString(tier["sale_price"].toFixed(2)), 1)
                  ], 64)) : createCommentVNode("", true)
                ], 2);
              }), 128))
            ], 64);
          }), 128))
        ])
      ], 2)) : createCommentVNode("", true),
      $options.isComda && !$options.checkIfSpecial ? (openBlock(), createElementBlock("table", {
        key: 1,
        class: normalizeClass(["price-matrix", "price-matrix--table", $options.customFont])
      }, [
        createBaseVNode("tr", _hoisted_4$t, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Quantity", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                style: normalizeStyle({ "font-family": $options.isComda ? "Montserrat" : "museo-sans" })
              }, toDisplayString(tier.QtyMin) + "+", 5)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_5$q, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, [
                createBaseVNode("span", {
                  class: normalizeClass([$options.isComda ? "all-in-price_comda" : "all-in-price"])
                }, toDisplayString($options.getPriceName), 3)
              ], 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(["price-matrix__col", "price-matrix__col--price", $options.customColor]),
                style: normalizeStyle({
                  "font-size": ($options.isComda ? 14 : 12) + "px",
                  "font-weight": ($options.isComda ? 800 : 700) + "!important",
                  "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important"
                })
              }, " $" + toDisplayString(tier.price.toFixed(2)), 7)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_6$p, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "You Save", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(["price-matrix__col", $options.isComda ? "price-matrix__col--your-save_comda" : "price-matrix__col--your-save"])
              }, toDisplayString(index > 0 ? Math.round(100 - tier.price * 100 / $data.store.prices.tier[0].price) + "%" : ""), 3)
            ], 64);
          }), 128))
        ])
      ], 2)) : createCommentVNode("", true),
      !$options.isComda && !$options.checkIfSpecial ? (openBlock(), createElementBlock("table", {
        key: 2,
        class: normalizeClass(["price-matrix", "price-matrix--table", $options.customFont])
      }, [
        createBaseVNode("tr", _hoisted_7$m, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Quantity", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                style: normalizeStyle({ "font-family": $options.isComda ? "Montserrat" : "museo-sans" })
              }, toDisplayString(tier.QtyMin) + "+", 5)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_8$k, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, [
                createBaseVNode("span", {
                  class: normalizeClass([$options.isComda ? "all-in-price_comda" : "all-in-price"])
                }, toDisplayString($options.getPriceName), 3)
              ], 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(["price-matrix__col", "price-matrix__col--price", $options.customColor]),
                style: normalizeStyle({
                  "font-size": ($options.isComda ? 14 : 12) + "px",
                  "font-weight": ($options.isComda ? 800 : 700) + "!important",
                  "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important"
                })
              }, " $" + toDisplayString(tier.price.toFixed(2)), 7)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_9$i, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "You Save", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(["price-matrix__col", $options.isComda ? "price-matrix__col--your-save_comda" : "price-matrix__col--your-save"])
              }, toDisplayString(index > 0 ? Math.round(100 - tier.price * 100 / $data.store.prices.tier[0].price) + "%" : ""), 3)
            ], 64);
          }), 128))
        ])
      ], 2)) : createCommentVNode("", true),
      !$options.isComda && $options.checkIfSpecial ? (openBlock(), createElementBlock("table", {
        key: 3,
        class: normalizeClass(["price-matrix", "price-matrix--table", "price-matrix--special-price", $options.customFont])
      }, [
        createBaseVNode("tr", _hoisted_10$i, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Quantity", 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                style: normalizeStyle({ "font-family": $options.isComda ? "Montserrat" : "museo-sans" })
              }, toDisplayString(tier.QtyMin) + "+", 5)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_11$h, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, [
                createBaseVNode("span", {
                  class: normalizeClass([$options.isComda ? "all-in-price_comda" : "all-in-price"])
                }, toDisplayString($options.getPriceName), 3)
              ], 2)) : createCommentVNode("", true),
              createBaseVNode("td", {
                class: normalizeClass(
                  $data.functions.isValidatedSpecialPrice(tier) || $data.functions.getB2BPriceForTier(tier, $data.store.prices.b2bTier) !== null ? ["price-matrix__col", "price-matrix__col--price", "special-col", $options.customColor] : ["price-matrix__col", "price-matrix__col--price", $options.customColor]
                ),
                style: normalizeStyle({
                  "font-size": ($options.isComda ? 14 : 12) + "px",
                  "font-weight": ($options.isComda ? 800 : 700) + "!important",
                  "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important"
                })
              }, " $" + toDisplayString(tier.price.toFixed(2)), 7)
            ], 64);
          }), 128))
        ]),
        createBaseVNode("tr", _hoisted_12$g, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices.tier, (tier, index) => {
            return openBlock(), createElementBlock(Fragment, { key: index }, [
              index === 0 ? (openBlock(), createElementBlock("td", {
                key: 0,
                class: normalizeClass([$options.isComda ? "price-matrix__title_comda" : "price-matrix__title"])
              }, "Sale Price", 2)) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList([$data.functions.getB2BPriceForTier(tier, $data.store.prices.b2bTier)], (b2bPrice) => {
                return openBlock(), createElementBlock("td", {
                  key: "b2b",
                  class: normalizeClass(["price-matrix__col", $options.isComda ? "price-matrix__col--your-save_comda" : "price-matrix__col--your-save"])
                }, [
                  b2bPrice !== null ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createTextVNode(" $" + toDisplayString(b2bPrice.toFixed(2)), 1)
                  ], 64)) : $data.functions.isValidatedSpecialPrice(tier) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(" $" + toDisplayString(tier["sale_price"].toFixed(2)), 1)
                  ], 64)) : createCommentVNode("", true)
                ], 2);
              }), 128))
            ], 64);
          }), 128))
        ])
      ], 2)) : createCommentVNode("", true),
      $options.isComda && $data.store.application_type != "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_13$f, [
        $options.checkIfSpecial ? (openBlock(), createElementBlock("div", _hoisted_14$d, [
          createBaseVNode("div", {
            class: "is-comda-product-special",
            style: normalizeStyle(`background-image: url('` + $data.specialPriceBannerImageUrl + `')`)
          }, null, 4)
        ])) : (openBlock(), createElementBlock("div", _hoisted_15$c)),
        createBaseVNode("div", _hoisted_16$c, [
          createBaseVNode("div", _hoisted_17$b, [
            _cache[1] || (_cache[1] = createBaseVNode("span", { class: "tooltip-icon" }, " ?", -1)),
            createBaseVNode("div", {
              class: normalizeClass(["tooltip-content"]),
              style: normalizeStyle({ "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important" })
            }, [..._cache[0] || (_cache[0] = [
              createBaseVNode("b", { style: { "display": "block", "padding-bottom": "10px" } }, " Retail Value ", -1),
              createBaseVNode("span", null, " The cost to buy one of these products, fully customized, at a retail store. ", -1)
            ])], 4)
          ]),
          createBaseVNode("h4", {
            style: normalizeStyle({
              "font-family": ($options.isComda ? "Oswald" : "museo-sans") + "!important",
              "font-weight": ($options.isComda ? "bold" : 900) + "!important",
              "letter-spacing": "normal!important"
            })
          }, " Retail Value: ", 4),
          createBaseVNode("span", {
            class: normalizeClass(["price-matrix__col", "price-matrix__col--price", $options.customColor]),
            style: normalizeStyle({ "font-size": ($options.isComda ? 15 : 12) + "px!important" })
          }, toDisplayString("$" + $data.store.prices.tierMSRP.toFixed(2)), 7)
        ])
      ])) : createCommentVNode("", true),
      !$options.isComda && $data.store.application_type != "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_18$b, [
        $options.checkIfSpecial ? (openBlock(), createElementBlock("div", _hoisted_19$b, [
          createBaseVNode("div", {
            class: "is-comda-product-special",
            style: normalizeStyle(`background-image: url('` + $data.specialPriceBannerImageUrl + `')`)
          }, null, 4)
        ])) : (openBlock(), createElementBlock("div", _hoisted_20$b)),
        createBaseVNode("div", _hoisted_21$b, [
          createBaseVNode("div", _hoisted_22$a, [
            _cache[3] || (_cache[3] = createBaseVNode("span", { class: "tooltip-icon" }, " ?", -1)),
            createBaseVNode("div", {
              class: normalizeClass(["tooltip-content"]),
              style: normalizeStyle({ "font-family": ($options.isComda ? "Montserrat" : "museo-sans") + "!important" })
            }, [..._cache[2] || (_cache[2] = [
              createBaseVNode("b", { style: { "display": "block", "padding-bottom": "10px" } }, " Retail Value ", -1),
              createBaseVNode("span", null, " The cost to buy one of these products, fully customized, at a retail store. ", -1)
            ])], 4)
          ]),
          createBaseVNode("h4", {
            style: normalizeStyle({
              "font-family": ($options.isComda ? "Oswald" : "museo-sans") + "!important",
              "font-weight": ($options.isComda ? "bold" : 900) + "!important",
              "letter-spacing": "normal!important"
            })
          }, " Retail Value: ", 4),
          createBaseVNode("span", {
            class: normalizeClass(["price-matrix__col", "price-matrix__col--price", $options.customColor]),
            style: normalizeStyle({ "font-size": ($options.isComda ? 15 : 12) + "px!important" })
          }, toDisplayString("$" + $data.store.prices.tierMSRP.toFixed(2)), 7)
        ])
      ])) : createCommentVNode("", true)
    ], 2);
  }
  const PriceMatrixComponent = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$B]]);
  const _sfc_main$E = {
    props: {
      options: {
        type: Array,
        required: true
      },
      default: {
        type: String,
        required: false,
        default: null
      },
      tabindex: {
        type: Number,
        required: false,
        default: 0
      }
    },
    data() {
      return {
        selected: this.default ? this.default : this.options.length > 0 ? this.options[0].tabName : null,
        open: false
      };
    },
    mounted() {
    },
    methods: {
      handleOptionClick(option, i) {
        if (!option.isAvailable) return;
        this.selected = option.tabName;
        this.open = false;
        this.$emit("updateTabsMobile", option, i);
      }
    }
  };
  const _hoisted_1$E = ["tabindex"];
  const _hoisted_2$x = { class: "wrap" };
  const _hoisted_3$v = ["onClick"];
  function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: "custom-select",
      tabindex: $props.tabindex,
      onBlur: _cache[1] || (_cache[1] = ($event) => $data.open = false)
    }, [
      createBaseVNode("div", {
        class: normalizeClass(["selected", { open: $data.open }]),
        onClick: _cache[0] || (_cache[0] = ($event) => $data.open = !$data.open)
      }, toDisplayString($data.selected), 3),
      createBaseVNode("div", {
        class: normalizeClass(["items", { selectHide: !$data.open }])
      }, [
        createBaseVNode("div", _hoisted_2$x, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.options, (option, i) => {
            return openBlock(), createElementBlock("div", {
              key: i,
              onClick: ($event) => $options.handleOptionClick(option, i),
              class: normalizeClass(["option-wrap"])
            }, [
              createBaseVNode("div", {
                class: normalizeClass(["c-tabs__btn", $data.selected == option.tabName ? "c-tabs__btn--active" : "", !option.isAvailable ? "disabled-option" : ""])
              }, toDisplayString(option.tabName), 3)
            ], 8, _hoisted_3$v);
          }), 128))
        ])
      ], 2)
    ], 40, _hoisted_1$E);
  }
  const CustomSelect = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$A], ["__scopeId", "data-v-3b2be975"]]);
  const productsJsonData = {
    //search/suggest.json?q=id:10205043097889&resources[type]=product&limit=1 // grouped product
    //products/16-oz-nova-stainless-steel-tumbler.js
    //https://devcomda.myshopify.com/search/suggest.json?q=id:10205043228961&resources[type]=product&limit=1 //color
    //products/16-oz-nova-stainless-steel-tumbler-1.js
    "apparel": {
      id: 10176201589025,
      associated_id: '{"configurable":{"id":10176201621793},"simples":{"id_color":10176201654561,"id_size":10176201687329}}',
      full_json: '{"sku":"NE105","sku_type":"grouped","famlyid":2956,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","description":"<p><Strong>Product Size:</Strong> 2XS-3XL<br><Strong>Imprint Method 1:</Strong> Screen Printed, 1 color, 1 Location<br><Strong>Imprint Method 2:</Strong> Screen Printed, 1 color, 1 Location<br><Strong>Imprint Method 3:</Strong> Screen Printed, 1 color, 1 Location<br><Strong>Imprint Method 4:</Strong> Embroidered, Includes up to 15 thread colors and 7,000 stitches, 1 Location<br><Strong>Imprint Method 5:</Strong> Embroidered, Includes up to 15 thread colors and 7,000 stitches, 1 Location<br><Strong>Imprint Method 6:</Strong> Embroidered, Includes up to 15 thread colors and 7,000 stitches, 1 Location<br><Strong>Imprint Method 7:</Strong> Full Color DTF, 1 Location<br><Strong>Imprint Method 8:</Strong> Full Color DTF, 1 Location<br><Strong>Imprint Method 9:</Strong> Full Color DTF, 1 Location<br><Strong>Optional Imprint Locations:</Strong><br>- Front Left Chest, 3.5”W X 4”H<br>- Front Right Chest, 3.5”W X 4”H<br>- Full Front, 8”W X 13”H<br>- Full Back, 8”W X 13”H<br>- Left Sleeve, 3.5”W X 3.5”H<br>- Right Sleeve, 3.5”W X 3.5”H<br>- Nape, 4”W X 2.5”H<br><Strong>Multiple Color Imprint:</Strong><br>- Screen Printed: Multiple colors available with additional fees<br>- Screen Printed: Multiple colors available with additional fees<br>- Screen Printed: Multiple colors available with additional fees<br>- Embroidered: Multiple color imprint included<br>- Embroidered: Multiple color imprint included<br>- Embroidered: Multiple color imprint included<br>- Full Color DTF: Multiple color imprint included<br>- Full Color DTF: Multiple color imprint included<br>- Full Color DTF: Multiple color imprint included<br><Strong>Packaging:</Strong> Bulk<br><Strong>Shipping Package:</Strong> 24 per carton, 19.23 lbs</p>","status":"Enabled","is_in_stock":"In Stock","brand":"North End","gtin":"00882849638565","mpn":"NE105","upi_exists":"yes","age_group":"Adult","gender":"Unisex","default_color":"black","badges":"New Product,COMDA Select","url_key":"unisex-jaq-stretch-performance-hooded-t-shirt","catalog_code":"NE105","varies_by":[{"CODE":"COLOR"},{"CODE":"SIZE"}],"is_calendar":"","video_url":"","video_title":"","video_desc":"","configurable_array":{"NE105_DTF":{"sku":"NE105_DTF","sku_type":"configurable","familydecorationid":8989,"store":"comda_us","name":"Full Color","short_description":"IMPMTHD_DTF","description":"IMPMTHD_DTF","imprint_description":"This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.","price":0,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","is_in_stock":"In Stock","badges":"","qty_increment":1,"min_order_qty":3,"max_color":99,"associated_sku":[{"sku":"NE105_2XL_0002"},{"sku":"NE105_2XL_0240"},{"sku":"NE105_2XL_0252"},{"sku":"NE105_2XL_0530"},{"sku":"NE105_2XS_0002"},{"sku":"NE105_2XS_0240"},{"sku":"NE105_2XS_0252"},{"sku":"NE105_2XS_0530"},{"sku":"NE105_3XL_0002"},{"sku":"NE105_3XL_0240"},{"sku":"NE105_3XL_0252"},{"sku":"NE105_3XL_0530"},{"sku":"NE105_L_0002"},{"sku":"NE105_L_0240"},{"sku":"NE105_L_0252"},{"sku":"NE105_L_0530"},{"sku":"NE105_M_0002"},{"sku":"NE105_M_0240"},{"sku":"NE105_M_0252"},{"sku":"NE105_M_0530"},{"sku":"NE105_S_0002"},{"sku":"NE105_S_0240"},{"sku":"NE105_S_0252"},{"sku":"NE105_S_0530"},{"sku":"NE105_XL_0002"},{"sku":"NE105_XL_0240"},{"sku":"NE105_XL_0252"},{"sku":"NE105_XL_0530"},{"sku":"NE105_XS_0002"},{"sku":"NE105_XS_0240"},{"sku":"NE105_XS_0252"},{"sku":"NE105_XS_0530"}],"attribute":[{"code":"color"},{"code":"size","upcharge":[{"option":"2XL","price_type":"","store":"comda_us","price":5.49},{"option":"3XL","price_type":"","store":"comda_us","price":7.69}]}],"colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour"}],"packaging":[{"sku":"PROMOBOX1","QtyMax":24,"weight":19.23,"height":8,"width":15,"length":20}],"locations":[{"sku":"IMP_LOC_BK","desc":"Full Back","dimensions":"8”W X 13”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":3},{"sku":"IMP_LOC_FF","desc":"Full Front","dimensions":"8”W X 13”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":2},{"sku":"IMP_LOC_FL","desc":"Front Left Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_FR","desc":"Front Right Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_LS","desc":"Left Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":4},{"sku":"IMP_LOC_NP","desc":"Nape","dimensions":"4”W X 2.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":6},{"sku":"IMP_LOC_RS","desc":"Right Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":5}],"fees":[{"sku":"CUSTLOGO","fee_type":"LOGO","fee_desc":"Full Color","fee_unit":"per image","fee_value":0},{"sku":"IMPCLR_CSTM","fee_type":"CUSTOM_COLOUR","fee_desc":"Full Color","fee_unit":"per order","fee_value":50},{"sku":"NEEDPROOF","fee_type":"PROOF","fee_desc":"Full Color","fee_unit":"per order","fee_value":5},{"sku":"SETUP_PERLOC","fee_type":"SETUP","fee_desc":"Full Color","fee_unit":"per order","fee_value":30},{"sku":"XTRACLR_RUN","fee_type":"EXTRA_COLOUR","fee_desc":"Full Color","fee_unit":"per piece","fee_value":0.25}],"configurable_2_data":{"imprint_data":{"_type":"configurable","weight":0,"price":0,"tax_class_id":"","min_order_qty":3,"pseudo_qty_increments":1,"qty_increments":1,"enable_qty_increments":1,"use_config_qty_increments":0,"is_in_stock":1,"package_sku":"PROMOBOX1","package_weight":19.23,"package_height":8,"package_width":15,"package_length":20,"package_max_qty":24,"image_fee":0,"image_fee_sku":"CUSTLOGO","custom_colour_fee":50,"colour_fee_sku":"IMPCLR_CSTM","proof_fee":5,"proof_fee_sku":"NEEDPROOF","setup_fee":30,"setup_fee_sku":"SETUP_PERLOC","running_fee":0.25,"running_fee_sku":"XTRACLR_RUN","color":"color","size":"size"},"imprint_position":{"_custom_option_type":"drop_down","_custom_option_title":"Imprint location","_custom_option_sku":"location_comda_us_NE105_DTF","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":1,"_custom_option_class":"imprint-location full-width color-limit-99","_custom_option_color_link_id":"","_imprints":[{"title":"Full Back, 8”W X 13”H","sku":"IMP_LOC_BK","sort":3,"price":0},{"title":"Full Front, 8”W X 13”H","sku":"IMP_LOC_FF","sort":2,"price":0},{"title":"Front Left Chest, 3.5”W X 4”H","sku":"IMP_LOC_FL","sort":1,"price":0},{"title":"Front Right Chest, 3.5”W X 4”H","sku":"IMP_LOC_FR","sort":1,"price":0},{"title":"Left Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_LS","sort":4,"price":0},{"title":"Nape, 4”W X 2.5”H","sku":"IMP_LOC_NP","sort":6,"price":0},{"title":"Right Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_RS","sort":5,"price":0}]},"imprint_options":[{"_custom_option_type":"field","_custom_option_title":"Line 1","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":2,"_custom_option_class":"imprint-line-input imprint-line-1 imprint-line full-width","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":3,"_custom_option_class":"color-input color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":4,"_custom_option_class":"color-input custom-color-input custom-color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"field","_custom_option_title":"Line 2","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":5,"_custom_option_class":"imprint-line-input imprint-line-2 imprint-line full-width","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":6,"_custom_option_class":"color-input color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":7,"_custom_option_class":"color-input custom-color-input custom-color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"field","_custom_option_title":"Line 3","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":8,"_custom_option_class":"imprint-line-input imprint-line-3 imprint-line full-width","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":9,"_custom_option_class":"color-input color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":10,"_custom_option_class":"color-input custom-color-input custom-color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"field","_custom_option_title":"Line 4","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":11,"_custom_option_class":"imprint-line-input imprint-line-4 imprint-line full-width","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":12,"_custom_option_class":"color-input color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":13,"_custom_option_class":"color-input custom-color-input custom-color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"field","_custom_option_title":"Line 5","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":14,"_custom_option_class":"imprint-line-input imprint-line-5 imprint-line full-width","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":15,"_custom_option_class":"color-input color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":16,"_custom_option_class":"color-input custom-color-input custom-color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"file","_custom_option_title":"Add an Image","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":17,"_custom_option_class":"add-image half-width active imprint-line-input  im","_custom_option_color_link_id":"line-6-color","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"},{"_custom_option_type":"drop_down","_custom_option_title":"Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":18,"_custom_option_class":"color-input color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color","_colors":[{"sku":"IMPCLR_DTF","desc":"Full Colour","file_name":"full-colour"}]},{"_custom_option_type":"field","_custom_option_title":"Select Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":19,"_custom_option_class":"color-input custom-color-input custom-color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color"},{"_custom_option_type":"area","_custom_option_title":"Special Instructions","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":20,"_custom_option_class":"special-instructions","_custom_option_color_link_id":""},{"_custom_option_type":"file","_custom_option_title":"Upload New Design","_custom_option_sku":"","_custom_option_is_new_design":"1","_custom_option_is_required":0,"_custom_option_price":20,"_custom_option_max_characters":1000,"_custom_option_sort_order":21,"_custom_option_class":"upload-design half-width","_custom_option_color_link_id":"","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"}]},"simple_array":{"NE105_2XL_0002":{"sku":"NE105_2XL_0002","sku_type":"simple","familyitemid":33867,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002"},"NE105_2XL_0240":{"sku":"NE105_2XL_0240","sku_type":"simple","familyitemid":33868,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240"},"NE105_2XL_0252":{"sku":"NE105_2XL_0252","sku_type":"simple","familyitemid":33870,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252"},"NE105_2XL_0530":{"sku":"NE105_2XL_0530","sku_type":"simple","familyitemid":33869,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530"},"NE105_2XS_0002":{"sku":"NE105_2XS_0002","sku_type":"simple","familyitemid":33871,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002"},"NE105_2XS_0240":{"sku":"NE105_2XS_0240","sku_type":"simple","familyitemid":33872,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240"},"NE105_2XS_0252":{"sku":"NE105_2XS_0252","sku_type":"simple","familyitemid":33874,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252"},"NE105_2XS_0530":{"sku":"NE105_2XS_0530","sku_type":"simple","familyitemid":33873,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530"},"NE105_3XL_0002":{"sku":"NE105_3XL_0002","sku_type":"simple","familyitemid":33875,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002"},"NE105_3XL_0240":{"sku":"NE105_3XL_0240","sku_type":"simple","familyitemid":33876,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240"},"NE105_3XL_0252":{"sku":"NE105_3XL_0252","sku_type":"simple","familyitemid":33878,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252"},"NE105_3XL_0530":{"sku":"NE105_3XL_0530","sku_type":"simple","familyitemid":33877,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530"},"NE105_L_0002":{"sku":"NE105_L_0002","sku_type":"simple","familyitemid":33879,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002"},"NE105_L_0240":{"sku":"NE105_L_0240","sku_type":"simple","familyitemid":33880,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240"},"NE105_L_0252":{"sku":"NE105_L_0252","sku_type":"simple","familyitemid":33882,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252"},"NE105_L_0530":{"sku":"NE105_L_0530","sku_type":"simple","familyitemid":33881,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530"},"NE105_M_0002":{"sku":"NE105_M_0002","sku_type":"simple","familyitemid":33883,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002"},"NE105_M_0240":{"sku":"NE105_M_0240","sku_type":"simple","familyitemid":33884,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240"},"NE105_M_0252":{"sku":"NE105_M_0252","sku_type":"simple","familyitemid":33886,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252"},"NE105_M_0530":{"sku":"NE105_M_0530","sku_type":"simple","familyitemid":33885,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530"},"NE105_S_0002":{"sku":"NE105_S_0002","sku_type":"simple","familyitemid":33887,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002"},"NE105_S_0240":{"sku":"NE105_S_0240","sku_type":"simple","familyitemid":33888,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240"},"NE105_S_0252":{"sku":"NE105_S_0252","sku_type":"simple","familyitemid":33890,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252"},"NE105_S_0530":{"sku":"NE105_S_0530","sku_type":"simple","familyitemid":33889,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530"},"NE105_XL_0002":{"sku":"NE105_XL_0002","sku_type":"simple","familyitemid":33891,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002"},"NE105_XL_0240":{"sku":"NE105_XL_0240","sku_type":"simple","familyitemid":33892,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240"},"NE105_XL_0252":{"sku":"NE105_XL_0252","sku_type":"simple","familyitemid":33894,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252"},"NE105_XL_0530":{"sku":"NE105_XL_0530","sku_type":"simple","familyitemid":33893,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530"},"NE105_XS_0002":{"sku":"NE105_XS_0002","sku_type":"simple","familyitemid":33895,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002"},"NE105_XS_0240":{"sku":"NE105_XS_0240","sku_type":"simple","familyitemid":33896,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240"},"NE105_XS_0252":{"sku":"NE105_XS_0252","sku_type":"simple","familyitemid":33898,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252"},"NE105_XS_0530":{"sku":"NE105_XS_0530","sku_type":"simple","familyitemid":33897,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530"}},"attributes_relation_array":{"black":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002","size":"XS","status":"Enabled"}],"carbon":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240","size":"XS","status":"Enabled"}],"platinum":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252","size":"XS","status":"Enabled"}],"classic-navy":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530","size":"XS","status":"Enabled"}]},"prices":{"sku":"NE105_DTF","sku_type":"configurable","familyid":2956,"familydecorationid":8989,"store":"comda_us","price":117.1,"msrp":117.1,"min_price":54.32,"max_price":80.69,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"80.69\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"64.21\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"59.89\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"55.68\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"55.6800\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"54.32\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3200\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":80.69,"sale_price":59.89,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":64.21,"sale_price":59.89,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":59.89},{"CustomerGroup":"STANDARD","QtyMin":24,"price":55.68},{"CustomerGroup":"STANDARD","QtyMin":48,"price":54.32}]},"prices_2":{"sku":"NE105_DTF","sku_type":"configurable","familyid":2956,"familydecorationid":8989,"store":"comda_us","price":117.1,"msrp":117.1,"min_price":54.32,"max_price":80.69,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"80.69\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"64.21\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"59.89\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"59.8900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"55.68\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"55.6800\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"54.32\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3200\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":80.69,"sale_price":59.89,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":64.21,"sale_price":59.89,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":59.89},{"CustomerGroup":"STANDARD","QtyMin":24,"price":55.68},{"CustomerGroup":"STANDARD","QtyMin":48,"price":54.32}]},"grouped_name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt"},"NE105_EMBR":{"sku":"NE105_EMBR","sku_type":"configurable","familydecorationid":4224,"store":"comda_us","name":"Embroidered","short_description":"IMPMTHD_EMB","description":"IMPMTHD_EMB","imprint_description":"Your products will be Embroidered in the color(s) you specify including full color. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.","price":0,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","is_in_stock":"In Stock","badges":"","qty_increment":1,"min_order_qty":3,"max_color":15,"associated_sku":[{"sku":"NE105_2XL_0002"},{"sku":"NE105_2XL_0240"},{"sku":"NE105_2XL_0252"},{"sku":"NE105_2XL_0530"},{"sku":"NE105_2XS_0002"},{"sku":"NE105_2XS_0240"},{"sku":"NE105_2XS_0252"},{"sku":"NE105_2XS_0530"},{"sku":"NE105_3XL_0002"},{"sku":"NE105_3XL_0240"},{"sku":"NE105_3XL_0252"},{"sku":"NE105_3XL_0530"},{"sku":"NE105_L_0002"},{"sku":"NE105_L_0240"},{"sku":"NE105_L_0252"},{"sku":"NE105_L_0530"},{"sku":"NE105_M_0002"},{"sku":"NE105_M_0240"},{"sku":"NE105_M_0252"},{"sku":"NE105_M_0530"},{"sku":"NE105_S_0002"},{"sku":"NE105_S_0240"},{"sku":"NE105_S_0252"},{"sku":"NE105_S_0530"},{"sku":"NE105_XL_0002"},{"sku":"NE105_XL_0240"},{"sku":"NE105_XL_0252"},{"sku":"NE105_XL_0530"},{"sku":"NE105_XS_0002"},{"sku":"NE105_XS_0240"},{"sku":"NE105_XS_0252"},{"sku":"NE105_XS_0530"}],"attribute":[{"code":"color"},{"code":"size","upcharge":[{"option":"2XL","price_type":"","store":"comda_us","price":5.49},{"option":"3XL","price_type":"","store":"comda_us","price":7.69}]}],"colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD"},{"sku":"SIM_EMB","desc":"Match Logo Colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD"}],"packaging":[{"sku":"PROMOBOX1","QtyMax":24,"weight":19.23,"height":8,"width":15,"length":20}],"locations":[{"sku":"IMP_LOC_FL","desc":"Front Left Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_FR","desc":"Front Right Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_LS","desc":"Left Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":2},{"sku":"IMP_LOC_NP","desc":"Nape","dimensions":"4”W X 2.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":4},{"sku":"IMP_LOC_RS","desc":"Right Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":3}],"fees":[{"sku":"CUSTLOGO","fee_type":"LOGO","fee_desc":"Embroidered","fee_unit":"per image","fee_value":0},{"sku":"IMPCLR_CSTM","fee_type":"CUSTOM_COLOUR","fee_desc":"Embroidered","fee_unit":"per order","fee_value":0},{"sku":"NEEDPROOF","fee_type":"PROOF","fee_desc":"Embroidered","fee_unit":"per order","fee_value":5},{"sku":"SETUP_PERLOC","fee_type":"SETUP","fee_desc":"Embroidered","fee_unit":"per order","fee_value":30},{"sku":"XTRACLR_RUN","fee_type":"EXTRA_COLOUR","fee_desc":"Embroidered","fee_unit":"per piece","fee_value":0}],"configurable_2_data":{"imprint_data":{"_type":"configurable","weight":0,"price":0,"tax_class_id":"","min_order_qty":3,"pseudo_qty_increments":1,"qty_increments":1,"enable_qty_increments":1,"use_config_qty_increments":0,"is_in_stock":1,"package_sku":"PROMOBOX1","package_weight":19.23,"package_height":8,"package_width":15,"package_length":20,"package_max_qty":24,"image_fee":0,"image_fee_sku":"CUSTLOGO","custom_colour_fee":0,"colour_fee_sku":"IMPCLR_CSTM","proof_fee":5,"proof_fee_sku":"NEEDPROOF","setup_fee":30,"setup_fee_sku":"SETUP_PERLOC","running_fee":0,"running_fee_sku":"XTRACLR_RUN","color":"color","size":"size"},"imprint_position":{"_custom_option_type":"drop_down","_custom_option_title":"Imprint location","_custom_option_sku":"location_comda_us_NE105_EMBR","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":1,"_custom_option_class":"imprint-location full-width color-limit-15","_custom_option_color_link_id":"","_imprints":[{"title":"Front Left Chest, 3.5”W X 4”H","sku":"IMP_LOC_FL","sort":1,"price":0},{"title":"Front Right Chest, 3.5”W X 4”H","sku":"IMP_LOC_FR","sort":1,"price":0},{"title":"Left Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_LS","sort":2,"price":0},{"title":"Nape, 4”W X 2.5”H","sku":"IMP_LOC_NP","sort":4,"price":0},{"title":"Right Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_RS","sort":3,"price":0}]},"imprint_options":[{"_custom_option_type":"field","_custom_option_title":"Line 1","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":2,"_custom_option_class":"imprint-line-input imprint-line-1 imprint-line full-width","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":3,"_custom_option_class":"color-input color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":4,"_custom_option_class":"color-input custom-color-input custom-color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"field","_custom_option_title":"Line 2","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":5,"_custom_option_class":"imprint-line-input imprint-line-2 imprint-line full-width","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":6,"_custom_option_class":"color-input color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":7,"_custom_option_class":"color-input custom-color-input custom-color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"field","_custom_option_title":"Line 3","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":8,"_custom_option_class":"imprint-line-input imprint-line-3 imprint-line full-width","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":9,"_custom_option_class":"color-input color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":10,"_custom_option_class":"color-input custom-color-input custom-color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"field","_custom_option_title":"Line 4","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":11,"_custom_option_class":"imprint-line-input imprint-line-4 imprint-line full-width","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":12,"_custom_option_class":"color-input color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":13,"_custom_option_class":"color-input custom-color-input custom-color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"field","_custom_option_title":"Line 5","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":14,"_custom_option_class":"imprint-line-input imprint-line-5 imprint-line full-width","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":15,"_custom_option_class":"color-input color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":16,"_custom_option_class":"color-input custom-color-input custom-color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"file","_custom_option_title":"Add an Image","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":17,"_custom_option_class":"add-image half-width active imprint-line-input  im","_custom_option_color_link_id":"line-6-color","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"},{"_custom_option_type":"drop_down","_custom_option_title":"Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":18,"_custom_option_class":"color-input color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color","_colors":[{"sku":"BLACK_EMB","desc":"BLACK Emb # 0020 ISACORD","file_name":"black-emb-0020-isacord"},{"sku":"BLU_EMB","desc":"BLUE Emb # 3522 ISACORD","file_name":"blue-emb-3522-isacord"},{"sku":"GOLD_EMB","desc":"GOLD Emb # 0552 ISACORD","file_name":"gold-emb-0552-isacord"},{"sku":"GRN_EMB","desc":"GREEN Emb # 5415 ISACORD","file_name":"green-emb-5415-isacord"},{"sku":"OTHER_EMB","desc":"OTHER Emb. Thread ISACORD","file_name":"other-emb-thread-isacord"},{"sku":"RED_EMB","desc":"RED Emb # 1904 ISACORD","file_name":"red-emb-1904-isacord"},{"sku":"SILV_EMB","desc":"SILVER Emb # 3971 ISACORD","file_name":"silver-emb-3971-isacord"},{"sku":"SIM_EMB","desc":"Match Logo Colors","file_name":"match-logo-colors"},{"sku":"WHIT_EMB","desc":"WHITE Emb #0017 ISACORD","file_name":"white-emb-0017-isacord"}]},{"_custom_option_type":"field","_custom_option_title":"Select Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":19,"_custom_option_class":"color-input custom-color-input custom-color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color"},{"_custom_option_type":"area","_custom_option_title":"Special Instructions","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":20,"_custom_option_class":"special-instructions","_custom_option_color_link_id":""},{"_custom_option_type":"file","_custom_option_title":"Upload New Design","_custom_option_sku":"","_custom_option_is_new_design":"1","_custom_option_is_required":0,"_custom_option_price":20,"_custom_option_max_characters":1000,"_custom_option_sort_order":21,"_custom_option_class":"upload-design half-width","_custom_option_color_link_id":"","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"}]},"simple_array":{"NE105_2XL_0002":{"sku":"NE105_2XL_0002","sku_type":"simple","familyitemid":33867,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002"},"NE105_2XL_0240":{"sku":"NE105_2XL_0240","sku_type":"simple","familyitemid":33868,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240"},"NE105_2XL_0252":{"sku":"NE105_2XL_0252","sku_type":"simple","familyitemid":33870,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252"},"NE105_2XL_0530":{"sku":"NE105_2XL_0530","sku_type":"simple","familyitemid":33869,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530"},"NE105_2XS_0002":{"sku":"NE105_2XS_0002","sku_type":"simple","familyitemid":33871,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002"},"NE105_2XS_0240":{"sku":"NE105_2XS_0240","sku_type":"simple","familyitemid":33872,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240"},"NE105_2XS_0252":{"sku":"NE105_2XS_0252","sku_type":"simple","familyitemid":33874,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252"},"NE105_2XS_0530":{"sku":"NE105_2XS_0530","sku_type":"simple","familyitemid":33873,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530"},"NE105_3XL_0002":{"sku":"NE105_3XL_0002","sku_type":"simple","familyitemid":33875,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002"},"NE105_3XL_0240":{"sku":"NE105_3XL_0240","sku_type":"simple","familyitemid":33876,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240"},"NE105_3XL_0252":{"sku":"NE105_3XL_0252","sku_type":"simple","familyitemid":33878,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252"},"NE105_3XL_0530":{"sku":"NE105_3XL_0530","sku_type":"simple","familyitemid":33877,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530"},"NE105_L_0002":{"sku":"NE105_L_0002","sku_type":"simple","familyitemid":33879,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002"},"NE105_L_0240":{"sku":"NE105_L_0240","sku_type":"simple","familyitemid":33880,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240"},"NE105_L_0252":{"sku":"NE105_L_0252","sku_type":"simple","familyitemid":33882,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252"},"NE105_L_0530":{"sku":"NE105_L_0530","sku_type":"simple","familyitemid":33881,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530"},"NE105_M_0002":{"sku":"NE105_M_0002","sku_type":"simple","familyitemid":33883,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002"},"NE105_M_0240":{"sku":"NE105_M_0240","sku_type":"simple","familyitemid":33884,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240"},"NE105_M_0252":{"sku":"NE105_M_0252","sku_type":"simple","familyitemid":33886,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252"},"NE105_M_0530":{"sku":"NE105_M_0530","sku_type":"simple","familyitemid":33885,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530"},"NE105_S_0002":{"sku":"NE105_S_0002","sku_type":"simple","familyitemid":33887,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002"},"NE105_S_0240":{"sku":"NE105_S_0240","sku_type":"simple","familyitemid":33888,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240"},"NE105_S_0252":{"sku":"NE105_S_0252","sku_type":"simple","familyitemid":33890,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252"},"NE105_S_0530":{"sku":"NE105_S_0530","sku_type":"simple","familyitemid":33889,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530"},"NE105_XL_0002":{"sku":"NE105_XL_0002","sku_type":"simple","familyitemid":33891,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002"},"NE105_XL_0240":{"sku":"NE105_XL_0240","sku_type":"simple","familyitemid":33892,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240"},"NE105_XL_0252":{"sku":"NE105_XL_0252","sku_type":"simple","familyitemid":33894,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252"},"NE105_XL_0530":{"sku":"NE105_XL_0530","sku_type":"simple","familyitemid":33893,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530"},"NE105_XS_0002":{"sku":"NE105_XS_0002","sku_type":"simple","familyitemid":33895,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002"},"NE105_XS_0240":{"sku":"NE105_XS_0240","sku_type":"simple","familyitemid":33896,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240"},"NE105_XS_0252":{"sku":"NE105_XS_0252","sku_type":"simple","familyitemid":33898,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252"},"NE105_XS_0530":{"sku":"NE105_XS_0530","sku_type":"simple","familyitemid":33897,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530"}},"attributes_relation_array":{"black":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002","size":"XS","status":"Enabled"}],"carbon":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240","size":"XS","status":"Enabled"}],"platinum":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252","size":"XS","status":"Enabled"}],"classic-navy":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530","size":"XS","status":"Enabled"}]},"prices":{"sku":"NE105_EMBR","sku_type":"configurable","familyid":2956,"familydecorationid":4224,"store":"comda_us","price":101.1,"msrp":101.1,"min_price":51.57,"max_price":69.69,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"69.69\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"61.46\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"57.14\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"52.93\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"52.9300\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"51.57\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"51.5700\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":69.69,"sale_price":57.14,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":61.46,"sale_price":57.14,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":57.14},{"CustomerGroup":"STANDARD","QtyMin":24,"price":52.93},{"CustomerGroup":"STANDARD","QtyMin":48,"price":51.57}]},"prices_2":{"sku":"NE105_EMBR","sku_type":"configurable","familyid":2956,"familydecorationid":4224,"store":"comda_us","price":101.1,"msrp":101.1,"min_price":51.57,"max_price":69.69,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"69.69\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"61.46\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"57.14\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"57.1400\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"52.93\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"52.9300\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"51.57\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"51.5700\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":69.69,"sale_price":57.14,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":61.46,"sale_price":57.14,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":57.14},{"CustomerGroup":"STANDARD","QtyMin":24,"price":52.93},{"CustomerGroup":"STANDARD","QtyMin":48,"price":51.57}]},"grouped_name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt"},"NE105_SCRE":{"sku":"NE105_SCRE","sku_type":"configurable","familydecorationid":4225,"store":"comda_us","name":"Screenprint","short_description":"IMPMTHD_SCRN","description":"IMPMTHD_SCRN","imprint_description":"Your products will be Screen Printed in the color(s) you specify. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.","price":0,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","is_in_stock":"In Stock","badges":"","qty_increment":1,"min_order_qty":3,"max_color":99,"associated_sku":[{"sku":"NE105_2XL_0002"},{"sku":"NE105_2XL_0240"},{"sku":"NE105_2XL_0252"},{"sku":"NE105_2XL_0530"},{"sku":"NE105_2XS_0002"},{"sku":"NE105_2XS_0240"},{"sku":"NE105_2XS_0252"},{"sku":"NE105_2XS_0530"},{"sku":"NE105_3XL_0002"},{"sku":"NE105_3XL_0240"},{"sku":"NE105_3XL_0252"},{"sku":"NE105_3XL_0530"},{"sku":"NE105_L_0002"},{"sku":"NE105_L_0240"},{"sku":"NE105_L_0252"},{"sku":"NE105_L_0530"},{"sku":"NE105_M_0002"},{"sku":"NE105_M_0240"},{"sku":"NE105_M_0252"},{"sku":"NE105_M_0530"},{"sku":"NE105_S_0002"},{"sku":"NE105_S_0240"},{"sku":"NE105_S_0252"},{"sku":"NE105_S_0530"},{"sku":"NE105_XL_0002"},{"sku":"NE105_XL_0240"},{"sku":"NE105_XL_0252"},{"sku":"NE105_XL_0530"},{"sku":"NE105_XS_0002"},{"sku":"NE105_XS_0240"},{"sku":"NE105_XS_0252"},{"sku":"NE105_XS_0530"}],"attribute":[{"code":"color"},{"code":"size","upcharge":[{"option":"2XL","price_type":"","store":"comda_us","price":5.50},{"option":"3XL","price_type":"","store":"comda_us","price":7.69}]}],"colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint"}],"packaging":[{"sku":"PROMOBOX1","QtyMax":24,"weight":19.23,"height":8,"width":15,"length":20}],"locations":[{"sku":"IMP_LOC_BK","desc":"Full Back","dimensions":"8”W X 13”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":3},{"sku":"IMP_LOC_FF","desc":"Full Front","dimensions":"8”W X 13”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":2},{"sku":"IMP_LOC_FL","desc":"Front Left Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_FR","desc":"Front Right Chest","dimensions":"3.5”W X 4”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":1},{"sku":"IMP_LOC_LS","desc":"Left Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":4},{"sku":"IMP_LOC_NP","desc":"Nape","dimensions":"4”W X 2.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":6},{"sku":"IMP_LOC_RS","desc":"Right Sleeve","dimensions":"3.5”W X 3.5”H","imprint_lines":5,"location_type":"OPTIONAL","sort_order":5}],"fees":[{"sku":"CUSTLOGO","fee_type":"LOGO","fee_desc":"Screenprint","fee_unit":"per image","fee_value":0},{"sku":"IMPCLR_CSTM","fee_type":"CUSTOM_COLOUR","fee_desc":"Screenprint","fee_unit":"per order","fee_value":50},{"sku":"NEEDPROOF","fee_type":"PROOF","fee_desc":"Screenprint","fee_unit":"per order","fee_value":5},{"sku":"SETUP_PERLOCCOL","fee_type":"SETUP","fee_desc":"Screenprint","fee_unit":"per order","fee_value":30},{"sku":"XTRACLR_RUN","fee_type":"EXTRA_COLOUR","fee_desc":"Screenprint","fee_unit":"per piece","fee_value":1}],"configurable_2_data":{"imprint_data":{"_type":"configurable","weight":0,"price":0,"tax_class_id":"","min_order_qty":3,"pseudo_qty_increments":1,"qty_increments":1,"enable_qty_increments":1,"use_config_qty_increments":0,"is_in_stock":1,"package_sku":"PROMOBOX1","package_weight":19.23,"package_height":8,"package_width":15,"package_length":20,"package_max_qty":24,"image_fee":0,"image_fee_sku":"CUSTLOGO","custom_colour_fee":50,"colour_fee_sku":"IMPCLR_CSTM","proof_fee":5,"proof_fee_sku":"NEEDPROOF","setup_fee":30,"setup_fee_sku":"SETUP_PERLOCCOL","running_fee":1,"running_fee_sku":"XTRACLR_RUN","color":"color","size":"size"},"imprint_position":{"_custom_option_type":"drop_down","_custom_option_title":"Imprint location","_custom_option_sku":"location_comda_us_NE105_SCRE","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":1,"_custom_option_class":"imprint-location full-width color-limit-99","_custom_option_color_link_id":"","_imprints":[{"title":"Full Back, 8”W X 13”H","sku":"IMP_LOC_BK","sort":3,"price":0},{"title":"Full Front, 8”W X 13”H","sku":"IMP_LOC_FF","sort":2,"price":0},{"title":"Front Left Chest, 3.5”W X 4”H","sku":"IMP_LOC_FL","sort":1,"price":0},{"title":"Front Right Chest, 3.5”W X 4”H","sku":"IMP_LOC_FR","sort":1,"price":0},{"title":"Left Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_LS","sort":4,"price":0},{"title":"Nape, 4”W X 2.5”H","sku":"IMP_LOC_NP","sort":6,"price":0},{"title":"Right Sleeve, 3.5”W X 3.5”H","sku":"IMP_LOC_RS","sort":5,"price":0}]},"imprint_options":[{"_custom_option_type":"field","_custom_option_title":"Line 1","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":2,"_custom_option_class":"imprint-line-input imprint-line-1 imprint-line full-width","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":3,"_custom_option_class":"color-input color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":4,"_custom_option_class":"color-input custom-color-input custom-color-input-1 imprint-line","_custom_option_color_link_id":"line-1-color"},{"_custom_option_type":"field","_custom_option_title":"Line 2","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":5,"_custom_option_class":"imprint-line-input imprint-line-2 imprint-line full-width","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":6,"_custom_option_class":"color-input color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":7,"_custom_option_class":"color-input custom-color-input custom-color-input-2 imprint-line","_custom_option_color_link_id":"line-2-color"},{"_custom_option_type":"field","_custom_option_title":"Line 3","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":8,"_custom_option_class":"imprint-line-input imprint-line-3 imprint-line full-width","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":9,"_custom_option_class":"color-input color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":10,"_custom_option_class":"color-input custom-color-input custom-color-input-3 imprint-line","_custom_option_color_link_id":"line-3-color"},{"_custom_option_type":"field","_custom_option_title":"Line 4","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":11,"_custom_option_class":"imprint-line-input imprint-line-4 imprint-line full-width","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":12,"_custom_option_class":"color-input color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":13,"_custom_option_class":"color-input custom-color-input custom-color-input-4 imprint-line","_custom_option_color_link_id":"line-4-color"},{"_custom_option_type":"field","_custom_option_title":"Line 5","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":14,"_custom_option_class":"imprint-line-input imprint-line-5 imprint-line full-width","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"drop_down","_custom_option_title":"Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":15,"_custom_option_class":"color-input color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Pantone Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":16,"_custom_option_class":"color-input custom-color-input custom-color-input-5 imprint-line","_custom_option_color_link_id":"line-5-color"},{"_custom_option_type":"file","_custom_option_title":"Add an Image","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":1000,"_custom_option_sort_order":17,"_custom_option_class":"add-image half-width active imprint-line-input  im","_custom_option_color_link_id":"line-6-color","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"},{"_custom_option_type":"drop_down","_custom_option_title":"Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":18,"_custom_option_class":"color-input color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color","_colors":[{"sku":"IMPCLR_116","desc":"Yellow Imprint (PMS 116)","file_name":"yellow-imprint-pms-116-"},{"sku":"IMPCLR_124","desc":"Athletic Gold (PMS 124)","file_name":"athletic-gold-pms-124-"},{"sku":"IMPCLR_165","desc":"Orange Imprint (PMS 165)","file_name":"orange-imprint-pms-165-"},{"sku":"IMPCLR_186","desc":"Red Imprint (PMS 186)","file_name":"red-imprint-pms-186-"},{"sku":"IMPCLR_227","desc":"Magenta Imprint (PMS 227)","file_name":"magenta-imprint-pms-227-"},{"sku":"IMPCLR_266","desc":"Purple Imprint (PMS 266)","file_name":"purple-imprint-pms-266-"},{"sku":"IMPCLR_320","desc":"Teal Imprint (PMS 320)","file_name":"teal-imprint-pms-320-"},{"sku":"IMPCLR_342","desc":"Kelly Green Imprint (PMS 342)","file_name":"kelly-green-imprint-pms-342-"},{"sku":"IMPCLR_476","desc":"Brown Imprint (PMS 476)","file_name":"brown-imprint-pms-476-"},{"sku":"IMPCLR_873","desc":"Gold Imprint (PMS 873)","file_name":"gold-imprint-pms-873-"},{"sku":"IMPCLR_877","desc":"Silver Imprint (PMS 877)","file_name":"silver-imprint-pms-877-"},{"sku":"IMPCLR_BLACK","desc":"Black Imprint","file_name":"black-imprint"},{"sku":"IMPCLR_COOL_GRAY_9","desc":"Cool Gray 9 Imprint","file_name":"cool-gray-9-imprint"},{"sku":"IMPCLR_WHITE","desc":"White Imprint","file_name":"white-imprint"},{"sku":"PMS_208","desc":"Burgundy Imprint (PMS 208)","file_name":"burgundy-imprint-pms-208-"},{"sku":"PMS_REFLEXBLUE","desc":"Reflex Blue Imprint","file_name":"reflex-blue-imprint"}]},{"_custom_option_type":"field","_custom_option_title":"Select Image Color","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":19,"_custom_option_class":"color-input custom-color-input custom-color-input-6 imprint-line","_custom_option_color_link_id":"line-6-color"},{"_custom_option_type":"area","_custom_option_title":"Special Instructions","_custom_option_sku":"","_custom_option_is_required":0,"_custom_option_price":0,"_custom_option_max_characters":0,"_custom_option_sort_order":20,"_custom_option_class":"special-instructions","_custom_option_color_link_id":""},{"_custom_option_type":"file","_custom_option_title":"Upload New Design","_custom_option_sku":"","_custom_option_is_new_design":"1","_custom_option_is_required":0,"_custom_option_price":20,"_custom_option_max_characters":1000,"_custom_option_sort_order":21,"_custom_option_class":"upload-design half-width","_custom_option_color_link_id":"","_custom_option_file_extension":"ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff"}]},"simple_array":{"NE105_2XL_0002":{"sku":"NE105_2XL_0002","sku_type":"simple","familyitemid":33867,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002"},"NE105_2XL_0240":{"sku":"NE105_2XL_0240","sku_type":"simple","familyitemid":33868,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240"},"NE105_2XL_0252":{"sku":"NE105_2XL_0252","sku_type":"simple","familyitemid":33870,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252"},"NE105_2XL_0530":{"sku":"NE105_2XL_0530","sku_type":"simple","familyitemid":33869,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XL","sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530"},"NE105_2XS_0002":{"sku":"NE105_2XS_0002","sku_type":"simple","familyitemid":33871,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002"},"NE105_2XS_0240":{"sku":"NE105_2XS_0240","sku_type":"simple","familyitemid":33872,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240"},"NE105_2XS_0252":{"sku":"NE105_2XS_0252","sku_type":"simple","familyitemid":33874,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252"},"NE105_2XS_0530":{"sku":"NE105_2XS_0530","sku_type":"simple","familyitemid":33873,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"2XS","sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530"},"NE105_3XL_0002":{"sku":"NE105_3XL_0002","sku_type":"simple","familyitemid":33875,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002"},"NE105_3XL_0240":{"sku":"NE105_3XL_0240","sku_type":"simple","familyitemid":33876,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240"},"NE105_3XL_0252":{"sku":"NE105_3XL_0252","sku_type":"simple","familyitemid":33878,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252"},"NE105_3XL_0530":{"sku":"NE105_3XL_0530","sku_type":"simple","familyitemid":33877,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"3XL","sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530"},"NE105_L_0002":{"sku":"NE105_L_0002","sku_type":"simple","familyitemid":33879,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002"},"NE105_L_0240":{"sku":"NE105_L_0240","sku_type":"simple","familyitemid":33880,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240"},"NE105_L_0252":{"sku":"NE105_L_0252","sku_type":"simple","familyitemid":33882,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252"},"NE105_L_0530":{"sku":"NE105_L_0530","sku_type":"simple","familyitemid":33881,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"L","sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530"},"NE105_M_0002":{"sku":"NE105_M_0002","sku_type":"simple","familyitemid":33883,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002"},"NE105_M_0240":{"sku":"NE105_M_0240","sku_type":"simple","familyitemid":33884,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240"},"NE105_M_0252":{"sku":"NE105_M_0252","sku_type":"simple","familyitemid":33886,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252"},"NE105_M_0530":{"sku":"NE105_M_0530","sku_type":"simple","familyitemid":33885,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Medium (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"M","sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530"},"NE105_S_0002":{"sku":"NE105_S_0002","sku_type":"simple","familyitemid":33887,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002"},"NE105_S_0240":{"sku":"NE105_S_0240","sku_type":"simple","familyitemid":33888,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240"},"NE105_S_0252":{"sku":"NE105_S_0252","sku_type":"simple","familyitemid":33890,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252"},"NE105_S_0530":{"sku":"NE105_S_0530","sku_type":"simple","familyitemid":33889,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"S","sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530"},"NE105_XL_0002":{"sku":"NE105_XL_0002","sku_type":"simple","familyitemid":33891,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002"},"NE105_XL_0240":{"sku":"NE105_XL_0240","sku_type":"simple","familyitemid":33892,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240"},"NE105_XL_0252":{"sku":"NE105_XL_0252","sku_type":"simple","familyitemid":33894,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252"},"NE105_XL_0530":{"sku":"NE105_XL_0530","sku_type":"simple","familyitemid":33893,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Large (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XL","sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530"},"NE105_XS_0002":{"sku":"NE105_XS_0002","sku_type":"simple","familyitemid":33895,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Black)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"black","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002"},"NE105_XS_0240":{"sku":"NE105_XS_0240","sku_type":"simple","familyitemid":33896,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Carbon)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"carbon","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240"},"NE105_XS_0252":{"sku":"NE105_XS_0252","sku_type":"simple","familyitemid":33898,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Platinum)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"platinum","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252"},"NE105_XS_0530":{"sku":"NE105_XS_0530","sku_type":"simple","familyitemid":33897,"store":"comda_us","name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","short_description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","description":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - X Small (Classic Navy)","price":0,"weight":0.8688,"status":"Enabled","visibility":"Not Visible","tax_class_id":"","qty":0,"is_in_stock":"In Stock","badges":"","color":"classic-navy","size":"XS","sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530"}},"attributes_relation_array":{"black":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0002","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0002","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0002","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0002","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0002","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0002","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0002","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0002","size":"XS","status":"Enabled"}],"carbon":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0240","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0240","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0240","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0240","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0240","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0240","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0240","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0240","size":"XS","status":"Enabled"}],"platinum":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0252","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0252","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0252","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0252","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0252","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0252","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0252","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0252","size":"XS","status":"Enabled"}],"classic-navy":[{"sku_product":"NE105","sku_size_code":"2XL","sku_color_code":"0530","size":"2XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"2XS","sku_color_code":"0530","size":"2XS","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"3XL","sku_color_code":"0530","size":"3XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"L","sku_color_code":"0530","size":"L","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"M","sku_color_code":"0530","size":"M","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"S","sku_color_code":"0530","size":"S","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XL","sku_color_code":"0530","size":"XL","status":"Enabled"},{"sku_product":"NE105","sku_size_code":"XS","sku_color_code":"0530","size":"XS","status":"Enabled"}]},"prices":{"sku":"NE105_SCRE","sku_type":"configurable","familyid":2956,"familydecorationid":4225,"store":"comda_us","price":93.1,"msrp":93.1,"min_price":50.47,"max_price":64.19,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"64.19\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"57.61\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"54.39\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"51.83\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"51.8300\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"50.47\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"50.4700\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":64.19,"sale_price":54.39,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":57.61,"sale_price":54.39,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":54.39},{"CustomerGroup":"STANDARD","QtyMin":24,"price":51.83},{"CustomerGroup":"STANDARD","QtyMin":48,"price":50.47}]},"prices_2":{"sku":"NE105_SCRE","sku_type":"configurable","familyid":2956,"familydecorationid":4225,"store":"comda_us","price":93.1,"msrp":93.1,"min_price":50.47,"max_price":64.19,"tier_price_data":"{\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"64.19\\",\\"price_qty\\":\\"3.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"57.61\\",\\"price_qty\\":\\"6.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"54.39\\",\\"price_qty\\":\\"12.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"54.3900\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"51.83\\",\\"price_qty\\":\\"24.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"51.8300\\"},\\"32000-3\\":{\\"website_id\\":\\"2\\",\\"all_groups\\":\\"1\\",\\"price\\":\\"50.47\\",\\"price_qty\\":\\"48.0000\\",\\"cust_group\\":\\"32000\\",\\"website_price\\":\\"50.4700\\"}}","tier_price":[{"CustomerGroup":"STANDARD","QtyMin":3,"price":64.19,"sale_price":54.39,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":6,"price":57.61,"sale_price":54.39,"sale_price_effectivedate":"2024-12-31","sale_price_terminationdate":"2025-12-31"},{"CustomerGroup":"STANDARD","QtyMin":12,"price":54.39},{"CustomerGroup":"STANDARD","QtyMin":24,"price":51.83},{"CustomerGroup":"STANDARD","QtyMin":48,"price":50.47}]},"grouped_name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt"}},"prices_2":{"sku":"NE105","sku_type":"grouped","familyid":2956,"familydecorationid":-1,"store":"comda_us","price":117.1,"as_low_as_price":50.47,"as_low_as_price2":59.89,"google_shopping_price":192.57,"google_shopping_price_text":"192.57 USD","google_shopping_sale_price":163.17,"google_shopping_sale_price_text":"163.17 USD","minimum_order_quantity":3,"google_shopping_name":"3 Screenprint North End Unisex JAQ Stretch Performance Hooded T-Shirt"},"categories":[{"category":"More","position":668},{"category":"All Promo Products","position":666},{"category":"Apparel & T-Shirts","position":311},{"category":"Full-Color Printed","position":277},{"category":"T-Shirts","position":108},{"category":"New Products","position":325},{"category":"Performance Shirts","position":61},{"category":"Sweatshirts & Hoodies","position":23}],"simple_attributes":{"color":{"black":"NE105_XS_0002","carbon":"NE105_XS_0240","platinum":"NE105_XS_0252","classic-navy":"NE105_XS_0530"},"size":{"2XL":"NE105_2XL_0530","2XS":"NE105_2XS_0530","3XL":"NE105_3XL_0530","L":"NE105_L_0530","M":"NE105_M_0530","S":"NE105_S_0530","XL":"NE105_XL_0530","XS":"NE105_XS_0530"}}}',
      productSuggest: '{"resources":{"results":{"products":[{"available":true,"body":"<p><\\/p><ul>\\n<li>5.3 oz.\\/yd² (US), 8.8 oz.\\/L yd (CA), 69\\/26\\/5 polyester\\/lycoell\\/spandex jersey<\\/li>\\n<li> Superior performance combined with a soft-hand feel<\\/li>\\n<li> Moisture-wicking <\\/li>\\n<li>Anti-microbial performance<\\/li>\\n<li>Self-fabric cuffs<\\/li>\\n<li>Thumbhole on cuffs<br>\\n<\\/li>\\n<li> Dyed-to-match cover stitching throughout<\\/li>\\n<li>Lower inseam pockets<\\/li>\\n<\\/ul><ul><li>The fiber lyocell from Lenzing® is a sustainably sourced, renewable and bio-degradable botanic fiber<\\/li><\\/ul>","compare_at_price_max":"0.00","compare_at_price_min":"0.00","handle":"unisex-jaq-stretch-performance-hooded-t-shirt","id":10176201589025,"image":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242","price":"50.47","price_max":"50.47","price_min":"50.47","tags":["COMDA Select","New Product"],"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","type":"grouped_apparel","url":"\\/products\\/unisex-jaq-stretch-performance-hooded-t-shirt?_pos=1&_psq=id%3A10176201589025&_ss=e&_v=1.0","variants":[],"vendor":"North End","featured_image":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","aspect_ratio":0.8,"height":1250,"url":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242","width":1000}}]}}}',
      mainProduct: '{"id":10176201589025,"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","handle":"unisex-jaq-stretch-performance-hooded-t-shirt","description":"<p><\\/p><ul>\\n<li>5.3 oz.\\/yd² (US), 8.8 oz.\\/L yd (CA), 69\\/26\\/5 polyester\\/lycoell\\/spandex jersey<\\/li>\\n<li> Superior performance combined with a soft-hand feel<\\/li>\\n<li> Moisture-wicking <\\/li>\\n<li>Anti-microbial performance<\\/li>\\n<li>Self-fabric cuffs<\\/li>\\n<li>Thumbhole on cuffs<br>\\n<\\/li>\\n<li> Dyed-to-match cover stitching throughout<\\/li>\\n<li>Lower inseam pockets<\\/li>\\n<\\/ul><ul><li>The fiber lyocell from Lenzing® is a sustainably sourced, renewable and bio-degradable botanic fiber<\\/li><\\/ul>","published_at":"2025-11-06T22:47:16-05:00","created_at":"2025-11-06T22:47:22-05:00","vendor":"North End","type":"grouped_apparel","tags":["COMDA Select","New Product"],"price":5047,"price_min":5047,"price_max":5047,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":51982135263521,"title":"Default Title","option1":"Default Title","option2":null,"option3":null,"sku":"NE105","requires_shipping":true,"taxable":true,"featured_image":null,"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","public_title":null,"options":["Default Title"],"price":5047,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":"NE105","quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]}],"images":["\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_specs.png?v=1762487242","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_left.jpg?v=1762487242","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_rear.jpg?v=1762487243","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front.jpg?v=1762487243","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front.jpg?v=1762487243","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front.jpg?v=1762487243","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/hoodie_imprint_locations_bd5652c5-e406-46df-9fe6-d2a9b7332f10.jpg?v=1762487243"],"featured_image":"\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242","options":[{"name":"Title","position":1,"values":["Default Title"]}],"url":"\\/products\\/unisex-jaq-stretch-performance-hooded-t-shirt","media":[{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","id":43380236157217,"position":1,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front.jpg?v=1762487242","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Specs","id":43380236189985,"position":2,"preview_image":{"aspect_ratio":1.354,"height":322,"width":436,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_specs.png?v=1762487242"},"aspect_ratio":1.354,"height":322,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_specs.png?v=1762487242","width":436},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","id":43380236222753,"position":3,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_left.jpg?v=1762487242"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_left.jpg?v=1762487242","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","id":43380236255521,"position":4,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_rear.jpg?v=1762487243"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_rear.jpg?v=1762487243","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Black","id":43380236288289,"position":5,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front.jpg?v=1762487243"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front.jpg?v=1762487243","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236321057,"position":6,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front.jpg?v=1762487243"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front.jpg?v=1762487243","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Platinum","id":43380236353825,"position":7,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front.jpg?v=1762487243"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front.jpg?v=1762487243","width":1000},{"alt":"Hoodie Imprint Locations","id":43380236386593,"position":8,"preview_image":{"aspect_ratio":1.0,"height":1200,"width":1200,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/hoodie_imprint_locations_bd5652c5-e406-46df-9fe6-d2a9b7332f10.jpg?v=1762487243"},"aspect_ratio":1.0,"height":1200,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/hoodie_imprint_locations_bd5652c5-e406-46df-9fe6-d2a9b7332f10.jpg?v=1762487243","width":1200}],"requires_selling_plan":false,"selling_plan_groups":[]}',
      colorSuggest: '{"resources":{"results":{"products":[{"available":true,"body":"","compare_at_price_max":"0.00","compare_at_price_min":"0.00","handle":"north-end-unisex-jaq-stretch-performance-hooded-t-shirt","id":10176201654561,"image":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250","price":"0.00","price_max":"0.00","price_min":"0.00","tags":[],"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","type":"color","url":"\\/products\\/north-end-unisex-jaq-stretch-performance-hooded-t-shirt?_pos=1&_psq=id%3A10176201654561&_ss=e&_v=1.0","variants":[],"vendor":"CMD US | DEV","featured_image":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","aspect_ratio":0.8,"height":1250,"url":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250","width":1000}}]}}}',
      colorProduct: '{"id":10176201654561,"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","handle":"north-end-unisex-jaq-stretch-performance-hooded-t-shirt","description":"","published_at":"2025-11-06T22:47:30-05:00","created_at":"2025-11-06T22:47:30-05:00","vendor":"CMD US | DEV","type":"color","tags":[],"price":0,"price_min":0,"price_max":0,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":51982135394593,"title":"black","option1":"black","option2":null,"option3":null,"sku":"NE105_XS_0002","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874555169,"product_id":10176201654561,"position":2,"created_at":"2025-11-06T22:47:31-05:00","updated_at":"2025-11-06T22:47:31-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Black","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front_18182ecc-f968-442c-a340-7c93e1eea0d6.jpg?v=1762487251","variant_ids":[51982135394593]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - black","public_title":"black","options":["black"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Black","id":43380236484897,"position":2,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front_18182ecc-f968-442c-a340-7c93e1eea0d6.jpg?v=1762487251"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135427361,"title":"carbon","option1":"carbon","option2":null,"option3":null,"sku":"NE105_XS_0240","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874587937,"product_id":10176201654561,"position":3,"created_at":"2025-11-06T22:47:32-05:00","updated_at":"2025-11-06T22:47:32-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Carbon","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front_5f2c2626-3852-4aa2-8a41-04c251f56825.jpg?v=1762487252","variant_ids":[51982135427361]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - carbon","public_title":"carbon","options":["carbon"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Carbon","id":43380236517665,"position":3,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front_5f2c2626-3852-4aa2-8a41-04c251f56825.jpg?v=1762487252"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135460129,"title":"platinum","option1":"platinum","option2":null,"option3":null,"sku":"NE105_XS_0252","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874620705,"product_id":10176201654561,"position":4,"created_at":"2025-11-06T22:47:34-05:00","updated_at":"2025-11-06T22:47:34-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Platinum","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front_73b6e83a-d983-41fa-97f9-179c51f38263.jpg?v=1762487254","variant_ids":[51982135460129]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - platinum","public_title":"platinum","options":["platinum"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Platinum","id":43380236550433,"position":4,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front_73b6e83a-d983-41fa-97f9-179c51f38263.jpg?v=1762487254"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135492897,"title":"classic-navy","option1":"classic-navy","option2":null,"option3":null,"sku":"NE105_XS_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874653473,"product_id":10176201654561,"position":5,"created_at":"2025-11-06T22:47:35-05:00","updated_at":"2025-11-06T22:47:35-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_8fdfb0fd-cc3e-4d95-83b9-df5c87d19510.jpg?v=1762487255","variant_ids":[51982135492897]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - classic-navy","public_title":"classic-navy","options":["classic-navy"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236583201,"position":5,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_8fdfb0fd-cc3e-4d95-83b9-df5c87d19510.jpg?v=1762487255"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]}],"images":["\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front_18182ecc-f968-442c-a340-7c93e1eea0d6.jpg?v=1762487251","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front_5f2c2626-3852-4aa2-8a41-04c251f56825.jpg?v=1762487252","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front_73b6e83a-d983-41fa-97f9-179c51f38263.jpg?v=1762487254","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_8fdfb0fd-cc3e-4d95-83b9-df5c87d19510.jpg?v=1762487255"],"featured_image":"\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250","options":[{"name":"Title","position":1,"values":["black","carbon","platinum","classic-navy"]}],"url":"\\/products\\/north-end-unisex-jaq-stretch-performance-hooded-t-shirt","media":[{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236452129,"position":1,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_b905cacd-e5f8-438a-956d-8c9e98fd9932.jpg?v=1762487250","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Black","id":43380236484897,"position":2,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front_18182ecc-f968-442c-a340-7c93e1eea0d6.jpg?v=1762487251"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_black_front_18182ecc-f968-442c-a340-7c93e1eea0d6.jpg?v=1762487251","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Carbon","id":43380236517665,"position":3,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front_5f2c2626-3852-4aa2-8a41-04c251f56825.jpg?v=1762487252"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_carbon_front_5f2c2626-3852-4aa2-8a41-04c251f56825.jpg?v=1762487252","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Platinum","id":43380236550433,"position":4,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front_73b6e83a-d983-41fa-97f9-179c51f38263.jpg?v=1762487254"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_platinum_front_73b6e83a-d983-41fa-97f9-179c51f38263.jpg?v=1762487254","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236583201,"position":5,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_8fdfb0fd-cc3e-4d95-83b9-df5c87d19510.jpg?v=1762487255"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_8fdfb0fd-cc3e-4d95-83b9-df5c87d19510.jpg?v=1762487255","width":1000}],"requires_selling_plan":false,"selling_plan_groups":[]}',
      sizeSuggest: '{"resources":{"results":{"products":[{"available":true,"body":"","compare_at_price_max":"0.00","compare_at_price_min":"0.00","handle":"north-end-unisex-jaq-stretch-performance-hooded-t-shirt-1","id":10176201687329,"image":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256","price":"0.00","price_max":"0.00","price_min":"0.00","tags":[],"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","type":"size","url":"\\/products\\/north-end-unisex-jaq-stretch-performance-hooded-t-shirt-1?_pos=1&_psq=id%3A10176201687329&_ss=e&_v=1.0","variants":[],"vendor":"CMD US | DEV","featured_image":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","aspect_ratio":0.8,"height":1250,"url":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256","width":1000}}]}}}',
      sizeProduct: '{"id":10176201687329,"title":"North End Unisex JAQ Stretch Performance Hooded T-Shirt","handle":"north-end-unisex-jaq-stretch-performance-hooded-t-shirt-1","description":"","published_at":"2025-11-06T22:47:36-05:00","created_at":"2025-11-06T22:47:36-05:00","vendor":"CMD US | DEV","type":"size","tags":[],"price":0,"price_min":0,"price_max":0,"available":true,"price_varies":false,"compare_at_price":null,"compare_at_price_min":0,"compare_at_price_max":0,"compare_at_price_varies":false,"variants":[{"id":51982135525665,"title":"2XS","option1":"2XS","option2":null,"option3":null,"sku":"NE105_2XS_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874719009,"product_id":10176201687329,"position":2,"created_at":"2025-11-06T22:47:37-05:00","updated_at":"2025-11-06T22:47:37-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_9d330aa0-11e1-49f3-8fa6-274328273eec.jpg?v=1762487257","variant_ids":[51982135525665]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2XS","public_title":"2XS","options":["2XS"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236648737,"position":2,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_9d330aa0-11e1-49f3-8fa6-274328273eec.jpg?v=1762487257"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135558433,"title":"XS","option1":"XS","option2":null,"option3":null,"sku":"NE105_XS_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874751777,"product_id":10176201687329,"position":3,"created_at":"2025-11-06T22:47:39-05:00","updated_at":"2025-11-06T22:47:39-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6a9fe723-943d-466c-9383-f8e4ae16e065.jpg?v=1762487259","variant_ids":[51982135558433]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - XS","public_title":"XS","options":["XS"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236681505,"position":3,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6a9fe723-943d-466c-9383-f8e4ae16e065.jpg?v=1762487259"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135591201,"title":"S","option1":"S","option2":null,"option3":null,"sku":"NE105_S_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874784545,"product_id":10176201687329,"position":4,"created_at":"2025-11-06T22:47:40-05:00","updated_at":"2025-11-06T22:47:40-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_441f3e26-9066-49b9-87bc-aff8d87199c2.jpg?v=1762487260","variant_ids":[51982135591201]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - S","public_title":"S","options":["S"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236714273,"position":4,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_441f3e26-9066-49b9-87bc-aff8d87199c2.jpg?v=1762487260"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135623969,"title":"M","option1":"M","option2":null,"option3":null,"sku":"NE105_M_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874817313,"product_id":10176201687329,"position":5,"created_at":"2025-11-06T22:47:41-05:00","updated_at":"2025-11-06T22:47:41-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_23c6081c-fac9-40c9-b060-a387f2516ffc.jpg?v=1762487261","variant_ids":[51982135623969]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - M","public_title":"M","options":["M"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236747041,"position":5,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_23c6081c-fac9-40c9-b060-a387f2516ffc.jpg?v=1762487261"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135656737,"title":"L","option1":"L","option2":null,"option3":null,"sku":"NE105_L_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874850081,"product_id":10176201687329,"position":6,"created_at":"2025-11-06T22:47:42-05:00","updated_at":"2025-11-06T22:47:42-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_37e72c2f-0373-499e-a30e-08bebd0baedf.jpg?v=1762487262","variant_ids":[51982135656737]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - L","public_title":"L","options":["L"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236779809,"position":6,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_37e72c2f-0373-499e-a30e-08bebd0baedf.jpg?v=1762487262"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135689505,"title":"XL","option1":"XL","option2":null,"option3":null,"sku":"NE105_XL_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874882849,"product_id":10176201687329,"position":7,"created_at":"2025-11-06T22:47:44-05:00","updated_at":"2025-11-06T22:47:44-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_f409ba83-d4ce-4b70-a92a-787a16771e5b.jpg?v=1762487264","variant_ids":[51982135689505]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - XL","public_title":"XL","options":["XL"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236812577,"position":7,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_f409ba83-d4ce-4b70-a92a-787a16771e5b.jpg?v=1762487264"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135722273,"title":"2XL","option1":"2XL","option2":null,"option3":null,"sku":"NE105_2XL_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874915617,"product_id":10176201687329,"position":8,"created_at":"2025-11-06T22:47:45-05:00","updated_at":"2025-11-06T22:47:45-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_ecfdaf5f-2f5c-467e-a9a9-16c744d488d6.jpg?v=1762487265","variant_ids":[51982135722273]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 2XL","public_title":"2XL","options":["2XL"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236845345,"position":8,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_ecfdaf5f-2f5c-467e-a9a9-16c744d488d6.jpg?v=1762487265"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":51982135755041,"title":"3XL","option1":"3XL","option2":null,"option3":null,"sku":"NE105_3XL_0530","requires_shipping":true,"taxable":true,"featured_image":{"id":53033874948385,"product_id":10176201687329,"position":9,"created_at":"2025-11-06T22:47:46-05:00","updated_at":"2025-11-06T22:47:46-05:00","alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","width":1000,"height":1250,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_08f1f8e2-8ce6-4311-8db8-870e9a5ecb58.jpg?v=1762487266","variant_ids":[51982135755041]},"available":true,"name":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - 3XL","public_title":"3XL","options":["3XL"],"price":0,"weight":0,"compare_at_price":null,"inventory_management":null,"barcode":null,"featured_media":{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236878113,"position":9,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_08f1f8e2-8ce6-4311-8db8-870e9a5ecb58.jpg?v=1762487266"}},"quantity_rule":{"min":1,"max":null,"increment":1},"quantity_price_breaks":[],"requires_selling_plan":false,"selling_plan_allocations":[]}],"images":["\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_9d330aa0-11e1-49f3-8fa6-274328273eec.jpg?v=1762487257","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6a9fe723-943d-466c-9383-f8e4ae16e065.jpg?v=1762487259","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_441f3e26-9066-49b9-87bc-aff8d87199c2.jpg?v=1762487260","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_23c6081c-fac9-40c9-b060-a387f2516ffc.jpg?v=1762487261","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_37e72c2f-0373-499e-a30e-08bebd0baedf.jpg?v=1762487262","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_f409ba83-d4ce-4b70-a92a-787a16771e5b.jpg?v=1762487264","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_ecfdaf5f-2f5c-467e-a9a9-16c744d488d6.jpg?v=1762487265","\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_08f1f8e2-8ce6-4311-8db8-870e9a5ecb58.jpg?v=1762487266"],"featured_image":"\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256","options":[{"name":"Title","position":1,"values":["2XS","XS","S","M","L","XL","2XL","3XL"]}],"url":"\\/products\\/north-end-unisex-jaq-stretch-performance-hooded-t-shirt-1","media":[{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236615969,"position":1,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6cfd57a7-2993-4c83-822d-4bee4c26d43c.jpg?v=1762487256","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236648737,"position":2,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_9d330aa0-11e1-49f3-8fa6-274328273eec.jpg?v=1762487257"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_9d330aa0-11e1-49f3-8fa6-274328273eec.jpg?v=1762487257","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236681505,"position":3,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6a9fe723-943d-466c-9383-f8e4ae16e065.jpg?v=1762487259"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_6a9fe723-943d-466c-9383-f8e4ae16e065.jpg?v=1762487259","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236714273,"position":4,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_441f3e26-9066-49b9-87bc-aff8d87199c2.jpg?v=1762487260"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_441f3e26-9066-49b9-87bc-aff8d87199c2.jpg?v=1762487260","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236747041,"position":5,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_23c6081c-fac9-40c9-b060-a387f2516ffc.jpg?v=1762487261"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_23c6081c-fac9-40c9-b060-a387f2516ffc.jpg?v=1762487261","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236779809,"position":6,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_37e72c2f-0373-499e-a30e-08bebd0baedf.jpg?v=1762487262"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_37e72c2f-0373-499e-a30e-08bebd0baedf.jpg?v=1762487262","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236812577,"position":7,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_f409ba83-d4ce-4b70-a92a-787a16771e5b.jpg?v=1762487264"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_f409ba83-d4ce-4b70-a92a-787a16771e5b.jpg?v=1762487264","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236845345,"position":8,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_ecfdaf5f-2f5c-467e-a9a9-16c744d488d6.jpg?v=1762487265"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_ecfdaf5f-2f5c-467e-a9a9-16c744d488d6.jpg?v=1762487265","width":1000},{"alt":"North End Unisex JAQ Stretch Performance Hooded T-Shirt - Classic Navy","id":43380236878113,"position":9,"preview_image":{"aspect_ratio":0.8,"height":1250,"width":1000,"src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_08f1f8e2-8ce6-4311-8db8-870e9a5ecb58.jpg?v=1762487266"},"aspect_ratio":0.8,"height":1250,"media_type":"image","src":"https:\\/\\/cdn.shopify.com\\/s\\/files\\/1\\/0848\\/8645\\/4561\\/files\\/ne105_classicnavy_front_08f1f8e2-8ce6-4311-8db8-870e9a5ecb58.jpg?v=1762487266","width":1000}],"requires_selling_plan":false,"selling_plan_groups":[]}'
    }
    //search/suggest.json?q=id:10176201589025&resources[type]=product&limit=1 // grouped product
    //products/unisex-jaq-stretch-performance-hooded-t-shirt.js
    //https://devcomda.myshopify.com/search/suggest.json?q=id:10205043228961&resources[type]=product&limit=1 //color
    //products/north-end-unisex-jaq-stretch-performance-hooded-t-shirt.js
    //https://devcomda.myshopify.com/search/suggest.json?q=id:10176201687329&resources[type]=product&limit=1 //size
    //products/north-end-unisex-jaq-stretch-performance-hooded-t-shirt-1.js
  };
  const mockProduct = productsJsonData.apparel;
  const useMockData$1 = function() {
    const host = window.location.hostname;
    return host === "localhost" || host === "127.0.0.1";
  };
  const useAppStore = /* @__PURE__ */ defineStore("app", {
    state: () => ({
      // Main product data
      mainProduct: {},
      mainProductID: null,
      full_product: null,
      full_product_json: null,
      responseProduct: {},
      // Application type and product type
      applicationType: "default",
      productType: null,
      // Store identification
      storeID: null,
      isComda: false,
      // Product flags
      isCustomBundlePage: false,
      isEnvelopProduct: false,
      // Customer data
      isCustomerGuest: true,
      b2bCompanyId: null,
      // numeric string company ID for the current B2B customer, or null
      b2bTierPrices: null,
      // parsed metafield JSON or null
      // Group ID for cart operations
      currentGroupID: null,
      // API configuration
      apiBaseUrl: "",
      currentLocationUrl: "",
      // Loading states
      disableButtonFirstStep: true,
      // Inventory / stock status ('In Stock', 'Out of Stock', etc.)
      inventoryStatus: null,
      // Calendar specific data
      calendar: {
        productList: []
      },
      // Calendar single page data (for data-attributes)
      calendarSingleData: {
        productId: null,
        productTitle: "",
        productImage: "",
        quantity: 25,
        unitPrice: 0,
        // Base unit price for calendar product
        tierPrice: []
        // Tier pricing matrix for bundle calculation
      },
      // Associated IDs (for color product mapping)
      associatedIds: null
    }),
    getters: {
      // Get main full main product
      getMainProduct(state) {
        return state.mainProduct;
      },
      // Get MainProductId grouped
      getMainProductId(state) {
        var _a;
        return ((_a = state.mainProduct) == null ? void 0 : _a.id) || state.mainProductID;
      },
      getApplicationType(state) {
        if (this.isCalendarSingle) {
          return "calendar_single";
        }
        if (state.applicationType === "calendar") {
          return "calendar";
        }
        return "default";
      },
      // Check if it's custom bundle page
      getIsCustomBundlePage(state) {
        return state.isCustomBundlePage;
      },
      // Check if product is envelope
      getIsEnvelopProduct(state) {
        return state.isEnvelopProduct;
      },
      // Get current group ID
      getCurrentGroupID(state) {
        return state.currentGroupID;
      },
      // Get color product ID by variant ID
      getColorProductIdByVariantId: (state) => (variantId) => {
        var _a;
        if (!state.associatedIds) {
          console.error("[AppStore] associatedIds not loaded");
          return variantId;
        }
        const idColor = (_a = state.associatedIds.simples) == null ? void 0 : _a.id_color;
        if (Array.isArray(idColor)) {
          return idColor[idColor.length - 1];
        }
        return idColor || variantId;
      },
      /**
       * Check if current mode requires Color & Quantity step
       * For calendar modes - hide Color & Quantity
       */
      shouldShowColorQuantityStep(state) {
        return state.applicationType === "default";
      },
      /**
       * Get minimum order quantity based on application type
       */
      getMinOrderQty(state) {
        var _a;
        if (state.applicationType === "calendar" || state.applicationType === "calendar_single") {
          return state.isComda ? 100 : 150;
        }
        return ((_a = state.full_product_json) == null ? void 0 : _a.min_order_qty) || 25;
      },
      /**
       * Check if current page is calendar single (bundle entry point)
       * Simplified detection using applicationType and DOM checks
       */
      isCalendarSingle(state) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const isProductPage = window.location.pathname.includes("/products/");
        const bundleTag = document.getElementById("it-is-bundle-product");
        const isBundleProduct = (bundleTag == null ? void 0 : bundleTag.textContent) === "yes";
        const isCalendar = state.applicationType === "calendar_single" || // Already detected
        ((_a = state.full_product) == null ? void 0 : _a.is_calendar) === "true" || // From full_product JSON
        ((_b = state.full_product) == null ? void 0 : _b.is_calendar) === true || // Boolean variant
        ((_d = (_c = state.full_product) == null ? void 0 : _c.tags) == null ? void 0 : _d.includes("calendar")) || // Shopify tags
        ((_e = state.full_product) == null ? void 0 : _e.product_type) === "Calendar";
        const result = isProductPage && isCalendar && isBundleProduct;
        console.log("[AppStore] isCalendarSingle check:", {
          isProductPage,
          isCalendar,
          isBundleProduct,
          result,
          pathname: window.location.pathname,
          applicationType: state.applicationType,
          fullProduct: state.full_product,
          fullProductIsCalendar: (_f = state.full_product) == null ? void 0 : _f.is_calendar,
          fullProductTags: (_g = state.full_product) == null ? void 0 : _g.tags,
          fullProductType: (_h = state.full_product) == null ? void 0 : _h.product_type,
          bundleTagElement: bundleTag,
          bundleTagText: bundleTag == null ? void 0 : bundleTag.textContent
        });
        return result;
      },
      /**
       * Check if calendar mode is active
       */
      isCalendarMode(state) {
        return state.applicationType === "calendar" || state.applicationType === "calendar_single";
      },
      isOutOfStock(state) {
        return state.inventoryStatus === "Out of Stock";
      },
      /**
       * Get calendar products with computed total quantity
       */
      getCalendarProducts(state) {
        return state.calendar.productList.map((product) => ({
          ...product,
          totalQty: product.qty || 0
        }));
      },
      /**
       * Return B2B tiers for the given imprint SKU.
       *
       * Security model:
       *   - #b2b_tier_prices and #b2b_company_id are only injected by Liquid
       *     for customer.b2b? visitors — non-B2B users never populate these.
       *   - b2bCompanyId = customer.current_company.id (injected by Liquid).
       *     We look up tiers ONLY under that exact key in the metafield, so a
       *     wrong/mismatched company ID in the metafield does NOT show B2B prices.
       *   - The backend independently validates via Admin API (resolveB2BCompanyId).
       */
      getB2BTierForSku: (state) => (imprintSku) => {
        var _a;
        if (!state.b2bTierPrices) return null;
        if (!state.b2bCompanyId) return null;
        const tiers = (_a = state.b2bTierPrices[state.b2bCompanyId]) == null ? void 0 : _a[imprintSku];
        if ((tiers == null ? void 0 : tiers.length) > 0) return tiers;
        console.warn(
          `[AppStore] B2B — no tiers found for companyId=${state.b2bCompanyId} sku=${imprintSku}. Available keys: [${Object.keys(state.b2bTierPrices).join(", ")}]`
        );
        return null;
      }
    },
    actions: {
      /**
       * Set associated IDs (called from ColorSizeSection after loading)
       */
      setAssociatedIds(ids) {
        this.associatedIds = ids;
        console.log("[AppStore] Associated IDs set:", this.associatedIds);
      },
      /**
      
                 * Initialize main product ID based on page context
                 * This replaces the created() logic from StepNavigation
                 */
      async initMainProductID() {
        let response = null;
        if (useMockData$1()) {
          this.mainProductID = mockProduct.id;
          return this.mainProductID;
        }
        if (window.location.pathname !== "/collections/calendar-bundle-custom") {
          const element = document.getElementById("current_main_product_id");
          if (element) {
            response = element.textContent;
            this.mainProductID = parseInt(response);
            console.log("Main product ID initialized:", this.mainProductID);
          }
        }
        if (this.applicationType === "calendar_single") {
          const mainProductElement = window.jQuery(".main_product_id")[0];
          if (mainProductElement) {
            response = mainProductElement.textContent;
            this.mainProductID = parseInt(response);
            const fullProductElement = window.jQuery("#full_product_info_json--wall");
            if (fullProductElement.length) {
              this.full_product = JSON.parse(fullProductElement.text());
            }
          }
        }
        if (window.location.pathname === "/collections/calendar-bundle-custom" && this.applicationType !== "calendar_single") {
          console.log("Calendar Bundle page detected");
          this.applicationType = "calendar";
          const mainProductElement = window.jQuery(".main_product_id")[0];
          if (mainProductElement) {
            response = mainProductElement.textContent;
            this.mainProductID = parseInt(response);
            const fullProductJsonElement = window.jQuery(`.full_product_info_json-${this.mainProductID}`)[0];
            if (fullProductJsonElement) {
              this.full_product = JSON.parse(fullProductJsonElement.textContent);
            }
          }
        }
        console.log("mainProductID initialized:", this.mainProductID);
        const fullProductInfoElement = document.getElementById("full_product_info_json");
        if (fullProductInfoElement) {
          this.full_product_json = JSON.parse(fullProductInfoElement.textContent);
        }
        if (this.isCalendarEnvelopProduct()) {
          this.isEnvelopProduct = true;
        }
        return this.mainProductID;
      },
      /**
       * Check if product is a calendar envelope
       */
      isCalendarEnvelopProduct() {
        return window.jQuery("#is_calendar_envelop_product").length > 0;
      },
      /**
       * Set inventory status (ported from StepNavigstion.vue setInventoryStatus()).
       * Drives isOutOfStock getter, which blocks Add to Cart.
       * Must be called AFTER full_product_json is loaded (i.e. after initMainProductID()).
       */
      setInventoryStatus() {
        var _a;
        console.log("-----Set Inventory Status ----- ");
        this.inventoryStatus = "In Stock";
        if (((_a = this.full_product_json) == null ? void 0 : _a.is_in_stock) !== void 0 && this.applicationType !== "calendar_single") {
          this.inventoryStatus = this.full_product_json.is_in_stock.trim();
          console.log("set status from full_product_json" + this.inventoryStatus);
        }
        if (this.applicationType === "calendar_single") {
          const statusEl = document.getElementById("inventory_status");
          if (statusEl) {
            const status = statusEl.textContent.trim();
            if (status) {
              this.inventoryStatus = status;
              console.log("inventory status for simple calendar " + this.inventoryStatus);
            } else {
              console.log("inventory status is empty for calendar_sku");
              console.log(status);
            }
          } else {
            console.log("inventory_status element not found for calendar_sku");
          }
        }
      },
      /**
       * Set application type based on page context
       */
      async initApplicationType() {
        const singleCalendarBundleElement = document.getElementById("it-is-bundle-product");
        if (singleCalendarBundleElement) {
          const singleCalendarBundleTag = singleCalendarBundleElement.textContent;
          console.log("Single calendar bundle tag:", singleCalendarBundleTag);
          if (singleCalendarBundleTag === "yes") {
            this.applicationType = "calendar_single";
          }
        }
        const customBundlePageElement = document.getElementById("it-is-bundle-custom-page");
        if (customBundlePageElement) {
          const customBundlePage = customBundlePageElement.textContent;
          if (customBundlePage === "yes") {
            this.isCustomBundlePage = true;
            console.log("Custom bundle page detected");
          }
        }
        console.log("Application type initialized:", this.applicationType);
      },
      /**
       * Initialize store ID based on theme settings
       */
      initStoreID() {
        var _a, _b, _c;
        if (((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.project_store_name) && ((_c = window.Shopify) == null ? void 0 : _c.country)) {
          this.storeID = `${window.PXUTheme.theme_settings.project_store_name}_${window.Shopify.country.toLowerCase()}`;
          console.log("Store ID initialized:", this.storeID);
        }
      },
      /**
       * Initialize if current site is Comda
       */
      initIsComda() {
        this.isComda = window.location.href.includes("comda");
        this.currentLocationUrl = window.location.host;
        console.log("Is Comda:", this.isComda);
      },
      /**
       * Check if customer is guest (not logged in) and load B2B data.
       *
       * B2B data is read from DOM elements injected by json_info__block.liquid.
       * Both elements are only present when customer.b2b? is true in Liquid,
       * so non-B2B visitors never populate b2bCompanyId or b2bTierPrices.
       *
       * b2bCompanyId (#b2b_company_id) — customer.current_company.id from Liquid.
       *   Used to match against metafield keys before showing B2B prices.
       * b2bTierPrices (#b2b_tier_prices) — custom.b2b_tier_prices metafield JSON.
       */
      initIsCustomerGuest() {
        var _a, _b;
        const customerIdElement = document.getElementById("customer_id");
        if (customerIdElement) {
          const customerId = customerIdElement.textContent;
          this.isCustomerGuest = !customerId;
        }
        console.log("Is customer guest:", this.isCustomerGuest);
        const b2bCompanyIdEl = document.getElementById("b2b_company_id");
        const rawCompanyId = (_a = b2bCompanyIdEl == null ? void 0 : b2bCompanyIdEl.textContent) == null ? void 0 : _a.trim();
        this.b2bCompanyId = rawCompanyId || null;
        const b2bTierPricesEl = document.getElementById("b2b_tier_prices");
        const rawTiers = (_b = b2bTierPricesEl == null ? void 0 : b2bTierPricesEl.textContent) == null ? void 0 : _b.trim();
        if (rawTiers) {
          try {
            this.b2bTierPrices = JSON.parse(rawTiers);
          } catch (e) {
            console.error("[AppStore] Failed to parse b2b_tier_prices JSON:", e);
            this.b2bTierPrices = null;
          }
        }
        console.log("[AppStore] B2B — companyId:", this.b2bCompanyId, "| hasTierPrices:", !!this.b2bTierPrices);
      },
      /**
       * Generate random string for group ID
       */
      generateRandomString(length) {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const charactersLength = characters.length;
        let result = "";
        const randomValues = new Uint32Array(length);
        window.crypto.getRandomValues(randomValues);
        randomValues.forEach((value) => {
          result += characters.charAt(value % charactersLength);
        });
        return result;
      },
      /**
       * Generate unique group ID for cart grouping
       */
      generateGroupID() {
        const date = /* @__PURE__ */ new Date();
        const timestamp = date.getTime();
        const randomString = this.generateRandomString(30);
        this.currentGroupID = `${timestamp}_${randomString}`;
        return this.currentGroupID;
      },
      /**
       * Initialize API base URL from theme settings
       */
      initApiBaseUrl() {
        var _a, _b;
        if ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.api_beckend_url) {
          this.apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
          console.log("API base URL initialized:", this.apiBaseUrl);
        } else {
          this.apiBaseUrl = "https://dev.api-customapp.comda.com/";
          console.error("Please set theme setting: api_beckend_url");
        }
      },
      /**
       * Get product by Shopify handle
       */
      async getProductByHandle(handle) {
        try {
          console.log("Fetching product by handle:", handle);
          const response = await axios.get(`${window.Shopify.routes.root}products/${handle}.js`);
          console.log("Product fetched:", response.data);
          console.log("Product type:", response.data.type);
          this.setProductType(response.data.type);
          this.disableButtonFirstStep = false;
          return response.data;
        } catch (error) {
          console.error("Error fetching product by handle:", error);
          throw error;
        }
      },
      /**
       * Set product type (grouped_plain, etc.)
       */
      setProductType(type) {
        this.productType = type;
        console.log("Product type set:", type);
      },
      /**
       * Get main product handle by ID using search API
       */
      async getMainProductHandleById(id) {
        var _a, _b, _c, _d;
        if (useMockData$1()) {
          const mainProduct = JSON.parse(mockProduct.mainProduct);
          this.setProductType(mainProduct.type);
          return true;
        }
        try {
          const response = await axios.get(
            `/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`
          );
          this.responseProduct = (response == null ? void 0 : response.data) || null;
          if ((_d = (_c = (_b = (_a = this.responseProduct) == null ? void 0 : _a.resources) == null ? void 0 : _b.results) == null ? void 0 : _c.products) == null ? void 0 : _d[0]) {
            const handle = this.responseProduct.resources.results.products[0].handle;
            await this.getProductByHandle(handle);
          }
        } catch (error) {
          console.error("Error fetching product handle by ID:", error);
          throw error;
        }
      },
      /**
       * Initialize products from calendar storage (localStorage)
       */
      initProductsFromCalendarStorage() {
        console.log("Initializing calendar products from storage");
        if (localStorage.fullStorageProductList && localStorage.fullStorageProductList.length) {
          try {
            this.calendar.productList = JSON.parse(localStorage.fullStorageProductList);
            console.log("Calendar products loaded:", this.calendar.productList);
          } catch (error) {
            console.error("Error parsing calendar products from storage:", error);
          }
        }
      },
      /**
       * Update calendar product quantity
       * Called from UI when user changes qty on calendar bundle page
       */
      updateCalendarProductQty(productId, newQty) {
        const product = this.calendar.productList.find((p2) => p2.id === productId);
        if (product) {
          product.qty = newQty;
          this.saveCalendarProductsToStorage();
          console.log("[AppStore] Calendar product qty updated:", productId, newQty);
        }
      },
      /**
       * Save calendar products back to localStorage
       */
      saveCalendarProductsToStorage() {
        if (this.applicationType === "calendar" || this.applicationType === "calendar_single") {
          localStorage.setItem(
            "fullStorageProductList",
            JSON.stringify(this.calendar.productList)
          );
          console.log("[AppStore] Calendar products saved to localStorage");
        }
      },
      /**
       * Clear calendar products
       */
      clearCalendarProducts() {
        this.calendar.productList = [];
        localStorage.removeItem("fullStorageProductList");
        localStorage.removeItem("storageProductList");
        console.log("[AppStore] Calendar products cleared");
      },
      /**
       * Load calendar single page data from DOM
       * This data is used for data-attributes on "Add to Bundle" button
       * Called from CalendarSinglePage component on mount
       */
      loadCalendarSingleData() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.isCalendarSingle) {
          console.warn("[AppStore] Not a calendar single page, skipping data load");
          return;
        }
        console.log("[AppStore] Loading calendar single data from DOM...");
        const idElement = document.getElementById("simple_calendar_pr_id");
        if (idElement) {
          this.calendarSingleData.productId = parseInt(idElement.textContent);
          console.log("[AppStore] Product ID loaded:", this.calendarSingleData.productId);
        } else {
          console.error("[AppStore] Element #simple_calendar_pr_id not found!");
        }
        const titleElement = document.querySelector("h1.product_name");
        if (titleElement) {
          this.calendarSingleData.productTitle = titleElement.textContent.trim();
          console.log("[AppStore] Product title loaded:", this.calendarSingleData.productTitle);
        } else {
          console.error("[AppStore] Element h1.product_name not found!");
        }
        const galleryCell = document.querySelector(".gallery-cell");
        if (galleryCell) {
          const lightbox = galleryCell.querySelector("a.lightbox");
          if (lightbox) {
            this.calendarSingleData.productImage = lightbox.getAttribute("href");
            console.log("[AppStore] Product image loaded from lightbox:", this.calendarSingleData.productImage);
          } else {
            const img = galleryCell.querySelector("img.product-gallery__image");
            if (img) {
              this.calendarSingleData.productImage = img.getAttribute("data-src") || img.getAttribute("src");
              console.log("[AppStore] Product image loaded from img:", this.calendarSingleData.productImage);
            } else {
              console.error("[AppStore] Image not found in gallery-cell!");
            }
          }
        } else {
          console.error("[AppStore] Element .gallery-cell not found!");
        }
        let unitPrice = 0;
        if (((_b = (_a = window.Shopify) == null ? void 0 : _a.Product) == null ? void 0 : _b.variants) && window.Shopify.Product.variants.length > 0) {
          const variant = window.Shopify.Product.variants[0];
          if (variant && variant.price) {
            unitPrice = parseFloat(variant.price) / 100;
            console.log("[AppStore] Unit price loaded from Shopify.Product.variants:", unitPrice);
          }
        }
        if (unitPrice === 0) {
          const priceElement = document.querySelector(".price .money, .price, [data-product-price]");
          if (priceElement) {
            const priceText = priceElement.textContent.trim().replace(/[$,]/g, "");
            const parsedPrice = parseFloat(priceText);
            if (!isNaN(parsedPrice)) {
              unitPrice = parsedPrice;
              console.log("[AppStore] Unit price loaded from DOM .price:", unitPrice);
            }
          }
        }
        if (unitPrice === 0) {
          const metaPrice = document.querySelector('meta[property="product:price:amount"]');
          if (metaPrice) {
            const price = parseFloat(metaPrice.getAttribute("content"));
            if (!isNaN(price)) {
              unitPrice = price;
              console.log("[AppStore] Unit price loaded from meta tag:", unitPrice);
            }
          }
        }
        this.calendarSingleData.unitPrice = unitPrice;
        if (unitPrice === 0) {
          console.warn("[AppStore] Could not find product price! Calendar will have $0.00 unit price.");
        }
        let tierPrice = [];
        if (((_d = (_c = window.Shopify) == null ? void 0 : _c.Product) == null ? void 0 : _d.variants) && window.Shopify.Product.variants.length > 0) {
          const variant = window.Shopify.Product.variants[0];
          if (variant && variant.tier_price) {
            tierPrice = variant.tier_price;
            console.log("[AppStore] Tier price loaded from Shopify.Product.variants:", tierPrice);
          }
        }
        if (tierPrice.length === 0 && ((_f = (_e = this.full_product) == null ? void 0 : _e.prices_2) == null ? void 0 : _f.tier_price)) {
          tierPrice = this.full_product.prices_2.tier_price;
          console.log("[AppStore] Tier price loaded from full_product:", tierPrice);
        }
        this.calendarSingleData.tierPrice = tierPrice;
        if (tierPrice.length === 0) {
          console.warn("[AppStore] No tier price matrix found! Will use fixed unitPrice.");
        }
        console.log("[AppStore] Calendar single data loaded:", this.calendarSingleData);
      },
      /**
       * Main initialization method - replaces created() hook logic
       * Call this from component's setup() or onMounted()
       */
      async initialize() {
        console.log("=== Starting App Store Initialization ===");
        try {
          this.initStoreID();
          this.initIsComda();
          this.initIsCustomerGuest();
          this.initApiBaseUrl();
          this.generateGroupID();
          if (!this._pageshowBound) {
            this._pageshowBound = true;
            window.addEventListener("pageshow", (event2) => {
              if (event2.persisted) {
                this.generateGroupID();
              }
            });
          }
          await this.initApplicationType();
          if (this.applicationType === "calendar_single") {
            this.loadCalendarSingleData();
          }
          await this.initMainProductID();
          this.setInventoryStatus();
          if (this.mainProductID) {
            await this.getMainProductHandleById(this.mainProductID);
          }
          if (this.applicationType === "calendar") {
            this.initProductsFromCalendarStorage();
          }
          console.log("=== App Store Initialization Complete ===");
          console.log("Store state:", {
            mainProductID: this.mainProductID,
            applicationType: this.applicationType,
            isCustomBundlePage: this.isCustomBundlePage,
            isEnvelopProduct: this.isEnvelopProduct,
            productType: this.productType,
            storeID: this.storeID,
            isComda: this.isComda,
            associatedIds: this.associatedIds
          });
        } catch (error) {
          console.error("Error during app store initialization:", error);
          throw error;
        }
      }
    }
  });
  const _sfc_main$D = {
    emits: ["tabs-status"],
    components: {
      PriceMatrixComponent,
      CustomSelect
    },
    props: {
      getColorText: Function,
      applicationType: String,
      textCardTitle: String
    },
    data() {
      return {
        debugMode: true,
        activeTab: 0,
        tabs: [],
        store,
        full_product: {},
        tier_data: [],
        // type [{}]
        configurable_array: {},
        isMSRPData: false,
        MSRPPrice: null,
        key: null,
        imprintData: {},
        imprintSKUs: [],
        isSpecial: false,
        functions,
        availablePrintMethods: [],
        activeTabForCalendarBundle: null
      };
    },
    computed: {
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      },
      isComda() {
        return store.storeID.includes("comda");
      },
      tabsCheckRequired() {
        return this.store.application_type === "calendar";
      },
      appStore() {
        return useAppStore();
      }
    },
    methods: {
      setActiveImprintTab(tab, index) {
        console.warn("tab:");
        console.warn(tab);
        this.activeTab = index;
        this.store.selectedImprint.id = index;
        this.store.selectedImprint.tabName = tab.tabName;
        this.setTierData(tab.id);
        this.initImprintData();
        this.initFeePriceForTab();
        this.initSkuValueForTab();
        console.log("imprint Tabs data");
        console.log(this.store.selectedImprint.tabName);
        console.log(this.store.imprintKey);
        console.log(this.store.specialPrice);
        console.warn(this.isSpecial);
        if (this.store.application_type == "calendar_single" || this.store.application_type == "calendar") {
          window.jQuery.event.trigger({
            type: "imprintTabChanged",
            message: "imprintTabChanged",
            time: { tab, index }
          });
        }
      },
      initFeePriceForTab() {
        let imprintSKU = this.store.selectedImprint.sku;
        this.imprintData = this.store.inputProductData.fullJson.configurable_array[imprintSKU].configurable_2_data;
        this.store.selectedImprint.data = this.store.inputProductData.fullJson.configurable_array[imprintSKU];
        if (this.store.isEnvelopProduct && !Object.hasOwn(this.imprintData.imprint_data, "setup_fee")) {
          return;
        }
        this.store.perItemFee.setupFee = this.imprintData.imprint_data.setup_fee;
        this.store.perItemFee.customColourFee = this.imprintData.imprint_data.custom_colour_fee;
        this.store.perItemFee.proof_fee = this.imprintData.imprint_data.proof_fee;
        this.store.perItemFee.image_fee = this.imprintData.imprint_data.image_fee;
        this.store.perItemFee.running_fee = this.imprintData.imprint_data.running_fee;
      },
      initSpecialPrice() {
        console.error("initSpecialPrice+++++");
        console.warn(this.store.selectedImprint.sku);
        let specialPriceObj = {
          dateStart: null,
          dateEnd: null,
          value: null,
          isImprintMethodSpecial: false,
          tier: []
        };
        this.imprintSKUs = Object.keys(this.store.inputProductData.fullJson.configurable_array);
        this.imprintSKUs.forEach((sku) => {
          this.store.inputProductData.fullJson.configurable_array[sku].prices_2.tier_price.forEach(
            (item, index) => {
              console.warn("sdasdasdasdasd 121212");
              console.log(this.store.prices.tier);
              console.log(index);
              const b2bTier = this.appStore.getB2BTierForSku(sku);
              const b2bPrice = b2bTier !== null ? this.functions.getB2BPriceForTier(item, b2bTier) : null;
              if (b2bPrice !== null) {
                this.store.prices.priceByQty = b2bPrice;
              } else if (this.functions.isValidatedSpecialPrice(item)) {
                this.isSpecial = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
                if (this.store.prices.tier) {
                  this.store.prices.tier[index]["is_special_tier"] = this.functions.isCurrentDateActive(
                    item["sale_price_effectivedate"],
                    item["sale_price_terminationdate"]
                  );
                }
                specialPriceObj.dateStart = item["sale_price_effectivedate"];
                specialPriceObj.dateEnd = item["sale_price_terminationdate"];
                specialPriceObj.value = item["sale_price"];
                specialPriceObj.tier.push({
                  index,
                  value: item["sale_price"]
                });
                this.store.specialPrice.byImprintMethods[sku] = specialPriceObj;
                Object.assign(this.store.specialPrice, specialPriceObj);
                this.store.prices.priceByQty = item["sale_price"];
              } else {
                if (this.store.prices.tier) {
                  this.store.prices.tier[index]["is_special_tier"] = false;
                }
                this.store.prices.priceByQty = item["price"];
              }
              if (this.store.prices.tier) {
                console.error("isCurrentDateActive vvvvvv ");
                console.error("qqqqqqqqqqqqqqqq");
                console.error(this.store.prices.tier[index]["is_special_tier"]);
                console.log(this.store.prices.tier[index]["is_special_tier"]);
              }
            }
          );
        });
      },
      initSkuValueForTab() {
        this.store.sku.fee.custom_colour_fee.val = this.imprintData.imprint_data.colour_fee_sku;
        this.store.sku.fee.image_fee.val = this.imprintData.imprint_data.image_fee_sku;
        this.store.sku.fee.proof_fee.val = this.imprintData.imprint_data.proof_fee_sku;
        this.store.sku.fee.running_fee.val = this.imprintData.imprint_data.running_fee_sku;
        this.store.sku.fee.setup_fee.val = this.imprintData.imprint_data.setup_fee_sku;
        this.store.sku.imprint.method.val = this.store.selectedImprint.sku;
      },
      setImprintKey() {
        this.store.imprintKey = this.store.selectedImprint.tabName;
      },
      initImprintData() {
        this.setImprintKey();
        if (!Object.hasOwn(this.store.colorSizeLines, this.store.imprintKey)) {
          this.store.colorSizeLines[this.store.imprintKey] = [];
          let colorSizeLines = {
            slectedColor: {
              id: null,
              title: "",
              img_src: "",
              img_id: "",
              sku: ""
            },
            /* same to variable sizesQty  ex.: {2XL:1}*/
            selectedSizes: {}
          };
          this.store.colorSizeLines[this.store.imprintKey].push(colorSizeLines);
          this.store.selectedColorsList[this.store.imprintKey] = [];
          this.store.selectedLastStep[this.store.imprintKey] = {};
          let selectedLastStep = {
            imprintLocation: "",
            _imprintLocation: {
              value: null,
              sku: null
            },
            uploaded_image: null,
            special_instruction: null,
            imprintTypeID: 1,
            lines: [],
            uniqueColors: [],
            uniqueColorsCount: 0,
            stepId: null,
            messageUpload: null
          };
          this.store.selectedLastStep[this.store.imprintKey] = selectedLastStep;
          this.store.imprintMessageColorLines[this.store.imprintKey] = [];
          let imprintMessageColorLines = {
            id: 0,
            // //countLines,not sure if need, investigation and improvenment
            label: "Line",
            selectedColor: null,
            //this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
            selectedColorObj: null,
            custommColor: false,
            isImageLine: false,
            lineMessage: "",
            colors: [],
            isOpenedColorsPantoneWrapp: 0,
            type: "message"
          };
          this.store.imprintMessageColorLines[this.store.imprintKey].push(imprintMessageColorLines);
        }
        console.log(this.store);
        console.log("STORE !!!!!!!!!!! Imprint Tab");
      },
      getAvailableMethods(configurableArray, selectedSkus) {
        const available = [];
        Object.keys(configurableArray).forEach((methodKey) => {
          const method = configurableArray[methodKey];
          const methodSKUs = method.associated_sku.map((item) => item.sku);
          const allPresent = selectedSkus.every(
            (sku) => methodSKUs.includes(sku)
          );
          if (allPresent) {
            available.push(methodKey);
          }
        });
        return available;
      },
      getImprintHtml() {
        let availablePrintMethods = [];
        if (this.tabsCheckRequired) {
          this.initCalendarSku();
          const selectedSkus = this.store.calendar.productList.map((item) => item.calendar_sku);
          availablePrintMethods = this.getAvailableMethods(this.full_product.configurable_array, selectedSkus);
          this.availablePrintMethods = availablePrintMethods;
          console.log("--calendar selected Skus and available methods--");
          console.log(selectedSkus);
          console.log(availablePrintMethods);
        }
        for (let key in this.full_product.configurable_array) {
          console.log(this.full_product.configurable_array[key].imprint_description);
          console.log(key);
          let isAvailable = true;
          if (this.tabsCheckRequired) {
            isAvailable = availablePrintMethods.includes(key);
          }
          this.tabs.push(
            {
              id: key,
              tabName: this.full_product.configurable_array[key].name,
              content: this.full_product.configurable_array[key].imprint_description !== void 0 ? this.full_product.configurable_array[key].imprint_description : "",
              priceSort: Number(this.full_product.configurable_array[key].prices_2.min_price),
              isAvailable
            }
          );
          console.log("min-price " + key + " " + Number(this.full_product.configurable_array[key].prices_2.min_price));
        }
        this.tabs.sort(function(a, b) {
          if (a.priceSort > b.priceSort) {
            return 1;
          }
          if (a.priceSort < b.priceSort) {
            return -1;
          }
          return 0;
        });
        if (this.tabsCheckRequired) {
          this.activeTabForCalendarBundle = this.tabs.findIndex((item) => item.isAvailable);
          if (this.activeTabForCalendarBundle == "-1") {
            this.activeTabForCalendarBundle = null;
          }
          this.$emit("tabs-status", this.activeTabForCalendarBundle);
          console.log("activeTabForCalendarBundle - " + this.activeTabForCalendarBundle);
        }
        console.log(">>>>>>>>>>>>>>>>> TABS:");
        console.log(this.tabs);
        console.log(this.activeTab);
      },
      getFullProductJson() {
        if (this.store.inputProductData.fullJson) {
          this.full_product = this.store.inputProductData.fullJson;
        } else {
          this.full_product = JSON.parse(document.getElementById("full_product_info_json").textContent);
          this.store.inputProductData.fullJson = this.full_product;
        }
        console.warn("-----> Start Full Json // ImprintTabs.vue");
        console.log(this.full_product);
        console.warn("-----> End Full Json");
      },
      setTierData(sku) {
        console.warn("setTierData");
        console.log(sku);
        console.log(this.full_product.configurable_array[sku]);
        this.initSpecialPrice();
        this.isSpecial = Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
        console.log("imprint Tabs data setTierData");
        console.log(this.store.selectedImprint.tabName);
        console.log(this.store.imprintKey);
        console.log(this.store.specialPrice);
        console.warn(this.isSpecial);
        let attribute = null;
        let upcharge = null;
        let colorUpcharge = null;
        this.store.selectedImprint.sku = sku;
        this.tier_data = this.store.inputProductData.fullJson.configurable_array[sku]["prices_2"].tier_price;
        this.store.prices.tier = this.tier_data;
        this.store.prices.b2bTier = this.appStore.getB2BTierForSku(sku);
        this.addMSRPproperty();
        this.initMapFullSizeNameToShort();
        if (this.store.selectedImprint.sku) {
          let imprintData = this.full_product.configurable_array[sku].configurable_2_data;
          console.error("%%%%%%%%%%%%%%% this.store.application_type mmmmmmmmmmmmmmmmmmmmmmmmmm");
          console.warn(this.store.application_type);
          let singleCalendarBundleTag = "";
          console.log(document.getElementById("it-is-bundle-product"));
          if (document.getElementById("it-is-bundle-product")) {
            singleCalendarBundleTag = document.getElementById("it-is-bundle-product").textContent;
            console.log(singleCalendarBundleTag);
            console.warn(singleCalendarBundleTag == "yes");
          }
          if (this.store.application_type == "default") {
            if (singleCalendarBundleTag == "yes") {
              this.store.application_type = "calendar_single";
            }
          }
          if (this.store.application_type !== "calendar" && singleCalendarBundleTag !== "yes") {
            attribute = this.full_product.configurable_array[sku].attribute;
            console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Attribute &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
            console.log(attribute);
            console.log(this.store.storeID);
            if (attribute.length == 1) {
              colorUpcharge = attribute[0].code == "color" ? attribute[0].upcharge : null;
            } else if (attribute.length == 2) {
              upcharge = attribute[1].code == "size" ? attribute[1].upcharge : null;
              colorUpcharge = attribute[0].code == "color" ? attribute[0].upcharge : null;
            }
            console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Size Upcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
            console.log(upcharge);
            console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&  Color Upcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
            console.log(colorUpcharge);
          }
          if (Object.hasOwn(this.imprintData, "imprint_data") && Object.hasOwn(this.imprintData.imprint_data, "setup_fee") && Object.hasOwn(this.imprintData.imprint_data, "proof_fee")) {
            this.store.perItemFee.proof_fee = imprintData.imprint_data.proof_fee;
            this.store.perItemFee.setupFee = imprintData.imprint_data.setup_fee;
          }
          if (!upcharge) {
            console.error(" >>>> attribute upcharge not found /ImprintTabs/setTierData <<<<");
          } else {
            let result = {};
            upcharge.forEach(
              (item) => {
                if (item.store == this.store.storeID) {
                  result[item.option] = item.price;
                }
              }
            );
            this.store.inputProductData.sizeUpcharge = result;
          }
          if (!colorUpcharge) {
            console.error(" >>>> attribute upcharge not found /ImprintTabs/setTierData <<<<");
          } else {
            let result = {};
            colorUpcharge.forEach(
              (item) => {
                if (item.store == this.store.storeID) {
                  let label = item.option.toLowerCase();
                  result[label] = {
                    price: item.price,
                    price_type: item.price_type
                  };
                }
              }
            );
            this.store.inputProductData.colorUpcharge = result;
          }
        }
        if (this.store.application_type == "calendar") {
          this.initCalendarSku();
        } else {
          console.error("Imprint tabs aplication_type not ''``" + this.store.application_type);
        }
        console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&   this.store.inputProductData.sizeUpcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
        console.log(this.store.inputProductData.sizeUpcharge);
        console.warn("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&   this.store.inputProductData.colorUpcharge &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
        console.log(this.store.inputProductData.colorUpcharge);
        this.$emit("imprintTierSeted", this.store.perItemFee);
        console.error(">>>>>>>>>>> setTierData >>>>>>>>>");
        console.log(this.tier_data);
      },
      initCalendarSku() {
        console.error(">>>> initCalendarSku <<<<");
        console.warn(this.store.calendar.productList);
        if (this.store.calendar.productList.length) {
          this.store.calendar.productList.forEach((item, index) => {
            console.warn(item);
            console.warn(index);
            console.warn(index);
            this.store.calendar.productList[index]["calendar_sku"] = this.store.inputProductData.fullJson.simple_attributes.calendar_sku[item.title.trim()];
          });
        }
      },
      initMapFullSizeNameToShort() {
        let simples = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].simple_array;
        for (const propName in simples) {
          if (!Object.keys(this.store.fullSizeNameToShort).length && simples[propName].size != simples[propName].sku_size_code) {
            this.store.fullSizeNameToShort[simples[propName].size] = simples[propName].sku_size_code;
            console.error(">>> !!! Loop length 00000 ");
            console.log(this.store.fullSizeNameToShort);
          } else if (!Object.hasOwn(this.store.fullSizeNameToShort, simples[propName].size)) {
            this.store.fullSizeNameToShort[simples[propName].size] = simples[propName].sku_size_code;
            console.error(">>> !!! Loop 'If property' build data full size name to short ");
            console.log(this.store.fullSizeNameToShort);
          }
        }
      },
      addMSRPproperty() {
        let curSKU = this.store.selectedImprint.sku;
        if (this.full_product.configurable_array[curSKU].prices_2.msrp && this.tier_data[0].QtyMin !== "MSRP") {
          this.MSRPPrice = this.full_product.configurable_array[curSKU].prices_2.msrp;
          this.store.prices.tierMSRP = this.MSRPPrice;
        }
        console.error("------------------Curren tier data ---------------");
        console.log(this.tier_data);
        console.error("------------------MSRPPrice ---------------");
        console.log(this.MSRPPrice);
      },
      initQtyIncriment() {
        if (this.debugMode && this.store.selectedImprint.sku == null) {
          console.error("check selectedImprint.sku");
        }
        this.store.inputProductData.qtyIncrement = this.full_product.configurable_array[this.store.selectedImprint.sku].qty_increment;
        if (this.store.application_type == "calendar" || this.store.application_type == "calendar_single") {
          if (localStorage.getItem("storageProductList") !== null) {
            let bundleProducts = JSON.parse(localStorage.storageProductList);
            let bundleTotalQty = 0;
            if (bundleProducts.length && bundleTotalQty == 0) {
              bundleProducts.forEach((product) => {
                bundleTotalQty = bundleTotalQty + parseInt(product.qty);
              });
            }
            this.store.totalSizesQty[this.store.imprintKey] = bundleTotalQty;
            this.store.inputProductData.minOrderQty = 100;
          }
        } else {
          this.store.inputProductData.minOrderQty = this.full_product.configurable_array[this.store.selectedImprint.sku].min_order_qty;
        }
        if (this.debugMpode && this.store.inputProductData.qtyIncrement == null) {
          console.error("check initQtyIncriment() ImprintTabs component");
          this.store.inputProductData.qtyIncrement = 1;
        }
        if (this.debugMode && this.store.inputProductData.minOrderQty == null) {
          console.error("check minOrderQty ImprintTabs component");
          this.store.inputProductData.minOrderQty = 100;
        }
        if (this.store.minOrderQty > 1 && this.store.qtyIncrement >= 1) {
          this.$emit("initedQtyIncrement", this.store.inputProductData.minOrderQty);
        }
        if (this.debugMpode) {
          console.log(this.store.selectedImprint.sku);
          console.log(this.full_product.configurable_array[this.store.selectedImprint.sku].qty_increment);
          console.error("End init Incriment");
        }
      }
    },
    created() {
      console.error("Created ImprintTabs");
      this.getFullProductJson();
      this.getImprintHtml();
      let indexActiveTab = this.activeTabForCalendarBundle !== null ? this.activeTabForCalendarBundle : 0;
      console.log("indexActiveTab -- ");
      console.log(indexActiveTab);
      if (this.store.selectedImprint.id === null) {
        this.setActiveImprintTab(this.tabs[indexActiveTab], indexActiveTab);
      }
      if (this.store.selectedImprint.sku === null) {
        this.setTierData(this.tabs[indexActiveTab].id);
      } else {
        this.setTierData(this.store.selectedImprint.sku);
      }
      if (this.store.selectedImprint.sku !== null) {
        console.error("init Incriment");
        this.initQtyIncriment();
      }
      if (window.jQuery("#calendar-qty-changed")) {
        window.jQuery("body").on(
          "click",
          "#calendar-qty-changed",
          (event2) => {
            console.log(event2);
            console.warn("ImprintTabs qty created hook ");
            if (window.jQuery("#calendar-imprint-common-qty")) {
              console.error(window.jQuery("#calendar-imprint-common-qty").val());
              if (this.store.selectedImprint.id === null) {
                this.setActiveImprintTab(this.tabs[0], 0);
              }
              if (this.store.selectedImprint.sku === null) {
                this.setTierData(this.tabs[0].id);
              } else {
                this.setTierData(this.store.selectedImprint.sku);
              }
              if (this.store.selectedImprint.sku !== null) {
                console.error("init Incriment");
                this.initQtyIncriment();
              }
            }
          }
        );
      }
    }
  };
  const _hoisted_1$D = { class: "tabs-content-wrapper" };
  const _hoisted_2$w = { class: "mobile-title c-text-card__title" };
  const _hoisted_3$u = {
    key: 0,
    class: "c-tabs"
  };
  const _hoisted_4$s = ["disabled", "data-imprint_sku", "onClick"];
  const _hoisted_5$p = {
    key: 1,
    class: "message-calendar-titles"
  };
  const _hoisted_6$o = { class: "c-tabs-content" };
  function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomSelect = resolveComponent("CustomSelect");
    const _component_PriceMatrixComponent = resolveComponent("PriceMatrixComponent");
    return openBlock(), createElementBlock("div", _hoisted_1$D, [
      createBaseVNode("div", _hoisted_2$w, toDisplayString($props.textCardTitle), 1),
      $data.tabs.length ? (openBlock(), createElementBlock("div", _hoisted_3$u, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.tabs, (tab, index) => {
          return openBlock(), createElementBlock("button", {
            key: index,
            class: normalizeClass(["c-tabs__btn_js", [tab.isAvailable ? "show_tab" : "hide_tab", $options.isComda ? "c-tabs__btn__comda" : "c-tabs__btn", $data.store.selectedImprint.id === index ? ["c-tabs__btn--active", $options.customBackground] : ""]]),
            disabled: !tab.isAvailable,
            "data-imprint_sku": tab.id,
            onClick: ($event) => $options.setActiveImprintTab(tab, index)
          }, toDisplayString(tab.tabName), 11, _hoisted_4$s);
        }), 128))
      ])) : createCommentVNode("", true),
      createVNode(_component_CustomSelect, {
        options: $data.tabs,
        default: $data.tabs[this.activeTabForCalendarBundle !== null ? this.activeTabForCalendarBundle : 0].tabName,
        class: "select mobile",
        onUpdateTabsMobile: $options.setActiveImprintTab
      }, null, 8, ["options", "default", "onUpdateTabsMobile"]),
      $options.tabsCheckRequired && !$data.availablePrintMethods.length ? (openBlock(), createElementBlock("p", _hoisted_5$p, " Unfortunately, one or more calendar titles in your bundle cannot be ordered together. Please remove one or more titles and try again. ")) : createCommentVNode("", true),
      createBaseVNode("div", _hoisted_6$o, [
        createBaseVNode("span", null, toDisplayString($data.tabs[$data.activeTab].content), 1)
      ]),
      createVNode(_component_PriceMatrixComponent, {
        applicationType: $props.applicationType,
        isSpecial: $data.isSpecial
      }, null, 8, ["applicationType", "isSpecial"])
    ]);
  }
  const ImprintTabs = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$z]]);
  const _sfc_main$C = {
    props: {
      sizeTitle: String,
      modelValue: {
        type: String,
        required: true
      },
      lineId: Number,
      cssClasses: {
        type: String,
        required: false
      },
      displayTitle: {
        type: Boolean,
        required: false
      },
      prId: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        store,
        qtyVal: 0,
        qtyError: null,
        maxQty: 1e4,
        minQty: 0
      };
    },
    computed: {
      value: {
        get() {
          if (store.productType === "grouped_plain") {
            this.setDefaultQtyForLine();
          }
          let val = this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] ? this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] : this.minQty;
          if (val < 0) {
            val = 0;
          }
          return val;
        },
        set(value) {
          if (value < 0) {
            value = 0;
          }
          this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] = "";
          this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes[this.sizeTitle] = value;
        }
      }
    },
    methods: {
      isTitleDisplay() {
        let display = false;
        if (this.store.productType == "grouped_apparel" && this.store.application_type == "default") {
          display = true;
        } else if (this.store.productType == "grouped_plain") {
          display = false;
        }
        if (this.displayTitle === true) {
          display = true;
        }
        console.error("#######################             Qty title display               >>>>");
        console.warn(this.displayTitle);
        console.warn(typeof this.displayTitle);
        console.warn(this.store.productType);
        console.warn(this.store.application_type);
        return display;
      },
      setDefaultQtyForLine() {
        let result = false;
        if (store.productType === "grouped_plain") {
          if (this.store.inputProductData.minOrderQty && !this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes.qty) {
            this.store.colorSizeLines[this.store.imprintKey][this.lineId].selectedSizes.qty = this.store.inputProductData.minOrderQty;
            result = true;
          }
        }
        return result;
      },
      increment() {
        console.error("Incriment clicked");
        this.value = Number(this.value);
        this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);
        if (this.value < this.maxQty) {
          if (this.qtyError) {
            let remainder = this.value % this.store.inputProductData.qtyIncrement;
            this.value = this.value + this.store.inputProductData.qtyIncrement - remainder;
            this.qtyError = null;
          } else {
            this.value = this.value + this.store.inputProductData.qtyIncrement;
          }
        } else {
          this.value = Number(this.maxQty);
        }
        this.$emit("customQtyChange", { value: this.value, lineIndex: this.lineId, title: this.sizeTitle });
        this.$emit("showQtyError", { qtyError: this.qtyError });
        this.store.qtyError = this.qtyError;
      },
      decriment() {
        if (this.minQty < 0) {
          this.minQty = 0;
        }
        this.value = Number(this.value);
        this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);
        if (this.value >= this.minQty) {
          if (this.qtyError) {
            let remainder = this.value % this.store.inputProductData.qtyIncrement;
            this.value = this.value - remainder;
            this.qtyError = null;
          } else {
            this.value = this.value - this.store.inputProductData.qtyIncrement;
          }
        } else {
          this.value = this.store.productType == "grouped_apparel" ? 0 : this.store.inputProductData.qtyIncrement;
        }
        this.$emit("customQtyChange", { value: this.value, lineIndex: this.lineId, title: this.sizeTitle });
        this.$emit("showQtyError", { qtyError: this.qtyError });
        this.store.qtyError = this.qtyError;
      },
      onChange(value, refValue = null) {
        if (this.minQty < 0) {
          this.minQty = 0;
        }
        console.log("change");
        console.log(value);
        value = Number(value);
        this.store.inputProductData.qtyIncrement = Number(this.store.inputProductData.qtyIncrement);
        if (value < 0 || value < this.store.inputProductData.qtyIncrement) {
          value = this.store.productType == "grouped_apparel" ? 0 : this.store.inputProductData.qtyIncrement;
        }
        if (value > this.maxQty) {
          value = Number(this.maxQty);
        }
        this.value = value;
        if (this.store.application_type == "calendar" || this.store.application_type == "calendar_single") {
          let currValue = 25;
          if (value < 25) {
            console.warn("if");
            currValue = 25;
          } else if (value % this.store.inputProductData.qtyIncrement) {
            console.warn("else if");
            currValue = this.roundValueBy(value, this.store.inputProductData.qtyIncrement);
          }
          if (value > 25 && !(value % this.store.inputProductData.qtyIncrement)) {
            currValue = value;
          }
          this.value = currValue;
          this.$refs[refValue].value = currValue;
          this.$emit("customQtyChange", { value: currValue, lineIndex: this.lineId, title: this.sizeTitle });
        } else {
          if (this.validateInputQty(value)) {
            this.$emit("customQtyChange", { value, lineIndex: this.lineId, title: this.sizeTitle });
          }
        }
      },
      roundValueBy(value, by) {
        return Math.round(parseInt(value) / parseInt(by)) * parseInt(by);
      },
      validateInputQty(value) {
        const increment = this.store.inputProductData.qtyIncrement;
        let result = true;
        let failCondition = value < increment || value % increment != 0 || !Number.isInteger(value);
        if (failCondition) {
          result = false;
        }
        if (!result) {
          this.qtyError = "Item purchasable in increments of " + increment;
          result = false;
        } else {
          this.qtyError = null;
        }
        this.store.qtyError = this.qtyError;
        this.$emit("showQtyError", { qtyError: this.qtyError });
        return result;
      }
    },
    created() {
      console.error(">>>>>>created custom QTY>>>>>>>");
      if (this.store.application_type == "calendar_single" || this.store.application_type == "calendar") {
        this.minQty = 25;
        if (window.jQuery("#calendar-qty-changed")) {
          window.jQuery("body").on(
            "click",
            "#calendar-qty-changed",
            (event2) => {
              console.log(event2);
              console.warn("custom qty created hook ");
              if (window.jQuery("#calendar-imprint-common-qty")) {
                console.error(window.jQuery("#calendar-imprint-common-qty").val());
                this.value = window.jQuery("#calendar-imprint-common-qty").val();
                this.$emit("customQtyChange", { value: this.value, lineIndex: this.lineId, title: this.sizeTitle });
              }
            }
          );
        }
      }
      console.log(this.sizeTitle);
      console.log(this.modelValue);
      console.log(this.lineId);
      this.value = Number(this.modelValue);
      console.log(this.store.totalSizesQty[this.store.imprintKey]);
      if (!this.store.totalSizesQty[this.store.imprintKey]) {
        this.$emit("customQtyChange", null);
      }
      console.error(">>>>>>End created custom QTY>>>>>>>");
    },
    mounted() {
      this.$emit("customQtyChange", { value: this.value, lineIndex: this.lineId, title: this.sizeTitle });
    }
  };
  const _hoisted_1$C = ["id"];
  const _hoisted_2$v = ["id", "name", "value"];
  const _hoisted_3$t = ["for"];
  const _hoisted_4$r = { class: "label-text" };
  const _hoisted_5$o = { class: "sub_upcharge" };
  function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: normalizeClass(["qty-wrap", $props.cssClasses]),
      id: "qty-wrap" + $props.sizeTitle
    }, [
      createBaseVNode("div", {
        class: "controls-container controls-container--decriment",
        onClick: _cache[0] || (_cache[0] = ($event) => $options.decriment())
      }, [..._cache[4] || (_cache[4] = [
        createBaseVNode("span", { class: "minus-qty" }, " - ", -1)
      ])]),
      createBaseVNode("input", {
        class: "size-row__input",
        ref: "bundle-single-product-" + $props.prId,
        id: $props.prId,
        name: "size-qty-" + $props.sizeTitle,
        maxlength: "12",
        value: $options.value,
        onChange: _cache[1] || (_cache[1] = ($event) => $options.onChange($event.target.value, "bundle-single-product-" + $props.prId)),
        onClick: _cache[2] || (_cache[2] = ($event) => $event.target.select()),
        type: "number"
      }, null, 40, _hoisted_2$v),
      createBaseVNode("div", {
        class: "controls-container controls-container--incriment",
        onClick: _cache[3] || (_cache[3] = ($event) => $options.increment())
      }, [..._cache[5] || (_cache[5] = [
        createBaseVNode("span", { class: "plus-qty" }, " + ", -1)
      ])]),
      $options.isTitleDisplay() ? (openBlock(), createElementBlock("label", {
        key: 0,
        class: "custom-qty-label",
        for: "qty-wrap" + $props.sizeTitle
      }, [
        createBaseVNode("span", _hoisted_4$r, toDisplayString($props.sizeTitle), 1),
        createBaseVNode("span", _hoisted_5$o, toDisplayString($data.store.inputProductData.sizeUpcharge[$props.sizeTitle] !== void 0 ? "+$" + $data.store.inputProductData.sizeUpcharge[$props.sizeTitle].toFixed(2) : ""), 1)
      ], 8, _hoisted_3$t)) : createCommentVNode("", true)
    ], 10, _hoisted_1$C);
  }
  const CustomQty$1 = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$y]]);
  const _sfc_main$B = {
    props: {
      lineIndex: Number,
      getColorText: Function
    },
    components: {
      CustomQty: CustomQty$1
    },
    data() {
      return {
        activeTab: 1,
        associated_aliases: { colors: "", sizes: "", product_type: "", main: "" },
        colorVariants: {},
        // TODO can be used data about variant only from store
        sizeVariants: [],
        colors: [],
        // TODO check if need sizes: []
        sizes: [],
        slectedColor: {
          id: null,
          title: ""
        },
        // TODO remove after testing
        sizesQty: {},
        store,
        responseProduct: {},
        associatedIds: {},
        s3BucketDomain: "https://prod-imprint-uploads.s3.ca-central-1.amazonaws.com",
        colorCatalogBaseUrl: "/assets/images/imprint_app/colors/",
        oneSizeField: {
          title: "qty"
        },
        qtyError: null,
        defaultImage: null,
        functions,
        enabledSizesForColor: {}
      };
    },
    methods: {
      init() {
        if (window.PXUTheme.theme_settings.s3_bucket_host) {
          this.s3BucketDomain = window.PXUTheme.theme_settings.s3_bucket_host;
          this.colorCatalogBaseUrl = this.s3BucketDomain + this.colorCatalogBaseUrl;
        }
        if (window.PXUTheme.theme_settings.color_img_placeholder) {
          this.defaultImage = window.PXUTheme.theme_settings.color_img_placeholder;
        }
      },
      hasColorSize(sizeTitle) {
        if (this.store.productType === "grouped_plain") {
          return true;
        }
        const imprintKey = this.store.imprintKey;
        const linesForImprint = this.store.colorSizeLines && this.store.colorSizeLines[imprintKey];
        const line = linesForImprint && linesForImprint[this.lineIndex];
        if (!line || !line.slectedColor || !line.slectedColor.title) {
          console.warn(
            "[ColorSizePickerComponent] hasColorSize: немає поточного кольору для лінії",
            {
              imprintKey,
              lineIndex: this.lineIndex,
              line
            }
          );
          return true;
        }
        const currentColor = line.slectedColor.title;
        const fullJson = this.store.inputProductData ? this.store.inputProductData.fullJson : null;
        const sku = this.store.selectedImprint ? this.store.selectedImprint.sku : null;
        const attrRel = fullJson && fullJson.configurable_array && fullJson.configurable_array[sku] && fullJson.configurable_array[sku].attributes_relation_array;
        let sizesForCurrentColor = attrRel && attrRel[currentColor];
        if (sizesForCurrentColor && typeof sizesForCurrentColor === "object" && !Array.isArray(sizesForCurrentColor) && sizesForCurrentColor.sku_color_code) {
          this.store.sku.color_code = sizesForCurrentColor.sku_color_code;
        }
        const enabledForColor = this.enabledSizesForColor && this.enabledSizesForColor[currentColor];
        const conditionEnabledSimple = enabledForColor ? Object.prototype.hasOwnProperty.call(enabledForColor, sizeTitle) : true;
        if (!Array.isArray(sizesForCurrentColor)) {
          console.warn(
            "[ColorSizePickerComponent] hasColorSize: sizesForCurrentColor не масив, показуємо розмір за замовчуванням",
            {
              currentColor,
              sku,
              sizesForCurrentColor
            }
          );
          return conditionEnabledSimple;
        }
        const hasSize = sizesForCurrentColor.some(
          (item) => item.size === sizeTitle
        );
        return hasSize && conditionEnabledSimple;
      },
      getEnabledColors() {
        let disabledColors = [];
        for (var key in this.store.selectedImprint.data.simple_array) {
          if (this.store.selectedImprint.data.simple_array[key].status == "Disabled") {
            disabledColors.push(this.store.selectedImprint.data.simple_array[key].sku);
          }
        }
        let enabledColors = [];
        this.colorVariants.forEach(function(item) {
          if (!disabledColors.includes(item.sku)) {
            enabledColors.push(item);
          }
        });
        return enabledColors;
      },
      getColorVariants(handle) {
        axios.get(window.Shopify.routes.root + "products/" + handle + ".js").then(
          (response) => {
            this.colorVariants = response.data.variants.filter((item) => !item.title.includes("_temp_"));
            this.colorVariants = this.getEnabledColors();
            this.store.inputProductData.colorVariants.data = this.colorVariants;
            if (!this.store.availableColorsList.length) {
              this.store.availableColorsList = this.colorVariants.map(function(item) {
                return item.id;
              });
              this.$emit("colorLoaded", this.store.availableColorsList.length);
            }
            if (this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor.id === null) {
              this.setSelectedColor(this.colorVariants[0]);
            }
            console.log("colors");
            console.log(this.colorVariants);
            console.error(">>>>>>>>>>>> Product by handle >>>>>>>>>>>");
            console.log(response.data);
            console.warn(this.store.inputProductData.colorVariants.data);
          }
        );
      },
      getSizeVariants(handle) {
        axios.get(window.Shopify.routes.root + "products/" + handle + ".js").then(
          (response) => {
            this.sizeVariants = response.data.variants;
            this.store.inputProductData.sizeVariants.data = this.sizeVariants;
            console.error("111111111111111 this.sizeVariants 111111111111111");
            console.error(this.sizeVariants);
            response.data.variants.filter(
              (item) => {
                if (item.title.length > 4) {
                  this.store.hasFullSizeNames = true;
                }
                if (!item.sku.includes(item.title)) {
                  this.store.hasFullSizeNames = true;
                }
                this.sizes.push(item.title);
              }
            );
          }
        );
      },
      getMainVariant() {
        axios.get(window.Shopify.routes.root + "products/" + this.associated_aliases.main + ".js").then(
          (response) => {
            this.store.mainVariantId = response.data.variants[0].id;
          }
        );
      },
      getAliases() {
        let aliaces = JSON.parse(document.getElementById("associated_aliases").innerHTML);
        console.error(">>>> aliaces <<<<<");
        console.log(aliaces);
        this.associated_aliases = aliaces;
      },
      getAssociatedIds() {
        let associatedIds = JSON.parse(document.getElementById("associated_id").innerHTML);
        this.associatedIds = associatedIds;
        this.store.inputProductData.associatedIds = associatedIds;
        let productColor = this.store.inputProductData.associatedIds.simples.id_color;
        if (Array.isArray(productColor)) {
          this.store.inputProductData.associatedIds.simples.id_color = productColor[productColor.length - 1];
        }
        console.warn("this.associatedIds");
        console.warn(this.associatedIds);
      },
      setSelectedColor(colorVariant) {
        console.log("Request selected color", colorVariant);
        if (!colorVariant) {
          console.warn("[ColorSizePickerComponent] setSelectedColor: colorVariant is falsy");
          return;
        }
        const imprintKey = this.store.imprintKey;
        if (!this.store.selectedColorsList) {
          this.store.selectedColorsList = {};
        }
        if (!Array.isArray(this.store.selectedColorsList[imprintKey])) {
          this.store.selectedColorsList[imprintKey] = [];
        }
        const selectedColors = this.store.selectedColorsList[imprintKey];
        if (!selectedColors.includes(colorVariant.id)) {
          selectedColors.push(colorVariant.id);
        }
        const linesForImprint = this.store.colorSizeLines && this.store.colorSizeLines[imprintKey];
        const line = linesForImprint && linesForImprint[this.lineIndex];
        if (!line) {
          console.warn(
            "[ColorSizePickerComponent] setSelectedColor: line not found",
            { imprintKey, lineIndex: this.lineIndex, linesForImprint }
          );
          return;
        }
        if (!line.slectedColor) {
          line.slectedColor = {};
        }
        line.slectedColor.id = colorVariant.id;
        line.slectedColor.title = colorVariant.title || colorVariant.label || line.slectedColor.title || null;
        line.slectedColor.hex = colorVariant.hex || colorVariant.color_hex || line.slectedColor.hex || null;
        console.log(
          "[ColorSizePickerComponent] setSelectedColor: updated",
          {
            imprintKey,
            lineIndex: this.lineIndex,
            slectedColor: line.slectedColor,
            selectedColorsList: this.store.selectedColorsList
          }
        );
      },
      async getProductById(id, type) {
        let response = null;
        if (type === "color" && this.store.inputProductData.colorVariants.handle === null) {
          response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
          this.responseProduct = response !== null ? response.data : null;
          this.store.inputProductData.colorVariants.handle = this.responseProduct ? this.responseProduct.resources.results.products[0].handle : null;
        }
        if (type === "size" && this.store.inputProductData.sizeVariants.handle === null) {
          response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
          this.responseProduct = response !== null ? response.data : null;
          this.store.inputProductData.sizeVariants.handle = this.responseProduct ? this.responseProduct.resources.results.products[0].handle : null;
        }
        if (type == "color") {
          if (this.store.inputProductData.colorVariants.data === null) {
            this.getColorVariants(this.responseProduct.resources.results.products[0].handle);
          } else {
            this.colorVariants = this.store.inputProductData.colorVariants.data;
          }
        }
        if (type == "size") {
          if (this.store.inputProductData.sizeVariants.data === null) {
            this.getSizeVariants(this.responseProduct.resources.results.products[0].handle);
          } else {
            this.sizeVariants = this.store.inputProductData.sizeVariants.data;
          }
        }
      },
      deleteLineSelectedColorSize(index) {
        let colorID = null;
        let colorIndex = null;
        if (this.store.colorSizeLines[this.store.imprintKey][index] !== void 0) {
          colorID = this.store.colorSizeLines[this.store.imprintKey][index].slectedColor.id;
          colorIndex = this.store.selectedColorsList[this.store.imprintKey].indexOf(colorID);
          this.store.selectedColorsList[this.store.imprintKey].splice(colorIndex, 1);
          this.store.colorSizeLines[this.store.imprintKey].splice(index, 1);
        }
        console.log("result deleting");
        console.log(this.store.colorSizeLines);
        console.error(">>>> size Variants");
        console.log(this.sizeVariants);
        console.warn("this.store.colorSizeLines");
        console.warn(this.store.colorSizeLines);
        this.calculateTotal();
      },
      selectDefaultColorByLine() {
        const notSelectedColorVariant = this.getNotSelectedColor();
        if (!Array.isArray(notSelectedColorVariant) || notSelectedColorVariant.length === 0) {
          console.warn(
            "[ColorSizePickerComponent] selectDefaultColorByLine: colorVariants.data ще не готові",
            {
              imprintKey: this.store.imprintKey,
              lineIndex: this.lineIndex,
              inputProductData: this.store.inputProductData
            }
          );
          return;
        }
        if (this.store.colorSizeLines[this.store.imprintKey] && this.store.colorSizeLines[this.store.imprintKey][this.lineIndex] && this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor && this.store.colorSizeLines[this.store.imprintKey][this.lineIndex].slectedColor.id === null) {
          this.setSelectedColor(notSelectedColorVariant[0]);
        }
        console.error("addNewColorSizeLine");
        console.log(notSelectedColorVariant);
        console.log(this.store.selectedColorsList);
      },
      getNotSelectedColor() {
        const imprintKey = this.store.imprintKey;
        const selectedColors = this.store.selectedColorsList && this.store.selectedColorsList[imprintKey] || [];
        const colorData = this.store.inputProductData && this.store.inputProductData.colorVariants && this.store.inputProductData.colorVariants.data;
        if (!Array.isArray(colorData)) {
          console.warn(
            "[ColorSizePickerComponent] getNotSelectedColor: colorVariants.data не масив",
            this.store.inputProductData && this.store.inputProductData.colorVariants
          );
          return [];
        }
        return colorData.filter((variant) => {
          return !selectedColors.includes(variant.id);
        });
      },
      isColorHidden(color) {
        let result = false;
        let currentLineIndex = this.lineIndex;
        if (color.title.includes("_temp_")) {
          result = true;
        } else {
          this.store.colorSizeLines[this.store.imprintKey].forEach(function(item, index) {
            console.warn(currentLineIndex);
            if (index !== currentLineIndex && item.slectedColor.id == color.id) {
              result = true;
            }
          });
        }
        return result;
      },
      // Qty functions
      addOneQtyField() {
        this.sizeVariants.push(this.oneSizeField);
        this.store.inputProductData.sizeVariants.data = this.sizeVariants;
        console.error("???????????????addOneQtyField");
        console.log(this.store.colorSizeLines);
        let key = 1;
        if (this.store.isEnvelopProduct && store.prices.tier.length == 1) {
          key = 0;
        }
        if (this.store.inputProductData.minOrderQty && !this.store.colorSizeLines[this.store.imprintKey][0].selectedSizes.qty) {
          this.store.colorSizeLines[this.store.imprintKey][0].selectedSizes.qty = store.prices.tier[key].QtyMin ? store.prices.tier[key].QtyMin : 0;
        }
      },
      updateStoreState(value) {
        console.error("!!!!!!!!!!!!!!!!!!updateStoreState");
        console.log(value);
        if (value !== null) {
          this.store.colorSizeLines[this.store.imprintKey][value.lineIndex].selectedSizes[value.title] = parseInt(value.value, 10);
        }
        this.calculateTotal();
      },
      calculateTotal() {
        let total = 0;
        let qtyByLine = 0;
        let priceByQty = 0;
        let upchargePrice = 0;
        let colorUpcharge = 0;
        store.inputProductData.minOrderQty;
        Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
        console.warn("@@@@@@@@@ this.store.colorSizeLines @@@@@@@@@@@");
        console.log(this.store.colorSizeLines);
        this.store.colorSizeLines[this.store.imprintKey].forEach(
          (item) => {
            if (Object.values(item.selectedSizes).length) {
              qtyByLine = Object.values(item.selectedSizes).reduce((previous, current, index) => previous + current);
              total += qtyByLine;
            }
          }
        );
        this.store.prices.tier.forEach(
          (item) => {
            if (item.QtyMin !== "MSRP") {
              if (total >= item.QtyMin) {
                const b2bPrice = this.functions.getB2BPriceForTier(item, this.store.prices.b2bTier);
                if (b2bPrice !== null) {
                  priceByQty = b2bPrice;
                } else {
                  priceByQty = this.functions.isValidatedSpecialPrice(item) ? item["sale_price"] : item.price;
                }
              }
            }
          }
        );
        this.store.prices.priceByQty = priceByQty;
        this.store.prices.priceColorUpcharge = 0;
        this.store.upchargesLines[this.store.imprintKey] = {};
        this.store.upchargesLines[this.store.imprintKey].size = {};
        this.store.upchargesLines[this.store.imprintKey].color = {};
        this.store.colorSizeLines[this.store.imprintKey].forEach(
          (item) => {
            console.warn(item.selectedSizes);
            for (const prop in item.selectedSizes) {
              console.warn("prop");
              console.warn(prop);
              if (prop !== "qty" && this.store.inputProductData.sizeUpcharge[prop] !== void 0) {
                let priceByEl = this.store.inputProductData.sizeUpcharge[prop] * item.selectedSizes[prop];
                upchargePrice += priceByEl;
                if (item.selectedSizes[prop] > 0) {
                  if (!this.store.upchargesLines[this.store.imprintKey].size.hasOwnProperty(prop)) {
                    this.store.upchargesLines[this.store.imprintKey].size[prop] = 0;
                  }
                  this.store.upchargesLines[this.store.imprintKey].size[prop] += priceByEl;
                }
              }
              console.error(">>> " + prop + " >> " + item.selectedSizes[prop] + " >>>>>");
            }
            let colorTitle = item.slectedColor.title;
            if (typeof colorTitle === "string") {
              colorTitle = colorTitle.replace(" with ", " ").split(" ").join("-");
            }
            if (this.store.inputProductData.colorUpcharge[colorTitle] !== void 0) {
              let priceByEl = 0;
              if (Object.values(item.selectedSizes).length) {
                qtyByLine = Object.values(item.selectedSizes).reduce((previous, current, index) => previous + current);
              }
              if (this.store.inputProductData.colorUpcharge[colorTitle].price_type === "%") {
                let priceUpcharge = priceByQty * (this.store.inputProductData.colorUpcharge[colorTitle].price / 100);
                priceByEl = priceUpcharge * qtyByLine;
                if ((priceUpcharge + priceByQty).toFixed(2) == priceByQty) {
                  priceByEl = 0;
                }
              } else {
                priceByEl = this.store.inputProductData.colorUpcharge[colorTitle].price * qtyByLine;
              }
              colorUpcharge += priceByEl;
              console.log("color-upcharge!!!!" + colorTitle + "   " + priceByEl);
              console.log(colorUpcharge);
              if (priceByEl != 0) {
                this.store.upchargesLines[this.store.imprintKey].color[colorTitle] = priceByEl;
              }
            }
            console.error(">>> " + colorTitle + " >> " + this.store.inputProductData.colorUpcharge[colorTitle] + " >>>>>");
          }
        );
        this.store.prices.priceSizeUpcharge = upchargePrice;
        this.store.prices.priceColorUpcharge = colorUpcharge;
        console.error(this.store.prices);
        this.store.totalSizesQty[this.store.imprintKey] = total;
        console.error("this.store.prices");
        console.warn(this.store.prices);
        console.warn(this.store.prices.tier);
        console.warn(priceByQty);
        console.log(this.store.totalSizesQty[this.store.imprintKey]);
        console.log("@@@@ this.store.upchargesLines >>>>");
        console.log(this.store.colorSizeLines);
      },
      checkErrorQty(value) {
        this.qtyError = value.qtyError;
      },
      setEnabledSizeForColor() {
        let enabledSizesForColor = {};
        let simpleArray = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].simple_array;
        console.log("setEnabledSizeForColor");
        console.log(simpleArray);
        for (let simple in simpleArray) {
          let simpleData = simpleArray[simple];
          if (simpleData.status == "Enabled") {
            if (!Object.hasOwn(enabledSizesForColor, simpleData.color)) {
              enabledSizesForColor[simpleData.color] = {};
            }
            enabledSizesForColor[simpleData.color][simpleData.size] = simpleData.size;
          }
        }
        this.enabledSizesForColor = enabledSizesForColor;
        console.log("this.enabledSizesForColor");
        console.log(this.enabledSizesForColor);
      }
    },
    created() {
      this.getAssociatedIds();
      console.log("this.associatedIds");
      console.log(this.associatedIds);
      this.init();
      if (this.getAssociatedIds && this.associatedIds.simples.id_color) {
        this.getProductById(this.associatedIds.simples.id_color, "color");
      }
      if (this.getAssociatedIds && this.associatedIds.simples.id_size) {
        this.getProductById(this.associatedIds.simples.id_size, "size");
      }
      if (this.store.productType === "grouped_plain") {
        if (!this.associatedIds.simples.id_size || this.associatedIds.simples.id_size && this.store.inputProductData.sizeVariants.data == null) {
          this.addOneQtyField();
        }
      }
      if (this.store.productType !== "grouped_plain") {
        this.setEnabledSizeForColor();
      }
      this.selectDefaultColorByLine();
      console.error("++++++++++++++++Selected colors and sizes");
      console.log(this.store.colorSizeLines);
      console.error("lineIndex>>> Created");
      console.log(this.lineIndex);
      console.warn("this.store.inputProductData.sizeVariants");
      console.log(this.store.inputProductData.sizeVariants);
    },
    computed: {
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      }
    }
  };
  const _hoisted_1$B = { class: "color-size-main-wrapper" };
  const _hoisted_2$u = { class: "img-preview-section" };
  const _hoisted_3$s = ["src", "alt"];
  const _hoisted_4$q = {
    key: 0,
    class: "remove-color-line-wrapp"
  };
  const _hoisted_5$n = { class: "color-size-section" };
  const _hoisted_6$n = {
    for: "color-row",
    class: "color-row-label"
  };
  const _hoisted_7$l = { class: "color-row-label--sub" };
  const _hoisted_8$j = {
    id: "color-row",
    class: "color-row"
  };
  const _hoisted_9$h = ["title", "onClick"];
  const _hoisted_10$h = {
    id: "size-row",
    class: "size-row"
  };
  const _hoisted_11$g = {
    key: 0,
    class: "error-qty"
  };
  function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomQty = resolveComponent("CustomQty");
    return openBlock(), createElementBlock("div", null, [
      createBaseVNode("div", _hoisted_1$B, [
        createBaseVNode("div", _hoisted_2$u, [
          createBaseVNode("div", {
            class: "img-preview-background-wrapper",
            style: normalizeStyle("background-color:" + $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].slectedColor.title.toLowerCase())
          }, [
            createBaseVNode("img", {
              class: "img-preview-section__img",
              src: $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].slectedColor.img_src,
              alt: $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].slectedColor.alt
            }, null, 8, _hoisted_3$s)
          ], 4),
          $data.store.colorSizeLines[$data.store.imprintKey].length > 1 ? (openBlock(), createElementBlock("div", _hoisted_4$q, [
            createBaseVNode("span", {
              class: normalizeClass(["remove-color-line__btn", $options.customColor]),
              onClick: _cache[0] || (_cache[0] = ($event) => $options.deleteLineSelectedColorSize($props.lineIndex))
            }, "Remove", 2)
          ])) : createCommentVNode("", true)
        ]),
        createBaseVNode("div", _hoisted_5$n, [
          createBaseVNode("label", _hoisted_6$n, [
            createTextVNode(" Product " + toDisplayString($props.getColorText()) + ": ", 1),
            createBaseVNode("span", _hoisted_7$l, toDisplayString($data.store.colorSizeLines[this.store.imprintKey][$props.lineIndex].slectedColor.title.replace(" with ", " ").split(" ").join("-").toUpperCase()), 1)
          ]),
          createBaseVNode("div", _hoisted_8$j, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($data.colorVariants, (color) => {
              return openBlock(), createElementBlock(Fragment, {
                key: color.id
              }, [
                !$options.isColorHidden(color) ? (openBlock(), createElementBlock("button", {
                  key: 0,
                  class: normalizeClass(["color-picker-btn", $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].slectedColor.id == color.id ? "color-picker-btn--selected" : ""]),
                  style: normalizeStyle([{}, color.title ? "background-image:url(" + $data.colorCatalogBaseUrl + color.title.replace(" with ", " ").split(" ").join("-").toLowerCase() + ".png)" : ""]),
                  title: color.title.replace("-", " ").toUpperCase(),
                  onClick: ($event) => $options.setSelectedColor(color)
                }, null, 14, _hoisted_9$h)) : createCommentVNode("", true)
              ], 64);
            }), 128))
          ]),
          _cache[1] || (_cache[1] = createBaseVNode("label", {
            for: "size-row",
            class: "size-row-label"
          }, " Quantity ", -1)),
          createBaseVNode("div", _hoisted_10$h, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($data.sizeVariants, (size) => {
              return openBlock(), createElementBlock(Fragment, {
                key: size.id
              }, [
                $options.hasColorSize(size.title) ? (openBlock(), createBlock(_component_CustomQty, {
                  key: 0,
                  modelValue: $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].selectedSizes[size.title] ? $data.store.colorSizeLines[$data.store.imprintKey][$props.lineIndex].selectedSizes[size.title] : 0,
                  sizeTitle: size.title,
                  lineId: $props.lineIndex,
                  onCustomQtyChange: $options.updateStoreState,
                  onShowQtyError: $options.checkErrorQty
                }, null, 8, ["modelValue", "sizeTitle", "lineId", "onCustomQtyChange", "onShowQtyError"])) : createCommentVNode("", true)
              ], 64);
            }), 128))
          ])
        ])
      ]),
      $data.qtyError ? (openBlock(), createElementBlock("div", _hoisted_11$g, toDisplayString($data.qtyError), 1)) : createCommentVNode("", true)
    ]);
  }
  const ColorSizePickerComponent = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$x]]);
  const _sfc_main$A = {
    props: {
      activeImprintTypeID: Number
    },
    data() {
      return {
        store,
        acceptedFiles: "",
        selectedFile: null,
        images: [],
        //upload_base_url: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/uploads",
        apiBaseUrl: "https://dev.api-customapp.comda.com/",
        endpoint: "api/upload/imprint",
        endpoint_s: "api/helloworld",
        message: "",
        errors: []
      };
    },
    computed: {
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      },
      customColorBefore() {
        return this.$getCustomColorBeforeClass(store.storeID);
      },
      customColorAfter() {
        return this.$getCustomColorAfterClass(store.storeID);
      },
      customFont() {
        return this.$getCustomFontClass(store.storeID);
      },
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      },
      customBackgroundHover() {
        return this.$getCustomBackgroundColorHoverClass(store.storeID);
      }
    },
    methods: {
      init() {
        if (window.PXUTheme.theme_settings.api_beckend_url) {
          this.apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
        }
        this.acceptedFiles = this.getAcceptedFileTypes();
        this.selectedFile = this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null ? this.store.selectedLastStep[this.store.imprintKey].uploaded_image.file : null;
        this.message = this.store.selectedLastStep[this.store.imprintKey].messageUpload != null ? this.store.selectedLastStep[this.store.imprintKey].messageUpload : null;
      },
      getAcceptedFileTypes() {
        return "ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff";
      },
      onFileSelected(event2) {
        console.error("this images before validation >>>>");
        console.warn(this.$refs.fileInput.files[0]);
        if (!this.validateImage(event2.target.files[0])) {
          return false;
        }
        this.selectedFile = event2.target.files[0];
        this.store.selectedLastStep[this.store.imprintKey].uploaded_image = { file: event2.target.files[0], href: null };
        this.images = this.$refs.fileInput.files[0];
        this.submitFile();
        console.error("Upload Event");
        console.log(event2);
        console.log(this.selectedFile);
      },
      validateImage(file) {
        let allowedTypesByName = [".ai", ".bmp", ".cdr", ".eps", ".jpeg", ".jpg", ".png", ".pdf", ".tiff"];
        this.errors = [];
        console.warn("validate file");
        console.warn(file);
        let file_name = "";
        let file_name_type = "";
        if (this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]["name"]) {
          file_name = this.$refs.fileInput.files[0]["name"];
          let splitNameByDot = file_name.split(".");
          if (splitNameByDot.length > 0) {
            file_name_type = "." + splitNameByDot[splitNameByDot.length - 1];
          }
        }
        if (!allowedTypesByName.includes(file_name_type)) {
          this.errors.push("Invalid file type. Only ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff are allowed.");
        }
        if (this.$refs.fileInput.files[0].size > 1024 * 1024 * 24) {
          console.error(" File to large ");
          this.errors.push("The file you are uploading is too large. The maximum file size is 24MB. Please upload a different file.");
        }
        if (this.errors.length > 0) {
          return false;
        }
        return true;
      },
      submitFile() {
        const formData = new FormData();
        let file_type = "";
        let file_name = "";
        let file_name_type = "";
        if (this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]["type"]) {
          file_type = this.$refs.fileInput.files[0]["type"];
        }
        if (this.$refs.fileInput.files[0] && this.$refs.fileInput.files[0]["name"]) {
          file_name = this.$refs.fileInput.files[0]["name"];
          let splitNameByDot = file_name.split(".");
          if (splitNameByDot.length > 0) {
            file_name_type = "." + splitNameByDot[splitNameByDot.length - 1];
          }
        }
        console.error("this images >>>>");
        console.warn(this.$refs.fileInput.files[0]);
        formData.append("file_type", file_type);
        formData.append("file_name", file_name);
        if (file_name_type) {
          formData.append("file_name_type", file_name_type);
        }
        formData.append("image", this.$refs.fileInput.files[0]);
        formData.append("_method", "PUT");
        let response = null;
        response = axios.post(
          this.apiBaseUrl + this.endpoint,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
              //'Accept': '*/*'
            }
          }
        ).then(
          (res) => {
            console.error(" axios result >>>");
            console.log(res);
            console.log(res.data);
            console.log(res.data.urlFromStorage);
            this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href = res.data.urlFromStorage;
            res.data.files;
            res.status;
            this.$emit("uploadChanged", { "imageUploaded": true, "uploadMessage": "Image Uploaded Successfully! " });
            this.message = "Image Uploaded Successfully!";
            this.store.selectedLastStep[this.store.imprintKey].messageUpload = this.message;
          }
        ).catch(
          (error) => {
            console.error("upload error");
            console.error(error);
          }
        );
        return response;
      },
      removeFile() {
        this.$refs.fileInput.value = "";
        this.selectedFile = null;
        this.message = "";
        this.store.selectedLastStep[this.store.imprintKey].uploaded_image = null;
        this.store.selectedLastStep[this.store.imprintKey].messageUpload = null;
        this.$emit("uploadChanged", { "imageUploaded": null });
      }
      /*onUpload(e) {
          console.log("onUpload");
          console.log(e);
          const fb = new FormData();
          fb.append('image', this.selectedFile, this.selectedFile.name);
      }*/
    },
    created() {
      this.init();
    }
  };
  const _hoisted_1$A = {
    class: "start-new-imprint__label",
    for: "imprint-types"
  };
  const _hoisted_2$t = { class: "clist-table clist-table--titles clist-style--none" };
  const _hoisted_3$r = { class: "clist-table__row clist-table__row--two-cols clist-table__row--uploads" };
  const _hoisted_4$p = { class: "clist-table__col clist-table__col--upload-image" };
  const _hoisted_5$m = ["title"];
  const _hoisted_6$m = { class: "clist-table__col clist-table__col--upload-accepted" };
  const _hoisted_7$k = { style: { "font-weight": "300", "font-size": "14px" } };
  const _hoisted_8$i = {
    key: 0,
    class: "success"
  };
  const _hoisted_9$g = { class: "message" };
  const _hoisted_10$g = {
    key: 1,
    class: "error"
  };
  function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock(Fragment, null, [
      createBaseVNode("label", _hoisted_1$A, toDisplayString($props.activeImprintTypeID === 3 ? "Step 2: " : "") + "Upload an Image ", 1),
      createBaseVNode("ul", _hoisted_2$t, [
        createBaseVNode("li", _hoisted_3$r, [
          createBaseVNode("div", _hoisted_4$p, [
            createBaseVNode("input", {
              class: normalizeClass(["imprint-types__upload-btn", $options.customBackground, $options.customBackgroundHover]),
              id: "imprint-types-upload-btn",
              type: "file",
              onChange: _cache[0] || (_cache[0] = (...args) => $options.onFileSelected && $options.onFileSelected(...args)),
              style: { "display": "none" },
              ref: "fileInput"
            }, null, 34),
            createBaseVNode("button", {
              class: normalizeClass(["imprint-types__upload-btn", $options.customBackground, $options.customBackgroundHover]),
              onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$refs.fileInput.click())
            }, "Choose file", 2),
            createBaseVNode("span", {
              class: "uploaded-file-name",
              title: $data.selectedFile ? $data.selectedFile.name : "No file chosen"
            }, toDisplayString($data.selectedFile ? $data.selectedFile.name : "No file chosen"), 9, _hoisted_5$m)
          ]),
          createBaseVNode("div", _hoisted_6$m, [
            _cache[3] || (_cache[3] = createBaseVNode("p", { class: "imprint-text-bold" }, "Accepted file types:", -1)),
            createBaseVNode("span", _hoisted_7$k, toDisplayString($data.acceptedFiles), 1)
          ])
        ]),
        $data.message ? (openBlock(), createElementBlock("li", _hoisted_8$i, [
          createBaseVNode("p", {
            class: "remove-file",
            onClick: _cache[2] || (_cache[2] = (...args) => $options.removeFile && $options.removeFile(...args))
          }, "Remove"),
          createBaseVNode("p", _hoisted_9$g, toDisplayString($data.message), 1)
        ])) : createCommentVNode("", true),
        $data.errors ? (openBlock(), createElementBlock("li", _hoisted_10$g, [
          createBaseVNode("p", null, toDisplayString($data.errors[0]), 1)
        ])) : createCommentVNode("", true)
      ])
    ], 64);
  }
  const UploadImage = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$w]]);
  const _sfc_main$z = {
    props: {
      validation: Object,
      validateDetails: Array,
      getColorText: Function
    },
    components: {
      UploadImage
    },
    data() {
      return {
        imprintLocationSelected: "",
        debugMode: false,
        customColors: ["green", "black", "red", "yellow"],
        selectedColors: [],
        selectedCustomColors: "",
        activeImprintTypeID: null,
        imprintTypes: [
          {
            id: 1,
            label: "Text"
          },
          {
            id: 2,
            label: "Image"
          },
          {
            id: 3,
            label: "Text & Image"
          }
        ],
        applayToAll: {
          id: null,
          // TODO what mean id, maybe its not need
          selectedColor: null,
          lineIndex: null,
          randID: null
        },
        imprintMessageColorLines: [
          {
            id: 0,
            //not sure if need, investigation and improvenment
            randID: Date.now(),
            label: "Line",
            selectedColor: null,
            selectedColorObj: null,
            custommColor: false,
            isImageLine: false,
            lineMessage: "",
            colors: [],
            isOpenedColorsPantoneWrapp: 0,
            type: "message"
          }
        ],
        customColorList: [],
        selectColorBtn: {
          defaultBg: "linear-gradient(135deg, #ffffff 0%, #ffffff 48%, #000000 50%, #ffffff 52%, #ffffff 100%);"
        },
        store,
        imprintData: {},
        // configurable_2_data
        imprintSKU: "",
        imprintColorsByLine: {},
        imprintImageColorsByLine: {},
        colorCatalogBaseUrl: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/colors/",
        maxCountLines: 5,
        customColourFee: 0,
        isImageLineInited: 0,
        specialInstruction: "",
        maxColors: 0,
        setMaxLimitColors: false,
        uniqueColors: [],
        functions
      };
    },
    computed: {
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      },
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      }
    },
    methods: {
      translate(str = "color") {
        return this.$getTranslatedColorWord(str);
      },
      isActiveAddLine() {
        let imageData = this.isImageLineInData();
        return this.activeImprintTypeID == 1 && this.imprintMessageColorLines.length - imageData.length < this.maxCountLines;
      },
      // TODO need improvements
      isRemoveBtnShow(activeImprintID, lineIndex, messageLine) {
        let hasImageLine = false;
        let hasRemoveBtn = false;
        let lineLength = this.imprintMessageColorLines.length;
        console.error("isRemoveBtnShow");
        this.imprintMessageColorLines.forEach(
          (line) => {
            if (line.type === "image") {
              hasImageLine = true;
            }
          }
        );
        if (activeImprintID === 1) {
          if (this.debugMode) ;
          if (hasImageLine && lineLength > 2) {
            hasRemoveBtn = true;
          }
          if (!hasImageLine && lineLength > 1) {
            hasRemoveBtn = true;
          }
          console.log("hasRemoveBtn");
          console.log(hasRemoveBtn);
        }
        if (activeImprintID === 3 && lineLength > 2) {
          hasRemoveBtn = true;
        }
        console.log("hasRemoveBtn 2");
        console.log(hasRemoveBtn);
        if (hasRemoveBtn && this.store.imprintStep.applyToAll.id === null) {
          hasRemoveBtn = true;
          console.log("hasRemoveBtn 3");
          console.log(hasRemoveBtn);
        } else {
          console.error("Remove Data>>>>");
          console.log(this.store.imprintStep.applyToAll);
          console.log(lineIndex);
          console.error(activeImprintID);
          console.warn(this.imprintMessageColorLines);
          console.warn(hasImageLine);
          if (this.store.imprintStep.applyToAll.randID === messageLine.randID) {
            hasRemoveBtn = false;
            console.log("hasRemoveBtn 4");
            console.log(hasRemoveBtn);
          } else if (this.store.imprintStep.applyToAll.randID !== null) {
            hasRemoveBtn = true;
            console.log("hasRemoveBtn 5");
            console.log(hasRemoveBtn);
            console.warn(messageLine.randID);
            console.warn(this.store.imprintStep.applyToAll.randID);
            console.warn(this.store.imprintStep.applyToAll.randID);
          }
        }
        return hasRemoveBtn;
      },
      initTab(id) {
        this.activeImprintTypeID = id;
        this.store.selectedLastStep[this.store.imprintKey].imprintTypeID = id;
        let result = 0;
        if (id > 1) {
          let LineObj = {
            id: this.imprintMessageColorLines.length,
            randID: Date.now(),
            label: "Line",
            selectedColor: this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
            selectedColorObj: this.applayToAll.selectedColor !== null ? this.store.imprintMessageColorLines[this.store.imprintKey][0].selectedColorObj : null,
            custommColor: false,
            lineMessage: "",
            colors: [],
            isOpenedColorsPantoneWrapp: 0,
            type: "image"
          };
          this.isImageLineInited = this.imprintMessageColorLines.filter((item) => {
            return item.type === "image";
          }).length;
          if (!this.isImageLineInited) {
            this.imprintMessageColorLines.push(LineObj);
            this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
          }
        }
        if (this.debugMode) {
          console.error("1111 imprintMessageColorLines");
          console.error(this.imprintMessageColorLines);
          console.error("2222 imprintTab id id id id ");
          console.error(id);
          console.warn(result);
        }
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      setSpecialInstruction(value) {
        this.store.selectedLastStep[this.store.imprintKey].special_instruction = value;
        this.specialInstruction = value;
        if (this.debugMode) {
          console.error("this.store.selectedLastStep[this.store.imprintKey].special_instruction");
          console.error(this.store.selectedLastStep[this.store.imprintKey].special_instruction);
        }
      },
      isCheckboxDisabled(index, randID = null) {
        let checkedNotCurrrent = this.store.imprintStep.applyToAll.randID !== randID && this.store.imprintStep.applyToAll.randID !== null;
        console.error("isCheckboxDisabled");
        console.log(this.applayToAll.index !== index && this.applayToAll.id !== null);
        console.log(this.imprintMessageColorLines.length === 0 || this.imprintMessageColorLines[index].selectedColor === null || checkedNotCurrrent);
        return this.imprintMessageColorLines.length === 0 || checkedNotCurrrent;
      },
      sortLineObjects() {
        let copiedImageLine = this.imprintMessageColorLines;
        this.imprintMessageColorLines = [];
        copiedImageLine.forEach(
          (item) => {
            if (item.type === "message") {
              item.id = this.imprintMessageColorLines.length;
              this.imprintMessageColorLines.push(item);
            }
          }
        );
        copiedImageLine.forEach(
          (item) => {
            if (item.type === "image") {
              item.id = this.imprintMessageColorLines.length;
              this.imprintMessageColorLines.push(item);
            }
          }
        );
      },
      uploadChanged(value) {
        this.$emit("stepFourChange", value);
      },
      addLineImprintMessage() {
        console.error("this.imprintMessageColorLines");
        console.error(this.imprintMessageColorLines);
        let countLines = this.imprintMessageColorLines.length;
        let LineObj = {
          id: countLines,
          randID: Date.now(),
          label: "Line",
          selectedColor: this.applayToAll.selectedColor !== null ? this.applayToAll.selectedColor : null,
          selectedColorObj: null,
          custommColor: false,
          lineMessage: "",
          colors: [],
          isOpenedColorsPantoneWrapp: 0,
          type: "message"
        };
        console.warn("this.store.imprintStep");
        console.warn(this.store.imprintStep);
        console.warn(this.store.imprintStep.applyToAll.id);
        if (this.store.imprintStep.applyToAll.id === null) {
          this.imprintMessageColorLines.push(LineObj);
        } else {
          if (this.store.imprintStep.applyToAll.randID) {
            let cloneImprintLine = { ...this.store.imprintStep.applyToAll["data"] };
            cloneImprintLine.id = this.store.imprintMessageColorLines[this.store.imprintKey].length;
            cloneImprintLine.randID = Date.now();
            cloneImprintLine.lineMessage = "";
            this.imprintMessageColorLines.push(cloneImprintLine);
          }
        }
        this.sortLineObjects();
        if (this.debugMode) {
          console.error("1111 imprintMessageColorLines");
          console.error(this.imprintMessageColorLines);
          console.warn(this.maxCountLines);
        }
        this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
        this.$emit("stepFourChange", this.imprintMessageColorLines);
        console.error("add line");
        console.warn(this.store.imprintStep.applyToAll);
        console.warn(this.store.imprintStep.applyToAll.id);
        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey][this.store.imprintStep.applyToAll.id]);
        console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.error(this.imprintMessageColorLines);
        console.error("this.store.imprintMessageColorLines");
        console.error(this.store.imprintMessageColorLines);
      },
      getLineIndexByRandID(randID) {
        this.store.imprintMessageColorLines[this.store.imprintKey].map(
          (item, index) => {
            if (item.randID === randID) {
              return index;
            }
          }
        );
      },
      // lineid used as index
      colorsPantoneWrappToogle(lineId) {
        console.warn("this message line on click");
        console.warn(this.imprintMessageColorLines);
        this.imprintMessageColorLines[lineId].isOpenedColorsPantoneWrapp = !this.imprintMessageColorLines[lineId].isOpenedColorsPantoneWrapp;
      },
      setMessageForLine(lineId, value) {
        this.imprintMessageColorLines[lineId].lineMessage = value;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].lineMessage = value;
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      setImprintLocation(value, event2) {
        console.error("!!!!!!!!!!!! setImprintLocation");
        this.store.selectedLastStep[this.store.imprintKey].imprintLocation = value;
        this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.value = value;
        this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.sku = event2.target.selectedOptions[0].dataset.sku;
        this.store.sku.imprint.location.val = event2.target.selectedOptions[0].dataset.sku;
        this.setMaxLinesByImprintLocations();
        this.imprintLocationSelected = value;
        if (this.debugMode) {
          console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
          console.log(this.store.selectedLastStep[this.store.imprintKey]);
          console.log(event2.target.dataSku);
          console.log(event2.target.selectedOptions);
          console.log(event2.target.selectedOptions[0].dataset.sku);
        }
      },
      // lineId used as index
      setColorForOneLine(lineId, color) {
        this.imprintMessageColorLines[lineId].selectedColor = color.file_name;
        this.imprintMessageColorLines[lineId].selectedColorObj = color;
        this.imprintMessageColorLines[lineId].custommColor = false;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColor = color.file_name;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColorObj = color;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].custommColor = false;
        this.setDataMaxColor();
      },
      setColorForMultipleLines(lineId, color) {
        let currentColorSkuForLine = null;
        if (this.imprintMessageColorLines[lineId].selectedColorObj) {
          currentColorSkuForLine = this.imprintMessageColorLines[lineId].selectedColorObj.sku;
        }
        this.selectedColors.forEach(
          (item) => {
            if (item.sku == currentColorSkuForLine || !currentColorSkuForLine) {
              console.warn("setColorForMultipleLines 2");
              item = color;
            }
          }
        );
        this.imprintMessageColorLines.forEach(
          (item) => {
            if (item.selectedColorObj && item.selectedColorObj.sku == currentColorSkuForLine || !currentColorSkuForLine) {
              item.selectedColor = color.file_name;
              item.selectedColorObj = color;
              item.custommColor = false;
            }
          }
        );
        this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
        this.setDataMaxColor();
      },
      /*update state unique chose colors and maximum limit of chose colors */
      setDataMaxColor() {
        let uniqueColors = [];
        this.imprintMessageColorLines.forEach(
          (item) => {
            if (item.selectedColorObj && !uniqueColors.includes(item.selectedColorObj.sku)) {
              uniqueColors.push(item.selectedColorObj.sku);
            }
          }
        );
        this.uniqueColors = uniqueColors;
        this.setMaxLimitColors = false;
        if (uniqueColors.length == this.maxColors) {
          this.setMaxLimitColors = true;
        }
      },
      setColorForLine(lineId, color, applayToObj = null) {
        if (this.applayToAll.id !== null) {
          let isCustomColor = this.imprintMessageColorLines[lineId].custommColor;
          let imprintLineData = this.imprintMessageColorLines[lineId];
          this.applayToAll["data"] = imprintLineData;
          this.applayToAll.id = lineId;
          this.applayToAll["randID"] = imprintLineData.randID;
          this.applayToAll.selectedColor = color["file_name"];
          this.applayToAll.index = lineId;
          this.imprintMessageColorLines[lineId]["isApplyToAllElement"] = true;
          this.setApplayToAllColor(color["file_name"], lineId, isCustomColor, imprintLineData);
          this.setApplayToAllDataInStore(this.applayToAll);
        }
        let setMaxLimitColors = false;
        if (this.uniqueColors.length == this.maxColors) {
          setMaxLimitColors = true;
          this.setMaxLimitColors = true;
        }
        if (!setMaxLimitColors) {
          if (!this.imprintMessageColorLines[lineId].selectedColorObj) {
            this.selectedColors.push(color);
          } else {
            this.selectedColors[lineId] = color;
          }
          this.setColorForOneLine(lineId, color);
        } else {
          if (!this.imprintMessageColorLines[lineId].selectedColorObj && !this.uniqueColors.includes(color.sku)) {
            return false;
          }
          let condition1 = !this.imprintMessageColorLines[lineId].selectedColorObj && this.uniqueColors.includes(color.sku);
          let condition2 = this.imprintMessageColorLines[lineId].selectedColorObj && this.uniqueColors.includes(color.sku);
          if (condition1 || condition2) {
            this.setColorForOneLine(lineId, color);
          }
          if (this.imprintMessageColorLines[lineId].selectedColorObj && !this.uniqueColors.includes(color.sku)) {
            this.setColorForMultipleLines(lineId, color);
          }
        }
        this.colorsPantoneWrappToogle(lineId);
        if (this.functions.isCheckboxChecked(".applay-to-all-checkbox input")) {
          let isCustomColor = this.imprintMessageColorLines[applayToObj.index].custommColor;
          this.setApplayToAllColor(applayToObj.color, applayToObj.id, isCustomColor, applayToObj.messageLine);
        }
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      // Hot fix, need to change line id in code to index, after removing line if we set for last text line type message
      // we change color for image color need to fix and delete this method
      reindexImprintLinesID() {
        this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines = this.imprintMessageColorLines.map(
          (element, index) => {
            return element.id = index;
          }
        );
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      removeUniqueColor(itemLine) {
        if (!itemLine.customColor && itemLine.selectedColorObj) {
          if (this.uniqueColors) {
            let countUniqueColor = 0;
            let colorToDelete = itemLine.selectedColorObj.sku;
            this.imprintMessageColorLines.filter(
              (item) => {
                if (item.selectedColorObj && item.selectedColorObj.sku == colorToDelete) {
                  countUniqueColor++;
                }
              }
            );
            if (countUniqueColor == 1) {
              this.uniqueColors = this.uniqueColors.filter(
                (item) => {
                  if (item !== colorToDelete) {
                    return item;
                  }
                }
              );
            }
          }
        }
      },
      deleteLineImprintMessage(index, messageLine) {
        let colorIndex = this.selectedColors.indexOf(this.imprintMessageColorLines[index].selectedColor);
        if (colorIndex !== -1) {
          this.selectedColors.splice(colorIndex, 1);
        }
        this.store.imprintMessageColorLines[this.store.imprintKey].filter(
          (el) => {
            if (el.randID === messageLine.randID) {
              console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
            }
          }
        );
        this.imprintMessageColorLines.filter(
          (item, itemIndex) => {
            if (item.randID === messageLine.randID) {
              this.removeUniqueColor(item);
              this.imprintMessageColorLines.splice(itemIndex, 1);
              this.store.imprintMessageColorLines[this.store.imprintKey] = this.imprintMessageColorLines;
              this.$emit("stepFourChange", this.imprintMessageColorLines);
              this.setDataMaxColor();
            }
          }
        );
        console.warn("deleteLineImprintMessage");
        console.log(index);
        console.log(messageLine);
        console.log(this.imprintMessageColorLines);
      },
      setDefaultActiveImprintTypeID(id = 1) {
        if (this.activeImprintTypeID === null) {
          this.activeImprintTypeID = id;
        }
      },
      addAdditionalColorsByImprintLocations() {
        if (this.maxCountLines + 1 > this.imprintColorsByLine.length) {
          let diffDataColors = this.maxCountLines + 1 - this.imprintColorsByLine.length;
          if (this.imprintColorsByLine.length) {
            for (let i = 0; i < diffDataColors; i++) {
              let additionalColor = this.imprintColorsByLine[0];
              this.imprintColorsByLine.push(additionalColor);
            }
          }
        }
      },
      initCurrentImprintData() {
        let linesData = null;
        this.imprintSKU = this.store.selectedImprint.sku;
        this.imprintData = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].configurable_2_data;
        this.customColourFee = this.imprintData.imprint_data.custom_colour_fee;
        console.error(">>>>>>>>>>this.imprintColorsByLine");
        console.warn(this.store);
        console.warn(this.imprintData.imprint_data);
        console.error(">>>>>>>>>>END this.imprintColorsByLine");
        this.imprintColorsByLine = this.imprintData.imprint_options.filter(
          (item) => {
            return item._custom_option_type == "drop_down";
          }
        );
        console.log(this.imprintColorsByLine);
        linesData = this.imprintData.imprint_options.filter(
          (item) => {
            return item._custom_option_title.includes("Line");
          }
        );
        console.log("linesData");
        console.log(linesData);
        this.setMaxLinesByImprintLocations();
        if (this.store.inputProductData.fullJson.configurable_array[this.imprintSKU]["max_color"]) {
          this.maxColors = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU]["max_color"];
        } else {
          console.log("max colors is empty");
        }
        if (this.debugMode) {
          console.error("initCurrentImprintData");
          console.log(this.imprintColorsByLine);
          console.log(this.imprintMessageColorLines);
          console.error("------------ this.maxCountLines");
          console.log(this.maxCountLines);
          console.error("prepeared properties sku >>>>>>>>>>>>");
          console.log(this.store.sku);
          console.log(this.store.properties);
        }
      },
      setMaxLinesByImprintLocations(location_sku = null) {
        if (!location_sku) {
          location_sku = this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.sku;
        }
        console.warn("setMaxLinesByImprintLocations");
        console.log(location_sku);
        console.warn("setMaxLinesByImprintLocations");
        if (this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].locations.length) {
          this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].locations.forEach((location2) => {
            if (location2.sku == location_sku) {
              this.maxCountLines = location2.imprint_lines;
              this.addAdditionalColorsByImprintLocations();
            }
          });
        }
      },
      validateMaxLinesByImprintLocation() {
        let isValid = true;
        console.error("before set is valid");
        console.warn(this.imprintMessageColorLines);
        console.log(this.imprintMessageColorLines.length);
        console.log(this.maxCountLines);
        console.warn(this.activeImprintTypeID);
        if (this.activeImprintTypeID == 3) {
          isValid = this.imprintMessageColorLines.length > this.maxCountLines + 1;
        } else {
          console.error("check if image line is in data");
          console.warn(this.isImageLineInData());
          let imageLineData = this.isImageLineInData();
          isValid = this.imprintMessageColorLines.length - imageLineData.length > this.maxCountLines;
        }
        console.error("after set is valid");
        console.warn(this.imprintMessageColorLines);
        console.log(this.imprintMessageColorLines.length);
        console.log(this.maxCountLines);
        console.warn(this.activeImprintTypeID);
        this.store.selectedLastStep[this.store.imprintKey]._imprintLocation["validateMaxLinesByImprintLocation"] = isValid;
        this.$emit("stepFourChange", this.imprintMessageColorLines);
        return isValid;
      },
      isImageLineInData() {
        return this.imprintMessageColorLines.filter((item) => item.type == "image");
      },
      // TODO hard to understending input data, check and improve
      // `id` and `index` after testing are equil
      /****
       * data: object
          id: null,
          selectedColor: null,
          index: null,
      */
      setApplayToAllDataInStore(data) {
        this.store.imprintStep.applyToAll = data;
      },
      applayToAllToogle(id, selectedColor, index, imprintLineData) {
        let isCustomColor = this.imprintMessageColorLines[index].custommColor;
        console.error("applayToAllToogle>>>>>>>");
        console.log(id);
        console.log(selectedColor);
        console.log(index);
        console.log(this.imprintMessageColorLines);
        console.warn(this.applayToAll);
        console.warn(imprintLineData);
        if (this.applayToAll.randID == null) {
          imprintLineData = this.imprintMessageColorLines[id];
          this.applayToAll["data"] = imprintLineData;
          this.applayToAll.id = id;
          this.applayToAll["randID"] = imprintLineData.randID;
          this.applayToAll.selectedColor = selectedColor;
          this.applayToAll.index = index;
          this.imprintMessageColorLines[index]["isApplyToAllElement"] = true;
          console.error("Rand ID NOT SET");
          this.setApplayToAllColor(selectedColor, id, isCustomColor, imprintLineData);
        } else {
          this.applayToAll["data"] = null;
          this.applayToAll.randID = null;
          this.store.imprintStep.applyToAll.randID = null;
          this.applayToAll.id = null;
          this.applayToAll.selectedColor = null;
          this.applayToAll.index = null;
          this.imprintMessageColorLines[index]["isApplyToAllElement"] = false;
          console.error("Rand ID IS SET");
          this.setApplayToAllColor(null, id, isCustomColor, imprintLineData);
        }
        this.setApplayToAllDataInStore(this.applayToAll);
        console.log(">>>>>this.applayToAll");
        console.log(this.applayToAll);
        console.log(this.imprintMessageColorLines);
      },
      setApplayToAllColor(selectedColor, excludeId, isCustomColor, lineData) {
        console.error(">>>>>> setApplayToAllColor");
        console.error(selectedColor);
        console.error(excludeId);
        console.error(this.imprintMessageColorLines);
        this.imprintMessageColorLines.forEach(
          (item, index) => {
            if (item.id !== excludeId) {
              if (selectedColor) {
                this.imprintMessageColorLines[index].selectedColor = selectedColor;
                this.imprintMessageColorLines[index].selectedColorObj = lineData.selectedColorObj;
              } else {
                this.imprintMessageColorLines[index].selectedColor = null;
                this.imprintMessageColorLines[index].selectedColorObj = null;
              }
              this.imprintMessageColorLines[index].custommColor = isCustomColor ? true : false;
            }
            if (this.functions.isCheckboxChecked(".applay-to-all-checkbox input")) {
              this.imprintMessageColorLines[index].selectedColor = this.applayToAll.selectedColor;
              this.imprintMessageColorLines[index].selectedColorObj = lineData.selectedColorObj;
            }
          }
        );
        this.uniqueColors = [];
        if (!isCustomColor && excludeId && this.imprintMessageColorLines[excludeId].selectedColorObj) {
          this.uniqueColors.push(this.imprintMessageColorLines[excludeId].selectedColorObj.sku);
        }
        this.setDataMaxColor();
        console.error(" >>>>> Set Apply to All Color After the loop");
        console.warn(this.imprintMessageColorLines);
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      // create list of custom colors (Pantone color)
      pantoneSubmit(lineId, ref2) {
        if (this.$refs["pantone-input-" + lineId][0]["value"].length) {
          let value = this.$refs["pantone-input-" + +lineId][0]["value"];
          if (!this.customColorList.includes(value)) {
            this.customColorList.push(value);
            this.initCustomColorForLine(value, lineId);
          }
          this.$refs["pantone-input-" + +lineId][0]["value"] = "";
        }
        if (this.debugMode) {
          console.warn("111111111++++ pantoneSubmit +++++11111111");
          console.warn(lineId);
          console.warn(ref2);
          console.warn(typeof ref2);
          console.warn(this.$refs);
          console.warn(this.$refs["pantone-input-" + +lineId][0]["value"]);
          console.warn(this.$refs[ref2].value);
        }
      },
      // change state global and current when user add the custom color (Pantone color)
      initCustomColorForLine(customColorText, lineId) {
        console.error("initCustomColorForLine");
        console.warn(this.applayToAll);
        this.imprintMessageColorLines[lineId].selectedColor = customColorText;
        this.imprintMessageColorLines[lineId].custommColor = true;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].selectedColor = customColorText;
        this.store.imprintMessageColorLines[this.store.imprintKey][lineId].custommColor = true;
        if (this.applayToAll.id !== null) {
          this.applayToAll.selectedColor = null;
          let imprintMessageLineData = this.store.imprintMessageColorLines[lineId] ? this.store.imprintMessageColorLines[lineId] : null;
          this.applayToAllToogle(lineId, customColorText, lineId, imprintMessageLineData);
        }
        console.error(this.imprintMessageColorLines);
        console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
        this.colorsPantoneWrappToogle(lineId);
        this.$emit("stepFourChange", this.imprintMessageColorLines);
      },
      initDataFromStore() {
        let dataFromStore = {
          hasColor: false,
          imprintLocation: this.store.selectedLastStep[this.store.imprintKey].imprintLocation
        };
        if (this.store.imprintMessageColorLines[this.store.imprintKey].length) {
          this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
            (line) => {
              if (line.selectedColor) {
                dataFromStore.hasColor = true;
              }
            }
          );
        }
        console.warn(dataFromStore);
        return dataFromStore;
      },
      sortLocationItems() {
        this.imprintData.imprint_position._imprints.sort((a, b) => {
          return a.sort - b.sort;
        });
        this.imprintLocationSelected = !this.store.selectedLastStep[this.store.imprintKey].imprintLocation ? this.imprintData.imprint_position._imprints[0].title : this.store.selectedLastStep[this.store.imprintKey].imprintLocation;
        if (this.imprintLocationSelected.length && !this.store.selectedLastStep[this.store.imprintKey].imprintLocation.length) {
          this.store.selectedLastStep[this.store.imprintKey].imprintLocation = this.imprintLocationSelected;
        }
        console.warn("sortLocationItems");
        console.log(this.imprintLocationSelected);
        console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
        console.log(this.imprintData.imprint_position._imprints[0]);
        this.setMaxLinesByImprintLocations(this.imprintData.imprint_position._imprints[0].sku);
        console.error("@@@@@@@@@@@@@@@@@ >>>>>> this.imprintData.imprint_position._imprints");
        console.log(this.imprintData.imprint_position._imprints);
      }
    },
    created() {
      let dataFromStore = this.initDataFromStore();
      if (dataFromStore.hasColor) {
        console.warn("imprint data reinited from store");
        this.imprintMessageColorLines = this.store.imprintMessageColorLines[this.store.imprintKey];
      }
      this.setDefaultActiveImprintTypeID(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID);
      this.initTab(this.store.selectedLastStep[this.store.imprintKey].imprintTypeID);
      if (this.debugMode) {
        console.error("first step imprint type");
        console.error(this.store.selectedImprint.sku);
      }
      this.initCurrentImprintData();
      this.specialInstruction = this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : "";
      this.sortLocationItems();
      console.error("New imprint created");
      console.warn(this.validateDetails);
      this.$emit("stepFourChange", { imprintLines: this.imprintMessageColorLines, type: "created" });
    }
  };
  const _hoisted_1$z = { class: "start-new-imprint" };
  const _hoisted_2$s = { class: "start-new-imprint__section imprint-location" };
  const _hoisted_3$q = ["value", "data-sku"];
  const _hoisted_4$o = { class: "start-new-imprint__section imprint-type" };
  const _hoisted_5$l = {
    id: "imprint-types",
    class: "start-new-imprint__tabs imprint-message__items"
  };
  const _hoisted_6$l = ["onClick"];
  const _hoisted_7$j = {
    key: 0,
    class: "start-new-imprint__section imprint-type--message"
  };
  const _hoisted_8$h = {
    class: "start-new-imprint__label",
    for: "imprint-type--message"
  };
  const _hoisted_9$f = {
    key: 0,
    class: "error"
  };
  const _hoisted_10$f = {
    id: "imprint-type--message",
    class: "start-new-imprint__tabs imprint-message__items"
  };
  const _hoisted_11$f = { class: "clist-table clist-table--titles clist-style--none" };
  const _hoisted_12$f = { class: "clist-table__row clist-table__row--two-cols" };
  const _hoisted_13$e = { class: "clist-table__col clist-table__col--title clist-table__col--title-double" };
  const _hoisted_14$c = {
    class: "applay-to-all_label",
    style: { "width": "50%", "text-align": "center" }
  };
  const _hoisted_15$b = { class: "clist-table__col clist-table__col--title clist-table__col--title_line" };
  const _hoisted_16$b = ["onClick"];
  const _hoisted_17$a = { class: "clist-table__row clist-table__row--two-cols" };
  const _hoisted_18$a = { class: "clist-table__col clist-table__col--double" };
  const _hoisted_19$a = ["onClick"];
  const _hoisted_20$a = {
    key: 1,
    class: "selected_color custom"
  };
  const _hoisted_21$a = ["data-title"];
  const _hoisted_22$9 = { class: "selected-color-name" };
  const _hoisted_23$7 = {
    class: "applay-to-all-checkbox",
    style: { "width": "50%", "text-align": "center" }
  };
  const _hoisted_24$7 = ["disabled", "checked", "onInput"];
  const _hoisted_25$6 = { class: "clist-table__col clist-table__col--right-input" };
  const _hoisted_26$6 = ["value", "onChange"];
  const _hoisted_27$6 = {
    key: 0,
    class: "cmyk-description"
  };
  const _hoisted_28$6 = {
    key: 1,
    class: "choise-colors-pantone-wrapp"
  };
  const _hoisted_29$6 = { class: "choise-colors-section" };
  const _hoisted_30$6 = ["title", "onClick"];
  const _hoisted_31$5 = { class: "pantone" };
  const _hoisted_32$4 = ["onClick"];
  const _hoisted_33$4 = ["id"];
  const _hoisted_34$3 = { class: "pantone-input-sub-wrapp" };
  const _hoisted_35$3 = { class: "pantone-input-sub__price" };
  const _hoisted_36$3 = { class: "pantone-input-sub__link-wrapp" };
  const _hoisted_37$3 = ["onClick"];
  const _hoisted_38$3 = { key: 3 };
  const _hoisted_39$3 = {
    key: 1,
    class: "start-new-imprint__section imprint-type--uploads"
  };
  const _hoisted_40$3 = {
    id: "imprint-type--message",
    class: "start-new-imprint__tabs imprint-message__items"
  };
  const _hoisted_41$2 = { class: "clist-table clist-table--titles clist-style--none" };
  const _hoisted_42$2 = { class: "clist-table__row clist-table__row--two-cols" };
  const _hoisted_43$2 = { class: "clist-table__col clist-table__col--title clist-table__col--title-double" };
  const _hoisted_44$2 = { class: "image-color-text" };
  const _hoisted_45$2 = { class: "clist-table__row clist-table__row--two-cols" };
  const _hoisted_46$2 = { class: "clist-table__col clist-table__col--double c-jc--unset-i" };
  const _hoisted_47$2 = ["onClick"];
  const _hoisted_48$2 = {
    key: 1,
    class: "selected_color"
  };
  const _hoisted_49$2 = ["data-title"];
  const _hoisted_50$2 = { class: "selected-color-name selected-color-name--left" };
  const _hoisted_51$2 = {
    class: "applay-to-all-checkbox",
    style: { "width": "50%", "text-align": "center", "display": "none" }
  };
  const _hoisted_52$2 = ["disabled", "checked", "onInput"];
  const _hoisted_53$2 = {
    class: "clist-table__col clist-table__col--right-input",
    style: { "display": "none" }
  };
  const _hoisted_54$2 = ["onChange"];
  const _hoisted_55 = {
    key: 0,
    class: "cmyk-description"
  };
  const _hoisted_56 = {
    key: 1,
    class: "choise-colors-pantone-wrapp"
  };
  const _hoisted_57 = { class: "choise-colors-section" };
  const _hoisted_58 = ["title", "onClick"];
  const _hoisted_59 = { class: "pantone" };
  const _hoisted_60 = ["onClick"];
  const _hoisted_61 = ["id"];
  const _hoisted_62 = { class: "pantone-input-sub-wrapp" };
  const _hoisted_63 = { class: "pantone-input-sub__price" };
  const _hoisted_64 = { class: "pantone-input-sub__link-wrapp" };
  const _hoisted_65 = ["onClick"];
  const _hoisted_66 = { class: "start-new-imprint__section imprint-textarea" };
  const _hoisted_67 = {
    id: "imprint-types",
    class: "start-new-imprint__textare"
  };
  const _hoisted_68 = ["value"];
  const _hoisted_69 = {
    key: 0,
    class: "error-section"
  };
  const _hoisted_70 = {
    style: { "font-size": "12px" },
    class: "error-message"
  };
  function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UploadImage = resolveComponent("UploadImage");
    return openBlock(), createElementBlock("div", _hoisted_1$z, [
      createBaseVNode("div", _hoisted_2$s, [
        _cache[5] || (_cache[5] = createBaseVNode("label", {
          class: "start-new-imprint__label",
          for: "imprint-location"
        }, " Imprint Location ", -1)),
        withDirectives(createBaseVNode("select", {
          id: "imprint-location",
          class: "start-new-imprint__selector form-control imprint-location",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.imprintLocationSelected = $event),
          onChange: _cache[1] || (_cache[1] = ($event) => $options.setImprintLocation($event.target.value, $event))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.imprintData.imprint_position._imprints, (option) => {
            return openBlock(), createElementBlock("option", {
              key: option.sku,
              value: option.title,
              "data-sku": option.sku,
              ref_for: true,
              ref: "imprint_location" + option.sku
            }, toDisplayString(option.title), 9, _hoisted_3$q);
          }), 128))
        ], 544), [
          [vModelSelect, $data.imprintLocationSelected]
        ])
      ]),
      createBaseVNode("div", _hoisted_4$o, [
        _cache[6] || (_cache[6] = createBaseVNode("label", {
          class: "start-new-imprint__label start-new-imprint__label-imprint-types",
          for: "imprint-types"
        }, "Imprint Type", -1)),
        createBaseVNode("div", _hoisted_5$l, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.imprintTypes, (imprintType) => {
            return openBlock(), createElementBlock("button", {
              key: imprintType.id,
              class: normalizeClass(["imprint-message__item imprint-message__item--btn", $data.activeImprintTypeID == imprintType.id ? ["imprint-type__tab--active", $options.customBackground] : ""]),
              onClick: ($event) => $options.initTab(imprintType.id)
            }, toDisplayString(imprintType.label), 11, _hoisted_6$l);
          }), 128))
        ])
      ]),
      $data.activeImprintTypeID !== 2 ? (openBlock(), createElementBlock("div", _hoisted_7$j, [
        createBaseVNode("label", _hoisted_8$h, toDisplayString($data.activeImprintTypeID === 3 ? "Step 1: Add your " : "") + "Imprint Message ", 1),
        $options.validateMaxLinesByImprintLocation() ? (openBlock(), createElementBlock("div", _hoisted_9$f, [
          createBaseVNode("p", null, " This Imprint Location supports up to " + toDisplayString($data.maxCountLines) + " " + toDisplayString($data.maxCountLines == 1 ? "line" : "lines") + " of imprint. ", 1)
        ])) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.imprintMessageColorLines, (messageLine, index) => {
          var _a;
          return openBlock(), createElementBlock(Fragment, {
            key: messageLine.id
          }, [
            messageLine.type === "message" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createBaseVNode("div", _hoisted_10$f, [
                createBaseVNode("ul", _hoisted_11$f, [
                  createBaseVNode("li", _hoisted_12$f, [
                    createBaseVNode("div", _hoisted_13$e, [
                      createBaseVNode("div", null, toDisplayString($props.getColorText()), 1),
                      createBaseVNode("div", _hoisted_14$c, [
                        index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          createTextVNode(" Apply to all ")
                        ], 64)) : createCommentVNode("", true)
                      ])
                    ]),
                    createBaseVNode("div", _hoisted_15$b, [
                      createBaseVNode("span", null, "Line " + toDisplayString(index + 1), 1),
                      $options.isRemoveBtnShow($data.activeImprintTypeID, index, messageLine) ? (openBlock(), createElementBlock("span", {
                        key: 0,
                        class: "clist-table__text-remove",
                        onClick: ($event) => $options.deleteLineImprintMessage(index, messageLine)
                      }, " Remove ", 8, _hoisted_16$b)) : createCommentVNode("", true)
                    ])
                  ]),
                  createBaseVNode("li", _hoisted_17$a, [
                    createBaseVNode("div", _hoisted_18$a, [
                      createBaseVNode("div", {
                        class: normalizeClass(messageLine.custommColor ? "selected_color_wrapper selected_color_wrapper--large" : "selected_color_wrapper"),
                        onClick: ($event) => $options.colorsPantoneWrappToogle(index)
                      }, [
                        !messageLine.custommColor ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: "selected_color",
                          style: normalizeStyle(messageLine.selectedColor != null ? "background-image:url(" + $data.colorCatalogBaseUrl + messageLine.selectedColor + ".png)" : "background:" + $data.selectColorBtn.defaultBg)
                        }, null, 4)) : createCommentVNode("", true),
                        messageLine.custommColor ? (openBlock(), createElementBlock("div", _hoisted_20$a, toDisplayString(messageLine.selectedColor), 1)) : createCommentVNode("", true)
                      ], 10, _hoisted_19$a),
                      !messageLine.custommColor ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: "selected-color-wrap",
                        "data-title": (messageLine.selectedColor ? ((_a = messageLine.selectedColorObj) == null ? void 0 : _a.desc) || "" : "").trim()
                      }, [
                        createBaseVNode("div", _hoisted_22$9, toDisplayString(messageLine.selectedColor != null ? messageLine.selectedColorObj["desc"] : ""), 1)
                      ], 8, _hoisted_21$a)) : createCommentVNode("", true),
                      createBaseVNode("div", _hoisted_23$7, [
                        createBaseVNode("input", {
                          disabled: $options.isCheckboxDisabled(index, messageLine.randID),
                          checked: $data.store.imprintStep.applyToAll.id !== null || $data.store.imprintStep.applyToAll.randID == messageLine.randID,
                          type: "checkbox",
                          onInput: ($event) => $options.applayToAllToogle(messageLine.id, messageLine.selectedColor, index, messageLine)
                        }, null, 40, _hoisted_24$7)
                      ])
                    ]),
                    createBaseVNode("div", _hoisted_25$6, [
                      createBaseVNode("input", {
                        class: "c-full-width new-imprint-input new-imprint-input--message",
                        type: "text",
                        value: messageLine.lineMessage,
                        onChange: ($event) => $options.setMessageForLine(index, $event.target.value)
                      }, null, 40, _hoisted_26$6)
                    ])
                  ])
                ])
              ]),
              messageLine.selectedColor == "cmyk" ? (openBlock(), createElementBlock("div", _hoisted_27$6, [
                createBaseVNode("b", null, "Full " + toDisplayString($props.getColorText()), 1),
                createBaseVNode("p", null, " Your imprint will be completed in full " + toDisplayString($props.getColorText(true)) + ". A member of our team will contact you about your design after your order.", 1)
              ])) : createCommentVNode("", true),
              messageLine.isOpenedColorsPantoneWrapp ? (openBlock(), createElementBlock("div", _hoisted_28$6, [
                createBaseVNode("div", _hoisted_29$6, [
                  $data.imprintColorsByLine[messageLine.id] ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList($data.imprintColorsByLine[messageLine.id]._colors, (c_color, colorsindex) => {
                    return openBlock(), createElementBlock("span", { key: colorsindex }, [
                      createBaseVNode("button", {
                        class: "choise-colors-section__item",
                        style: normalizeStyle([{ "width": "25px", "height": "25px" }, ["background-image:url(" + $data.colorCatalogBaseUrl + c_color.file_name + ".png)", !messageLine.selectedColorObj && this.setMaxLimitColors && !this.uniqueColors.includes(c_color.sku) ? "opacity:0.5" : ""]]),
                        title: c_color.desc,
                        onClick: ($event) => $options.setColorForLine(
                          index,
                          c_color,
                          { id: messageLine.id, color: messageLine.selectedColor, index, messageLine }
                        )
                      }, null, 12, _hoisted_30$6)
                    ]);
                  }), 128)) : createCommentVNode("", true)
                ]),
                _cache[7] || (_cache[7] = createBaseVNode("div", { class: "text-or" }, " -OR- ", -1)),
                _cache[8] || (_cache[8] = createBaseVNode("div", { class: "applay-to-all" }, null, -1)),
                createBaseVNode("div", _hoisted_31$5, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($data.customColorList, (customColor, colorIndex) => {
                    return openBlock(), createElementBlock("div", {
                      key: colorIndex,
                      class: "custom-color-wrapp",
                      onClick: ($event) => $options.initCustomColorForLine(customColor, index)
                    }, toDisplayString(customColor), 9, _hoisted_32$4);
                  }), 128)),
                  createBaseVNode("input", {
                    id: "pantone-input-" + messageLine.id,
                    ref_for: true,
                    ref: "pantone-input-" + messageLine.id,
                    class: "pantone-input",
                    type: "text",
                    placeholder: "Enter PANTONE© name"
                  }, null, 8, _hoisted_33$4),
                  createBaseVNode("div", _hoisted_34$3, [
                    createBaseVNode("div", _hoisted_35$3, toDisplayString("$" + $data.customColourFee.toFixed(2)), 1),
                    createBaseVNode("div", _hoisted_36$3, [
                      createBaseVNode("a", {
                        class: "pantone-input-sub__link",
                        onClick: ($event) => $options.pantoneSubmit(messageLine.id, "pantone-input-" + messageLine.id)
                      }, " submit ", 8, _hoisted_37$3)
                    ])
                  ])
                ])
              ])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true)
          ], 64);
        }), 128)),
        $options.isActiveAddLine() ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["imprint-message__add", $options.customColor]),
          onClick: _cache[2] || (_cache[2] = (...args) => $options.addLineImprintMessage && $options.addLineImprintMessage(...args))
        }, [..._cache[9] || (_cache[9] = [
          createBaseVNode("span", { class: "plus" }, "+", -1),
          createBaseVNode("span", null, "Add a New Line", -1)
        ])], 2)) : createCommentVNode("", true),
        $data.activeImprintTypeID === 3 && $data.imprintMessageColorLines.length <= $data.maxCountLines ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["imprint-message__add", $options.customColor]),
          onClick: _cache[3] || (_cache[3] = (...args) => $options.addLineImprintMessage && $options.addLineImprintMessage(...args))
        }, [..._cache[10] || (_cache[10] = [
          createBaseVNode("span", { class: "plus" }, "+", -1),
          createBaseVNode("span", null, "Add a New Line", -1)
        ])], 2)) : createCommentVNode("", true),
        $data.activeImprintTypeID === 3 ? (openBlock(), createElementBlock("div", _hoisted_38$3, [..._cache[11] || (_cache[11] = [
          createBaseVNode("p", { style: { "border-bottom": "1px solid #5A5A5A", "margin": "0", "padding-top": "8px" } }, null, -1)
        ])])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true),
      $data.activeImprintTypeID !== 1 ? (openBlock(), createElementBlock("div", _hoisted_39$3, [
        createVNode(_component_UploadImage, {
          onUploadChanged: $options.uploadChanged,
          activeImprintTypeID: $data.activeImprintTypeID
        }, null, 8, ["onUploadChanged", "activeImprintTypeID"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.imprintMessageColorLines, (messageLine, index) => {
          var _a;
          return openBlock(), createElementBlock(Fragment, {
            key: messageLine.id
          }, [
            messageLine.type === "image" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createBaseVNode("div", _hoisted_40$3, [
                createBaseVNode("ul", _hoisted_41$2, [
                  createBaseVNode("li", _hoisted_42$2, [
                    createBaseVNode("div", _hoisted_43$2, [
                      createBaseVNode("div", _hoisted_44$2, " Image " + toDisplayString($props.getColorText()), 1)
                    ]),
                    _cache[12] || (_cache[12] = createBaseVNode("div", { class: "clist-table__col clist-table__col--title clist-table__col--title_line" }, null, -1))
                  ]),
                  createBaseVNode("li", _hoisted_45$2, [
                    createBaseVNode("div", _hoisted_46$2, [
                      createBaseVNode("div", {
                        class: normalizeClass(messageLine.custommColor ? "selected_color_wrapper selected_color_wrapper--large" : "selected_color_wrapper"),
                        onClick: ($event) => $options.colorsPantoneWrappToogle(index)
                      }, [
                        !messageLine.custommColor ? (openBlock(), createElementBlock("div", {
                          key: 0,
                          class: "selected_color",
                          style: normalizeStyle(messageLine.selectedColor != null ? "background-image:url(" + $data.colorCatalogBaseUrl + messageLine.selectedColor + ".png)" : "background:" + $data.selectColorBtn.defaultBg)
                        }, null, 4)) : createCommentVNode("", true),
                        messageLine.custommColor ? (openBlock(), createElementBlock("div", _hoisted_48$2, toDisplayString(messageLine.selectedColor), 1)) : createCommentVNode("", true)
                      ], 10, _hoisted_47$2),
                      !messageLine.custommColor ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: "selected-color-wrap",
                        "data-title": (messageLine.selectedColor ? ((_a = messageLine.selectedColorObj) == null ? void 0 : _a.desc) || "" : "").trim()
                      }, [
                        createBaseVNode("div", _hoisted_50$2, toDisplayString(messageLine.selectedColor != null ? messageLine.selectedColorObj["desc"] : ""), 1)
                      ], 8, _hoisted_49$2)) : createCommentVNode("", true),
                      createBaseVNode("div", _hoisted_51$2, [
                        createBaseVNode("input", {
                          disabled: $options.isCheckboxDisabled(index, messageLine.randID),
                          checked: $data.store.imprintStep.applyToAll.id !== null && $data.store.imprintStep.applyToAll.randID !== messageLine.randID,
                          type: "checkbox",
                          onInput: ($event) => $options.applayToAllToogle(messageLine.id, messageLine.selectedColor, index, messageLine)
                        }, null, 40, _hoisted_52$2)
                      ])
                    ]),
                    createBaseVNode("div", _hoisted_53$2, [
                      createBaseVNode("input", {
                        class: "c-full-width new-imprint-input new-imprint-input--message",
                        type: "text",
                        onChange: ($event) => $options.setMessageForLine(index, $event.target.value)
                      }, null, 40, _hoisted_54$2)
                    ])
                  ])
                ])
              ]),
              messageLine.selectedColor == "cmyk" ? (openBlock(), createElementBlock("div", _hoisted_55, [
                createBaseVNode("b", null, "Full " + toDisplayString($props.getColorText()), 1),
                createBaseVNode("p", null, " Your imprint will be completed in full " + toDisplayString($props.getColorText(true)) + ". A member of our team will contact you about your design after your order.", 1)
              ])) : createCommentVNode("", true),
              messageLine.isOpenedColorsPantoneWrapp ? (openBlock(), createElementBlock("div", _hoisted_56, [
                createBaseVNode("div", _hoisted_57, [
                  $data.imprintColorsByLine[messageLine.id] ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList($data.imprintColorsByLine[messageLine.id]._colors, (c_color, imageColorIndex) => {
                    return openBlock(), createElementBlock("button", {
                      key: imageColorIndex,
                      class: "choise-colors-section__item",
                      title: c_color.desc,
                      style: normalizeStyle([{ "width": "25px", "height": "25px" }, ["background-image:url(" + $data.colorCatalogBaseUrl + c_color.file_name + ".png)", !messageLine.selectedColorObj && this.setMaxLimitColors && !this.uniqueColors.includes(c_color.sku) ? "opacity:0.5" : ""]]),
                      onClick: ($event) => $options.setColorForLine(
                        index,
                        c_color,
                        { id: messageLine.id, color: messageLine.selectedColor, index, messageLine }
                      )
                    }, null, 12, _hoisted_58);
                  }), 128)) : createCommentVNode("", true)
                ]),
                _cache[13] || (_cache[13] = createBaseVNode("div", { class: "text-or" }, " -OR- ", -1)),
                _cache[14] || (_cache[14] = createBaseVNode("div", { class: "applay-to-all" }, null, -1)),
                createBaseVNode("div", _hoisted_59, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($data.customColorList, (customColor, colorIndex) => {
                    return openBlock(), createElementBlock("div", {
                      key: colorIndex,
                      class: "custom-color-wrapp",
                      onClick: ($event) => $options.initCustomColorForLine(customColor, index)
                    }, toDisplayString(customColor), 9, _hoisted_60);
                  }), 128)),
                  createBaseVNode("input", {
                    id: "pantone-input-" + messageLine.id,
                    ref_for: true,
                    ref: "pantone-input-" + messageLine.id,
                    class: "pantone-input",
                    type: "text",
                    placeholder: "Enter PANTONE© name"
                  }, null, 8, _hoisted_61),
                  createBaseVNode("div", _hoisted_62, [
                    createBaseVNode("div", _hoisted_63, toDisplayString("$" + $data.customColourFee.toFixed(2)), 1),
                    createBaseVNode("div", _hoisted_64, [
                      createBaseVNode("a", {
                        class: "pantone-input-sub__link",
                        onClick: ($event) => $options.pantoneSubmit(messageLine.id, "pantone-input-" + messageLine.id)
                      }, " submit ", 8, _hoisted_65)
                    ])
                  ])
                ])
              ])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ])) : createCommentVNode("", true),
      _cache[16] || (_cache[16] = createBaseVNode("div", { class: "start-new-imprint__section imprint-type--message_uploads" }, null, -1)),
      createBaseVNode("div", _hoisted_66, [
        _cache[15] || (_cache[15] = createBaseVNode("label", {
          class: "start-new-imprint__label",
          for: "imprint-types"
        }, "Special Instructions", -1)),
        createBaseVNode("div", _hoisted_67, [
          createBaseVNode("textarea", {
            class: "c-full-width",
            cols: "30",
            rows: "10",
            value: $data.specialInstruction,
            onChange: _cache[4] || (_cache[4] = ($event) => $options.setSpecialInstruction($event.target.value))
          }, "                ", 40, _hoisted_68)
        ]),
        $props.validateDetails && $data.activeImprintTypeID === $props.validation.imprintType.id ? (openBlock(), createElementBlock("div", _hoisted_69, [
          createBaseVNode("span", _hoisted_70, [
            $data.activeImprintTypeID === 1 && $props.validation.imprintType.id === 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(" Please ensure each line has been filled out and has a " + toDisplayString($options.translate("color")) + " selected before proceeding. ", 1)
            ], 64)) : createCommentVNode("", true),
            $data.activeImprintTypeID === 2 && $props.validation.imprintType.id === 2 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createTextVNode(" Please ensure that your image has been added and " + toDisplayString($options.translate("color")) + " has been selected. ", 1)
            ], 64)) : createCommentVNode("", true),
            $data.activeImprintTypeID === 3 && $props.validation.imprintType.id === 3 ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createTextVNode(" Please ensure each line has been filled out, an image has been selected and all " + toDisplayString($options.translate("color")) + "s have been chosen before proceeding. ", 1)
            ], 64)) : createCommentVNode("", true)
          ])
        ])) : createCommentVNode("", true)
      ])
    ]);
  }
  const NewImprintCard = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$v]]);
  const _sfc_main$y = {
    props: {
      newImprint: Object,
      newTierData: Object,
      step: Number,
      applicationType: String,
      isOutOfStock: { type: Boolean }
    },
    components: {
      CustomQty: CustomQty$1
    },
    data() {
      return {
        totalQty: 0,
        subtotal: 0,
        store,
        feeData: {},
        calendarQty: 0,
        isTooltip: true,
        simpleCalendarID: null,
        functions
      };
    },
    computed: {
      totalSizesQty: function() {
        let key = 1;
        if (this.store.isEnvelopProduct && store.prices.tier.length == 1) {
          key = 0;
          console.error("totalSizesQty1");
        }
        let defaultQty = this.store.productType === "grouped_plain" ? store.prices.tier[key].QtyMin : 0;
        return this.store.totalSizesQty[this.store.imprintKey] ? this.store.totalSizesQty[this.store.imprintKey] : defaultQty;
      },
      subtotalPrice: function() {
        this.calculatePriceByQty();
        let imprintData = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].configurable_2_data;
        if (this.store.isEnvelopProduct && !Object.hasOwn(imprintData, "setup_fee")) {
          return this.formatCurrency(this.totalSizesQty * this.store.prices.priceByQty);
        }
        this.calculateSetupFee();
        this.calculateRunningFee();
        this.calculateImageFee();
        this.calculateProofFee();
        this.calculateCustomColorFee();
        this.calculateColorUpcharge();
        this.calculateSizeUpcharge();
        console.error("ImprintAppSummary this.store.selectedImprint.sku");
        console.warn(this.store);
        console.error("this.store.selectedImprint.sku");
        console.error(this.store.selectedImprint.sku);
        console.error(this.store.prices);
        console.error(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.error(this.newImprint);
        console.error(this.newTierData);
        console.warn(
          " (1) priceByQty: " + this.totalSizesQty * this.store.prices.priceByQty + " (2) priceSizeUpcharge: " + this.store.prices.priceSizeUpcharge + " (3) setupFee: " + this.store.setupFee + " (4) running_fee: " + this.store.prices.running_fee + " (5) proof_fee: " + this.store.prices.proof_fee + " (6) customColourFee: " + this.store.customColourFee + " (7) Image_Fee: " + this.store.prices.image_fee
        );
        let result = this.totalSizesQty * this.store.prices.priceByQty + this.store.prices.priceSizeUpcharge + this.store.prices.setup_fee + this.store.prices.running_fee + this.store.prices.proof_fee + this.store.prices.image_fee + this.store.prices.customColourFee + this.store.prices.priceColorUpcharge;
        return this.formatCurrency(result);
      },
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      },
      customFont() {
        return this.$getCustomFontClass(store.storeID);
      },
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      },
      customBackgroundHover() {
        return this.$getCustomBackgroundColorHoverClass(store.storeID);
      },
      isComda() {
        return store.storeID.includes("comda");
      }
    },
    methods: {
      handleAddToBundle() {
        if (this.isOutOfStock) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
      },
      /* downloadImage(url,title) {
           axios({
               method: 'get',
               url,
               responseType: 'arraybuffer',
           })
               .then((response) => {
               this.forceFileDownload(response, title)
           })
               .catch(() => console.log('error occured'))
       },
       forceFileDownload(response, title) {
           console.log(title)
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', title)
           window.jQuery("#download_image").appendChild(link);
           link.click();
       },*/
      init() {
        this.totalQty = this.store.totalSizesQty[this.store.imprintKey] ? this.store.totalSizesQty[this.store.imprintKey] : this.store.inputProductData.minOrderQty;
        this.subtotal = this.totalQty * this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku].prices_2.price;
      },
      navigateToCalendars() {
        window.location.href = this.isComda ? "/collections/promotional-calendars" : "/collections/calendars";
      },
      getColorUpcharge() {
        let result = 0;
        if (Object.keys(store.upchargesLines[this.store.imprintKey].color)) {
          result = store.upchargesLines[this.store.imprintKey].color[Object.keys(store.upchargesLines[this.store.imprintKey].color)[0]];
          this.store.prices.priceColorUpcharge = result;
        }
        return this.formatCurrency(result);
      },
      pricesNamePresenter(key) {
        let priceNames = {
          setup_fee: "Setup Fee",
          image_fee: "Image Fee",
          running_fee: "Running Fee",
          proof_fee: "Proof Fee",
          customColourFee: window.Shopify.country === "CA" ? "Colour Fee" : "Color Fee"
        };
        return priceNames.hasOwnProperty(key) ? priceNames[key] : false;
      },
      addTooltips(priceNames) {
        var colorWord = window.Shopify.country === "CA" ? "colour" : "color";
        priceNames.setup_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Setup Fee</b>The industry standard cost<br>associated with setting up<br>the screen, die, laser or<br>other necessary items to<br>imprint your specific logo.</span>';
        priceNames.image_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Image Fee</b>The fees associated with<br>formatting, retouching,<br>and/or redrawing custom<br>logos.</span>';
        priceNames.running_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Running Fee</b>Pricing varies by product<br> ' + colorWord + ", size and material.<br>Standard pricing includes<br> 1 " + colorWord + " imprint on<br>standard products, 2XL<br> sizes, different fabrics, etc.<br> may be customized for<br> additional fees.</span>";
        priceNames.proof_fee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>Proof Fee</b>The cost to digitize your<br>artwork (company<br>name/logo/message)<br>and digitally render it on a<br>product for review prior to<br>production.</span>';
        priceNames.customColourFee += '<span class="tooltip-icon">?</span><span class="fee-tooltiptext"><b>' + colorWord[0].toUpperCase() + colorWord.slice(1) + " Fee</b>PMS (Pantone) " + colorWord + " <br>match fee, applied when<br> creating non-standard<br>imprint " + colorWord + " (matching<br>to existing logo, etc.).</span>";
        return priceNames;
      },
      calculatePriceByQty() {
        let priceByQty = 0;
        let total = this.totalSizesQty;
        let minQtyPrice = 0;
        this.store.prices.tier.forEach(
          (item) => {
            if (item.QtyMin !== "MSRP") {
              if (total >= item.QtyMin) {
                const b2bPrice = this.functions.getB2BPriceForTier(item, this.store.prices.b2bTier);
                if (b2bPrice !== null) {
                  priceByQty = b2bPrice;
                } else {
                  priceByQty = this.functions.isValidatedSpecialPrice(item) ? item["sale_price"] : item.price;
                }
              }
            }
            if (item.QtyMin === this.store.inputProductData.minOrderQty) {
              const b2bMinPrice = this.functions.getB2BPriceForTier(item, this.store.prices.b2bTier);
              if (b2bMinPrice !== null) {
                minQtyPrice = b2bMinPrice;
              } else {
                minQtyPrice = this.functions.isValidatedSpecialPrice(item) ? item["sale_price"] : item.price;
              }
            }
          }
        );
        this.store.prices.priceByQty = Number(priceByQty > 0 ? priceByQty : minQtyPrice);
      },
      calculateSetupFee() {
        console.error("33333333333 calculateSetupFee() 3333333333333");
        console.error(this.store.setupFee);
        if (this.isComda) {
          let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;
          this.store.prices.setup_fee = this.store.perItemFee.setupFee;
          if (uniqueColorsCount && this.store.perItemFee.setupFee) {
            this.store.prices.setup_fee = uniqueColorsCount * this.store.perItemFee.setupFee;
          }
        } else if (this.store.prices.priceByQty) {
          this.store.prices.setup_fee = 0;
          let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;
          if (uniqueColorsCount && this.store.perItemFee.setupFee) {
            this.store.prices.setup_fee = (uniqueColorsCount - 1) * this.store.perItemFee.setupFee;
          }
        }
      },
      calculateRunningFee() {
        console.error("444444444444 calculateRunningFee() 4444444444");
        console.error(this.store.prices);
        console.warn(this.store.perItemFee);
        console.warn("Per Item");
        console.log(this.store.perItemFee);
        let uniqueColorsCount = this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount;
        if (this.store.prices.priceByQty && this.store.imprintMessageColorLines[this.store.imprintKey].length > 1 && uniqueColorsCount > 1) {
          this.store.prices.running_fee = (uniqueColorsCount - 1) * this.store.perItemFee.running_fee * this.store.totalSizesQty[this.store.imprintKey];
          this.store.runningFeePerItem = (uniqueColorsCount - 1) * this.store.perItemFee.running_fee;
        } else {
          this.store.prices.running_fee = 0;
        }
      },
      calculateImageFee() {
        console.error("calculateImageFee");
        console.log(this.store.selectedLastStep[this.store.imprintKey].uploaded_image);
        let imageFeePrice = 0;
        if (this.store.selectedLastStep[this.store.imprintKey].uploaded_image && this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href) {
          imageFeePrice = this.store.perItemFee.image_fee ? this.store.perItemFee.image_fee : 0;
          this.store.prices.image_fee = imageFeePrice;
          console.log("uploaded_image worrrk");
        }
        console.error("!!!!!!!!!!!!!! Prise Image");
        console.log(imageFeePrice);
        return imageFeePrice;
      },
      calculateProofFee() {
        console.error("calculateProofFee");
        console.log(this.store.perItemFee.proof_fee);
        console.log(this.store.lastMaxInitedStep);
        console.log(this.store.prices.proof_fee);
        console.warn(this.store.lastMaxInitedStep > 1);
        let proofFeePrice = 0;
        if (this.isComda || this.store.lastMaxInitedStep > 2 && this.store.perItemFee.proof_fee && this.totalSizesQty > 0 && this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount >= 2) {
          proofFeePrice = this.store.perItemFee.proof_fee ? this.store.perItemFee.proof_fee : 0;
          this.store.prices.proof_fee = proofFeePrice;
        } else {
          this.store.prices.proof_fee = 0;
          proofFeePrice = 0;
        }
        console.error("!!!!!!!!!!!!!! Proof Image");
        console.log(proofFeePrice);
        return proofFeePrice;
      },
      calculateCustomColorFee() {
        this.store.prices.customColourFee = 0;
        if (Object.hasOwn(this.store.customColourFee, this.store.imprintKey)) {
          this.store.prices.customColourFee = this.store.customColourFee[this.store.imprintKey];
        }
      },
      calculateColorUpcharge() {
        this.store.prices.priceColorUpcharge = 0;
        if (Object.hasOwn(this.store.upchargesLines, this.store.imprintKey) && Object.hasOwn(this.store.upchargesLines[this.store.imprintKey], "color")) {
          for (let color in this.store.upchargesLines[this.store.imprintKey].color) {
            console.log("inpricein");
            this.store.prices.priceColorUpcharge += this.store.upchargesLines[this.store.imprintKey].color[color];
            console.log(this.store.prices.priceColorUpcharge);
          }
        }
      },
      calculateSizeUpcharge() {
        this.store.prices.priceSizeUpcharge = 0;
        if (Object.hasOwn(this.store.upchargesLines, this.store.imprintKey) && Object.hasOwn(this.store.upchargesLines[this.store.imprintKey], "size")) {
          for (let size in this.store.upchargesLines[this.store.imprintKey].size) {
            console.log("inpricein");
            this.store.prices.priceSizeUpcharge += this.store.upchargesLines[this.store.imprintKey].size[size];
            console.log(this.store.prices.priceColorUpcharge);
          }
        }
      },
      updateStoreState(val) {
        if (val) {
          this.store.totalSizesQty[this.store.imprintKey] = val.value;
          this.store.inputProductData.minOrderQty = val.value;
          this.calendarQty = Number(val.value);
          this.store.calendar.qtyVal = Number(val.value);
          console.error(this.calendarQty);
          console.warn(this.store.calendar.qtyVal);
        }
      },
      formatCurrency(number) {
        return number.toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
        });
      }
    },
    created() {
      this.init();
      console.error("$$$$$$$ Calendar bundle");
      console.warn(this.store);
    },
    mounted() {
      if (this.isComda) {
        this.isTooltip = false;
      }
      if (this.store.application_type == "calendar_single") {
        console.error("++++++++++++ Mounted Application Type ImpSummary +++++++++++++");
        console.log(this.store.application_type);
        this.simpleCalendarID = parseInt(document.getElementById("simple_calendar_pr_id").textContent);
        this.store.calendar.productPageTitle = window.jQuery("h1.product_name").text();
        this.store.calendar["productImage"] = window.jQuery(window.jQuery(".gallery-cell")[0]).find("a.lightbox").attr("href");
        if (!this.store.calendar["productImage"]) {
          this.store.calendar["productImage"] = window.jQuery(window.jQuery(".gallery-cell")[0]).find("img.product-gallery__image").attr("data-src");
        }
        console.log(">>>>");
        console.log(this.store);
      }
      if (this.store.application_type == "calendar_single" || this.store.application_type == "calendar") {
        if (window.jQuery("#calendar-qty-changed")) {
          window.jQuery("body").on(
            "click",
            "#calendar-qty-changed",
            (event2) => {
              console.log(event2);
              console.warn("ImprintAppSummary qty created hook ");
              if (window.jQuery("#calendar-imprint-common-qty")) {
                console.error(window.jQuery("#calendar-imprint-common-qty").val());
                let qtyValue = window.jQuery("#calendar-imprint-common-qty").val();
                this.updateStoreState({ value: qtyValue });
              }
            }
          );
          window.jQuery(document).on(
            "imprintTabChanged",
            () => {
              if (window.jQuery("#calendar-imprint-common-qty")) {
                console.error("Imprint tab changed=>>>>");
                console.error(window.jQuery("#calendar-imprint-common-qty").val());
                let qtyValue = window.jQuery("#calendar-imprint-common-qty").val();
                this.updateStoreState({ value: qtyValue });
              }
            }
          );
        }
      }
    }
  };
  const _hoisted_1$y = {
    id: "imprint-app-total",
    class: "imprint-app-total"
  };
  const _hoisted_2$r = {
    class: "imprint-app-total__line comda_underline_line",
    style: { "padding-bottom": "10px" }
  };
  const _hoisted_3$p = {
    style: { "padding": "6px", "font-size": "16px", "background": "#eeeeee" },
    class: "imprint-app-total__line-value"
  };
  const _hoisted_4$n = {
    style: { "padding": "6px", "font-size": "16px" },
    class: "imprint-app-total__line-value"
  };
  const _hoisted_5$k = {
    style: { "padding": "6px", "font-size": "16px" },
    class: "imprint-app-total__line-value"
  };
  const _hoisted_6$k = { class: "imprint-app-total__fee-wrapp" };
  const _hoisted_7$i = { key: 0 };
  const _hoisted_8$g = {
    key: 0,
    class: "comda_imprint-app-total__line"
  };
  const _hoisted_9$e = {
    key: 0,
    class: "comda_imprint-app-total__line-value"
  };
  const _hoisted_10$e = {
    key: 1,
    class: "comda_imprint-app-total__line-value"
  };
  const _hoisted_11$e = { class: "comda_imprint-app-total__line-value" };
  const _hoisted_12$e = {
    key: 0,
    class: "comda_imprint-app-total__line"
  };
  const _hoisted_13$d = { class: "comda_imprint-app-total__line-value" };
  const _hoisted_14$b = {
    key: 0,
    class: "tooltip-icon"
  };
  const _hoisted_15$a = {
    key: 1,
    class: "fee-tooltiptext"
  };
  const _hoisted_16$a = { class: "comda_imprint-app-total__line-value" };
  const _hoisted_17$9 = {
    key: 0,
    class: "comda_imprint-app-total__line"
  };
  const _hoisted_18$9 = ["innerHTML"];
  const _hoisted_19$9 = { class: "comda_imprint-app-total__line-value" };
  const _hoisted_20$9 = {
    class: "comda_imprint-app-total__line total",
    style: { "justify-content": "normal" }
  };
  const _hoisted_21$9 = { class: "comda_imprint-app-total__line-value" };
  const _hoisted_22$8 = { class: "imprint-app-total__line" };
  const _hoisted_23$6 = { class: "imprint-app-total__line" };
  const _hoisted_24$6 = { class: "imprint-app-total__line-value" };
  const _hoisted_25$5 = { class: "imprint-app-total__line-value" };
  const _hoisted_26$5 = { class: "imprint-app-total__fee-wrapp" };
  const _hoisted_27$5 = { key: 0 };
  const _hoisted_28$5 = {
    key: 0,
    class: "imprint-app-total__line"
  };
  const _hoisted_29$5 = {
    key: 0,
    class: "imprint-app-total__line-value"
  };
  const _hoisted_30$5 = {
    key: 1,
    class: "imprint-app-total__line-value"
  };
  const _hoisted_31$4 = { class: "imprint-app-total__line-value" };
  const _hoisted_32$3 = { class: "imprint-app-total__line-value" };
  const _hoisted_33$3 = { class: "imprint-app-total__line-value" };
  const _hoisted_34$2 = {
    key: 0,
    class: "imprint-app-total__line"
  };
  const _hoisted_35$2 = { class: "imprint-app-total__line-value" };
  const _hoisted_36$2 = { class: "imprint-app-total__line-value" };
  const _hoisted_37$2 = { class: "imprint-app-total__line" };
  const _hoisted_38$2 = { class: "imprint-app-total__line-value sub-total-value" };
  const _hoisted_39$2 = { class: "bundle-butons bundle-butons-wrapper calendar" };
  const _hoisted_40$2 = ["data-product_id", "data-product_title", "data-product_image", "data-product_qty"];
  function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomQty = resolveComponent("CustomQty");
    return openBlock(), createElementBlock("div", _hoisted_1$y, [
      $props.applicationType !== "calendar_single" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $options.isComda ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          _cache[4] || (_cache[4] = createBaseVNode("div", { class: "imprint-app-total__line" }, [
            createBaseVNode("div", { class: "comda_imprint-app-total__line-title" }, "Unit Price"),
            createBaseVNode("div", { class: "comda_imprint-app-total__line-title" }, "Total Qty"),
            createBaseVNode("div", { class: "comda_imprint-app-total__line-title" }, "Subtotal")
          ], -1)),
          createBaseVNode("div", _hoisted_2$r, [
            createBaseVNode("div", _hoisted_3$p, " $" + toDisplayString($data.store.prices.priceByQty ? $data.store.prices.priceByQty.toFixed(2) : 0) + " / Each ", 1),
            createBaseVNode("div", _hoisted_4$n, toDisplayString($options.totalSizesQty), 1),
            createBaseVNode("div", _hoisted_5$k, toDisplayString($options.formatCurrency(this.totalSizesQty * this.store.prices.priceByQty)), 1)
          ]),
          createBaseVNode("div", _hoisted_6$k, [
            Object.hasOwn($data.store.upchargesLines, this.store.imprintKey) ? (openBlock(), createElementBlock("div", _hoisted_7$i, [
              Object.hasOwn($data.store.upchargesLines[this.store.imprintKey], "color") && Object.keys($data.store.upchargesLines[this.store.imprintKey].color).length && $data.store.prices.priceColorUpcharge != 0 ? (openBlock(), createElementBlock("div", _hoisted_8$g, [
                $data.store.productType === "grouped_plain" ? (openBlock(), createElementBlock("div", _hoisted_9$e, " Colour Charge ")) : (openBlock(), createElementBlock("div", _hoisted_10$e, " Apparel Color " + toDisplayString(this.store.prices.priceColorUpcharge.toFixed(2) < 0 ? "Downcharge" : "Upcharge"), 1)),
                createBaseVNode("div", _hoisted_11$e, toDisplayString($options.formatCurrency(this.store.prices.priceColorUpcharge)), 1)
              ])) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.upchargesLines[this.store.imprintKey].size, (sizePrice, sizeProp) => {
                return openBlock(), createElementBlock(Fragment, { key: sizeProp }, [
                  sizePrice != 0 ? (openBlock(), createElementBlock("div", _hoisted_12$e, [
                    createBaseVNode("div", _hoisted_13$d, [
                      createTextVNode(" Apparel Upsize (" + toDisplayString(sizeProp) + ") ", 1),
                      !$options.isComda ? (openBlock(), createElementBlock("span", _hoisted_14$b, "?")) : createCommentVNode("", true),
                      !$options.isComda ? (openBlock(), createElementBlock("span", _hoisted_15$a, [..._cache[2] || (_cache[2] = [
                        createBaseVNode("b", null, "Apparel Upsize", -1),
                        createTextVNode(" Pricing based on extra sizes ", -1)
                      ])])) : createCommentVNode("", true)
                    ]),
                    createBaseVNode("div", _hoisted_16$a, toDisplayString($options.formatCurrency(sizePrice)), 1)
                  ])) : createCommentVNode("", true)
                ], 64);
              }), 128))
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices, (feeLine, index) => {
              return openBlock(), createElementBlock(Fragment, { key: index }, [
                index !== "tier" && $options.pricesNamePresenter(index) !== false && (feeLine != 0 || this.store.isEnvelopProduct && index == "setup_fee") ? (openBlock(), createElementBlock("div", _hoisted_17$9, [
                  createBaseVNode("div", {
                    class: "comda_imprint-app-total__line-value",
                    innerHTML: $options.pricesNamePresenter(index)
                  }, null, 8, _hoisted_18$9),
                  createBaseVNode("div", _hoisted_19$9, toDisplayString($options.formatCurrency(feeLine)), 1)
                ])) : createCommentVNode("", true)
              ], 64);
            }), 128)),
            createBaseVNode("div", _hoisted_20$9, [
              _cache[3] || (_cache[3] = createBaseVNode("div", {
                class: "comda_imprint-app-total__line-value",
                style: { "width": "70%", "text-align": "right" }
              }, " Total ", -1)),
              createBaseVNode("div", _hoisted_21$9, toDisplayString($options.formatCurrency($options.subtotalPrice)), 1)
            ])
          ])
        ], 64)) : createCommentVNode("", true),
        !$options.isComda ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createBaseVNode("div", _hoisted_22$8, [
            createBaseVNode("div", {
              class: normalizeClass(["imprint-app-total__line-title", [$options.customFont, $options.customColor]])
            }, "Unit Price", 2),
            createBaseVNode("div", {
              class: normalizeClass(["imprint-app-total__line-title", [$options.customFont, $options.customColor]])
            }, "Total Qty", 2)
          ]),
          createBaseVNode("div", _hoisted_23$6, [
            createBaseVNode("div", _hoisted_24$6, "$" + toDisplayString($data.store.prices.priceByQty ? $data.store.prices.priceByQty.toFixed(2) : 0) + " / Each", 1),
            createBaseVNode("div", _hoisted_25$5, toDisplayString($options.totalSizesQty), 1)
          ]),
          createBaseVNode("div", _hoisted_26$5, [
            Object.hasOwn($data.store.upchargesLines, this.store.imprintKey) ? (openBlock(), createElementBlock("div", _hoisted_27$5, [
              Object.hasOwn($data.store.upchargesLines[this.store.imprintKey], "color") && Object.keys($data.store.upchargesLines[this.store.imprintKey].color).length && $data.store.prices.priceColorUpcharge != 0 ? (openBlock(), createElementBlock("div", _hoisted_28$5, [
                $data.store.productType === "grouped_plain" ? (openBlock(), createElementBlock("div", _hoisted_29$5, " Colour Charge ")) : (openBlock(), createElementBlock("div", _hoisted_30$5, " Apparel Color " + toDisplayString(this.store.prices.priceColorUpcharge.toFixed(2) < 0 ? "Downcharge" : "Upcharge"), 1)),
                createBaseVNode("div", _hoisted_31$4, toDisplayString($options.formatCurrency(this.store.prices.priceColorUpcharge)), 1)
              ])) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.upchargesLines[this.store.imprintKey].size, (sizePrice, sizeProp) => {
                return openBlock(), createElementBlock("div", {
                  key: sizeProp,
                  class: "imprint-app-total__line"
                }, [
                  createBaseVNode("div", _hoisted_32$3, [
                    createTextVNode(" Apparel Upsize (" + toDisplayString(sizeProp) + ") ", 1),
                    _cache[5] || (_cache[5] = createBaseVNode("span", { class: "tooltip-icon" }, "?", -1)),
                    _cache[6] || (_cache[6] = createBaseVNode("span", { class: "fee-tooltiptext" }, [
                      createBaseVNode("b", null, "Apparel Upsize"),
                      createTextVNode(" Pricing based on extra sizes ")
                    ], -1))
                  ]),
                  createBaseVNode("div", _hoisted_33$3, toDisplayString($options.formatCurrency(sizePrice)), 1)
                ]);
              }), 128))
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.prices, (feeLine, index) => {
              return openBlock(), createElementBlock(Fragment, { key: index }, [
                index !== "tier" && $options.pricesNamePresenter(index) !== false ? (openBlock(), createElementBlock("div", _hoisted_34$2, [
                  createBaseVNode("div", _hoisted_35$2, toDisplayString($options.pricesNamePresenter(index)), 1),
                  createBaseVNode("div", _hoisted_36$2, toDisplayString($options.formatCurrency(feeLine)), 1)
                ])) : createCommentVNode("", true)
              ], 64);
            }), 128))
          ]),
          createBaseVNode("div", _hoisted_37$2, [
            createBaseVNode("div", {
              class: normalizeClass(["imprint-app-total__line-title", [$options.customFont, $options.customColor]])
            }, "Sub-Total", 2),
            createBaseVNode("div", _hoisted_38$2, toDisplayString($options.subtotalPrice), 1)
          ])
        ], 64)) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true),
      $props.applicationType === "calendar_single" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        _cache[7] || (_cache[7] = createBaseVNode("div", { class: "min-order-qty-text" }, " Minimum order for calendar bundles is 100 unit(s) ", -1)),
        createBaseVNode("div", _hoisted_39$2, [
          createVNode(_component_CustomQty, {
            "css-classes": "bundle-butons__item bundle-butons__item--qty",
            modelValue: $data.store.calendar.qtyVal ? $data.store.calendar.qtyVal : 25,
            sizeTitle: "QTY",
            displayTitle: true,
            lineId: 0,
            prId: "size-input-single-" + $data.simpleCalendarID,
            onCustomQtyChange: $options.updateStoreState
          }, null, 8, ["modelValue", "prId", "onCustomQtyChange"]),
          createBaseVNode("a", {
            class: normalizeClass(["bundle-butons__item bundle-butons__item--add-to-bundle arrow-right add_to_cart_type_class--bundle", [$props.isOutOfStock ? "btn-disabled" : "", $options.customBackground]]),
            "data-product_id": $data.simpleCalendarID,
            "data-product_title": $data.store.calendar.productPageTitle,
            "data-product_image": $data.store.calendar.productImage,
            "data-product_qty": $data.calendarQty,
            type: "submit",
            onClick: _cache[0] || (_cache[0] = (...args) => $options.handleAddToBundle && $options.handleAddToBundle(...args))
          }, " Add to Bundle ", 10, _hoisted_40$2),
          createBaseVNode("button", {
            class: normalizeClass(["bundle-butons__item bundle-butons__item--back-to-themes arrow-left", [$options.customBackgroundHover]]),
            onClick: _cache[1] || (_cache[1] = ($event) => $options.navigateToCalendars())
          }, " Back to themes ", 2)
        ])
      ], 64)) : createCommentVNode("", true)
    ]);
  }
  const imprintAppSummary = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$u]]);
  const _sfc_main$x = {
    props: {
      cStep: Number
    },
    data() {
      return {
        debugMode: true,
        store,
        imprintData: {},
        // configurable_2_data
        imprintLocationSelected: "",
        imprintLocationData: {
          value: null,
          sku: null
        }
      };
    },
    computed: {
      getID: function() {
        return "imprint-location-" + this.cStep;
      }
    },
    methods: {
      sortItems() {
        this.imprintData.imprint_position._imprints.sort((a, b) => {
          return a.sort - b.sort;
        });
        console.error("@@@@@@@@@@@@@@@@@ >>>>>> this.imprintData.imprint_position._imprints");
        console.log(this.imprintData.imprint_position._imprints);
      },
      initLocationDataFromStore() {
        this.imprintLocationSelected = this.imprintData.imprint_position._imprints[0].title;
        this.store.selectedLastStep[this.store.imprintKey].imprintLocation = this.imprintLocationSelected;
      },
      initLocationDataFromLastSavedState() {
        this.imprintLocationSelected = this.store.selectedLastStep[this.store.imprintKey].imprintLocation;
      },
      initCurrentImprintData() {
        console.error(">>>>>>>>> Imprint Location init >>>>>>");
        this.imprintSKU = this.store.selectedImprint.sku;
        this.store.sku.imprint.method.val = this.imprintSKU;
        this.imprintData = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU].configurable_2_data;
        this.store.selectedImprint.data = this.store.inputProductData.fullJson.configurable_array[this.imprintSKU];
        this.sortItems();
        if (!this.store.selectedLastStep[this.store.imprintKey].imprintLocation) {
          console.error(this.store);
          this.initLocationDataFromStore();
        } else {
          this.initLocationDataFromLastSavedState();
        }
      },
      setImprintLocation(value, event2) {
        console.error("!!!!!!!!!!!! setImprintLocation");
        this.store.selectedLastStep[this.store.imprintKey].imprintLocation = value;
        this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.value = value;
        this.store.selectedLastStep[this.store.imprintKey]._imprintLocation.sku = event2.target.selectedOptions[0].dataset.sku;
        this.store.sku.imprint.location.val = event2.target.selectedOptions[0].dataset.sku;
        this.imprintLocationSelected = value;
        if (this.debugMode) {
          console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
          console.log(this.store.selectedLastStep[this.store.imprintKey]);
          console.log(event2.target.dataSku);
          console.log(event2.target.selectedOptions);
          console.log(event2.target.selectedOptions[0].dataset.sku);
        }
      }
    },
    created() {
      this.initCurrentImprintData();
    }
  };
  const _hoisted_1$x = { class: "start-new-imprint__section imprint-location" };
  const _hoisted_2$q = ["for"];
  const _hoisted_3$o = ["id"];
  function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$x, [
      createBaseVNode("label", {
        class: "start-new-imprint__label",
        for: $options.getID
      }, " Imprint Location ", 8, _hoisted_2$q),
      withDirectives(createBaseVNode("select", {
        id: $options.getID,
        class: "start-new-imprint__selector form-control imprint-location",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.imprintLocationSelected = $event),
        onChange: _cache[1] || (_cache[1] = ($event) => $options.setImprintLocation($event.target.value, $event))
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.imprintData.imprint_position._imprints, (option, arrIndex) => {
          return openBlock(), createElementBlock("option", { key: arrIndex }, toDisplayString(option.title), 1);
        }), 128))
      ], 40, _hoisted_3$o), [
        [vModelSelect, $data.imprintLocationSelected]
      ])
    ]);
  }
  const ImprintLocation = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$t]]);
  let pending = null;
  let pagehideBound = false;
  function send(apiBaseUrl, message2) {
    const url = (apiBaseUrl || "") + "api/add-log";
    const payload = { type: "debug", scope: "atc-result", message: message2 };
    const body = JSON.stringify(payload);
    if (typeof fetch === "function") {
      try {
        fetch(url, {
          method: "POST",
          body,
          keepalive: true,
          credentials: "omit",
          headers: { "Content-Type": "text/plain" }
        }).catch(() => sendFallback(url, payload, body));
        return;
      } catch (e) {
      }
    }
    sendFallback(url, payload, body);
  }
  function sendFallback(url, payload, body) {
    try {
      if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function" && navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }))) {
        return;
      }
      axios.post(url, payload).catch(() => {
      });
    } catch (e) {
    }
  }
  function fields({ flow, mode, corrId, startedAt }) {
    const shop = window.Shopify && window.Shopify.shop || "";
    const durationMs = startedAt ? Math.max(0, Date.now() - startedAt) : "";
    return [
      `flow=${flow || "-"}`,
      `shop=${shop || "-"}`,
      `mode=${mode || "-"}`,
      `duration_ms=${durationMs === "" ? "-" : durationMs}`,
      `corr=${corrId || "-"}`
    ];
  }
  function onPagehide() {
    try {
      if (!pending) {
        return;
      }
      const p2 = pending;
      pending = null;
      reportAtcResult({ ...p2, outcome: "abandoned", stage: p2.stage });
    } catch (e) {
    }
  }
  function trackAtcStart({ apiBaseUrl, flow, mode = "", corrId = "", startedAt = Date.now() }) {
    try {
      pending = { apiBaseUrl, flow, mode, corrId, startedAt, stage: "start" };
      if (!pagehideBound && typeof window !== "undefined") {
        window.addEventListener("pagehide", onPagehide);
        pagehideBound = true;
      }
      send(apiBaseUrl, ["ATC_STAGE", "stage=start", ...fields(pending)].join(" "));
    } catch (e) {
    }
  }
  function trackAtcStage(stage, corrId = "") {
    try {
      if (!pending || corrId && pending.corrId !== corrId) {
        return;
      }
      pending.stage = stage;
      send(pending.apiBaseUrl, ["ATC_STAGE", `stage=${stage}`, ...fields(pending)].join(" "));
    } catch (e) {
    }
  }
  function reportAtcResult({
    apiBaseUrl,
    outcome,
    stage = "",
    flow,
    mode = "",
    corrId = "",
    startedAt = 0,
    status = ""
  }) {
    try {
      if (pending && (!corrId || pending.corrId === corrId)) {
        pending = null;
      }
      const shop = window.Shopify && window.Shopify.shop || "";
      const durationMs = startedAt ? Math.max(0, Date.now() - startedAt) : "";
      const message2 = [
        "ATC_RESULT",
        `success=${outcome === "success" ? 1 : 0}`,
        `outcome=${outcome}`,
        `stage=${stage || "-"}`,
        `flow=${flow || "-"}`,
        `shop=${shop || "-"}`,
        `mode=${mode || "-"}`,
        `status=${status || "-"}`,
        `duration_ms=${durationMs === "" ? "-" : durationMs}`,
        `corr=${corrId || "-"}`
      ].join(" ");
      send(apiBaseUrl, message2);
    } catch (e) {
    }
  }
  const imageHowToOrder = "data:image/png;base64,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";
  var define_process_env_default = {};
  const show = /* @__PURE__ */ ref(false);
  const title = /* @__PURE__ */ ref("Something went wrong!");
  const message = /* @__PURE__ */ ref("The imprint builder ran into an issue. Please reload the page and start again.");
  const primaryLabel = /* @__PURE__ */ ref("Next Step");
  const reloadOnPrimary = /* @__PURE__ */ ref(true);
  const _sfc_main$w = {
    components: {
      CTextCard,
      ImprintTabs,
      ColorSizePickerComponent,
      NewImprintCard,
      CTextCardRequrenmentRules,
      imprintAppSummary,
      ImprintLocation,
      PriceMatrixComponent
    },
    data() {
      return {
        activeTabCalendarBundle: 0,
        imageHowToOrder,
        functions,
        showModal: false,
        step: 1,
        stepsDebugMode: true,
        isComda: false,
        specialInstruction: "",
        stepInfo: [
          {
            id: 1,
            navNextSubText: "Choose Product " + this.getColorText() + " and Quantity",
            navPrevSubText: "",
            infoSubText: "",
            textCardTitle: "Choose Imprint Method",
            textCardBody: "Choose the imprint method that you would like your product to be customized with. The price grid below will update based on which imprint method is selected.",
            additionalText: ""
          },
          {
            id: 2,
            navNextSubText: "Customize your Product",
            navPrevSubText: "Choose your Imprint Method",
            infoSubText: "",
            textCardTitle: "Choose Product " + this.getColorText() + " and Quantity",
            textCardBody: "Choose the product " + this.getColorText(true) + "  and quantity that you wish to purchase. If you would like to choose more than one " + this.getColorText(true) + "  click + Add a New " + this.getColorText(),
            additionalText: ""
          },
          {
            id: 3,
            navNextSubText: "",
            navPrevSubText: "Choose Product " + this.getColorText() + " and Quantity",
            infoSubText: "",
            textCardTitle: "Customize Your Product",
            textCardBody: "You can choose to start a new imprint, or if you are a returning customer you can select “Use My Previous Artwork” - we keep your previous files on record. If you would like to make any changes to a previous imprint please comment any specifics in the “Special Instructions” box.",
            additionalText: 'Alternatively, if you would like to send your art files after placing your order, select “Send Us Your Artwork After Ordering”. After placing your order, send an email to <a href="mailto:' + this.getEmail() + '">' + this.getEmail() + "</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production."
          },
          {
            id: 4,
            navNextSubText: "",
            navPrevSubText: "Choose Product " + this.getColorText() + " and Quantity",
            infoSubText: "",
            textCardTitle: "Customize Your Product",
            textCardBody: this.getStepText(),
            additionalText: ""
          },
          {
            id: 5,
            navNextSubText: "",
            navPrevSubText: "Choose Product " + this.getColorText() + " and Quantity",
            infoSubText: "",
            textCardTitle: "Customize Your Product",
            textCardBody: 'Please send an email to <a href="mailto:' + this.getEmail() + '">' + this.getEmail() + "</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production. Note that your order will not proceed until we receive your artwork and create your proof.",
            additionalText: "",
            specialInstruction: "Send Us Your Artwork After Ordering. \r\n\r\nComment:"
          },
          {
            id: 6,
            navNextSubText: "",
            navPrevSubText: "Choose Product " + this.getColorText() + " and Quantity",
            infoSubText: "",
            textCardTitle: "Customize Your Product",
            textCardBody: "If you are a returning customer, we have your previous art on file. Please specify which artwork you’re looking for, and if you would like to make any changes, please comment any specifics in the “Special Instructions” box. If you know your previous Order Number, please include it in the Special Instructions box below.",
            additionalText: "",
            specialInstruction: "Use My Previous Artwork.\r\n\r\nComment:"
          }
        ],
        calendarStepInfo: [
          {
            id: 1,
            navNextSubText: "Customize your Product",
            navPrevSubText: "",
            infoSubText: "",
            textCardTitle: "Choose Imprint Method",
            textCardBody: "Choose the imprint method that you would like your product to be customized with. The price grid below will update based on which imprint method is selected.",
            additionalText: ""
          }
        ],
        maxStep: 3,
        store,
        responseProduct: {},
        mainProductID: null,
        minOrderQty: null,
        qtyIncrement: null,
        maxColorCount: 2,
        newImprint: null,
        validationMessages: {},
        validationResult: {
          hasError: false,
          imprintType: {
            id: 1,
            message: null
          }
        },
        addToCartSatatus: false,
        imprintTierData: {},
        cartState: false,
        stepForAddAssociatedFee: "",
        // 'first' or 'last'
        applicationType: "default",
        cartObject: {},
        responsedCartItems: {},
        colorText: null,
        colorTextUppercase: null,
        currentGroupID: null,
        bundleProductCleared: false,
        loader: false,
        apiBaseUrl: "",
        currentLocationUrl: "",
        errorsRezult: [],
        addToCartBtnStatus: true,
        inventoryStatus: null
      };
    },
    mounted() {
      this.isComda = window.location.href.includes("comda");
      this.currentLocationUrl = window.location.host;
    },
    computed: {
      customColor() {
        return this.$getCustomColorClass(store.storeID);
      },
      customColorBefore() {
        return this.$getCustomColorBeforeClass(store.storeID);
      },
      customColorAfter() {
        return this.$getCustomColorAfterClass(store.storeID);
      },
      customFont() {
        return this.$getCustomFontClass(store.storeID);
      },
      customBackground() {
        return this.$getCustomBackgroundColorClass(store.storeID);
      },
      customBackgroundHover() {
        return this.$getCustomBackgroundColorHoverClass(store.storeID);
      },
      showTextCard() {
        let result = !this.store.isCustomBundlePage && this.applicationType !== "calendar_single" && this.applicationType !== "calendar";
        if (this.isComda && this.applicationType == "calendar_single" && !this.store.isCustomBundlePage) {
          result = true;
        }
        return result;
      },
      isOutOfStock() {
        return this.inventoryStatus === "Out of Stock";
      }
    },
    methods: {
      isCalendarBundleWithoutSelection() {
        if (!this.store.isCustomBundlePage || this.store.application_type !== "calendar") {
          return false;
        }
        let bundleIsEmpty = true;
        try {
          const raw = window.localStorage.getItem("fullStorageProductList");
          if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.length > 0) {
              bundleIsEmpty = false;
            }
          }
        } catch (e) {
          console.error("isCalendarBundleWithoutSelection parse error", e);
          bundleIsEmpty = true;
        }
        return bundleIsEmpty;
      },
      designOnlineTogle() {
        this.designOnlineTogleStatus = !this.designOnlineTogleStatus;
      },
      setInventoryStatus() {
        var _a;
        console.log("-----Set Inventory Status ----- ");
        this.inventoryStatus = "In Stock";
        if (((_a = this.full_product_json) == null ? void 0 : _a.is_in_stock) !== void 0 && this.store.application_type !== "calendar_single") {
          this.inventoryStatus = this.full_product_json.is_in_stock.trim();
          console.log("set status from full_product_json" + this.inventoryStatus);
        }
        if (this.store.application_type === "calendar_single") {
          let statusEl = document.getElementById("inventory_status");
          if (statusEl) {
            let status = statusEl.textContent.trim();
            if (status) {
              this.inventoryStatus = status;
              console.log("inventory status for simple calendar " + this.inventoryStatus);
            } else {
              console.log("inventory status is empty for calendar_sku");
              console.log(status);
            }
          } else {
            console.log("inventory_status element not found for calendar_sku");
          }
        }
      },
      getStepText() {
        let stepThreeText = "Add your imprint here. You can choose to add Text, an Image or both! To start, choose where you would like to imprint your product and fill in the required info. You can add one imprint per product online; to add additional imprints please contact us at 866-858-3276.";
        if (window.PXUTheme.theme_settings.project_store_name == "comda") {
          stepThreeText = "Add your imprint here. You can choose to add Text, an Image or both! To start, choose where you would like to imprint your product and fill in the required info. You can add one imprint per product online; to add additional imprints please contact us at 800-387-7702.";
        }
        return stepThreeText;
      },
      isImprintStepShow(step) {
        if (this.store.application_type == "default" && step == 3) {
          return true;
        } else if (this.store.application_type == "calendar" && step == 2) {
          return true;
        } else if (this.store.application_type == "calendar_single" && step == 2) {
          return true;
        } else {
          return false;
        }
      },
      isAddToCartDisabled() {
        console.error("isAddToCartDisabled method run");
        console.log(this.store.isCustomBundlePage);
        console.log(this.bundleProductCleared);
        if (this.store.isCustomBundlePage && this.bundleProductCleared) {
          this.addToCartBtnStatus = true;
        } else {
          this.addToCartBtnStatus = this.store.disabledAddToCart;
        }
      },
      setSpecialInstruction(value) {
        this.specialInstruction = value;
        this.store.selectedLastStep[this.store.imprintKey].special_instruction = value;
      },
      prev() {
        if (this.stepsDebugMode) {
          console.error(" before Prev Step");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        if (this.step > 3) {
          this.step = 2;
        } else {
          this.step = this.step !== 1 ? this.step - 1 : this.step;
        }
        this.navigateCustomBundle();
        if (this.stepsDebugMode) {
          console.error(" aftere Prev Step");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        window.location.href = "#step-imprint-app-header";
      },
      navigateCustomBundle() {
        if (this.store.isCustomBundlePage) {
          if (this.step === 1) {
            this.calendarStepInfo[0] = this.stepInfo[0];
            this.calendarStepInfo[0]["navNextSubText"] = "Customize your Product";
          }
          if (this.step === 2) {
            this.calendarStepInfo[0] = this.stepInfo[1];
            this.calendarStepInfo[0]["navPrevSubText"] = "Choose your Imprint Method";
          }
        }
      },
      next() {
        if (this.stepsDebugMode) {
          console.error(" before Next Step");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        if (this.step == 2 && this.store.totalSizesQty[this.store.imprintKey] < this.store.inputProductData.minOrderQty || this.store.qtyError) {
          this.step = 2;
          console.log(" --- if ----");
        } else {
          console.log(" --- else ----");
          if (this.step == 2 && this.store.selectedLastStep[this.store.imprintKey].stepId) {
            console.log(" --- else if ----");
            this.step = this.store.selectedLastStep[this.store.imprintKey].stepId;
          } else {
            console.log(" --- else else ----");
            this.step = this.step !== this.maxStep ? this.step + 1 : this.step;
          }
        }
        this.store.lastMaxInitedStep = this.store.lastMaxInitedStep < this.step ? this.step : this.store.lastMaxInitedStep;
        this.navigateCustomBundle();
        if (this.stepsDebugMode) {
          console.error(" after Next Step");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        window.location.href = "#step-imprint-app-header";
      },
      startNewImprint() {
        if (this.stepsDebugMode) {
          console.error(" before New Imprint");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        this.initCartState();
        this.step = 4;
        this.store.selectedLastStep[this.store.imprintKey].stepId = 4;
        this.calendarStepInfo[0] = this.stepInfo[2];
        this.calendarStepInfo[0]["navPrevSubText"] = "Choose Product Color and Quantity";
        if (this.stepsDebugMode) {
          console.log(" step - 1 " + (this.step - 1));
          console.warn(this.stepInfo);
        }
      },
      sendUsYourArtworkAfterOrdering() {
        if (this.stepsDebugMode) {
          console.error(" sendUsYourArtworkAfterOrdering");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
        }
        this.initCartState();
        this.step = 5;
        this.store.selectedLastStep[this.store.imprintKey].stepId = 5;
        this.calendarStepInfo[0] = this.stepInfo[3];
        this.calendarStepInfo[0]["navPrevSubText"] = "Choose Product Color and Quantity";
        this.calendarStepInfo[0]["specialInstruction"] = "Send Us Your Artwork After Ordering. \r\n\r\nComment:";
        if (this.store.application_type === "calendar" && this.store.isCustomBundlePage) {
          this.store.disabledAddToCart = this.isCalendarBundleWithoutSelection();
        } else {
          this.store.disabledAddToCart = false;
        }
        if (this.stepsDebugMode) {
          console.log(this.store);
        }
      },
      useMyPreviousArtwork() {
        if (this.stepsDebugMode) {
          console.error(" before useMyPreviousArtwork ");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
          console.log(this.calendarStepInfo);
          console.warn(this.store.isCustomBundlePage);
          console.warn(this.stepInfo);
        }
        this.initCartState();
        this.step = 6;
        this.store.selectedLastStep[this.store.imprintKey].stepId = 6;
        this.calendarStepInfo[0] = this.stepInfo[4];
        this.calendarStepInfo[0]["navPrevSubText"] = "Choose Product Color and Quantity";
        this.calendarStepInfo[0]["specialInstruction"] = "Use My Previous Artwork.\r\n\r\nComment:";
        if (this.store.application_type === "calendar" && this.store.isCustomBundlePage) {
          this.store.disabledAddToCart = this.isCalendarBundleWithoutSelection();
        } else {
          this.store.disabledAddToCart = false;
        }
        if (this.stepsDebugMode) {
          console.error(" after useMyPreviousArtwork ");
          console.log(" step " + this.step);
          console.log(" maxStep " + this.maxStep);
          console.log(" stepInfo >>> ");
          console.log(this.stepInfo);
          console.log(" step - 1 " + (this.step - 1));
        }
      },
      initCartState() {
        axios.get(window.Shopify.routes.root + "cart.js").then(
          (getCart) => {
            if (getCart.data.length) {
              this.cartState = true;
            } else {
              this.cartState = false;
            }
          }
        );
      },
      backToParent() {
        this.step = this.maxStep;
        console.warn("back to parent");
        console.log(this.step);
        console.log(this.stepInfo[this.step - 1]["navPrevSubText"]);
        this.navigateCustomBundle();
        this.store.selectedLastStep[this.store.imprintKey].special_instruction = null;
      },
      setIncrementMinOrderQty() {
        console.error("setIncrementMinOrderQty");
        this.minOrderQty = this.store.inputProductData.minOrderQty;
        this.qtyIncrement = this.store.inputProductData.qtyIncrement;
      },
      setActiveImprintType(id) {
        this.activeImprintTypeID = id;
      },
      validate() {
        console.error("@@@@@@@@@@@@@@@@@@@ this.store.imprintMessageColorLines[this.store.imprintKey] @@@@@@@@@@@@@@@");
        console.warn(this.store.colorSizeLines.length);
        console.warn(this.maxColorCount);
        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.warn(this.store);
        console.warn(this.addToCartSatatus);
        console.warn(this.step);
        console.warn(this.step <= 4);
        let errors = {};
        if (this.step <= 4) {
          if (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 1 || this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 3) {
            this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
              (item, index) => {
                console.log("item.lineMessage.trim().length");
                console.log(item.lineMessage.trim().length);
                console.log(item);
                console.log(!item.selectedColor && !item.lineMessage.trim().length && !errors.length);
                if (item.type !== "image") {
                  if (!item.lineMessage.trim().length) {
                    errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + "Line" + index] = "empty message";
                  }
                  if (!item.selectedColor) {
                    errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + "Line" + index] = "empty color";
                  }
                  if (Object.keys(errors).length) {
                    this.store.disabledAddToCart = true;
                    this.validationResult.hasError = true;
                    this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
                  } else {
                    this.validationResult.hasError = false;
                    this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
                    this.store.disabledAddToCart = true;
                  }
                  console.error("validate");
                  console.log(this.validationResult);
                }
              }
            );
          }
          if (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2) {
            //!this.store.selectedLastStep[this.store.imprintKey].uploaded_image.trim().length
            if (this.store.selectedLastStep[this.store.imprintKey].uploaded_image === null) {
              errors[this.store.selectedLastStep[this.store.imprintKey].imprintTypeID + "uploaded_image"] = "not_uploaded";
              this.validationResult.hasError = true;
              this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
            }
          }
        }
        if (this.step > 4) {
          this.store.disabledAddToCart = true;
        }
        console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
        console.warn(">>>serrors");
        console.warn(errors);
        console.log(Object.keys(errors).length);
        this.errorsRezult = errors;
        return Object.keys(errors).length;
      },
      getLocationSKU(locationTitle) {
        let result = false;
        let selectedImprint = this.store.inputProductData.fullJson.configurable_array[this.store.selectedImprint.sku];
        selectedImprint.configurable_2_data.imprint_position._imprints.forEach((location2) => {
          if (!result) {
            result = location2.title == locationTitle ? location2.sku : false;
          }
        });
        return result;
      },
      prepareImprintDetails() {
        let result = {};
        result["Imprint location"] = this.store.selectedLastStep[this.store.imprintKey].imprintLocation;
        result["_Imprint Method SKU"] = this.store.sku.imprint.method.val;
        if (!this.store.isEnvelopProduct) {
          result["_Imprint Location SKU"] = this.getLocationSKU(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
        }
        result["imprint_lines"] = {};
        result["_colorUpcharge"] = this.store.inputProductData.colorUpcharge;
        result["_sizeUpcharge"] = this.store.inputProductData.sizeUpcharge;
        if (this.store.imprintMessageColorLines[this.store.imprintKey][0].selectedColor != null) {
          this.store.imprintMessageColorLines[this.store.imprintKey].forEach(
            (colorItem, index) => {
              let key = "Line";
              if ((this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 1 || this.store.selectedLastStep[this.store.imprintKey].imprintTypeID === 3) && colorItem.type === "message") {
                key = "Line " + (index + 1);
                let imprintLineKey = "line" + (index + 1);
                result[key + " text"] = colorItem.lineMessage;
                result[key + " color"] = colorItem.selectedColor;
                if (!colorItem.custommColor) {
                  result["_Imprint " + key + " Color SKU"] = colorItem.selectedColorObj.sku;
                }
                result["imprint_lines"][imprintLineKey] = {
                  type: colorItem.custommColor ? "custom_color" : "standard_color",
                  color: colorItem.selectedColor
                };
                result["_colorUpcharge"] = this.store.inputProductData.colorUpcharge;
                result["_sizeUpcharge"] = this.store.inputProductData.sizeUpcharge;
              }
              if (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2 && colorItem.type === "image") {
                key = "line_img";
                result["imprint_lines"][key] = {
                  type: colorItem.custommColor ? "custom_color" : "standard_color",
                  color: colorItem.selectedColor
                };
                result["Add an Image Color"] = colorItem.selectedColor;
                if (result["imprint_lines"][key]["type"] == "standard_color") {
                  result["_Add an Image Color SKU"] = colorItem.selectedColorObj.sku;
                }
              }
            }
          );
        }
        if (this.store.selectedLastStep[this.store.imprintKey].imprintTypeID >= 2 && this.store.selectedLastStep[this.store.imprintKey].uploaded_image) {
          result["Add an Image Filename"] = this.store.selectedLastStep[this.store.imprintKey].uploaded_image.file.name;
          result["_Add an Image Url"] = this.store.selectedLastStep[this.store.imprintKey].uploaded_image.href;
        }
        result["Special Instruction"] = this.store.selectedLastStep[this.store.imprintKey].special_instruction;
        result["_groupID"] = this.currentGroupID;
        result["_qtyIncrement"] = this.store.inputProductData.qtyIncrement;
        if (this.step >= 5) {
          result["_colorUpcharge"] = this.store.inputProductData.colorUpcharge;
          result["_sizeUpcharge"] = this.store.inputProductData.sizeUpcharge;
        }
        console.error("prepareImprintDetails");
        console.warn(result);
        return result;
      },
      generateRandomString(length) {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const charactersLength = characters.length;
        let result = "";
        const randomValues = new Uint32Array(length);
        window.crypto.getRandomValues(randomValues);
        randomValues.forEach((value) => {
          result += characters.charAt(value % charactersLength);
        });
        return result;
      },
      getGroupID() {
        let date = /* @__PURE__ */ new Date();
        let timestamp = date.getTime();
        let randomString = this.generateRandomString(30);
        return timestamp + "_" + randomString;
      },
      lineItemsFeeFormatToCart(lineItemsFeeProperties) {
        let feeFormated = {};
        console.error("START >>>>>>>>>>>lineItemsFeeFormatToCart>>>>>>>>>>>");
        console.log(lineItemsFeeProperties);
        console.warn(this.store.sku);
        if (typeof lineItemsFeeProperties === "object") {
          for (const [key, value] of Object.entries(lineItemsFeeProperties)) {
            console.warn("key ---- ");
            console.warn(key);
            console.warn("value ---- ");
            console.warn(value);
            switch (value["name"]) {
              case "setup_fee":
                feeFormated["Setup Fee"] = Number(value["value"]).toFixed(2);
                feeFormated["_Setup Fee SKU"] = this.store.sku.fee[value["name"]].val;
                break;
              case "proof_fee":
                feeFormated["Proof Fee"] = Number(value["value"]).toFixed(2);
                feeFormated["_Proof Fee SKU"] = this.store.sku.fee[value["name"]].val;
                break;
              case "image_fee":
                feeFormated["Image Fee"] = Number(value["value"]).toFixed(2);
                feeFormated["_Image Fee SKU"] = this.store.sku.fee[value["name"]].val;
                break;
              case "running_fee":
                feeFormated["Running Fee"] = Number(value["value"]).toFixed(2);
                feeFormated["_Running Fee SKU"] = this.store.sku.fee[value["name"]].val;
                break;
              case "custom_colour_fee":
                feeFormated["Custom Colour Fee"] = Number(value["value"]).toFixed(2);
                feeFormated["_Custom Colour Fee SKU"] = this.store.sku.fee[value["name"]].val;
                break;
            }
          }
        }
        console.error(">>>>>>>>>>>lineItemsFeeFormatToCart>>>>>>>>>>> end");
        console.log(feeFormated);
        feeFormated["_groupID"] = this.currentGroupID;
        return feeFormated;
      },
      isCustomerGuest() {
        let result = document.getElementById("customer_id").textContent;
        return !result;
      },
      addToCart() {
        try {
          this.loader = true;
          let date = /* @__PURE__ */ new Date();
          console.error(
            `$$$$$$$$$$$$$ Start js adding to cart script: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}` + date.getTime()
          );
          this._corrId = `ATC-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
          this.addLog({
            type: "debug",
            message: `ATC start corrId=${this._corrId}; appType=${this.store.application_type}; isEnvelop=${!!this.store.isEnvelopProduct}`
          });
          if (this.store.application_type === "calendar" && this.store.isCustomBundlePage) {
            let hasStoreItems = Array.isArray(this.store.calendar.productList) && this.store.calendar.productList.length > 0;
            let hasStorageItems = false;
            try {
              const raw = window.localStorage.getItem("fullStorageProductList") ?? window.localStorage.fullStorageProductList;
              if (raw) {
                const parsed = JSON.parse(raw);
                hasStorageItems = Array.isArray(parsed) && parsed.length > 0;
                if (!hasStoreItems && hasStorageItems) {
                  this.store.calendar.productList = parsed;
                  hasStoreItems = true;
                }
              }
            } catch (e) {
              console.error("fullStorageProductList parse error in addToCart", e);
              hasStorageItems = false;
            }
            if (!hasStoreItems && !hasStorageItems) {
              console.warn("Add to Cart blocked: empty calendar bundle (no items in productList & fullStorageProductList)");
              this.validationResult.hasError = true;
              this.store.disabledAddToCart = true;
              this.loader = false;
              try {
                this.addLog({
                  type: "error",
                  message: `${this._corrId} calendar bundle empty, blocking addToCart (no items)`
                });
              } catch (e) {
                console.error("addLog error (calendar bundle empty)", e);
              }
              return;
            }
          }
          if (this.store.application_type === "default") {
            let totalQty = 0;
            if (this.store.totalSizesQty && this.store.imprintKey in this.store.totalSizesQty) {
              totalQty = this.store.totalSizesQty[this.store.imprintKey];
            } else if (typeof this.store.totalSizesQty === "number") {
              totalQty = this.store.totalSizesQty;
            }
            if (!totalQty || totalQty <= 0) {
              console.warn("Add to Cart blocked: totalSizesQty is 0 for default mode");
              this.validationResult.hasError = true;
              this.store.disabledAddToCart = true;
              this.loader = false;
              try {
                this.addLog({
                  type: "error",
                  message: `${this._corrId} default product qty=0, blocking addToCart`
                });
              } catch (e) {
                console.error("addLog error (default qty=0)", e);
              }
              return;
            }
          }
          if (this.step >= 5) {
            let stepKey = this.store.application_type == "calendar" ? this.step - 2 : this.step - 1;
            this.specialInstruction = this.stepInfo[stepKey].specialInstruction + " " + this.specialInstruction;
            this.store.selectedLastStep[this.store.imprintKey].special_instruction = this.specialInstruction;
            console.error("special");
            console.warn(this.stepInfo[stepKey].specialInstruction);
            console.warn(this.specialInstruction);
            console.warn(this.store.selectedLastStep[this.store.imprintKey].special_instruction);
          }
          let resultv = this.validate();
          console.error("this.validate()");
          console.log(resultv);
          if (this.store.isEnvelopProduct) {
            this.validationResult.hasError = false;
          }
          if (!this.validationResult.hasError) {
            let imprintLinesData = this.prepareImprintDetails();
            let prepareDataToCart = {
              id: this.store.inputProuctIds.mainProductID,
              imprint_lines: imprintLinesData.imprint_lines,
              items: []
            };
            if (this.store.application_type == "default") {
              prepareDataToCart["colorProductID"] = this.store.inputProductData.associatedIds.simples.id_color;
              console.error(">>>>>>>>> STEP 3 lines >>>>>>>>>>>>>>>>>");
              console.warn(this.store.imprintMessageColorLines[this.store.imprintKey]);
              console.log(this.store.selectedLastStep[this.store.imprintKey].imprintLocation);
              console.warn(this.store.colorSizeLines);
              console.error(">>>>>>>>> STEP 3 Lines end >>>>>>>>>>>>>>>>>");
              this.store.colorSizeLines[store.imprintKey].forEach(
                (colorSizeLine) => {
                  console.error("colorSizeLine");
                  console.log(colorSizeLine);
                  for (const prop in colorSizeLine.selectedSizes) {
                    let prepareProperties = {};
                    if (colorSizeLine.selectedSizes[prop]) {
                      let formatedColorName = "";
                      let outputColorName = colorSizeLine.slectedColor.title;
                      if (outputColorName.includes("-")) {
                        var words = outputColorName.split("-");
                        for (let i = 0; i < words.length; i++) {
                          words[i] = words[i][0].toUpperCase() + words[i].slice(1);
                        }
                        formatedColorName = words.join(" ");
                      } else {
                        formatedColorName = outputColorName[0].toUpperCase() + outputColorName.slice(1);
                      }
                      if (this.store.productType != "grouped_plain") {
                        prepareProperties = {
                          "Color": colorSizeLine.slectedColor.title,
                          "Size": prop,
                          "Imprint Method": this.store.selectedImprint.tabName,
                          "_Product name": `${this.store.inputProductData.fullJson.name + " - " + this.renameSize(prop) + " (" + formatedColorName + ")"}`,
                          "_img_src": colorSizeLine.slectedColor.img_src,
                          "_price_details": this.store.prices,
                          "_mainProductId": this.store.inputProuctIds.mainProductID,
                          "_colorId": colorSizeLine.slectedColor.id
                        };
                      } else {
                        prepareProperties = {
                          "Color": colorSizeLine.slectedColor.title,
                          "Imprint Method": this.store.selectedImprint.tabName,
                          "_Product name": this.store.inputProductData.fullJson.name + " - (" + formatedColorName + ")",
                          "_img_src": colorSizeLine.slectedColor.img_src,
                          "_price_details": this.store.prices,
                          "_mainProductId": this.store.inputProuctIds.mainProductID,
                          "_colorId": colorSizeLine.slectedColor.id
                        };
                      }
                      if (this.store.isEnvelopProduct) {
                        prepareProperties.__isEnvelopProduct = true;
                      }
                      prepareProperties._productUrl = window.location.pathname;
                      prepareProperties._runningFeePerItem = this.store.runningFeePerItem;
                      Object.assign(prepareProperties, imprintLinesData);
                      delete prepareProperties.imprint_lines;
                      console.error("????????ColorSku");
                      console.log(colorSizeLine);
                      let colorSkuArr = [];
                      if (colorSizeLine.slectedColor.img_sku) {
                        colorSkuArr = colorSizeLine.slectedColor.img_sku.split("_");
                      }
                      let sizeCode = prop;
                      if (this.store.hasFullSizeNames) {
                        console.warn(">>>>>>>>>>>>>>>>>>>>>>>>>> colorSizeLine.slectedColor");
                        console.log(colorSizeLine.slectedColor);
                        sizeCode = this.store.fullSizeNameToShort[prop];
                      }
                      let prepareSkuBySize = this.store.productType === "grouped_plain" ? colorSizeLine.slectedColor.img_sku : this.store.inputProductData.fullJson.catalog_code + "_" + sizeCode + "_" + colorSkuArr[colorSkuArr.length - 1];
                      console.error("let prepareSkuBySize = this.store.productType === grouped_plain");
                      console.log(prepareSkuBySize);
                      console.warn(this.store.selectedImprint.data.simple_array);
                      console.error("end let prepareSkuBySize = this.store.productType === grouped_plain");
                      if (this.store.selectedImprint.data.simple_array) {
                        prepareProperties["_Product Weight"] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].weight;
                        prepareProperties["_Product Color"] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].color;
                        prepareProperties["_Product SKU"] = this.store.selectedImprint.data.simple_array[prepareSkuBySize].sku;
                      }
                      let prepareProduct = {
                        id: colorSizeLine.slectedColor.id,
                        quantity: colorSizeLine.selectedSizes[prop],
                        properties: prepareProperties,
                        // >>> metaData: optional, need delete for cart
                        metaData: {
                          price: this.store.prices.priceByQty.toFixed(2),
                          productColorID: this.store.inputProductData.associatedIds.simples.id_color,
                          imgID: colorSizeLine.slectedColor.img_id,
                          imgGID: colorSizeLine.slectedColor["img_gid"] ? colorSizeLine.slectedColor["img_gid"] : null,
                          color_sku: prepareSkuBySize,
                          imprint_sku: this.store.selectedImprint.sku,
                          mainProduct_id: this.store.inputProuctIds.mainProductID
                        }
                      };
                      console.error("prepareProduct");
                      console.log(prepareProduct);
                      if (!prepareProduct.metaData.color_sku) {
                        this.addLog({
                          type: "critical",
                          message: `${this._corrId} default-mode item missing color_sku; colorId=${prepareProduct.id}; sizeProp=${prop}`
                        });
                      }
                      prepareDataToCart.items.push(prepareProduct);
                    }
                  }
                }
              );
            } else {
              this.store.calendar.productList.forEach(
                (calendar) => {
                  prepareDataToCart["id"] = this.mainProductID;
                  prepareDataToCart["colorProductID"] = calendar.id;
                  let prepareCalendar = {
                    id: calendar.id,
                    quantity: calendar.qty,
                    properties: {
                      "Is Calendar": "Yes",
                      "Calendar SKU": calendar.calendar_sku,
                      "Imprint Method": this.store.selectedImprint.tabName,
                      "_variant_title": calendar.title,
                      "_variant_title_img": calendar.image,
                      "_Product name": calendar.title,
                      "_Grouped Product name": this.store.inputProductData.fullJson["name"],
                      "_img_src": calendar.image,
                      "_Product SKU": calendar.calendar_sku,
                      "_Product Weight": this.store.selectedImprint.data.simple_array[calendar.calendar_sku].weight,
                      "_mainProductId": calendar.id,
                      "_groupedCalendarId": this.store.inputProuctIds.mainProductID,
                      "_price_details": this.store.prices,
                      "_productUrl": window.location.pathname,
                      "_runningFeePerItem": this.store.runningFeePerItem
                    },
                    // >>> metaData: optional, need delete for cart
                    metaData: {
                      price: calendar.unitPrice.toFixed(2),
                      productColorID: calendar.id,
                      imgID: null,
                      imprint_sku: this.store.selectedImprint.sku,
                      mainProduct_id: calendar.id
                    }
                  };
                  Object.assign(prepareCalendar.properties, imprintLinesData);
                  delete prepareCalendar.properties.imprint_lines;
                  prepareDataToCart.items.push(prepareCalendar);
                }
              );
            }
            console.error("Data for stor");
            console.log(this.store);
            console.log(this.store.colorSizeLines);
            console.error(prepareDataToCart);
            try {
              const sumItems = (prepareDataToCart.items || []).map((i) => {
                var _a, _b;
                return {
                  colorId: i.id,
                  qty: i.quantity,
                  sku: (_a = i.metaData) == null ? void 0 : _a.color_sku,
                  price: (_b = i.metaData) == null ? void 0 : _b.price
                };
              });
              this.addLog({
                type: "debug",
                message: `${this._corrId} BE payload summary: colorProductID=${prepareDataToCart.colorProductID}; items=${sumItems.length}; sample=${JSON.stringify(sumItems.slice(0, 3))}`
              });
            } catch (e) {
              console.error("addLog error (BE payload summary)", e);
            }
            const apiData = {
              "mode": this.store.application_type,
              "associatedFeeID": window.PXUTheme.theme_settings.associated_fee_id,
              "placeholderImageGID": window.PXUTheme.theme_settings.placeholder_image_gid,
              "shop": "mapleleafpromotions",
              "shop_domain": "mapleleafpromotions.myshopify.com",
              "isCustomerGuest": this.store.isCustomerGuest,
              "data": prepareDataToCart
            };
            apiData._corrId = this._corrId;
            if (this.store.isEnvelopProduct) {
              apiData.isEnvelopProduct = true;
            }
            let laravelEnvShop = define_process_env_default.APP_ENV;
            console.error(">>>>>>>>>>>>>>>>>>>>>>>>   laravelEnvShop   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
            console.error(laravelEnvShop);
            let apiBaseUrl = "https://dev.api-customapp.comda.com/";
            if (window.PXUTheme.theme_settings.api_beckend_url) {
              apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
              this.apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
            } else {
              console.error("Please set theme setting: api_beckend_url");
            }
            if (window.PXUTheme.theme_settings.api_shop_domain) {
              let domainStr = window.PXUTheme.theme_settings.api_shop_domain;
              apiData.shop_domain = window.PXUTheme.theme_settings.api_shop_domain;
              apiData.shop = domainStr.replace(".myshopify.com", "");
              console.error("GET Shop domain from theme Settings");
              console.warn(apiData);
            } else {
              console.error("Please set theme setting: api_shop_domain");
            }
            console.error("API base Url !!!!!!!! >>>>>>>>>> !!!!!!!!!!!!! >>>>>>>>>> !!!!!!!!!!!!!!");
            console.log(apiBaseUrl);
            console.warn(window.PXUTheme.theme_settings.api_beckend_url);
            let endpoint = "api/shopify/addtocart";
            this.addToCartSatatus = true;
            console.error("######## STORE state after click on button ADD to cart >>>>>>>>>>>>>>> ");
            console.warn(this.store);
            this.asincAddToCart(apiBaseUrl, endpoint, apiData);
          }
        } catch (e) {
          if (window.PXUTheme.theme_settings.debug_mode) {
            this.store.disabledAddToCart = false;
          }
          this.loader = false;
          console.error(e);
          this.addLog({
            type: "critical",
            message: `${this._corrId} Exception in addToCart(): ${(e == null ? void 0 : e.message) || e}`
          });
        }
      },
      /***
       *
       * @param data {message: "test log from vue", type: "critical|debug|error|etc...", scope: "frontend"}
       * @param endpoint
       */
      addLog(data, endpoint = "api/add-log") {
        data.message = this.currentLocationUrl + " - " + data.message;
        axios.post(this.apiBaseUrl + endpoint, data).then(
          (response) => {
            console.error("Log backend response");
            console.error(response);
          }
        );
      },
      asincAddToCart(apiBaseUrl, endpoint, apiData) {
        let commonFirstSecond = [];
        let first = [];
        let last = [];
        this._atcMetric = { apiBaseUrl, mode: apiData == null ? void 0 : apiData.mode, startedAt: Date.now() };
        trackAtcStart({ apiBaseUrl, flow: "legacy", mode: apiData == null ? void 0 : apiData.mode, corrId: this._corrId, startedAt: this._atcMetric.startedAt });
        axios.post(apiBaseUrl + endpoint, apiData, { headers: { "X-Client-Request-Id": this._corrId } }).then((backendResponse) => {
          console.error("backendResponse222222");
          console.error(backendResponse);
          console.warn(typeof backendResponse.data);
          console.warn(backendResponse.data);
          let lineItems = {};
          if (typeof backendResponse.data == "string") {
            lineItems = this.getJsonResponseFromString(backendResponse.data);
          } else {
            lineItems = backendResponse.data.responesVariantsList;
          }
          if (!lineItems || !lineItems.items) {
            this.addLog({ type: "critical", message: `${this._corrId} Backend response missing items. Raw=${JSON.stringify(backendResponse.data).slice(0, 800)}` });
            throw new Error("Backend payload malformed (no items)");
          }
          if (!lineItems.items.product_fee || !lineItems.items.product_fee.id) {
            this.addLog({ type: "error", message: `${this._corrId} No fee variant id in backend payload.` });
          }
          const nonFee = Object.entries(lineItems.items).filter(([k]) => k !== "product_fee").map(([, v]) => v);
          const missingIds = nonFee.filter((v) => !(v && Number.isInteger(v.id) && v.id > 0));
          if (missingIds.length) {
            this.addLog({ type: "critical", message: `${this._corrId} Some items missing numeric variant id: count=${missingIds.length}; sample=${JSON.stringify(missingIds.slice(0, 3))}` });
          }
          let productFeeProperties = this.lineItemsFeeFormatToCart(lineItems.items.product_fee.properties);
          if (lineItems.items.product_fee.fee_sig) {
            productFeeProperties["_fee_sig"] = lineItems.items.product_fee.fee_sig;
          }
          delete lineItems.items.product_fee.fee_sig;
          lineItems.items.product_fee.properties = productFeeProperties;
          let feeCartLine = [lineItems.items.product_fee];
          let sortedItems = [];
          for (const [key, value] of Object.entries(lineItems.items)) {
            console.warn(typeof key);
            if (key !== "product_fee") {
              sortedItems.push(value);
              console.log(`${key}: ${value}`);
            }
          }
          try {
            const firstIds = (this.cartState ? sortedItems : feeCartLine).map((i) => i.id);
            const lastIds = (this.cartState ? feeCartLine : sortedItems).map((i) => i.id);
            this.addLog({ type: "debug", message: `${this._corrId} Prepared for cart/add.js: first.len=${firstIds.length} last.len=${lastIds.length} first[0..2]=${JSON.stringify(firstIds.slice(0, 3))} last[0..2]=${JSON.stringify(lastIds.slice(0, 3))}` });
          } catch (e) {
          }
          if (this.cartState) {
            first = sortedItems;
            last = feeCartLine;
            this.stepForAddAssociatedFee = "last";
          } else {
            first = feeCartLine;
            this.stepForAddAssociatedFee = "first";
            last = sortedItems;
          }
          commonFirstSecond.push(first);
          commonFirstSecond.push(last);
          console.error("@@@@@@@ Prepeared to cart <<<<<<<<<");
          console.log(Object.assign({}, sortedItems));
          this.setMinQtyToStorage();
          trackAtcStage("backend_ok", this._corrId);
          this.asincAddToCartFirst(first, last);
        }).catch(
          (error) => {
            var _a, _b, _c;
            console.error("this.errors = error.response.data");
            console.log(error);
            let cors = error["code"] == "ERR_NETWORK" ? "CORS" : "";
            let stringError = cors + " error code: " + error["code"] + "; error message: " + error["message"];
            window.dispatchEvent(new CustomEvent("add-to-cart-error", { detail: { message: "The imprint builder ran into an issue. Please reload the page and start again." } }));
            this.reportLegacyAtcResult("failure", "backend", (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status);
            const status = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status;
            const data = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data;
            this.addLog(
              {
                type: "critical",
                message: `${this._corrId} catch error asincAddToCart(); ${stringError}; http=${status}; body=${typeof data === "string" ? data : data ? JSON.stringify(data).slice(0, 800) : "n/a"}`
              }
            );
          }
        );
        return commonFirstSecond;
      },
      asincAddToCartFirst(first, last) {
        try {
          const ids = (first || []).map((i) => i.id);
          this.addLog({ type: "debug", message: `${this._corrId} cart/add.js FIRST -> ids=${JSON.stringify(ids)} len=${ids.length}` });
        } catch (e) {
        }
        axios.post(window.Shopify.routes.root + "cart/add.js", { items: first }, { headers: { "X-Client-Request-Id": this._corrId } }).then(
          (response) => {
            console.warn("Cart Response");
            console.warn(response.data);
            console.error("this.stepForAddAssociatedFee");
            console.log(this.stepForAddAssociatedFee);
            response.data.items.forEach((item) => {
              if (!Object.hasOwn(item.variant_id, this.responsedCartItems)) {
                this.responsedCartItems[item.variant_id] = item;
              }
            });
            trackAtcStage("cart_first_ok", this._corrId);
            this.asincAddToCartSecond(last);
          }
        ).catch(
          (error) => {
            var _a, _b, _c;
            console.error("First this.errors = error.response.data");
            console.log(error);
            let cors = error["code"] == "ERR_NETWORK" ? "CORS" : "";
            let stringError = cors + " error code: " + error["code"] + "; error message: " + error["message"];
            window.dispatchEvent(new CustomEvent("add-to-cart-error", { detail: { message: "The imprint builder ran into an issue. Please reload the page and start again." } }));
            this.reportLegacyAtcResult("failure", "cart_first", (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status);
            const status = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status;
            const data = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data;
            this.addLog({ type: "critical", message: `${this._corrId} catch error asincAddToCartFirst() ${stringError}; http=${status}; body=${typeof data === "string" ? data : data ? JSON.stringify(data).slice(0, 800) : "n/a"}` });
            return null;
          }
        );
      },
      asincAddToCartSecond(last) {
        try {
          const ids = (last || []).map((i) => i.id);
          this.addLog({ type: "debug", message: `${this._corrId} cart/add.js LAST  -> ids=${JSON.stringify(ids)} len=${ids.length}` });
        } catch (e) {
        }
        axios.post(window.Shopify.routes.root + "cart/add.js", { items: last }, { headers: { "X-Client-Request-Id": this._corrId } }).then(
          (response) => {
            if (response) {
              console.error("Last Response");
              console.log(response);
              console.error("this.stepForAddAssociatedFee");
              console.log(this.stepForAddAssociatedFee);
              response.data.items.forEach((item) => {
                if (!Object.hasOwn(item.variant_id, this.responsedCartItems)) {
                  console.log(item);
                  console.log("item +");
                  this.responsedCartItems[item.variant_id] = item;
                }
              });
              this.addToCartSatatus = false;
              this.store.selectedLastStep[this.store.imprintKey].special_instruction = null;
              let date = /* @__PURE__ */ new Date();
              console.error(`$$$$$$$$$$$$$ End js adding to cart script: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}` + date.getTime());
              console.log(" >>>> getFromCart ");
              this.getFromCart();
              localStorage.removeItem("stringProductList");
              localStorage.removeItem("fullStorageProductList");
              if (window.jQuery("#add-to-cart-complited")) {
                window.jQuery("#add-to-cart-complited").trigger("click");
              }
              if (store.isCustomBundlePage) {
                this.store.disabledAddToCart = true;
                this.bundleProductCleared = true;
              } else {
                this.store.disabledAddToCart = false;
              }
              this.currentGroupID = this.getGroupID();
              this.loader = false;
              this.addLog({ type: "debug", message: `${this._corrId} ATC flow finished OK` });
              this.reportLegacyAtcResult("success");
            }
            let self2 = this;
            let maxIteration = 50;
            let counter = 0;
            let timeoutId = setTimeout(function run() {
              counter++;
              console.warn("Counter");
              console.log(counter);
              if (self2.validateCartLocalStorageVariables()) {
                console.error("SetTimeOut if valid");
                console.log(counter);
                console.log(maxIteration);
                clearTimeout(timeoutId);
                window.location.href = "/cart";
              } else if (counter < maxIteration) {
                console.error("SetTimeOut else if");
                console.log(counter);
                console.log(maxIteration);
                setTimeout(run, 100);
              } else {
                console.error("SetTimeOut else");
                console.log(counter);
                console.log(maxIteration);
                this.addLog({ message: "Failed validateCartLocalStorageVariables after " + counter + "iteration", type: "debug" });
                alert("There was an issue with adding the last product to the cart. Please, reload the page and add the product again");
              }
            }, 100);
          }
        ).catch(
          (error) => {
            var _a, _b, _c;
            console.error("Last this.errors = error.response.data");
            console.log(error);
            let cors = error["code"] == "ERR_NETWORK" ? "CORS" : "";
            let stringError = cors + " error code: " + error["code"] + "; error message: " + error["message"];
            window.dispatchEvent(new CustomEvent("add-to-cart-error", { detail: { message: "The imprint builder ran into an issue. Please reload the page and start again." } }));
            this.reportLegacyAtcResult("failure", "cart_second", (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status);
            const status = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status;
            const data = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data;
            this.addLog({ type: "critical", message: `${this._corrId} catch error asincAddToCartSecond(); ${stringError}; http=${status}; body=${typeof data === "string" ? data : data ? JSON.stringify(data).slice(0, 800) : "n/a"}` });
          }
        );
      },
      /** One ATC_RESULT event per legacy add-to-cart attempt (see utils/atcMetric.js). */
      reportLegacyAtcResult(outcome, stage = "", status = "") {
        const m = this._atcMetric;
        if (!m) {
          return;
        }
        this._atcMetric = null;
        reportAtcResult({
          apiBaseUrl: m.apiBaseUrl,
          outcome,
          stage,
          flow: "legacy",
          mode: m.mode,
          corrId: this._corrId,
          startedAt: m.startedAt,
          status
        });
      },
      validateCartLocalStorageVariables() {
        let variablesKeys = ["cartItems", "minQty"];
        let result = 0;
        variablesKeys.forEach((key) => {
          if (localStorage.getItem(key) === null) {
            return false;
          } else {
            let value = JSON.parse(localStorage.getItem(key));
            console.error("validateCartLocalStorageVariables");
            console.error(value);
            if (value) {
              result++;
            }
          }
        });
        return variablesKeys.length === result;
      },
      getJsonResponseFromString(string) {
        let cutKey = "responesVariantsList";
        let indexOfCutKey = string.indexOf(cutKey);
        let cutedData = string.slice(indexOfCutKey, string.length);
        let jsonTypeResponse = '{"' + cutedData;
        let formatedStr = jsonTypeResponse.replace(/\\"\s*W/g, '\\" W').replace(/\\"\s*H/g, '\\" H');
        let jsonResponse = JSON.parse(formatedStr);
        if (cutKey in jsonResponse) {
          return jsonResponse[cutKey];
        } else {
          console.error("Bad response>>: " + jsonResponse);
        }
      },
      setMinQtyToStorage() {
        let minQty = {};
        minQty.minQty = this.store.inputProductData.minOrderQty;
        if (this.store.application_type == "calendar" || this.store.application_type == "calendar_single") {
          minQty.minQty = this.isComda ? 100 : 150;
        }
        minQty.errrorMessage = false;
        let minQtyStorage = JSON.parse(localStorage.getItem("minQty"));
        if (!minQtyStorage) {
          minQtyStorage = {};
        }
        minQtyStorage[this.currentGroupID] = minQty;
        localStorage.setItem("minQty", JSON.stringify(minQtyStorage));
      },
      getFromCart() {
        axios.get(window.Shopify.routes.root + "cart.js").then(
          (response) => {
            console.warn("getFromCart response.data");
            if (response.data) {
              this.cartObject = response.data;
              this.updateCartItemsInCartObject();
            }
            console.warn(response.data);
          }
        );
      },
      updateCartItemsInCartObject() {
        if (this.cartObject.items.length && this.responsedCartItems) {
          console.error("this.cartObject.items.length && this.responsedCartItems.length");
          this.cartObject.items.map(
            (item, index) => {
              console.error("item updateCartItemsInCartObject");
              console.error(item);
              if (!item.image && this.responsedCartItems) {
                this.cartObject.items[index] = this.responsedCartItems[item.variant_id];
              }
            }
          );
          this.cartObject.updated_at = "";
          this.cartObject.updated_at = (/* @__PURE__ */ new Date()).getTime();
          window.miniCart.refreshMiniCart(this.cartObject);
          localStorage.setItem("cartItems", JSON.stringify(this.cartObject));
        }
      },
      checkIsSpecial() {
        return Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
      },
      addNewColorSizeLine() {
        let emptyColorSizeObj = {
          slectedColor: {
            id: null,
            title: "",
            img_src: ""
          },
          selectedSizes: {}
        };
        if (this.store.productType === "grouped_plain") {
          emptyColorSizeObj.selectedSizes.qty = store.prices.tier[1].QtyMin ? store.prices.tier[1].QtyMin : 0;
        }
        this.store.colorSizeLines[store.imprintKey].push(emptyColorSizeObj);
      },
      getProductByHandle(handle) {
        console.error("getProductByHandle>>>");
        console.error(handle);
        axios.get(window.Shopify.routes.root + "products/" + handle + ".js").then(
          (response) => {
            console.error(">>>>>>>>>>>> Product by handle >>>>>>>>>>>");
            console.log(response.data);
            console.log(response.data.type);
            this.setProductType(response.data.type);
            this.store.disableButtonFirsStep = false;
          }
        );
      },
      setProductType(type) {
        this.store.productType = type;
      },
      initMainProductID() {
        let response = null;
        if (window.location.pathname != "/collections/calendar-bundle-custom") {
          response = document.getElementById("current_main_product_id").textContent;
          this.mainProductID = parseInt(response);
          console.error("----- Calendar Bundle page ------");
          console.error(this.applicationType);
        }
        if (this.applicationType == "calendar_single") {
          console.error("----- ???? Calendar Bundle page else if------");
          delete this.stepInfo[1];
          this.stepInfo[2].id = 2;
          response = window.jQuery(".main_product_id")[0].textContent;
          this.mainProductID = parseInt(response);
          this.full_product = this.full_product = JSON.parse(window.jQuery("#full_product_info_json--wall").text());
        }
        if (window.location.pathname == "/collections/calendar-bundle-custom" && this.applicationType !== "calendar_single") {
          console.error("----- Calendar Bundle page only else ------");
          this.store.application_type = "calendar";
          delete this.stepInfo[1];
          this.stepInfo[2].id = 2;
          response = window.jQuery(".main_product_id")[0].textContent;
          this.mainProductID = parseInt(response);
          this.full_product = JSON.parse(window.jQuery(".full_product_info_json-" + this.mainProductID)[0].textContent);
        }
        console.error("mainProductID ^^^^^^^^^^^^^^^^^^^");
        console.warn(this.store);
        console.log(parseInt(response));
        this.full_product_json = JSON.parse(document.getElementById("full_product_info_json").textContent);
        if (this.isCalendarEnvelopProduct()) {
          this.store.isEnvelopProduct = true;
        }
      },
      isCalendarEnvelopProduct() {
        return window.jQuery("#is_calendar_envelop_product").length;
      },
      async getMainProductHandleById(id) {
        let response = null;
        response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
        this.responseProduct = response !== null ? response.data : null;
        this.getProductByHandle(this.responseProduct.resources.results.products[0].handle);
      },
      afterLoadedColors(value) {
        this.maxColorCount = value;
        console.error("event afterLoadedColors");
      },
      afterSetImprintTier(value) {
        console.warn(">>>>>>>>>>>>. !!!!!!! afterSetImprintTier");
        this.store.perItemFee.proof_fee = value.proof_fee;
        this.imprintTierData = value;
        console.log(this.store.perItemFee.proof_fee);
      },
      showAddToCartButton(uploaddedImage) {
        let activeTextTab = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 1 ? true : false;
        let activeImageTab = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 2 ? true : false;
        let activeTextAndImageTab = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID == 3 ? true : false;
        let disabledAddToCart = activeTextTab || activeImageTab || activeTextAndImageTab ? true : false;
        let mesageLineFilled = null;
        this.store.imprintMessageColorLines[this.store.imprintKey].forEach((item) => {
          if (activeTextTab && item.type == "message") {
            disabledAddToCart = true;
            if (item.selectedColor != null && item.lineMessage != "" && mesageLineFilled !== false) {
              disabledAddToCart = false;
            } else {
              disabledAddToCart = true;
              mesageLineFilled = false;
            }
          }
          if (activeImageTab && item.type == "image") {
            disabledAddToCart = true;
            if (item.selectedColor != null && (this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null || uploaddedImage)) {
              disabledAddToCart = false;
            }
          }
          if (activeTextAndImageTab) {
            disabledAddToCart = true;
            if (item.type == "message" && mesageLineFilled !== false) {
              if (item.selectedColor != null && item.lineMessage != "") {
                disabledAddToCart = false;
              } else {
                disabledAddToCart = true;
                mesageLineFilled = false;
              }
            }
            if (item.type == "image" && (uploaddedImage || this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null) && mesageLineFilled != false) {
              disabledAddToCart = true;
              if (item.selectedColor != null) {
                disabledAddToCart = false;
              }
            }
          }
        });
        console.log("validate btn1");
        console.log(this.store.selectedLastStep[this.store.imprintKey]._imprintLocation);
        if (this.store.selectedLastStep[this.store.imprintKey]._imprintLocation["validateMaxLinesByImprintLocation"]) {
          disabledAddToCart = !this.store.selectedLastStep[this.store.imprintKey].imprintLocation["validateMaxLinesByImprintLocation"];
        }
        if (this.store.application_type === "calendar" && this.store.isCustomBundlePage) {
          let bundleIsEmpty = true;
          if (Array.isArray(this.store.calendar.productList) && this.store.calendar.productList.length > 0) {
            bundleIsEmpty = false;
          }
          if (bundleIsEmpty) {
            try {
              const raw = window.localStorage.getItem("fullStorageProductList") ?? window.localStorage.fullStorageProductList;
              if (raw) {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length > 0) {
                  bundleIsEmpty = false;
                  if (!Array.isArray(this.store.calendar.productList) || !this.store.calendar.productList.length) {
                    this.store.calendar.productList = parsed;
                  }
                }
              }
            } catch (e) {
              console.error("fullStorageProductList parse error in showAddToCartButton", e);
              bundleIsEmpty = true;
            }
          }
          if (bundleIsEmpty) {
            console.warn("Calendar bundle is empty – disabling Add to Cart button (showAddToCartButton)");
            disabledAddToCart = true;
          }
        }
        this.store.disabledAddToCart = disabledAddToCart;
      },
      afterNewImprintChanged(data) {
        let value = null;
        let type = null;
        if (typeof data === "object" && Object.hasOwn(data, "type")) {
          value = data.imprintLines;
          type = data.type;
        } else {
          value = data;
        }
        if (type != null) {
          this.validate();
        }
        this.validationResult.hasError = false;
        this.validationResult.imprintType.id = this.store.selectedLastStep[this.store.imprintKey].imprintTypeID;
        this.addToCartSatatus = false;
        this.showAddToCartButton(value.imageUploaded);
        let uniqueColors = [];
        let uniqueCustomColors = [];
        this.store.imprintMessageColorLines[this.store.imprintKey].forEach((item) => {
          if (item.selectedColor !== null && item.custommColor !== true && !uniqueColors.includes(item.selectedColor)) {
            if (this.validationResult.imprintType.id == 1 && item.type !== "image") {
              uniqueColors.push(item.selectedColor);
              this.store.selectedLastStep[this.store.imprintKey].uniqueColors = uniqueColors;
              this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount = uniqueColors.length;
            }
            if (this.validationResult.imprintType.id == 2) {
              if (item.type == "image") {
                uniqueColors.push(item.selectedColor);
                this.store.selectedLastStep[this.store.imprintKey].uniqueColors = uniqueColors;
              }
              this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount = 1;
            }
            if (this.validationResult.imprintType.id == 3) {
              if (item.type != "image" || item.type == "image" && this.store.selectedLastStep[this.store.imprintKey].uploaded_image != null) {
                uniqueColors.push(item.selectedColor);
                this.store.selectedLastStep[this.store.imprintKey].uniqueColors = uniqueColors;
                this.store.selectedLastStep[this.store.imprintKey].uniqueColorsCount = uniqueColors.length;
              }
            }
          }
          if (item.selectedColor !== null && item.custommColor === true && !uniqueCustomColors.includes(item.selectedColor)) {
            uniqueCustomColors.push(item.selectedColor);
          }
        });
        console.error("uniqueColors");
        console.log(uniqueColors);
        if (uniqueColors.length && this.store.perItemFee.setupFee) {
          this.store.setupFee = (uniqueColors.length - 1) * this.store.perItemFee.setupFee;
        }
        if (uniqueColors.length && this.store.perItemFee.running_fee) {
          this.store.prices.running_fee = (uniqueColors.length - 1) * this.store.perItemFee.running_fee;
        }
        console.error("uniqueCustomColors >>>>>>>>>");
        console.log(uniqueCustomColors);
        console.error(uniqueCustomColors.length);
        this.store.customColourFee[this.store.imprintKey] = uniqueCustomColors.length * this.store.perItemFee.customColourFee;
        if (!value.imageUploaded) {
          this.newImprint = value;
          console.error("event new imprint fired");
          console.log(this.store.customColourFee);
          console.error(uniqueCustomColors.length * this.store.perItemFee.customColourFee);
          console.log(this.store.setupFee);
        }
        this.isAddToCartDisabled();
      },
      getColorText(loverCase = false) {
        if (!this.colorText && !this.colorTextUppercase) {
          let result = window.Shopify.country == "US" ? "Color" : "Colour";
          this.colorText = result;
          this.colorTextUppercase = result.toLowerCase();
        }
        return !loverCase ? this.colorText : this.colorTextUppercase;
      },
      initProductsfromCalendarStorage() {
        let prWrPrefix = ".product-main-wrap-";
        this.stepInfo.splice(1, 1);
        this.maxStep = 2;
        console.error("++++++++++++ Calendar STORE +++++++++++++");
        console.log(this.stepInfo);
        if (localStorage.fullStorageProductList && localStorage.fullStorageProductList.length) {
          this.store.calendar.productList = JSON.parse(localStorage.fullStorageProductList);
          this.store.calendar.productList.forEach(
            (calProduct) => {
              console.error("999999999999999999999 Addd Qty El &&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
              console.log(prWrPrefix + calProduct.id + " > .product-info__caption");
              console.warn(window.jQuery(prWrPrefix + calProduct.id + " > .product-info__caption"));
              if (window.jQuery(prWrPrefix + calProduct.id + " > .product-info__caption")) {
                let qtyTag = `<div class='customize-bundle customize-bundle-page__qty'>
                                <span class='customize-bundle__qty-key'>Quantity: </span>
                                <span class='customize-bundle__qty-value'>${calProduct.qty}</span></div>`;
                window.jQuery(window.jQuery(prWrPrefix + calProduct.id + " > .product-info__caption")[0]).append(qtyTag);
              }
            }
          );
        }
      },
      renameSize(size) {
        let sizeNames = {
          "S": "Small",
          "M": "Medium",
          "L": "Large"
        };
        let lastChar = size.slice(-1);
        if (lastChar in sizeNames) {
          if (size.length > 1) {
            size = size.slice(0, -1) + " " + sizeNames[lastChar];
          } else {
            size = sizeNames[lastChar];
          }
        }
        return size;
      },
      getEmail() {
        return window.location.href.includes("comda") ? "artwork@comda.com" : "mlcs@mapleleafpromotions.com";
      },
      disableNextButton() {
        return this.store.totalSizesQty[this.store.selectedImprint.tabName] < this.store.inputProductData.minOrderQty ? true : false;
      },
      onImprintError(e) {
        const d = e.detail || {};
        title.value = d.title ?? title.value;
        message.value = d.message ?? message.value;
        primaryLabel.value = d.primaryLabel ?? "Next Step";
        reloadOnPrimary.value = d.reloadOnPrimary ?? true;
        show.value = true;
      }
    },
    created() {
      this.currentGroupID = this.getGroupID();
      this.store.isCustomerGuest = this.isCustomerGuest();
      if (window.jQuery("#calendar-qty-changed")) {
        window.jQuery("body").on(
          "click",
          "#calendar-qty-changed",
          (event2) => {
            console.log(event2);
            console.warn("Step navigation created hook ");
            if (window.jQuery("#calendar-imprint-common-qty")) {
              console.error(window.jQuery("#calendar-imprint-common-qty").val());
            }
          }
        );
      }
      if (window.PXUTheme.theme_settings.project_store_name && window.Shopify.country) {
        this.store.storeID = window.PXUTheme.theme_settings.project_store_name + "_" + window.Shopify.country.toLowerCase();
      }
      let singleCalendarBundleTag = "no";
      if (document.getElementById("it-is-bundle-product")) {
        console.log("singleCalendarBundleTag>>>>>");
        singleCalendarBundleTag = document.getElementById("it-is-bundle-product").textContent;
        console.log(singleCalendarBundleTag);
        if (singleCalendarBundleTag == "yes") {
          this.store.application_type = "calendar_single";
          this.applicationType = "calendar_single";
        }
      }
      let customBundlePage = "no";
      if (document.getElementById("it-is-bundle-custom-page")) {
        customBundlePage = document.getElementById("it-is-bundle-custom-page").textContent;
        if (customBundlePage == "yes") {
          this.store.isCustomBundlePage = true;
          console.error("++++++++++++ customBundlePage +++++++++++++");
        }
      }
      this.initMainProductID();
      console.error("++++++++++++ Application Type +++++++++++++");
      console.log(this.store.application_type);
      console.log(this.applicationType);
      this.setInventoryStatus();
      if (this.mainProductID !== null) {
        this.getMainProductHandleById(this.mainProductID);
        this.store.inputProuctIds.mainProductID = this.mainProductID;
      }
      if (this.store.application_type == "calendar") {
        this.initProductsfromCalendarStorage();
      }
      if (this.store.application_type == "calendar_single") {
        console.error("++++++++++++ Application Type +++++++++++++");
        console.log(this.store.application_type);
        this.stepInfo.splice(1, 1);
        this.maxStep = 2;
      }
      console.warn("++++++++++++ STORE +++++++++++++");
      console.log(this.store);
      if (localStorage.storageProductList) {
        console.log(localStorage.storageProductList);
        console.error(JSON.parse(localStorage.storageProductList));
        console.warn("++++++++++++ fullStorageProductList +++++++++++++");
        console.error(JSON.parse(localStorage.fullStorageProductList));
      }
      if (!localStorage.getItem("cartItems")) {
        localStorage.removeItem("minQty");
      }
    }
  };
  const _hoisted_1$w = { class: "imprint-nav-wrapper" };
  const _hoisted_2$p = {
    key: 0,
    id: "step-imprint-app-header",
    class: "step-info-header"
  };
  const _hoisted_3$n = { class: "step-info-header__list c-list" };
  const _hoisted_4$m = { key: 0 };
  const _hoisted_5$j = { key: 0 };
  const _hoisted_6$j = { key: 0 };
  const _hoisted_7$h = { key: 0 };
  const _hoisted_8$f = {
    key: 1,
    class: "step-info-header"
  };
  const _hoisted_9$d = { class: "step-info-header__list c-list calendar-bundle" };
  const _hoisted_10$d = { key: 0 };
  const _hoisted_11$d = { class: "imprint-step-content" };
  const _hoisted_12$d = {
    key: 0,
    class: "product-promo-section promo-block"
  };
  const _hoisted_13$c = {
    key: 4,
    class: "btns-wrapper btns--vertical"
  };
  const _hoisted_14$a = {
    key: 6,
    class: "start-new-imprint"
  };
  const _hoisted_15$9 = { class: "start-new-imprint__section imprint-textarea" };
  const _hoisted_16$9 = {
    id: "imprint-types",
    class: "start-new-imprint__textare"
  };
  const _hoisted_17$8 = ["value"];
  const _hoisted_18$8 = {
    key: 7,
    class: "start-new-imprint"
  };
  const _hoisted_19$8 = { class: "start-new-imprint__section imprint-textarea" };
  const _hoisted_20$8 = {
    id: "imprint-types",
    class: "start-new-imprint__textare"
  };
  const _hoisted_21$8 = ["value"];
  const _hoisted_22$7 = {
    key: 8,
    class: "imprint-bottom-info-text"
  };
  const _hoisted_23$5 = {
    key: 9,
    class: "imprint-line"
  };
  const _hoisted_24$5 = {
    key: 2,
    class: "step-nav"
  };
  const _hoisted_25$4 = { key: 0 };
  const _hoisted_26$4 = { class: "c-btn-addtocart-wrap" };
  const _hoisted_27$4 = {
    key: 0,
    class: "loader",
    src: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/opc-ajax-loader.gif",
    alt: "Adding to Cart...",
    title: "Adding to Cart..."
  };
  const _hoisted_28$4 = ["disabled"];
  const _hoisted_29$4 = {
    key: 0,
    class: "modal-mask"
  };
  const _hoisted_30$4 = { class: "modal-container" };
  const _hoisted_31$3 = ["src"];
  function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CTextCard = resolveComponent("CTextCard");
    const _component_ImprintTabs = resolveComponent("ImprintTabs");
    const _component_ColorSizePickerComponent = resolveComponent("ColorSizePickerComponent");
    const _component_PriceMatrixComponent = resolveComponent("PriceMatrixComponent");
    const _component_NewImprintCard = resolveComponent("NewImprintCard");
    const _component_ImprintLocation = resolveComponent("ImprintLocation");
    const _component_CTextCardRequrenmentRules = resolveComponent("CTextCardRequrenmentRules");
    const _component_imprintAppSummary = resolveComponent("imprintAppSummary");
    const _component_RouterView = resolveComponent("RouterView");
    const _component_ErrorModal = resolveComponent("ErrorModal");
    return openBlock(), createElementBlock(Fragment, null, [
      createBaseVNode("div", {
        class: normalizeClass([$options.isOutOfStock ? "out-of-stock-status" : "", "availability-status"])
      }, " Availability: " + toDisplayString($data.inventoryStatus), 3),
      createBaseVNode("div", {
        class: normalizeClass(["imprint-app-wrapper", $data.isComda ? "comda" : "mlp"])
      }, [
        createBaseVNode("div", _hoisted_1$w, [
          $data.applicationType !== "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_2$p, [
            createBaseVNode("ul", _hoisted_3$n, [
              createBaseVNode("li", {
                class: normalizeClass(["c-list__item", [$data.step === 1 ? ["c-list__item-active", $options.customBackground] : ""]])
              }, [
                createBaseVNode("div", null, [
                  _cache[19] || (_cache[19] = createTextVNode(" Step 1 ", -1)),
                  $data.step == 1 ? (openBlock(), createElementBlock("span", _hoisted_4$m, ": Choose Imprint Method")) : createCommentVNode("", true)
                ])
              ], 2),
              $data.store.application_type == "default" ? (openBlock(), createElementBlock("li", {
                key: 0,
                class: normalizeClass(["c-list__item", [$data.step === 2 ? ["c-list__item-active", $options.customBackground] : ""]])
              }, [
                createBaseVNode("div", null, [
                  _cache[20] || (_cache[20] = createTextVNode(" Step 2 ", -1)),
                  $data.step == 2 ? (openBlock(), createElementBlock("span", _hoisted_5$j, ": Product " + toDisplayString($options.getColorText()) + " and Quantity", 1)) : createCommentVNode("", true)
                ])
              ], 2)) : createCommentVNode("", true),
              $data.store.isCustomBundlePage ? (openBlock(), createElementBlock("li", {
                key: 1,
                class: normalizeClass(["c-list__item", [$data.step >= $data.maxStep ? ["c-list__item-active", $options.customBackground] : ""]])
              }, [
                createTextVNode(" Step " + toDisplayString($data.maxStep) + " ", 1),
                $data.step >= $data.maxStep ? (openBlock(), createElementBlock("span", _hoisted_6$j, ": Customize your Product")) : createCommentVNode("", true)
              ], 2)) : createCommentVNode("", true),
              !$data.store.isCustomBundlePage ? (openBlock(), createElementBlock("li", {
                key: 2,
                class: normalizeClass(["c-list__item", [$data.step >= 3 ? ["c-list__item-active", $options.customBackground] : ""]])
              }, [
                createBaseVNode("div", null, [
                  createTextVNode(" Step " + toDisplayString($data.maxStep) + " ", 1),
                  $data.step >= 3 ? (openBlock(), createElementBlock("span", _hoisted_7$h, ": Customize your Product")) : createCommentVNode("", true)
                ])
              ], 2)) : createCommentVNode("", true)
            ])
          ])) : createCommentVNode("", true),
          $data.isComda && $data.applicationType == "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_8$f, [
            createBaseVNode("ul", _hoisted_9$d, [
              createBaseVNode("li", {
                class: normalizeClass(["c-list__item", [$data.step === 1 ? ["c-list__item-active", $options.customBackground] : ""]])
              }, [
                createBaseVNode("div", null, [
                  _cache[21] || (_cache[21] = createTextVNode(" Step 1 ", -1)),
                  $data.step == 1 ? (openBlock(), createElementBlock("span", _hoisted_10$d, ": Choose Imprint Method")) : createCommentVNode("", true)
                ])
              ], 2)
            ])
          ])) : createCommentVNode("", true),
          createBaseVNode("div", _hoisted_11$d, [
            $options.showTextCard ? (openBlock(), createBlock(_component_CTextCard, {
              key: 0,
              cStep: $data.step,
              textCardTitle: $data.stepInfo[$data.step - 1].textCardTitle,
              textCardBody: $data.stepInfo[$data.step - 1].textCardBody,
              additionalText: $data.stepInfo[$data.step - 1].additionalText,
              onBackToParent: $options.backToParent,
              isCustomBundlePage: false
            }, null, 8, ["cStep", "textCardTitle", "textCardBody", "additionalText", "onBackToParent"])) : createCommentVNode("", true),
            $data.store.isCustomBundlePage ? (openBlock(), createBlock(_component_CTextCard, {
              key: 1,
              cStep: $data.step,
              textCardTitle: $data.calendarStepInfo[0].textCardTitle ? $data.calendarStepInfo[0].textCardTitle : "",
              textCardBody: $data.calendarStepInfo[0].textCardBody,
              additionalText: $data.calendarStepInfo[0].additionalText,
              onBackToParent: $options.backToParent,
              isCustomBundlePage: true
            }, null, 8, ["cStep", "textCardTitle", "textCardBody", "additionalText", "onBackToParent"])) : createCommentVNode("", true),
            $data.step == 1 ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createVNode(_component_ImprintTabs, {
                onInitedQtyIncrement: $options.setIncrementMinOrderQty,
                onTabsStatus: _cache[0] || (_cache[0] = ($event) => $data.activeTabCalendarBundle = $event),
                onImprintTierSeted: $options.afterSetImprintTier,
                getColorText: $options.getColorText,
                applicationType: $data.applicationType,
                textCardTitle: $data.calendarStepInfo[0].textCardTitle ? $data.calendarStepInfo[0].textCardTitle : ""
              }, null, 8, ["onInitedQtyIncrement", "onImprintTierSeted", "getColorText", "applicationType", "textCardTitle"]),
              $data.applicationType != "calendar_single" && !$data.isComda && !$data.store.isCustomBundlePage ? (openBlock(), createElementBlock("div", _hoisted_12$d, [..._cache[22] || (_cache[22] = [
                createStaticVNode('<div class="promo-label promo-label--vue"><span>pricing made easy!</span></div><div class="promo-text promo-text--vue"><span><p style="margin:0;"> All-in pricing, no added fees, <span class="green-bold">Free Shipping.</span></p> We’ve made it <span class="green-bold">easy</span> for you to fit any budget! </span></div>', 2)
              ])])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true),
            $data.step == 2 && $data.maxStep !== 2 ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.store.colorSizeLines[$data.store.imprintKey], (line, index) => {
                return openBlock(), createBlock(_component_ColorSizePickerComponent, {
                  key: index,
                  "line-index": index,
                  "removed-line": _ctx.removedLineIndex,
                  onColorLoaded: $options.afterLoadedColors,
                  getColorText: $options.getColorText
                }, null, 8, ["line-index", "removed-line", "onColorLoaded", "getColorText"]);
              }), 128)),
              $data.store.colorSizeLines[$data.store.imprintKey].length < $data.maxColorCount ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["imprint-message__add add-color", $options.customColor]),
                style: normalizeStyle($data.step === 2 ? "" : ""),
                onClick: _cache[1] || (_cache[1] = (...args) => $options.addNewColorSizeLine && $options.addNewColorSizeLine(...args))
              }, [
                _cache[23] || (_cache[23] = createBaseVNode("span", { class: "plus" }, "+", -1)),
                createBaseVNode("span", null, "Add a New " + toDisplayString($options.getColorText()), 1)
              ], 6)) : createCommentVNode("", true),
              _cache[24] || (_cache[24] = createBaseVNode("p", { style: { "border-bottom": "2px solid rgb(215, 215, 215)", "margin": "0" } }, null, -1)),
              createVNode(_component_PriceMatrixComponent, {
                applicationType: $data.applicationType,
                isSpecial: $options.checkIsSpecial
              }, null, 8, ["applicationType", "isSpecial"])
            ], 64)) : createCommentVNode("", true),
            $options.isImprintStepShow($data.step) ? (openBlock(), createElementBlock("div", _hoisted_13$c, [
              createBaseVNode("button", {
                class: normalizeClass(["btns__item", $options.customBackgroundHover]),
                onClick: _cache[2] || (_cache[2] = (...args) => $options.startNewImprint && $options.startNewImprint(...args))
              }, "Start New Imprint", 2),
              createBaseVNode("button", {
                class: normalizeClass(["btns__item", $options.customBackgroundHover]),
                onClick: _cache[3] || (_cache[3] = (...args) => $options.sendUsYourArtworkAfterOrdering && $options.sendUsYourArtworkAfterOrdering(...args))
              }, "Send Us Your Artwork After Ordering", 2),
              _cache[25] || (_cache[25] = createBaseVNode("p", null, "Are you a Returning Customer?", -1)),
              createBaseVNode("button", {
                class: normalizeClass(["btns__item", $options.customBackgroundHover]),
                onClick: _cache[4] || (_cache[4] = (...args) => $options.useMyPreviousArtwork && $options.useMyPreviousArtwork(...args))
              }, "Use My Previous Artwork", 2)
            ])) : createCommentVNode("", true),
            $data.step == 4 && !$data.store.isEnvelopProduct ? (openBlock(), createBlock(_component_NewImprintCard, {
              key: 5,
              onStepFourChange: $options.afterNewImprintChanged,
              validation: $data.validationResult,
              validateDetails: $data.addToCartBtnStatus,
              getColorText: $options.getColorText
            }, null, 8, ["onStepFourChange", "validation", "validateDetails", "getColorText"])) : createCommentVNode("", true),
            $data.step == 5 && !$data.store.isEnvelopProduct ? (openBlock(), createElementBlock("div", _hoisted_14$a, [
              createVNode(_component_ImprintLocation, { "c-step": $data.step }, null, 8, ["c-step"]),
              createBaseVNode("div", _hoisted_15$9, [
                _cache[26] || (_cache[26] = createBaseVNode("label", {
                  class: "start-new-imprint__label",
                  for: "imprint-types"
                }, "Special Instruction", -1)),
                createBaseVNode("div", _hoisted_16$9, [
                  createBaseVNode("textarea", {
                    class: "c-full-width",
                    name: "",
                    id: "step-5",
                    cols: "30",
                    rows: "10",
                    value: this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : $data.specialInstruction,
                    onChange: _cache[5] || (_cache[5] = ($event) => $options.setSpecialInstruction($event.target.value))
                  }, "                            ", 40, _hoisted_17$8)
                ])
              ])
            ])) : createCommentVNode("", true),
            $data.step == 6 && !$data.store.isEnvelopProduct ? (openBlock(), createElementBlock("div", _hoisted_18$8, [
              createVNode(_component_ImprintLocation, { "c-step": $data.step }, null, 8, ["c-step"]),
              createBaseVNode("div", _hoisted_19$8, [
                createBaseVNode("label", {
                  class: normalizeClass(["start-new-imprint__label", $options.customFont]),
                  for: "imprint-types"
                }, "Special Instruction", 2),
                createBaseVNode("div", _hoisted_20$8, [
                  createBaseVNode("textarea", {
                    class: "c-full-width",
                    name: "",
                    id: "step-6",
                    cols: "30",
                    rows: "10",
                    value: this.store.selectedLastStep[this.store.imprintKey].special_instruction ? this.store.selectedLastStep[this.store.imprintKey].special_instruction : $data.specialInstruction,
                    onChange: _cache[6] || (_cache[6] = ($event) => $options.setSpecialInstruction($event.target.value))
                  }, "                                ", 40, _hoisted_21$8)
                ])
              ])
            ])) : createCommentVNode("", true),
            $data.step < 3 && !$data.store.isCustomBundlePage && $data.store.application_type != "calendar" && $data.store.application_type != "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_22$7, [
              createVNode(_component_CTextCardRequrenmentRules, {
                "c-step": $data.step,
                "tab-name": this.store.imprintKey
              }, null, 8, ["c-step", "tab-name"])
            ])) : createCommentVNode("", true),
            $data.step == 2 && $data.store.isCustomBundlePage ? (openBlock(), createElementBlock("div", _hoisted_23$5)) : createCommentVNode("", true)
          ]),
          $data.applicationType !== "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_24$5, [
            createBaseVNode("ul", {
              class: normalizeClass(["step-nav__list step-nav__list--imprint", $data.store.totalSizesQty < $data.store.inputProductData.minOrderQty && $data.step == 2 ? "imprint-nav-next--disabled" : ""])
            }, [
              $data.isComda && $data.step === 1 ? (openBlock(), createElementBlock("li", _hoisted_25$4, [
                createBaseVNode("div", {
                  class: "modal-btn",
                  onClick: _cache[7] || (_cache[7] = ($event) => $data.showModal = true)
                }, " How to order with COMDA.COM ")
              ])) : createCommentVNode("", true),
              createBaseVNode("li", {
                class: normalizeClass(["step-nav__item", [$data.step !== 1 ? "step-nav__item--prev" : "", $options.customColorBefore]])
              }, [
                createBaseVNode("div", {
                  class: "c-btn c-btn--imprint-nav c-btn--imprint-nav-left",
                  onClick: _cache[10] || (_cache[10] = (...args) => $options.prev && $options.prev(...args)),
                  onKeyup: _cache[11] || (_cache[11] = withKeys((...args) => $options.prev && $options.prev(...args), ["enter"]))
                }, [
                  $data.step !== 1 ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass(["imprint-nav__text nav-step", "imprint-nav__text--main", $options.customColor]),
                    tabindex: "0",
                    onClick: _cache[8] || (_cache[8] = ($event) => $event.target.blur()),
                    onKeyup: _cache[9] || (_cache[9] = withKeys(($event) => $event.target.blur(), ["enter"]))
                  }, " Previous Step ", 34)) : createCommentVNode("", true),
                  !$data.store.isCustomBundlePage ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    $data.step !== 1 ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass(["imprint-nav__text", "imprint-nav__text--sub", $options.customColor])
                    }, toDisplayString($data.stepInfo[$data.step - 1].navPrevSubText), 3)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true),
                  $data.store.isCustomBundlePage ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                    $data.step !== 1 ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass(["imprint-nav__text", "imprint-nav__text--sub", $options.customColor])
                    }, toDisplayString($data.calendarStepInfo[0].navPrevSubText), 3)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true)
                ], 32)
              ], 2),
              $data.step < 3 && $data.step != $data.maxStep ? (openBlock(), createElementBlock("li", {
                key: 1,
                class: normalizeClass(["step-nav__item", [$data.step < 3 ? "step-nav__item--next" : "", $options.customColorAfter, $options.disableNextButton() && $data.step == 2 || $data.step == 1 && $data.store.disableButtonFirsStep || $data.activeTabCalendarBundle == null ? "disabled" : ""]])
              }, [
                createBaseVNode("div", {
                  class: normalizeClass(["c-btn c-btn--imprint-nav c-btn--imprint-nav-right", $options.disableNextButton() && $data.step == 2 || this.store.qtyError && $data.step == 2 || $data.step == 1 && $data.store.disableButtonFirsStep || $data.activeTabCalendarBundle == null ? "c-btn--imprint-nav--disabled" : ""]),
                  onClick: _cache[14] || (_cache[14] = (...args) => $options.next && $options.next(...args)),
                  onKeyup: _cache[15] || (_cache[15] = withKeys((...args) => $options.next && $options.next(...args), ["enter"]))
                }, [
                  $data.step < 3 && $data.step != $data.maxStep ? (openBlock(), createElementBlock("span", {
                    key: 0,
                    class: normalizeClass(["imprint-nav__text nav-step", "imprint-nav__text--main", $options.customColor]),
                    tabindex: "0",
                    onClick: _cache[12] || (_cache[12] = ($event) => $event.target.blur()),
                    onKeyup: _cache[13] || (_cache[13] = withKeys(($event) => $event.target.blur(), ["enter"]))
                  }, " Next Step ", 34)) : createCommentVNode("", true),
                  !$data.store.isCustomBundlePage ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    $data.step < 3 && $data.step != $data.maxStep ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass(["imprint-nav__text", "imprint-nav__text--sub", $options.customColor])
                    }, toDisplayString($data.stepInfo[$data.step - 1].navNextSubText), 3)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true),
                  $data.store.isCustomBundlePage ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                    $data.step < 3 && $data.step != $data.maxStep ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass(["imprint-nav__text", "imprint-nav__text--sub", $options.customColor])
                    }, toDisplayString($data.calendarStepInfo[0].navNextSubText), 3)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true)
                ], 34)
              ], 2)) : createCommentVNode("", true),
              $data.step >= 4 ? (openBlock(), createElementBlock("li", {
                key: 2,
                class: normalizeClass(["step-nav__item", $data.step == 3 ? "step-nav__item--add-to-cart" : ""])
              }, [
                createBaseVNode("div", _hoisted_26$4, [
                  $data.loader ? (openBlock(), createElementBlock("img", _hoisted_27$4)) : createCommentVNode("", true),
                  createBaseVNode("button", {
                    class: normalizeClass(["c-btn c-btn--add-to-cart", [
                      $data.addToCartBtnStatus && $data.step < 5 || $data.store.disabledAddToCart || $options.isOutOfStock ? "btn-disabled" : "",
                      $options.customBackground,
                      $options.customBackgroundHover
                    ]]),
                    disabled: $data.store.isCustomBundlePage && $data.bundleProductCleared || $data.store.disabledAddToCart || $options.isOutOfStock ? "disabled" : false,
                    onClick: _cache[16] || (_cache[16] = (...args) => $options.addToCart && $options.addToCart(...args))
                  }, " Add to cart ", 10, _hoisted_28$4)
                ])
              ], 2)) : createCommentVNode("", true)
            ], 2)
          ])) : createCommentVNode("", true)
        ]),
        createVNode(_component_imprintAppSummary, {
          "new-imprint": $data.newImprint,
          "new-tier-data": $data.imprintTierData,
          step: $data.step,
          "application-type": $data.store.application_type,
          "is-out-of-stock": $options.isOutOfStock
        }, null, 8, ["new-imprint", "new-tier-data", "step", "application-type", "is-out-of-stock"])
      ], 2),
      createVNode(Transition, null, {
        default: withCtx(() => [
          $data.showModal ? (openBlock(), createElementBlock("div", _hoisted_29$4, [
            createBaseVNode("div", _hoisted_30$4, [
              createBaseVNode("img", {
                src: $data.imageHowToOrder,
                alt: ""
              }, null, 8, _hoisted_31$3),
              createBaseVNode("div", {
                class: "modal-close-btn",
                onClick: _cache[17] || (_cache[17] = ($event) => $data.showModal = false)
              }, "X")
            ])
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      }),
      createBaseVNode("template", null, [
        createVNode(_component_RouterView),
        createVNode(_component_ErrorModal, {
          modelValue: _ctx.show,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => _ctx.show = $event),
          title: _ctx.title,
          message: _ctx.message,
          "primary-label": _ctx.primaryLabel,
          "reload-on-primary": _ctx.reloadOnPrimary
        }, null, 8, ["modelValue", "title", "message", "primary-label", "reload-on-primary"])
      ])
    ], 64);
  }
  const StepNavigstion = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$s]]);
  function getSections(applicationType = "default") {
    if (applicationType === "calendar_single") {
      console.log("[getSections] Calendar single: returning empty sections array");
      return [];
    }
    const baseSections = [
      {
        id: "colourQuantity",
        label: `Step 1:  ${getColorName()} & Quantity`,
        meta: null,
        isAlwaysOpen: false,
        isInitiallyOpen: true,
        requiresPrevious: false,
        // Hide for calendar modes
        hidden: applicationType === "calendar" || applicationType === "calendar_single",
        description: `Choose a product variety below to enter your desired quantities. You can mix and match different styles to complete your order.`
      },
      {
        id: "imprintSelection",
        label: applicationType === "calendar" || applicationType === "calendar_single" ? "Step 1: Customize Your Product" : "Step 2: Customize Your Product",
        // Step 2 for default
        meta: null,
        isAlwaysOpen: false,
        isInitiallyOpen: applicationType === "calendar" || applicationType === "calendar_single",
        requiresPrevious: applicationType === "default",
        // Only required for default,
        description: "section 2 Description "
      },
      {
        id: "addons",
        label: applicationType === "calendar" || applicationType === "calendar_single" ? "Step 2: Add-Ons (Optional)" : "Step 3: Add-Ons (Optional)",
        meta: "Optional",
        isAlwaysOpen: false,
        isInitiallyOpen: false,
        requiresPrevious: false,
        description: "section 3 Description "
      },
      {
        id: "review",
        label: applicationType === "calendar" || applicationType === "calendar_single" ? "Step 2: Review & Add to Cart" : "Step 3: Review & Add to Cart",
        meta: null,
        isAlwaysOpen: false,
        isInitiallyOpen: false,
        requiresPrevious: true,
        description: "section 4 Description "
      }
    ];
    return baseSections.filter((section) => !section.hidden);
  }
  getSections("default");
  getSections("calendar");
  getSections("calendar_single");
  function getColorName(lowercase = false) {
    const hostname = window.location.hostname;
    const isCanada = hostname.includes(".ca") || hostname.includes("-ca") || hostname.includes("ca.");
    const word = isCanada ? "Colour" : "Color";
    return lowercase ? word.toLowerCase() : word;
  }
  function getAvailablePrintMethods(configurableArray, selectedSkus) {
    const available = [];
    console.log("[🔍 DEBUG] getAvailablePrintMethods called");
    if (!configurableArray) {
      console.error("[🔍 DEBUG] configurableArray is null/undefined!");
      return available;
    }
    if (!selectedSkus || selectedSkus.length === 0) {
      console.warn("[🔍 DEBUG] selectedSkus is empty, returning all methods as available");
      return Object.keys(configurableArray);
    }
    Object.keys(configurableArray).forEach((methodKey) => {
      var _a;
      const method = configurableArray[methodKey];
      console.log("[🔍 DEBUG] Checking method:", methodKey);
      console.log("[🔍 DEBUG] method.associated_sku:", method.associated_sku);
      const methodSKUs = ((_a = method.associated_sku) == null ? void 0 : _a.map((item) => item.sku)) || [];
      console.log("[🔍 DEBUG] methodSKUs for", methodKey, ":", methodSKUs);
      const allPresent = selectedSkus.every((sku) => {
        const found = methodSKUs.includes(sku);
        console.log("[🔍 DEBUG] Checking if", sku, "is in", methodKey, ":", found);
        return found;
      });
      console.log("[🔍 DEBUG] Method", methodKey, "supports all SKUs:", allPresent);
      if (allPresent) {
        available.push(methodKey);
      }
    });
    console.log("[🔍 DEBUG] Final available methods:", available);
    return available;
  }
  function validateCalendarBundle(configurableArray, calendarProducts) {
    console.log("[🔍 DEBUG] validateCalendarBundle called");
    console.log("[🔍 DEBUG] calendarProducts:", calendarProducts);
    const result = {
      isValid: false,
      availableMethods: [],
      selectedSkus: [],
      errorMessage: null
    };
    result.selectedSkus = calendarProducts.map((product) => {
      console.log("[🔍 DEBUG] Product:", product.title, "calendar_sku:", product.calendar_sku);
      return product.calendar_sku;
    }).filter((sku) => sku);
    console.log("[🔍 DEBUG] Extracted selectedSkus:", result.selectedSkus);
    if (result.selectedSkus.length === 0) {
      console.warn("[🔍 DEBUG] No SKUs found, returning all methods as valid");
      result.availableMethods = Object.keys(configurableArray || {});
      result.isValid = result.availableMethods.length > 0;
      return result;
    }
    result.availableMethods = getAvailablePrintMethods(configurableArray, result.selectedSkus);
    result.isValid = result.availableMethods.length > 0;
    if (!result.isValid) {
      result.errorMessage = "Unfortunately, one or more calendar titles in your bundle cannot be ordered together. Please remove one or more titles and try again.";
    }
    console.log("[🔍 DEBUG] validateCalendarBundle result:", result);
    return result;
  }
  function isSalePriceActive(tier) {
    if (!tier || tier.sale_price === void 0 || !tier.sale_price_effectivedate || !tier.sale_price_terminationdate) {
      return false;
    }
    const now = /* @__PURE__ */ new Date();
    const effectiveDate = new Date(tier.sale_price_effectivedate);
    const terminationDate = new Date(tier.sale_price_terminationdate);
    const active = now >= effectiveDate && now <= terminationDate;
    console.log("[calendarPricing] isSalePriceActive:", {
      now: now.toISOString(),
      effectiveDate: effectiveDate.toISOString(),
      terminationDate: terminationDate.toISOString(),
      active
    });
    return active;
  }
  const useCalendarStore = /* @__PURE__ */ defineStore("calendar", {
    state: () => ({
      // Product list loaded from localStorage
      products: [],
      // Quantity per product (key: product.id, value: qty)
      quantities: {},
      // Validation state
      isValid: false,
      // Loading state
      isLoading: false,
      // Error messages
      errors: [],
      // ========== CALENDAR BUNDLE COMPATIBILITY ==========
      // Available print methods that support ALL selected calendars
      availablePrintMethods: [],
      // Active tab index for calendar bundle (null if no available methods)
      activeTabForCalendarBundle: null
    }),
    getters: {
      /**
       * Get total quantity across all calendar products
       */
      totalQuantity(state) {
        return state.products.reduce((sum, product) => {
          return sum + (state.quantities[product.id] || 0);
        }, 0);
      },
      /**
       * Check if bundle compatibility check is required
       * Only for calendar application type
       */
      isBundleCheckRequired() {
        const appStore = useAppStore();
        console.log("[🔍 DEBUG CalendarStore] isBundleCheckRequired - applicationType:", appStore.applicationType);
        return appStore.applicationType === "calendar";
      },
      /**
       * Check if bundle has compatibility issues (no available print methods)
       */
      hasBundleCompatibilityError(state) {
        const hasError = this.isBundleCheckRequired && state.availablePrintMethods.length === 0 && state.products.length > 0;
        console.log("[🔍 DEBUG CalendarStore] hasBundleCompatibilityError:", hasError, {
          isBundleCheckRequired: this.isBundleCheckRequired,
          availablePrintMethodsLength: state.availablePrintMethods.length,
          productsLength: state.products.length
        });
        return hasError;
      },
      /**
       * Calculate unit price based on total quantity using tier pricing
       * For calendar bundles - takes pricing from selected imprint method
       */
      unitPriceByTotalQty() {
        var _a, _b, _c, _d;
        const totalQty = this.totalQuantity;
        const appStore = useAppStore();
        const imprintStore = useImprintStore();
        console.log("[🎯 CALENDAR-PRICING] === START ===");
        console.log("[🎯 CALENDAR-PRICING] totalQty:", totalQty);
        if (!appStore.full_product_json) {
          console.error("[🎯 CALENDAR-PRICING] ❌ full_product_json is NULL!");
          return 0;
        }
        let tierPrices = [];
        const selectedMethodSku = (_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        console.log("[🎯 CALENDAR-PRICING] Selected imprint method SKU:", selectedMethodSku);
        if (selectedMethodSku && ((_c = (_b = appStore.full_product_json) == null ? void 0 : _b.configurable_array) == null ? void 0 : _c[selectedMethodSku])) {
          const methodData = appStore.full_product_json.configurable_array[selectedMethodSku];
          tierPrices = ((_d = methodData.prices_2) == null ? void 0 : _d.tier_price) || [];
          console.log("[🎯 CALENDAR-PRICING] ✅ Found tier prices in imprint method:", selectedMethodSku);
          console.log("[🎯 CALENDAR-PRICING] tierPrices:", tierPrices);
        } else {
          console.error("[🎯 CALENDAR-PRICING] ❌ No imprint method selected or no tier prices!");
          console.error("[🎯 CALENDAR-PRICING] selectedMethodSku:", selectedMethodSku);
        }
        if (totalQty < 1 || isNaN(totalQty)) {
          console.error("[🎯 CALENDAR-PRICING] ❌ Invalid totalQty:", totalQty);
          return 0;
        }
        if (!Array.isArray(tierPrices) || tierPrices.length === 0) {
          console.error("[🎯 CALENDAR-PRICING] ❌ No tier prices found!");
          console.error("[🎯 CALENDAR-PRICING] Check: imprint method selected AND prices_2.tier_price exists");
          return 0;
        }
        if (!tierPrices[0] || typeof tierPrices[0].price === "undefined") {
          console.error("[🎯 CALENDAR-PRICING] ❌ First tier has no price!");
          return 0;
        }
        let priceByQty = Number(tierPrices[0].price || 0);
        if (isNaN(priceByQty)) {
          console.error("[🎯 CALENDAR-PRICING] ❌ First tier price is NaN!");
          return 0;
        }
        console.log("[🎯 CALENDAR-PRICING] Default price (first tier):", priceByQty);
        const sortedTiers = [...tierPrices].filter((tier) => tier.QtyMin !== "MSRP").sort((a, b) => Number(b.QtyMin || 0) - Number(a.QtyMin || 0));
        console.log("[🎯 CALENDAR-PRICING] Sorted tiers:", sortedTiers.map((t) => ({
          QtyMin: t.QtyMin,
          price: t.price
        })));
        let foundTier = false;
        let matchedTier = null;
        for (const tier of sortedTiers) {
          const tierMin = Number(tier.QtyMin || 0);
          if (Number(totalQty) >= tierMin) {
            foundTier = true;
            matchedTier = tier;
            const regularPrice = Number(tier.price || 0);
            if (!isNaN(regularPrice)) {
              priceByQty = regularPrice;
              console.log("[🎯 CALENDAR-PRICING] ✅ Found tier: QtyMin=" + tier.QtyMin + ", price=" + priceByQty);
            }
            break;
          }
        }
        const b2bTiers = selectedMethodSku ? appStore.getB2BTierForSku(selectedMethodSku) : null;
        if (b2bTiers) {
          const sortedB2b = [...b2bTiers].sort((a, b) => parseFloat(a.QtyMin || 0) - parseFloat(b.QtyMin || 0));
          let b2bEntry = null;
          sortedB2b.forEach((t) => {
            if (Number(totalQty) >= parseFloat(t.QtyMin || 0)) b2bEntry = t;
          });
          if (b2bEntry) {
            const b2bPrice = parseFloat(b2bEntry.price);
            if (!isNaN(b2bPrice)) {
              console.log("[🎯 CALENDAR-PRICING] ✅ B2B price active. Using b2b price:", b2bPrice, "(was:", priceByQty, ")");
              return b2bPrice;
            }
          }
        }
        if (matchedTier && isSalePriceActive(matchedTier)) {
          const salePrice = Number(matchedTier.sale_price);
          if (!isNaN(salePrice)) {
            console.log("[🎯 CALENDAR-PRICING] ✅ Sale price active. Using sale_price:", salePrice, "(was:", priceByQty, ")");
            priceByQty = salePrice;
          }
        }
        if (!foundTier) {
          console.warn("[🎯 CALENDAR-PRICING] ⚠️ No matching tier for qty:", totalQty);
        }
        if (isNaN(priceByQty)) {
          console.error("[🎯 CALENDAR-PRICING] ❌ FINAL PRICE IS NaN!");
          return 0;
        }
        console.log("[🎯 CALENDAR-PRICING] === FINAL PRICE:", priceByQty, "===");
        return priceByQty;
      },
      /**
       * Get products with quantities merged and calculated unit price
       * CRITICAL: Always calculates unitPrice dynamically from tier pricing
       */
      productsWithQuantities(state) {
        const tierUnitPrice = this.unitPriceByTotalQty;
        return state.products.map((product) => {
          const { unitPrice: oldPrice, ...productWithoutPrice } = product;
          return {
            ...productWithoutPrice,
            qty: state.quantities[product.id] || 0,
            unitPrice: tierUnitPrice
            // Always use calculated price
          };
        });
      },
      /**
       * Check if meets minimum quantity requirement
       */
      meetsMinimumQuantity() {
        const appStore = useAppStore();
        const minQty = appStore.getMinOrderQty;
        return this.totalQuantity >= minQty;
      },
      /**
       * Get validation errors
       */
      validationErrors(state) {
        const errors = [];
        const appStore = useAppStore();
        const minQty = appStore.getMinOrderQty;
        if (this.totalQuantity < minQty) {
          errors.push(`Minimum order quantity is ${minQty}. Current total: ${this.totalQuantity}`);
        }
        const productsWithNoQty = state.products.filter((p2) => !state.quantities[p2.id] || state.quantities[p2.id] === 0);
        if (productsWithNoQty.length > 0) {
          errors.push(`Please set quantity for all selected calendars (${productsWithNoQty.length} calendar(s) have no quantity)`);
        }
        return errors;
      },
      /**
       * Check if any products loaded
       */
      hasProducts(state) {
        return state.products.length > 0;
      }
    },
    actions: {
      /**
       * Initialize calendar_sku for each product from full_product_json
       * Maps product title to calendar_sku from simple_attributes.calendar_sku
       */
      initCalendarSku() {
        var _a, _b, _c;
        const appStore = useAppStore();
        console.log("[🔍 DEBUG CalendarStore] initCalendarSku called");
        console.log("[🔍 DEBUG CalendarStore] full_product_json:", appStore.full_product_json);
        console.log("[🔍 DEBUG CalendarStore] simple_attributes:", (_a = appStore.full_product_json) == null ? void 0 : _a.simple_attributes);
        const calendarSkuMap = (_c = (_b = appStore.full_product_json) == null ? void 0 : _b.simple_attributes) == null ? void 0 : _c.calendar_sku;
        console.log("[🔍 DEBUG CalendarStore] calendarSkuMap:", calendarSkuMap);
        if (!calendarSkuMap) {
          console.warn("[🔍 DEBUG CalendarStore] No calendar_sku mapping found in simple_attributes");
          return;
        }
        console.log("[🔍 DEBUG CalendarStore] Products before initCalendarSku:", JSON.stringify(this.products));
        if (this.products.length) {
          this.products.forEach((item, index) => {
            var _a2;
            const title2 = (_a2 = item.title) == null ? void 0 : _a2.trim();
            console.log("[🔍 DEBUG CalendarStore] Looking for title:", title2);
            console.log("[🔍 DEBUG CalendarStore] Available titles in map:", Object.keys(calendarSkuMap));
            if (title2 && calendarSkuMap[title2]) {
              this.products[index].calendar_sku = calendarSkuMap[title2];
              console.log("[🔍 DEBUG CalendarStore] ✅ Set calendar_sku for", title2, ":", calendarSkuMap[title2]);
            } else {
              console.warn("[🔍 DEBUG CalendarStore] ❌ No calendar_sku found for title:", title2);
            }
          });
        }
        console.log("[🔍 DEBUG CalendarStore] Products after initCalendarSku:", JSON.stringify(this.products));
      },
      /**
       * Validate bundle compatibility with imprint methods
       */
      validateBundleCompatibility() {
        var _a;
        const appStore = useAppStore();
        console.log("[🔍 DEBUG CalendarStore] validateBundleCompatibility called");
        console.log("[🔍 DEBUG CalendarStore] applicationType:", appStore.applicationType);
        console.log("[🔍 DEBUG CalendarStore] products:", this.products);
        if (!this.isBundleCheckRequired) {
          console.log("[🔍 DEBUG CalendarStore] Bundle check not required (not calendar mode)");
          return { isValid: true, availableMethods: [] };
        }
        this.initCalendarSku();
        const configurableArray = (_a = appStore.full_product_json) == null ? void 0 : _a.configurable_array;
        console.log("[🔍 DEBUG CalendarStore] configurable_array:", configurableArray);
        if (!configurableArray) {
          console.warn("[🔍 DEBUG CalendarStore] No configurable_array found");
          return { isValid: true, availableMethods: [] };
        }
        const selectedSkus = this.products.map((item) => item.calendar_sku).filter((sku) => sku);
        console.log("[🔍 DEBUG CalendarStore] Selected calendar SKUs:", selectedSkus);
        if (selectedSkus.length === 0) {
          console.warn("[🔍 DEBUG CalendarStore] No calendar SKUs found, assuming all methods available");
          this.availablePrintMethods = Object.keys(configurableArray);
          this.activeTabForCalendarBundle = 0;
          return { isValid: true, availableMethods: this.availablePrintMethods };
        }
        const validation = validateCalendarBundle(configurableArray, this.products);
        this.availablePrintMethods = validation.availableMethods;
        console.log("[🔍 DEBUG CalendarStore] availablePrintMethods set to:", this.availablePrintMethods);
        if (validation.isValid && this.availablePrintMethods.length > 0) {
          this.activeTabForCalendarBundle = 0;
        } else {
          this.activeTabForCalendarBundle = null;
        }
        console.log("[🔍 DEBUG CalendarStore] Final validation result:", {
          availableMethods: this.availablePrintMethods,
          isValid: validation.isValid,
          activeTabForCalendarBundle: this.activeTabForCalendarBundle
        });
        return validation;
      },
      /**
       * Check if a specific imprint method is available for the bundle
       */
      isMethodAvailableForBundle(methodSku) {
        if (!this.isBundleCheckRequired) {
          return true;
        }
        const isAvailable = this.availablePrintMethods.includes(methodSku);
        console.log("[🔍 DEBUG CalendarStore] isMethodAvailableForBundle", methodSku, ":", isAvailable, "availableMethods:", this.availablePrintMethods);
        return isAvailable;
      },
      /**
       * Load calendar products from localStorage
       * Called on mount when in calendar mode
       */
      async loadFromLocalStorage() {
        this.isLoading = true;
        this.errors = [];
        try {
          console.log("[CalendarStore] Loading products from localStorage...");
          const storedData = localStorage.getItem("fullStorageProductList");
          if (!storedData) {
            console.warn("[CalendarStore] No fullStorageProductList found in localStorage");
            this.products = [];
            this.quantities = {};
            return;
          }
          const products = JSON.parse(storedData);
          if (!Array.isArray(products)) {
            console.error("[CalendarStore] Invalid data format in localStorage (not an array)");
            this.errors.push("Invalid calendar data format");
            return;
          }
          this.products = products;
          products.forEach((product) => {
            if (product.id && product.qty) {
              this.quantities[product.id] = product.qty;
            }
          });
          console.log("[CalendarStore] Loaded products:", {
            count: products.length,
            products,
            quantities: this.quantities
          });
          this.validate();
        } catch (error) {
          console.error("[CalendarStore] Error loading from localStorage:", error);
          this.errors.push("Failed to load calendar products from storage");
          this.products = [];
          this.quantities = {};
        } finally {
          this.isLoading = false;
        }
      },
      /**
       * Update quantity for a specific product
       * @param {number} productId - Product variant ID
       * @param {number} qty - New quantity
       */
      updateQuantity(productId, qty) {
        const parsedQty = parseInt(qty, 10);
        if (isNaN(parsedQty) || parsedQty < 0) {
          console.error("[CalendarStore] Invalid quantity:", qty);
          return;
        }
        this.quantities[productId] = parsedQty;
        console.log("[CalendarStore] Updated quantity:", { productId, qty: parsedQty });
        this.validate();
        this.saveToLocalStorage();
      },
      /**
       * Save current state back to localStorage
       * Keeps localStorage in sync with store state
       * CRITICAL: Never save unitPrice to localStorage - always calculate dynamically
       */
      saveToLocalStorage() {
        try {
          const productsToSave = this.products.map((product) => {
            const { unitPrice, ...productData } = product;
            return {
              ...productData,
              qty: this.quantities[product.id] || 0
            };
          });
          localStorage.setItem("fullStorageProductList", JSON.stringify(productsToSave));
          console.log("[CalendarStore] Saved to localStorage (without unitPrice):", productsToSave);
        } catch (error) {
          console.error("[CalendarStore] Error saving to localStorage:", error);
        }
      },
      /**
       * Validate current state
       * Updates isValid flag and returns validation result
       */
      validate() {
        const errors = this.validationErrors;
        this.isValid = errors.length === 0;
        console.log("[CalendarStore] Validation result:", {
          isValid: this.isValid,
          errors,
          totalQty: this.totalQuantity,
          productsCount: this.products.length
        });
        return this.isValid;
      },
      /**
       * Clear all calendar data
       * Removes data from store and localStorage
       */
      clear() {
        console.log("[CalendarStore] Clearing all data");
        this.products = [];
        this.quantities = {};
        this.isValid = false;
        this.errors = [];
        this.availablePrintMethods = [];
        this.activeTabForCalendarBundle = null;
        localStorage.removeItem("fullStorageProductList");
        localStorage.removeItem("storageProductList");
      },
      /**
       * Reload products from localStorage
       * Useful for refreshing data
       */
      async reload() {
        console.log("[CalendarStore] Reloading products...");
        await this.loadFromLocalStorage();
      }
    }
  });
  const useImprintStore = /* @__PURE__ */ defineStore("imprint", {
    state: () => ({
      // Full product JSON payload (plain object).
      // Minimum expected shape for price matrix:
      // { configurable_array: { [methodKey]: { prices?: { tier_price: [] }, prices_2?: { tier_price: [] } } } }
      fullJson: null,
      // Sections UI state for the imprint flow.
      // Sections will be initialized in initializeSections() based on application type
      // Do NOT initialize sections here with IMPRINT_SECTIONS_STATIC to avoid race conditions
      sections: [],
      // Selected imprint method data (e.g., Screenprint, Embroidery, etc.)
      selectedImprintMethod: {
        id: null,
        sku: null,
        name: null,
        tabName: null,
        data: null
      },
      // Selected artwork method (how user provides artwork)
      selectedArtworkMethod: null,
      // 'new', 'send', 'previous', 'design',
      sizeUpcharge: {},
      colorUpcharge: {},
      // Additional imprint location fees (loaded from metafield DOM element)
      // Structure: { [sku]: { additional_location_fees: [{fee_value, fee_qtymin}] } }
      additionalLocationFees: null
    }),
    getters: {
      // Convenience accessor; never throws.
      configurableArray(state) {
        var _a;
        return ((_a = state.fullJson) == null ? void 0 : _a.configurable_array) || {};
      },
      // Rows: keys of configurable_array (as requested for now).
      imprintMethodKeys() {
        return Object.keys(this.configurableArray);
      },
      // Columns: union of QtyMin across ALL methods and both price sets (prices / prices_2).
      // Sorted asc.
      quantityBreaks() {
        var _a, _b, _c;
        const set = /* @__PURE__ */ new Set();
        for (const key of this.imprintMethodKeys) {
          const methodObj = ((_a = this.configurableArray) == null ? void 0 : _a[key]) || {};
          const tier1 = ((_b = methodObj == null ? void 0 : methodObj.prices) == null ? void 0 : _b.tier_price) || [];
          const tier2 = ((_c = methodObj == null ? void 0 : methodObj.prices_2) == null ? void 0 : _c.tier_price) || [];
          for (const row of tier1) {
            if ((row == null ? void 0 : row.QtyMin) != null) set.add(Number(row.QtyMin));
          }
          for (const row of tier2) {
            if ((row == null ? void 0 : row.QtyMin) != null) set.add(Number(row.QtyMin));
          }
        }
        return Array.from(set).filter((n) => !Number.isNaN(n)).sort((a, b) => a - b);
      },
      currentMethodQuantityBreaks(state) {
        var _a, _b, _c, _d;
        const sku = (_a = state.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!sku) return [];
        const methodObj = ((_b = this.configurableArray) == null ? void 0 : _b[sku]) || {};
        const set = /* @__PURE__ */ new Set();
        const tier1 = ((_c = methodObj == null ? void 0 : methodObj.prices) == null ? void 0 : _c.tier_price) || [];
        const tier2 = ((_d = methodObj == null ? void 0 : methodObj.prices_2) == null ? void 0 : _d.tier_price) || [];
        for (const row of tier1) {
          if ((row == null ? void 0 : row.QtyMin) != null) set.add(Number(row.QtyMin));
        }
        for (const row of tier2) {
          if ((row == null ? void 0 : row.QtyMin) != null) set.add(Number(row.QtyMin));
        }
        return Array.from(set).filter((n) => !Number.isNaN(n)).sort((a, b) => a - b);
      },
      // Get available imprint methods sorted by price
      // TODO can be improved: we have unsorted and sorted methods:
      // unsorted                imprintMethodKeys() - getter
      // sorted by price method  availableImprintMethods() - getter
      availableImprintMethods(state) {
        var _a, _b, _c, _d;
        const methods = [];
        const configArray = (_a = state.fullJson) == null ? void 0 : _a.configurable_array;
        if (!configArray) return [];
        for (const key in configArray) {
          const methodData = configArray[key];
          if (((_b = methodData.status) == null ? void 0 : _b.toLowerCase()) === "disabled") {
            continue;
          }
          methods.push({
            sku: key,
            name: methodData.name,
            description: methodData.imprint_description || "",
            image: methodData.imprint_image || null,
            price: Number(((_c = methodData.prices_2) == null ? void 0 : _c.min_price) || 0),
            priceSort: Number(((_d = methodData.prices_2) == null ? void 0 : _d.min_price) || 0)
          });
        }
        return methods.sort((a, b) => {
          if (a.priceSort > b.priceSort) return 1;
          if (a.priceSort < b.priceSort) return -1;
          return 0;
        });
      },
      // Get configurable_2_data for current imprint method
      currentConfigurable2Data(state) {
        var _a, _b;
        if (!state.selectedImprintMethod.sku) return null;
        return (_b = (_a = state.fullJson) == null ? void 0 : _a.configurable_array[state.selectedImprintMethod.sku]) == null ? void 0 : _b.configurable_2_data;
      },
      // Get imprint locations for current method
      availableLocations(state) {
        var _a, _b, _c;
        const configData = (_b = (_a = state.fullJson) == null ? void 0 : _a.configurable_array[state.selectedImprintMethod.sku]) == null ? void 0 : _b.configurable_2_data;
        if (!((_c = configData == null ? void 0 : configData.imprint_position) == null ? void 0 : _c._imprints)) return [];
        return configData.imprint_position._imprints.sort((a, b) => a.sort - b.sort);
      },
      // Get available colors for current method
      availableColors(state) {
        var _a, _b;
        const configData = (_b = (_a = state.fullJson) == null ? void 0 : _a.configurable_array[state.selectedImprintMethod.sku]) == null ? void 0 : _b.configurable_2_data;
        if (!(configData == null ? void 0 : configData.imprint_options)) return [];
        return configData.imprint_options.filter((opt) => opt._custom_option_type === "drop_down").flatMap((opt) => opt._colors || []);
      },
      // Alias for fullJson (for compatibility)
      productData(state) {
        return { fullJson: state.fullJson };
      },
      /**
       * Check if additional location fee data is available for the current imprint method
       * Button "Add Another Location" should be disabled when this returns false
       */
      hasAdditionalLocationFeeData(state) {
        var _a, _b;
        const sku = (_a = state.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!sku || !state.additionalLocationFees) return false;
        return !!((_b = state.additionalLocationFees) == null ? void 0 : _b[sku]);
      },
      /**
       * Get additional location fee tiers for the current imprint method
       * Returns sorted array of { fee_value, fee_qtymin } descending by fee_qtymin
       */
      currentAdditionalLocationFeeTiers(state) {
        var _a, _b, _c;
        const sku = (_a = state.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!sku || !state.additionalLocationFees) return [];
        const tiers = ((_c = (_b = state.additionalLocationFees) == null ? void 0 : _b[sku]) == null ? void 0 : _c.additional_location_fees) || [];
        return [...tiers].sort((a, b) => b.fee_qtymin - a.fee_qtymin);
      },
      // Get imprint method key
      getImprintMethodKey(state) {
        return state.selectedImprintMethod.name;
      },
      // Get qty_increment for current imprint method
      currentQtyIncrement(state) {
        var _a, _b, _c, _d;
        const currentSku = (_a = state.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!currentSku) return 1;
        const qtyIncrement = (_d = (_c = (_b = state.fullJson) == null ? void 0 : _b.configurable_array) == null ? void 0 : _c[currentSku]) == null ? void 0 : _d.qty_increment;
        return Number(qtyIncrement) || 1;
      }
    },
    actions: {
      setFullJson(fullJson) {
        this.fullJson = fullJson || null;
        console.log("[ImprintStore] setFullJson called");
        console.log("[ImprintStore] fullJson:", fullJson ? "loaded" : "null");
        console.log("[ImprintStore] configurable_array:", (fullJson == null ? void 0 : fullJson.configurable_array) ? Object.keys(fullJson.configurable_array) : "none");
        const appStore = useAppStore();
        if (appStore.applicationType === "calendar") {
          console.log("[DEBUG ImprintStore] Calendar mode detected, validating bundle...");
          try {
            const calendarStore = useCalendarStore();
            console.log("[DEBUG ImprintStore] CalendarStore products:", calendarStore.products);
            const validation = calendarStore.validateBundleCompatibility();
            console.log("[DEBUG ImprintStore] Bundle validation result:", validation);
            console.log("[DEBUG ImprintStore] Available methods after validation:", calendarStore.availablePrintMethods);
          } catch (e) {
            console.error("[DEBUG ImprintStore] Error validating bundle:", e);
          }
        }
        this.initImprintMethod();
      },
      // Initialize selectedImprintMethod with first available method sorted by price
      initImprintMethod() {
        var _a, _b;
        console.log("[ImprintStore] initImprintMethod called");
        console.log("[ImprintStore] fullJson exists:", !!this.fullJson);
        console.log("[ImprintStore] configurable_array exists:", !!((_a = this.fullJson) == null ? void 0 : _a.configurable_array));
        if ((_b = this.fullJson) == null ? void 0 : _b.configurable_array) {
          const sortedMethods = this.availableImprintMethods;
          console.log("[ImprintStore] Sorted methods:", sortedMethods.map((m) => ({ sku: m.sku, name: m.name, price: m.price })));
          if (sortedMethods.length > 0) {
            let firstMethod = sortedMethods[0];
            const appStore = useAppStore();
            if (appStore.applicationType === "calendar") {
              console.log("[DEBUG ImprintStore] Calendar mode - checking available methods");
              try {
                const calendarStore = useCalendarStore();
                const availableForBundle = calendarStore.availablePrintMethods;
                console.log("[DEBUG ImprintStore] availableForBundle:", availableForBundle);
                if (availableForBundle && availableForBundle.length > 0) {
                  const availableMethod = sortedMethods.find((m) => availableForBundle.includes(m.sku));
                  console.log("[DEBUG ImprintStore] Found available method:", availableMethod);
                  if (availableMethod) {
                    firstMethod = availableMethod;
                    console.log("[DEBUG ImprintStore] Selected first available method:", firstMethod.sku);
                  } else {
                    console.warn("[DEBUG ImprintStore] No available methods found in sorted list");
                    return;
                  }
                } else if (availableForBundle && availableForBundle.length === 0 && calendarStore.products.length > 0) {
                  console.warn("[DEBUG ImprintStore] No methods available for bundle");
                  return;
                }
              } catch (e) {
                console.error("[DEBUG ImprintStore] Error checking bundle availability:", e);
              }
            }
            const methodData = this.fullJson.configurable_array[firstMethod.sku];
            this.setSelectedImprintMethod({
              id: sortedMethods.indexOf(firstMethod),
              sku: firstMethod.sku,
              name: firstMethod.name,
              data: methodData
            });
            console.log("[ImprintStore] Auto-initialized imprint method (sorted by price):", firstMethod.sku, "Price:", firstMethod.price);
          } else {
            console.warn("[ImprintStore] No methods available to initialize");
          }
        } else {
          console.warn("[ImprintStore] Cannot initialize imprint method: fullJson.configurable_array not available");
        }
      },
      initUpcharges(sku) {
        var _a, _b;
        console.log("[ImprintStore] initUpcharges called for sku:", sku);
        let upcharge = null;
        let colorUpcharge = null;
        const methodData = (_b = (_a = this.fullJson) == null ? void 0 : _a.configurable_array) == null ? void 0 : _b[sku];
        if (!methodData) {
          console.warn("[ImprintStore] Method data not found for sku:", sku);
          return;
        }
        const attribute = methodData.attribute;
        if (!attribute || !Array.isArray(attribute)) {
          console.warn("[ImprintStore] No attribute array found for sku:", sku, "(this is normal for calendar products)");
          this.sizeUpcharge = {};
          this.colorUpcharge = {};
          return;
        }
        console.log("[ImprintStore] Attribute array:", attribute);
        if (attribute.length == 1) {
          colorUpcharge = attribute[0].code == "color" ? attribute[0].upcharge : null;
        } else if (attribute.length == 2) {
          upcharge = attribute[1].code == "size" ? attribute[1].upcharge : null;
          colorUpcharge = attribute[0].code == "color" ? attribute[0].upcharge : null;
        }
        console.log("[ImprintStore] Size Upcharge:", upcharge);
        console.log("[ImprintStore] Color Upcharge:", colorUpcharge);
        if (!upcharge) {
          console.error(" >>>>  1 attribute upcharge not found /ImprintTabs/setTierData <<<<");
        } else {
          let result = {};
          upcharge.forEach(
            (item) => {
              result[item.option] = item.price;
            }
          );
          this.sizeUpcharge = result;
        }
        if (!colorUpcharge) {
          console.error(" >>>> 2 attribute upcharge not found /ImprintTabs/setTierData <<<<");
        } else {
          let result = {};
          colorUpcharge.forEach(
            (item) => {
              let label = item.option.toLowerCase();
              result[label] = {
                price: item.price,
                price_type: item.price_type
              };
            }
          );
          this.colorUpcharge = result;
        }
      },
      // Set selected imprint method (Screenprint, Embroidery, etc.)
      setSelectedImprintMethod({ id, sku, name, data }) {
        if (id !== void 0) this.selectedImprintMethod.id = id;
        if (sku) this.selectedImprintMethod.sku = sku;
        if (name) {
          this.selectedImprintMethod.name = name;
          this.selectedImprintMethod.tabName = name;
        }
        if (data) this.selectedImprintMethod.data = data;
        console.log("[ImprintStore] Selected imprint method set:", {
          id: this.selectedImprintMethod.id,
          sku: this.selectedImprintMethod.sku,
          name: this.selectedImprintMethod.name
        });
        this.initUpcharges(sku);
      },
      // Set selected artwork method (how user provides artwork)
      setSelectedArtworkMethod(methodId) {
        this.selectedArtworkMethod = methodId;
        console.log("[ImprintStore] Selected artwork method:", methodId);
      },
      canOpenSection(id) {
        return true;
      },
      toggleSectionOpen(id) {
        if (!this.canOpenSection(id)) {
          return;
        }
        this.sections = this.sections.map((section) => {
          if (section.id === id && section.isAlwaysOpen) {
            return { ...section, isOpen: true };
          }
          if (section.id === id) {
            return { ...section, isOpen: !section.isOpen };
          }
          return section;
        });
      },
      isSectionOpen(id) {
        const section = this.sections.find((s) => s.id === id);
        return !!(section && section.isOpen);
      },
      setSectionMeta(id, meta) {
        this.sections = this.sections.map((section) => {
          if (section.id === id) {
            return { ...section, meta };
          }
          return section;
        });
      },
      /**
       * Initialize additional location fees from Liquid metafield DOM element
       * Called once on app mount
       */
      initAdditionalLocationFees() {
        try {
          const el = document.getElementById("additional_location_fee");
          if (!el) {
            console.warn("[ImprintStore] #additional_location_fee element not found");
            return;
          }
          const raw = (el.textContent || "").trim();
          if (!raw) {
            console.warn("[ImprintStore] #additional_location_fee is empty");
            return;
          }
          const parsed = JSON.parse(raw);
          this.additionalLocationFees = (parsed == null ? void 0 : parsed.configurable_array) || parsed;
          console.log("[ImprintStore] Additional location fees loaded:", Object.keys(this.additionalLocationFees));
        } catch (e) {
        }
      },
      /**
       * Calculate additional location fee per piece for a given quantity
       * Uses the same tier logic as product pricing (highest qualifying tier)
       * @param {number} totalQty
       * @returns {number} fee per piece
       */
      getAdditionalLocationFeePerPiece(totalQty) {
        var _a;
        const tiers = this.currentAdditionalLocationFeeTiers;
        if (!tiers || tiers.length === 0) return 0;
        for (const tier of tiers) {
          if (totalQty >= Number(tier.fee_qtymin)) {
            return Number(tier.fee_value);
          }
        }
        return Number(((_a = tiers[tiers.length - 1]) == null ? void 0 : _a.fee_value) || 0);
      },
      unlockSection(id) {
        console.log("[ImprintStore] Unlocking section:", id);
      },
      /**
       * Initialize sections based on application type
       * This should be called after appStore is initialized
       * @param {string} applicationType - 'default' | 'calendar' | 'calendar_single'
       */
      initializeSections(applicationType = "default") {
        console.log("[ImprintStore] Initializing sections for application type:", applicationType);
        const sectionsConfig = getSections(applicationType);
        this.sections = sectionsConfig.map((s) => {
          const section = {
            ...s,
            meta: s.meta || null,
            isOpen: !!s.isAlwaysOpen || !!s.isInitiallyOpen
          };
          console.log("[ImprintStore] Initialized section:", section.id, "isOpen:", section.isOpen, "isInitiallyOpen:", s.isInitiallyOpen);
          return section;
        });
        console.log("[ImprintStore] Sections initialized: ", this.sections.map((s) => ({ id: s.id, label: s.label, isOpen: s.isOpen })));
      }
    }
  });
  const STORAGE_KEY$3 = "selection_state_v1";
  const STORAGE_VERSION$2 = 1;
  const STORAGE_TTL$1 = 30 * 60 * 1e3;
  const useSelectionStore = /* @__PURE__ */ defineStore("selection", {
    state: () => ({
      // Main data structures for "lines" (Step 2)
      /**
       * Color-size-quantity lines, grouped by imprintKey
       * @type {Object.<string, ColorSizeLine[]>}
       * 
       * IMPORTANT: Uses "slectedColor" and "selectedSizes" (note the typo in "slected")
       * This is intentional for backward compatibility with addToCart in StepNavigation.vue
       * 
       * Structure: 
       * {
       *   'embroidery': [
       *     {
       *       id: 1,
       *       imprintKey: 'embroidery',
       *       slectedColor: {
       *         id: 51975323156769,
       *         title: 'red',
       *         img_src: 'https://cdn.shopify.com/...',
       *         img_id: 52988245508385,
       *         img_sku: 'D640W_XL_0004',
       *         img_gid: 'gid://shopify/...',
       *         alt: 'Red shirt',
       *         hex: '#FF0000'
       *       },
       *       selectedSizes: {'S': 10, 'M': 20, 'L': 15},
       *       totalQty: 45,
       *       randID: 'abc123'
       *     }
       *   ]
       * }
       */
      colorSizeLines: {},
      /**
       * List of selected color IDs by imprintKey
       * @type {Object.<string, Array<string|number>>}
       * 
       * Structure:
       * {
       *   'embroidery': [51975323156769, 51975323156770]
       * }
       */
      selectedColorsList: {},
      /**
       * Total quantity by sizes for each imprintKey
       * @type {Object.<string, Object.<string, number>>}
       * 
       * Structure:
       * {
       *   'embroidery': {
       *     'S': 25,
       *     'M': 50,
       *     'L': 30
       *   }
       * }
       */
      totalSizesQty: {},
      /**
       * List of available color variant IDs for selection
       * @type {Array<string|number>}
       * 
       * This is the general list of product color IDs from which user can choose
       */
      availableColorsList: [],
      /**
       * Mapping of full size names to short ones
       * @type {Object.<string, string>}
       * Example: {'Small': 'S', 'Medium': 'M', 'Large': 'L'}
       */
      fullSizeNameToShort: {},
      /**
       * Whether full size names are used
       * @type {boolean}
       */
      hasFullSizeNames: false,
      /**
       * Messages with color lines for imprint
       * @type {Array}
       */
      imprintMessageColorLines: [],
      /**
       * Data for "Apply to All" functionality
       * @type {Object}
       */
      // Todo check duplicate at useNewImprintStore
      applyToAll: {
        id: null,
        selectedColor: null,
        index: null,
        randID: null
      },
      /**
       * Cached API data to avoid redundant requests
       * @type {Object}
       */
      cachedApiData: {
        colorVariants: [],
        sizeVariants: [],
        colorHandle: null,
        sizeHandle: null,
        associatedIds: null,
        isLoaded: false
      },
      /**
       * Special instructions from Step 4 (Review)
       * @type {string}
       */
      specialInstructions: ""
    }),
    getters: {
      /**
       * Get all lines for a specific imprintKey
       * @param {Object} state
       * @returns {function(string): ColorSizeLine[]}
       */
      getLinesByImprintKey: (state) => (imprintKey) => {
        return state.colorSizeLines[imprintKey] || [];
      },
      /**
       * Get selected color IDs for a specific imprintKey
       * @param {Object} state
       * @returns {function(string): Array<string|number>}
       */
      getSelectedColorsByImprintKey: (state) => (imprintKey) => {
        return state.selectedColorsList[imprintKey] || [];
      },
      /**
       * Get total quantity by sizes for imprintKey
       * @param {Object} state
       * @returns {function(string): Object.<string, number>}
       */
      getTotalSizesQtyByImprintKey: (state) => (imprintKey) => {
        return state.totalSizesQty[imprintKey] || {};
      },
      /**
       * Calculate total quantity for all sizes for imprintKey
       * @param {Object} state
       * @returns {function(string): number}
       */
      getTotalQtyByImprintKey: (state) => (imprintKey) => {
        const sizesQty = state.totalSizesQty[imprintKey] || {};
        return Object.values(sizesQty).reduce((sum, qty) => sum + (Number(qty) || 0), 0);
      },
      /**
       * Get count of unique colors for imprintKey
       * @param {Object} state
       * @returns {function(string): number}
       */
      getUniqueColorsCountByImprintKey: (state) => (imprintKey) => {
        const lines = state.colorSizeLines[imprintKey] || [];
        const uniqueColors = new Set(lines.map((line) => {
          var _a;
          return (_a = line.slectedColor) == null ? void 0 : _a.id;
        }).filter(Boolean));
        return uniqueColors.size;
      },
      /**
       * Check if color is selected in the list for imprintKey
       * @param {Object} state
       * @returns {function(string, string|number): boolean}
       */
      hasColorSelected: (state) => (imprintKey, colorId) => {
        const selectedColors = state.selectedColorsList[imprintKey] || [];
        return selectedColors.includes(colorId);
      },
      /**
       * Get all available sizes from all lines for imprintKey
       * @param {Object} state
       * @returns {function(string): string[]}
       */
      getAvailableSizesByImprintKey: (state) => (imprintKey) => {
        const lines = state.colorSizeLines[imprintKey] || [];
        const sizesSet = /* @__PURE__ */ new Set();
        lines.forEach((line) => {
          if (line.selectedSizes && typeof line.selectedSizes === "object") {
            Object.keys(line.selectedSizes).forEach((size) => sizesSet.add(size));
          }
        });
        return Array.from(sizesSet);
      },
      /**
       * Check if there is data for Step 2 for a specific imprintKey
       * @param {Object} state
       * @returns {function(string): boolean}
       */
      hasStep2DataForImprintKey: (state) => (imprintKey) => {
        const lines = state.colorSizeLines[imprintKey] || [];
        const hasData = lines.length > 0;
        console.log("[useSelectionStore] hasStep2DataForImprintKey(" + imprintKey + "):", hasData, "lines.length:", lines.length);
        return hasData;
      }
    },
    actions: {
      /**
       * Check and remove data from storage using a print method key for which no data is selected.
       * @param {string} previousImprintMethod
       */
      removeEmptyImprintMethodData(previousImprintMethod) {
        const hasData = this.hasStep2DataForImprintKey(previousImprintMethod);
        if (!hasData) {
          this.clearLines(previousImprintMethod);
        }
      },
      /**
       * Initialize structures for a new imprintKey
       * @param {string} imprintKey
       * @param {string} [previousImprintKey] - Previous imprint key to copy data from (HOTFIX)
       */
      initImprintKey(imprintKey, previousImprintKey = null) {
        if (previousImprintKey && this.colorSizeLines[previousImprintKey]) {
          this.colorSizeLines[imprintKey] = JSON.parse(
            JSON.stringify(this.colorSizeLines[previousImprintKey])
          ).map((line) => ({ ...line, imprintKey }));
          this.selectedColorsList[imprintKey] = [...this.selectedColorsList[previousImprintKey] || []];
          this.totalSizesQty[imprintKey] = { ...this.totalSizesQty[previousImprintKey] || {} };
        } else {
          if (!this.colorSizeLines[imprintKey]) {
            this.colorSizeLines[imprintKey] = [];
          }
          if (!this.selectedColorsList[imprintKey]) {
            this.selectedColorsList[imprintKey] = [];
          }
          if (!this.totalSizesQty[imprintKey]) {
            this.totalSizesQty[imprintKey] = {};
          }
        }
      },
      /**
       * Add a new color-size-quantity line
       * @param {string} imprintKey
       * @param {ColorSizeLine} line
       */
      addColorSizeLine(imprintKey, line) {
        this.initImprintKey(imprintKey);
        if (line.slectedColor && !line.slectedColor.img_sku) {
          console.warn("[useSelectionStore] addColorSizeLine: img_sku is missing!");
        }
        if (line.slectedColor && !line.slectedColor.img_id) {
          console.warn("[useSelectionStore] addColorSizeLine: img_id is missing!");
        }
        if (!line.randID) {
          line.randID = `line_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }
        if (!line.id) {
          const existingLines = this.colorSizeLines[imprintKey];
          line.id = existingLines.length > 0 ? Math.max(...existingLines.map((l) => Number(l.id) || 0)) + 1 : 1;
        }
        if (!line.selectedSizes) {
          line.selectedSizes = {};
        }
        this.colorSizeLines[imprintKey].push(line);
        this.recalculateTotalSizesQty(imprintKey);
        this.updateSelectedColorsList(imprintKey);
      },
      /**
       * Update existing line
       * @param {string} imprintKey
       * @param {string|number} lineId
       * @param {Partial<ColorSizeLine>} updates
       */
      updateColorSizeLine(imprintKey, lineId, updates) {
        const lines = this.colorSizeLines[imprintKey] || [];
        const index = lines.findIndex((line) => line.id === lineId);
        if (index !== -1) {
          this.colorSizeLines[imprintKey][index] = {
            ...lines[index],
            ...updates
          };
          this.recalculateTotalSizesQty(imprintKey);
          this.updateSelectedColorsList(imprintKey);
        }
      },
      /**
       * Remove line
       * @param {string} imprintKey
       * @param {string|number} lineId
       */
      removeColorSizeLine(imprintKey, lineId) {
        if (this.colorSizeLines[imprintKey]) {
          this.colorSizeLines[imprintKey] = this.colorSizeLines[imprintKey].filter((line) => line.id !== lineId);
          this.recalculateTotalSizesQty(imprintKey);
          this.updateSelectedColorsList(imprintKey);
        }
      },
      /**
       * Clear all lines for imprintKey
       * @param {string} imprintKey
       */
      clearLines(imprintKey) {
        if (this.colorSizeLines[imprintKey] !== void 0) {
          delete this.colorSizeLines[imprintKey];
        }
        if (this.selectedColorsList[imprintKey] !== void 0) {
          delete this.selectedColorsList[imprintKey];
        }
        if (this.totalSizesQty[imprintKey] !== void 0) {
          delete this.totalSizesQty[imprintKey];
        }
      },
      /**
       * Recalculate total quantity by sizes for imprintKey
       * NOTE: Uses "selectedSizes" field name
       * @param {string} imprintKey
       */
      recalculateTotalSizesQty(imprintKey) {
        const lines = this.colorSizeLines[imprintKey] || [];
        const totals = {};
        lines.forEach((line) => {
          if (line.selectedSizes && typeof line.selectedSizes === "object") {
            Object.entries(line.selectedSizes).forEach(([size, qty]) => {
              const numQty = Number(qty) || 0;
              totals[size] = (totals[size] || 0) + numQty;
            });
          }
        });
        this.totalSizesQty[imprintKey] = totals;
      },
      /**
       * Update list of selected color IDs based on lines
       * NOTE: Uses "slectedColor" field name
       * @param {string} imprintKey
       */
      updateSelectedColorsList(imprintKey) {
        const lines = this.colorSizeLines[imprintKey] || [];
        const uniqueColorIds = /* @__PURE__ */ new Set();
        lines.forEach((line) => {
          if (line.slectedColor && line.slectedColor.id) {
            uniqueColorIds.add(line.slectedColor.id);
          }
        });
        this.selectedColorsList[imprintKey] = Array.from(uniqueColorIds);
      },
      /**
       * Set list of available color variant IDs
       * @param {Array<string|number>} colorIds
       */
      setAvailableColorsList(colorIds) {
        this.availableColorsList = colorIds || [];
      },
      /**
       * Set mapping of full size names
       * @param {Object.<string, string>} mapping
       */
      setFullSizeNameMapping(mapping) {
        this.fullSizeNameToShort = mapping || {};
        this.hasFullSizeNames = Object.keys(mapping || {}).length > 0;
      },
      /**
       * Apply settings to all lines (Apply to All)
       * @param {string} imprintKey
       * @param {Object} applyToAllData
       */
      setApplyToAll(imprintKey, applyToAllData) {
        this.applyToAll = {
          ...this.applyToAll,
          ...applyToAllData
        };
      },
      /**
       * Clear Apply to All data
       */
      clearApplyToAll() {
        this.applyToAll = {
          id: null,
          selectedColor: null,
          index: null,
          randID: null
        };
      },
      /**
       * Update quantity for a specific size in line
       * NOTE: Uses "selectedSizes" field name
       * @param {string} imprintKey
       * @param {string|number} lineId
       * @param {string} size
       * @param {number} qty
       */
      updateLineSizeQty(imprintKey, lineId, size, qty) {
        const lines = this.colorSizeLines[imprintKey] || [];
        const line = lines.find((l) => l.id === lineId);
        if (line) {
          if (!line.selectedSizes) {
            line.selectedSizes = {};
          }
          line.selectedSizes[size] = Number(qty) || 0;
          line.totalQty = Object.values(line.selectedSizes).reduce((sum, q) => sum + (Number(q) || 0), 0);
          this.recalculateTotalSizesQty(imprintKey);
        }
      },
      /**
       * Set messages with color lines
       * @param {Array} messages
       */
      setImprintMessageColorLines(messages) {
        this.imprintMessageColorLines = messages || [];
      },
      /**
       * Set cached API data
       * @param {Object} data
       */
      setCachedApiData(data) {
        this.cachedApiData = {
          ...this.cachedApiData,
          ...data,
          isLoaded: true
        };
      },
      /**
       * Get cached API data
       * @returns {Object}
       */
      getCachedApiData() {
        return this.cachedApiData;
      },
      /**
       * Check if API data is already loaded
       * @returns {boolean}
       */
      isApiDataLoaded() {
        return this.cachedApiData.isLoaded;
      },
      /**
       * Set special instructions
       * @param {string} instructions
       */
      setSpecialInstructions(instructions) {
        this.specialInstructions = instructions || "";
        console.log("[useSelectionStore] Special instructions set:", instructions);
      },
      /**
       * Reset entire store to initial state
       */
      $reset() {
        this.colorSizeLines = {};
        this.selectedColorsList = {};
        this.totalSizesQty = {};
        this.availableColorsList = [];
        this.fullSizeNameToShort = {};
        this.hasFullSizeNames = false;
        this.imprintMessageColorLines = [];
        this.applyToAll = {
          id: null,
          selectedColor: null,
          index: null,
          randID: null
        };
        this.cachedApiData = {
          colorVariants: [],
          sizeVariants: [],
          colorHandle: null,
          sizeHandle: null,
          associatedIds: null,
          isLoaded: false
        };
        this.specialInstructions = "";
      },
      // ====================================
      // SESSION STORAGE PERSISTENCE
      // ====================================
      /**
       * Save selection state to sessionStorage
       * Called before redirect to preserve user's color & quantity selections
       */
      saveToSessionStorage() {
        try {
          const data = {
            version: STORAGE_VERSION$2,
            timestamp: Date.now(),
            productKey: window.location.pathname,
            // ✅ NEW: Save product pathname for validation
            colorSizeLines: this.colorSizeLines,
            selectedColorsList: this.selectedColorsList,
            totalSizesQty: this.totalSizesQty,
            availableColorsList: this.availableColorsList,
            fullSizeNameToShort: this.fullSizeNameToShort,
            hasFullSizeNames: this.hasFullSizeNames,
            specialInstructions: this.specialInstructions
            // NOTE: We DON'T save:
            // - cachedApiData (will reload from product)
            // - imprintMessageColorLines (temporary)
            // - applyToAll (UI state)
          };
          sessionStorage.setItem(STORAGE_KEY$3, JSON.stringify(data));
          console.log("[useSelectionStore] 💾 State saved to sessionStorage:", {
            colorLines: Object.keys(data.colorSizeLines).length,
            totalColors: Object.values(data.selectedColorsList).flat().length
          });
          return true;
        } catch (error) {
          console.error("[useSelectionStore] ❌ Failed to save to sessionStorage:", error);
          return false;
        }
      },
      /**
       * Restore selection state from sessionStorage
       * Called on page load to recover user data after redirect
       */
      restoreFromSessionStorage() {
        try {
          const raw = sessionStorage.getItem(STORAGE_KEY$3);
          if (!raw) {
            console.log("[useSelectionStore] No saved state found in sessionStorage");
            return false;
          }
          const data = JSON.parse(raw);
          if (data.version !== STORAGE_VERSION$2) {
            console.warn("[useSelectionStore] ⚠️ Storage version mismatch");
            this.clearSessionStorage();
            return false;
          }
          const currentProductKey = window.location.pathname;
          if (data.productKey && data.productKey !== currentProductKey) {
            console.warn("[useSelectionStore] ⚠️ Product key mismatch:", {
              stored: data.productKey,
              current: currentProductKey
            });
            console.log("[useSelectionStore] Clearing storage from different product");
            this.clearSessionStorage();
            return false;
          }
          const age = Date.now() - data.timestamp;
          if (age > STORAGE_TTL$1) {
            console.warn("[useSelectionStore] ⚠️ Storage data expired (age:", Math.round(age / 1e3), "seconds)");
            this.clearSessionStorage();
            return false;
          }
          this.colorSizeLines = data.colorSizeLines || {};
          this.selectedColorsList = data.selectedColorsList || {};
          this.totalSizesQty = data.totalSizesQty || {};
          this.availableColorsList = data.availableColorsList || [];
          this.fullSizeNameToShort = data.fullSizeNameToShort || {};
          this.hasFullSizeNames = data.hasFullSizeNames || false;
          this.specialInstructions = data.specialInstructions || "";
          console.log("[useSelectionStore] ✅ State restored from sessionStorage:", {
            colorLines: Object.keys(this.colorSizeLines).length,
            totalColors: Object.values(this.selectedColorsList).flat().length,
            age: Math.round(age / 1e3) + "s ago"
          });
          return true;
        } catch (error) {
          console.error("[useSelectionStore] ❌ Failed to restore from sessionStorage:", error);
          this.clearSessionStorage();
          return false;
        }
      },
      /**
       * Clear saved state from sessionStorage
       */
      clearSessionStorage() {
        try {
          sessionStorage.removeItem(STORAGE_KEY$3);
          console.log("[useSelectionStore] 🗑️ SessionStorage cleared");
        } catch (error) {
          console.error("[useSelectionStore] ❌ Failed to clear sessionStorage:", error);
        }
      }
    }
  });
  const useSelectionStore$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    useSelectionStore
  }, Symbol.toStringTag, { value: "Module" }));
  function calculateSetupFee(uniqueColorsCount, artworkMethod = "new", isComda = true, setupFeeRate = 30, isFirstImprintLocation = true) {
    return calculateSetupFeeDetailed(uniqueColorsCount, artworkMethod, isComda, setupFeeRate, isFirstImprintLocation).total;
  }
  function calculateSetupFeeDetailed(uniqueColorsCount, artworkMethod = "new", isComda = true, setupFeeRate = 30, isFirstImprintLocation = true) {
    if (artworkMethod === "send") {
      const qty = isComda ? 1 : 0;
      return { qty, unitPrice: setupFeeRate, total: qty * setupFeeRate };
    }
    if (isComda) {
      if (uniqueColorsCount === 0) {
        return { qty: 1, unitPrice: setupFeeRate, total: setupFeeRate };
      }
      return { qty: uniqueColorsCount, unitPrice: setupFeeRate, total: uniqueColorsCount * setupFeeRate };
    } else {
      if (isFirstImprintLocation) {
        if (uniqueColorsCount <= 1) {
          return { qty: 0, unitPrice: setupFeeRate, total: 0 };
        }
        const qty = uniqueColorsCount - 1;
        return { qty, unitPrice: setupFeeRate, total: qty * setupFeeRate };
      } else {
        if (uniqueColorsCount === 0) {
          return { qty: 1, unitPrice: setupFeeRate, total: setupFeeRate };
        }
        return { qty: uniqueColorsCount, unitPrice: setupFeeRate, total: uniqueColorsCount * setupFeeRate };
      }
    }
  }
  function calculateRunningFee(uniqueColorsCount, totalQuantity, artworkMethod = "new", runningFeeRate = 0) {
    console.log("[calculateRunningFee] Input:", {
      uniqueColorsCount,
      totalQuantity,
      artworkMethod,
      runningFeeRate
    });
    if (artworkMethod !== "new") {
      console.log("[calculateRunningFee] Returning 0: artworkMethod is not new");
      return 0;
    }
    if (uniqueColorsCount <= 1) {
      console.log("[calculateRunningFee] Returning 0: only 1 or 0 colors");
      return 0;
    }
    const additionalColors = uniqueColorsCount - 1;
    return additionalColors * runningFeeRate * totalQuantity;
  }
  function calculateCustomColorFee(hasPantoneColorOrCount, artworkMethod = "new", customColorFeeRate = 50) {
    return calculateCustomColorFeeDetailed(hasPantoneColorOrCount, artworkMethod, customColorFeeRate).total;
  }
  function calculateCustomColorFeeDetailed(hasPantoneColorOrCount, artworkMethod = "new", customColorFeeRate = 50) {
    if (artworkMethod !== "new") {
      return { qty: 0, unitPrice: customColorFeeRate, total: 0 };
    }
    let customColorCount = 0;
    if (typeof hasPantoneColorOrCount === "number") {
      customColorCount = hasPantoneColorOrCount;
    } else if (hasPantoneColorOrCount === true) {
      customColorCount = 1;
    }
    return { qty: customColorCount, unitPrice: customColorFeeRate, total: customColorCount * customColorFeeRate };
  }
  function calculateImageFee(hasImage, artworkMethod = "new", imageFeeRate = 25) {
    if (artworkMethod !== "new") {
      return 0;
    }
    return hasImage ? imageFeeRate : 0;
  }
  function calculateProofFee(artworkMethod = "new", proofFeeRate = 5) {
    return proofFeeRate;
  }
  function calculateRunningFeePerItem(uniqueColorsCount, artworkMethod = "new", runningFeeRate = 0) {
    if (artworkMethod !== "new") {
      return 0;
    }
    if (uniqueColorsCount <= 1) {
      return 0;
    }
    return runningFeeRate;
  }
  function calculateAllFees({
    uniqueColorsCount = 0,
    totalQuantity = 0,
    hasPantoneColor: hasPantoneColor2 = false,
    hasImage = false,
    artworkMethod = "new",
    isComda = true,
    backendConfig = {},
    isFirstImprintLocation = true
  }) {
    const setupFeeRate = backendConfig.setup_fee ?? 30;
    const runningFeeRate = backendConfig.running_fee ?? 0;
    const customColorFeeRate = backendConfig.custom_colour_fee ?? 50;
    const imageFeeRate = backendConfig.image_fee ?? 25;
    const proofFeeRate = backendConfig.proof_fee ?? 5;
    const fees = {
      setup_fee: calculateSetupFee(uniqueColorsCount, artworkMethod, isComda, setupFeeRate, isFirstImprintLocation),
      running_fee: calculateRunningFee(uniqueColorsCount, totalQuantity, artworkMethod, runningFeeRate),
      customColourFee: calculateCustomColorFee(hasPantoneColor2, artworkMethod, customColorFeeRate),
      image_fee: calculateImageFee(hasImage, artworkMethod, imageFeeRate),
      proof_fee: calculateProofFee(artworkMethod, proofFeeRate),
      runningFeePerItem: calculateRunningFeePerItem(uniqueColorsCount, artworkMethod, runningFeeRate)
    };
    const setupFeeDetail = calculateSetupFeeDetailed(uniqueColorsCount, artworkMethod, isComda, setupFeeRate, isFirstImprintLocation);
    const customColorFeeDetail = calculateCustomColorFeeDetailed(hasPantoneColor2, artworkMethod, customColorFeeRate);
    fees.setup_fee_qty = setupFeeDetail.qty;
    fees.setup_fee_unit_price = setupFeeDetail.unitPrice;
    fees.customColourFee_qty = customColorFeeDetail.qty;
    fees.customColourFee_unit_price = customColorFeeDetail.unitPrice;
    fees.running_fee_multiplier = uniqueColorsCount > 1 ? uniqueColorsCount - 1 : 0;
    fees.running_fee_rate = runningFeeRate;
    fees.proof_fee_unit_price = proofFeeRate;
    fees.image_fee_qty = hasImage ? 1 : 0;
    fees.image_fee_unit_price = imageFeeRate;
    fees.total = fees.setup_fee + fees.running_fee + fees.customColourFee + fees.image_fee + fees.proof_fee;
    return fees;
  }
  function getUniqueColorsCount(imprintData) {
    var _a, _b;
    if (!imprintData) return 0;
    const uniqueColors = /* @__PURE__ */ new Set();
    const messageType = imprintData.messageType || "text";
    if (messageType === "text" || messageType === "text_image") {
      if (Array.isArray(imprintData.textLines)) {
        imprintData.textLines.forEach((line) => {
          if (!line || line.type === "image") return;
          const hasText = typeof line.message === "string" && line.message.trim().length > 0;
          if (!hasText) return;
          if (line.selectedColor) {
            uniqueColors.add(line.selectedColor);
          } else if (typeof line.customColor === "string" && line.customColor.trim().length > 0) {
            uniqueColors.add(line.customColor.trim());
          }
        });
      }
    }
    if (messageType === "image" || messageType === "text_image") {
      if (Array.isArray(imprintData.textLines)) {
        imprintData.textLines.forEach((line) => {
          var _a2;
          if (!line || line.type !== "image") return;
          console.log("[getUniqueColorsCount] Image line found:", line);
          if (line.selectedColor) {
            uniqueColors.add(line.selectedColor);
            console.log("[getUniqueColorsCount] Added image color from selectedColor:", line.selectedColor);
          } else if ((_a2 = line.selectedColorObj) == null ? void 0 : _a2.file_name) {
            uniqueColors.add(line.selectedColorObj.file_name);
            console.log("[getUniqueColorsCount] Added image color from selectedColorObj.file_name:", line.selectedColorObj.file_name);
          }
        });
      }
      if ((_a = imprintData.uploadedImage) == null ? void 0 : _a.selectedColor) {
        uniqueColors.add(imprintData.uploadedImage.selectedColor);
      }
      if ((_b = imprintData.imageData) == null ? void 0 : _b.selectedColor) {
        uniqueColors.add(imprintData.imageData.selectedColor);
      }
    }
    console.log("[getUniqueColorsCount] Final unique colors:", uniqueColors.size, Array.from(uniqueColors));
    return uniqueColors.size;
  }
  function getUniqueCustomColorsCount(imprintData) {
    if (!imprintData || !imprintData.textLines) return 0;
    const messageType = imprintData.messageType || "text";
    if (messageType !== "text" && messageType !== "text_image") {
      return 0;
    }
    const uniqueCustomColors = /* @__PURE__ */ new Set();
    imprintData.textLines.forEach((line) => {
      if (!line || line.type === "image") return;
      const hasText = typeof line.message === "string" && line.message.trim().length > 0;
      if (!hasText) return;
      if (line.customColor === true && line.selectedColor) {
        uniqueCustomColors.add(line.selectedColor);
        console.log("[getUniqueCustomColorsCount] Found custom color:", line.selectedColor);
      }
    });
    console.log("[getUniqueCustomColorsCount] Total unique custom colors:", uniqueCustomColors.size, Array.from(uniqueCustomColors));
    return uniqueCustomColors.size;
  }
  function hasUploadedImage(imprintData) {
    if (!imprintData) return false;
    return !!imprintData.imageData && imprintData.imageData.url;
  }
  function combineProofFee(imprintsFees, feeUnit = "per order") {
    if (feeUnit === "per location") {
      return imprintsFees.reduce((sum, fee) => sum + (fee.proof_fee || 0), 0);
    }
    return imprintsFees.reduce((found, fee) => {
      if (found > 0) return found;
      return fee.proof_fee || 0;
    }, 0);
  }
  function getFeeUnit(feesArray, feeType, defaultUnit = "per order") {
    if (!Array.isArray(feesArray)) return defaultUnit;
    const entry = feesArray.find((f) => f.fee_type === feeType);
    return (entry == null ? void 0 : entry.fee_unit) || defaultUnit;
  }
  const STORAGE_KEY$2 = "new_imprint_state_v1";
  const STORAGE_VERSION$1 = 1;
  const STORAGE_TTL = 30 * 60 * 1e3;
  const useNewImprintStore = /* @__PURE__ */ defineStore("newImprint", {
    state: () => ({
      // Current imprint key (for multiple imprints support)
      currentImprintKey: 0,
      // Imprints data - array to support multiple imprints
      imprints: [
        {
          // Selected location
          selectedLocation: {
            sku: null,
            title: null,
            imprintLines: 5
            // Default max lines
          },
          // ✅ NEW: Separate state for each imprint method (Screen Print, Embroidery, DTG, etc.)
          // Each method preserves its own textLines, colors, images when switching
          methodsData: {},
          // ✅ NEW: Track which imprint method is currently active
          // Example: 'SCRE' for Screen Print, 'EMBR' for Embroidery
          activeMethodSku: null,
          // ✅ NEW: Separate state for each location (preserves textLines when switching locations)
          // Structure: { 'LOC_SKU': { textLines: [...], nextLineId: N } }
          // Example: { 'FRC': { textLines: [line1, line2], nextLineId: 3 } }
          locationsData: {},
          // LEGACY: Old fields kept for backwards compatibility
          // These are now computed from methodsData[activeMethodSku]
          // Message type: 'text' | 'image' | 'text_image'
          messageType: "text",
          // Text lines with colors - Initialize with 1 line (will be adjusted when location is selected)
          textLines: [
            {
              id: 0,
              randID: Date.now(),
              type: "message",
              selectedColor: null,
              selectedColorObj: null,
              customColor: false,
              message: "",
              showColorPicker: false
            }
          ],
          // Image data (for Image/Text+Image types)
          imageData: null,
          // Special instructions
          specialInstructions: "",
          // Max lines allowed for current location
          maxLines: 5,
          // Validation state
          errors: {},
          // Next line ID counter
          nextLineId: 1,
          // Start from 1 since we have 1 initial line
          // Apply to All state (per imprint)
          applyToAll: {
            active: false,
            sourceLineId: null,
            sourceLineRandID: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          // Max colors tracking (per imprint)
          maxColorsTracking: {
            uniqueColors: [],
            // Array of color SKUs
            maxColors: null,
            // Max allowed from product config
            isMaxReached: false
          },
          // Custom Pantone inputs (UI state per imprint)
          customPantoneInputs: {},
          // Pending color selection (for Add Colour button flow)
          pendingColorSelection: {
            lineId: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          // Saved Pantone colors (for reuse)
          savedPantoneColors: [],
          // Saved image line data (preserved when switching to 'text' mode)
          savedImageLineData: null
        }
      ]
    }),
    getters: {
      /**
       * Get current imprint data
       */
      currentImprint(state) {
        return state.imprints[state.currentImprintKey] || null;
      },
      /**
       * Get current text lines
       */
      currentTextLines(state) {
        const imprint = state.imprints[state.currentImprintKey];
        return (imprint == null ? void 0 : imprint.textLines) || [];
      },
      /**
       * Get current location
       */
      currentLocation(state) {
        const imprint = state.imprints[state.currentImprintKey];
        return (imprint == null ? void 0 : imprint.selectedLocation) || null;
      },
      /**
       * Get current message type
       */
      currentMessageType(state) {
        const imprint = state.imprints[state.currentImprintKey];
        return (imprint == null ? void 0 : imprint.messageType) || "text";
      },
      /**
       * Get max lines for current location
       */
      currentMaxLines(state) {
        const imprint = state.imprints[state.currentImprintKey];
        return (imprint == null ? void 0 : imprint.maxLines) || 5;
      },
      // Note: canAddLine and canRemoveLine removed - all lines auto-shown on desktop based on maxLines
      /**
       * Get available locations from main imprint store
       * FIXED: Now includes imprint_lines from fullJson
       */
      availableLocations() {
        var _a, _b, _c, _d;
        const imprintStore = useImprintStore();
        const baseLocations = imprintStore.availableLocations || [];
        console.log("[DEBUG availableLocations] START");
        console.log("[DEBUG availableLocations] baseLocations count:", baseLocations.length);
        if (baseLocations.length > 0) {
          console.log("[DEBUG availableLocations] First base location:", baseLocations[0]);
        }
        const fullJson = imprintStore.fullJson;
        const selectedSku = (_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        console.log("[DEBUG availableLocations] selectedSku:", selectedSku);
        console.log("[DEBUG availableLocations] Has fullJson:", !!fullJson);
        console.log("[DEBUG availableLocations] Has configurable_array:", !!(fullJson == null ? void 0 : fullJson.configurable_array));
        console.log("[DEBUG availableLocations] Has selected SKU in array:", !!((_b = fullJson == null ? void 0 : fullJson.configurable_array) == null ? void 0 : _b[selectedSku]));
        if (!fullJson || !selectedSku || !((_c = fullJson.configurable_array) == null ? void 0 : _c[selectedSku])) {
          console.warn("[useNewImprintStore] Cannot enrich locations - missing fullJson or selectedSku");
          console.warn("[DEBUG availableLocations] Returning BASE locations (NOT enriched)");
          return baseLocations;
        }
        const configData = fullJson.configurable_array[selectedSku];
        console.log("[DEBUG availableLocations] configData keys:", Object.keys(configData));
        console.log("[DEBUG availableLocations] Has locations directly:", !!configData.locations);
        const locationsFromJson = configData.locations || [];
        console.log("[DEBUG availableLocations] locationsFromJson count:", locationsFromJson.length);
        console.log("[DEBUG availableLocations] All JSON location SKUs:", locationsFromJson.map((l) => l.sku));
        if (locationsFromJson.length > 0) {
          console.log("[DEBUG availableLocations] First JSON location:", locationsFromJson[0]);
          console.log("[DEBUG availableLocations] First JSON location imprint_lines:", (_d = locationsFromJson[0]) == null ? void 0 : _d.imprint_lines);
        }
        console.log("[DEBUG availableLocations] All base location SKUs:", baseLocations.map((l) => l.sku));
        const enrichedLocations = baseLocations.map((loc) => {
          const jsonLocation = locationsFromJson.find((jloc) => jloc.sku === loc.sku);
          const imprintLines = loc.imprint_lines || (jsonLocation == null ? void 0 : jsonLocation.imprint_lines) || 5;
          console.log(`[DEBUG availableLocations] Mapping location ${loc.sku}:`, {
            baseLocation: loc,
            "loc.imprint_lines (already exists?)": loc.imprint_lines,
            jsonLocation,
            "jsonLocation?.imprint_lines": jsonLocation == null ? void 0 : jsonLocation.imprint_lines,
            "FINAL imprintLines": imprintLines
          });
          return {
            ...loc,
            imprint_lines: imprintLines
            // Use existing or fallback
          };
        });
        console.log("[DEBUG availableLocations] FINAL enriched locations:", enrichedLocations);
        console.log("[DEBUG availableLocations] First enriched location:", enrichedLocations[0]);
        console.log("[useNewImprintStore] Enriched locations with imprint_lines:", enrichedLocations.length);
        return enrichedLocations;
      },
      /**
       * Get available colors from main imprint store
       */
      availableColors() {
        const imprintStore = useImprintStore();
        return imprintStore.availableColors || [];
      },
      /**
       * Get custom color fee from product data
       */
      customColorFee() {
        var _a;
        const imprintStore = useImprintStore();
        const configData = imprintStore.currentConfigurable2Data;
        return ((_a = configData == null ? void 0 : configData.imprint_data) == null ? void 0 : _a.custom_colour_fee) || 0;
      },
      /**
       * Get unique colors count for current imprint
       */
      currentUniqueColorsCount(state) {
        var _a, _b;
        const imprint = state.imprints[state.currentImprintKey];
        return ((_b = (_a = imprint == null ? void 0 : imprint.maxColorsTracking) == null ? void 0 : _a.uniqueColors) == null ? void 0 : _b.length) || 0;
      },
      /**
       * Check if max colors reached for current imprint
       */
      isMaxColorsReached(state) {
        var _a;
        const imprint = state.imprints[state.currentImprintKey];
        return ((_a = imprint == null ? void 0 : imprint.maxColorsTracking) == null ? void 0 : _a.isMaxReached) || false;
      },
      /**
       * Get unique colors array for current imprint
       */
      currentUniqueColors(state) {
        var _a;
        const imprint = state.imprints[state.currentImprintKey];
        return ((_a = imprint == null ? void 0 : imprint.maxColorsTracking) == null ? void 0 : _a.uniqueColors) || [];
      },
      /**
       * Check if has image line in current imprint
       */
      hasImageLine(state) {
        const imprint = state.imprints[state.currentImprintKey];
        if (!imprint) return false;
        return imprint.textLines.some((line) => line.type === "image");
      },
      /**
       * Get validation errors for current imprint
       */
      currentErrors(state) {
        const imprint = state.imprints[state.currentImprintKey];
        return (imprint == null ? void 0 : imprint.errors) || {};
      },
      /**
       * Get all currently selected location SKUs across all imprints
       * @returns {string[]} Array of location SKUs
       */
      usedLocationSkus(state) {
        return state.imprints.map((imprint) => {
          var _a;
          return (_a = imprint.selectedLocation) == null ? void 0 : _a.sku;
        }).filter(Boolean);
      },
      /**
       * Check if a location SKU is already used in any imprint
       * @param {Object} state
       * @returns {function(string): boolean}
       */
      isLocationUsed: (state) => (sku) => {
        if (!sku) return false;
        const usedSkus = state.imprints.map((imprint) => {
          var _a;
          return (_a = imprint.selectedLocation) == null ? void 0 : _a.sku;
        }).filter(Boolean);
        return usedSkus.includes(sku);
      },
      /**
       * Check if a location SKU is used in OTHER imprints (not current)
       * @param {Object} state
       * @returns {function(string, number|null): boolean}
       */
      isLocationUsedInOtherImprints: (state) => (sku, currentImprintKey = null) => {
        if (!sku) return false;
        const key = currentImprintKey !== null ? currentImprintKey : state.currentImprintKey;
        return state.imprints.some((imprint, index) => {
          var _a;
          if (index === key) return false;
          return ((_a = imprint.selectedLocation) == null ? void 0 : _a.sku) === sku;
        });
      },
      /**
       * Get available locations excluding already used ones
       * Useful for dropdowns when adding new imprints
       * @returns {Array} Filtered locations array
       */
      availableLocationsForNewImprint(state) {
        const imprintStore = useImprintStore();
        const allLocations = imprintStore.availableLocations || [];
        const usedSkus = state.usedLocationSkus;
        return allLocations.filter((loc) => !usedSkus.includes(loc.sku));
      }
    },
    actions: {
      /**
       * Get max_color for a given imprint method from product's fullJson config.
       * Each imprint method (SCRE, EMBR, DTG, etc.) can have its own max_color limit.
       * @param {string} methodSku
       * @returns {number|null} max colors allowed, or null if not configured
       */
      getMaxColorsForMethod(methodSku) {
        var _a, _b, _c;
        const imprintStore = useImprintStore();
        const maxColor = (_c = (_b = (_a = imprintStore.fullJson) == null ? void 0 : _a.configurable_array) == null ? void 0 : _b[methodSku]) == null ? void 0 : _c.max_color;
        return maxColor ? Number(maxColor) : null;
      },
      /**
       * Initialize store from product data
       */
      initializeFromProductData() {
        var _a, _b;
        const imprintStore = useImprintStore();
        const configData = imprintStore.currentConfigurable2Data;
        if (!configData) {
          console.warn("[useNewImprintStore] No configurable_2_data available");
          return;
        }
        const imprint = this.imprints[this.currentImprintKey];
        const selectedSku = (_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        const maxColors = this.getMaxColorsForMethod(selectedSku);
        if (maxColors !== null) {
          imprint.maxColorsTracking.maxColors = maxColors;
        }
        const locations = imprintStore.availableLocations;
        if (locations && locations.length > 0 && !imprint.selectedLocation.sku) {
          this.setLocation(locations[0]);
        }
        console.log("[useNewImprintStore] Initialized from product data", {
          maxColors: imprint.maxColorsTracking.maxColors,
          locations: locations == null ? void 0 : locations.length,
          colors: (_b = imprintStore.availableColors) == null ? void 0 : _b.length
        });
      },
      /**
       * ✅ NEW: Create empty method data structure
       * Used when initializing a new imprint method (Screen Print, Embroidery, etc.)
       * Each method gets its own isolated state for textLines, colors, images
       * 
       * @returns {Object} Empty method data structure
       */
      createEmptyMethodData() {
        return {
          messageType: "text",
          textLines: [
            {
              id: 0,
              randID: Date.now(),
              type: "message",
              selectedColor: null,
              selectedColorObj: null,
              customColor: false,
              message: "",
              showColorPicker: false
            }
          ],
          // imageData is NOT stored per-method — it lives on imprint directly (shared across methods)
          specialInstructions: "",
          maxLines: 5,
          errors: {},
          nextLineId: 1,
          applyToAll: {
            active: false,
            sourceLineId: null,
            sourceLineRandID: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          maxColorsTracking: {
            uniqueColors: [],
            maxColors: null,
            isMaxReached: false
          },
          customPantoneInputs: {},
          pendingColorSelection: {
            lineId: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          savedPantoneColors: []
        };
      },
      /**
       * ✅ NEW: Set active imprint method (Screen Print, Embroidery, DTG, etc.)
       * Switches between imprint methods while preserving each method's data
       * Auto-creates methodsData if it doesn't exist
       * 
       * IMPORTANT: This is called when user selects a different imprint method
       * Example: User switches from Screen Print (SCRE) to Embroidery (EMBR)
       * - Screen Print data is preserved in methodsData['SCRE']
       * - Embroidery gets clean slate in methodsData['EMBR']
       * - Switching back to Screen Print restores original data
       * 
       * @param {string} methodSku - Method SKU (e.g., 'SCRE', 'EMBR', 'DTG')
       * @param {number|null} imprintKey - Imprint index (defaults to current)
       */
      setActiveImprintMethod(methodSku, imprintKey = null) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) {
          console.warn("[useNewImprintStore] setActiveImprintMethod: Invalid imprint key", key);
          return;
        }
        const previousMethod = imprint.activeMethodSku;
        console.log("%c[METHOD-SWITCH] ▶ setActiveImprintMethod START", "color: orange; font-weight: bold", {
          from: previousMethod,
          to: methodSku,
          imprintKey: key,
          "imprint.messageType (before)": imprint.messageType,
          "imprint.imageData (before)": imprint.imageData ? "✅ HAS DATA" : "❌ NULL",
          "methodsData keys": Object.keys(imprint.methodsData),
          "methodsData[from].imageData": previousMethod ? ((_a = imprint.methodsData[previousMethod]) == null ? void 0 : _a.imageData) ? "✅ HAS DATA" : "❌ NULL" : "N/A",
          "methodsData[from].messageType": previousMethod ? (_b = imprint.methodsData[previousMethod]) == null ? void 0 : _b.messageType : "N/A"
        });
        if (!previousMethod && !imprint.methodsData[methodSku]) {
          console.log("[useNewImprintStore] First time setting method - migrating existing data");
          const targetMaxLines = ((_c = imprint.selectedLocation) == null ? void 0 : _c.imprintLines) || imprint.maxLines || 5;
          console.log("[useNewImprintStore] MIGRATION maxLines:", {
            "imprint.maxLines": imprint.maxLines,
            "imprint.selectedLocation?.imprintLines": (_d = imprint.selectedLocation) == null ? void 0 : _d.imprintLines,
            "targetMaxLines (final)": targetMaxLines
          });
          imprint.methodsData[methodSku] = {
            messageType: imprint.messageType || "text",
            textLines: ((_e = imprint.textLines) == null ? void 0 : _e.length) > 0 ? [...imprint.textLines] : [this.createEmptyMethodData().textLines[0]],
            specialInstructions: imprint.specialInstructions || "",
            maxLines: targetMaxLines,
            // ✅ Use maxLines from location, not default
            errors: imprint.errors || {},
            nextLineId: imprint.nextLineId || 1,
            applyToAll: imprint.applyToAll || this.createEmptyMethodData().applyToAll,
            maxColorsTracking: imprint.maxColorsTracking || this.createEmptyMethodData().maxColorsTracking,
            customPantoneInputs: imprint.customPantoneInputs || {},
            pendingColorSelection: imprint.pendingColorSelection || this.createEmptyMethodData().pendingColorSelection,
            savedPantoneColors: imprint.savedPantoneColors || []
          };
        }
        imprint.activeMethodSku = methodSku;
        if (!imprint.methodsData[methodSku]) {
          console.log("[useNewImprintStore] Creating new method data for:", methodSku);
          imprint.methodsData[methodSku] = this.createEmptyMethodData();
          const methodMaxColors = this.getMaxColorsForMethod(methodSku);
          if (methodMaxColors !== null) {
            imprint.methodsData[methodSku].maxColorsTracking.maxColors = methodMaxColors;
          }
          if ((_f = imprint.selectedLocation) == null ? void 0 : _f.imprintLines) {
            const targetMaxLines = imprint.selectedLocation.imprintLines;
            imprint.methodsData[methodSku].maxLines = targetMaxLines;
            const newData = imprint.methodsData[methodSku];
            const currentLines = newData.textLines.filter((l) => l.type === "message").length;
            console.log("[useNewImprintStore] Auto-adjusting lines for new method:", {
              method: methodSku,
              currentLines,
              targetMaxLines
            });
            if (currentLines < targetMaxLines) {
              const linesToAdd = targetMaxLines - currentLines;
              for (let i = 0; i < linesToAdd; i++) {
                newData.textLines.push({
                  id: newData.nextLineId++,
                  randID: Date.now() + i,
                  type: "message",
                  selectedColor: null,
                  selectedColorObj: null,
                  customColor: false,
                  message: "",
                  showColorPicker: false
                });
              }
              console.log("[useNewImprintStore] Added", linesToAdd, "lines for new method");
            } else if (currentLines > targetMaxLines) {
              const linesToRemove = currentLines - targetMaxLines;
              let removed = 0;
              for (let i = newData.textLines.length - 1; i >= 0 && removed < linesToRemove; i--) {
                if (newData.textLines[i].type === "message") {
                  newData.textLines.splice(i, 1);
                  removed++;
                }
              }
              console.log("[useNewImprintStore] Removed", removed, "lines for new method");
            }
          }
        }
        const activeData = imprint.methodsData[methodSku];
        console.log("%c[METHOD-SWITCH] Loading activeData for method:", "color: darkorange", methodSku, {
          "activeData.messageType": activeData.messageType,
          // imageData is shared (not per-method), so we show imprint.imageData
          "imprint.imageData (shared, unchanged)": imprint.imageData ? "✅ HAS DATA" : "❌ NULL"
        });
        imprint.messageType = activeData.messageType;
        imprint.textLines = activeData.textLines;
        imprint.specialInstructions = activeData.specialInstructions;
        imprint.maxLines = activeData.maxLines;
        imprint.errors = activeData.errors;
        imprint.nextLineId = Math.max(imprint.nextLineId, activeData.nextLineId);
        imprint.applyToAll = activeData.applyToAll;
        imprint.maxColorsTracking = activeData.maxColorsTracking;
        imprint.customPantoneInputs = activeData.customPantoneInputs;
        imprint.pendingColorSelection = { lineId: null, color: null, colorObj: null, customColor: false };
        imprint.textLines.forEach((line) => {
          line.showColorPicker = false;
        });
        imprint.savedPantoneColors = activeData.savedPantoneColors;
        if ((_g = imprint.selectedLocation) == null ? void 0 : _g.imprintLines) {
          const locationMaxLines = imprint.selectedLocation.imprintLines;
          console.log("[useNewImprintStore] Syncing maxLines from location:", {
            method: methodSku,
            "activeData.maxLines (before)": activeData.maxLines,
            "imprint.maxLines (before)": imprint.maxLines,
            "location.imprintLines": locationMaxLines,
            "will update to": locationMaxLines
          });
          activeData.maxLines = locationMaxLines;
          imprint.maxLines = locationMaxLines;
        }
        console.log("%c[METHOD-SWITCH] ✅ setActiveImprintMethod END", "color: green; font-weight: bold", {
          from: previousMethod,
          to: methodSku,
          "imprint.messageType (after)": imprint.messageType,
          "imprint.imageData (after)": imprint.imageData ? "✅ HAS DATA" : "❌ NULL",
          "methodsData[to].messageType": (_h = imprint.methodsData[methodSku]) == null ? void 0 : _h.messageType,
          "methodsData[to].imageData": ((_i = imprint.methodsData[methodSku]) == null ? void 0 : _i.imageData) ? "✅ HAS DATA" : "❌ NULL",
          "methodsData[from].imageData (saved)": previousMethod ? ((_j = imprint.methodsData[previousMethod]) == null ? void 0 : _j.imageData) ? "✅ HAS DATA" : "❌ NULL" : "N/A",
          textLinesCount: ((_k = activeData.textLines) == null ? void 0 : _k.length) || 0
        });
      },
      /**
       * Validate location selection for duplicate check
       * @param {string} locationSku - Location SKU to validate
       * @param {number|null} imprintKey - Optional imprint key to exclude from check (defaults to currentImprintKey)
       * @returns {Object} { valid: boolean, error: string|null }
       */
      validateLocationSelection(locationSku, imprintKey = null) {
        if (!locationSku) {
          return {
            valid: false,
            error: "Please select a location"
          };
        }
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const isUsedInOther = this.isLocationUsedInOtherImprints(locationSku, key);
        if (isUsedInOther) {
          return {
            valid: false,
            error: "This location is already used in another imprint. Please select a different location."
          };
        }
        return { valid: true, error: null };
      },
      /**
       * Set selected location
       * @param {ImprintLocation} location
       * @param {number|null} imprintKey - Optional imprint key (defaults to currentImprintKey)
       */
      setLocation(location2, imprintKey = null) {
        var _a;
        console.log("[DEBUG setLocation] START - Location:", location2.title, "imprint_lines:", location2.imprint_lines);
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) {
          console.log("[DEBUG setLocation] ERROR - Imprint not found for key:", key);
          return;
        }
        const newMaxLines = location2.imprint_lines || 5;
        console.log("[DEBUG setLocation] newMaxLines:", newMaxLines, "current textLines count:", imprint.textLines.length);
        const previousLocationSku = (_a = imprint.selectedLocation) == null ? void 0 : _a.sku;
        if (previousLocationSku && previousLocationSku !== location2.sku) {
          console.log("[setLocation] 💾 Saving textLines for previous location:", previousLocationSku);
          imprint.locationsData[previousLocationSku] = {
            textLines: [...imprint.textLines],
            // Deep copy
            nextLineId: imprint.nextLineId
          };
          console.log("[setLocation] Saved", imprint.textLines.length, "lines for", previousLocationSku);
        }
        imprint.selectedLocation = {
          sku: location2.sku,
          title: location2.title,
          imprintLines: newMaxLines
        };
        imprint.maxLines = newMaxLines;
        const savedLocationData = imprint.locationsData[location2.sku];
        if (savedLocationData) {
          console.log("[setLocation] 📚 Restoring textLines for location:", location2.sku);
          imprint.textLines = [...savedLocationData.textLines];
          imprint.nextLineId = savedLocationData.nextLineId;
          this.recalculateUniqueColors(key);
          console.log("[setLocation] ✅ Restored", imprint.textLines.length, "lines from saved data");
          console.log("[setLocation] Restored lines:", imprint.textLines.map((l) => {
            var _a2;
            return {
              id: l.id,
              type: l.type,
              message: (_a2 = l.message) == null ? void 0 : _a2.substring(0, 20),
              hasColor: !!l.selectedColor
            };
          }));
          if (imprint.errors.location) {
            delete imprint.errors.location;
          }
          if (imprint.errors.maxLines) {
            delete imprint.errors.maxLines;
          }
          if (imprint.activeMethodSku && imprint.methodsData[imprint.activeMethodSku]) {
            console.log("[useNewImprintStore] Syncing maxLines to active method:", {
              method: imprint.activeMethodSku,
              "methodsData.maxLines (before)": imprint.methodsData[imprint.activeMethodSku].maxLines,
              "newMaxLines": newMaxLines
            });
            imprint.methodsData[imprint.activeMethodSku].maxLines = newMaxLines;
          }
          console.log("[useNewImprintStore] Location restored:", location2.title, "Lines:", imprint.textLines.length);
          return;
        }
        console.log("[setLocation] No saved data for location:", location2.sku, "- will auto-adjust lines");
        const messageLines = imprint.textLines.filter((l) => l.type === "message");
        const currentCount = messageLines.length;
        console.log("[DEBUG setLocation] BEFORE auto-adjust - messageLines:", currentCount, "maxLines:", newMaxLines);
        if (currentCount > newMaxLines) {
          console.log("[DEBUG setLocation] REMOVING LINES - Need to remove:", currentCount - newMaxLines);
          const linesToRemove = currentCount - newMaxLines;
          console.log("[useNewImprintStore] Removing", linesToRemove, "excess lines. Current:", currentCount, "Max:", newMaxLines);
          let removed = 0;
          for (let i = imprint.textLines.length - 1; i >= 0 && removed < linesToRemove; i--) {
            if (imprint.textLines[i].type === "message") {
              imprint.textLines.splice(i, 1);
              removed++;
            }
          }
          this.recalculateUniqueColors(key);
          console.log("[DEBUG setLocation] AFTER REMOVAL - textLines count:", imprint.textLines.length);
        } else if (currentCount < newMaxLines) {
          console.log("[DEBUG setLocation] ADDING LINES - Need to add:", newMaxLines - currentCount);
          const linesToAdd = newMaxLines - currentCount;
          console.log("[useNewImprintStore] Adding", linesToAdd, "lines to reach max. Current:", currentCount, "Max:", newMaxLines);
          const imageLineIndex = imprint.textLines.findIndex((l) => l.type === "image");
          const insertIndex = imageLineIndex !== -1 ? imageLineIndex : imprint.textLines.length;
          for (let i = 0; i < linesToAdd; i++) {
            const newLine = {
              id: imprint.nextLineId++,
              randID: Date.now() + i,
              type: "message",
              selectedColor: imprint.applyToAll.active ? imprint.applyToAll.color : null,
              selectedColorObj: imprint.applyToAll.active ? imprint.applyToAll.colorObj : null,
              customColor: imprint.applyToAll.active ? imprint.applyToAll.customColor : false,
              message: "",
              showColorPicker: false
            };
            imprint.textLines.splice(insertIndex + i, 0, newLine);
          }
          console.log("[DEBUG setLocation] AFTER ADDING - textLines count:", imprint.textLines.length);
        } else {
          console.log("[DEBUG setLocation] NO CHANGE - Already correct count");
        }
        console.log("[DEBUG setLocation] FINAL - textLines:", imprint.textLines.length, "messageLines:", imprint.textLines.filter((l) => l.type === "message").length);
        if (imprint.errors.location) {
          delete imprint.errors.location;
        }
        if (imprint.errors.maxLines) {
          delete imprint.errors.maxLines;
        }
        if (imprint.activeMethodSku && imprint.methodsData[imprint.activeMethodSku]) {
          console.log("[useNewImprintStore] Syncing maxLines to active method:", {
            method: imprint.activeMethodSku,
            "methodsData.maxLines (before)": imprint.methodsData[imprint.activeMethodSku].maxLines,
            "newMaxLines": newMaxLines
          });
          imprint.methodsData[imprint.activeMethodSku].maxLines = newMaxLines;
        }
        console.log("[useNewImprintStore] Location set:", location2.title, "Max lines:", imprint.maxLines, "Current lines:", imprint.textLines.filter((l) => l.type === "message").length, "ImprintKey:", key);
      },
      /**
       * Set message type (text/image/text_image)
       * @param {string} type
       * @param {number|null} imprintKey - Optional imprint key
       */
      setMessageType(type, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        imprint.textLines.forEach((line) => {
          line.showColorPicker = false;
        });
        imprint.pendingColorSelection = { lineId: null, color: null, colorObj: null, customColor: false };
        const oldType = imprint.messageType;
        console.log("%c[MSG-TYPE] setMessageType called", "color: blue; font-weight: bold", {
          from: oldType,
          to: type,
          imprintKey: key,
          activeMethodSku: imprint.activeMethodSku
        });
        console.trace("[MSG-TYPE] call stack");
        imprint.messageType = type;
        if (imprint.activeMethodSku && imprint.methodsData[imprint.activeMethodSku]) {
          imprint.methodsData[imprint.activeMethodSku].messageType = type;
        }
        const existingImageLine = imprint.textLines.find((line) => line.type === "image");
        if ((type === "image" || type === "text_image") && oldType === "text") {
          if (!existingImageLine) {
            if (imprint.savedImageLineData) {
              const restoredImageLine = {
                ...imprint.savedImageLineData,
                id: imprint.nextLineId++,
                randID: Date.now(),
                showColorPicker: false
              };
              imprint.textLines.push(restoredImageLine);
              console.log("[useNewImprintStore] Restored saved image line data:", restoredImageLine);
            } else {
              const imageLine = {
                id: imprint.nextLineId++,
                randID: Date.now(),
                type: "image",
                selectedColor: imprint.applyToAll.active ? imprint.applyToAll.color : null,
                selectedColorObj: imprint.applyToAll.active ? imprint.applyToAll.colorObj : null,
                customColor: imprint.applyToAll.active ? imprint.applyToAll.customColor : false,
                message: "",
                showColorPicker: false
              };
              imprint.textLines.push(imageLine);
            }
          }
        } else if (type === "text" && oldType !== "text") {
          if (existingImageLine) {
            imprint.savedImageLineData = {
              type: existingImageLine.type,
              selectedColor: existingImageLine.selectedColor,
              selectedColorObj: existingImageLine.selectedColorObj,
              customColor: existingImageLine.customColor,
              message: existingImageLine.message
            };
            console.log("[useNewImprintStore] Saved image line data:", imprint.savedImageLineData);
          }
          imprint.textLines = imprint.textLines.filter((line) => line.type !== "image");
        }
        console.log("[useNewImprintStore] Message type set:", type, "ImprintKey:", key);
      },
      // Note: addTextLine() and removeTextLine() removed
      // Lines are automatically managed by setLocation() based on maxLines
      // All lines are shown on desktop - no manual add/remove needed
      /**
       * Update line text
       * @param {number} lineId
       * @param {string} text
       * @param {number|null} imprintKey - Optional imprint key
       */
      updateLineText(lineId, text, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (line) {
          line.message = text;
          if (text && text.trim()) {
            delete imprint.errors[`line${lineId}_message`];
          }
        }
      },
      /**
       * Set color for line
       * @param {number} lineId
       * @param {Object} color - Color object with {sku, desc, file_name}
       * @param {number|null} imprintKey - Optional imprint key
       */
      setLineColor(lineId, color, imprintKey = null) {
        var _a;
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (!line) return;
        const tracking = imprint.maxColorsTracking;
        const oldColorSku = ((_a = line.selectedColorObj) == null ? void 0 : _a.sku) || null;
        const newColorSku = color.sku;
        if (oldColorSku === newColorSku) {
          return;
        }
        const othersColors = /* @__PURE__ */ new Set();
        imprint.textLines.forEach((l) => {
          if (l.id === lineId) return;
          if (l.selectedColorObj && l.selectedColorObj.sku) {
            othersColors.add(l.selectedColorObj.sku);
          }
        });
        const prospectiveColors = new Set(othersColors);
        prospectiveColors.add(newColorSku);
        const maxColors = tracking.maxColors;
        const wouldExceedLimit = maxColors !== null && prospectiveColors.size > maxColors;
        if (wouldExceedLimit && oldColorSku) {
          imprint.textLines.forEach((l) => {
            if (l.selectedColorObj && l.selectedColorObj.sku === oldColorSku) {
              l.selectedColor = color.file_name;
              l.selectedColorObj = color;
              l.customColor = false;
              delete imprint.errors[`line${l.id}_color`];
            }
          });
          console.log("[useNewImprintStore] Cascaded colour rename:", oldColorSku, "->", newColorSku, "ImprintKey:", key);
        } else if (wouldExceedLimit && !oldColorSku) {
          return;
        } else {
          line.selectedColor = color.file_name;
          line.selectedColorObj = color;
          line.customColor = false;
          delete imprint.errors[`line${lineId}_color`];
        }
        this.recalculateUniqueColors(key);
        if (imprint.applyToAll.active && imprint.applyToAll.sourceLineId === lineId) {
          this.applyColorToAllLines(color, false, key);
        }
        console.log("[useNewImprintStore] Line color set:", lineId, color.desc, "ImprintKey:", key);
      },
      /**
       * Set custom/Pantone color for line
       * @param {number} lineId
       * @param {string} colorName - Pantone name
       * @param {number|null} imprintKey - Optional imprint key
       */
      setLineCustomColor(lineId, colorName, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (!line) return;
        line.selectedColor = colorName;
        line.selectedColorObj = null;
        line.customColor = true;
        delete imprint.errors[`line${lineId}_color`];
        if (imprint.applyToAll.active && imprint.applyToAll.sourceLineId === lineId) {
          this.applyColorToAllLines(colorName, true, key);
        }
        console.log("[useNewImprintStore] Line custom color set:", lineId, colorName, "ImprintKey:", key);
      },
      /**
       * Select color as pending (not applied yet - waiting for Add Colour button)
       * @param {number} lineId
       * @param {Object|string} color - Color object or Pantone name
       * @param {boolean} isCustom - Is custom/Pantone color
       * @param {number|null} imprintKey - Optional imprint key
       */
      selectPendingColor(lineId, color, isCustom, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        imprint.pendingColorSelection = {
          lineId,
          color: isCustom ? color : color.file_name,
          colorObj: isCustom ? null : color,
          customColor: isCustom
        };
        console.log("[useNewImprintStore] Pending color selected:", lineId, isCustom ? color : color.desc, "ImprintKey:", key);
      },
      /**
       * Apply pending color to line (triggered by Add Colour button)
       * @param {number} lineId
       * @param {number|null} imprintKey - Optional imprint key
       */
      applyPendingColor(lineId, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const pending2 = imprint.pendingColorSelection;
        if (!pending2 || !pending2.color || pending2.lineId !== lineId) {
          console.warn("[useNewImprintStore] No pending color to apply for line:", lineId);
          return;
        }
        if (pending2.customColor) {
          this.setLineCustomColor(lineId, pending2.color, key);
        } else {
          this.setLineColor(lineId, pending2.colorObj, key);
        }
        imprint.pendingColorSelection = {
          lineId: null,
          color: null,
          colorObj: null,
          customColor: false
        };
        console.log("[useNewImprintStore] Pending color applied to line:", lineId, "ImprintKey:", key);
      },
      /**
       * Add Pantone color to saved list
       * @param {string} pantoneValue - Pantone name
       * @param {number|null} imprintKey - Optional imprint key
       */
      addSavedPantoneColor(pantoneValue, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        if (imprint.savedPantoneColors.includes(pantoneValue)) {
          console.log("[useNewImprintStore] Pantone color already saved:", pantoneValue);
          return;
        }
        imprint.savedPantoneColors.push(pantoneValue);
        console.log("[useNewImprintStore] Pantone color saved:", pantoneValue, "Total:", imprint.savedPantoneColors.length);
      },
      /**
       * Always open color picker for line (no toggle - used when clicking/focusing text input)
       * Closes all other open pickers for cleaner UX.
       * @param {number} lineId
       * @param {number|null} imprintKey - Optional imprint key
       */
      openColorPicker(lineId, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (!line) return;
        imprint.textLines.forEach((l) => {
          if (l.id !== lineId) l.showColorPicker = false;
        });
        line.showColorPicker = true;
      },
      /**
       * Toggle color picker visibility for line
       * @param {number} lineId
       * @param {number|null} imprintKey - Optional imprint key
       */
      toggleColorPicker(lineId, imprintKey = null) {
        var _a, _b;
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        console.log("[useNewImprintStore] toggleColorPicker called:", {
          lineId,
          imprintKey: key,
          imprintFound: !!imprint,
          textLinesCount: (_a = imprint == null ? void 0 : imprint.textLines) == null ? void 0 : _a.length,
          textLineIds: (_b = imprint == null ? void 0 : imprint.textLines) == null ? void 0 : _b.map((l) => ({ id: l.id, type: l.type }))
        });
        if (!imprint) {
          console.error("[useNewImprintStore] toggleColorPicker: imprint not found for key", key);
          return;
        }
        const line = imprint.textLines.find((l) => l.id === lineId);
        console.log("[useNewImprintStore] toggleColorPicker: line found:", !!line, "id searched:", lineId);
        if (line) {
          const isOpening = !line.showColorPicker;
          line.showColorPicker = isOpening;
          console.log("[useNewImprintStore] toggleColorPicker: showColorPicker set to", isOpening);
          if (!isOpening && imprint.pendingColorSelection.lineId === lineId) {
            imprint.pendingColorSelection = {
              lineId: null,
              color: null,
              colorObj: null,
              customColor: false
            };
          }
        } else {
          console.error(
            "[useNewImprintStore] toggleColorPicker: LINE NOT FOUND! id:",
            lineId,
            "available ids:",
            imprint.textLines.map((l) => l.id)
          );
        }
      },
      /**
       * Force-open colour picker for a specific line.
       * Closes other message-line pickers so only one is visible at a time.
       * Used when user focuses a text input — no toggle, only opens.
       * @param {number} lineId
       * @param {number|null} imprintKey
       */
      openColorPicker(lineId, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (!line) return;
        imprint.textLines.forEach((l) => {
          if (l.type === "message" && l.id !== lineId && l.showColorPicker) {
            l.showColorPicker = false;
            if (imprint.pendingColorSelection.lineId === l.id) {
              imprint.pendingColorSelection = {
                lineId: null,
                color: null,
                colorObj: null,
                customColor: false
              };
            }
          }
        });
        line.showColorPicker = true;
        console.log("[useNewImprintStore] openColorPicker:", lineId, "ImprintKey:", key);
      },
      /**
       * Toggle Apply to All
       * @param {number} sourceLineId - Line ID to use as source
       * @param {number|null} imprintKey - Optional imprint key (CRITICAL: prevents cross-imprint contamination)
       */
      toggleApplyToAll(sourceLineId, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const sourceLine = imprint.textLines.find((l) => l.id === sourceLineId);
        if (!sourceLine) return;
        if (!imprint.applyToAll.active) {
          imprint.applyToAll.active = true;
          imprint.applyToAll.sourceLineId = sourceLineId;
          imprint.applyToAll.sourceLineRandID = sourceLine.randID;
          imprint.applyToAll.color = sourceLine.selectedColor;
          imprint.applyToAll.colorObj = sourceLine.selectedColorObj;
          imprint.applyToAll.customColor = sourceLine.customColor;
          if (sourceLine.selectedColor) {
            this.applyColorToAllLines(
              sourceLine.customColor ? sourceLine.selectedColor : sourceLine.selectedColorObj,
              sourceLine.customColor,
              key
            );
          }
          console.log("[useNewImprintStore] Apply to All activated:", sourceLineId, "ImprintKey:", key);
        } else {
          imprint.applyToAll.active = false;
          imprint.applyToAll.sourceLineId = null;
          imprint.applyToAll.sourceLineRandID = null;
          imprint.applyToAll.color = null;
          imprint.applyToAll.colorObj = null;
          imprint.applyToAll.customColor = false;
          imprint.textLines.forEach((line) => {
            if (line.id !== sourceLineId) {
              line.selectedColor = null;
              line.selectedColorObj = null;
              line.customColor = false;
            }
          });
          this.recalculateUniqueColors(key);
          console.log("[useNewImprintStore] Apply to All deactivated. ImprintKey:", key);
        }
      },
      /**
       * Apply color to all lines (except source)
       * @param {Object|string} color - Color object or Pantone name
       * @param {boolean} isCustom - Is custom/Pantone color
       * @param {number|null} imprintKey - Optional imprint key
       */
      applyColorToAllLines(color, isCustom, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        imprint.textLines.forEach((line) => {
          if (line.id !== imprint.applyToAll.sourceLineId) {
            if (isCustom) {
              line.selectedColor = color;
              line.selectedColorObj = null;
              line.customColor = true;
            } else {
              line.selectedColor = color.file_name;
              line.selectedColorObj = color;
              line.customColor = false;
            }
          }
        });
        this.recalculateUniqueColors(key);
      },
      /**
       * Recalculate unique colors array
       * @param {number|null} imprintKey - Optional imprint key
       */
      recalculateUniqueColors(imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        const tracking = imprint.maxColorsTracking;
        const uniqueSkus = /* @__PURE__ */ new Set();
        imprint.textLines.forEach((line) => {
          if (line.selectedColorObj && line.selectedColorObj.sku) {
            uniqueSkus.add(line.selectedColorObj.sku);
          }
        });
        tracking.uniqueColors = Array.from(uniqueSkus);
        tracking.isMaxReached = tracking.maxColors !== null && tracking.uniqueColors.length >= tracking.maxColors;
        console.log("[useNewImprintStore] Unique colors:", tracking.uniqueColors.length, "/", tracking.maxColors, "ImprintKey:", key);
      },
      /**
       * Update unique colors after line removal
       * @param {Object} line - Line being removed
       * @param {number|null} imprintKey - Optional imprint key
       */
      updateUniqueColorsAfterRemoval(line, imprintKey = null) {
        if (!line.selectedColorObj || !line.selectedColorObj.sku) return;
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        const colorSku = line.selectedColorObj.sku;
        const otherLineWithSameColor = imprint.textLines.find(
          (l) => {
            var _a;
            return l.id !== line.id && ((_a = l.selectedColorObj) == null ? void 0 : _a.sku) === colorSku;
          }
        );
        if (!otherLineWithSameColor) {
          const tracking = imprint.maxColorsTracking;
          tracking.uniqueColors = tracking.uniqueColors.filter((sku) => sku !== colorSku);
          tracking.isMaxReached = tracking.maxColors !== null && tracking.uniqueColors.length >= tracking.maxColors;
        }
      },
      /**
       * Set special instructions
       * @param {string} text
       * @param {number|null} imprintKey - Optional imprint key
       */
      setSpecialInstructions(text, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (imprint) {
          imprint.specialInstructions = text;
        }
      },
      /**
       * Set image data
       * @param {Object} data
       * @param {number|null} imprintKey - Optional imprint key
       */
      setImageData(data, imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (imprint) {
          imprint.imageData = data;
          console.log("[IMAGE-DEBUG] setImageData called:", {
            imprintKey: key,
            hasData: !!data,
            activeMethodSku: imprint.activeMethodSku
          });
        }
      },
      /**
       * Validate current imprint
       * @param {number|null} imprintKey - Optional imprint key
       * @returns {boolean} - True if valid
       */
      validate(imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return false;
        console.log("[VALIDATE] Starting validation for imprintKey:", key);
        console.log("[VALIDATE] Message type:", imprint.messageType);
        console.log("[VALIDATE] Text lines count:", imprint.textLines.length);
        imprint.errors = {};
        const appStore = useAppStore();
        if (appStore.isEnvelopProduct) {
          console.log("[VALIDATE] Envelop product - skipping all validation");
          return true;
        }
        if (!imprint.selectedLocation.sku) {
          imprint.errors.location = "Please select a location";
        }
        const messageLines = imprint.textLines.filter((l) => l.type === "message");
        const maxLines = imprint.maxLines || 5;
        if (messageLines.length > maxLines) {
          imprint.errors.maxLines = `This Imprint Location supports up to ${maxLines} ${maxLines === 1 ? "line" : "lines"} of imprint.`;
          console.log("[VALIDATE] Max lines exceeded:", messageLines.length, ">", maxLines);
        }
        if (imprint.messageType === "text" || imprint.messageType === "text_image") {
          const messageLines2 = imprint.textLines.filter((l) => l.type === "message");
          console.log("[VALIDATE] Message lines:", messageLines2.length);
          messageLines2.forEach((line, index) => {
            const hasText = line.message && line.message.trim().length > 0;
            const hasColor = !!line.selectedColor;
            console.log(`[VALIDATE] Line ${index + 1} (id=${line.id}): text="${line.message}", hasText=${hasText}, hasColor=${hasColor}`);
            if (index === 0) {
              if (!line.selectedColor) {
                imprint.errors[`line${line.id}_color`] = "Please select a color";
                console.log(`[VALIDATE] Added error: line${line.id}_color`);
              }
              if (!line.message || !line.message.trim()) {
                imprint.errors[`line${line.id}_message`] = "Please enter text";
                console.log(`[VALIDATE] Added error: line${line.id}_message`);
              }
            } else {
              if (hasText && !hasColor) {
                imprint.errors[`line${line.id}_color`] = "Please select a color";
                console.log(`[VALIDATE] Added error: line${line.id}_color (hasText but no color)`);
              }
            }
          });
          if (imprint.messageType === "text_image") {
            if (!imprint.imageData) {
              imprint.errors.image = "Please upload an image";
            }
            const imageLine = imprint.textLines.find((l) => l.type === "image");
            if (imageLine && !imageLine.selectedColor) {
              imprint.errors.imageColor = "Please select image color";
            }
          }
        } else if (imprint.messageType === "image") {
          if (!imprint.imageData) {
            imprint.errors.image = "Please upload an image";
          }
          const imageLine = imprint.textLines.find((l) => l.type === "image");
          if (imageLine && !imageLine.selectedColor) {
            imprint.errors.imageColor = "Please select image color";
          }
        }
        console.log("[VALIDATE] Total errors:", Object.keys(imprint.errors).length, imprint.errors);
        return Object.keys(imprint.errors).length === 0;
      },
      /**
       * Get imprint data for export/submission
       * @param {number|null} imprintKey - Optional imprint key
       * @returns {Object}
       */
      getImprintData(imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return null;
        return {
          location: imprint.selectedLocation,
          messageType: imprint.messageType,
          textLines: imprint.textLines.map((line) => ({
            id: line.id,
            randID: line.randID,
            type: line.type,
            message: line.message,
            selectedColor: line.selectedColor,
            selectedColorObj: line.selectedColorObj,
            customColor: line.customColor
          })),
          imageData: imprint.imageData,
          specialInstructions: imprint.specialInstructions,
          applyToAll: {
            active: imprint.applyToAll.active,
            sourceLineId: imprint.applyToAll.sourceLineId
          }
        };
      },
      /**
       * Reset current imprint to initial state
       * @param {number|null} imprintKey - Optional imprint key
       */
      resetCurrentImprint(imprintKey = null) {
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        if (!imprint) return;
        imprint.selectedLocation = {
          sku: null,
          title: null,
          imprintLines: 5
        };
        imprint.messageType = "text";
        imprint.textLines = [
          {
            id: 0,
            randID: Date.now(),
            type: "message",
            selectedColor: null,
            selectedColorObj: null,
            customColor: false,
            message: "",
            showColorPicker: false
          }
        ];
        imprint.imageData = null;
        imprint.specialInstructions = "";
        imprint.maxLines = 5;
        imprint.errors = {};
        imprint.nextLineId = 1;
        imprint.applyToAll = {
          active: false,
          sourceLineId: null,
          sourceLineRandID: null,
          color: null,
          colorObj: null,
          customColor: false
        };
        imprint.maxColorsTracking = {
          uniqueColors: [],
          maxColors: null,
          isMaxReached: false
        };
        imprint.customPantoneInputs = {};
        imprint.pendingColorSelection = {
          lineId: null,
          color: null,
          colorObj: null,
          customColor: false
        };
        imprint.savedPantoneColors = [];
        imprint.locationsData = {};
        console.log("[useNewImprintStore] Current imprint reset. ImprintKey:", key);
      },
      /**
       * Add new imprint (for multiple imprints support)
       * FIXED: Copy maxLines from first imprint if it has a selected location
       */
      addNewImprint() {
        var _a, _b, _c, _d, _e, _f;
        const newIndex = this.imprints.length;
        const timestamp = Date.now();
        const firstImprint = this.imprints[0];
        const initialMaxLines = ((_b = (_a = firstImprint == null ? void 0 : firstImprint.methodsData) == null ? void 0 : _a[firstImprint.activeMethodSku]) == null ? void 0 : _b.maxLines) || ((_c = firstImprint == null ? void 0 : firstImprint.selectedLocation) == null ? void 0 : _c.imprintLines) || (firstImprint == null ? void 0 : firstImprint.maxLines) || 5;
        console.log("[useNewImprintStore] addNewImprint - copying maxLines from first imprint:", {
          firstImprintHasLocation: !!((_d = firstImprint == null ? void 0 : firstImprint.selectedLocation) == null ? void 0 : _d.sku),
          firstImprintMaxLines: (_e = firstImprint == null ? void 0 : firstImprint.selectedLocation) == null ? void 0 : _e.imprintLines,
          initialMaxLines
        });
        const newImprint = {
          selectedLocation: {
            sku: null,
            title: null,
            imprintLines: initialMaxLines
            // ✅ Use maxLines from first imprint
          },
          // ✅ CRITICAL FIX: Add methodsData and activeMethodSku fields
          // Without these, setActiveImprintMethod() cannot save data properly
          methodsData: {},
          activeMethodSku: null,
          // ✅ NEW: Locations data (empty for new imprint)
          locationsData: {},
          messageType: "text",
          // Initialize with correct number of lines based on first imprint's location
          textLines: [],
          // Will be populated below
          imageData: null,
          specialInstructions: "",
          maxLines: initialMaxLines,
          // ✅ Use maxLines from first imprint
          errors: {},
          nextLineId: 0,
          // Will be incremented as lines are added
          applyToAll: {
            active: false,
            sourceLineId: null,
            sourceLineRandID: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          maxColorsTracking: {
            uniqueColors: [],
            maxColors: null,
            isMaxReached: false
          },
          customPantoneInputs: {},
          pendingColorSelection: {
            lineId: null,
            color: null,
            colorObj: null,
            customColor: false
          },
          savedPantoneColors: []
        };
        for (let i = 0; i < initialMaxLines; i++) {
          newImprint.textLines.push({
            id: newImprint.nextLineId++,
            randID: timestamp + i,
            type: "message",
            selectedColor: null,
            selectedColorObj: null,
            customColor: false,
            message: "",
            showColorPicker: false
          });
        }
        console.log("[useNewImprintStore] addNewImprint - created textLines:", {
          initialMaxLines,
          textLinesCreated: newImprint.textLines.length
        });
        this.imprints.push(newImprint);
        const imprintStore = useImprintStore();
        const selectedMethod = imprintStore.selectedImprintMethod;
        const currentMethodSku = selectedMethod == null ? void 0 : selectedMethod.sku;
        console.log("[useNewImprintStore] BEFORE auto-initializing method:", {
          newIndex,
          selectedMethod,
          currentMethodSku,
          typeOfSku: typeof currentMethodSku,
          "newImprint.activeMethodSku (before)": this.imprints[newIndex].activeMethodSku,
          "newImprint.methodsData (before)": Object.keys(this.imprints[newIndex].methodsData || {})
        });
        if (currentMethodSku && typeof currentMethodSku === "string") {
          console.log("[useNewImprintStore] Calling setActiveImprintMethod with:", {
            newIndex,
            methodSku: currentMethodSku
          });
          this.setActiveImprintMethod(currentMethodSku, newIndex);
          console.log("[useNewImprintStore] AFTER setActiveImprintMethod:", {
            "newImprint.activeMethodSku (after)": this.imprints[newIndex].activeMethodSku,
            "newImprint.methodsData (after)": Object.keys(this.imprints[newIndex].methodsData || {}),
            "newImprint.maxLines (after)": this.imprints[newIndex].maxLines,
            "newImprint.textLines.length (after)": (_f = this.imprints[newIndex].textLines) == null ? void 0 : _f.length
          });
        } else {
          console.error("[useNewImprintStore] Cannot auto-initialize method - invalid SKU:", {
            currentMethodSku,
            typeOfSku: typeof currentMethodSku,
            selectedMethod
          });
        }
        console.log("[useNewImprintStore] New imprint added:", {
          newIndex,
          totalImprints: this.imprints.length,
          newImprintLocation: newImprint.selectedLocation,
          newImprintMaxLines: newImprint.maxLines,
          newImprintTextLinesCount: newImprint.textLines.length,
          currentImprintKey: this.currentImprintKey
        });
      },
      /**
       * Switch to different imprint
       * @param {number} index
       */
      switchToImprint(index) {
        if (index >= 0 && index < this.imprints.length) {
          this.currentImprintKey = index;
          console.log("[useNewImprintStore] Switched to imprint:", index);
        }
      },
      /**
       * Delete imprint by index
       * @param {number} index
       */
      deleteImprint(index) {
        if (index === 0) {
          console.warn("[useNewImprintStore] Cannot delete first imprint");
          return;
        }
        if (index >= this.imprints.length) {
          console.warn("[useNewImprintStore] Invalid imprint index:", index);
          return;
        }
        this.imprints.splice(index, 1);
        if (this.currentImprintKey >= this.imprints.length) {
          this.currentImprintKey = this.imprints.length - 1;
        }
        console.log("[useNewImprintStore] Imprint deleted:", index, "Total imprints:", this.imprints.length);
      },
      /**
       * Transform imprint data to cart payload format (Start New Imprint)
       * Returns imprint_lines and properties objects ready for cart
       * @param {number|null} imprintKey - Optional imprint key (defaults to currentImprintKey)
       * @param {Object} priceData - Price data from useAddToCartStore (includes tier pricing)
       * @returns {Object} { imprint_lines, properties, fees }
       */
      transformToCartPayload(imprintKey = null, priceData = null) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const key = imprintKey !== null ? imprintKey : this.currentImprintKey;
        const imprint = this.imprints[key];
        console.log("[transformToCartPayload] key:", key);
        console.log("[transformToCartPayload] imprint:", imprint);
        if (!imprint) {
          console.error("[useNewImprintStore] Invalid imprint key:", key);
          console.error("[useNewImprintStore] Available keys:", Object.keys(this.imprints));
          return null;
        }
        const imprintStore = useImprintStore();
        const filledLines = imprint.textLines.filter((line) => {
          const messageType2 = imprint.messageType || "text";
          if (line.type === "message") {
            if (messageType2 === "image") {
              return false;
            }
            return !!(line.message && line.message.trim() && line.selectedColor);
          }
          if (line.type === "image") {
            if (messageType2 === "text") {
              return false;
            }
            const hasImage2 = !!imprint.imageData;
            const hasImageColor = !!(line.selectedColor || line.selectedColorObj);
            return hasImage2 && hasImageColor;
          }
          return false;
        });
        const imprintLines = {};
        let lineNum = 1;
        filledLines.forEach((line) => {
          var _a2, _b2, _c2;
          if (line.type === "message") {
            imprintLines[`line${lineNum}`] = {
              type: line.customColor ? "custom_color" : "standard_color",
              color: line.customColor ? line.selectedColor : ((_b2 = (_a2 = line.selectedColorObj) == null ? void 0 : _a2.file_name) == null ? void 0 : _b2.replace(".png", "")) || ""
            };
            lineNum++;
          } else if (line.type === "image") {
            if ((imprint.messageType === "text_image" || imprint.messageType === "image") && line.selectedColorObj) {
              imprintLines["line_img"] = {
                type: "standard_color",
                color: ((_c2 = line.selectedColorObj.file_name) == null ? void 0 : _c2.replace(".png", "")) || ""
              };
            }
          }
        });
        const properties = {
          "Imprint location": imprint.selectedLocation.title || "",
          "_Imprint Location SKU": imprint.selectedLocation.sku || "",
          "Imprint Method": ((_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.name) || "",
          "_Imprint Method SKU": ((_b = imprintStore.selectedImprintMethod) == null ? void 0 : _b.sku) || "",
          "_colorUpcharge": imprintStore.colorUpcharge || {},
          "_sizeUpcharge": imprintStore.sizeUpcharge || {}
        };
        lineNum = 1;
        filledLines.forEach((line) => {
          var _a2, _b2, _c2;
          if (line.type === "message") {
            properties[`Line ${lineNum} text`] = line.message || "";
            properties[`Line ${lineNum} color`] = line.customColor ? line.selectedColor : ((_b2 = (_a2 = line.selectedColorObj) == null ? void 0 : _a2.file_name) == null ? void 0 : _b2.replace(".png", "")) || "";
            if (!line.customColor && ((_c2 = line.selectedColorObj) == null ? void 0 : _c2.sku)) {
              properties[`_Imprint Line ${lineNum} Color SKU`] = line.selectedColorObj.sku;
            }
            lineNum++;
          }
        });
        if (imprint.imageData) {
          const imageLine = imprint.textLines.find((l) => l.type === "image");
          properties["Add an Image Filename"] = imprint.imageData.filename || "";
          properties["_Add an Image Url"] = imprint.imageData.url || "";
          if (imageLine && imageLine.selectedColorObj) {
            properties["Add an Image Color"] = ((_c = imageLine.selectedColorObj.file_name) == null ? void 0 : _c.replace(".png", "")) || "";
            properties["_Add an Image Color SKU"] = imageLine.selectedColorObj.sku || "";
          }
        }
        const selectionStore = useSelectionStore();
        properties["Special Instruction"] = selectionStore.specialInstructions || "";
        const uniqueColorsCount = getUniqueColorsCount(imprint);
        const uniqueCustomColorsCount = getUniqueCustomColorsCount(imprint);
        const imageDataExists = !!imprint.imageData;
        const messageType = imprint.messageType || "text";
        const messageTypeAllowsImage = messageType === "image" || messageType === "text_image";
        const hasImage = imageDataExists && messageTypeAllowsImage;
        const isComda = ((_e = (_d = window.Shopify) == null ? void 0 : _d.shop) == null ? void 0 : _e.includes("comda")) ?? true;
        const sku = (_f = imprintStore.selectedImprintMethod) == null ? void 0 : _f.sku;
        let backendConfig = {};
        if (sku && ((_h = (_g = imprintStore.fullJson) == null ? void 0 : _g.configurable_array) == null ? void 0 : _h[sku])) {
          const imprintData = (_i = imprintStore.fullJson.configurable_array[sku].configurable_2_data) == null ? void 0 : _i.imprint_data;
          if (imprintData) {
            backendConfig = {
              setup_fee: imprintData.setup_fee || 0,
              running_fee: imprintData.running_fee || 0,
              custom_colour_fee: imprintData.custom_colour_fee || 0,
              image_fee: imprintData.image_fee || 0,
              proof_fee: imprintData.proof_fee || 0
            };
          }
        }
        console.log("[useNewImprintStore] Backend fee config:", backendConfig);
        const fees = calculateAllFees({
          uniqueColorsCount,
          totalQuantity: 1,
          // Will be multiplied by actual quantity later
          hasPantoneColor: uniqueCustomColorsCount,
          hasImage,
          artworkMethod: "new",
          isComda,
          backendConfig
          // ✅ Pass backend config for correct rates
        });
        const appStore = useAppStore();
        properties["_price_details"] = {
          tier: (priceData == null ? void 0 : priceData.tier) || [],
          b2bTier: appStore.getB2BTierForSku(sku) ?? null,
          tierMSRP: (priceData == null ? void 0 : priceData.tierMSRP) || 0,
          priceByQty: (priceData == null ? void 0 : priceData.priceByQty) || 0,
          priceSizeUpcharge: (priceData == null ? void 0 : priceData.priceSizeUpcharge) || 0,
          priceColorUpcharge: (priceData == null ? void 0 : priceData.priceColorUpcharge) || 0,
          setup_fee: fees.setup_fee,
          // Uses correct COMDA/NON-COMDA formula
          setup_fee_qty: fees.setup_fee_qty,
          setup_fee_unit_price: fees.setup_fee_unit_price,
          proof_fee: fees.proof_fee,
          // $5 standard
          proof_fee_unit_price: fees.proof_fee_unit_price,
          image_fee: fees.image_fee,
          // $25 if has image
          image_fee_qty: fees.image_fee_qty,
          image_fee_unit_price: fees.image_fee_unit_price,
          customColourFee: fees.customColourFee,
          // $50 if Pantone
          customColourFee_qty: fees.customColourFee_qty,
          customColourFee_unit_price: fees.customColourFee_unit_price,
          running_fee_multiplier: fees.running_fee_multiplier,
          running_fee_rate: fees.running_fee_rate,
          running_fee: 0
          // Running fee is NOT in _price_details (it's per-item)
        };
        console.log("[useNewImprintStore] Transform to cart payload:", {
          imprintKey: key,
          totalLines: imprint.textLines.length,
          filledLines: filledLines.length,
          uniqueColorsCount,
          uniqueCustomColorsCount,
          imageDataExists,
          messageType,
          messageTypeAllowsImage,
          hasImage,
          isComda,
          fees
        });
        return {
          imprint_lines: imprintLines,
          properties,
          fees
          // Return fees object for use by addToCart
        };
      },
      /**
       * Get cart properties for all imprints (for multiple imprints)
       * @returns {Array} Array of { imprint_lines, properties } objects
       */
      getAllImprintsCartPayload() {
        const payloads = [];
        for (let i = 0; i < this.imprints.length; i++) {
          const payload = this.transformToCartPayload(i);
          if (payload) {
            payloads.push({
              imprintIndex: i,
              ...payload
            });
          }
        }
        console.log("[useNewImprintStore] All imprints payload:", payloads.length, "imprints");
        return payloads;
      },
      // ====================================
      // SESSION STORAGE PERSISTENCE
      // ====================================
      /**
       * Save imprints state to sessionStorage
       * Called before redirect to preserve user data
       */
      saveToSessionStorage() {
        try {
          const data = {
            version: STORAGE_VERSION$1,
            timestamp: Date.now(),
            productKey: window.location.pathname,
            // ✅ NEW: Save product pathname for validation
            currentImprintKey: this.currentImprintKey,
            imprints: this.imprints.map((imprint) => ({
              // Location
              selectedLocation: imprint.selectedLocation,
              // Methods data (CRITICAL - preserves all method states)
              methodsData: imprint.methodsData,
              activeMethodSku: imprint.activeMethodSku,
              // ✅ NEW: Locations data (preserves textLines per location)
              locationsData: imprint.locationsData,
              // Legacy fields (for backwards compatibility)
              messageType: imprint.messageType,
              textLines: imprint.textLines,
              imageData: imprint.imageData,
              specialInstructions: imprint.specialInstructions,
              maxLines: imprint.maxLines,
              // Apply to All state
              applyToAll: imprint.applyToAll,
              // Max colors tracking
              maxColorsTracking: imprint.maxColorsTracking,
              // Saved Pantone colors
              savedPantoneColors: imprint.savedPantoneColors,
              // Saved image line data
              savedImageLineData: imprint.savedImageLineData
            }))
          };
          sessionStorage.setItem(STORAGE_KEY$2, JSON.stringify(data));
          console.log("[useNewImprintStore] 💾 State saved to sessionStorage:", {
            imprints: data.imprints.length,
            currentKey: data.currentImprintKey
          });
          return true;
        } catch (error) {
          console.error("[useNewImprintStore] ❌ Failed to save to sessionStorage:", error);
          return false;
        }
      },
      /**
       * Restore imprints state from sessionStorage
       * Called on page load to recover user data after redirect
       */
      restoreFromSessionStorage() {
        try {
          const raw = sessionStorage.getItem(STORAGE_KEY$2);
          if (!raw) {
            console.log("[useNewImprintStore] No saved state found in sessionStorage");
            return false;
          }
          const data = JSON.parse(raw);
          if (data.version !== STORAGE_VERSION$1) {
            console.warn("[useNewImprintStore] ⚠️ Storage version mismatch");
            this.clearSessionStorage();
            return false;
          }
          const currentProductKey = window.location.pathname;
          if (data.productKey && data.productKey !== currentProductKey) {
            console.warn("[useNewImprintStore] ⚠️ Product key mismatch:", {
              stored: data.productKey,
              current: currentProductKey
            });
            console.log("[useNewImprintStore] Clearing storage from different product");
            this.clearSessionStorage();
            return false;
          }
          const age = Date.now() - data.timestamp;
          if (age > STORAGE_TTL) {
            console.warn("[useNewImprintStore] ⚠️ Storage data expired (age:", Math.round(age / 1e3), "seconds)");
            this.clearSessionStorage();
            return false;
          }
          this.currentImprintKey = data.currentImprintKey;
          this.imprints = data.imprints.map((savedImprint) => {
            const imprint = {
              // Location
              selectedLocation: savedImprint.selectedLocation || {
                sku: null,
                title: null,
                imprintLines: 5
              },
              // Methods data (CRITICAL!)
              methodsData: savedImprint.methodsData || {},
              activeMethodSku: savedImprint.activeMethodSku || null,
              // ✅ NEW: Locations data (CRITICAL!)
              locationsData: savedImprint.locationsData || {},
              // Legacy fields
              messageType: savedImprint.messageType || "text",
              textLines: savedImprint.textLines || [],
              imageData: savedImprint.imageData || null,
              specialInstructions: savedImprint.specialInstructions || "",
              maxLines: savedImprint.maxLines || 5,
              // Apply to All
              applyToAll: savedImprint.applyToAll || {
                active: false,
                sourceLineId: null,
                sourceLineRandID: null,
                color: null,
                colorObj: null,
                customColor: false
              },
              // Max colors tracking
              maxColorsTracking: savedImprint.maxColorsTracking || {
                uniqueColors: [],
                maxColors: null,
                isMaxReached: false
              },
              // Saved Pantone colors
              savedPantoneColors: savedImprint.savedPantoneColors || [],
              // Saved image line data
              savedImageLineData: savedImprint.savedImageLineData || null,
              // Fresh state (not saved)
              errors: {},
              nextLineId: Math.max(...(savedImprint.textLines || []).map((l) => l.id || 0), 0) + 1,
              customPantoneInputs: {},
              pendingColorSelection: {
                lineId: null,
                color: null,
                colorObj: null,
                customColor: false
              }
            };
            imprint.textLines = imprint.textLines.map((line) => ({
              ...line,
              randID: line.randID || Date.now() + Math.random() * 1e3,
              showColorPicker: false
            }));
            return imprint;
          });
          console.log("[useNewImprintStore] ✅ State restored from sessionStorage:", {
            imprints: this.imprints.length,
            currentKey: this.currentImprintKey,
            age: Math.round(age / 1e3) + "s ago"
          });
          return true;
        } catch (error) {
          console.error("[useNewImprintStore] ❌ Failed to restore from sessionStorage:", error);
          this.clearSessionStorage();
          return false;
        }
      },
      /**
       * Clear saved state from sessionStorage
       */
      clearSessionStorage() {
        try {
          sessionStorage.removeItem(STORAGE_KEY$2);
          console.log("[useNewImprintStore] 🗑️ SessionStorage cleared");
        } catch (error) {
          console.error("[useNewImprintStore] ❌ Failed to clear sessionStorage:", error);
        }
      }
    }
  });
  const useNewImprintStore$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    useNewImprintStore
  }, Symbol.toStringTag, { value: "Module" }));
  const STUDIO_PATH = "/apps/studio";
  const DEV_FALLBACK = "https://dev.api-customapp.comda.com/";
  function getEndpointsBase() {
    var _a, _b;
    const base = ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.api_beckend_url) || DEV_FALLBACK;
    return base.replace(/\/+$/, "") + STUDIO_PATH;
  }
  class DesignOnlineApiService {
    /**
     * Check if product supports Design Online
     * Supports two-phase loading:
     * - Phase 1 (fast): design_enabled=1, force_probe=0 (metafield short-circuit)
     * - Phase 2 (lazy): design_enabled=1, force_probe=1 (fetch URLs from Studio API)
     * 
     * @param {string} productId - Product ID from Shopify
     * @param {string} sku - Product SKU
     * @param {object} options - Optional parameters
     * @param {boolean} options.design_enabled - Product has design_enabled metafield
     * @param {boolean} options.force_probe - Force call to Studio API even with metafield
     */
    async canDesign(productId, sku, options = {}) {
      try {
        const finalProductId = productId;
        let url = `${getEndpointsBase()}/can-design?product_id=${encodeURIComponent(finalProductId)}`;
        if (sku) {
          url += `&sku=${encodeURIComponent(sku)}`;
        }
        if (options.design_enabled) {
          url += "&design_enabled=1";
        }
        if (options.force_probe) {
          url += "&force_probe=1";
        }
        url += "&lang_id=EN";
        console.log("[DesignOnlineApi] canDesign request:", { productId: finalProductId, sku, url });
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const data = await response.json();
        console.log("[DesignOnlineApi] canDesign response:", data);
        return {
          ok: !!data.ok,
          upload_center_url: data.upload_center_url || null,
          customize_studio_url: data.customize_studio_url || null,
          source: data.source || null
        };
      } catch (error) {
        console.error("[DesignOnlineApi] canDesign failed:", error);
        throw error;
      }
    }
    /**
     * Get redirect URL for editing existing design in studio
     * (must return URL that will come back with token_id + ex_response_param)
     */
    async getEditRedirectUrl({ tokenId, returnPage, returnUrl, userId }) {
      const url = `${getEndpointsBase()}/redirect-edit?token_id=${encodeURIComponent(tokenId)}&return_page=${encodeURIComponent(returnPage)}&return_url=${encodeURIComponent(returnUrl)}&user_id=${encodeURIComponent(userId)}&lang_id=EN`;
      console.log("[DesignOnlineApi] getEditRedirectUrl request:", url);
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      console.log("[DesignOnlineApi] getEditRedirectUrl response:", data);
      if (data.ok && data.url) return data.url;
      throw new Error("No redirect URL in response");
    }
    /**
     * Fetch available templates for a product from Studio.
     * Returns normalized list: [{ pid, tempid, type, title, preview_url }]
     */
    async getProductTemplates(productId, sku) {
      try {
        let url = `${getEndpointsBase()}/product-templates?product_id=${encodeURIComponent(productId)}&lang_id=EN`;
        if (sku) url += `&sku=${encodeURIComponent(sku)}`;
        console.log("[DesignOnlineApi] 📤 /product-templates REQUEST:", { productId, sku });
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        console.log("[DesignOnlineApi] ✅ /product-templates RESPONSE:", data);
        if (!data.ok) throw new Error(data.reason || "Templates request failed");
        return data.templates || [];
      } catch (error) {
        console.error("[DesignOnlineApi] getProductTemplates failed:", error);
        throw error;
      }
    }
    /**
     * Get redirect URL for creating design in studio.
     * Requires pid + tempid resolved from getProductTemplates().
     */
    async getRedirectUrl({ productId, sku, pid, tempid, type, returnPage, returnUrl, userId }) {
      try {
        if (!pid || !tempid) throw new Error("Missing pid/tempid for Studio redirect");
        let url = `${getEndpointsBase()}/redirect?pid=${encodeURIComponent(pid)}&tempid=${encodeURIComponent(tempid)}&type=${encodeURIComponent(type || "S")}&return_page=${encodeURIComponent(returnPage)}&return_url=${encodeURIComponent(returnUrl)}&user_id=${encodeURIComponent(userId)}`;
        if (productId) url += `&product_id=${encodeURIComponent(productId)}`;
        if (sku) url += `&sku=${encodeURIComponent(sku)}`;
        url += "&lang_id=EN";
        console.log("[DesignOnlineApi] 📤 /redirect REQUEST:", { pid, tempid, type, productId, url });
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        console.log("[DesignOnlineApi] ✅ /redirect RESPONSE:", data);
        if (data.ok && data.url) return data.url;
        throw new Error(data.reason || "No redirect URL in response");
      } catch (error) {
        console.error("[DesignOnlineApi] getRedirectUrl failed:", error);
        throw error;
      }
    }
    /**
     * Get redirect URL for upload center
     */
    async getUploadRedirectUrl({ productId, sku, uploadCenterUrl, returnPage, returnUrl, userId }) {
      try {
        const finalProductId = productId;
        let url = `${getEndpointsBase()}/redirect-upload?return_page=${encodeURIComponent(returnPage)}&return_url=${encodeURIComponent(returnUrl)}&user_id=${encodeURIComponent(userId)}&upload_center_url=${encodeURIComponent(uploadCenterUrl)}`;
        url += `&product_id=${encodeURIComponent(finalProductId)}`;
        if (sku) {
          url += `&sku=${encodeURIComponent(sku)}`;
        }
        url += "&lang_id=EN";
        console.log("[DesignOnlineApi] getUploadRedirectUrl request:", url);
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const data = await response.json();
        console.log("[DesignOnlineApi] getUploadRedirectUrl response:", data);
        if (data.ok && data.url) {
          return data.url;
        }
        throw new Error("No redirect URL in response");
      } catch (error) {
        console.error("[DesignOnlineApi] getUploadRedirectUrl failed:", error);
        throw error;
      }
    }
    /**
     * Get design template data after return from studio
     */
    async getTemplateData({ tokenId, exResponseParam, returnPage, returnUrl, userId }) {
      try {
        const url = `${getEndpointsBase()}/template?token_id=${encodeURIComponent(tokenId)}&ex_response_param=${encodeURIComponent(exResponseParam)}&user_id=${encodeURIComponent(userId)}&return_url=${encodeURIComponent(returnUrl)}&return_page=${encodeURIComponent(returnPage)}&lang_id=EN`;
        console.log("[DesignOnlineApi] 📤 /template REQUEST:", {
          url,
          tokenId,
          exResponseParam: exResponseParam.substring(0, 50) + "..."
        });
        const response = await fetch(url);
        console.log("[DesignOnlineApi] 📥 /template RESPONSE status:", response.status, response.statusText);
        if (!response.ok) {
          const errorText = await response.text();
          console.error("[DesignOnlineApi] ❌ /template ERROR response:", errorText);
          throw new Error(`HTTP ${response.status}: ${errorText}`);
        }
        const data = await response.json();
        console.log("[DesignOnlineApi] ✅ /template SUCCESS response:", data);
        console.log("[DesignOnlineApi] 🔑 design_url in response:", data.design_url);
        console.log("[DesignOnlineApi] 🖼️ preview_image in response:", data.preview_image);
        return {
          token_id: data.token_id || null,
          preview_image: data.preview_image || null,
          design_url: data.design_url || null,
          pdf_preview_url: data.pdf_preview_url || null,
          print_ready_file_url: data.print_ready_file_url || null
        };
      } catch (error) {
        console.error("[DesignOnlineApi] getTemplateData failed:", error);
        throw error;
      }
    }
  }
  const designOnlineApi = new DesignOnlineApiService();
  const STORAGE_KEY$1 = "design_online_v2";
  const RETURN_KEY = "design_online_return_v2";
  const STORAGE_VERSION = 2;
  const useDesignOnlineStore = /* @__PURE__ */ defineStore("designOnline", {
    state: () => ({
      // Design data
      tokenId: null,
      previewImage: null,
      editUrl: null,
      downloadUrl: null,
      pdfPreviewUrl: null,
      printReadyFileUrl: null,
      exResponseParam: null,
      // Studio config
      // productId is populated at runtime from DOM #ops_product_id (Shopify metafield custom.OPS_product_id)
      studioConfig: {
        productId: null
      },
      // UI state
      stage: "idle",
      // idle | chooser | preview | loading | error
      source: null,
      // create | upload | restored | null
      isLoading: false,
      error: null,
      // Approval
      isApproved: false,
      // Config URLs (from can-design API)
      uploadCenterUrl: null,
      customizeStudioUrl: null,
      // Support check cache
      isSupported: null,
      supportCheckDone: false,
      // Which product page the supportCheckDone refers to
      supportCheckProductKey: null,
      // Template selection (Variant A flow)
      templates: [],
      // list from /product-templates
      selectedTemplate: null
      // { pid, tempid, type, title, preview_url }
    }),
    getters: {
      hasDesign: (state) => !!(state.previewImage || state.pdfPreviewUrl || state.printReadyFileUrl),
      isReady: (state) => {
        const ready = state.tokenId && (state.previewImage || state.pdfPreviewUrl) && state.isApproved;
        if (typeof window !== "undefined" && window.__DESIGN_ONLINE_DEBUG__) {
          console.log("[AddToCart] isReady getter called:", {
            hasTokenId: !!state.tokenId,
            hasPreview: !!(state.previewImage || state.pdfPreviewUrl),
            isApproved: state.isApproved,
            result: ready
          });
        }
        return ready;
      },
      lineItemProperties: (state) => {
        if (!state.tokenId) return null;
        return {
          token_id: state.tokenId,
          pdf_preview_url: state.pdfPreviewUrl || "",
          print_ready_file_url: state.printReadyFileUrl || "",
          preview_image: state.previewImage || ""
        };
      },
      // Keep for backward compatibility if referenced somewhere,
      // but do NOT use this for storage identity anymore.
      currentProductKey: () => window.location.pathname + window.location.search
    },
    actions: {
      // ===================
      // API ACTIONS
      // ===================
      /**
       * Check if product supports Design Online
       * Supports two-phase loading strategy:
       * - Phase 1 (fast): options.design_enabled=true, force_probe=false
       * - Phase 2 (lazy): options.force_probe=true to fetch URLs
       * 
       * @param {string} productId - Shopify product ID
       * @param {string} sku - Product SKU
       * @param {object} options - Check options
       * @param {boolean} options.design_enabled - Product has design_enabled metafield
       * @param {boolean} options.force_probe - Force Studio API call to get URLs
       */
      async checkSupport(productId, sku, options = {}) {
        const currentKey = this.getStableProductKey();
        const hasUrls = !!this.uploadCenterUrl || !!this.customizeStudioUrl;
        console.log("[DO_NAV] 🔍 checkSupport() called:", {
          productId,
          sku,
          options,
          supportCheckDone: this.supportCheckDone,
          supportCheckProductKey: this.supportCheckProductKey,
          currentKey,
          hasUrls,
          currentProductKey: window.location.pathname
        });
        if (this.supportCheckDone && this.supportCheckProductKey === currentKey && !options.force_probe) {
          console.log("[DO_NAV] Support already checked for THIS product, skipping (isSupported:", this.isSupported, ")");
          return this.isSupported;
        }
        if (this.supportCheckDone && this.supportCheckProductKey !== currentKey && !options.force_probe) {
          console.log("[DO_NAV] Support was checked for a different product. Re-checking for current product...");
        }
        console.log("[DO_NAV] Proceeding with support check...");
        this.isLoading = true;
        this.error = null;
        try {
          console.log("[DO_NAV] Calling designOnlineApi.canDesign...");
          const result = await designOnlineApi.canDesign(productId, sku, options);
          console.log("[DO_NAV] API response:", {
            ok: result.ok,
            source: result.source,
            upload_center_url: result.upload_center_url,
            customize_studio_url: result.customize_studio_url
          });
          this.isSupported = result.ok;
          if (result.upload_center_url) {
            this.uploadCenterUrl = result.upload_center_url;
            console.log("[DO_NAV] ✅ uploadCenterUrl saved");
          }
          if (result.customize_studio_url) {
            this.customizeStudioUrl = result.customize_studio_url;
            console.log("[DO_NAV] ✅ customizeStudioUrl saved");
          }
          this.supportCheckDone = true;
          this.supportCheckProductKey = currentKey;
          console.log("[DO_NAV] ✅ supportCheckDone = true");
          console.log("[DO_NAV] Support check complete:", {
            supported: this.isSupported,
            source: result.source,
            hasUploadUrl: !!this.uploadCenterUrl,
            hasCustomizeUrl: !!this.customizeStudioUrl,
            forceProbe: options.force_probe || false
          });
          return this.isSupported;
        } catch (error) {
          console.error("[DesignOnline] Support check failed:", error);
          console.warn("[DesignOnline] Assuming supported (fallback mode)");
          this.isSupported = true;
          this.supportCheckDone = true;
          this.supportCheckProductKey = currentKey;
          this.error = null;
          return true;
        } finally {
          this.isLoading = false;
        }
      },
      // Fetch templates and either redirect immediately (1 template)
      // or show template selector (multiple templates).
      async startCreate(sku) {
        console.log("[DO_NAV] 🎨 startCreate() START", { sku });
        const productId = this.studioConfig.productId;
        if (!productId) {
          this.error = "Missing OPS product ID — initProductId() was not called";
          console.error("[DO_NAV] ❌", this.error);
          return;
        }
        this.isLoading = true;
        this.error = null;
        this.templates = [];
        this.selectedTemplate = null;
        try {
          const templates = await designOnlineApi.getProductTemplates(productId, sku);
          console.log("[DO_NAV] Templates loaded:", templates);
          if (!templates || templates.length === 0) {
            throw new Error("No templates available for this product");
          }
          await this.redirectWithTemplate(sku, templates[0]);
        } catch (error) {
          console.error("[DesignOnline] startCreate failed:", error);
          this.error = "Failed to load design templates. Please try again.";
          this.isLoading = false;
        }
      },
      // Redirect to Studio with a specific template's pid/tempid.
      async redirectWithTemplate(sku, template) {
        const productId = this.studioConfig.productId;
        console.log("[DO_NAV] redirectWithTemplate()", template);
        this.isLoading = true;
        this.error = null;
        try {
          const redirectUrl = await designOnlineApi.getRedirectUrl({
            productId,
            sku,
            pid: template.pid,
            tempid: template.tempid,
            type: template.type || "S",
            returnPage: this.getCleanReturnPage(),
            returnUrl: window.location.origin,
            userId: this.getCurrentUserId()
          });
          if (redirectUrl) {
            this.saveBeforeRedirect("create");
            window.location.href = redirectUrl;
          } else {
            throw new Error("No redirect URL received");
          }
        } catch (error) {
          console.error("[DesignOnline] redirectWithTemplate failed:", error);
          this.error = "Failed to start Design Online. Please try again.";
          this.isLoading = false;
        }
      },
      setStudioConfig(patch) {
        this.studioConfig = { ...this.studioConfig, ...patch || {} };
      },
      // Read OPS product ID from DOM and store it in studioConfig.
      // Call this once on component mount before checkSupport().
      // Returns the product ID string or null if not found.
      initProductId() {
        var _a, _b;
        const id = ((_b = (_a = document.getElementById("ops_product_id")) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim()) || null;
        if (id) {
          this.studioConfig = { ...this.studioConfig, productId: id };
          console.log("[DesignOnline] OPS productId from DOM:", id);
        } else {
          console.warn("[DesignOnline] #ops_product_id not found or empty — Design Online not available for this product");
          this.isSupported = false;
          this.supportCheckDone = true;
          this.supportCheckProductKey = this.getStableProductKey();
        }
        return id;
      },
      async startUpload(productId, sku) {
        if (!this.uploadCenterUrl) {
          this.error = "Upload center not available";
          return;
        }
        this.isLoading = true;
        this.error = null;
        try {
          const redirectUrl = await designOnlineApi.getUploadRedirectUrl({
            productId,
            sku,
            uploadCenterUrl: this.uploadCenterUrl,
            returnPage: this.getCleanReturnPage(),
            returnUrl: window.location.origin,
            userId: this.getCurrentUserId()
          });
          if (redirectUrl) {
            this.saveBeforeRedirect("upload");
            sessionStorage.setItem("studio_upload_flow_v1", "1");
            window.location.href = redirectUrl;
          } else {
            throw new Error("No redirect URL received");
          }
        } catch (error) {
          console.error("[DesignOnline] Start upload failed:", error);
          this.error = "Failed to open upload center. Please try again.";
          this.isLoading = false;
        }
      },
      async handleReturn(tokenId, exResponseParam) {
        var _a;
        if (!tokenId || !exResponseParam) {
          console.warn("[DesignOnline] Missing return parameters");
          return false;
        }
        this.exResponseParam = exResponseParam;
        this.saveToStorage();
        this.isLoading = true;
        this.error = null;
        this.stage = "loading";
        try {
          const designData = await designOnlineApi.getTemplateData({
            tokenId,
            exResponseParam,
            returnPage: this.getCleanReturnPage(),
            returnUrl: window.location.origin,
            userId: this.getCurrentUserId()
          });
          if (!designData || !designData.preview_image) {
            console.warn("[DesignOnline] Design expired or invalid");
            this.resetToChooser();
            return false;
          }
          console.log("[DesignOnline] 📦 RAW /template response:", JSON.parse(JSON.stringify(designData)));
          console.log("[DesignOnline] 🔑 token_id from response:", designData.token_id);
          console.log("[DesignOnline] 🎨 design_url from response:", designData.design_url);
          console.log("[DesignOnline] 🖼️ preview_image from response:", ((_a = designData.preview_image) == null ? void 0 : _a.substring(0, 100)) + "...");
          this.tokenId = designData.token_id || tokenId;
          this.previewImage = designData.preview_image;
          this.editUrl = designData.design_url;
          this.downloadUrl = designData.pdf_preview_url;
          this.pdfPreviewUrl = designData.pdf_preview_url;
          this.printReadyFileUrl = designData.print_ready_file_url;
          this.stage = "preview";
          this.source = this.getSourceFromStorage() || "create";
          console.log("[DesignOnline] 🎉 Data saved to store:", {
            tokenId: String(this.tokenId),
            hasPreview: !!this.previewImage,
            editUrl: String(this.editUrl),
            downloadUrl: String(this.downloadUrl),
            source: String(this.source)
          });
          if (this.editUrl) {
            try {
              const urlCheck = new URL(this.editUrl, window.location.origin);
              console.log("[DesignOnline] 🔍 Edit URL parameters:", {
                fullUrl: String(this.editUrl),
                pid: urlCheck.searchParams.get("pid"),
                tempid: urlCheck.searchParams.get("tempid"),
                type: urlCheck.searchParams.get("type"),
                hasTokenInUrl: urlCheck.searchParams.has("token_id"),
                allParams: JSON.stringify(Array.from(urlCheck.searchParams.entries()))
              });
            } catch (e) {
              console.error("[DesignOnline] ❌ Could not parse editUrl:", e.message);
              console.log("[DesignOnline] editUrl value:", String(this.editUrl));
            }
          } else {
            console.warn("[DesignOnline] ⚠️ editUrl is EMPTY or NULL!");
          }
          this.saveToStorage();
          this.cleanUrlParameters();
          console.log("[DesignOnline] Return handled successfully:", {
            tokenId: this.tokenId,
            hasPreview: !!this.previewImage,
            source: this.source
          });
          return true;
        } catch (error) {
          console.error("[DesignOnline] Handle return failed:", error);
          this.error = "Failed to load design data";
          this.stage = "error";
          return false;
        } finally {
          this.isLoading = false;
          sessionStorage.removeItem("studio_upload_flow_v1");
        }
      },
      /**
       * Open Edit Design mode
       * ✅ EXACT COPY from old working code - DO NOT modify!
       * Uses design_url from Studio API directly with return parameters only
       */
      openEdit() {
        if (!this.editUrl) {
          console.warn("[DesignOnline] No edit URL available");
          this.error = "Edit URL not available";
          return;
        }
        try {
          console.log("[DesignOnline] 📊 Opening edit with editUrl:", String(this.editUrl));
          console.log("[EditDesign] 💾 Saving all data before redirect...");
          Promise.resolve().then(() => useNewImprintStore$1).then(({ useNewImprintStore: useNewImprintStore2 }) => {
            const newImprintStore = useNewImprintStore2();
            if (newImprintStore.imprints.length > 0) {
              newImprintStore.saveToSessionStorage();
              console.log("[EditDesign] ✅ Saved newImprintStore");
            }
          });
          Promise.resolve().then(() => useSelectionStore$1).then(({ useSelectionStore: useSelectionStore2 }) => {
            const selectionStore = useSelectionStore2();
            selectionStore.saveToSessionStorage();
            console.log("[EditDesign] ✅ Saved selectionStore");
          });
          this.saveToStorage();
          console.log("[EditDesign] ✅ Saved designOnlineStore");
          const url = new URL(this.editUrl, window.location.origin);
          const cleanReturnPage = this.getCleanReturnPage();
          url.searchParams.set("return_url", `${location.protocol}//${location.host}`);
          url.searchParams.set("return_page", cleanReturnPage);
          url.searchParams.set("user_id", this.getCurrentUserId());
          url.searchParams.set("lang_id", "EN");
          if (this.exResponseParam) {
            url.searchParams.set("ex_response_param", this.exResponseParam);
          }
          console.log("[DesignOnline] ✅ Final edit URL:", String(url.toString()));
          this.saveBeforeRedirect("edit");
          setTimeout(() => {
            console.log("[EditDesign] 🚀 Redirecting to Studio...");
            window.location.href = url.toString();
          }, 100);
        } catch (error) {
          console.error("[DesignOnline] ❌ Failed to open edit:", error);
          this.error = "Failed to open edit";
        }
      },
      openDownload() {
        if (!this.downloadUrl) {
          console.warn("[DesignOnline] No download URL available");
          return;
        }
        window.open(this.downloadUrl, "_blank");
      },
      /**
        * Stable page identity for storage/restore.
        * We intentionally use pathname only to avoid Studio return params
        * breaking restore (product key mismatch).
        */
      getStableProductKey() {
        try {
          const u = new URL(window.location.href);
          return u.pathname;
        } catch (e) {
          return window.location.pathname;
        }
      },
      // ===================
      // STORAGE ACTIONS
      // ===================
      saveToStorage() {
        const data = {
          tokenId: this.tokenId,
          previewImage: this.previewImage,
          editUrl: this.editUrl,
          pdfPreviewUrl: this.pdfPreviewUrl,
          printReadyFileUrl: this.printReadyFileUrl,
          source: this.source,
          productKey: this.getStableProductKey(),
          timestamp: Date.now(),
          version: STORAGE_VERSION,
          exResponseParam: this.exResponseParam,
          isApproved: this.isApproved
          // ✅ Save approval state
        };
        try {
          sessionStorage.setItem(STORAGE_KEY$1, JSON.stringify(data));
          console.log("[DesignOnline] State saved to storage (isApproved:", this.isApproved, ")");
        } catch (error) {
          console.error("[DesignOnline] Failed to save to storage:", error);
        }
      },
      restoreFromStorage() {
        try {
          console.log("[DO_NAV] 💾 restoreFromStorage() START");
          console.log("[DO_NAV] Current stage before restore:", this.stage);
          console.log("[DO_NAV] Current productKey:", window.location.pathname);
          const raw = sessionStorage.getItem(STORAGE_KEY$1);
          if (!raw) {
            console.log("[DO_NAV] ❌ No storage data found in sessionStorage");
            return false;
          }
          console.log("[DO_NAV] Storage data found, parsing...");
          const data = JSON.parse(raw);
          console.log("[AUTO_SWITCH] Storage data:", {
            version: data.version,
            tokenId: data.tokenId,
            hasPreview: !!data.previewImage,
            age: Math.round((Date.now() - data.timestamp) / 1e3) + "s"
          });
          if (data.version !== STORAGE_VERSION) {
            console.warn("[DO_NAV] ❌ Storage version mismatch - clearing");
            this.clearStorage();
            return false;
          }
          const currentKey = this.getStableProductKey();
          console.log("[DO_NAV] Product key check:", {
            stored: data.productKey,
            current: currentKey,
            match: data.productKey === currentKey
          });
          if (data.productKey && data.productKey !== currentKey) {
            console.warn("[DO_NAV] ❌ Product key mismatch - clearing storage");
            this.clearStorage();
            return false;
          }
          const age = Date.now() - data.timestamp;
          console.log("[DO_NAV] Data age:", Math.round(age / 1e3), "seconds");
          if (age > 10 * 60 * 1e3) {
            console.warn("[DO_NAV] ❌ Storage data expired (> 10min) - clearing");
            this.clearStorage();
            return false;
          }
          if (!data.tokenId || !data.previewImage) {
            console.warn("[DO_NAV] ❌ Invalid storage data (missing tokenId or previewImage) - clearing");
            this.clearStorage();
            return false;
          }
          console.log("[DO_NAV] ✅ All validations passed - restoring data...");
          console.log("[AUTO_SWITCH] 👍 All validations passed - restoring state");
          console.log("[AUTO_SWITCH] Current stage:", this.stage, "→ Will change to: preview");
          this.tokenId = data.tokenId;
          this.previewImage = data.previewImage;
          this.editUrl = data.editUrl;
          this.downloadUrl = data.pdfPreviewUrl;
          this.pdfPreviewUrl = data.pdfPreviewUrl;
          this.printReadyFileUrl = data.printReadyFileUrl;
          this.source = data.source || "restored";
          this.stage = "preview";
          this.exResponseParam = data.exResponseParam || null;
          this.isApproved = data.isApproved || false;
          console.log("[DO_NAV] ✅ restoreFromStorage() SUCCESS - State restored:", {
            stage: this.stage,
            hasDesign: this.hasDesign,
            tokenId: this.tokenId,
            isApproved: this.isApproved
          });
          return true;
        } catch (error) {
          console.error("[DO_NAV] ❌ restoreFromStorage() FAILED:", error);
          return false;
        }
      },
      saveBeforeRedirect(source) {
        const data = {
          source,
          timestamp: Date.now(),
          productKey: this.getStableProductKey()
        };
        try {
          sessionStorage.setItem(RETURN_KEY, JSON.stringify(data));
        } catch (error) {
          console.error("[DesignOnline] Failed to save return data:", error);
        }
      },
      getSourceFromStorage() {
        try {
          const raw = sessionStorage.getItem(RETURN_KEY);
          if (!raw) return null;
          const data = JSON.parse(raw);
          return data.source || null;
        } catch (error) {
          return null;
        }
      },
      clearStorage() {
        try {
          sessionStorage.removeItem(STORAGE_KEY$1);
          sessionStorage.removeItem(RETURN_KEY);
          sessionStorage.removeItem("studio_payload");
          sessionStorage.removeItem("studio_return");
          localStorage.removeItem("studio_payload");
          localStorage.removeItem("studio_return");
          console.log("[DesignOnline] Storage cleared");
        } catch (error) {
          console.error("[DesignOnline] Failed to clear storage:", error);
        }
      },
      // ===================
      // STATE MANAGEMENT
      // ===================
      setApproval(approved) {
        this.isApproved = approved;
        console.log("[DesignOnline] Approval:", approved ? "✅ Approved" : "⏸️ Not approved");
        console.log("[AddToCart] 📦 setApproval() called with:", approved);
        console.log("[AddToCart] Store state after setApproval:", {
          isApproved: this.isApproved,
          hasTokenId: !!this.tokenId,
          hasPreview: !!(this.previewImage || this.pdfPreviewUrl),
          isReady: this.isReady
        });
        if (this.tokenId) {
          this.saveToStorage();
          console.log("[AddToCart] 💾 Approval state saved to storage");
        }
      },
      resetToChooser() {
        this.tokenId = null;
        this.previewImage = null;
        this.editUrl = null;
        this.downloadUrl = null;
        this.pdfPreviewUrl = null;
        this.printReadyFileUrl = null;
        this.source = null;
        this.templates = [];
        this.selectedTemplate = null;
        this.stage = "idle";
        this.isApproved = false;
        this.error = null;
        this.clearStorage();
        console.log("[DesignOnline] Reset to idle (prevents auto-scroll)");
      },
      fullReset() {
        console.log("[DO_NAV] 🔄 fullReset() START");
        console.log("[DO_NAV] State before reset:", {
          stage: this.stage,
          isSupported: this.isSupported,
          supportCheckDone: this.supportCheckDone,
          hasUploadUrl: !!this.uploadCenterUrl,
          hasCustomizeUrl: !!this.customizeStudioUrl,
          studioConfig: JSON.parse(JSON.stringify(this.studioConfig))
        });
        this.resetToChooser();
        this.supportCheckDone = false;
        this.isSupported = null;
        this.uploadCenterUrl = null;
        this.customizeStudioUrl = null;
        this.exResponseParam = null;
        console.log("[DO_NAV] 🔄 fullReset() END - State after reset:", {
          stage: this.stage,
          isSupported: this.isSupported,
          supportCheckDone: this.supportCheckDone,
          supportCheckProductKey: this.supportCheckProductKey,
          hasUploadUrl: !!this.uploadCenterUrl,
          hasCustomizeUrl: !!this.customizeStudioUrl,
          studioConfig: JSON.parse(JSON.stringify(this.studioConfig))
        });
      },
      initialize() {
        console.log("[DO_NAV] 🚀 initialize() called - current stage:", this.stage);
        if (this.stage === "idle") {
          console.log("[DO_NAV] Setting stage: idle → chooser");
          this.stage = "chooser";
        } else {
          console.log("[DO_NAV] Stage already", this.stage, "- skipping initialization");
        }
        console.log("[DO_NAV] initialize() END - stage:", this.stage);
      },
      // ===================
      // HELPER METHODS
      // ===================
      getCleanReturnPage() {
        try {
          const url = new URL(window.location.href);
          const pathOnly = url.pathname;
          let hash = url.hash || "";
          if (hash.startsWith("#")) hash = hash.slice(1);
          const [anchor] = hash.split("?", 1);
          const cleanHash = anchor ? "#" + anchor : "";
          return pathOnly + cleanHash;
        } catch (error) {
          return window.location.pathname;
        }
      },
      getCurrentUserId() {
        var _a, _b, _c;
        const shopifyUserId = (_b = (_a = window.ShopifyAnalytics) == null ? void 0 : _a.meta) == null ? void 0 : _b.page_customer_id;
        if (shopifyUserId) return shopifyUserId;
        const appStore = useAppStore();
        if (appStore.userId) return appStore.userId;
        const KEY = "guest_uuid";
        let id = localStorage.getItem(KEY);
        if (!id) {
          id = ((_c = crypto == null ? void 0 : crypto.randomUUID) == null ? void 0 : _c.call(crypto)) || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
          localStorage.setItem(KEY, id);
        }
        return id;
      },
      cleanUrlParameters() {
        try {
          const rawHref = window.location.href;
          const badTokenIndex = rawHref.indexOf("?token_id=");
          if (badTokenIndex !== -1) {
            const hashIndex = rawHref.indexOf("#");
            const hashPart = hashIndex !== -1 ? rawHref.slice(hashIndex) : "";
            const base = rawHref.slice(0, badTokenIndex);
            window.history.replaceState({}, "", base + hashPart);
            console.log("[DesignOnline] Malformed token params stripped from URL");
            return;
          }
          const url = new URL(window.location.href);
          const search = new URLSearchParams(url.search);
          search.delete("token_id");
          search.delete("ex_response_param");
          search.delete("ex_response_params");
          const rawHash = url.hash.startsWith("#") ? url.hash.slice(1) : url.hash;
          const [hashAnchor, hashQuery] = rawHash.split("?", 2);
          let newHash = hashAnchor || "";
          if (hashQuery) {
            const hq = new URLSearchParams(hashQuery);
            hq.delete("token_id");
            hq.delete("ex_response_param");
            hq.delete("ex_response_params");
            const tail = hq.toString();
            newHash = tail ? `${newHash}?${tail}` : newHash;
          }
          const clean = url.origin + url.pathname + (search.toString() ? "?" + search.toString() : "") + (newHash ? "#" + newHash : "");
          window.history.replaceState({}, "", clean);
          console.log("[DesignOnline] URL parameters cleaned");
        } catch (error) {
          console.error("[DesignOnline] Failed to clean URL:", error);
        }
      },
      readReturnParamsFromUrl() {
        try {
          const search = new URLSearchParams(window.location.search);
          let tokenId = search.get("token_id");
          let exParam = search.get("ex_response_param") || search.get("ex_response_params");
          if (!tokenId || !exParam) {
            const href = window.location.href;
            const idx = href.indexOf("?token_id=");
            if (idx !== -1) {
              const tail = href.slice(idx + 1);
              const tailBeforeHash = tail.split("#", 1)[0];
              const tailParams = new URLSearchParams(tailBeforeHash);
              tokenId = tokenId || tailParams.get("token_id");
              exParam = exParam || tailParams.get("ex_response_param") || tailParams.get("ex_response_params");
              console.warn("[DesignOnline] Detected malformed return params in URL; recovered via fallback");
            }
          }
          if (!tokenId || !exParam) {
            const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
            const hashIndex = hash.indexOf("?");
            if (hashIndex >= 0) {
              const hashParams = new URLSearchParams(hash.slice(hashIndex + 1));
              tokenId = tokenId || hashParams.get("token_id");
              exParam = exParam || hashParams.get("ex_response_param") || hashParams.get("ex_response_params");
            }
          }
          if (exParam) {
            const cut = exParam.indexOf("?token_id=");
            if (cut !== -1) exParam = exParam.slice(0, cut);
          }
          return { tokenId, exParam };
        } catch (error) {
          console.error("[DesignOnline] Failed to read URL params:", error);
          return { tokenId: null, exParam: null };
        }
      }
    }
  });
  function formatColorName(colorName) {
    if (!colorName) return "";
    if (colorName.includes("-")) {
      return colorName.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }
    return colorName.charAt(0).toUpperCase() + colorName.slice(1);
  }
  function renameSize(size) {
    const sizeMap = {
      "XS": "X-Small",
      "S": "Small",
      "M": "Medium",
      "L": "Large",
      "XL": "X-Large",
      "2XL": "2X-Large",
      "3XL": "3X-Large",
      "4XL": "4X-Large",
      "5XL": "5X-Large"
    };
    return sizeMap[size] || size;
  }
  function buildProductName(colorSizeLine, size, appStore, imprintStore) {
    var _a;
    const productName = ((_a = imprintStore.fullJson) == null ? void 0 : _a.name) || "Product";
    const colorName = formatColorName(colorSizeLine.slectedColor.title);
    let names = {};
    if (appStore.productType === "grouped_plain" || !size) {
      names.cart = `${colorName}`;
      names.order = `${productName} - (${colorName})`;
      return names;
    }
    const sizeName = renameSize(size);
    names.cart = `${colorName} - ${sizeName}`;
    names.order = `${productName} - ${sizeName} (${colorName})`;
    return names;
  }
  function buildProductSKU(colorSizeLine, size, appStore, imprintStore, selectionStore) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (appStore.productType === "grouped_plain") {
      return colorSizeLine.slectedColor.img_sku;
    }
    const catalogCode = ((_a = imprintStore.fullJson) == null ? void 0 : _a.catalog_code) || "";
    const sku = (_b = imprintStore.selectedImprintMethod) == null ? void 0 : _b.sku;
    const simpleArray = (_e = (_d = (_c = imprintStore.fullJson) == null ? void 0 : _c.configurable_array) == null ? void 0 : _d[sku]) == null ? void 0 : _e.simple_array;
    const colorName = (_f = colorSizeLine.slectedColor.title) == null ? void 0 : _f.toLowerCase();
    if (simpleArray) {
      const entry = Object.values(simpleArray).find(
        (e) => e.color === colorName && e.size === size
      );
      if ((entry == null ? void 0 : entry.sku_size_code) && (entry == null ? void 0 : entry.sku_color_code)) {
        return `${catalogCode}_${entry.sku_size_code}_${entry.sku_color_code}`;
      }
      console.warn(
        `[ProductMetadata] buildProductSKU: no simple_array match for color="${colorName}" size="${size}" — using fallback`
      );
    }
    const colorSkuArr = ((_g = colorSizeLine.slectedColor.img_sku) == null ? void 0 : _g.split("_")) || [];
    const colorCode = colorSkuArr[colorSkuArr.length - 1] || "";
    return size ? `${catalogCode}_${size}_${colorCode}` : `${catalogCode}_${colorCode}`;
  }
  function getProductWeight(colorSizeLine, size, imprintStore, appStore, selectionStore) {
    var _a, _b, _c;
    const sku = imprintStore.selectedImprintMethod.sku;
    const productSKU = buildProductSKU(colorSizeLine, size, appStore, imprintStore);
    const configurableData = (_b = (_a = imprintStore.fullJson) == null ? void 0 : _a.configurable_array) == null ? void 0 : _b[sku];
    const simpleData = (_c = configurableData == null ? void 0 : configurableData.simple_array) == null ? void 0 : _c[productSKU];
    return (simpleData == null ? void 0 : simpleData.weight) || 0;
  }
  function buildItemMetaData(colorSizeLine, size, appStore, imprintStore, selectionStore, priceByQty) {
    var _a;
    let colorProductId = colorSizeLine.slectedColor.id;
    if (appStore.associatedIds && ((_a = appStore.associatedIds.simples) == null ? void 0 : _a.id_color)) {
      colorProductId = appStore.associatedIds.simples.id_color;
    }
    return {
      price: priceByQty.toFixed(2),
      productColorID: colorProductId,
      imgID: colorSizeLine.slectedColor.img_id,
      imgGID: colorSizeLine.slectedColor.img_gid || null,
      color_sku: buildProductSKU(colorSizeLine, size, appStore, imprintStore),
      imprint_sku: imprintStore.selectedImprintMethod.sku,
      mainProduct_id: appStore.mainProductID
    };
  }
  function getColorProductId(lines, appStore) {
    var _a, _b, _c;
    let colorProductId = (_b = (_a = lines[0]) == null ? void 0 : _a.slectedColor) == null ? void 0 : _b.id;
    if (appStore.associatedIds && ((_c = appStore.associatedIds.simples) == null ? void 0 : _c.id_color)) {
      colorProductId = appStore.associatedIds.simples.id_color;
      console.log("[ProductMetadata] Using colorProductId from associatedIds:", colorProductId);
    } else {
      console.warn("[ProductMetadata] WARNING: associatedIds not loaded, using variant ID as fallback:", colorProductId);
    }
    return colorProductId;
  }
  function buildSendArtworkPayload(imprint, imprintStore, priceData, backendConfig = {}) {
    var _a, _b, _c, _d;
    console.log("[PayloadBuilder] buildSendArtworkPayload()", { backendConfig });
    const appStore = useAppStore();
    const isEnvelopProduct = appStore.isEnvelopProduct;
    const locationTitle = ((_a = imprint == null ? void 0 : imprint.selectedLocation) == null ? void 0 : _a.title) || "";
    const locationSku = ((_b = imprint == null ? void 0 : imprint.selectedLocation) == null ? void 0 : _b.sku) || "";
    const baseInstruction = "Send Us Your Artwork After Ordering.";
    const userComment = (imprint == null ? void 0 : imprint.specialInstructions) || "";
    const globalSpecialInstructions = getSpecialInstructions();
    const imprintDetails = `${baseInstruction} \r
\r
Comment: ${userComment}`;
    const fees = calculateAllFees({
      uniqueColorsCount: 1,
      // Assume 1 color for send artwork
      totalQuantity: 0,
      hasPantoneColor: false,
      hasImage: false,
      artworkMethod: "send",
      backendConfig
      // ✅ Pass backend config
    });
    const updatedPriceData = {
      ...priceData,
      setup_fee: fees.setup_fee,
      proof_fee: fees.proof_fee,
      running_fee: fees.running_fee,
      customColourFee: fees.customColourFee,
      image_fee: fees.image_fee
    };
    const properties = {
      "Imprint Method": ((_c = imprintStore.selectedImprintMethod) == null ? void 0 : _c.name) || "",
      "_Imprint Method SKU": ((_d = imprintStore.selectedImprintMethod) == null ? void 0 : _d.sku) || "",
      "Imprint Details": imprintDetails,
      "Special Instruction": globalSpecialInstructions,
      "_price_details": updatedPriceData,
      "_colorUpcharge": imprintStore.colorUpcharge || {},
      "_sizeUpcharge": imprintStore.sizeUpcharge || {}
    };
    if (!isEnvelopProduct) {
      properties["Imprint location"] = locationTitle;
      properties["_Imprint Location SKU"] = locationSku;
    }
    console.log("[PayloadBuilder] Send Artwork fees:", {
      setup_fee: fees.setup_fee,
      proof_fee: fees.proof_fee
    });
    return {
      imprint_lines: {},
      properties,
      fees
      // Return fees for runningFeePerItem
    };
  }
  function buildPreviousArtworkPayload(imprint, imprintStore, priceData, backendConfig = {}) {
    var _a, _b, _c, _d;
    console.log("[PayloadBuilder] buildPreviousArtworkPayload()", { backendConfig });
    const appStore = useAppStore();
    const isEnvelopProduct = appStore.isEnvelopProduct;
    const locationTitle = ((_a = imprint == null ? void 0 : imprint.selectedLocation) == null ? void 0 : _a.title) || "";
    const locationSku = ((_b = imprint == null ? void 0 : imprint.selectedLocation) == null ? void 0 : _b.sku) || "";
    const baseInstruction = "Use My Previous Artwork.";
    const userComment = (imprint == null ? void 0 : imprint.specialInstructions) || "";
    const globalSpecialInstructions = getSpecialInstructions();
    const imprintDetails = `${baseInstruction} \r
\r
Comment: ${userComment}`;
    const fees = calculateAllFees({
      uniqueColorsCount: 0,
      totalQuantity: 0,
      hasPantoneColor: false,
      hasImage: false,
      artworkMethod: "previous",
      backendConfig
      // ✅ Pass backend config (though not used for 'previous')
    });
    const updatedPriceData = {
      ...priceData,
      setup_fee: fees.setup_fee,
      proof_fee: fees.proof_fee,
      running_fee: fees.running_fee,
      customColourFee: fees.customColourFee,
      image_fee: fees.image_fee
    };
    const properties = {
      "Imprint Method": ((_c = imprintStore.selectedImprintMethod) == null ? void 0 : _c.name) || "",
      "_Imprint Method SKU": ((_d = imprintStore.selectedImprintMethod) == null ? void 0 : _d.sku) || "",
      "Imprint Details": imprintDetails,
      "Special Instruction": globalSpecialInstructions,
      "_price_details": updatedPriceData,
      "_colorUpcharge": imprintStore.colorUpcharge || {},
      "_sizeUpcharge": imprintStore.sizeUpcharge || {}
    };
    if (!isEnvelopProduct) {
      properties["Imprint location"] = locationTitle;
      properties["_Imprint Location SKU"] = locationSku;
    }
    console.log("[PayloadBuilder] Previous Artwork fees:", {
      setup_fee: fees.setup_fee,
      proof_fee: fees.proof_fee
    });
    return {
      imprint_lines: {},
      properties,
      fees
      // Return fees for runningFeePerItem
    };
  }
  function formatLineItemsFeeForCart(lineItemsFeeProperties, groupID, feeSkus = {}, priceDetails = {}) {
    var _a;
    const feeFormatted = {};
    const customColourLabel = ((_a = window.Shopify) == null ? void 0 : _a.country) === "CA" ? "Custom Colour Fee" : "Custom Color Fee";
    console.log("[PayloadBuilder] formatLineItemsFeeForCart - input:", lineItemsFeeProperties, "feeSkus:", feeSkus, "priceDetails:", priceDetails);
    if (typeof lineItemsFeeProperties === "object") {
      for (const [key, value] of Object.entries(lineItemsFeeProperties)) {
        const feeValue = Number(value["value"]);
        const hasValue = feeValue > 0;
        switch (value["name"]) {
          case "setup_fee": {
            const setupQty = Number(priceDetails.setup_fee_qty);
            const setupUnitPrice = Number(priceDetails.setup_fee_unit_price);
            if (setupQty >= 1 && setupUnitPrice > 0) {
              feeFormatted["Setup Fee Qty"] = String(setupQty);
              feeFormatted["Setup Fee Unit Price"] = setupUnitPrice.toFixed(2);
              feeFormatted["Setup Fee Subtotal"] = feeValue.toFixed(2);
            } else {
              feeFormatted["Setup Fee"] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.setup_fee_sku) {
              feeFormatted["_Setup Fee SKU"] = feeSkus.setup_fee_sku;
            }
            break;
          }
          case "proof_fee": {
            const proofRate = Number(priceDetails.proof_fee_unit_price) || feeValue;
            if (hasValue) {
              feeFormatted["Proof Fee Qty"] = "1";
              feeFormatted["Proof Fee Unit Price"] = proofRate.toFixed(2);
              feeFormatted["Proof Fee Subtotal"] = feeValue.toFixed(2);
            } else {
              feeFormatted["Proof Fee"] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.proof_fee_sku) {
              feeFormatted["_Proof Fee SKU"] = feeSkus.proof_fee_sku;
            }
            break;
          }
          case "image_fee": {
            const imgQty = Number(priceDetails.image_fee_qty);
            const imgUnitPrice = Number(priceDetails.image_fee_unit_price) || feeValue;
            if (hasValue) {
              feeFormatted["Image Fee Qty"] = String(imgQty >= 1 ? imgQty : 1);
              feeFormatted["Image Fee Unit Price"] = imgUnitPrice.toFixed(2);
              feeFormatted["Image Fee Subtotal"] = feeValue.toFixed(2);
            } else {
              feeFormatted["Image Fee"] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.image_fee_sku) {
              feeFormatted["_Image Fee SKU"] = feeSkus.image_fee_sku;
            }
            break;
          }
          case "running_fee": {
            const runQty = Number(priceDetails.running_fee_qty);
            const runUnitPrice = Number(priceDetails.running_fee_unit_price);
            if (runQty > 0 && runUnitPrice > 0) {
              feeFormatted["Running Fee Qty"] = String(runQty);
              feeFormatted["Running Fee Unit Price"] = runUnitPrice.toFixed(2);
              feeFormatted["Running Fee Subtotal"] = feeValue.toFixed(2);
            } else {
              feeFormatted["Running Fee"] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.running_fee_sku) {
              feeFormatted["_Running Fee SKU"] = feeSkus.running_fee_sku;
            }
            break;
          }
          case "custom_colour_fee": {
            const customQty = Number(priceDetails.customColourFee_qty);
            const customUnitPrice = Number(priceDetails.customColourFee_unit_price);
            if (customQty >= 1 && customUnitPrice > 0) {
              feeFormatted[`${customColourLabel} Qty`] = String(customQty);
              feeFormatted[`${customColourLabel} Unit Price`] = customUnitPrice.toFixed(2);
              feeFormatted[`${customColourLabel} Subtotal`] = feeValue.toFixed(2);
            } else {
              feeFormatted[customColourLabel] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.colour_fee_sku) {
              feeFormatted[`_${customColourLabel} SKU`] = feeSkus.colour_fee_sku;
            }
            break;
          }
          case "additional_location_fee": {
            const addLocQty = Number(priceDetails.additional_location_fee_qty);
            const addLocUnitPrice = Number(priceDetails.additional_location_fee_unit_price);
            if (addLocQty >= 1 && addLocUnitPrice > 0) {
              feeFormatted["Additional Location Fee Qty"] = String(addLocQty);
              feeFormatted["Additional Location Fee Unit Price"] = addLocUnitPrice.toFixed(2);
              feeFormatted["Additional Location Fee Subtotal"] = feeValue.toFixed(2);
            } else {
              feeFormatted["Additional Location Fee"] = feeValue.toFixed(2);
            }
            if (hasValue && feeSkus.additional_location_fee_sku) {
              feeFormatted["_Additional Location Fee SKU"] = feeSkus.additional_location_fee_sku;
            }
            break;
          }
        }
      }
    }
    feeFormatted["_groupID"] = groupID;
    console.log("[PayloadBuilder] formatLineItemsFeeForCart - output:", feeFormatted);
    return feeFormatted;
  }
  const normalizeCalendarTitle = (title2) => String(title2 ?? "").replace(new RegExp("\\p{Cf}", "gu"), "").replace(new RegExp("\\p{Pd}", "gu"), "-").replace(/\s+/g, " ").trim().toLowerCase();
  function resolveCalendarSku(title2, calendarSkuMap = {}, simpleArray = {}) {
    if (title2 && calendarSkuMap[title2]) {
      return calendarSkuMap[title2];
    }
    const wanted = normalizeCalendarTitle(title2);
    if (!wanted) return "";
    for (const [mapTitle, sku] of Object.entries(calendarSkuMap)) {
      if (sku && normalizeCalendarTitle(mapTitle) === wanted) {
        return sku;
      }
    }
    for (const [sku, simple] of Object.entries(simpleArray || {})) {
      if (simple && normalizeCalendarTitle(simple.name) === wanted) {
        return simple.sku || sku;
      }
    }
    return "";
  }
  function buildCalendarCartPayload(appStore, imprintStore, newImprintStore, calendarStore, imprintPayload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    console.log("[PayloadBuilder] Building calendar cart payload");
    console.log("[PayloadBuilder] Received imprintPayload:", imprintPayload);
    const imprintProperties = (imprintPayload == null ? void 0 : imprintPayload.properties) || imprintPayload || {};
    const imprintLines = (imprintPayload == null ? void 0 : imprintPayload.imprint_lines) || {};
    const totalQty = calendarStore.totalQuantity;
    console.log("[PayloadBuilder] Calendar totalQty:", totalQty);
    const sku = (_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
    let backendConfig = {};
    if (sku && ((_c = (_b = imprintStore.fullJson) == null ? void 0 : _b.configurable_array) == null ? void 0 : _c[sku])) {
      const imprintData = (_d = imprintStore.fullJson.configurable_array[sku].configurable_2_data) == null ? void 0 : _d.imprint_data;
      if (imprintData) {
        backendConfig = {
          setup_fee: imprintData.setup_fee || 0,
          running_fee: imprintData.running_fee || 0,
          custom_colour_fee: imprintData.custom_colour_fee || 0,
          image_fee: imprintData.image_fee || 0,
          proof_fee: imprintData.proof_fee || 0
        };
      }
    }
    console.log("[PayloadBuilder] Calendar backend fee config:", backendConfig);
    const isComda = ((_f = (_e = window.Shopify) == null ? void 0 : _e.shop) == null ? void 0 : _f.includes("comda")) ?? true;
    const artworkMethod = imprintStore.selectedArtworkMethod || "new";
    const allImprints = newImprintStore.imprints;
    let totalSetupFee = 0;
    let totalProofFee = 0;
    let totalRunningFee = 0;
    let totalImageFee = 0;
    let totalCustomColorFee = 0;
    const calendarImprintsFees = [];
    console.log("[PayloadBuilder] Calculating fees for", allImprints.length, "calendar imprints");
    allImprints.forEach((imprint, index) => {
      const uniqueColorsCount = getUniqueColorsCount(imprint);
      const uniqueCustomColorsCount = getUniqueCustomColorsCount(imprint);
      const imageDataExists = hasUploadedImage(imprint);
      const messageType = (imprint == null ? void 0 : imprint.messageType) || "text";
      const messageTypeAllowsImage = messageType === "image" || messageType === "text_image";
      const hasImage = imageDataExists && messageTypeAllowsImage;
      const fees = calculateAllFees({
        uniqueColorsCount,
        totalQuantity: totalQty,
        // ✅ FIX: Use calendar totalQty, not 1
        hasPantoneColor: uniqueCustomColorsCount,
        hasImage,
        artworkMethod,
        isComda,
        backendConfig
      });
      console.log(`[PayloadBuilder] Calendar imprint ${index} fees:`, {
        uniqueColorsCount,
        uniqueCustomColorsCount,
        hasImage,
        totalQty,
        fees
      });
      totalSetupFee += fees.setup_fee || 0;
      calendarImprintsFees.push(fees);
      totalRunningFee += fees.running_fee || 0;
      totalImageFee += fees.image_fee || 0;
      totalCustomColorFee += fees.customColourFee || 0;
    });
    const feesArray = ((_i = (_h = (_g = imprintStore.fullJson) == null ? void 0 : _g.configurable_array) == null ? void 0 : _h[sku]) == null ? void 0 : _i.fees) || [];
    const proofFeeUnit = getFeeUnit(feesArray, "PROOF", "per order");
    totalProofFee = combineProofFee(calendarImprintsFees, proofFeeUnit);
    console.log("[PayloadBuilder] Calendar total fees:", {
      totalSetupFee,
      totalProofFee,
      totalRunningFee,
      totalImageFee,
      totalCustomColorFee
    });
    const correctedPriceDetails = {
      ...imprintProperties._price_details || {},
      setup_fee: totalSetupFee,
      proof_fee: totalProofFee,
      running_fee: totalRunningFee,
      image_fee: totalImageFee,
      customColourFee: totalCustomColorFee
    };
    const items = [];
    if (!appStore.currentGroupID) {
      appStore.generateGroupID();
    }
    const groupID = appStore.currentGroupID;
    const qtyIncrement = imprintStore.currentQtyIncrement || 1;
    console.log("[PayloadBuilder] Calendar groupID:", groupID);
    console.log("[PayloadBuilder] Calendar qtyIncrement:", qtyIncrement);
    const calendarSkuMap = ((_k = (_j = imprintStore.fullJson) == null ? void 0 : _j.simple_attributes) == null ? void 0 : _k.calendar_sku) || {};
    const simpleArray = ((_o = (_n = (_l = imprintStore.fullJson) == null ? void 0 : _l.configurable_array) == null ? void 0 : _n[(_m = imprintStore.selectedImprintMethod) == null ? void 0 : _m.sku]) == null ? void 0 : _o.simple_array) || {};
    console.log("[PayloadBuilder] Calendar SKU map:", calendarSkuMap);
    calendarStore.productsWithQuantities.forEach((calendar) => {
      var _a2, _b2, _c2, _d2;
      const calendarSku = resolveCalendarSku(calendar.title, calendarSkuMap, simpleArray);
      const properties = {
        "Is Calendar": "Yes",
        "Calendar SKU": calendarSku,
        "Imprint Method": ((_a2 = imprintStore.selectedImprintMethod) == null ? void 0 : _a2.name) || "",
        "_variant_title": calendar.title,
        "_variant_title_img": calendar.image || "",
        "_Product name": calendar.title,
        "_Grouped Product name": ((_b2 = appStore.full_product_json) == null ? void 0 : _b2.name) || "",
        "_img_src": calendar.image || "",
        "_Product SKU": calendarSku,
        "_Product Weight": ((_c2 = simpleArray[calendarSku]) == null ? void 0 : _c2.weight) ?? "",
        "_mainProductId": calendar.id,
        "_groupedCalendarId": appStore.mainProductID,
        "_price_details": correctedPriceDetails,
        // ✅ Use corrected price details
        "_productUrl": window.location.pathname,
        "_runningFeePerItem": backendConfig.running_fee || 0,
        "_groupID": groupID,
        // ✅ Add groupID for cart association
        "_qtyIncrement": qtyIncrement
        // ✅ Add qtyIncrement for cart qty controls
      };
      Object.keys(imprintProperties).forEach((key) => {
        if (key !== "_price_details") {
          properties[key] = imprintProperties[key];
        }
      });
      const item = {
        id: calendar.id,
        quantity: calendar.qty,
        properties,
        metaData: {
          price: (calendar.unitPrice || 0).toFixed(2),
          productColorID: calendar.id,
          imgID: null,
          imprint_sku: ((_d2 = imprintStore.selectedImprintMethod) == null ? void 0 : _d2.sku) || "",
          mainProduct_id: calendar.id
        }
      };
      items.push(item);
    });
    const payload = {
      id: appStore.mainProductID,
      colorProductID: ((_p = calendarStore.products[0]) == null ? void 0 : _p.id) || appStore.mainProductID,
      imprint_lines: imprintLines,
      // ✅ Use extracted imprint_lines
      items
    };
    console.log("[PayloadBuilder] Calendar payload imprint_lines:", imprintLines);
    console.log("[PayloadBuilder] Calendar payload built:", payload);
    return payload;
  }
  function extractLinesFromProperties(properties) {
    const lines = [];
    let lineNum = 1;
    while (properties[`Line ${lineNum} text`]) {
      lines.push({
        [`Line ${lineNum} text`]: properties[`Line ${lineNum} text`],
        [`Line ${lineNum} color`]: properties[`Line ${lineNum} color`],
        [`Line ${lineNum} Color SKU`]: properties[`_Imprint Line ${lineNum} Color SKU`]
      });
      lineNum++;
    }
    return lines;
  }
  function extractImageDataFromProperties(properties) {
    if (!properties["Add an Image Filename"]) {
      return null;
    }
    return {
      filename: properties["Add an Image Filename"],
      url: properties["_Add an Image Url"],
      "Image Color": properties["Add an Image Color"],
      "Image Color SKU": properties["_Add an Image Color SKU"]
    };
  }
  function combineMultipleImprintsAsArray(allImprintsPayloads, feesArray = []) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    if (!allImprintsPayloads || allImprintsPayloads.length === 0) {
      return null;
    }
    console.log("[PayloadBuilder] combineMultipleImprintsAsArray - processing", allImprintsPayloads.length, "imprints");
    const firstPayload = allImprintsPayloads[0].payload;
    const imprintsArray = allImprintsPayloads.map((item) => ({
      imprintKey: item.imprintKey,
      "Imprint location": item.payload.properties["Imprint location"],
      "_Imprint Location SKU": item.payload.properties["_Imprint Location SKU"],
      "Imprint Method": item.payload.properties["Imprint Method"],
      "_Imprint Method SKU": item.payload.properties["_Imprint Method SKU"],
      lines: extractLinesFromProperties(item.payload.properties),
      // "Special Instructions": item.payload.properties["Special Instruction"],
      "Image Data": extractImageDataFromProperties(item.payload.properties)
    }));
    const imprintLinesArray = allImprintsPayloads.map((item, index) => {
      const imprintLines = item.payload.imprint_lines;
      console.log(`[PayloadBuilder] Imprint ${index} lines:`, imprintLines);
      return imprintLines;
    });
    console.log("[PayloadBuilder] Final imprint_lines array:", imprintLinesArray);
    const properties = {
      ...firstPayload.properties,
      "_Imprint Lines": imprintsArray,
      "_Imprints Count": allImprintsPayloads.length
    };
    const totalSetupFee = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.setup_fee) || 0);
    }, 0);
    const totalSetupFeeQty = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.setup_fee_qty) || 0);
    }, 0);
    const setupFeeUnitPrice = ((_b = (_a = allImprintsPayloads[0]) == null ? void 0 : _a.payload.fees) == null ? void 0 : _b.setup_fee_unit_price) || 0;
    const proofFeeUnit = getFeeUnit(feesArray, "PROOF", "per order");
    const imprintsFeeObjects = allImprintsPayloads.map((item) => item.payload.fees || {});
    const totalProofFee = combineProofFee(imprintsFeeObjects, proofFeeUnit);
    const totalRunningFee = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.running_fee) || 0);
    }, 0);
    const totalRunningFeeMultiplier = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.running_fee_multiplier) || 0);
    }, 0);
    const runningFeeRate = ((_d = (_c = allImprintsPayloads[0]) == null ? void 0 : _c.payload.fees) == null ? void 0 : _d.running_fee_rate) || 0;
    const totalImageFee = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.image_fee) || 0);
    }, 0);
    const totalImageFeeQty = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.image_fee_qty) || 0);
    }, 0);
    const imageFeeUnitPrice = ((_f = (_e = allImprintsPayloads[0]) == null ? void 0 : _e.payload.fees) == null ? void 0 : _f.image_fee_unit_price) || 0;
    const totalCustomColourFee = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.customColourFee) || 0);
    }, 0);
    const totalCustomColourFeeQty = allImprintsPayloads.reduce((sum, item) => {
      var _a2;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.customColourFee_qty) || 0);
    }, 0);
    const customColourFeeUnitPrice = ((_h = (_g = allImprintsPayloads[0]) == null ? void 0 : _g.payload.fees) == null ? void 0 : _h.customColourFee_unit_price) || 0;
    const totalAdditionalLocationFee = allImprintsPayloads.reduce((sum, item, index) => {
      var _a2;
      if (index === 0) return sum;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.additional_location_fee) || 0);
    }, 0);
    const totalAdditionalLocationFeeQty = allImprintsPayloads.reduce((sum, item, index) => {
      var _a2;
      if (index === 0) return sum;
      return sum + (((_a2 = item.payload.fees) == null ? void 0 : _a2.additional_location_fee_qty) || 0);
    }, 0);
    const additionalLocationFeeUnitPrice = allImprintsPayloads.length > 1 ? ((_j = (_i = allImprintsPayloads[1]) == null ? void 0 : _i.payload.fees) == null ? void 0 : _j.additional_location_fee_unit_price) || 0 : 0;
    const additionalLocationFeeTiers = allImprintsPayloads.length > 1 ? ((_m = (_l = (_k = allImprintsPayloads[1]) == null ? void 0 : _k.payload) == null ? void 0 : _l.fees) == null ? void 0 : _m.additional_location_fee_tiers) || [] : [];
    console.log("[PayloadBuilder] Combined fees:", {
      totalSetupFee,
      totalProofFee,
      totalRunningFee,
      totalImageFee,
      totalCustomColourFee,
      totalAdditionalLocationFee
    });
    if (properties["_price_details"]) {
      properties["_price_details"].setup_fee = totalSetupFee;
      properties["_price_details"].setup_fee_qty = totalSetupFeeQty;
      properties["_price_details"].setup_fee_unit_price = setupFeeUnitPrice;
      properties["_price_details"].proof_fee = totalProofFee;
      properties["_price_details"].running_fee = totalRunningFee;
      properties["_price_details"].running_fee_multiplier = totalRunningFeeMultiplier;
      properties["_price_details"].running_fee_rate = runningFeeRate;
      properties["_price_details"].image_fee = totalImageFee;
      properties["_price_details"].image_fee_qty = totalImageFeeQty;
      properties["_price_details"].image_fee_unit_price = imageFeeUnitPrice;
      properties["_price_details"].customColourFee = totalCustomColourFee;
      properties["_price_details"].customColourFee_qty = totalCustomColourFeeQty;
      properties["_price_details"].customColourFee_unit_price = customColourFeeUnitPrice;
      properties["_price_details"].additional_location_fee = totalAdditionalLocationFee;
      properties["_price_details"].additional_location_fee_qty = totalAdditionalLocationFeeQty;
      properties["_price_details"].additional_location_fee_unit_price = additionalLocationFeeUnitPrice;
      properties["_price_details"].additional_location_fee_tiers = additionalLocationFeeTiers;
    }
    return {
      imprint_lines: imprintLinesArray,
      // ✅ ARRAY of objects instead of single object
      properties,
      fees: {
        ...firstPayload.fees,
        setup_fee: totalSetupFee,
        setup_fee_qty: totalSetupFeeQty,
        setup_fee_unit_price: setupFeeUnitPrice,
        proof_fee: totalProofFee,
        running_fee: totalRunningFee,
        running_fee_multiplier: totalRunningFeeMultiplier,
        running_fee_rate: runningFeeRate,
        image_fee: totalImageFee,
        image_fee_qty: totalImageFeeQty,
        image_fee_unit_price: imageFeeUnitPrice,
        customColourFee: totalCustomColourFee,
        customColourFee_qty: totalCustomColourFeeQty,
        customColourFee_unit_price: customColourFeeUnitPrice,
        additional_location_fee: totalAdditionalLocationFee,
        additional_location_fee_qty: totalAdditionalLocationFeeQty,
        additional_location_fee_unit_price: additionalLocationFeeUnitPrice
      }
    };
  }
  function getSpecialInstructions() {
    const selectionStore = useSelectionStore();
    return selectionStore.specialInstructions || "";
  }
  function validateAddToCart({ appStore, selectionStore, imprintStore, newImprintStore }) {
    const validationResult = {
      hasError: false,
      errors: []
    };
    if (!appStore.mainProductID) {
      validationResult.hasError = true;
      validationResult.errors.push("Step 1: Main product ID is missing");
    }
    if (!imprintStore.selectedImprintMethod.sku) {
      validationResult.hasError = true;
      validationResult.errors.push("Step 1: Please select an imprint method");
    }
    if (appStore.applicationType === "default") {
      const imprintKey = imprintStore.selectedImprintMethod.name;
      const lines = selectionStore.getLinesByImprintKey(imprintKey);
      if (!lines || lines.length === 0) {
        validationResult.hasError = true;
        validationResult.errors.push("Step 1: Please select at least one color and size");
      }
      if (lines && lines.length > 0) {
        const totalQty = lines.reduce((sum, line) => sum + (line.totalQty || 0), 0);
        const minQty = imprintStore.currentMinQty || 0;
        if (minQty > 0 && totalQty < minQty) {
          validationResult.hasError = true;
          validationResult.errors.push(`Step 1: Minimum quantity requirements not met (minimum: ${minQty}, current: ${totalQty})`);
        }
      }
      if (lines) {
        lines.forEach((line, index) => {
          if (!line.selectedSizes || Object.keys(line.selectedSizes).length === 0) {
            validationResult.hasError = true;
            validationResult.errors.push(`Step 1: Line ${index + 1} - Please select at least one size`);
          }
        });
      }
      const currentImprint = newImprintStore.imprints[newImprintStore.currentImprintKey];
      if (currentImprint) {
        if (!currentImprint.selectedLocation.sku) {
          validationResult.hasError = true;
          validationResult.errors.push("Step 2: Please select an imprint location");
        }
        const artworkMethod = imprintStore.selectedArtworkMethod;
        if (artworkMethod === "new") {
          const mt = currentImprint.messageType;
          if (mt === "text" || mt === "text_image") {
            const messageLines = (currentImprint.textLines || []).filter((l) => l.type === "message");
            messageLines.forEach((line, index) => {
              const hasText = !!(line.message && line.message.trim());
              const hasColor = !!line.selectedColor;
              if (index === 0) {
                if (!hasText) {
                  validationResult.hasError = true;
                  validationResult.errors.push("Step 2: Missing text in Line 1");
                }
                if (!hasColor) {
                  validationResult.hasError = true;
                  validationResult.errors.push("Step 2: Missing color in Line 1");
                }
              }
            });
          }
          if (mt === "image" || mt === "text_image") {
            if (!currentImprint.imageData) {
              validationResult.hasError = true;
              validationResult.errors.push("Step 2: Please upload an image");
            }
            console.log("currentImprint");
            console.log(currentImprint);
            const imageLine = currentImprint.textLines.find((l) => l.type === "image");
            if (imageLine && !imageLine.selectedColor) {
              validationResult.errors.push("Step 2: Please select image color");
            }
          }
        }
      }
    } else if (appStore.applicationType === "calendar") {
      if (!appStore.calendar.productList || appStore.calendar.productList.length === 0) {
        validationResult.hasError = true;
        validationResult.errors.push("Step 1: Please select calendar products");
      }
    }
    return validationResult;
  }
  function validateCartLocalStorageVariables() {
    try {
      const minQty = localStorage.getItem("minQty");
      return minQty !== null && minQty !== void 0;
    } catch (error) {
      console.error("[Validation] Failed to validate cart localStorage:", error);
      return false;
    }
  }
  function setMinQtyToStorage(groupId, minQty, totalQty) {
    try {
      let minQtyStorage = {};
      const existingData = localStorage.getItem("minQty");
      if (existingData) {
        try {
          minQtyStorage = JSON.parse(existingData);
        } catch (parseError) {
          console.warn("[Validation] Failed to parse existing minQty data, creating new:", parseError);
          minQtyStorage = {};
        }
      }
      minQtyStorage[groupId] = {
        minQty,
        // errorMessage: false,
        totalQty
      };
      localStorage.setItem("minQty", JSON.stringify(minQtyStorage));
      console.log("[Validation] Minimum quantity saved to localStorage for group:", groupId, {
        minQty,
        totalQty
      });
    } catch (error) {
      console.error("[Validation] Failed to save min qty to storage:", error);
    }
  }
  function useCartAPI() {
    const getApiBaseUrl = () => {
      var _a, _b;
      return ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.api_beckend_url) || "https://dev.api-customapp.comda.com/";
    };
    const getShopDomain = () => {
      var _a, _b;
      return ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.api_shop_domain) || "devcomda.myshopify.com";
    };
    const getShopName = () => {
      const domain = getShopDomain();
      return domain.replace(".myshopify.com", "");
    };
    const getJsonResponseFromString = (stringResponse) => {
      try {
        const cutKey = "responesVariantsList";
        const indexOfCutKey = stringResponse.indexOf(cutKey);
        if (indexOfCutKey === -1) {
          console.error("[CartAPI] responesVariantsList key not found in string response");
          return null;
        }
        const cutedData = stringResponse.slice(indexOfCutKey);
        const jsonTypeResponse = '{"' + cutedData;
        const formatedStr = jsonTypeResponse.replace(/\\"\s*W/g, '\\" W').replace(/\\"\s*H/g, '\\" H');
        const jsonResponse = JSON.parse(formatedStr);
        console.warn("[CartAPI] getJsonResponseFromString - response was a STRING");
        if (cutKey in jsonResponse) {
          return jsonResponse[cutKey];
        }
        console.error("[CartAPI] responesVariantsList not found after parse");
        return null;
      } catch (e) {
        console.error("[CartAPI] getJsonResponseFromString failed to parse JSON response:", e);
        return null;
      }
    };
    const getFromCart = async (cartObject, responsedCartItems) => {
      try {
        const response = await axios.get(window.Shopify.routes.root + "cart.js");
        console.log("[CartAPI] Current cart:", response.data);
        if (response.data && response.data.items) {
          try {
            cartObject.value = response.data;
            updateCartItemsInCartObject(cartObject, responsedCartItems);
            console.log("[CartAPI] Cart items saved to localStorage:", response.data.items.length);
          } catch (storageError) {
            console.error("[CartAPI] Failed to save cart items to localStorage:", storageError);
          }
        }
        return response.data;
      } catch (error) {
        console.error("[CartAPI] Failed to fetch cart:", error);
        return null;
      }
    };
    const updateCartItemsInCartObject = (cartObject, responsedCartItems) => {
      var _a;
      if (((_a = cartObject.value.items) == null ? void 0 : _a.length) && responsedCartItems.value) {
        console.log("[CartAPI] Updating cart items in cart object");
        cartObject.value.items = cartObject.value.items.map((item) => {
          if (!item.image && responsedCartItems.value[item.key]) {
            return responsedCartItems.value[item.key];
          }
          return item;
        });
        cartObject.value.updated_at = (/* @__PURE__ */ new Date()).getTime();
        if (window.miniCart) {
          window.miniCart.refreshMiniCart(cartObject.value);
        }
        localStorage.setItem("cartItems", JSON.stringify(cartObject.value));
      }
    };
    const logToBackend = (type, scope, message2, corrId) => {
      try {
        axios.post(
          getApiBaseUrl() + "api/add-log",
          { type, scope, message: message2 },
          { headers: { "X-Client-Request-Id": corrId } }
        ).catch(() => {
        });
      } catch (e) {
      }
    };
    const reportAddToCartCritical = (error, items, corrId, batch2) => {
      var _a, _b, _c, _d, _e, _f, _g;
      try {
        const status = ((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) ?? "n/a";
        const shopifyMsg = ((_c = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.data) == null ? void 0 : _c.message) || "";
        const description = ((_e = (_d = error == null ? void 0 : error.response) == null ? void 0 : _d.data) == null ? void 0 : _e.description) || (error == null ? void 0 : error.message) || "unknown";
        const variantIds = Array.isArray(items) ? items.map((i) => i == null ? void 0 : i.id).filter(Boolean) : [];
        const groupID = Array.isArray(items) && ((_g = (_f = items[0]) == null ? void 0 : _f.properties) == null ? void 0 : _g._groupID) || "";
        const message2 = `cart/add.js failed (batch=${batch2}) status=${status} shopify="${shopifyMsg}: ${description}" variants=[${variantIds.join(",")}] group=${groupID} corr=${corrId}`;
        logToBackend("critical", "cart-add", message2, corrId);
      } catch (e) {
      }
    };
    const CART_ADD_MAX_ATTEMPTS = 5;
    const CART_ADD_RETRY_BASE_MS = 1500;
    const _isVariantNotFound = (error) => {
      var _a, _b, _c;
      return ((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 422 && ((_c = (_b = error == null ? void 0 : error.response) == null ? void 0 : _b.data) == null ? void 0 : _c.description) === "Cannot find variant";
    };
    const _delay = (ms) => new Promise((resolve2) => setTimeout(resolve2, ms));
    const PRODUCT_TOUCH_WAIT_MS = 2e3;
    const addToCartFirst = async (items, corrId, responsedCartItems, shopInfo = {}) => {
      console.log("[CartAPI] addToCartFirst - adding", items.length, "items");
      let touched = null;
      for (let attempt = 1; attempt <= CART_ADD_MAX_ATTEMPTS; attempt++) {
        try {
          const response = await axios.post(
            window.Shopify.routes.root + "cart/add.js",
            { items },
            { headers: { "X-Client-Request-Id": corrId } }
          );
          response.data.items.forEach((item) => {
            responsedCartItems.value[item.key] = item;
          });
          if (attempt > 1) {
            console.log(`[CartAPI] addToCartFirst - succeeded on attempt ${attempt}`);
          }
          return response.data;
        } catch (error) {
          if (_isVariantNotFound(error) && attempt < CART_ADD_MAX_ATTEMPTS) {
            let wait = attempt * CART_ADD_RETRY_BASE_MS;
            if (touched === null) {
              const variantIds = items.map((i) => i == null ? void 0 : i.id).filter(Boolean);
              touched = await touchVariants(variantIds, corrId, shopInfo);
              logToBackend(
                "debug",
                "cart-add-touch",
                `cart/add.js 422 (batch=first) -> touched=${touched} variants=[${variantIds.join(",")}] corr=${corrId}`,
                corrId
              );
              wait = PRODUCT_TOUCH_WAIT_MS;
            }
            console.warn(`[CartAPI] addToCartFirst - attempt ${attempt} "Cannot find variant", touched=${touched}, retrying in ${wait}ms`);
            await _delay(wait);
            continue;
          }
          console.error("[CartAPI] addToCartFirst - error:", error);
          throw error;
        }
      }
    };
    const touchVariants = async (variantIds, corrId, shopInfo) => {
      var _a;
      try {
        const response = await axios.post(
          getApiBaseUrl() + "api/shopify/variants/touch",
          {
            shop: (shopInfo == null ? void 0 : shopInfo.shop) || getShopName(),
            shop_domain: (shopInfo == null ? void 0 : shopInfo.shop_domain) || getShopDomain(),
            variant_ids: variantIds
          },
          { headers: { "X-Client-Request-Id": corrId } }
        );
        return ((_a = response == null ? void 0 : response.data) == null ? void 0 : _a.touched) ?? 0;
      } catch (e) {
        console.warn("[CartAPI] touchVariants failed:", e);
        return 0;
      }
    };
    const addToCartSecond = async (items, corrId, responsedCartItems, shopInfo = {}) => {
      if (!items || items.length === 0) {
        console.warn("[CartAPI] addToCartSecond called with empty items array");
        return null;
      }
      console.log("[CartAPI] addToCartSecond - adding", items.length, "items");
      const addItems = async () => {
        const response = await axios.post(
          window.Shopify.routes.root + "cart/add.js",
          { items },
          { headers: { "X-Client-Request-Id": corrId } }
        );
        if (response.data.items) {
          response.data.items.forEach((item) => {
            responsedCartItems.value[item.key] = item;
          });
        }
        return response.data;
      };
      try {
        return await addItems();
      } catch (error) {
        if (!_isVariantNotFound(error)) {
          console.error("[CartAPI] addToCartSecond - error:", error);
          reportAddToCartCritical(error, items, corrId, "second");
          throw error;
        }
        const variantIds = items.map((i) => i == null ? void 0 : i.id).filter(Boolean);
        const touched = await touchVariants(variantIds, corrId, shopInfo);
        console.warn(`[CartAPI] addToCartSecond - "Cannot find variant", touched=${touched}, retrying in ${PRODUCT_TOUCH_WAIT_MS}ms`);
        logToBackend(
          "debug",
          "cart-add-touch",
          `cart/add.js 422 (batch=second) -> touched=${touched} variants=[${variantIds.join(",")}] corr=${corrId}`,
          corrId
        );
        await _delay(PRODUCT_TOUCH_WAIT_MS);
        try {
          const data = await addItems();
          console.log("[CartAPI] addToCartSecond - succeeded after touch");
          return data;
        } catch (retryError) {
          console.error("[CartAPI] addToCartSecond - error after touch:", retryError);
          reportAddToCartCritical(retryError, items, corrId, "second");
          throw retryError;
        }
      }
    };
    const SEND_TO_BACKEND_MAX_ATTEMPTS = 3;
    const SEND_TO_BACKEND_RETRY_BASE_MS = 1500;
    const sendToBackend = async (apiData, corrId, groupID, feeSkus = {}) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
      const apiBaseUrl = getApiBaseUrl();
      const endpoint = "api/shopify/addtocart";
      const itemsCount = ((_b = (_a = apiData == null ? void 0 : apiData.data) == null ? void 0 : _a.items) == null ? void 0 : _b.length) ?? 0;
      console.log("[CartAPI] Sending to backend:", {
        url: apiBaseUrl + endpoint,
        corrId,
        itemsCount
      });
      for (let attempt = 1; attempt <= SEND_TO_BACKEND_MAX_ATTEMPTS; attempt++) {
        try {
          const response = await axios.post(
            apiBaseUrl + endpoint,
            apiData,
            { headers: { "X-Client-Request-Id": corrId } }
          );
          let lineItems = {};
          if (typeof response.data === "string") {
            lineItems = getJsonResponseFromString(response.data);
          } else {
            lineItems = response.data.responesVariantsList;
          }
          if (!lineItems || !lineItems.items) {
            throw new Error("Backend response missing items");
          }
          const priceDetailsItem = Array.isArray((_c = apiData == null ? void 0 : apiData.data) == null ? void 0 : _c.items) ? apiData.data.items.find((i) => {
            var _a2;
            return (_a2 = i == null ? void 0 : i.properties) == null ? void 0 : _a2._price_details;
          }) : null;
          const priceDetails = ((_d = priceDetailsItem == null ? void 0 : priceDetailsItem.properties) == null ? void 0 : _d._price_details) || {};
          const productFeeProperties = formatLineItemsFeeForCart(
            lineItems.items.product_fee.properties,
            groupID,
            feeSkus,
            priceDetails
          );
          if (lineItems.items.product_fee.fee_sig) {
            productFeeProperties["_fee_sig"] = lineItems.items.product_fee.fee_sig;
          }
          delete lineItems.items.product_fee.fee_sig;
          lineItems.items.product_fee.properties = productFeeProperties;
          if (attempt > 1) {
            console.log(`[CartAPI] sendToBackend - succeeded on attempt ${attempt}`);
          }
          console.log("[CartAPI] Backend response processed successfully");
          logToBackend(
            "debug",
            "cart-add-response",
            `sendToBackend OK <- ${endpoint} corr=${corrId} attempt=${attempt}/${SEND_TO_BACKEND_MAX_ATTEMPTS} status=${response.status}`,
            corrId
          );
          return lineItems;
        } catch (error) {
          const isOpaqueOrNetworkError = !error.response;
          const status = ((_e = error == null ? void 0 : error.response) == null ? void 0 : _e.status) ?? "n/a";
          const contentType = ((_g = (_f = error == null ? void 0 : error.response) == null ? void 0 : _f.headers) == null ? void 0 : _g["content-type"]) ?? "n/a";
          const isClientError = typeof status === "number" && status >= 400 && status < 500 && status !== 408 && status !== 429;
          const backendError = String(((_i = (_h = error == null ? void 0 : error.response) == null ? void 0 : _h.data) == null ? void 0 : _i.error) ?? "");
          const isInvalidPayload = status === 422 && backendError.startsWith("Invalid payload");
          const isFinalAttempt = attempt === SEND_TO_BACKEND_MAX_ATTEMPTS || isClientError;
          let bodySnippet = null;
          if (contentType.includes("text")) {
            const rawBody = typeof ((_j = error.response) == null ? void 0 : _j.data) === "string" ? error.response.data : JSON.stringify(((_k = error.response) == null ? void 0 : _k.data) ?? "");
            bodySnippet = rawBody.slice(0, 500);
          }
          console.error(`[CartAPI] Backend API error (attempt ${attempt}/${SEND_TO_BACKEND_MAX_ATTEMPTS}):`, error);
          const logType = !isFinalAttempt ? "debug" : isInvalidPayload ? "warning" : "critical";
          logToBackend(
            logType,
            "cart-add-response-error",
            `sendToBackend FAILED -> ${endpoint} corr=${corrId} attempt=${attempt}/${SEND_TO_BACKEND_MAX_ATTEMPTS} status=${status} contentType=${contentType} corsOrNetworkError=${isOpaqueOrNetworkError} message="${(error == null ? void 0 : error.message) || "unknown"}"` + (backendError ? ` error="${backendError.slice(0, 200)}"` : "") + (bodySnippet !== null ? ` bodySnippet="${bodySnippet}"` : ""),
            corrId
          );
          if (isFinalAttempt) {
            throw error;
          }
          const wait = attempt * SEND_TO_BACKEND_RETRY_BASE_MS;
          console.warn(`[CartAPI] sendToBackend - attempt ${attempt} failed, retrying in ${wait}ms`);
          await _delay(wait);
        }
      }
    };
    const completeAddToCart = async ({
      apiData,
      corrId,
      groupID,
      cartState,
      cartObject,
      responsedCartItems,
      feeSkus = {},
      onSuccess,
      onError
    }) => {
      var _a;
      const atcStartedAt = Date.now();
      let atcStage = "backend";
      trackAtcStart({ apiBaseUrl: getApiBaseUrl(), flow: "new", mode: apiData == null ? void 0 : apiData.mode, corrId, startedAt: atcStartedAt });
      try {
        const lineItems = await sendToBackend(apiData, corrId, groupID, feeSkus);
        trackAtcStage("backend_ok", corrId);
        const feeCartLine = [lineItems.items.product_fee];
        const productItems = [];
        for (const [key, value] of Object.entries(lineItems.items)) {
          if (key !== "product_fee") {
            productItems.push(value);
          }
        }
        if (productItems.length === 0 && !lineItems.items.product_fee) {
          throw new Error("Backend returned no items and no fee - cannot proceed");
        }
        let firstBatch, secondBatch;
        if (cartState) {
          firstBatch = productItems;
          secondBatch = feeCartLine;
        } else {
          firstBatch = feeCartLine;
          secondBatch = productItems;
        }
        atcStage = "cart_first";
        await addToCartFirst(firstBatch, corrId, responsedCartItems, {
          shop: apiData == null ? void 0 : apiData.shop,
          shop_domain: apiData == null ? void 0 : apiData.shop_domain
        });
        trackAtcStage("cart_first_ok", corrId);
        atcStage = "cart_second";
        await addToCartSecond(secondBatch, corrId, responsedCartItems, {
          shop: apiData == null ? void 0 : apiData.shop,
          shop_domain: apiData == null ? void 0 : apiData.shop_domain
        });
        trackAtcStage("cart_second_ok", corrId);
        atcStage = "get_cart";
        await getFromCart(cartObject, responsedCartItems);
        reportAtcResult({
          apiBaseUrl: getApiBaseUrl(),
          outcome: "success",
          flow: "new",
          mode: apiData == null ? void 0 : apiData.mode,
          corrId,
          startedAt: atcStartedAt
        });
        localStorage.removeItem("stringProductList");
        localStorage.removeItem("fullStorageProductList");
        if (window.jQuery("#add-to-cart-complited")) {
          window.jQuery("#add-to-cart-complited").trigger("click");
        }
        if (onSuccess) {
          onSuccess();
        }
        console.log("[CartAPI] Add to cart completed successfully");
      } catch (error) {
        console.error("[CartAPI] Add to cart failed:", error);
        reportAtcResult({
          apiBaseUrl: getApiBaseUrl(),
          outcome: "failure",
          stage: atcStage,
          flow: "new",
          mode: apiData == null ? void 0 : apiData.mode,
          corrId,
          startedAt: atcStartedAt,
          status: (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status
        });
        if (onError) {
          onError(error);
        }
        throw error;
      }
    };
    return {
      getApiBaseUrl,
      getShopDomain,
      getShopName,
      getFromCart,
      addToCartFirst,
      addToCartSecond,
      sendToBackend,
      completeAddToCart
    };
  }
  const useAddToCartStore = /* @__PURE__ */ defineStore("addToCart", {
    state: () => ({
      // Loading state
      loader: false,
      addToCartStatus: false,
      // Correlation ID for tracking
      _corrId: null,
      // Validation results
      validationResult: {
        hasError: false,
        errors: []
      },
      // Fees and prices
      runningFeePerItem: 0,
      perItemFee: {
        setupFee: 0,
        proof_fee: 0
      },
      // Cart state (determines fee order)
      cartState: false,
      // false = fee first, true = items first
      stepForAddAssociatedFee: "first",
      // Tracking cart items responses
      responsedCartItems: {},
      // Price data (gathered from stores)
      priceData: {
        tier: [],
        tierMSRP: 0,
        priceByQty: 0,
        priceSizeUpcharge: 0,
        priceColorUpcharge: 0,
        setup_fee: 0,
        proof_fee: 0,
        image_fee: 0,
        customColourFee: 0,
        running_fee: 0
      },
      // Bundle product cleared flag
      bundleProductCleared: false,
      // Logs for debugging
      logs: [],
      // Cart object (reactive reference)
      cartObject: {}
    }),
    getters: {
      /**
       * Check if Add to Cart is ready
       */
      isReadyToAddToCart(state) {
        const appStore = useAppStore();
        const selectionStore = useSelectionStore();
        const imprintStore = useImprintStore();
        if (!appStore.mainProductID) return false;
        if (appStore.isOutOfStock) return false;
        if (!imprintStore.selectedImprintMethod.sku) return false;
        if (appStore.applicationType === "default") {
          const imprintKey = imprintStore.selectedImprintMethod.name;
          const lines = selectionStore.getLinesByImprintKey(imprintKey);
          if (!lines || lines.length === 0) return false;
        }
        if (appStore.applicationType === "calendar") {
          if (!appStore.calendar.productList || appStore.calendar.productList.length === 0) {
            return false;
          }
        }
        return true;
      }
    },
    actions: {
      /**
       * Add log entry for debugging
       */
      addLog({ type, message: message2 }) {
        const timestamp = (/* @__PURE__ */ new Date()).toISOString();
        const logEntry = {
          timestamp,
          type,
          // 'debug', 'error', 'critical'
          message: message2
        };
        this.logs.push(logEntry);
        if (type === "critical") {
          console.error("[AddToCart]", message2);
        } else if (type === "error") {
          console.warn("[AddToCart]", message2);
        } else {
          console.log("[AddToCart]", message2);
        }
      },
      /**
       * Check if current artwork method is "new" (Start New Imprint)
       */
      isNewArtworkMethod() {
        const imprintStore = useImprintStore();
        return imprintStore.selectedArtworkMethod === "new";
      },
      /**
       * Build complete cart payload using transform methods and utilities
       * 
       * This method orchestrates:
       * 1. Get imprint payload from appropriate transform method
       * 2. Build cart items with product metadata
       * 3. Calculate and apply fees
       * 4. Return complete payload for backend
       */
      buildCartPayload() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const appStore = useAppStore();
        const imprintStore = useImprintStore();
        const selectionStore = useSelectionStore();
        const newImprintStore = useNewImprintStore();
        console.log("[AddToCart] buildCartPayload() - Building cart payload");
        if (appStore.isCalendarMode) {
          console.log("[AddToCart] Calendar mode detected, using calendar payload builder");
          const calendarStore = useCalendarStore();
          const artworkMethod2 = imprintStore.selectedArtworkMethod;
          let imprintPayload2 = null;
          if (artworkMethod2 === "new") {
            imprintPayload2 = newImprintStore.transformToCartPayload(null, this.priceData);
          } else if (artworkMethod2 === "send") {
            const currentImprint = newImprintStore.currentImprint;
            imprintPayload2 = buildSendArtworkPayload(currentImprint, imprintStore, this.priceData);
          } else if (artworkMethod2 === "previous") {
            const currentImprint = newImprintStore.currentImprint;
            imprintPayload2 = buildPreviousArtworkPayload(currentImprint, imprintStore, this.priceData);
          } else if (artworkMethod2 === "design") {
            const designOnlineStore = useDesignOnlineStore();
            if (!designOnlineStore.isReady) {
              console.error("[AddToCart] Calendar + Design Online: store not ready");
              return null;
            }
            const props = designOnlineStore.lineItemProperties;
            if (!props || !props.token_id) {
              console.error("[AddToCart] Calendar + Design Online: missing token_id");
              return null;
            }
            imprintPayload2 = {
              imprint_lines: {},
              properties: {
                "_token_id": props.token_id,
                "_pdf_preview_url": props.pdf_preview_url || "",
                "_print_ready_file_url": props.print_ready_file_url || "",
                "_design_url": designOnlineStore.editUrl || "",
                "_preview_image": props.preview_image || "",
                "Imprint Method": "Design Online",
                "_Imprint Method SKU": ((_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku) || "DESIGN_ONLINE",
                "_price_details": {
                  tier: this.priceData.tier || [],
                  tierMSRP: this.priceData.tierMSRP || 0,
                  priceByQty: this.priceData.priceByQty || 0,
                  priceSizeUpcharge: 0,
                  priceColorUpcharge: 0,
                  setup_fee: 0,
                  proof_fee: 0,
                  image_fee: 0,
                  customColourFee: 0,
                  running_fee: 0
                }
              }
            };
            console.log("[AddToCart] Calendar + Design Online payload created:", imprintPayload2);
          }
          if (!imprintPayload2) {
            console.error("[AddToCart] No imprint payload generated for calendar mode, artworkMethod:", artworkMethod2);
            return null;
          }
          if (artworkMethod2 === "new") {
            const allImprintsPayloads = [];
            console.log("[AddToCart] Calendar mode: Processing multiple imprints, total:", newImprintStore.imprints.length);
            const calendarTotalQty = calendarStore.totalQuantity;
            for (let i = 0; i < newImprintStore.imprints.length; i++) {
              const singleImprintPayload = newImprintStore.transformToCartPayload(i, this.priceData);
              if (singleImprintPayload) {
                if (i >= 1) {
                  const addLocFeePerPiece = imprintStore.getAdditionalLocationFeePerPiece(calendarTotalQty);
                  const addLocFeeTotal = addLocFeePerPiece * calendarTotalQty;
                  singleImprintPayload.fees = {
                    ...singleImprintPayload.fees,
                    additional_location_fee: addLocFeeTotal,
                    additional_location_fee_qty: calendarTotalQty,
                    additional_location_fee_unit_price: addLocFeePerPiece,
                    additional_location_fee_tiers: imprintStore.currentAdditionalLocationFeeTiers
                  };
                  console.log(`[AddToCart] Calendar imprint ${i}: additional_location_fee=${addLocFeeTotal}`);
                } else {
                  singleImprintPayload.fees = {
                    ...singleImprintPayload.fees,
                    additional_location_fee: 0,
                    additional_location_fee_qty: 0,
                    additional_location_fee_unit_price: 0,
                    additional_location_fee_tiers: []
                  };
                }
                allImprintsPayloads.push({
                  imprintKey: i,
                  payload: singleImprintPayload
                });
                console.log(`[AddToCart] Calendar imprint ${i} payload:`, singleImprintPayload);
              }
            }
            if (allImprintsPayloads.length > 0) {
              imprintPayload2 = combineMultipleImprintsAsArray(allImprintsPayloads);
              console.log("[AddToCart] Calendar combined payload:", imprintPayload2);
              if ((_b = imprintPayload2 == null ? void 0 : imprintPayload2.properties) == null ? void 0 : _b["_price_details"]) {
                const runningFeeMultiplier = ((_c = imprintPayload2.fees) == null ? void 0 : _c.running_fee_multiplier) || 0;
                const runningFeeRate = ((_d = imprintPayload2.fees) == null ? void 0 : _d.running_fee_rate) || 0;
                imprintPayload2.properties["_price_details"].running_fee_qty = runningFeeMultiplier * calendarTotalQty;
                imprintPayload2.properties["_price_details"].running_fee_unit_price = runningFeeRate;
              }
            }
          }
          return buildCalendarCartPayload(
            appStore,
            imprintStore,
            newImprintStore,
            calendarStore,
            imprintPayload2
            // ✅ Pass full payload with imprint_lines
          );
        }
        const artworkMethod = imprintStore.selectedArtworkMethod;
        let imprintPayload = null;
        if (artworkMethod === "new") {
          console.log("[AddToCart] Calling transformToCartPayload with priceData:", this.priceData);
          imprintPayload = newImprintStore.transformToCartPayload(null, this.priceData);
          console.log("[AddToCart] transformToCartPayload returned:", imprintPayload);
          const allImprintsPayloads = [];
          console.log("[AddToCart] Processing multiple imprints, total:", newImprintStore.imprints.length);
          const imprintKey2 = imprintStore.selectedImprintMethod.name;
          const totalQtyForFee = selectionStore.getTotalQtyByImprintKey(imprintKey2);
          for (let i = 0; i < newImprintStore.imprints.length; i++) {
            const singleImprintPayload = newImprintStore.transformToCartPayload(i, this.priceData);
            if (singleImprintPayload) {
              if (i >= 1) {
                const addLocFeePerPiece = imprintStore.getAdditionalLocationFeePerPiece(totalQtyForFee);
                const addLocFeeTotal = addLocFeePerPiece * totalQtyForFee;
                singleImprintPayload.fees = {
                  ...singleImprintPayload.fees,
                  additional_location_fee: addLocFeeTotal,
                  additional_location_fee_qty: totalQtyForFee,
                  additional_location_fee_unit_price: addLocFeePerPiece,
                  // Pass full tier array so cart can recalculate dynamically on qty change
                  additional_location_fee_tiers: imprintStore.currentAdditionalLocationFeeTiers
                };
                console.log(`[AddToCart] Imprint ${i}: additional_location_fee=${addLocFeeTotal} (${addLocFeePerPiece}/pc × ${totalQtyForFee}qty)`);
              } else {
                singleImprintPayload.fees = {
                  ...singleImprintPayload.fees,
                  additional_location_fee: 0,
                  additional_location_fee_qty: 0,
                  additional_location_fee_unit_price: 0,
                  additional_location_fee_tiers: []
                };
              }
              allImprintsPayloads.push({
                imprintKey: i,
                payload: singleImprintPayload
              });
              console.log(`[AddToCart] Imprint ${i} payload:`, singleImprintPayload);
            }
          }
          if (allImprintsPayloads.length === 0) {
            console.error("[AddToCart] No valid imprints found");
            return null;
          }
          imprintPayload = combineMultipleImprintsAsArray(allImprintsPayloads);
          console.log("[AddToCart] Combined payload for", allImprintsPayloads.length, "imprints:", imprintPayload);
          if (!imprintPayload) {
            console.error("[AddToCart] transformToCartPayload returned NULL");
            console.error("[AddToCart] currentImprintKey:", newImprintStore.currentImprintKey);
            console.error("[AddToCart] imprints:", newImprintStore.imprints);
          } else if ((_e = imprintPayload.properties) == null ? void 0 : _e["_price_details"]) {
            const runningFeeMultiplier = ((_f = imprintPayload.fees) == null ? void 0 : _f.running_fee_multiplier) || 0;
            const runningFeeRate = ((_g = imprintPayload.fees) == null ? void 0 : _g.running_fee_rate) || 0;
            imprintPayload.properties["_price_details"].running_fee_qty = runningFeeMultiplier * totalQtyForFee;
            imprintPayload.properties["_price_details"].running_fee_unit_price = runningFeeRate;
          }
        } else if (artworkMethod === "send") {
          const currentImprint = newImprintStore.currentImprint;
          imprintPayload = buildSendArtworkPayload(currentImprint, imprintStore, this.priceData);
          console.log("[AddToCart] Using Send Artwork payload:", imprintPayload);
        } else if (artworkMethod === "previous") {
          const currentImprint = newImprintStore.currentImprint;
          imprintPayload = buildPreviousArtworkPayload(currentImprint, imprintStore, this.priceData);
          console.log("[AddToCart] Using Previous Artwork payload:", imprintPayload);
        } else if (artworkMethod === "design") {
          console.log("[AddToCart] Design Online detected - getting payload from store");
          const designOnlineStore = useDesignOnlineStore();
          console.log("[AddToCart] Design Online store state:", {
            stage: designOnlineStore.stage,
            hasDesign: designOnlineStore.hasDesign,
            isReady: designOnlineStore.isReady,
            isApproved: designOnlineStore.isApproved,
            tokenId: designOnlineStore.tokenId
          });
          if (!designOnlineStore.isReady) {
            console.error("[AddToCart] Design Online: Not ready!");
            console.error("[AddToCart] User must approve design by checking the checkbox");
            return null;
          }
          const props = designOnlineStore.lineItemProperties;
          if (!props || !props.token_id) {
            console.error("[AddToCart] Design Online: Missing token_id");
            return null;
          }
          const sizeUpchargeObj = {};
          const colorUpchargeObj = {};
          if (imprintStore.sizeUpcharge) {
            Object.keys(imprintStore.sizeUpcharge).forEach((size) => {
              if (imprintStore.sizeUpcharge[size] !== 0) {
                sizeUpchargeObj[size] = imprintStore.sizeUpcharge[size];
              }
            });
          }
          if (imprintStore.colorUpcharge) {
            Object.keys(imprintStore.colorUpcharge).forEach((colorKey) => {
              const colorData = imprintStore.colorUpcharge[colorKey];
              if (colorData && colorData.price !== 0) {
                colorUpchargeObj[colorKey] = {
                  price: colorData.price || 0,
                  price_type: colorData.price_type || ""
                };
              }
            });
          }
          console.log("[AddToCart] Design Online upcharges:", {
            sizeUpcharge: sizeUpchargeObj,
            colorUpcharge: colorUpchargeObj
          });
          imprintPayload = {
            imprint_lines: {},
            properties: {
              // ✅ REQUIRED: Design Online specific
              "_token_id": props.token_id,
              "_pdf_preview_url": props.pdf_preview_url || "",
              "_print_ready_file_url": props.print_ready_file_url || "",
              // ✅ OPTIONAL
              "_design_url": designOnlineStore.editUrl || "",
              "_preview_image": props.preview_image || "",
              // Standard
              "Imprint Method": "Design Online",
              "_Imprint Method SKU": ((_h = imprintStore.selectedImprintMethod) == null ? void 0 : _h.sku) || "DESIGN_ONLINE",
              // ✅ NEW: Size and Color upcharges
              "_sizeUpcharge": sizeUpchargeObj,
              "_colorUpcharge": colorUpchargeObj,
              // Price details (no fees for Design Online, but includes tier pricing)
              "_price_details": {
                tier: this.priceData.tier || [],
                tierMSRP: this.priceData.tierMSRP || 0,
                priceByQty: this.priceData.priceByQty || 0,
                priceSizeUpcharge: this.priceData.priceSizeUpcharge || 0,
                priceColorUpcharge: this.priceData.priceColorUpcharge || 0,
                setup_fee: 0,
                proof_fee: 0,
                image_fee: 0,
                customColourFee: 0,
                running_fee: 0
              }
            }
          };
          console.log("[AddToCart] ✅ Design Online payload created:", imprintPayload);
        }
        if (!imprintPayload) {
          console.error("[AddToCart] No imprint payload generated for method:", artworkMethod);
          return null;
        }
        if (imprintPayload.fees) {
          this.runningFeePerItem = imprintPayload.fees.runningFeePerItem || 0;
        }
        const imprintKey = imprintStore.selectedImprintMethod.name;
        const lines = selectionStore.getLinesByImprintKey(imprintKey);
        const groupID = this.getGroupID();
        const items = [];
        console.log("[AddToCart] Building items from", lines.length, "color lines");
        lines.forEach((colorSizeLine) => {
          for (const [size, qty] of Object.entries(colorSizeLine.selectedSizes)) {
            if (qty > 0) {
              const isQtyOnly = size === "qty";
              const sizeForSku = isQtyOnly ? null : size;
              const names = buildProductName(colorSizeLine, sizeForSku, appStore, imprintStore);
              const properties = {
                ...imprintPayload.properties,
                // All imprint data ready!
                // Add product-specific properties using utilities
                "Color": colorSizeLine.slectedColor.title,
                // Only add Size if it's not a qty-only product
                ...isQtyOnly ? {} : { "Size": size },
                "_Product name": names.order,
                "_Cart product name": names.cart,
                "_img_src": colorSizeLine.slectedColor.img_src,
                "_mainProductId": appStore.mainProductID,
                "_colorId": colorSizeLine.slectedColor.id,
                "_productUrl": window.location.pathname,
                "_groupID": groupID,
                "_qtyIncrement": imprintStore.currentQtyIncrement,
                "_runningFeePerItem": this.runningFeePerItem,
                // Product metadata from simple_array (using utilities)
                "_Product Weight": getProductWeight(colorSizeLine, sizeForSku, imprintStore, appStore),
                "_Product Color": colorSizeLine.slectedColor.title,
                "_Product SKU": buildProductSKU(colorSizeLine, sizeForSku, appStore, imprintStore)
              };
              items.push({
                id: colorSizeLine.slectedColor.id,
                quantity: qty,
                properties,
                metaData: buildItemMetaData(
                  colorSizeLine,
                  sizeForSku,
                  appStore,
                  imprintStore,
                  selectionStore,
                  this.priceData.priceByQty
                )
              });
            }
          }
        });
        console.log("[AddToCart] Built", items.length, "cart items");
        const colorProductId = getColorProductId(lines, appStore);
        return {
          id: appStore.mainProductID,
          imprint_lines: imprintPayload.imprint_lines,
          items,
          colorProductID: colorProductId
        };
      },
      /**
       * Validate all data before adding to cart
       * Uses cartValidation.js utility
       */
      validate() {
        const appStore = useAppStore();
        const selectionStore = useSelectionStore();
        const imprintStore = useImprintStore();
        const newImprintStore = useNewImprintStore();
        this.validationResult = validateAddToCart({
          appStore,
          selectionStore,
          imprintStore,
          newImprintStore
        });
        return this.validationResult;
      },
      /**
       * Gather price data from stores and calculate fees
       * 
       * This method:
       * 1. Gets tier pricing based on quantity
       * 2. Applies sale prices if applicable
       * 3. Calculates size/color upcharges
       * 4. Gets base fees from backend config
       * 
       * Note: Actual fees are calculated in transform methods/utilities
       * This just gathers the base pricing structure
       */
      gatherPriceData() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
        const imprintStore = useImprintStore();
        const selectionStore = useSelectionStore();
        const imprintKey = imprintStore.selectedImprintMethod.name;
        const totalQty = selectionStore.getTotalQtyByImprintKey(imprintKey);
        const sku = imprintStore.selectedImprintMethod.sku;
        const configurableData = (_b = (_a = imprintStore.fullJson) == null ? void 0 : _a.configurable_array) == null ? void 0 : _b[sku];
        const tierPricing = ((_c = configurableData == null ? void 0 : configurableData.prices_2) == null ? void 0 : _c.tier_price) || ((_d = configurableData == null ? void 0 : configurableData.prices) == null ? void 0 : _d.tier_price) || [];
        let applicableTier = tierPricing[0];
        for (const tier of tierPricing) {
          if (totalQty >= tier.QtyMin) {
            applicableTier = tier;
          } else {
            break;
          }
        }
        let priceByQty = (applicableTier == null ? void 0 : applicableTier.price) || 0;
        if (applicableTier == null ? void 0 : applicableTier.sale_price) {
          const now = /* @__PURE__ */ new Date();
          const effectiveDate = applicableTier.sale_price_effectivedate ? new Date(applicableTier.sale_price_effectivedate) : null;
          const terminationDate = applicableTier.sale_price_terminationdate ? new Date(applicableTier.sale_price_terminationdate) : null;
          if ((!effectiveDate || now >= effectiveDate) && (!terminationDate || now <= terminationDate)) {
            priceByQty = applicableTier.sale_price;
          }
        }
        if (priceByQty === 0) {
          priceByQty = ((_e = configurableData == null ? void 0 : configurableData.prices_2) == null ? void 0 : _e.min_price) || ((_f = configurableData == null ? void 0 : configurableData.prices) == null ? void 0 : _f.min_price) || ((_g = configurableData == null ? void 0 : configurableData.prices_2) == null ? void 0 : _g.sale_min_price) || 0;
        }
        let totalSizeUpcharge = 0;
        let totalColorUpcharge = 0;
        const lines = selectionStore.getLinesByImprintKey(imprintKey);
        lines.forEach((line) => {
          var _a2;
          const color = line.slectedColor;
          const colorName = (_a2 = color == null ? void 0 : color.title) == null ? void 0 : _a2.toLowerCase();
          if (colorName && imprintStore.colorUpcharge[colorName]) {
            const colorUpchargeData = imprintStore.colorUpcharge[colorName];
            totalColorUpcharge += colorUpchargeData.price || 0;
          }
          if (line.selectedSizes) {
            Object.keys(line.selectedSizes).forEach((size) => {
              const qty = line.selectedSizes[size];
              if (qty > 0 && imprintStore.sizeUpcharge[size]) {
                totalSizeUpcharge += imprintStore.sizeUpcharge[size] * qty;
              }
            });
          }
        });
        const imprintData = ((_h = configurableData == null ? void 0 : configurableData.configurable_2_data) == null ? void 0 : _h.imprint_data) || {};
        const tierPricingWithFlags = tierPricing.map((tier) => ({
          ...tier,
          is_special_tier: tier.is_special_tier || false
        }));
        const appStore = useAppStore();
        this.priceData = {
          tier: tierPricingWithFlags,
          b2bTier: appStore.getB2BTierForSku(sku) ?? null,
          tierMSRP: ((_i = configurableData == null ? void 0 : configurableData.prices_2) == null ? void 0 : _i.msrp) || ((_j = configurableData == null ? void 0 : configurableData.prices) == null ? void 0 : _j.msrp) || 0,
          priceByQty,
          priceSizeUpcharge: totalSizeUpcharge,
          priceColorUpcharge: totalColorUpcharge,
          setup_fee: imprintData.setup_fee || 0,
          // Base fee from backend
          proof_fee: imprintData.proof_fee || 0,
          // Base fee from backend
          image_fee: imprintData.image_fee || 0,
          // Base fee from backend
          customColourFee: 0,
          running_fee: imprintData.running_fee || 0
          // Base fee from backend
        };
        this.perItemFee.setupFee = this.priceData.setup_fee;
        this.perItemFee.proof_fee = this.priceData.proof_fee;
        return this.priceData;
      },
      /**
       * Get group ID from app store
       */
      getGroupID() {
        const appStore = useAppStore();
        if (!appStore.currentGroupID) {
          appStore.generateGroupID();
        }
        return appStore.currentGroupID;
      },
      /**
       * Main Add to Cart method
       * 
       * Orchestrates the complete flow:
       * 1. Generate correlation ID
       * 2. Validate all data
       * 3. Gather price data
       * 4. Build cart payload
       * 5. Send to backend and Shopify
       * 6. Handle redirect
       */
      async addToCart({ onAfterSuccess } = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        try {
          this.loader = true;
          const date = /* @__PURE__ */ new Date();
          console.log(`[AddToCart] Start adding to cart: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`);
          const appStore = useAppStore();
          const imprintStore = useImprintStore();
          const selectionStore = useSelectionStore();
          this._corrId = `ATC-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
          this.addLog({
            type: "debug",
            message: `ATC start corrId=${this._corrId}; appType=${appStore.applicationType}; isEnvelop=${!!appStore.isEnvelopProduct}`
          });
          const resultv = this.validate();
          console.log("[AddToCart] Validation result:", resultv);
          if (appStore.isEnvelopProduct) {
            this.validationResult.hasError = false;
          }
          if (!this.validationResult.hasError) {
            this.gatherPriceData();
            const prepareDataToCart = this.buildCartPayload();
            if (!prepareDataToCart) {
              this.loader = false;
              this.addLog({
                type: "critical",
                message: `${this._corrId} buildCartPayload() returned null - cannot proceed`
              });
              console.error("[AddToCart] Failed to build cart payload");
              return;
            }
            prepareDataToCart.items = (Array.isArray(prepareDataToCart.items) ? prepareDataToCart.items : []).filter((item) => Number(item == null ? void 0 : item.quantity) > 0);
            if (prepareDataToCart.items.length === 0) {
              this.loader = false;
              this.addLog({
                type: "debug",
                message: `${this._corrId} no items with quantity > 0 - add to cart not sent`
              });
              window.dispatchEvent(new CustomEvent("add-to-cart-error", { detail: {
                title: "Nothing to add",
                message: "Please enter a quantity for at least one item, then add to cart again.",
                primaryLabel: "OK",
                reloadOnPrimary: false
              } }));
              return;
            }
            console.log("[AddToCart] Cart payload built successfully:", prepareDataToCart);
            try {
              const sumItems = (prepareDataToCart.items || []).map((i) => {
                var _a2, _b2;
                return {
                  colorId: i.id,
                  qty: i.quantity,
                  sku: (_a2 = i.metaData) == null ? void 0 : _a2.color_sku,
                  price: (_b2 = i.metaData) == null ? void 0 : _b2.price
                };
              });
              this.addLog({
                type: "debug",
                message: `${this._corrId} BE payload summary: colorProductID=${prepareDataToCart.colorProductID}; items=${sumItems.length}; sample=${JSON.stringify(sumItems.slice(0, 3))}`
              });
            } catch (e) {
              console.warn("[AddToCart] Failed to log payload summary:", e);
            }
            const apiData = {
              "mode": appStore.applicationType,
              "associatedFeeID": window.PXUTheme.theme_settings.associated_fee_id,
              "placeholderImageGID": window.PXUTheme.theme_settings.placeholder_image_gid,
              "shop": "mapleleafpromotions",
              "shop_domain": "mapleleafpromotions.myshopify.com",
              "isCustomerGuest": appStore.isCustomerGuest,
              // customerId is passed so the backend can resolve the B2B company ID
              // via the Shopify Admin API. b2bCompanyId is intentionally omitted —
              // the backend derives it server-side and never trusts client input.
              "customerId": ((_b = (_a = document.getElementById("customer_id")) == null ? void 0 : _a.textContent) == null ? void 0 : _b.trim()) || "",
              "data": prepareDataToCart,
              "_corrId": this._corrId
            };
            if (appStore.isEnvelopProduct) {
              apiData.isEnvelopProduct = true;
            }
            if (window.PXUTheme.theme_settings.api_shop_domain) {
              const domainStr = window.PXUTheme.theme_settings.api_shop_domain;
              apiData.shop_domain = domainStr;
              apiData.shop = domainStr.replace(".myshopify.com", "");
            }
            this.addToCartStatus = true;
            const imprintKey = imprintStore.selectedImprintMethod.name;
            const totalQty = selectionStore.getTotalQtyByImprintKey(imprintKey);
            const cartAPI = useCartAPI();
            const cartObjectRef = /* @__PURE__ */ ref(this.cartObject);
            const responsedCartItemsRef = /* @__PURE__ */ ref(this.responsedCartItems);
            const imprintSku = (_c = imprintStore.selectedImprintMethod) == null ? void 0 : _c.sku;
            const imprintData = imprintSku ? (_g = (_f = (_e = (_d = imprintStore.fullJson) == null ? void 0 : _d.configurable_array) == null ? void 0 : _e[imprintSku]) == null ? void 0 : _f.configurable_2_data) == null ? void 0 : _g.imprint_data : null;
            const additionalLocationFeeSku = ((_i = (_h = imprintStore.currentAdditionalLocationFeeTiers) == null ? void 0 : _h[0]) == null ? void 0 : _i.sku) || "ADDLOCRUN";
            const feeSkus = {
              setup_fee_sku: (imprintData == null ? void 0 : imprintData.setup_fee_sku) || "",
              running_fee_sku: (imprintData == null ? void 0 : imprintData.running_fee_sku) || "",
              image_fee_sku: (imprintData == null ? void 0 : imprintData.image_fee_sku) || "",
              colour_fee_sku: (imprintData == null ? void 0 : imprintData.colour_fee_sku) || "",
              proof_fee_sku: (imprintData == null ? void 0 : imprintData.proof_fee_sku) || "",
              additional_location_fee_sku: additionalLocationFeeSku
            };
            console.log("[AddToCart] Fee SKUs from product data:", feeSkus);
            await cartAPI.completeAddToCart({
              apiData,
              corrId: this._corrId,
              groupID: this.getGroupID(),
              cartState: this.cartState,
              cartObject: cartObjectRef,
              responsedCartItems: responsedCartItemsRef,
              feeSkus,
              onSuccess: async () => {
                var _a2;
                this.cartObject = cartObjectRef.value;
                this.responsedCartItems = responsedCartItemsRef.value;
                this.addToCartStatus = false;
                this.loader = false;
                const minQty = ((_a2 = this.priceData.tier[0]) == null ? void 0 : _a2.QtyMin) || 0;
                setMinQtyToStorage(this.getGroupID(), minQty, totalQty);
                appStore.generateGroupID();
                if (typeof onAfterSuccess === "function") {
                  console.log("[AddToCart] Calling onAfterSuccess (clearAllData)...");
                  onAfterSuccess();
                }
                try {
                  if (window.__cartRecovery) {
                    const result = await window.__cartRecovery.recoverCart();
                    if (result == null ? void 0 : result.broken) {
                      console.warn("[AddToCart] Recovered broken cart before redirect:", result);
                    }
                  }
                } catch (e) {
                  console.error("[AddToCart] cart recovery check failed (non-blocking):", e);
                }
                this.waitForLocalStorageAndRedirect();
              },
              onError: (error) => {
                this.loader = false;
                this.addToCartStatus = false;
                this.addLog({
                  type: "critical",
                  message: `${this._corrId} Add to cart failed: ${error.message}`
                });
                if (window.__cartRecovery) {
                  window.__cartRecovery.recoverCart().catch(() => {
                  });
                }
              }
            });
          } else {
            this.loader = false;
            console.error("[AddToCart] Validation failed:", this.validationResult.errors);
          }
        } catch (e) {
          this.loader = false;
          this.addToCartStatus = false;
          console.error("[AddToCart] Exception:", e);
          this.addLog({
            type: "critical",
            message: `${this._corrId} Exception in addToCart(): ${(e == null ? void 0 : e.message) || e}`
          });
        }
      },
      /**
       * Wait for localStorage to be ready, then redirect to cart
       * 
       * This ensures both minQty and cartItems are saved before redirecting
       */
      waitForLocalStorageAndRedirect() {
        const maxIteration = 50;
        let counter = 0;
        const checkAndRedirect = () => {
          counter++;
          let hasMinQty = false;
          try {
            hasMinQty = validateCartLocalStorageVariables();
          } catch (e) {
            console.warn("[AddToCart] validateCartLocalStorageVariables failed", e);
            hasMinQty = false;
          }
          const hasCartItems = localStorage.getItem("cartItems") !== null;
          if (hasMinQty && hasCartItems) {
            console.log("[AddToCart] localStorage ready, redirecting to cart");
            window.location.href = "/cart";
          } else if (counter < maxIteration) {
            setTimeout(checkAndRedirect, 100);
          } else {
            console.error("[AddToCart] Redirect timeout - missing localStorage:", {
              hasMinQty,
              hasCartItems
            });
            try {
              localStorage.setItem("atc_redirect_timeout", "1");
            } catch (e) {
              console.warn("[AddToCart] localStorage blocked, skipping flag", e);
            }
            window.location.href = "/cart";
          }
        };
        setTimeout(checkAndRedirect, 100);
      }
    }
  });
  const IMPRINT_METHOD_DESCRIPTIONS = {
    SCRE: {
      code: "SCRE",
      name: "Screenprint",
      description: `Your products will be Screen Printed in the ${getColorName(true)}(s) you specify. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "screenprint.png"
    },
    EMBR: {
      code: "EMBR",
      name: "Embroidery",
      description: `Your products will be Embroidered in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "embroidery.png"
    },
    CMYK: {
      code: "CMYK",
      name: "CMYK",
      description: `Your products will be imprinted in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Also known as 4 ${getColorName(true)} process, this method uses primary colours: Cyan, Magenta, Yellow and Black to produce a full ${getColorName(true)} screen printed imprint. Useful when exact ${getColorName(true)} matches are required on a full ${getColorName(true)} imprint. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "cmyk.png"
    },
    // Full Color variants
    FULL: {
      code: "FULL",
      name: "Full Color",
      description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "cmyk.png"
      // Using same image as CMYK
    },
    FULLCOLOR: {
      code: "FULLCOLOR",
      name: "Full Color",
      description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "cmyk.png"
    },
    FC: {
      code: "FC",
      name: "Full Color",
      description: `This is a printing technique that transfers vibrant, full-color designs onto fabrics. A design is printed onto a special film, placed on the fabric, and a heat press transfers the design. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "cmyk.png"
    },
    DTG: {
      code: "DTG",
      name: "DTG",
      description: `Your products will be printed Direct-to-Garment in the ${getColorName(true)}(s) you specify including full ${getColorName(true)}. Full ${getColorName(true)} inks are jetted or sprayed onto the textile by the print head. The inks soak into the garment fibers directly and then it is sealed with heat. It's like printing on paper, but on fabric! You can make intricate colourful designs with many details, and photo-realistic artwork. Preferred imprint method for many apparel options. Please enter lines of text with your message, attach a logo or art file, or provide special instructions for your imprint.`,
      image: "dtg.png"
    }
  };
  function getImprintMethodBySku(sku) {
    if (!sku) return null;
    const parts = sku.split("_");
    const methodCode = parts[parts.length - 1];
    return IMPRINT_METHOD_DESCRIPTIONS[methodCode] || null;
  }
  function getFallbackDescription(sku) {
    const descriptions = {
      SCRE: "Your products will be Screen Printed in the colour(s) you specify.",
      EMBR: "Your products will be Embroidered with your custom design.",
      DTG: "Your products will be printed using Direct-to-Garment (DTG) technology.",
      DTF: "Your products will be printed using Direct-to-Film (DTF) technology.",
      CMYK: "Your products will be printed in full color using CMYK printing technology.",
      FULL: "This is a printing technique that transfers vibrant, full-color designs onto fabrics.",
      FULLCOLOR: "This is a printing technique that transfers vibrant, full-color designs onto fabrics.",
      FC: "This is a printing technique that transfers vibrant, full-color designs onto fabrics."
    };
    const parts = (sku || "").split("_");
    const methodCode = parts[parts.length - 1];
    return descriptions[methodCode] || "Your products will be customized with your design.";
  }
  const _sfc_main$v = {
    name: "ImprintPriceMatrix",
    data() {
      return {
        // Cache: key = `${methodKey}:${qty}` => tier|null
        tierCache: /* @__PURE__ */ Object.create(null),
        functions,
        _resizeHandler: null,
        isMobileView: typeof window !== "undefined" && window.innerWidth <= 767
      };
    },
    computed: {
      imprintStore() {
        return useImprintStore();
      },
      appStore() {
        return useAppStore();
      },
      configurableArray() {
        return this.imprintStore.configurableArray;
      },
      methodKeys() {
        return this.imprintStore.availableImprintMethods.map((method) => method.sku);
      },
      quantityBreaks() {
        return this.imprintStore.quantityBreaks;
      },
      hasMethods() {
        return this.methodKeys.length > 0;
      },
      pmConfig() {
        var _a, _b;
        return ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.price_matrix) || {};
      },
      /**
       * Returns a Set of column indices (0-based) that have at least one
       * method with an active sale_price AND a sale_price_column_text.
       * sale_price_column_text is the gatekeeper — without it nothing renders.
       */
      columnsWithActiveSale() {
        const result = /* @__PURE__ */ new Set();
        this.quantityBreaks.forEach((qty, idx) => {
          for (const methodKey of this.methodKeys) {
            const tier = this.getTierForQty(methodKey, qty);
            if (tier && this.isSalePriceValid(tier) && tier.sale_price_column_text) {
              result.add(idx);
              break;
            }
          }
        });
        return result;
      },
      /**
       * Returns the 0-based index of the "source" column —
       * the column whose regular prices are being matched by the sale.
       * Only active when at least one sale column has sale_price_column_text.
       *
       * Detection logic:
       *   1. No badge columns     → -1
       *   2. ALL columns on sale  → last column is the source
       *   3. Normal case          → price-match: non-sale column whose
       *                             regular price ≈ sale_price of a sale column
       *   4. Fallback             → first non-sale column after last sale column
       */
      saleSourceColumnIndex() {
        const breaks = this.quantityBreaks;
        const saleSet = this.columnsWithActiveSale;
        if (saleSet.size === 0) return -1;
        if (this.pmConfig.disable_column_highlight) return -1;
        if (saleSet.size === breaks.length) {
          return breaks.length - 1;
        }
        for (const methodKey of this.methodKeys) {
          for (const saleIdx of saleSet) {
            const saleTier = this.getTierForQty(methodKey, breaks[saleIdx]);
            if (!saleTier || !this.isSalePriceValid(saleTier) || !saleTier.sale_price_column_text) continue;
            const salePrice = Number(saleTier.sale_price);
            for (let i = 0; i < breaks.length; i++) {
              if (saleSet.has(i)) continue;
              const refTier = this.getTierForQty(methodKey, breaks[i]);
              if (!refTier) continue;
              if (Math.abs(Number(refTier.price) - salePrice) < 5e-3) {
                return i;
              }
            }
          }
        }
        const lastSaleIdx = Math.max(...saleSet);
        for (let i = lastSaleIdx + 1; i < breaks.length; i++) {
          if (!saleSet.has(i)) return i;
        }
        return -1;
      },
      /**
       * Reactive mobile flag — updated in the resize handler so that
       * column labels and getBadgeText() switch on resize.
       */
      isMobile() {
        return this.isMobileView;
      },
      printMethodTooltipsEnabled() {
        var _a, _b;
        return typeof window !== "undefined" && ((_b = (_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.enable_price_grid_tooltips) === true;
      },
      badgeStyle() {
        return {
          background: this.pmConfig.badge_background || "#FAA633",
          color: this.pmConfig.badge_text_color || "#FFFFFF"
        };
      }
    },
    watch: {
      configurableArray() {
        this.tierCache = /* @__PURE__ */ Object.create(null);
        this.syncBadgeHeights();
      }
    },
    mounted() {
      this.syncBadgeHeights();
      this._resizeHandler = this._debounce(() => {
        this.isMobileView = window.innerWidth <= 767;
        this.syncBadgeHeights();
      }, 100);
      window.addEventListener("resize", this._resizeHandler);
    },
    beforeUnmount() {
      if (this._resizeHandler) {
        window.removeEventListener("resize", this._resizeHandler);
      }
    },
    methods: {
      getB2BTierForMethod(methodKey) {
        return this.appStore.getB2BTierForSku(methodKey);
      },
      getTiers(methodKey) {
        var _a, _b;
        const method = ((_a = this.configurableArray) == null ? void 0 : _a[methodKey]) || {};
        const tiers = ((_b = method == null ? void 0 : method.prices_2) == null ? void 0 : _b.tier_price) || [];
        return Array.isArray(tiers) ? tiers : [];
      },
      /**
       * Returns the tier that applies to the given quantity break.
       * Picks the tier with max(QtyMin) <= qty.
       */
      getTierForQty(methodKey, qty) {
        const tiers = this.getTiers(methodKey).map((t) => ({ ...t, QtyMin: Number(t == null ? void 0 : t.QtyMin) })).filter((t) => !Number.isNaN(t.QtyMin)).sort((a, b) => a.QtyMin - b.QtyMin);
        if (!tiers.length) return null;
        let best = null;
        for (let i = 0; i < tiers.length; i += 1) {
          if (tiers[i].QtyMin <= qty) best = tiers[i];
        }
        return best || tiers[0] || null;
      },
      cellTier(methodKey, qty) {
        const k = `${methodKey}:${qty}`;
        if (Object.prototype.hasOwnProperty.call(this.tierCache, k)) {
          return this.tierCache[k];
        }
        const tier = this.getTierForQty(methodKey, qty);
        this.tierCache[k] = tier;
        return tier;
      },
      formatMoney(value) {
        const n = Number(value);
        if (Number.isNaN(n)) return "";
        return `${n.toFixed(2)}`;
      },
      /**
       * Returns the display name for a method key.
       */
      getMethodName(methodKey) {
        var _a;
        const method = (_a = this.configurableArray) == null ? void 0 : _a[methodKey];
        return (method == null ? void 0 : method.name) || methodKey;
      },
      getMethodDescription(methodKey) {
        var _a, _b;
        const staticData = getImprintMethodBySku(methodKey);
        if (staticData == null ? void 0 : staticData.description) return staticData.description;
        const liveDescription = (_b = (_a = this.configurableArray) == null ? void 0 : _a[methodKey]) == null ? void 0 : _b.imprint_description;
        if (liveDescription) return liveDescription;
        return getFallbackDescription(methodKey);
      },
      /**
       * Returns true if the tier has a valid sale_price with active dates.
       */
      isSalePriceValid(tier) {
        if (!tier) return false;
        return this.functions.isValidatedSpecialPrice(tier);
      },
      /**
       * Measures all rendered .pm__badge elements and sets minHeight
       * on all of them to the tallest one, so badges stay uniform.
       * Called on mount, data change, and window resize (debounced).
       */
      syncBadgeHeights() {
        this.$nextTick(() => {
          const badges = this.$el ? [...this.$el.querySelectorAll(".pm__badge")] : [];
          if (!badges.length) return;
          badges.forEach((b) => {
            b.style.minHeight = "";
          });
          const maxH = Math.max(...badges.map((b) => b.getBoundingClientRect().height));
          if (maxH > 0) {
            badges.forEach((b) => {
              b.style.minHeight = maxH + "px";
            });
          }
        });
      },
      /**
       * Simple debounce — avoids pulling in lodash for one call.
       */
      _debounce(fn, delay) {
        let timer = null;
        return function(...args) {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), delay);
        };
      },
      getBadgeText(colIdx) {
        if (this.pmConfig.disable_badge_text) return null;
        const qty = this.quantityBreaks[colIdx];
        for (const methodKey of this.methodKeys) {
          const tier = this.getTierForQty(methodKey, qty);
          if (!tier || !this.isSalePriceValid(tier) || !tier.sale_price_column_text) continue;
          if (this.isMobile && tier.sale_price_column_text_mobile) {
            return tier.sale_price_column_text_mobile;
          }
          return tier.sale_price_column_text;
        }
        return null;
      }
    }
  };
  const _hoisted_1$v = {
    class: "pm",
    id: "price-table"
  };
  const _hoisted_2$o = {
    key: 0,
    class: "pm__table"
  };
  const _hoisted_3$m = { class: "pm__rowhead" };
  const _hoisted_4$l = {
    key: 0,
    class: "fee-tooltip-wrap"
  };
  const _hoisted_5$i = { class: "fee-tooltip-content" };
  const _hoisted_6$i = {
    key: "price",
    class: "pm__cell"
  };
  const _hoisted_7$g = {
    key: 0,
    class: "pm__price pm__price--sale"
  };
  const _hoisted_8$e = {
    key: 1,
    class: "pm__price pm__price--sale"
  };
  const _hoisted_9$c = {
    key: 1,
    class: "pm__cell"
  };
  const _hoisted_10$c = { key: 0 };
  const _hoisted_11$c = { class: "pm__badge-line" };
  const _hoisted_12$c = {
    key: 1,
    class: "pm__empty-state"
  };
  function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$v, [
      $options.hasMethods ? (openBlock(), createElementBlock("table", _hoisted_2$o, [
        createBaseVNode("thead", null, [
          createBaseVNode("tr", null, [
            _cache[0] || (_cache[0] = createBaseVNode("th", { class: "pm__th pm__th--rowhead pm__th--label" }, "Column", -1)),
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.quantityBreaks, (q, qIdx) => {
              return openBlock(), createElementBlock("th", {
                key: "col-label-" + qIdx,
                class: normalizeClass(["pm__th pm__th--label", { "pm__th--source": qIdx === $options.saleSourceColumnIndex }])
              }, toDisplayString($options.isMobile ? "Col. " + (qIdx + 1) : "Column " + (qIdx + 1)), 3);
            }), 128))
          ]),
          createBaseVNode("tr", null, [
            _cache[1] || (_cache[1] = createBaseVNode("th", { class: "pm__th pm__th--rowhead" }, "Quantity", -1)),
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.quantityBreaks, (q, qIdx) => {
              return openBlock(), createElementBlock("th", {
                key: q,
                class: normalizeClass(["pm__th", { "pm__th--source": qIdx === $options.saleSourceColumnIndex }])
              }, toDisplayString(q) + "+ ", 3);
            }), 128))
          ])
        ]),
        createBaseVNode("tbody", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.methodKeys, (methodKey) => {
            return openBlock(), createElementBlock("tr", { key: methodKey }, [
              createBaseVNode("th", _hoisted_3$m, [
                createTextVNode(toDisplayString($options.getMethodName(methodKey)) + " ", 1),
                $options.printMethodTooltipsEnabled && $options.getMethodDescription(methodKey) ? (openBlock(), createElementBlock("span", _hoisted_4$l, [
                  _cache[2] || (_cache[2] = createBaseVNode("span", { class: "fee-tooltip-icon" }, "?", -1)),
                  createBaseVNode("span", _hoisted_5$i, toDisplayString($options.getMethodDescription(methodKey)), 1)
                ])) : createCommentVNode("", true)
              ]),
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.quantityBreaks, (q, qIdx) => {
                return openBlock(), createElementBlock("td", {
                  key: methodKey + ":" + q,
                  class: normalizeClass(["pm__td", { "pm__td--source": qIdx === $options.saleSourceColumnIndex }])
                }, [
                  $options.getTierForQty(methodKey, q) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList([$options.getB2BTierForMethod(methodKey)], (b2bTier) => {
                    return openBlock(), createElementBlock(Fragment, { key: "b2b" }, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList([$data.functions.getB2BPriceForTier($options.getTierForQty(methodKey, q), b2bTier)], (b2bPrice) => {
                        return openBlock(), createElementBlock("div", _hoisted_6$i, [
                          createBaseVNode("div", {
                            class: normalizeClass(["pm__price pm__price--regular", {
                              "pm__price--strikethrough": b2bPrice !== null || $options.isSalePriceValid($options.getTierForQty(methodKey, q))
                            }])
                          }, toDisplayString($options.formatMoney($options.getTierForQty(methodKey, q).price)), 3),
                          b2bPrice !== null ? (openBlock(), createElementBlock("div", _hoisted_7$g, toDisplayString($options.formatMoney(b2bPrice)), 1)) : $options.isSalePriceValid($options.getTierForQty(methodKey, q)) ? (openBlock(), createElementBlock("div", _hoisted_8$e, toDisplayString($options.formatMoney($options.getTierForQty(methodKey, q).sale_price)), 1)) : createCommentVNode("", true)
                        ]);
                      }), 128))
                    ], 64);
                  }), 128)) : (openBlock(), createElementBlock("div", _hoisted_9$c, [..._cache[3] || (_cache[3] = [
                    createBaseVNode("span", { class: "pm__empty" }, "—", -1)
                  ])]))
                ], 2);
              }), 128))
            ]);
          }), 128))
        ]),
        $options.columnsWithActiveSale.size > 0 ? (openBlock(), createElementBlock("tfoot", _hoisted_10$c, [
          createBaseVNode("tr", null, [
            _cache[4] || (_cache[4] = createBaseVNode("td", { class: "pm__foot-spacer" }, null, -1)),
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.quantityBreaks, (q, qIdx) => {
              return openBlock(), createElementBlock("td", {
                key: "foot:" + q,
                class: "pm__foot-cell"
              }, [
                $options.columnsWithActiveSale.has(qIdx) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList([$options.getBadgeText(qIdx)], (badgeText) => {
                  return openBlock(), createElementBlock(Fragment, { key: "badge" }, [
                    badgeText ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: "pm__badge",
                      style: normalizeStyle($options.badgeStyle)
                    }, [
                      createBaseVNode("span", _hoisted_11$c, toDisplayString(badgeText), 1)
                    ], 4)) : createCommentVNode("", true)
                  ], 64);
                }), 128)) : createCommentVNode("", true)
              ]);
            }), 128))
          ])
        ])) : createCommentVNode("", true)
      ])) : (openBlock(), createElementBlock("div", _hoisted_12$c, " No pricing data (configurable_array is empty). "))
    ]);
  }
  const ImprintPriceMatrix = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$r], ["__scopeId", "data-v-5c4f6cb8"]]);
  const _sfc_main$u = {
    name: "BaseButton",
    // Declaring emits prevents @click from falling through $attrs to the root element.
    // Without this, clicking the button fires the parent's @click handler TWICE:
    // once via native click ($attrs fallthrough) and once via this.$emit('click').
    emits: ["click"],
    props: {
      /**
       * Button text content
       */
      text: {
        type: String,
        default: ""
      },
      /**
       * Button variant/type
       * @values primary, secondary, outline, outline-yellow, text, danger
       */
      variant: {
        type: String,
        default: "primary",
        validator: (value) => ["primary", "secondary", "outline", "outline-yellow", "text", "danger"].includes(value)
      },
      /**
       * Button size
       * @values small, medium, large
       */
      size: {
        type: String,
        default: "medium",
        validator: (value) => ["small", "medium", "large"].includes(value)
      },
      /**
       * Icon (can be string class or Vue component)
       */
      icon: {
        type: [String, Object],
        default: null
      },
      /**
       * Icon position
       * @values left, right, top
       */
      iconPosition: {
        type: String,
        default: "left",
        validator: (value) => ["left", "right", "top"].includes(value)
      },
      /**
       * HTML button type
       * @values button, submit, reset
       */
      buttonType: {
        type: String,
        default: "button",
        validator: (value) => ["button", "submit", "reset"].includes(value)
      },
      /**
       * Disabled state
       */
      disabled: {
        type: Boolean,
        default: false
      },
      /**
       * Loading state
       */
      loading: {
        type: Boolean,
        default: false
      },
      /**
       * Full width button
       */
      block: {
        type: Boolean,
        default: false
      },
      /**
       * Custom color scheme (overrides variant)
       */
      color: {
        type: String,
        default: null
      }
    },
    computed: {
      buttonClasses() {
        return [
          "base-button",
          `base-button--${this.variant}`,
          `base-button--${this.size}`,
          {
            "base-button--block": this.block,
            "base-button--disabled": this.disabled,
            "base-button--loading": this.loading,
            "base-button--icon-only": this.icon && !this.text && !this.$slots.default,
            "base-button--with-icon": this.icon,
            "base-button--icon-top": this.icon && this.iconPosition === "top"
          }
        ];
      }
    },
    methods: {
      handleClick(event2) {
        if (!this.disabled && !this.loading) {
          this.$emit("click", event2);
        }
      }
    }
  };
  const _hoisted_1$u = ["type", "disabled"];
  const _hoisted_2$n = {
    key: 0,
    class: "btn-spinner"
  };
  const _hoisted_3$l = {
    key: 1,
    class: "btn-icon btn-icon--top"
  };
  const _hoisted_4$k = {
    key: 2,
    class: "btn-icon btn-icon--left"
  };
  const _hoisted_5$h = { class: "btn-text" };
  const _hoisted_6$h = {
    key: 3,
    class: "btn-icon btn-icon--right"
  };
  function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("button", {
      type: $props.buttonType,
      class: normalizeClass($options.buttonClasses),
      disabled: $props.disabled || $props.loading,
      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
    }, [
      $props.loading ? (openBlock(), createElementBlock("span", _hoisted_2$n, [..._cache[1] || (_cache[1] = [
        createBaseVNode("span", { class: "spinner" }, null, -1)
      ])])) : createCommentVNode("", true),
      $props.icon && $props.iconPosition === "top" && !$props.loading ? (openBlock(), createElementBlock("span", _hoisted_3$l, [
        typeof $props.icon === "object" ? (openBlock(), createBlock(resolveDynamicComponent($props.icon), { key: 0 })) : (openBlock(), createElementBlock("i", {
          key: 1,
          class: normalizeClass($props.icon)
        }, null, 2))
      ])) : createCommentVNode("", true),
      $props.icon && $props.iconPosition === "left" && !$props.loading ? (openBlock(), createElementBlock("span", _hoisted_4$k, [
        typeof $props.icon === "object" ? (openBlock(), createBlock(resolveDynamicComponent($props.icon), { key: 0 })) : (openBlock(), createElementBlock("i", {
          key: 1,
          class: normalizeClass($props.icon)
        }, null, 2))
      ])) : createCommentVNode("", true),
      createBaseVNode("span", _hoisted_5$h, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createTextVNode(toDisplayString($props.text), 1)
        ])
      ]),
      $props.icon && $props.iconPosition === "right" && !$props.loading ? (openBlock(), createElementBlock("span", _hoisted_6$h, [
        typeof $props.icon === "object" ? (openBlock(), createBlock(resolveDynamicComponent($props.icon), { key: 0 })) : (openBlock(), createElementBlock("i", {
          key: 1,
          class: normalizeClass($props.icon)
        }, null, 2))
      ])) : createCommentVNode("", true)
    ], 10, _hoisted_1$u);
  }
  const BaseButton = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$q], ["__scopeId", "data-v-6f92f3c5"]]);
  const _hoisted_1$t = { class: "calendar-product-list" };
  const _hoisted_2$m = {
    key: 0,
    class: "loading-state"
  };
  const _hoisted_3$k = {
    key: 1,
    class: "empty-state"
  };
  const _hoisted_4$j = {
    key: 0,
    class: "message-calendar-titles"
  };
  const _hoisted_5$g = { class: "calendar-products" };
  const _hoisted_6$g = { class: "product-image" };
  const _hoisted_7$f = ["src", "alt"];
  const _hoisted_8$d = {
    key: 1,
    class: "image-placeholder"
  };
  const _hoisted_9$b = { class: "product-info" };
  const _hoisted_10$b = { class: "product-title" };
  const _hoisted_11$b = {
    key: 0,
    class: "product-sku"
  };
  const _hoisted_12$b = { class: "value" };
  const _hoisted_13$b = { class: "product-quantity" };
  const _hoisted_14$9 = { class: "qty-value" };
  const _hoisted_15$8 = {
    key: 1,
    class: "product-price"
  };
  const _hoisted_16$8 = { class: "price-value" };
  const _hoisted_17$7 = { class: "quantity-summary" };
  const _hoisted_18$7 = { class: "summary-row" };
  const _hoisted_19$7 = { class: "summary-value" };
  const _hoisted_20$7 = { class: "summary-row" };
  const _hoisted_21$7 = { class: "summary-value" };
  const _hoisted_22$6 = {
    key: 0,
    class: "validation-error"
  };
  const _hoisted_23$4 = {
    key: 1,
    class: "validation-success"
  };
  const _hoisted_24$4 = {
    key: 3,
    class: "error-messages"
  };
  const _sfc_main$t = {
    __name: "CalendarProductList",
    setup(__props) {
      const appStore = useAppStore();
      const calendarStore = useCalendarStore();
      const products = computed(() => calendarStore.productsWithQuantities);
      const formatPrice = (price) => {
        return Number(price).toFixed(2);
      };
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock("div", _hoisted_1$t, [
          _cache[10] || (_cache[10] = createBaseVNode("h3", { class: "calendar-products__title" }, "Selected Calendar Products", -1)),
          unref(calendarStore).isLoading ? (openBlock(), createElementBlock("div", _hoisted_2$m, [..._cache[0] || (_cache[0] = [
            createBaseVNode("p", null, "Loading calendar products...", -1)
          ])])) : !unref(calendarStore).hasProducts ? (openBlock(), createElementBlock("div", _hoisted_3$k, [..._cache[1] || (_cache[1] = [
            createBaseVNode("p", null, "No calendar products selected.", -1),
            createBaseVNode("p", null, "Please select calendars from the bundle page first.", -1)
          ])])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
            unref(calendarStore).hasBundleCompatibilityError ? (openBlock(), createElementBlock("p", _hoisted_4$j, " Unfortunately, one or more calendar titles in your bundle cannot be ordered together. Please remove one or more titles and try again. ")) : createCommentVNode("", true),
            createBaseVNode("div", _hoisted_5$g, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(products.value, (product) => {
                return openBlock(), createElementBlock("div", {
                  key: product.id,
                  class: "calendar-product-card"
                }, [
                  createBaseVNode("div", _hoisted_6$g, [
                    product.image ? (openBlock(), createElementBlock("img", {
                      key: 0,
                      src: product.image,
                      alt: product.title
                    }, null, 8, _hoisted_7$f)) : (openBlock(), createElementBlock("div", _hoisted_8$d, [..._cache[2] || (_cache[2] = [
                      createBaseVNode("span", null, "No Image", -1)
                    ])]))
                  ]),
                  createBaseVNode("div", _hoisted_9$b, [
                    createBaseVNode("h4", _hoisted_10$b, toDisplayString(product.title), 1),
                    product.calendar_sku ? (openBlock(), createElementBlock("p", _hoisted_11$b, [
                      _cache[3] || (_cache[3] = createBaseVNode("span", { class: "label" }, "SKU:", -1)),
                      createBaseVNode("span", _hoisted_12$b, toDisplayString(product.calendar_sku), 1)
                    ])) : createCommentVNode("", true),
                    createBaseVNode("div", _hoisted_13$b, [
                      _cache[4] || (_cache[4] = createBaseVNode("span", { class: "qty-label" }, "Quantity:", -1)),
                      createBaseVNode("span", _hoisted_14$9, toDisplayString(product.qty), 1)
                    ]),
                    product.unitPrice ? (openBlock(), createElementBlock("div", _hoisted_15$8, [
                      _cache[5] || (_cache[5] = createBaseVNode("span", { class: "price-label" }, "Unit Price:", -1)),
                      createBaseVNode("span", _hoisted_16$8, "$" + toDisplayString(formatPrice(product.unitPrice)), 1)
                    ])) : createCommentVNode("", true)
                  ])
                ]);
              }), 128))
            ]),
            createBaseVNode("div", _hoisted_17$7, [
              createBaseVNode("div", _hoisted_18$7, [
                _cache[6] || (_cache[6] = createBaseVNode("span", { class: "summary-label" }, "Total Quantity:", -1)),
                createBaseVNode("span", _hoisted_19$7, toDisplayString(unref(calendarStore).totalQuantity), 1)
              ]),
              createBaseVNode("div", _hoisted_20$7, [
                _cache[7] || (_cache[7] = createBaseVNode("span", { class: "summary-label" }, "Minimum Required:", -1)),
                createBaseVNode("span", _hoisted_21$7, toDisplayString(unref(appStore).getMinOrderQty), 1)
              ]),
              !unref(calendarStore).meetsMinimumQuantity ? (openBlock(), createElementBlock("div", _hoisted_22$6, [
                _cache[8] || (_cache[8] = createBaseVNode("svg", {
                  class: "error-icon",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  createBaseVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                    "clip-rule": "evenodd"
                  })
                ], -1)),
                createBaseVNode("span", null, " Minimum order quantity not met. Please add " + toDisplayString(unref(appStore).getMinOrderQty - unref(calendarStore).totalQuantity) + " more items. ", 1)
              ])) : unref(calendarStore).isValid && !unref(calendarStore).hasBundleCompatibilityError ? (openBlock(), createElementBlock("div", _hoisted_23$4, [..._cache[9] || (_cache[9] = [
                createBaseVNode("svg", {
                  class: "success-icon",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  createBaseVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                    "clip-rule": "evenodd"
                  })
                ], -1),
                createBaseVNode("span", null, "Minimum quantity requirement met ✓", -1)
              ])])) : createCommentVNode("", true)
            ])
          ], 64)),
          unref(calendarStore).errors.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_24$4, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(calendarStore).errors, (error, idx) => {
              return openBlock(), createElementBlock("div", {
                key: idx,
                class: "error-message"
              }, " ⚠️ " + toDisplayString(error), 1);
            }), 128))
          ])) : createCommentVNode("", true)
        ]);
      };
    }
  };
  const CalendarProductList = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["__scopeId", "data-v-8d8f2a6b"]]);
  const _hoisted_1$s = { class: "qty-wrapper" };
  const _hoisted_2$l = { class: "qty-control" };
  const _hoisted_3$j = ["disabled"];
  const _hoisted_4$i = ["id", "min", "step"];
  const _sfc_main$s = {
    __name: "CalendarQuantityInput",
    props: {
      productId: {
        type: Number,
        required: true
      },
      modelValue: {
        type: Number,
        default: 25
      },
      minQty: {
        type: Number,
        default: 25
      },
      qtyIncrement: {
        type: Number,
        default: 25
      }
    },
    emits: ["update:modelValue", "update:quantity"],
    setup(__props, { emit: __emit }) {
      const props = __props;
      const emit2 = __emit;
      const localQuantity = /* @__PURE__ */ ref(props.modelValue);
      watch(() => props.modelValue, (newValue) => {
        localQuantity.value = newValue;
      });
      const handleInput = () => {
        emit2("update:modelValue", localQuantity.value);
        emit2("update:quantity", localQuantity.value);
      };
      const handleBlur = () => {
        if (localQuantity.value < props.minQty) {
          localQuantity.value = props.minQty;
        } else {
          const remainder = localQuantity.value % props.qtyIncrement;
          if (remainder !== 0) {
            localQuantity.value = Math.round(localQuantity.value / props.qtyIncrement) * props.qtyIncrement;
          }
        }
        if (localQuantity.value < props.minQty) {
          localQuantity.value = props.minQty;
        }
        emit2("update:modelValue", localQuantity.value);
        emit2("update:quantity", localQuantity.value);
        console.log("[CalendarQuantityInput] Quantity adjusted on blur:", localQuantity.value);
      };
      const decreaseQty = () => {
        if (localQuantity.value > props.minQty) {
          localQuantity.value -= props.qtyIncrement;
          if (localQuantity.value < props.minQty) {
            localQuantity.value = props.minQty;
          }
          emit2("update:modelValue", localQuantity.value);
          emit2("update:quantity", localQuantity.value);
        }
      };
      const increaseQty = () => {
        localQuantity.value += props.qtyIncrement;
        emit2("update:modelValue", localQuantity.value);
        emit2("update:quantity", localQuantity.value);
      };
      onMounted(() => {
        console.log("[CalendarQuantityInput] Mounted with productId:", props.productId);
        console.log("[CalendarQuantityInput] Input ID:", `size-input-single-${props.productId}`);
      });
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock("div", _hoisted_1$s, [
          _cache[1] || (_cache[1] = createBaseVNode("div", { class: "qty-label" }, "QTY", -1)),
          createBaseVNode("div", _hoisted_2$l, [
            createBaseVNode("button", {
              class: "qty-btn qty-btn--minus",
              onClick: decreaseQty,
              disabled: localQuantity.value <= __props.minQty,
              type: "button"
            }, " − ", 8, _hoisted_3$j),
            withDirectives(createBaseVNode("input", {
              id: `size-input-single-${__props.productId}`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => localQuantity.value = $event),
              type: "number",
              class: "qty-input size-row__input--add-to-bundle",
              min: __props.minQty,
              step: __props.qtyIncrement,
              onInput: handleInput,
              onBlur: handleBlur
            }, null, 40, _hoisted_4$i), [
              [
                vModelText,
                localQuantity.value,
                void 0,
                { number: true }
              ]
            ]),
            createBaseVNode("button", {
              class: "qty-btn qty-btn--plus",
              onClick: increaseQty,
              type: "button"
            }, " + ")
          ])
        ]);
      };
    }
  };
  const CalendarQuantityInput = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-801ce87f"]]);
  const DEBUG_ENABLED = false;
  const DEBUG_CONFIG = {
    // Show State Debugger panels
    showStateDebugger: DEBUG_ENABLED,
    // Show Cart Payload Tester
    showCartPayloadTester: DEBUG_ENABLED,
    // Show raw JSON data in Step 4 ("Your Customization" section)
    showRawImprintData: DEBUG_ENABLED,
    // Show debug info in Review section (gray box with state data)
    showReviewDebugInfo: DEBUG_ENABLED,
    // Show "Customization Method" section in Review
    showCustomizationMethodInfo: DEBUG_ENABLED,
    // Show Step 3: Add-Ons section
    showAddOnsSection: DEBUG_ENABLED,
    // Show Special Instructions in Step 2 (Start New Imprint form)
    showSpecialInstructionsStep2: DEBUG_ENABLED,
    // Show "Components to migrate" section
    showMigrationInfo: DEBUG_ENABLED,
    // Show console logs from stores
    enableStoreLogging: DEBUG_ENABLED,
    // Show validation debug info
    showValidationDebug: DEBUG_ENABLED,
    // Show calendar single debug info (yellow box with product data)
    showCalendarSingleDebug: DEBUG_ENABLED
  };
  const _hoisted_1$r = { class: "calendar-single-page" };
  const _hoisted_2$k = {
    key: 0,
    style: { "background": "yellow", "padding": "10px", "margin-bottom": "10px" }
  };
  const _hoisted_3$i = { class: "bundle-butons bundle-butons-wrapper calendar" };
  const _hoisted_4$h = ["aria-disabled", "data-product_id", "data-product_title", "data-product_image", "data-product_qty"];
  const minBundleQty = 100;
  const _sfc_main$r = {
    __name: "CalendarSinglePage",
    setup(__props) {
      const appStore = useAppStore();
      const quantity = /* @__PURE__ */ ref(25);
      const handleQuantityUpdate = (newQty) => {
        quantity.value = newQty;
        appStore.calendarSingleData.quantity = newQty;
        console.log("[CalendarSinglePage] Quantity updated:", newQty);
      };
      const handleAddToBundleClick = (e) => {
        if (appStore.isOutOfStock) {
          e.preventDefault();
          e.stopPropagation();
          console.warn("[CalendarSinglePage] Add to Bundle blocked: product is Out of Stock");
        }
      };
      const navigateToCalendars = () => {
        const url = appStore.isComda ? "/collections/promotional-calendars" : "/collections/calendars";
        window.location.href = url;
      };
      onMounted(() => {
        console.log("[CalendarSinglePage] Component mounted");
        console.log("[CalendarSinglePage] isCalendarSingle:", appStore.isCalendarSingle);
        console.log("[CalendarSinglePage] Calendar data:", appStore.calendarSingleData);
      });
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock("div", _hoisted_1$r, [
          unref(DEBUG_CONFIG).showCalendarSingleDebug ? (openBlock(), createElementBlock("div", _hoisted_2$k, [
            _cache[1] || (_cache[1] = createBaseVNode("strong", null, "DEBUG:", -1)),
            _cache[2] || (_cache[2] = createBaseVNode("br", null, null, -1)),
            createTextVNode(" productId: " + toDisplayString(unref(appStore).calendarSingleData.productId), 1),
            _cache[3] || (_cache[3] = createBaseVNode("br", null, null, -1)),
            createTextVNode(" productTitle: " + toDisplayString(unref(appStore).calendarSingleData.productTitle), 1),
            _cache[4] || (_cache[4] = createBaseVNode("br", null, null, -1)),
            createTextVNode(" productImage: " + toDisplayString(unref(appStore).calendarSingleData.productImage ? "Yes" : "No"), 1),
            _cache[5] || (_cache[5] = createBaseVNode("br", null, null, -1)),
            createTextVNode(" isCalendarSingle: " + toDisplayString(unref(appStore).isCalendarSingle), 1),
            _cache[6] || (_cache[6] = createBaseVNode("br", null, null, -1)),
            createTextVNode(" applicationType: " + toDisplayString(unref(appStore).applicationType), 1)
          ])) : createCommentVNode("", true),
          createBaseVNode("div", { class: "min-order-qty-text" }, " Minimum order for calendar bundles is " + toDisplayString(minBundleQty) + " unit(s) "),
          createBaseVNode("div", _hoisted_3$i, [
            unref(appStore).calendarSingleData.productId ? (openBlock(), createBlock(CalendarQuantityInput, {
              key: 0,
              "product-id": unref(appStore).calendarSingleData.productId,
              modelValue: quantity.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => quantity.value = $event),
              "onUpdate:quantity": handleQuantityUpdate
            }, null, 8, ["product-id", "modelValue"])) : createCommentVNode("", true),
            unref(appStore).calendarSingleData.productId ? (openBlock(), createElementBlock("a", {
              key: 1,
              class: normalizeClass(["bundle-butons__item bundle-butons__item--add-to-bundle arrow-right add_to_cart_type_class--bundle", { "is-disabled": unref(appStore).isOutOfStock }]),
              "aria-disabled": unref(appStore).isOutOfStock,
              "data-product_id": unref(appStore).calendarSingleData.productId,
              "data-product_title": unref(appStore).calendarSingleData.productTitle,
              "data-product_image": unref(appStore).calendarSingleData.productImage,
              "data-product_qty": quantity.value,
              onClick: handleAddToBundleClick
            }, " Add to Bundle ", 10, _hoisted_4$h)) : createCommentVNode("", true),
            createBaseVNode("button", {
              class: "bundle-butons__item bundle-butons__item--back-to-themes arrow-left",
              onClick: navigateToCalendars
            }, " Back to themes ")
          ])
        ]);
      };
    }
  };
  const CalendarSinglePage = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["__scopeId", "data-v-7db62287"]]);
  function validateQuantityIncrement(quantity, increment, maxQty = 1e4) {
    if (quantity < 0) {
      return {
        isValid: false,
        error: "Quantity cannot be negative",
        suggestedQty: 0
      };
    }
    if (quantity > maxQty) {
      return {
        isValid: false,
        error: `Max quantity is ${maxQty}`,
        suggestedQty: maxQty
      };
    }
    if (quantity > 0 && quantity < increment) {
      return {
        isValid: false,
        error: `Minimum quantity is ${increment}`,
        suggestedQty: increment
      };
    }
    if (quantity > 0 && quantity % increment !== 0) {
      const remainder = quantity % increment;
      const suggestedQty = quantity + (increment - remainder);
      return {
        isValid: false,
        error: `Item purchasable in increments of ${increment}`,
        suggestedQty
      };
    }
    return { isValid: true };
  }
  function validateStep1(selectionStore, imprintStore, appStore = null) {
    var _a, _b;
    const errors = [];
    if (appStore && appStore.isCalendarMode) {
      console.log("[Validation] Skipping Step 1 validation (calendar mode)");
      return {
        hasErrors: false,
        errorCount: 0,
        errors: [],
        incrementErrors: []
      };
    }
    const imprintKey = imprintStore.getImprintMethodKey;
    const colorLines = selectionStore.getLinesByImprintKey(imprintKey);
    if (!colorLines || colorLines.length === 0) {
      errors.push(`Please select at least one ${getColorName(true)}`);
    }
    const totalQty = selectionStore.getTotalQtyByImprintKey(imprintKey);
    if (totalQty === 0) {
      errors.push(`Please enter quantities for selected ${getColorName(true)}`);
    }
    const sku = (_a = imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
    let minOrderQty = 0;
    if (sku && ((_b = imprintStore.fullJson) == null ? void 0 : _b.configurable_array)) {
      const methodData = imprintStore.fullJson.configurable_array[sku];
      const parsedQty = parseInt(methodData == null ? void 0 : methodData.min_order_qty, 10);
      minOrderQty = !isNaN(parsedQty) && parsedQty > 0 ? parsedQty : 0;
    }
    if (minOrderQty === 0) {
      minOrderQty = imprintStore.minOrderQty || 0;
    }
    if (minOrderQty > 0 && totalQty < minOrderQty) {
      const remaining = minOrderQty - totalQty;
      errors.push(`${remaining} more items until minimum quantity`);
    }
    const qtyIncrement = imprintStore.currentQtyIncrement || 1;
    const maxQty = 1e4;
    const incrementErrors = [];
    if (colorLines && colorLines.length > 0) {
      colorLines.forEach((line, lineIndex) => {
        if (line.selectedSizes) {
          Object.entries(line.selectedSizes).forEach(([size, qty]) => {
            if (qty > 0) {
              const validation = validateQuantityIncrement(qty, qtyIncrement, maxQty);
              if (!validation.isValid) {
                incrementErrors.push({
                  lineIndex,
                  size,
                  qty,
                  error: validation.error,
                  suggestedQty: validation.suggestedQty
                });
              }
            }
          });
        }
      });
    }
    if (incrementErrors.length > 0) {
      const errorsByType = {};
      incrementErrors.forEach((e) => {
        if (!errorsByType[e.error]) {
          errorsByType[e.error] = [];
        }
        errorsByType[e.error].push(`${e.size}: ${e.qty}`);
      });
      Object.entries(errorsByType).forEach(([errorMsg, sizes]) => {
        errors.push(`${errorMsg} (${sizes.join(", ")})`);
      });
    }
    return {
      hasErrors: errors.length > 0,
      errorCount: errors.length,
      errors,
      incrementErrors
      // Detailed errors for debugging/display
    };
  }
  function validateStep2(imprintStore, newImprintStore, appStore = null) {
    const errors = [];
    if (appStore && appStore.isEnvelopProduct) {
      console.log("[Validation] Skipping Step 2 validation (Envelop product)");
      return {
        hasErrors: false,
        errorCount: 0,
        errors: []
      };
    }
    if (!imprintStore.selectedArtworkMethod) {
      errors.push("Please select an artwork method");
    }
    if (!imprintStore.selectedImprintMethod || !imprintStore.selectedImprintMethod.sku) {
      errors.push("Please select an imprint method");
    }
    const artworkMethod = imprintStore.selectedArtworkMethod;
    if (artworkMethod === "new") {
      newImprintStore.imprints.forEach((imprint, index) => {
        var _a, _b, _c;
        if (!imprint.selectedLocation || !imprint.selectedLocation.sku) {
          errors.push(`Imprint ${index + 1}: Please select a location`);
        }
        if (imprint.messageType === "text" || imprint.messageType === "text_image") {
          const messageLines = imprint.textLines.filter((line) => line.type === "message");
          messageLines.forEach((line, lineIndex) => {
            const hasText = line.message && line.message.trim().length > 0;
            const hasColor = !!line.selectedColor;
            if (lineIndex === 0) {
              if (!hasText) {
                errors.push(`Imprint ${index + 1}, Line ${lineIndex + 1}: Please enter text`);
              }
              if (!hasColor) {
                errors.push(`Imprint ${index + 1}, Line ${lineIndex + 1}: Please select a ${getColorName(true)}`);
              }
            } else {
              if (hasText && !hasColor) {
                errors.push(`Imprint ${index + 1}, Line ${lineIndex + 1}: Please select a ${getColorName(true)}`);
              }
            }
          });
        }
        console.log(`%c[VALIDATE-IMAGE] Imprint ${index + 1}`, "color: purple; font-weight: bold", {
          messageType: imprint.messageType,
          hasImageData: !!imprint.imageData,
          imageData: imprint.imageData,
          activeMethodSku: imprint.activeMethodSku,
          textLines: (_a = imprint.textLines) == null ? void 0 : _a.map((l) => ({ id: l.id, type: l.type, hasColor: !!l.selectedColor })),
          methodsDataKeys: Object.keys(imprint.methodsData || {}),
          "methodsData[active].messageType": imprint.activeMethodSku ? (_b = imprint.methodsData[imprint.activeMethodSku]) == null ? void 0 : _b.messageType : "N/A",
          "methodsData[active].imageData": imprint.activeMethodSku ? ((_c = imprint.methodsData[imprint.activeMethodSku]) == null ? void 0 : _c.imageData) ? "✅" : "❌ NULL" : "N/A"
        });
        if (imprint.messageType === "image" || imprint.messageType === "text_image") {
          if (!imprint.imageData) {
            console.error(`%c[VALIDATE-IMAGE] ❌ ERROR: messageType='${imprint.messageType}' but imageData=null!`, "color: red; font-weight: bold");
            errors.push(`Imprint ${index + 1}: Please upload an image`);
          }
          if (imprint.messageType === "text_image" || imprint.messageType === "image") {
            const imageLine = imprint.textLines.find((line) => line.type === "image");
            if (imageLine && !imageLine.selectedColor) {
              errors.push(`Imprint ${index + 1}: Please select image ${getColorName(true)}`);
            }
          }
        }
      });
    } else if (artworkMethod === "send") ;
    else if (artworkMethod === "previous") ;
    else if (artworkMethod === "design") {
      const designOnlineStore = useDesignOnlineStore();
      if (!designOnlineStore.hasDesign) {
        errors.push("Please create or upload a design using Design Online");
      }
      if (designOnlineStore.hasDesign && !designOnlineStore.isApproved) {
        errors.push("Please approve your design by checking the confirmation box");
      }
    }
    return {
      hasErrors: errors.length > 0,
      errorCount: errors.length,
      errors
    };
  }
  function validateStep3() {
    const errors = [];
    return {
      hasErrors: errors.length > 0,
      errorCount: errors.length,
      errors
    };
  }
  function validateStep4(selectionStore, imprintStore, newImprintStore, appStore = null) {
    const step1 = validateStep1(selectionStore, imprintStore, appStore);
    const step2 = validateStep2(imprintStore, newImprintStore, appStore);
    const step3 = validateStep3();
    const allErrors = [
      ...step1.errors,
      ...step2.errors,
      ...step3.errors
    ];
    return {
      hasErrors: allErrors.length > 0,
      errorCount: allErrors.length,
      errors: allErrors
    };
  }
  function useSectionValidation() {
    const imprintStore = useImprintStore();
    const selectionStore = useSelectionStore();
    const newImprintStore = useNewImprintStore();
    const appStore = useAppStore();
    const step1Validation = computed(() => {
      return validateStep1(selectionStore, imprintStore, appStore);
    });
    const step2Validation = computed(() => {
      return validateStep2(imprintStore, newImprintStore, appStore);
    });
    const step3Validation = computed(() => {
      return validateStep3();
    });
    const step4Validation = computed(() => {
      return validateStep4(selectionStore, imprintStore, newImprintStore, appStore);
    });
    const getSectionValidation = (sectionId) => {
      switch (sectionId) {
        case "colourQuantity":
          return step1Validation.value;
        case "imprintSelection":
          return step2Validation.value;
        case "addons":
          return step3Validation.value;
        case "review":
          return step4Validation.value;
        default:
          return { hasErrors: false, errorCount: 0, errors: [] };
      }
    };
    const sectionHasErrors = (sectionId) => {
      const validation = getSectionValidation(sectionId);
      return validation.hasErrors;
    };
    const getSectionErrorCount = (sectionId) => {
      const validation = getSectionValidation(sectionId);
      return validation.errorCount;
    };
    const getSectionErrors = (sectionId) => {
      const validation = getSectionValidation(sectionId);
      return validation.errors;
    };
    return {
      step1Validation,
      step2Validation,
      step3Validation,
      step4Validation,
      getSectionValidation,
      sectionHasErrors,
      getSectionErrorCount,
      getSectionErrors
    };
  }
  const _sfc_main$q = {
    name: "ColorCard",
    props: {
      color: {
        type: Object,
        required: true
      },
      quantity: {
        type: Number,
        default: 0
      },
      isSelected: {
        type: Boolean,
        default: false
      },
      isExpanded: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleClick() {
        this.$emit("select", this.color);
        this.syncGalleryThumbnail();
      },
      /**
       * Finds the MLP theme gallery thumbnail whose data-title (or img alt)
       * matches the clicked color image alt text, then clicks it to sync the slider.
       *
       * Uses bubbles:false to prevent the programmatic click from reaching
       * document's handleClickOutside listener in ColorSizeSection, which would
       * otherwise collapse the qty selector immediately after it opens.
       */
      syncGalleryThumbnail() {
        var _a, _b, _c;
        if (window.innerWidth <= 1401) return;
        const altText = (_b = (_a = this.color) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.alt;
        if (!altText) return;
        const normalized = altText.trim().toLowerCase();
        const thumbnails = document.querySelectorAll(
          ".product_gallery_nav .gallery-cell.product-gallery__thumbnail"
        );
        for (const thumb of thumbnails) {
          const thumbTitle = (thumb.getAttribute("data-title") || ((_c = thumb.querySelector("img")) == null ? void 0 : _c.getAttribute("alt")) || "").trim().toLowerCase();
          if (thumbTitle === normalized) {
            thumb.dispatchEvent(new MouseEvent("click", { bubbles: false, cancelable: true }));
            break;
          }
        }
      }
    },
    computed: {
      formattedColor() {
        return this.color.title.replace(/-/g, " ");
      }
    }
  };
  const _hoisted_1$q = { class: "color-image-wrapper" };
  const _hoisted_2$j = ["src", "alt"];
  const _hoisted_3$h = {
    key: 1,
    class: "no-image-placeholder"
  };
  const _hoisted_4$g = {
    key: 2,
    class: "quantity-badge"
  };
  const _hoisted_5$f = { class: "color-name-frame" };
  const _hoisted_6$f = { class: "color-name" };
  function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: normalizeClass(["color-card", {
        "is-selected": $props.isSelected && !$props.isExpanded,
        "is-expanded": $props.isExpanded
      }]),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
    }, [
      createBaseVNode("div", _hoisted_1$q, [
        $props.color.featured_image ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: $props.color.featured_image.src,
          alt: $props.color.featured_image.alt,
          class: "color-image"
        }, null, 8, _hoisted_2$j)) : (openBlock(), createElementBlock("div", _hoisted_3$h, " Image not loaded ")),
        $props.quantity > 0 ? (openBlock(), createElementBlock("div", _hoisted_4$g, toDisplayString($props.quantity), 1)) : createCommentVNode("", true)
      ]),
      createBaseVNode("div", _hoisted_5$f, [
        createBaseVNode("div", _hoisted_6$f, toDisplayString($options.formattedColor), 1)
      ])
    ], 2);
  }
  const ColorCard = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$p], ["__scopeId", "data-v-8ded500f"]]);
  let _qtyIdCounter = 0;
  const _sfc_main$p = {
    props: {
      // New props for new architecture
      line: {
        type: Object,
        required: false
      },
      imprintKey: {
        type: String,
        default: "default-imprint"
      },
      // Old props for compatibility
      sizeTitle: String,
      modelValue: {
        type: [String, Number],
        required: false,
        default: 0
      },
      lineId: Number,
      cssClasses: {
        type: String,
        required: false
      },
      displayTitle: {
        type: Boolean,
        required: false
      },
      prId: {
        type: String,
        required: false,
        // Fallback: use module-level counter to guarantee uniqueness
        // (Date.now() is NOT safe — multiple instances created in same ms get same value)
        default: () => `qty-${++_qtyIdCounter}`
      },
      minOrderQty: {
        type: Number,
        default: 0
      },
      qtyIncrement: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        selectionStore: useSelectionStore(),
        imprintStore: useImprintStore(),
        qtyVal: 0,
        qtyError: null,
        maxQty: 1e4,
        minQty: 0,
        isInitialized: false
        // Track if component has been initialized
      };
    },
    computed: {
      // Check if this is a qty-only product (no sizes)
      isQtyOnly() {
        return this.sizeTitle === "qty";
      },
      // Get qty_increment from fullJson (works for ALL products, not just qty-only)
      effectiveQtyIncrement() {
        var _a, _b, _c, _d, _e, _f;
        const currentSku = (_b = (_a = this.imprintStore) == null ? void 0 : _a.selectedImprintMethod) == null ? void 0 : _b.sku;
        const qtyIncrementFromJson = (_f = (_e = (_d = (_c = this.imprintStore) == null ? void 0 : _c.fullJson) == null ? void 0 : _d.configurable_array) == null ? void 0 : _e[currentSku]) == null ? void 0 : _f.qty_increment;
        if (qtyIncrementFromJson) {
          const value = Number(qtyIncrementFromJson);
          console.log("[CustomQty] effectiveQtyIncrement from fullJson:", value, "sku:", currentSku);
          return value;
        }
        if (this.qtyIncrement && this.qtyIncrement !== 1) {
          console.log("[CustomQty] effectiveQtyIncrement from prop:", this.qtyIncrement);
          return Number(this.qtyIncrement);
        }
        console.log("[CustomQty] effectiveQtyIncrement using default: 1");
        return 1;
      },
      // Get min_order_qty from fullJson for qty-only products  
      effectiveMinOrderQty() {
        var _a, _b, _c, _d, _e, _f;
        if (this.isQtyOnly) {
          const currentSku = (_b = (_a = this.imprintStore) == null ? void 0 : _a.selectedImprintMethod) == null ? void 0 : _b.sku;
          const minOrderQtyFromJson = (_f = (_e = (_d = (_c = this.imprintStore) == null ? void 0 : _c.fullJson) == null ? void 0 : _d.configurable_array) == null ? void 0 : _e[currentSku]) == null ? void 0 : _f.min_order_qty;
          if (minOrderQtyFromJson) {
            console.log("[CustomQty] Using min_order_qty from fullJson:", minOrderQtyFromJson);
            return Number(minOrderQtyFromJson);
          }
        }
        return Number(this.minOrderQty) || 0;
      },
      // Get product type
      productType() {
        var _a, _b;
        return ((_b = (_a = this.imprintStore) == null ? void 0 : _a.fullJson) == null ? void 0 : _b.product_type) || "grouped_plain";
      },
      applicationType() {
        var _a, _b;
        return ((_b = (_a = this.imprintStore) == null ? void 0 : _a.fullJson) == null ? void 0 : _b.application_type) || "grouped_plain";
      },
      // Get surcharge data
      getSurcharge() {
        var _a, _b;
        const sizeUpcharge = ((_b = (_a = this.imprintStore) == null ? void 0 : _a.fullJson) == null ? void 0 : _b.size_upcharge) || {};
        if (sizeUpcharge[this.sizeTitle]) {
          console.log("surcharge");
          console.log(`${sizeUpcharge[this.sizeTitle].toFixed(2)}`);
          console.log(sizeUpcharge[this.sizeTitle].toFixed(2));
          return "+".sizeUpcharge[this.sizeTitle].toFixed(2);
        }
        return "";
      },
      // Computed value getter/setter
      value: {
        get() {
          var _a;
          if (this.line && this.line.selectedSizes) {
            const currentValue = this.line.selectedSizes[this.sizeTitle];
            if (currentValue !== void 0 && currentValue !== 0) {
              return currentValue < 0 ? 0 : currentValue;
            }
            return this.minQty;
          }
          const lines = this.selectionStore.getLinesByImprintKey(this.imprintKey);
          if (lines && lines[this.lineId]) {
            const currentValue = (_a = lines[this.lineId].selectedSizes) == null ? void 0 : _a[this.sizeTitle];
            if (currentValue !== void 0 && currentValue !== null) {
              return currentValue < 0 ? 0 : currentValue;
            }
            return this.minQty;
          }
          return this.minQty;
        },
        set(newValue) {
          const value = newValue < 0 ? 0 : newValue;
          this.isInitialized = true;
          if (this.line) {
            this.selectionStore.updateLineSizeQty(
              this.imprintKey,
              this.line.id,
              this.sizeTitle,
              value
            );
          }
        }
      }
    },
    methods: {
      isTitleDisplay() {
        if (this.displayTitle === true) {
          return true;
        }
        if (this.productType === "grouped_apparel" && this.applicationType === "default") {
          return true;
        }
        if (this.productType === "grouped_plain") {
          return false;
        }
        return false;
      },
      setDefaultQtyForLine() {
        return false;
      },
      increment() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let newValue = Number(this.value);
        const increment = this.effectiveQtyIncrement;
        console.log("[CustomQty] increment() called:", {
          currentValue: newValue,
          effectiveQtyIncrement: increment,
          qtyIncrementProp: this.qtyIncrement,
          isQtyOnly: this.isQtyOnly,
          currentSku: (_b = (_a = this.imprintStore) == null ? void 0 : _a.selectedImprintMethod) == null ? void 0 : _b.sku,
          qtyIncrementFromJson: (_h = (_g = (_d = (_c = this.imprintStore) == null ? void 0 : _c.fullJson) == null ? void 0 : _d.configurable_array) == null ? void 0 : _g[(_f = (_e = this.imprintStore) == null ? void 0 : _e.selectedImprintMethod) == null ? void 0 : _f.sku]) == null ? void 0 : _h.qty_increment
        });
        if (newValue < this.maxQty) {
          if (this.qtyError) {
            const remainder = newValue % increment;
            newValue = newValue + increment - remainder;
            this.qtyError = null;
          } else {
            newValue = newValue + increment;
          }
        } else {
          newValue = Number(this.maxQty);
        }
        this.value = newValue;
        this.emitChange(newValue);
      },
      decriment() {
        if (this.minQty < 0) {
          this.minQty = 0;
        }
        let newValue = Number(this.value);
        const increment = this.effectiveQtyIncrement;
        if (this.qtyError) {
          const remainder = newValue % increment;
          newValue = newValue - remainder;
          this.qtyError = null;
        } else {
          newValue = newValue - increment;
        }
        if (newValue < 0) {
          newValue = 0;
        }
        this.value = newValue;
        this.emitChange(newValue);
      },
      onChange(inputValue, refValue = null) {
        if (this.minQty < 0) {
          this.minQty = 0;
        }
        let value = Number(inputValue);
        const increment = this.effectiveQtyIncrement;
        if (value < 0) {
          value = 0;
        }
        if (value > this.maxQty) {
          value = Number(this.maxQty);
        }
        if (this.applicationType === "calendar" || this.applicationType === "calendar_single") {
          let currValue = 25;
          if (value < 25) {
            currValue = 25;
          } else if (value % increment) {
            currValue = this.roundValueBy(value, increment);
          }
          if (value > 25 && !(value % increment)) {
            currValue = value;
          }
          this.value = currValue;
          if (this.$refs[refValue]) {
            this.$refs[refValue].value = currValue;
          }
          this.emitChange(currValue);
        } else {
          if (value === 0) {
            this.value = 0;
            this.emitChange(0);
            this.qtyError = null;
            this.emitError(null);
          } else if (value < increment) {
            value = increment;
            this.value = value;
            if (this.$refs[refValue]) {
              this.$refs[refValue].value = value;
            }
            this.emitChange(value);
            this.qtyError = null;
            this.emitError(null);
          } else {
            const remainder = value % increment;
            if (remainder !== 0) {
              if (remainder >= increment / 2) {
                value = value + (increment - remainder);
              } else {
                value = value - remainder;
              }
            }
            this.value = value;
            if (this.$refs[refValue]) {
              this.$refs[refValue].value = value;
            }
            this.emitChange(value);
            this.qtyError = null;
            this.emitError(null);
          }
        }
      },
      onEnter(event2) {
        event2.preventDefault();
        const inputValue = event2.target.value;
        let value = Number(inputValue);
        const increment = this.effectiveQtyIncrement;
        if (value < 0) {
          value = 0;
        } else if (value === 0) ;
        else if (value < increment) {
          value = increment;
        } else if (value > this.maxQty) {
          value = this.maxQty;
        } else {
          const remainder = value % increment;
          if (remainder !== 0) {
            if (remainder >= increment / 2) {
              value = value + (increment - remainder);
            } else {
              value = value - remainder;
            }
          }
        }
        this.value = value;
        event2.target.value = value;
        this.qtyError = null;
        this.emitChange(value);
        this.emitError(null);
        event2.target.blur();
      },
      onArrowUp(event2) {
        event2.preventDefault();
        this.increment();
      },
      onArrowDown(event2) {
        event2.preventDefault();
        this.decriment();
      },
      roundValueBy(value, by) {
        return Math.round(parseInt(value) / parseInt(by)) * parseInt(by);
      },
      validateInputQty(value) {
        const increment = this.effectiveQtyIncrement;
        if (value === 0) {
          this.qtyError = null;
          this.emitError(null);
          return true;
        }
        const failCondition = value < increment || value % increment !== 0 || !Number.isInteger(value);
        if (failCondition) {
          this.qtyError = `Item purchasable in increments of ${increment}`;
          this.emitError(this.qtyError);
          return false;
        } else {
          this.qtyError = null;
          this.emitError(null);
          return true;
        }
      },
      emitChange(value) {
        var _a;
        this.$emit("update-quantity", {
          lineId: ((_a = this.line) == null ? void 0 : _a.id) || this.lineId,
          size: this.sizeTitle,
          quantity: value
        });
        this.$emit("customQtyChange", {
          value,
          lineIndex: this.lineId,
          title: this.sizeTitle
        });
      },
      emitError(error) {
        this.$emit("showQtyError", { qtyError: error });
      }
    },
    created() {
      if (this.applicationType === "calendar_single" || this.applicationType === "calendar") {
        this.minQty = 25;
        if (window.jQuery && window.jQuery("#calendar-qty-changed")) {
          window.jQuery("body").on("click", "#calendar-qty-changed", (event2) => {
            if (window.jQuery("#calendar-imprint-common-qty")) {
              const qtyValue = window.jQuery("#calendar-imprint-common-qty").val();
              this.value = qtyValue;
              this.emitChange(qtyValue);
            }
          });
        }
      }
    },
    mounted() {
      if (this.line && this.line.selectedSizes) {
        const currentValue = this.line.selectedSizes[this.sizeTitle];
        if (currentValue !== void 0 && currentValue !== null) {
          this.isInitialized = true;
        }
      }
    }
  };
  const _hoisted_1$p = ["id"];
  const _hoisted_2$i = ["id", "name", "value"];
  const _hoisted_3$g = ["for"];
  const _hoisted_4$f = { class: "sub_upcharge" };
  function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", {
      class: normalizeClass(["qty-wrap", $props.cssClasses]),
      id: "qty-wrap" + $props.sizeTitle
    }, [
      createBaseVNode("div", {
        class: "controls-container controls-container--decriment",
        onClick: _cache[0] || (_cache[0] = ($event) => $options.decriment())
      }, [..._cache[7] || (_cache[7] = [
        createBaseVNode("span", { class: "minus-qty" }, " - ", -1)
      ])]),
      createBaseVNode("input", {
        class: "size-row__input",
        ref: "bundle-single-product-" + $props.prId,
        id: $props.prId,
        name: "size-qty-" + $props.sizeTitle,
        maxlength: "12",
        value: $options.value,
        onChange: _cache[1] || (_cache[1] = ($event) => $options.onChange($event.target.value, "bundle-single-product-" + $props.prId)),
        onKeydown: [
          _cache[2] || (_cache[2] = withKeys(($event) => $options.onEnter($event), ["enter"])),
          _cache[3] || (_cache[3] = withKeys(($event) => $options.onArrowUp($event), ["up"])),
          _cache[4] || (_cache[4] = withKeys(($event) => $options.onArrowDown($event), ["down"]))
        ],
        onClick: _cache[5] || (_cache[5] = ($event) => $event.target.select()),
        type: "number"
      }, null, 40, _hoisted_2$i),
      createBaseVNode("div", {
        class: "controls-container controls-container--incriment",
        onClick: _cache[6] || (_cache[6] = ($event) => $options.increment())
      }, [..._cache[8] || (_cache[8] = [
        createBaseVNode("span", { class: "plus-qty" }, " + ", -1)
      ])]),
      $options.isTitleDisplay() ? (openBlock(), createElementBlock("label", {
        key: 0,
        class: "custom-qty-label",
        for: "qty-wrap" + $props.sizeTitle
      }, [
        createBaseVNode("span", _hoisted_4$f, toDisplayString($options.getSurcharge), 1)
      ], 8, _hoisted_3$g)) : createCommentVNode("", true)
    ], 10, _hoisted_1$p);
  }
  const CustomQty = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$o], ["__scopeId", "data-v-9393a0d0"]]);
  const _sfc_main$o = {
    name: "ColorSizeLine",
    components: {
      CustomQty
    },
    props: {
      line: {
        type: Object,
        required: true
      },
      availableSizes: {
        type: Array,
        required: true
      },
      imprintKey: {
        type: String,
        default: "default-imprint"
      },
      qtyIncrement: {
        type: Number,
        default: 1
      },
      minOrderQty: {
        type: Number,
        default: 0
      },
      isQtyOnly: {
        type: Boolean,
        default: false
      },
      showArrow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        imprintStore: useImprintStore()
      };
    },
    computed: {
      colorName() {
        var _a;
        return ((_a = this.line.slectedColor) == null ? void 0 : _a.title) || "Color";
      },
      // Filter available sizes based on color's attributes_relation_array
      filteredSizes() {
        var _a, _b, _c, _d;
        const colorTitle = (_a = this.line.slectedColor) == null ? void 0 : _a.title;
        if (!colorTitle) {
          console.warn("[ColorSizeLine] No color selected, showing all sizes");
          return this.availableSizes;
        }
        if (this.availableSizes.length === 1 && this.availableSizes[0] === "qty") {
          return this.availableSizes;
        }
        const fullJson = this.imprintStore.fullJson;
        const currentSku = (_b = this.imprintStore.selectedImprintMethod) == null ? void 0 : _b.sku;
        if (!fullJson || !currentSku) {
          console.warn("[ColorSizeLine] No fullJson or SKU, showing all sizes");
          return this.availableSizes;
        }
        const attributesRelation = (_d = (_c = fullJson.configurable_array) == null ? void 0 : _c[currentSku]) == null ? void 0 : _d.attributes_relation_array;
        if (!attributesRelation) {
          console.warn("[ColorSizeLine] No attributes_relation_array, showing all sizes");
          return this.availableSizes;
        }
        const colorRelation = attributesRelation[colorTitle];
        if (!colorRelation) {
          console.warn("[ColorSizeLine] No relation for color:", colorTitle, "showing all sizes");
          return this.availableSizes;
        }
        if (!Array.isArray(colorRelation)) {
          console.warn("[ColorSizeLine] colorRelation is not array for:", colorTitle, "showing all sizes");
          return this.availableSizes;
        }
        const availableSizesForColor = colorRelation.filter((item) => item.status !== "Disabled").map((item) => item.size);
        const filtered = this.availableSizes.filter((size) => availableSizesForColor.includes(size));
        const hiddenSizes = this.availableSizes.filter((size) => !availableSizesForColor.includes(size));
        if (hiddenSizes.length) {
          console.log(
            `[VariantFilter] 🚫 Hidden sizes for "${colorTitle}" (${hiddenSizes.length}):`,
            colorRelation.filter((i) => !availableSizesForColor.includes(i.size)).map((i) => ({ size: i.size, status: i.status }))
          );
        }
        console.log(`[VariantFilter] ✅ Visible sizes for "${colorTitle}": [${filtered.join(", ")}]`);
        return filtered;
      }
    },
    methods: {
      getSizeLabel(size) {
        return size === "qty" ? "Quantity" : size;
      },
      getLineIndex() {
        const selectionStore = useSelectionStore();
        const lines = selectionStore.getLinesByImprintKey(this.imprintKey);
        return lines.findIndex((l) => l.id === this.line.id);
      },
      hasSurcharge(size) {
        var _a;
        if (size === "qty") return false;
        const surcharges = ((_a = this.imprintStore) == null ? void 0 : _a.sizeUpcharge) || {};
        const sizes = Object.keys(surcharges);
        return sizes.includes(size);
      },
      getSurcharge(size) {
        var _a;
        const surcharges = ((_a = this.imprintStore) == null ? void 0 : _a.sizeUpcharge) || {};
        const value = surcharges[size];
        if (value === void 0 || value === null) {
          return "";
        }
        const formatted = Math.abs(value).toFixed(2);
        return value >= 0 ? `+$${formatted}` : `-$${formatted}`;
      },
      handleUpdateQuantity(event2) {
        this.$emit("update-quantity", event2);
      },
      handleClear() {
        this.$emit("remove", this.line.id);
      }
    }
  };
  const _hoisted_1$o = {
    key: 0,
    class: "qty-arrow-indicator"
  };
  const _hoisted_2$h = {
    key: 1,
    class: "line-header"
  };
  const _hoisted_3$f = { class: "color-info" };
  const _hoisted_4$e = { class: "color-name-label" };
  const _hoisted_5$e = { class: "sizes-container" };
  const _hoisted_6$e = { class: "size-label" };
  const _hoisted_7$e = {
    key: 0,
    class: "surcharge"
  };
  const _hoisted_8$c = { class: "btn-clear-wrap" };
  function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomQty = resolveComponent("CustomQty");
    return openBlock(), createElementBlock("div", {
      class: normalizeClass(["color-size-line", { "is-qty-only": $props.isQtyOnly }])
    }, [
      $props.isQtyOnly && $props.showArrow ? (openBlock(), createElementBlock("div", _hoisted_1$o, [..._cache[1] || (_cache[1] = [
        createBaseVNode("div", { class: "arrow-up" }, null, -1)
      ])])) : createCommentVNode("", true),
      !$props.isQtyOnly ? (openBlock(), createElementBlock("div", _hoisted_2$h, [
        createBaseVNode("div", _hoisted_3$f, [
          createBaseVNode("span", _hoisted_4$e, toDisplayString($options.colorName.replace(/-/g, " ")) + " Quantity", 1)
        ])
      ])) : createCommentVNode("", true),
      createBaseVNode("div", _hoisted_5$e, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.filteredSizes, (size) => {
          return openBlock(), createElementBlock("div", {
            key: size,
            class: "size-column"
          }, [
            createBaseVNode("div", _hoisted_6$e, toDisplayString($options.getSizeLabel(size)), 1),
            createVNode(_component_CustomQty, {
              line: $props.line,
              imprintKey: $props.imprintKey,
              sizeTitle: size,
              lineId: $options.getLineIndex(),
              qtyIncrement: $props.qtyIncrement,
              minOrderQty: $props.minOrderQty,
              prId: `qty-${$props.line.id}-${size}`,
              onUpdateQuantity: $options.handleUpdateQuantity
            }, null, 8, ["line", "imprintKey", "sizeTitle", "lineId", "qtyIncrement", "minOrderQty", "prId", "onUpdateQuantity"]),
            $options.hasSurcharge(size) ? (openBlock(), createElementBlock("div", _hoisted_7$e, toDisplayString($options.getSurcharge(size)), 1)) : createCommentVNode("", true)
          ]);
        }), 128))
      ]),
      createBaseVNode("div", _hoisted_8$c, [
        createBaseVNode("button", {
          class: "btn-clear",
          onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClear && $options.handleClear(...args)),
          title: "Clear this color"
        }, " Clear ")
      ])
    ], 2);
  }
  const ColorSizeLine = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$n], ["__scopeId", "data-v-94dbf404"]]);
  function useMockData() {
    const urlParams = new URLSearchParams(window.location.search);
    const forceMock = urlParams.get("mock") === "true";
    return forceMock;
  }
  const _sfc_main$n = {
    name: "ColorSizeSection",
    components: {
      ColorCard,
      ColorSizeLine
    },
    props: {
      imprintKey: {
        type: String,
        default: "default-imprint"
      },
      description: {
        type: String,
        default: ""
      },
      resetTrigger: {
        type: Number,
        default: 0
      }
    },
    setup() {
      const { step1Validation } = useSectionValidation();
      return {
        step1Validation
      };
    },
    data() {
      return {
        selectionStore: useSelectionStore(),
        imprintStore: useImprintStore(),
        appStore: useAppStore(),
        expandedColorId: null,
        // null = falls back to defaultActiveColorId
        userHasClickedColor: false,
        // whether user explicitly clicked a color card
        lastActiveColorId: null,
        // Track last active color even when collapsed
        colorQuantities: {},
        columnsPerRow: 6,
        gridRefs: {},
        colorCardRefs: {},
        lineWrapperRefs: {},
        arrowPosition: "0px",
        tempLineData: {},
        // Track if user modified quantities for colors (for isQtyOnly logic)
        userModifiedColors: /* @__PURE__ */ new Set(),
        // Track colors that were auto-initialized (should not be marked as modified)
        autoInitializedColors: /* @__PURE__ */ new Set(),
        // Initialize API data arrays
        colorVariants: [],
        sizeVariants: [],
        colorHandle: null,
        sizeHandle: null,
        associatedIds: null,
        // Pagination
        COLORS_PER_PAGE: 25,
        currentPage: 1,
        isLoadingMore: false,
        isDataLoaded: false
      };
    },
    computed: {
      minQuantity() {
        var _a, _b;
        const sku = (_a = this.imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!sku || !((_b = this.imprintStore.fullJson) == null ? void 0 : _b.configurable_array)) {
          return 18;
        }
        const methodData = this.imprintStore.fullJson.configurable_array[sku];
        const minQty = methodData == null ? void 0 : methodData.min_order_qty;
        const parsedQty = parseInt(minQty, 10);
        return !isNaN(parsedQty) && parsedQty > 0 ? parsedQty : 18;
      },
      qtyIncrement() {
        var _a, _b;
        const sku = (_a = this.imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!sku || !((_b = this.imprintStore.fullJson) == null ? void 0 : _b.configurable_array)) {
          return 1;
        }
        const methodData = this.imprintStore.fullJson.configurable_array[sku];
        const increment = methodData == null ? void 0 : methodData.qty_increment;
        const parsedIncrement = parseInt(increment, 10);
        return !isNaN(parsedIncrement) && parsedIncrement > 0 ? parsedIncrement : 1;
      },
      /**
       * All color variants with disabled colors filtered out.
       * A color is considered disabled when ALL its sizes in attributes_relation_array
       * have status 'Disabled' for the current imprint method.
       * Falls back to showing all colors when feed data is unavailable.
       */
      enabledColorVariants() {
        var _a, _b, _c;
        if (useMockData()) {
          const response = JSON.parse(mockProduct.colorProduct);
          return response.variants;
        }
        const cached = this.selectionStore.getCachedApiData();
        const allColors = cached.colorVariants || [];
        const fullJson = this.imprintStore.fullJson;
        const currentSku = (_a = this.imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku;
        if (!fullJson || !currentSku) return allColors;
        const attributesRelation = (_c = (_b = fullJson.configurable_array) == null ? void 0 : _b[currentSku]) == null ? void 0 : _c.attributes_relation_array;
        if (!attributesRelation) return allColors;
        const result = [];
        const hidden = [];
        allColors.forEach((color) => {
          const colorTitle = color.title;
          if (!colorTitle) {
            result.push(color);
            return;
          }
          const colorRelation = attributesRelation[colorTitle];
          if (!colorRelation || !Array.isArray(colorRelation)) {
            hidden.push({ color: colorTitle, reason: "not in attributes_relation_array" });
            return;
          }
          const hasEnabled = colorRelation.some((item) => item.status !== "Disabled");
          if (hasEnabled) {
            result.push(color);
          } else {
            hidden.push({
              color: colorTitle,
              reason: "all sizes Disabled",
              sizes: colorRelation.map((i) => i.size)
            });
          }
        });
        if (hidden.length) {
          console.log(`[VariantFilter] 🚫 Hidden colors (${hidden.length}):`, hidden);
        }
        console.log(`[VariantFilter] ✅ Visible colors: ${result.length} / ${allColors.length}`);
        return result;
      },
      availableColors() {
        const endIndex = this.currentPage * this.COLORS_PER_PAGE;
        return this.enabledColorVariants.slice(0, endIndex);
      },
      totalAvailableColors() {
        return this.enabledColorVariants.length;
      },
      hasMoreColors() {
        return this.availableColors.length < this.totalAvailableColors;
      },
      remainingColorsCount() {
        return this.totalAvailableColors - this.availableColors.length;
      },
      // Returns the color id that should have the quantity selector visible per client requirements:
      // Rule 1: if any qty > 0 exists — show the first color with qty > 0
      // Rule 2: otherwise — show the first available color
      defaultActiveColorId() {
        if (!this.isDataLoaded || this.availableColors.length === 0) return null;
        const firstWithQty = this.availableColors.find(
          (color) => this.selectedLines.some((line) => {
            var _a;
            return line && ((_a = line.slectedColor) == null ? void 0 : _a.id) === color.id && line.totalQty > 0;
          })
        );
        if (firstWithQty) return firstWithQty.id;
        return this.availableColors[0].id;
      },
      // Active color = explicit user selection OR default
      activeColorId() {
        return this.expandedColorId || this.defaultActiveColorId;
      },
      isQtyOnlyProduct() {
        return this.availableSizes.length === 1 && this.availableSizes[0] === "qty";
      },
      isDefaultQtyToSecondColumnEnabled() {
        var _a, _b;
        return ((_b = (_a = window == null ? void 0 : window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.qty_default_second_column_enabled) === true;
      },
      secondColumnQty() {
        const breaks = this.imprintStore.currentMethodQuantityBreaks || [];
        if (breaks.length > 1) return breaks[1];
        if (breaks.length === 1) return breaks[0];
        return this.minQuantity;
      },
      colorRows() {
        const rows = [];
        for (let i = 0; i < this.availableColors.length; i += this.columnsPerRow) {
          rows.push(this.availableColors.slice(i, i + this.columnsPerRow));
        }
        return rows;
      },
      availableSizes() {
        if (useMockData()) {
          const codes = this.imprintStore.productData.fullJson.varies_by.map((v) => v.CODE);
          return codes.includes("COLOR") && codes.includes("SIZE") ? ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL"] : ["qty"];
        }
        const cached = this.selectionStore.getCachedApiData();
        const sizeVariants = cached.sizeVariants || [];
        const sizes = [];
        sizeVariants.forEach((variant) => {
          if (variant.title && !sizes.includes(variant.title)) {
            sizes.push(variant.title);
          }
        });
        if (sizes.length === 0) {
          return ["qty"];
        }
        return sizes;
      },
      selectedLines() {
        return this.selectionStore.getLinesByImprintKey(this.imprintKey);
      },
      totalQuantity() {
        return this.selectionStore.getTotalQtyByImprintKey(this.imprintKey);
      },
      remainingQuantity() {
        return this.minQuantity - this.totalQuantity;
      },
      canProceed() {
        return this.totalQuantity >= this.minQuantity;
      },
      showValidation() {
        return this.totalQuantity < this.minQuantity;
      },
      validationClass() {
        return this.canProceed ? "success" : "warning";
      },
      validationMessage() {
        return `${this.remainingQuantity} more items until minimum quantity`;
      }
    },
    watch: {
      imprintKey: {
        handler(newKey, oldKey) {
          console.log("[ColorSizeSection] imprintKey changed:", oldKey, "->", newKey);
          if (newKey && newKey !== "default-imprint") {
            this.selectionStore.initImprintKey(newKey);
          }
        },
        immediate: true
      },
      selectedLines: {
        handler(lines) {
          this.updateColorQuantities();
        },
        deep: true,
        immediate: true
      },
      activeColorId() {
        this.$nextTick(() => {
          this.updateArrowPosition();
        });
      },
      resetTrigger() {
        this.expandedColorId = null;
        setTimeout(() => {
          this.updateArrowPosition();
        }, 350);
      },
      expandedColorId() {
      },
      // Reset expandedColorId when section state changes
      // so activeColorId falls back to defaultActiveColorId (client requirements)
      "imprintStore.sections": {
        handler(sections) {
          const colourSection = sections == null ? void 0 : sections.find((s) => s.id === "colourQuantity");
          const isOpen = (colourSection == null ? void 0 : colourSection.isOpen) ?? true;
          if (!isOpen) {
            this.expandedColorId = null;
          } else {
            setTimeout(() => {
              this.updateArrowPosition();
            }, 350);
          }
        },
        deep: true
      }
    },
    async mounted() {
      console.log("[ColorSizeSection] Component mounted");
      const restored = this.selectionStore.restoreFromSessionStorage();
      if (restored) {
        console.log("[ColorSizeSection] ✅ Restored selection data from sessionStorage");
      }
      this.selectionStore.initImprintKey(this.imprintKey);
      await this.loadData();
      this.isDataLoaded = true;
      this.selectionStore.setAvailableColorsList(this.availableColors);
      this.updateColorQuantities();
      this.calculateColumnsPerRow();
      if (this.isQtyOnlyProduct && this.availableColors.length > 0) {
        this.$nextTick(() => {
          this.initializeFirstColorForQtyOnly();
        });
      }
      window.addEventListener("resize", this.handleResize);
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.handleResize);
      document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
      handleClickOutside(event2) {
      },
      async loadData() {
        if (useMockData()) {
          console.log("[ColorSizeSection] Using mock data");
          return;
        }
        try {
          await this.getAssociatedIds();
          if (this.associatedIds && this.associatedIds.simples && this.associatedIds.simples.id_color) {
            await this.getProductById(this.associatedIds.simples.id_color, "color");
          }
          if (this.associatedIds && this.associatedIds.simples && this.associatedIds.simples.id_size) {
            await this.getProductById(this.associatedIds.simples.id_size, "size");
          }
        } catch (error) {
          console.error("[ColorSizeSection] Error loading data:", error);
        }
      },
      getAssociatedIds() {
        try {
          const element = document.getElementById("associated_id");
          if (element && element.innerHTML) {
            this.associatedIds = JSON.parse(element.innerHTML);
            console.log("[ColorSizeSection] Associated IDs:", this.associatedIds);
            if (Array.isArray(this.associatedIds.simples.id_color)) {
              this.associatedIds.simples.id_color = this.associatedIds.simples.id_color[this.associatedIds.simples.id_color.length - 1];
            }
            this.appStore.setAssociatedIds(this.associatedIds);
          }
        } catch (error) {
          console.error("[ColorSizeSection] Error parsing associated IDs:", error);
        }
      },
      async getProductById(id, type) {
        try {
          if (!id) {
            console.warn(`[ColorSizeSection] No ID provided for type: ${type}`);
            return;
          }
          if (type === "color" && !this.colorHandle) {
            this.colorHandle = await this.resolveProductHandle(id, "color");
            if (!this.colorHandle) return;
          }
          if (type === "size" && !this.sizeHandle) {
            this.sizeHandle = await this.resolveProductHandle(id, "size");
            if (!this.sizeHandle) return;
          }
          if (type === "color" && this.colorHandle) {
            if (!this.colorVariants) this.colorVariants = [];
            if (this.colorVariants.length === 0) {
              await this.getColorVariants(this.colorHandle, id);
            }
          }
          if (type === "size" && this.sizeHandle) {
            if (!this.sizeVariants) this.sizeVariants = [];
            if (this.sizeVariants.length === 0) {
              await this.getSizeVariants(this.sizeHandle, id);
            }
          }
        } catch (error) {
          console.error(`[ColorSizeSection] Error getting product by ID (${type}):`, error);
        }
      },
      /**
       * Resolve a simple product's handle, in priority order:
       *   1) full_product_info.associated_ids.simples.handle_color / handle_size
       *      — no network call, set by integrator after UNLISTED migration.
       *   2) associated_id DOM element simples.handle_color / handle_size
       *      — same data, read directly from DOM (fallback if fullJson not loaded yet).
       *   3) /search/suggest.json — works only for active/listed products.
       *   4) backend endpoint for UNLISTED products without a stored handle.
       */
      async resolveProductHandle(id, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const handleKey = type === "color" ? "handle_color" : "handle_size";
        const fullJson = (_a = this.imprintStore) == null ? void 0 : _a.fullJson;
        const handleFromFullJson = (_c = (_b = fullJson == null ? void 0 : fullJson.associated_ids) == null ? void 0 : _b.simples) == null ? void 0 : _c[handleKey];
        if (handleFromFullJson) {
          console.log(`[ColorSizeSection] resolveProductHandle: from fullJson (${type}):`, handleFromFullJson);
          return handleFromFullJson;
        }
        const handleFromDom = (_e = (_d = this.associatedIds) == null ? void 0 : _d.simples) == null ? void 0 : _e[handleKey];
        if (handleFromDom) {
          console.log(`[ColorSizeSection] resolveProductHandle: from associated_id DOM (${type}):`, handleFromDom);
          return handleFromDom;
        }
        try {
          const response = await axios.get(`/search/suggest.json?q=id:${id}&resources[type]=product&limit=1`);
          const products = (_h = (_g = (_f = response == null ? void 0 : response.data) == null ? void 0 : _f.resources) == null ? void 0 : _g.results) == null ? void 0 : _h.products;
          if (products && products.length > 0) {
            console.log(`[ColorSizeSection] resolveProductHandle: from suggest.json (${type}):`, products[0].handle);
            return products[0].handle;
          }
        } catch (e) {
          console.warn(`[ColorSizeSection] resolveProductHandle: suggest.json failed (${type})`, e);
        }
        const handleFromBackend = await this.resolveFromBackend(id, type);
        if (handleFromBackend) {
          console.log(`[ColorSizeSection] resolveProductHandle: from backend (${type}):`, handleFromBackend);
          return handleFromBackend;
        }
        console.warn(`[ColorSizeSection] resolveProductHandle: no handle found for id=${id} type=${type}`);
        return null;
      },
      /**
       * Backend fallback via imprint-app ProductInfoController (GET /api/product/variants).
       * Called when the stored handle, fullJson, associated_id DOM data, and
       * suggest.json all come up empty (UNLISTED products without a stored handle yet).
       *
       * @param {string|number} id   - Shopify numeric product ID
       * @param {string}        type - 'color' or 'size' (used for logging only)
       * @returns {Promise<string|null>}
       */
      async resolveFromBackend(id, type) {
        var _a, _b;
        try {
          const settings = ((_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) || {};
          const appUrl = settings.api_beckend_url || "";
          const shopDomain = settings.api_shop_domain || "";
          const shopName = shopDomain.replace(".myshopify.com", "");
          if (!appUrl || !shopDomain) {
            console.warn("[ColorSizeSection] resolveFromBackend: missing api_beckend_url or api_shop_domain theme setting");
            return null;
          }
          const base = appUrl.replace(/\/+$/, "");
          const response = await axios.get(`${base}/api/product/variants`, {
            params: {
              product_id: id,
              shop_domain: shopDomain,
              shop: shopName
            }
          });
          return ((_b = response == null ? void 0 : response.data) == null ? void 0 : _b.handle) || null;
        } catch (error) {
          console.warn(`[ColorSizeSection] resolveFromBackend error (${type}):`, error);
          return null;
        }
      },
      async getColorVariants(handle, id) {
        var _a, _b;
        try {
          if (!handle) {
            console.warn("[ColorSizeSection] No handle provided for color variants");
            return;
          }
          let response;
          try {
            response = await axios.get(window.Shopify.routes.root + "products/" + handle + ".js");
          } catch (error) {
            if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 404) {
              const freshHandle = await this.resolveFromBackend(id, "color");
              if (!freshHandle) throw error;
              this.colorHandle = freshHandle;
              response = await axios.get(window.Shopify.routes.root + "products/" + freshHandle + ".js");
            } else {
              throw error;
            }
          }
          if (((_b = response == null ? void 0 : response.data) == null ? void 0 : _b.variants) && Array.isArray(response.data.variants)) {
            this.colorVariants = response.data.variants.filter(
              (item) => item && item.title && !item.title.includes("_temp_")
            );
            console.log("[ColorSizeSection] Total color variants loaded:", this.colorVariants.length);
            this.selectionStore.setCachedApiData({ colorVariants: this.colorVariants });
          } else {
            console.warn("[ColorSizeSection] Invalid response structure for color variants");
            this.colorVariants = [];
          }
        } catch (error) {
          console.error("[ColorSizeSection] Error loading color variants:", error);
          this.colorVariants = [];
        }
      },
      loadMoreColors() {
        if (this.isLoadingMore || !this.hasMoreColors) {
          return;
        }
        this.isLoadingMore = true;
        setTimeout(() => {
          this.currentPage++;
          this.isLoadingMore = false;
          console.log(
            "[ColorSizeSection] Loaded more colors. Current page:",
            this.currentPage,
            "Showing:",
            this.availableColors.length,
            "of",
            this.totalAvailableColors
          );
        }, 300);
      },
      async getSizeVariants(handle, id) {
        var _a, _b;
        try {
          if (!handle) {
            console.warn("[ColorSizeSection] No handle provided for size variants");
            return;
          }
          let response;
          try {
            response = await axios.get(window.Shopify.routes.root + "products/" + handle + ".js");
          } catch (error) {
            if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 404) {
              const freshHandle = await this.resolveFromBackend(id, "size");
              if (!freshHandle) throw error;
              this.sizeHandle = freshHandle;
              response = await axios.get(window.Shopify.routes.root + "products/" + freshHandle + ".js");
            } else {
              throw error;
            }
          }
          if (((_b = response == null ? void 0 : response.data) == null ? void 0 : _b.variants) && Array.isArray(response.data.variants)) {
            this.sizeVariants = response.data.variants;
            console.log("[ColorSizeSection] Size variants loaded:", this.sizeVariants.length);
            this.selectionStore.setCachedApiData({ sizeVariants: this.sizeVariants });
          } else {
            console.warn("[ColorSizeSection] Invalid response structure for size variants");
            this.sizeVariants = [];
          }
        } catch (error) {
          console.error("[ColorSizeSection] Error loading size variants:", error);
          this.sizeVariants = [];
        }
      },
      setGridRef(el, rowIndex) {
        if (el) {
          this.gridRefs[rowIndex] = el;
        }
      },
      setColorCardRef(el, colorId) {
        if (el) {
          this.colorCardRefs[colorId] = el;
        }
      },
      setLineWrapperRef(el, rowIndex) {
        if (el) {
          this.lineWrapperRefs[rowIndex] = el;
        }
      },
      updateArrowPosition() {
        const activeId = this.activeColorId;
        if (!activeId) {
          this.arrowPosition = "0px";
          return;
        }
        const cardEl = this.colorCardRefs[activeId];
        if (!cardEl || !cardEl.$el) {
          return;
        }
        const cardDom = cardEl.$el;
        const gridContainer = cardDom.closest(".colors-grid");
        if (!gridContainer) {
          return;
        }
        const cardRect = cardDom.getBoundingClientRect();
        const gridRect = gridContainer.getBoundingClientRect();
        const relativeLeft = cardRect.left - gridRect.left;
        const cardCenter = relativeLeft + cardRect.width / 2;
        if (!this.isQtyOnlyProduct) {
          this.arrowPosition = `${cardCenter}px`;
        }
        if (this.isQtyOnlyProduct) {
          let rowIndex = -1;
          for (let i = 0; i < this.colorRows.length; i++) {
            const idx = this.colorRows[i].findIndex((c) => c.id === activeId);
            if (idx !== -1) {
              rowIndex = i;
              break;
            }
          }
          if (rowIndex !== -1) {
            const lineWrapper = this.lineWrapperRefs[rowIndex];
            if (lineWrapper) {
              const offsetLeft = cardRect.left - gridRect.left;
              lineWrapper.style.paddingLeft = `${offsetLeft}px`;
            }
          }
        }
      },
      handleResize() {
        this.calculateColumnsPerRow();
        this.$nextTick(() => {
          this.updateArrowPosition();
        });
      },
      getExpandedColorInRow(row) {
        const activeId = this.activeColorId;
        if (!activeId) return null;
        const expandedColor = row.find((color) => color.id === activeId);
        if (!expandedColor) return null;
        if (!this.tempLineData[activeId]) {
          this.ensureTempLineData(expandedColor);
        }
        const lineFromStore = this.selectedLines.find((line) => {
          return line && line.slectedColor && line.slectedColor.id === activeId;
        });
        return lineFromStore || (this.tempLineData[activeId] ? true : null);
      },
      getExpandedLineData(row) {
        const activeId = this.activeColorId;
        if (!activeId) return null;
        const expandedColor = row.find((color) => color.id === activeId);
        if (!expandedColor) return null;
        const lineFromStore = this.selectedLines.find((line) => {
          return line && line.slectedColor && line.slectedColor.id === activeId;
        });
        return lineFromStore || this.tempLineData[activeId] || null;
      },
      calculateColumnsPerRow() {
        var _a;
        const container = (_a = this.$el) == null ? void 0 : _a.querySelector(".colors-grid");
        const width = window.innerWidth;
        if (!container || width <= 460) {
          const width2 = window.innerWidth;
          if (width2 >= 1400) {
            this.columnsPerRow = 6;
          } else if (width2 >= 1200) {
            this.columnsPerRow = 5;
          } else if (width2 >= 992) {
            this.columnsPerRow = 4;
          } else if (width2 >= 460) {
            this.columnsPerRow = 3;
          } else {
            this.columnsPerRow = 2;
          }
          return;
        }
        const containerWidth = container.offsetWidth;
        const gap = 16;
        const minCardWidth = 112;
        const cols = Math.floor((containerWidth + gap) / (minCardWidth + gap));
        this.columnsPerRow = Math.max(1, Math.min(cols, 6));
      },
      updateColorQuantities() {
        const newQuantities = {};
        this.selectedLines.forEach((line) => {
          if (line && line.slectedColor && line.slectedColor.id) {
            newQuantities[line.slectedColor.id] = line.totalQty || 0;
          }
        });
        this.colorQuantities = { ...newQuantities };
      },
      isColorSelected(colorId) {
        return this.selectionStore.hasColorSelected(this.imprintKey, colorId);
      },
      isColorExpanded(colorId) {
        return this.activeColorId === colorId;
      },
      handleColorSelect(color) {
        var _a, _b, _c, _d;
        const isExpanded = this.expandedColorId === color.id;
        const lineInStore = this.selectedLines.find((line) => {
          return line && line.slectedColor && line.slectedColor.id === color.id;
        });
        console.log("[ColorSizeSection] handleColorSelect:", {
          colorId: color.id,
          isExpanded,
          expandedColorId: this.expandedColorId,
          lastActiveColorId: this.lastActiveColorId,
          userModifiedColors: Array.from(this.userModifiedColors),
          autoInitializedColors: Array.from(this.autoInitializedColors)
        });
        if (isExpanded) {
          return;
        } else {
          if (this.isQtyOnlyProduct && this.lastActiveColorId && this.lastActiveColorId !== color.id) {
            const previousLine = this.selectedLines.find((line) => {
              return line && line.slectedColor && line.slectedColor.id === this.lastActiveColorId;
            });
            const isModified = this.userModifiedColors.has(this.lastActiveColorId);
            console.log("[ColorSizeSection] Previous color check:", {
              previousColorId: this.lastActiveColorId,
              previousColorIdType: typeof this.lastActiveColorId,
              isModified,
              userModifiedColors: Array.from(this.userModifiedColors),
              userModifiedColorsTypes: Array.from(this.userModifiedColors).map((id) => typeof id),
              willRemove: previousLine && !isModified
            });
            if (previousLine && !isModified) {
              this.selectionStore.removeColorSizeLine(this.imprintKey, previousLine.id);
              this.autoInitializedColors.delete(this.lastActiveColorId);
              console.log("[ColorSizeSection] Removed previous color (not modified by user):", this.lastActiveColorId);
            }
          }
          if (!lineInStore) {
            const defaultSizes = {};
            this.availableSizes.forEach((size) => {
              defaultSizes[size] = 0;
            });
            this.tempLineData[color.id] = {
              id: `temp-${color.id}`,
              slectedColor: {
                id: color.id,
                title: color.title || color.option1 || "",
                img_src: ((_a = color.featured_image) == null ? void 0 : _a.src) || color.image || "",
                img_id: ((_b = color.featured_image) == null ? void 0 : _b.id) || color.image_id || null,
                img_sku: color.sku || "",
                img_gid: ((_c = color.featured_media) == null ? void 0 : _c.id) || null,
                alt: ((_d = color.featured_image) == null ? void 0 : _d.alt) || color.title || "",
                hex: color.hex || color.color_hex || null
              },
              selectedSizes: defaultSizes,
              // Commented out: Set totalQty to minQuantity for isQtyOnly
              // totalQty: this.isQtyOnlyProduct ? this.minQuantity : 0
              totalQty: 0
            };
          }
          this.expandedColorId = color.id;
          this.lastActiveColorId = color.id;
        }
      },
      handleUpdateQuantity({ lineId, size, quantity }) {
        const isTemp = lineId.toString().startsWith("temp-");
        if (isTemp) {
          const colorId = Number(lineId.toString().replace("temp-", ""));
          const tempLine = this.tempLineData[colorId];
          if (tempLine) {
            tempLine.selectedSizes[size] = quantity;
            tempLine.totalQty = Object.values(tempLine.selectedSizes).reduce((sum, q) => sum + (Number(q) || 0), 0);
            if (tempLine.totalQty > 0) {
              this.selectionStore.addColorSizeLine(this.imprintKey, {
                slectedColor: tempLine.slectedColor,
                selectedSizes: tempLine.selectedSizes,
                totalQty: tempLine.totalQty
              });
              this.userModifiedColors.add(colorId);
              console.log("[ColorSizeSection] Color marked as user-modified (from temp):", colorId, "type:", typeof colorId);
              delete this.tempLineData[colorId];
            }
          }
        } else {
          const line = this.selectedLines.find((l) => l.id === lineId);
          if (line && line.slectedColor) {
            const colorId = line.slectedColor.id;
            if (!this.autoInitializedColors.has(colorId)) {
              this.userModifiedColors.add(colorId);
              console.log("[ColorSizeSection] Color marked as user-modified:", colorId);
            } else {
              this.autoInitializedColors.delete(colorId);
              this.userModifiedColors.add(colorId);
              console.log("[ColorSizeSection] Color changed from auto-initialized to user-modified:", colorId);
            }
          }
          this.selectionStore.updateLineSizeQty(this.imprintKey, lineId, size, quantity);
          const updatedLine = this.selectedLines.find((l) => l.id === lineId);
          if (updatedLine && updatedLine.totalQty === 0) {
            this.selectionStore.removeColorSizeLine(this.imprintKey, lineId);
            if (updatedLine.slectedColor) {
              this.userModifiedColors.delete(updatedLine.slectedColor.id);
              this.autoInitializedColors.delete(updatedLine.slectedColor.id);
            }
            if (updatedLine.slectedColor && updatedLine.slectedColor.id && this.expandedColorId === updatedLine.slectedColor.id) {
              this.tempLineData[updatedLine.slectedColor.id] = {
                id: `temp-${updatedLine.slectedColor.id}`,
                slectedColor: updatedLine.slectedColor,
                selectedSizes: updatedLine.selectedSizes,
                totalQty: 0
              };
            }
          }
        }
      },
      handleRemoveLine(lineId) {
        const isTemp = lineId.toString().startsWith("temp-");
        if (isTemp) {
          const colorId = lineId.replace("temp-", "");
          delete this.tempLineData[colorId];
          this.expandedColorId = null;
        } else {
          const line = this.selectedLines.find((l) => l.id === lineId);
          this.selectionStore.removeColorSizeLine(this.imprintKey, lineId);
          if (line && line.slectedColor) {
            this.userModifiedColors.delete(line.slectedColor.id);
            this.autoInitializedColors.delete(line.slectedColor.id);
          }
          if (line && line.slectedColor && this.expandedColorId === line.slectedColor.id) {
            this.expandedColorId = null;
          }
        }
      },
      handleNextStep() {
        console.log("[ColorSizeSection] Next Step button clicked");
        this.$emit("next-step");
      },
      // Reset expanded color selection to defaultActiveColorId (called externally via ref)
      resetColorSelection() {
        this.expandedColorId = null;
      },
      // Ensure tempLineData exists for a color (called from getExpandedColorInRow)
      ensureTempLineData(color) {
        var _a, _b, _c, _d;
        if (this.tempLineData[color.id]) return;
        const existingLine = this.selectedLines.find((line) => {
          return line && line.slectedColor && line.slectedColor.id === color.id;
        });
        if (existingLine) return;
        const defaultSizes = {};
        this.availableSizes.forEach((size) => {
          defaultSizes[size] = 0;
        });
        this.tempLineData[color.id] = {
          id: `temp-${color.id}`,
          slectedColor: {
            id: color.id,
            title: color.title || color.option1 || "",
            img_src: ((_a = color.featured_image) == null ? void 0 : _a.src) || color.image || "",
            img_id: ((_b = color.featured_image) == null ? void 0 : _b.id) || color.image_id || null,
            img_sku: color.sku || "",
            img_gid: ((_c = color.featured_media) == null ? void 0 : _c.id) || null,
            alt: ((_d = color.featured_image) == null ? void 0 : _d.alt) || color.title || "",
            hex: color.hex || color.color_hex || null
          },
          selectedSizes: defaultSizes,
          totalQty: 0
        };
      },
      initializeFirstColorForQtyOnly() {
        var _a, _b, _c, _d;
        if (!this.isQtyOnlyProduct || this.availableColors.length === 0) {
          return;
        }
        const firstColor = this.availableColors[0];
        const existingLine = this.selectedLines.find((line) => {
          return line && line.slectedColor && line.slectedColor.id === firstColor.id;
        });
        if (existingLine) {
          this.expandedColorId = firstColor.id;
          this.lastActiveColorId = firstColor.id;
        } else {
          const defaultQtyValue = this.isDefaultQtyToSecondColumnEnabled ? this.secondColumnQty : 0;
          const defaultSizes = {};
          this.availableSizes.forEach((size) => {
            defaultSizes[size] = defaultQtyValue;
          });
          const newLine = {
            slectedColor: {
              id: firstColor.id,
              title: firstColor.title || firstColor.option1 || "",
              img_src: ((_a = firstColor.featured_image) == null ? void 0 : _a.src) || firstColor.image || "",
              img_id: ((_b = firstColor.featured_image) == null ? void 0 : _b.id) || firstColor.image_id || null,
              img_sku: firstColor.sku || "",
              img_gid: ((_c = firstColor.featured_media) == null ? void 0 : _c.id) || null,
              alt: ((_d = firstColor.featured_image) == null ? void 0 : _d.alt) || firstColor.title || "",
              hex: firstColor.hex || firstColor.color_hex || null
            },
            selectedSizes: defaultSizes,
            totalQty: defaultQtyValue
          };
          if (defaultQtyValue > 0) {
            this.selectionStore.addColorSizeLine(this.imprintKey, {
              slectedColor: newLine.slectedColor,
              selectedSizes: newLine.selectedSizes,
              totalQty: newLine.totalQty
            });
            this.userModifiedColors.add(firstColor.id);
            console.log("[ColorSizeSection] First color default qty committed as user-modified:", firstColor.id);
          } else {
            this.tempLineData[firstColor.id] = {
              id: `temp-${firstColor.id}`,
              slectedColor: newLine.slectedColor,
              selectedSizes: newLine.selectedSizes,
              totalQty: newLine.totalQty
            };
            this.autoInitializedColors.add(firstColor.id);
            console.log("[ColorSizeSection] First color auto-initialized (no default qty):", firstColor.id);
          }
          this.expandedColorId = firstColor.id;
          this.lastActiveColorId = firstColor.id;
        }
        this.$nextTick(() => {
          this.updateArrowPosition();
        });
      }
    }
  };
  const _hoisted_1$n = { class: "color-size-selector" };
  const _hoisted_2$g = { class: "section-description" };
  const _hoisted_3$e = {
    key: 0,
    class: "load-more-section"
  };
  const _hoisted_4$d = {
    key: 0,
    class: "validation-message"
  };
  const _hoisted_5$d = {
    key: 0,
    class: "validation-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_6$d = {
    key: 1,
    class: "colors-grid-wrapper"
  };
  const _hoisted_7$d = {
    key: 2,
    class: "load-more-section"
  };
  const _hoisted_8$b = { key: 0 };
  const _hoisted_9$a = { key: 1 };
  const _hoisted_10$a = {
    key: 3,
    class: "loading-state"
  };
  const _hoisted_11$a = {
    key: 4,
    class: "validation-message"
  };
  const _hoisted_12$a = {
    key: 0,
    class: "validation-icon",
    width: "16",
    height: "16",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  };
  const _hoisted_13$a = { class: "action-buttons" };
  function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ColorCard = resolveComponent("ColorCard");
    const _component_ColorSizeLine = resolveComponent("ColorSizeLine");
    return openBlock(), createElementBlock("div", _hoisted_1$n, [
      createBaseVNode("p", _hoisted_2$g, toDisplayString($props.description), 1),
      $options.hasMoreColors ? (openBlock(), createElementBlock("div", _hoisted_3$e, [
        $options.showValidation ? (openBlock(), createElementBlock("div", _hoisted_4$d, [
          createBaseVNode("span", {
            class: normalizeClass(["validation-text", $options.validationClass])
          }, [
            $options.validationClass === "warning" ? (openBlock(), createElementBlock("svg", _hoisted_5$d, [..._cache[2] || (_cache[2] = [
              createBaseVNode("path", {
                "fill-rule": "evenodd",
                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                "clip-rule": "evenodd"
              }, null, -1)
            ])])) : createCommentVNode("", true),
            createTextVNode(" " + toDisplayString($options.validationMessage), 1)
          ], 2)
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true),
      $options.availableColors.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_6$d, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.colorRows, (row, rowIndex) => {
          return openBlock(), createElementBlock(Fragment, {
            key: `row-${rowIndex}`
          }, [
            createBaseVNode("div", {
              class: "colors-grid",
              ref_for: true,
              ref: (el) => $options.setGridRef(el, rowIndex)
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(row, (color) => {
                return openBlock(), createBlock(_component_ColorCard, {
                  key: color.id,
                  ref_for: true,
                  ref: (el) => $options.setColorCardRef(el, color.id),
                  color,
                  quantity: $data.colorQuantities[color.id] || 0,
                  "is-selected": $options.isColorSelected(color.id),
                  "is-expanded": $options.isColorExpanded(color.id),
                  onSelect: $options.handleColorSelect
                }, null, 8, ["color", "quantity", "is-selected", "is-expanded", "onSelect"]);
              }), 128))
            ], 512),
            createVNode(Transition, {
              name: $options.isQtyOnlyProduct ? "" : "slide-fade",
              onAfterEnter: $options.updateArrowPosition
            }, {
              default: withCtx(() => [
                $options.getExpandedColorInRow(row) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(["color-size-line-wrapper", { "is-qty-only": $options.isQtyOnlyProduct }]),
                  ref_for: true,
                  ref: (el) => $options.setLineWrapperRef(el, rowIndex)
                }, [
                  !$options.isQtyOnlyProduct ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "arrow-indicator",
                    style: normalizeStyle({ left: $data.arrowPosition })
                  }, [..._cache[3] || (_cache[3] = [
                    createBaseVNode("div", { class: "arrow-up" }, null, -1)
                  ])], 4)) : createCommentVNode("", true),
                  createVNode(_component_ColorSizeLine, {
                    line: $options.getExpandedLineData(row),
                    "available-sizes": $options.availableSizes,
                    "is-qty-only": $options.isQtyOnlyProduct,
                    "show-arrow": $options.isQtyOnlyProduct,
                    "qty-increment": $options.qtyIncrement,
                    "min-order-qty": $options.minQuantity,
                    "imprint-key": $props.imprintKey,
                    onUpdateQuantity: $options.handleUpdateQuantity,
                    onRemove: $options.handleRemoveLine
                  }, null, 8, ["line", "available-sizes", "is-qty-only", "show-arrow", "qty-increment", "min-order-qty", "imprint-key", "onUpdateQuantity", "onRemove"])
                ], 2)) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["name", "onAfterEnter"])
          ], 64);
        }), 128))
      ])) : createCommentVNode("", true),
      $options.hasMoreColors ? (openBlock(), createElementBlock("div", _hoisted_7$d, [
        createBaseVNode("a", {
          class: normalizeClass(["load-more-link", { "disabled": $data.isLoadingMore }]),
          onClick: _cache[0] || (_cache[0] = withModifiers((...args) => $options.loadMoreColors && $options.loadMoreColors(...args), ["prevent"])),
          href: "#"
        }, [
          !$data.isLoadingMore ? (openBlock(), createElementBlock("span", _hoisted_8$b, " Load More Colors (" + toDisplayString($options.remainingColorsCount) + " remaining) ", 1)) : (openBlock(), createElementBlock("span", _hoisted_9$a, " Loading... "))
        ], 2)
      ])) : $options.availableColors.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_10$a, [..._cache[4] || (_cache[4] = [
        createBaseVNode("p", null, "Loading colors and sizes...", -1)
      ])])) : createCommentVNode("", true),
      $options.showValidation ? (openBlock(), createElementBlock("div", _hoisted_11$a, [
        createBaseVNode("span", {
          class: normalizeClass(["validation-text", $options.validationClass])
        }, [
          $options.validationClass === "warning" ? (openBlock(), createElementBlock("svg", _hoisted_12$a, [..._cache[5] || (_cache[5] = [
            createBaseVNode("path", {
              "fill-rule": "evenodd",
              d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
              "clip-rule": "evenodd"
            }, null, -1)
          ])])) : createCommentVNode("", true),
          createTextVNode(" " + toDisplayString($options.validationMessage), 1)
        ], 2)
      ])) : createCommentVNode("", true),
      createBaseVNode("div", null, [
        createBaseVNode("p", null, "Minimum Order Quantity of " + toDisplayString($options.minQuantity) + " | Mix-n-Match in Increments of " + toDisplayString($options.qtyIncrement), 1)
      ]),
      createBaseVNode("div", _hoisted_13$a, [
        createBaseVNode("button", {
          class: "btn-next",
          onClick: _cache[1] || (_cache[1] = (...args) => $options.handleNextStep && $options.handleNextStep(...args))
        }, " Next Step: Customize Your Product ")
      ])
    ]);
  }
  const ColorSizeSection = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$m], ["__scopeId", "data-v-37230852"]]);
  const _sfc_main$m = {
    name: "NewImprintModule",
    props: {
      // Title shown in header
      title: {
        type: String,
        default: "First Imprint"
      },
      // Whether module can be collapsed
      collapsible: {
        type: Boolean,
        default: true
      },
      // Initial collapsed state
      initialCollapsed: {
        type: Boolean,
        default: false
      },
      // Whether delete button is shown
      deletable: {
        type: Boolean,
        default: false
      },
      // Imprint index/key
      imprintKey: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        isCollapsed: this.initialCollapsed
      };
    },
    methods: {
      toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        this.$emit("collapse-toggled", this.isCollapsed);
      },
      handleDelete() {
        this.$emit("delete-requested", this.imprintKey);
      }
    }
  };
  const _hoisted_1$m = { class: "new-imprint-module" };
  const _hoisted_2$f = { class: "imprint-header" };
  const _hoisted_3$d = { class: "header-content" };
  const _hoisted_4$c = { class: "imprint-title c-f-white" };
  const _hoisted_5$c = { class: "collapse-icon" };
  const _hoisted_6$c = { class: "imprint-container" };
  const _hoisted_7$c = {
    key: 0,
    class: "delete-section"
  };
  function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$m, [
      createBaseVNode("div", _hoisted_2$f, [
        createBaseVNode("div", _hoisted_3$d, [
          createBaseVNode("h3", _hoisted_4$c, toDisplayString($props.title), 1),
          $props.collapsible ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: normalizeClass(["collapse-btn", { "collapsed": $data.isCollapsed }]),
            onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleCollapse && $options.toggleCollapse(...args)),
            "aria-label": "Toggle imprint details"
          }, [
            createBaseVNode("span", _hoisted_5$c, toDisplayString($data.isCollapsed ? "+" : "−"), 1)
          ], 2)) : createCommentVNode("", true)
        ])
      ]),
      withDirectives(createBaseVNode("div", _hoisted_6$c, [
        renderSlot(_ctx.$slots, "default", {}, void 0),
        $props.deletable ? (openBlock(), createElementBlock("div", _hoisted_7$c, [
          createBaseVNode("button", {
            class: "delete-btn",
            onClick: _cache[1] || (_cache[1] = (...args) => $options.handleDelete && $options.handleDelete(...args))
          }, " Delete Imprint ")
        ])) : createCommentVNode("", true)
      ], 512), [
        [vShow, !$data.isCollapsed]
      ])
    ]);
  }
  const NewImprintModule = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$l], ["__scopeId", "data-v-2cf63c73"]]);
  const __vite_glob_0_0 = "data:image/png;base64,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";
  const __vite_glob_0_1 = "data:image/png;base64,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";
  const __vite_glob_0_2 = "data:image/png;base64,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";
  const __vite_glob_0_3 = "data:image/png;base64,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";
  const _sfc_main$l = {
    name: "ImprintMethodSelector",
    components: {
      BaseButton
    },
    props: {
      initialMethod: {
        type: String,
        default: null
      },
      // NEW: Disabled prop for locking method selection
      disabled: {
        type: Boolean,
        default: false
      },
      // NEW: Imprint index (0 = first, 1 = second, etc.)
      imprintIndex: {
        type: Number,
        default: 0
      }
    },
    setup() {
      const imprintStore = useImprintStore();
      const selectionStore = useSelectionStore();
      const calendarStore = useCalendarStore();
      const appStore = useAppStore();
      return {
        imprintStore,
        selectionStore,
        calendarStore,
        appStore
      };
    },
    data() {
      return {
        selectedMethodSku: this.initialMethod
      };
    },
    computed: {
      // Check if bundle compatibility check is required (calendar mode)
      isBundleCheckRequired() {
        return this.appStore.applicationType === "calendar";
      },
      // Show error message when no methods are available for bundle
      showBundleCompatibilityError() {
        return this.isBundleCheckRequired && this.calendarStore.availablePrintMethods.length === 0 && this.calendarStore.hasProducts;
      },
      // Check if this selector should be locked (disabled)
      // Only first imprint (index 0) can change method
      isLocked() {
        return this.disabled || this.imprintIndex > 0;
      },
      // Get available methods from Pinia store
      availableMethods() {
        return this.imprintStore.availableImprintMethods;
      },
      // Get selected method data
      selectedMethodData() {
        if (!this.selectedMethodSku) return null;
        const method = this.availableMethods.find((m) => m.sku === this.selectedMethodSku);
        if (!method) return null;
        const enhancedData = getImprintMethodBySku(this.selectedMethodSku);
        let imagePath = null;
        if (enhancedData == null ? void 0 : enhancedData.image) {
          imagePath = this.getImagePath(enhancedData.image);
        } else if (method.image) {
          imagePath = method.image;
        }
        return {
          sku: method.sku,
          name: (enhancedData == null ? void 0 : enhancedData.name) || method.name,
          description: (enhancedData == null ? void 0 : enhancedData.description) || method.description || getFallbackDescription(method.sku),
          image: imagePath
          // Will be null if no image
        };
      }
    },
    methods: {
      /**
       * Check if method is hidden/disabled for calendar bundle
       */
      isMethodHiddenForBundle(methodSku) {
        if (!this.isBundleCheckRequired) {
          return false;
        }
        return !this.calendarStore.isMethodAvailableForBundle(methodSku);
      },
      /**
       * Check if method button should be disabled
       */
      isMethodDisabled(methodSku) {
        if (this.isLocked) {
          return true;
        }
        if (this.isMethodHiddenForBundle(methodSku)) {
          return true;
        }
        return false;
      },
      /**
       * Get button variant based on selection and availability
       */
      getMethodVariant(methodSku) {
        if (this.selectedMethodSku === methodSku && !this.isMethodHiddenForBundle(methodSku)) {
          return "primary";
        }
        return "secondary";
      },
      handleImageError(event2) {
        console.warn("[ImprintMethodSelector] Failed to load image:", event2.target.src);
        event2.target.style.display = "none";
      },
      getImagePath(filename) {
        try {
          return new URL((/* @__PURE__ */ Object.assign({ "../../../assets/imprint-methods/cmyk.png": __vite_glob_0_0, "../../../assets/imprint-methods/dtg.png": __vite_glob_0_1, "../../../assets/imprint-methods/embroidery.png": __vite_glob_0_2, "../../../assets/imprint-methods/screenprint.png": __vite_glob_0_3 }))[`../../../assets/imprint-methods/${filename}`], _documentCurrentScript && _documentCurrentScript.tagName.toUpperCase() === "SCRIPT" && _documentCurrentScript.src || new URL("js/app.js", document.baseURI).href).href;
        } catch (e) {
          console.warn("Failed to load imprint method image:", filename, e);
          return null;
        }
      },
      emitMethodSelectedBySku(sku) {
        const method = this.availableMethods.find((m) => m.sku === sku);
        if (!method) return;
        this.$emit("method-selected", this.getMethodEmitData(method));
      },
      selectMethod(sku) {
        if (this.isLocked) {
          console.warn("[ImprintMethodSelector] Method selection is locked for imprint", this.imprintIndex);
          return;
        }
        if (this.isMethodHiddenForBundle(sku)) {
          console.warn("[ImprintMethodSelector] Method not available for calendar bundle:", sku);
          return;
        }
        this.selectedMethodSku = sku;
        const method = this.availableMethods.find((m) => m.sku === sku);
        if (method) {
          const previousImprintMethod = this.imprintStore.getImprintMethodKey;
          const newImprintMethod = method.name;
          if (this.imprintIndex === 0) {
            this.imprintStore.setSelectedImprintMethod({
              id: this.availableMethods.indexOf(method),
              sku,
              name: method.name,
              data: method
            });
            if (previousImprintMethod && previousImprintMethod !== newImprintMethod) {
              console.log("[ImprintMethodSelector] HOTFIX: Copying data from", previousImprintMethod, "to", newImprintMethod);
              this.selectionStore.initImprintKey(newImprintMethod, previousImprintMethod);
            }
            this.selectionStore.removeEmptyImprintMethodData(previousImprintMethod);
          }
          this.$emit("method-selected", this.getMethodEmitData(method));
        }
      },
      getMethodEmitData(method) {
        var _a, _b;
        return {
          sku: method.sku,
          name: method.name,
          description: ((_a = this.selectedMethodData) == null ? void 0 : _a.description) || method.description || "",
          image: ((_b = this.selectedMethodData) == null ? void 0 : _b.image) || method.image || null,
          price: method.price
        };
      },
      initializeSelection() {
        if (this.isLocked) {
          const storeMethod = this.imprintStore.selectedImprintMethod;
          if (storeMethod && storeMethod.sku) {
            this.selectedMethodSku = storeMethod.sku;
            console.log("[ImprintMethodSelector] Locked to store method:", storeMethod.sku, "for imprint", this.imprintIndex);
            this.emitMethodSelectedBySku(storeMethod.sku);
            return;
          }
        }
        if (this.isBundleCheckRequired) {
          const availableForBundle = this.calendarStore.availablePrintMethods;
          if (availableForBundle.length > 0) {
            const firstAvailable = this.availableMethods.find(
              (m) => availableForBundle.includes(m.sku)
            );
            if (firstAvailable) {
              console.log("[ImprintMethodSelector] Calendar bundle: selecting first available method:", firstAvailable.sku);
              this.selectMethod(firstAvailable.sku);
              return;
            }
          } else {
            console.warn("[ImprintMethodSelector] Calendar bundle: no methods available");
            return;
          }
        }
        if (!this.selectedMethodSku && this.availableMethods.length > 0) {
          this.selectMethod(this.availableMethods[0].sku);
        } else if (this.selectedMethodSku) {
          const method = this.availableMethods.find((m) => m.sku === this.selectedMethodSku);
          if (method) {
            this.selectMethod(this.selectedMethodSku);
          }
        }
      }
    },
    watch: {
      // Watch for changes in available methods
      availableMethods: {
        immediate: true,
        handler(newMethods, oldMethods) {
          console.log("%c[METHOD-SELECTOR] availableMethods watcher fired", "color: teal; font-weight: bold", {
            methodCount: newMethods == null ? void 0 : newMethods.length,
            selectedMethodSku: this.selectedMethodSku,
            imprintIndex: this.imprintIndex,
            isLocked: this.isLocked,
            oldSkus: oldMethods == null ? void 0 : oldMethods.map((m) => m.sku),
            newSkus: newMethods == null ? void 0 : newMethods.map((m) => m.sku)
          });
          console.trace("[METHOD-SELECTOR] availableMethods watcher trace");
          if (newMethods && newMethods.length > 0) {
            this.initializeSelection();
          }
        }
      },
      // Watch for calendar bundle validation changes
      "calendarStore.availablePrintMethods": {
        handler(newAvailableMethods) {
          console.log("[ImprintMethodSelector] Calendar available methods changed:", newAvailableMethods);
          if (this.isBundleCheckRequired && this.selectedMethodSku && newAvailableMethods.length > 0 && !newAvailableMethods.includes(this.selectedMethodSku)) {
            const firstAvailable = this.availableMethods.find(
              (m) => newAvailableMethods.includes(m.sku)
            );
            if (firstAvailable) {
              console.log("[ImprintMethodSelector] Switching to available method:", firstAvailable.sku);
              this.selectMethod(firstAvailable.sku);
            }
          }
        }
      },
      "imprintStore.selectedImprintMethod.sku": {
        handler(newSku) {
          if (this.isLocked && newSku && this.selectedMethodSku !== newSku) {
            this.selectedMethodSku = newSku;
            console.log("[ImprintMethodSelector] Synced locked selector to store method:", newSku, "for imprint", this.imprintIndex);
            this.emitMethodSelectedBySku(newSku);
          }
        }
      }
    },
    mounted() {
      console.log("[ImprintMethodSelector] Mounted", {
        availableMethods: this.availableMethods,
        selectedMethodSku: this.selectedMethodSku,
        imprintIndex: this.imprintIndex,
        isLocked: this.isLocked,
        isBundleCheckRequired: this.isBundleCheckRequired,
        bundleAvailableMethods: this.calendarStore.availablePrintMethods
      });
    }
  };
  const _hoisted_1$l = { class: "imprint-method-selector" };
  const _hoisted_2$e = { class: "section-header" };
  const _hoisted_3$c = {
    key: 0,
    class: "locked-indicator"
  };
  const _hoisted_4$b = {
    key: 0,
    class: "message-calendar-titles"
  };
  const _hoisted_5$b = { class: "method-buttons" };
  const _hoisted_6$b = {
    key: 1,
    class: "method-description"
  };
  const _hoisted_7$b = {
    key: 0,
    class: "method-image"
  };
  const _hoisted_8$a = ["src", "alt"];
  function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseButton = resolveComponent("BaseButton");
    return openBlock(), createElementBlock("div", _hoisted_1$l, [
      createBaseVNode("div", _hoisted_2$e, [
        _cache[1] || (_cache[1] = createBaseVNode("label", { class: "section-label" }, "1. Choose an Imprint Method", -1)),
        $options.isLocked ? (openBlock(), createElementBlock("span", _hoisted_3$c, "(Locked to First Imprint method)")) : createCommentVNode("", true)
      ]),
      $options.showBundleCompatibilityError ? (openBlock(), createElementBlock("p", _hoisted_4$b, " Unfortunately, one or more calendar titles in your bundle cannot be ordered together. Please remove one or more titles and try again. ")) : createCommentVNode("", true),
      createBaseVNode("div", _hoisted_5$b, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.availableMethods, (method) => {
          return openBlock(), createBlock(_component_BaseButton, {
            key: method.sku,
            text: method.name,
            variant: $options.getMethodVariant(method.sku),
            size: "small",
            disabled: $options.isMethodDisabled(method.sku),
            class: normalizeClass({ "hide_tab": $options.isMethodHiddenForBundle(method.sku) }),
            onClick: ($event) => $options.selectMethod(method.sku)
          }, null, 8, ["text", "variant", "disabled", "class", "onClick"]);
        }), 128))
      ]),
      $options.selectedMethodData && !$options.isMethodHiddenForBundle($data.selectedMethodSku) ? (openBlock(), createElementBlock("div", _hoisted_6$b, [
        $options.selectedMethodData.image ? (openBlock(), createElementBlock("div", _hoisted_7$b, [
          createBaseVNode("img", {
            src: $options.selectedMethodData.image,
            alt: $options.selectedMethodData.name,
            onError: _cache[0] || (_cache[0] = (...args) => $options.handleImageError && $options.handleImageError(...args))
          }, null, 40, _hoisted_8$a)
        ])) : createCommentVNode("", true),
        createBaseVNode("p", null, toDisplayString($options.selectedMethodData.description), 1)
      ])) : createCommentVNode("", true)
    ]);
  }
  const ImprintMethodSelector = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$k], ["__scopeId", "data-v-8236b825"]]);
  const _sfc_main$k = {
    name: "ImprintLocationSelector",
    emits: ["location-selected", "update:modelValue"],
    props: {
      // Label text
      label: {
        type: String,
        default: "2. Choose an Imprint Location"
      },
      // Placeholder for dropdown
      placeholder: {
        type: String,
        default: "Location Name"
      },
      // Initial selected location SKU
      initialLocation: {
        type: String,
        default: ""
      },
      // Imprint key (index) for validation
      imprintKey: {
        type: Number,
        default: null
      },
      // Show help icon
      showHelp: {
        type: Boolean,
        default: false
      },
      // Help text content
      helpText: {
        type: String,
        default: "Select where you want the imprint to appear on the product."
      },
      // Help icon title (tooltip)
      helpIconTitle: {
        type: String,
        default: "Show help"
      },
      // Disabled state
      disabled: {
        type: Boolean,
        default: false
      },
      // Loading state
      loading: {
        type: Boolean,
        default: false
      },
      // Error state
      hasError: {
        type: Boolean,
        default: false
      },
      // Error message
      errorMessage: {
        type: String,
        default: ""
      },
      // Auto-select first location
      autoSelectFirst: {
        type: Boolean,
        default: true
      },
      // Required field (show error if empty)
      required: {
        type: Boolean,
        default: true
      }
    },
    setup() {
      const imprintStore = useImprintStore();
      const newImprintStore = useNewImprintStore();
      const appStore = useAppStore();
      return {
        imprintStore,
        newImprintStore,
        appStore
      };
    },
    data() {
      return {
        selectedLocationValue: this.initialLocation,
        isHelpVisible: false,
        isMounted: false,
        // Track if component is mounted
        locationError: null
        // Validation error for duplicate locations
      };
    },
    computed: {
      // Get available locations from Pinia store
      availableLocations() {
        const locations = this.imprintStore.availableLocations;
        console.log("[ImprintLocationSelector] Available locations:", locations);
        return locations || [];
      },
      // Get selected location object
      selectedLocationObject() {
        if (!this.selectedLocationValue) return null;
        return this.availableLocations.find((loc) => loc.sku === this.selectedLocationValue);
      },
      // Check if should show error state (red border)
      showErrorState() {
        if (this.appStore.isEnvelopProduct) {
          return this.hasError || !!this.locationError;
        }
        return this.hasError || !!this.locationError || this.required && !this.selectedLocationValue;
      },
      /**
       * Check if this selector should be hidden
       * Envelop products do not have location selection
       */
      isHiddenForEnvelop() {
        return this.appStore.isEnvelopProduct;
      }
    },
    methods: {
      toggleHelp() {
        this.isHelpVisible = !this.isHelpVisible;
      },
      /**
       * Check if location is used in OTHER imprints (not current)
       */
      isLocationUsedInOtherImprints(locationSku) {
        const currentKey = this.imprintKey !== null ? this.imprintKey : this.newImprintStore.currentImprintKey;
        return this.newImprintStore.isLocationUsedInOtherImprints(
          locationSku,
          currentKey
        );
      },
      handleLocationChange() {
        const location2 = this.selectedLocationObject;
        console.log("[ImprintLocationSelector] Location selected:", {
          sku: this.selectedLocationValue,
          location: location2,
          imprintKey: this.imprintKey
        });
        const currentKey = this.imprintKey !== null ? this.imprintKey : this.newImprintStore.currentImprintKey;
        const validation = this.newImprintStore.validateLocationSelection(
          this.selectedLocationValue,
          currentKey
        );
        if (!validation.valid) {
          this.locationError = validation.error;
          console.warn("[ImprintLocationSelector] Validation failed:", validation.error);
          this.selectedLocationValue = "";
          return;
        }
        this.locationError = null;
        this.$emit("location-selected", {
          sku: this.selectedLocationValue,
          location: location2
        });
        this.$emit("update:modelValue", this.selectedLocationValue);
      },
      // Public method to set location programmatically
      setLocation(locationSku) {
        this.selectedLocationValue = locationSku;
        this.handleLocationChange();
      },
      // Public method to clear selection
      clearSelection() {
        this.selectedLocationValue = "";
        this.$emit("location-selected", null);
        this.$emit("update:modelValue", "");
      }
    },
    watch: {
      initialLocation: {
        immediate: true,
        handler(newValue) {
          console.log("[ImprintLocationSelector] initialLocation changed:", {
            newValue,
            imprintKey: this.imprintKey,
            currentValue: this.selectedLocationValue
          });
          this.selectedLocationValue = newValue || "";
          this.locationError = null;
        }
      },
      // Watch for locations becoming available
      availableLocations: {
        handler(newLocations) {
          if (!this.isMounted) {
            console.log("[ImprintLocationSelector] Not mounted yet, skipping auto-select");
            return;
          }
          console.log("[ImprintLocationSelector] availableLocations changed:", {
            locationsCount: newLocations == null ? void 0 : newLocations.length,
            selectedLocationValue: this.selectedLocationValue,
            autoSelectFirst: this.autoSelectFirst,
            imprintKey: this.imprintKey
          });
          if (this.autoSelectFirst && newLocations && newLocations.length > 0 && !this.selectedLocationValue) {
            const firstAvailable = newLocations.find(
              (loc) => !this.isLocationUsedInOtherImprints(loc.sku)
            );
            if (firstAvailable) {
              this.selectedLocationValue = firstAvailable.sku;
              this.handleLocationChange();
              console.log("[ImprintLocationSelector] Auto-selected first available location:", firstAvailable);
            } else {
              console.warn("[ImprintLocationSelector] No available locations to auto-select (all are used)");
            }
          } else {
            console.log("[ImprintLocationSelector] Skipping auto-select:", {
              reason: !this.autoSelectFirst ? "autoSelectFirst=false" : !newLocations ? "no locations" : newLocations.length === 0 ? "empty locations" : this.selectedLocationValue ? "already selected" : "unknown"
            });
          }
        }
      }
    },
    mounted() {
      console.log("[ImprintLocationSelector] Mounted", {
        availableLocations: this.availableLocations.length,
        selectedLocation: this.selectedLocationValue,
        autoSelectFirst: this.autoSelectFirst
      });
      this.isMounted = true;
      if (this.autoSelectFirst && this.availableLocations && this.availableLocations.length > 0 && !this.selectedLocationValue) {
        const firstAvailable = this.availableLocations.find(
          (loc) => !this.isLocationUsedInOtherImprints(loc.sku)
        );
        if (firstAvailable) {
          this.selectedLocationValue = firstAvailable.sku;
          this.handleLocationChange();
          console.log("[ImprintLocationSelector] Auto-selected first available location on mount:", firstAvailable);
        } else {
          console.warn("[ImprintLocationSelector] No available locations to auto-select on mount (all are used)");
        }
      }
    }
  };
  const _hoisted_1$k = {
    key: 0,
    class: "imprint-location-selector"
  };
  const _hoisted_2$d = { class: "section-header" };
  const _hoisted_3$b = { class: "section-label" };
  const _hoisted_4$a = ["title"];
  const _hoisted_5$a = {
    key: 0,
    class: "help-text"
  };
  const _hoisted_6$a = { class: "location-dropdown-wrapper" };
  const _hoisted_7$a = ["disabled"];
  const _hoisted_8$9 = {
    value: "",
    disabled: ""
  };
  const _hoisted_9$9 = ["value", "disabled"];
  const _hoisted_10$9 = { key: 0 };
  const _hoisted_11$9 = {
    key: 0,
    class: "error-message"
  };
  const _hoisted_12$9 = {
    key: 1,
    class: "error-message"
  };
  const _hoisted_13$9 = {
    key: 2,
    class: "info-message"
  };
  const _hoisted_14$8 = {
    key: 3,
    class: "info-message"
  };
  function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
    return !$options.isHiddenForEnvelop ? (openBlock(), createElementBlock("div", _hoisted_1$k, [
      createBaseVNode("div", _hoisted_2$d, [
        createBaseVNode("label", _hoisted_3$b, toDisplayString($props.label), 1),
        $props.showHelp && $props.helpText ? (openBlock(), createElementBlock("button", {
          key: 0,
          class: "help-icon",
          onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleHelp && $options.toggleHelp(...args)),
          title: $props.helpIconTitle
        }, " ? ", 8, _hoisted_4$a)) : createCommentVNode("", true)
      ]),
      createVNode(Transition, { name: "slide-fade" }, {
        default: withCtx(() => [
          $data.isHelpVisible && $props.helpText ? (openBlock(), createElementBlock("div", _hoisted_5$a, toDisplayString($props.helpText), 1)) : createCommentVNode("", true)
        ]),
        _: 1
      }),
      createBaseVNode("div", _hoisted_6$a, [
        withDirectives(createBaseVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.selectedLocationValue = $event),
          class: normalizeClass(["location-dropdown", { "has-error": $options.showErrorState }]),
          disabled: $props.disabled || $options.availableLocations.length === 0,
          onChange: _cache[2] || (_cache[2] = (...args) => $options.handleLocationChange && $options.handleLocationChange(...args))
        }, [
          createBaseVNode("option", _hoisted_8$9, toDisplayString($props.placeholder), 1),
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.availableLocations, (location2) => {
            return openBlock(), createElementBlock("option", {
              key: location2.sku,
              value: location2.sku,
              disabled: $options.isLocationUsedInOtherImprints(location2.sku)
            }, [
              createTextVNode(toDisplayString(location2.title) + " ", 1),
              $options.isLocationUsedInOtherImprints(location2.sku) && location2.sku !== $data.selectedLocationValue ? (openBlock(), createElementBlock("span", _hoisted_10$9, " (Already Used)")) : createCommentVNode("", true)
            ], 8, _hoisted_9$9);
          }), 128))
        ], 42, _hoisted_7$a), [
          [vModelSelect, $data.selectedLocationValue]
        ]),
        _cache[3] || (_cache[3] = createBaseVNode("span", { class: "dropdown-icon" }, "▼", -1))
      ]),
      $props.errorMessage ? (openBlock(), createElementBlock("p", _hoisted_11$9, toDisplayString($props.errorMessage), 1)) : createCommentVNode("", true),
      $data.locationError ? (openBlock(), createElementBlock("p", _hoisted_12$9, toDisplayString($data.locationError), 1)) : createCommentVNode("", true),
      $options.availableLocations.length === 0 && !$props.loading ? (openBlock(), createElementBlock("p", _hoisted_13$9, " Please select an imprint method first to see available locations. ")) : createCommentVNode("", true),
      $props.loading ? (openBlock(), createElementBlock("p", _hoisted_14$8, " Loading locations... ")) : createCommentVNode("", true)
    ])) : createCommentVNode("", true);
  }
  const ImprintLocationSelector = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$j], ["__scopeId", "data-v-7ba3890e"]]);
  const _sfc_main$j = {
    name: "ArtworkUpload",
    props: {
      /**
       * API endpoint for upload
       */
      uploadEndpoint: {
        type: String,
        default: "api/upload/imprint"
      },
      /**
       * Existing uploaded image data (from Pinia store)
       * Expected shape: { filename?, file?, response?, urlFromStorage?, uploadedFileUrl?, ... }
       */
      initialImageData: {
        type: Object,
        default: null
      },
      /**
       * Maximum file size in MB
       */
      maxSizeMB: {
        type: Number,
        default: 24
      }
    },
    data() {
      return {
        selectedFile: null,
        isDragActive: false,
        uploadSuccess: false,
        uploadMessage: "",
        uploading: false,
        uploadProgress: 0,
        errors: [],
        acceptedFileTypes: ".ai,.bmp,.cdr,.eps,.jpeg,.jpg,.pdf,.png,.tiff",
        acceptedTypesDisplay: "ai, bmp, cdr, eps, jpeg, jpg, pdf, png, tiff",
        uploadedFileUrl: null,
        imagePreviewUrl: null,
        // Preview URL for uploaded image
        dragCounter: 0
        // Track nested drag events
      };
    },
    computed: {
      apiBaseUrl() {
        var _a, _b;
        return ((_b = (_a = window == null ? void 0 : window.PXUTheme) == null ? void 0 : _a.theme_settings) == null ? void 0 : _b.api_beckend_url) || "https://dev.api-customapp.comda.com/";
      },
      maxSizeBytes() {
        return this.maxSizeMB * 1024 * 1024;
      }
    },
    watch: {
      initialImageData: {
        immediate: true,
        deep: true,
        handler(val) {
          var _a, _b, _c, _d, _e;
          if (!val) {
            this.selectedFile = null;
            this.uploadSuccess = false;
            this.uploadMessage = "";
            this.uploadedFileUrl = null;
            this.imagePreviewUrl = null;
            this.errors = [];
            return;
          }
          const url = val.urlFromStorage || val.uploadedFileUrl || ((_a = val.response) == null ? void 0 : _a.urlFromStorage) || ((_b = val.response) == null ? void 0 : _b.url) || val.url;
          if (!url) return;
          const name = val.filename || ((_c = val.file) == null ? void 0 : _c.name) || ((_d = val.response) == null ? void 0 : _d.result) || "uploaded_image";
          const size = Number.isFinite((_e = val.file) == null ? void 0 : _e.size) ? val.file.size : 0;
          this.selectedFile = { name, size };
          this.uploadSuccess = true;
          this.uploadMessage = val.message || "Image Uploaded Successfully!";
          this.uploadedFileUrl = url;
          this.imagePreviewUrl = url;
          this.errors = [];
          this.uploading = false;
          this.uploadProgress = 0;
        }
      }
    },
    methods: {
      // Click on dropzone area opens file dialog (only when no file is selected)
      handleDropzoneClick(e) {
        if (!this.selectedFile) {
          this.openFileDialog();
        }
      },
      // Drag & Drop handlers
      handleDragEnter(e) {
        this.dragCounter++;
        this.isDragActive = true;
      },
      handleDragOver(e) {
        this.isDragActive = true;
      },
      handleDragLeave(e) {
        this.dragCounter--;
        if (this.dragCounter === 0) {
          this.isDragActive = false;
        }
      },
      handleDrop(e) {
        var _a;
        this.dragCounter = 0;
        this.isDragActive = false;
        const files = (_a = e.dataTransfer) == null ? void 0 : _a.files;
        if (files && files.length > 0) {
          this.processFile(files[0]);
        }
      },
      // File dialog
      openFileDialog() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.click();
        }
      },
      handleFileSelect(event2) {
        const file = event2.target.files[0];
        if (file) {
          this.processFile(file);
        }
      },
      // File processing
      processFile(file) {
        this.errors = [];
        this.uploadSuccess = false;
        if (!this.validateFile(file)) {
          return;
        }
        this.selectedFile = file;
        this.uploadFile();
      },
      validateFile(file) {
        const allowedExtensions = [".ai", ".bmp", ".cdr", ".eps", ".jpeg", ".jpg", ".png", ".pdf", ".tiff"];
        const fileName = file.name.toLowerCase();
        const fileExtension = "." + fileName.split(".").pop();
        if (!allowedExtensions.includes(fileExtension)) {
          this.errors.push(
            `Invalid file type. Only ${this.acceptedTypesDisplay} are allowed.`
          );
          return false;
        }
        if (file.size > this.maxSizeBytes) {
          this.errors.push(
            `The file you are uploading is too large. The maximum file size is ${this.maxSizeMB}MB.`
          );
          return false;
        }
        return true;
      },
      async uploadFile() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        if (!this.selectedFile) return;
        this.uploading = true;
        this.uploadProgress = 0;
        this.errors = [];
        const file = this.selectedFile;
        const file_type = file.type || "";
        const file_name = file.name || "";
        let file_name_type = "";
        const splitNameByDot = file_name.split(".");
        if (splitNameByDot.length > 0) {
          file_name_type = "." + splitNameByDot[splitNameByDot.length - 1];
        }
        const formData = new FormData();
        formData.append("file_type", file_type);
        formData.append("file_name", file_name);
        if (file_name_type) {
          formData.append("file_name_type", file_name_type);
        }
        formData.append("image", file);
        formData.append("_method", "PUT");
        try {
          const response = await axios.post(
            `${this.apiBaseUrl}${this.uploadEndpoint}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                  this.uploadProgress = Math.round(
                    progressEvent.loaded * 100 / progressEvent.total
                  );
                }
              }
            }
          );
          this.uploading = false;
          this.uploadSuccess = true;
          this.uploadMessage = "Image Uploaded Successfully!";
          this.uploadedFileUrl = response.data.urlFromStorage || response.data.url || response.data.file_url;
          const imageExtensions = [".jpeg", ".jpg", ".png", ".gif", ".webp"];
          const fileName = this.selectedFile.name.toLowerCase();
          const isImageFile = imageExtensions.some((ext) => fileName.endsWith(ext));
          if (isImageFile && this.uploadedFileUrl) {
            this.imagePreviewUrl = this.uploadedFileUrl;
          } else {
            this.imagePreviewUrl = URL.createObjectURL(this.selectedFile);
          }
          this.$emit("upload-success", {
            file: this.selectedFile,
            url: this.uploadedFileUrl,
            response: response.data
          });
          console.log("[ArtworkUpload] Upload successful:", response.data);
        } catch (error) {
          this.uploading = false;
          this.uploadSuccess = false;
          console.error("[ArtworkUpload] Upload error details:", {
            message: error.message,
            response: (_a = error.response) == null ? void 0 : _a.data,
            status: (_b = error.response) == null ? void 0 : _b.status,
            headers: (_c = error.response) == null ? void 0 : _c.headers,
            config: {
              url: (_d = error.config) == null ? void 0 : _d.url,
              method: (_e = error.config) == null ? void 0 : _e.method,
              headers: (_f = error.config) == null ? void 0 : _f.headers
            }
          });
          const errorMessage = ((_h = (_g = error.response) == null ? void 0 : _g.data) == null ? void 0 : _h.message) || ((_j = (_i = error.response) == null ? void 0 : _i.data) == null ? void 0 : _j.error) || error.message || "Upload failed. Please try again.";
          this.errors.push(errorMessage);
          this.$emit("upload-error", {
            error,
            message: errorMessage,
            status: (_k = error.response) == null ? void 0 : _k.status
          });
        }
      },
      removeFile() {
        if (this.imagePreviewUrl && this.imagePreviewUrl.startsWith("blob:")) {
          URL.revokeObjectURL(this.imagePreviewUrl);
        }
        this.selectedFile = null;
        this.uploadSuccess = false;
        this.uploadMessage = "";
        this.uploadedFileUrl = null;
        this.imagePreviewUrl = null;
        this.errors = [];
        this.uploadProgress = 0;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
        this.$emit("file-removed");
      },
      // Utility
      formatFileSize(bytes) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + " " + sizes[i];
      }
    },
    beforeUnmount() {
      if (this.imagePreviewUrl && this.imagePreviewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(this.imagePreviewUrl);
      }
    }
  };
  const _hoisted_1$j = { class: "artwork-upload" };
  const _hoisted_2$c = ["accept"];
  const _hoisted_3$a = {
    key: 0,
    class: "dropzone-content"
  };
  const _hoisted_4$9 = { class: "dropzone-text" };
  const _hoisted_5$9 = { class: "dropzone-hint" };
  const _hoisted_6$9 = { class: "accepted-types" };
  const _hoisted_7$9 = {
    key: 1,
    class: "selected-file"
  };
  const _hoisted_8$8 = { class: "file-details" };
  const _hoisted_9$8 = ["title"];
  const _hoisted_10$8 = { class: "file-size" };
  const _hoisted_11$8 = { class: "file-info" };
  const _hoisted_12$8 = { class: "file-size-limit" };
  const _hoisted_13$8 = {
    key: 0,
    class: "upload-message success"
  };
  const _hoisted_14$7 = { class: "image-preview" };
  const _hoisted_15$7 = ["src"];
  const _hoisted_16$7 = { class: "success-content" };
  const _hoisted_17$6 = {
    key: 1,
    class: "upload-message error"
  };
  const _hoisted_18$6 = { class: "error-list" };
  const _hoisted_19$6 = {
    key: 2,
    class: "upload-progress"
  };
  const _hoisted_20$6 = { class: "progress-bar" };
  const _hoisted_21$6 = { class: "progress-percentage" };
  function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$j, [
      createBaseVNode("div", {
        class: normalizeClass(["dropzone", {
          "dropzone-active": $data.isDragActive,
          "dropzone-has-file": $data.selectedFile
        }]),
        onDragenter: _cache[3] || (_cache[3] = withModifiers((...args) => $options.handleDragEnter && $options.handleDragEnter(...args), ["prevent"])),
        onDragover: _cache[4] || (_cache[4] = withModifiers((...args) => $options.handleDragOver && $options.handleDragOver(...args), ["prevent"])),
        onDragleave: _cache[5] || (_cache[5] = withModifiers((...args) => $options.handleDragLeave && $options.handleDragLeave(...args), ["prevent"])),
        onDrop: _cache[6] || (_cache[6] = withModifiers((...args) => $options.handleDrop && $options.handleDrop(...args), ["prevent"])),
        onClick: _cache[7] || (_cache[7] = (...args) => $options.handleDropzoneClick && $options.handleDropzoneClick(...args))
      }, [
        createBaseVNode("input", {
          ref: "fileInput",
          type: "file",
          accept: $data.acceptedFileTypes,
          onChange: _cache[0] || (_cache[0] = (...args) => $options.handleFileSelect && $options.handleFileSelect(...args)),
          class: "file-input"
        }, null, 40, _hoisted_2$c),
        !$data.selectedFile ? (openBlock(), createElementBlock("div", _hoisted_3$a, [
          _cache[10] || (_cache[10] = createStaticVNode('<div class="dropzone-icon" data-v-4cc82097><svg width="40" height="40" viewBox="0 0 40 40" fill="none" data-v-4cc82097><rect x="2" y="2" width="36" height="36" rx="4" stroke="#0D72B1" stroke-width="2" data-v-4cc82097></rect><path d="M12 20L20 12L28 20" stroke="#0D72B1" stroke-width="2" stroke-linecap="round" data-v-4cc82097></path><path d="M20 12V28" stroke="#0D72B1" stroke-width="2" stroke-linecap="round" data-v-4cc82097></path></svg></div>', 1)),
          createBaseVNode("div", _hoisted_4$9, [
            _cache[8] || (_cache[8] = createBaseVNode("span", null, "Drop your image here, or ", -1)),
            createBaseVNode("button", {
              type: "button",
              class: "browse-link",
              onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.openFileDialog && $options.openFileDialog(...args), ["stop"]))
            }, "browse")
          ]),
          createBaseVNode("div", _hoisted_5$9, [
            _cache[9] || (_cache[9] = createTextVNode(" Accepted file types: ", -1)),
            createBaseVNode("span", _hoisted_6$9, toDisplayString($data.acceptedTypesDisplay), 1)
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_7$9, [
          _cache[11] || (_cache[11] = createBaseVNode("div", { class: "file-icon" }, [
            createBaseVNode("svg", {
              width: "32",
              height: "32",
              viewBox: "0 0 32 32",
              fill: "none"
            }, [
              createBaseVNode("path", {
                d: "M6 4C6 2.89543 6.89543 2 8 2H20L26 8V28C26 29.1046 25.1046 30 24 30H8C6.89543 30 6 29.1046 6 28V4Z",
                fill: "#0D72B1",
                "fill-opacity": "0.1"
              }),
              createBaseVNode("path", {
                d: "M20 2L26 8H20V2Z",
                fill: "#0D72B1",
                "fill-opacity": "0.2"
              })
            ])
          ], -1)),
          createBaseVNode("div", _hoisted_8$8, [
            createBaseVNode("span", {
              class: "file-name",
              title: $data.selectedFile.name
            }, toDisplayString($data.selectedFile.name), 9, _hoisted_9$8),
            createBaseVNode("span", _hoisted_10$8, toDisplayString($options.formatFileSize($data.selectedFile.size)), 1)
          ]),
          createBaseVNode("button", {
            type: "button",
            class: "remove-btn",
            onClick: _cache[2] || (_cache[2] = withModifiers((...args) => $options.removeFile && $options.removeFile(...args), ["stop"])),
            title: "Remove file"
          }, " × ")
        ]))
      ], 34),
      createBaseVNode("div", _hoisted_11$8, [
        createBaseVNode("p", _hoisted_12$8, "Maximum file size: " + toDisplayString($props.maxSizeMB) + "MB", 1)
      ]),
      $data.uploadSuccess ? (openBlock(), createElementBlock("div", _hoisted_13$8, [
        createBaseVNode("div", _hoisted_14$7, [
          createBaseVNode("img", {
            src: $data.imagePreviewUrl,
            alt: "Uploaded image preview"
          }, null, 8, _hoisted_15$7)
        ]),
        createBaseVNode("div", _hoisted_16$7, [
          _cache[12] || (_cache[12] = createBaseVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            class: "message-icon"
          }, [
            createBaseVNode("path", {
              d: "M13.5 4.5L6 12L2.5 8.5",
              stroke: "#155724",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          createBaseVNode("p", null, toDisplayString($data.uploadMessage), 1)
        ])
      ])) : createCommentVNode("", true),
      $data.errors.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_17$6, [
        _cache[13] || (_cache[13] = createBaseVNode("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          class: "message-icon"
        }, [
          createBaseVNode("circle", {
            cx: "8",
            cy: "8",
            r: "7",
            stroke: "#721c24",
            "stroke-width": "2"
          }),
          createBaseVNode("path", {
            d: "M8 4V9",
            stroke: "#721c24",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }),
          createBaseVNode("circle", {
            cx: "8",
            cy: "12",
            r: "1",
            fill: "#721c24"
          })
        ], -1)),
        createBaseVNode("div", _hoisted_18$6, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.errors, (error, index) => {
            return openBlock(), createElementBlock("p", { key: index }, toDisplayString(error), 1);
          }), 128))
        ])
      ])) : createCommentVNode("", true),
      $data.uploading ? (openBlock(), createElementBlock("div", _hoisted_19$6, [
        createBaseVNode("div", _hoisted_20$6, [
          createBaseVNode("div", {
            class: "progress-fill",
            style: normalizeStyle({ width: $data.uploadProgress + "%" })
          }, [
            createBaseVNode("span", _hoisted_21$6, toDisplayString($data.uploadProgress) + "%", 1)
          ], 4)
        ]),
        _cache[14] || (_cache[14] = createBaseVNode("p", { class: "progress-text" }, "Uploading...", -1))
      ])) : createCommentVNode("", true)
    ]);
  }
  const ArtworkUpload = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$i], ["__scopeId", "data-v-4cc82097"]]);
  const _sfc_main$i = {
    name: "StartNewImprintForm",
    components: {
      BaseButton,
      ImprintMethodSelector,
      ImprintLocationSelector,
      ArtworkUpload
    },
    props: {
      // Imprint key to work with specific imprint in store
      imprintKey: {
        type: Number,
        default: 0
      }
    },
    setup(props) {
      const imprintStore = useImprintStore();
      const newImprintStore = useNewImprintStore();
      const appStore = useAppStore();
      return {
        imprintStore,
        newImprintStore,
        appStore,
        debugConfig: DEBUG_CONFIG
      };
    },
    data() {
      return {
        // Pantone input values per line (line.id -> string)
        pantoneInputs: {},
        // DOM refs for each text line's wrapper (line.id -> element), used to
        // detect clicks outside a line's colour picker regardless of how it was opened
        lineRefs: {},
        // Message Types
        messageTypes: [
          { id: "text", label: "Text Only" },
          { id: "image", label: "Image Only" },
          { id: "text_image", label: "Text & Image" }
        ],
        // Colors
        colorCatalogBaseUrl: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/colors/",
        customColorPresets: []
        //'Full Color', 'CMYK'
      };
    },
    computed: {
      // Current imprint data from store
      // IMPORTANT: Use imprintKey prop to ensure correct imprint for this component instance
      currentImprint() {
        return this.newImprintStore.imprints[this.imprintKey] || {};
      },
      getColorNameText() {
        return getColorName();
      },
      // Filtered text lines (only message type, not image)
      textLinesFiltered() {
        return (this.currentImprint.textLines || []).filter((l) => l.type === "message");
      },
      // Check if should show text lines section
      shouldShowTextLines() {
        return this.currentImprint.messageType === "text" || this.currentImprint.messageType === "text_image";
      },
      // Check if should show image upload section
      shouldShowImageUpload() {
        return this.currentImprint.messageType === "image" || this.currentImprint.messageType === "text_image";
      },
      // Get image line data
      imageLineData() {
        const lines = this.currentImprint.textLines || [];
        const imageLine = lines.find((line) => line.type === "image") || null;
        console.log("[StartNewImprintForm] imageLineData computed:", {
          linesCount: lines.length,
          lineTypes: lines.map((l) => l.type),
          imageLineFound: !!imageLine,
          imageLineId: imageLine == null ? void 0 : imageLine.id
        });
        return imageLine;
      },
      // Check if has any validation errors
      hasErrors() {
        return Object.keys(this.currentImprint.errors || {}).length > 0;
      },
      // Check if this is an Envelop product (hide imprint message section)
      isEnvelopProduct() {
        return this.appStore.isEnvelopProduct;
      },
      // Note: canAddLine computed removed - all lines are automatically shown based on maxLines
      // Get pending color selection for current imprint
      pendingColorSelection() {
        return this.currentImprint.pendingColorSelection || {};
      },
      // Get saved Pantone colors for current imprint
      savedPantoneColors() {
        return this.currentImprint.savedPantoneColors || [];
      },
      // Check if color is currently pending for a specific line
      isPendingColor() {
        return (lineId, colorSku) => {
          var _a;
          const pending2 = this.pendingColorSelection;
          return pending2.lineId === lineId && ((_a = pending2.colorObj) == null ? void 0 : _a.sku) === colorSku;
        };
      },
      // Check if Pantone is currently pending for a specific line
      isPendingPantone() {
        return (lineId, pantoneValue) => {
          const pending2 = this.pendingColorSelection;
          return pending2.lineId === lineId && pending2.customColor && pending2.color === pantoneValue;
        };
      },
      // NEW: Check if color is currently selected (applied) for a specific line
      isSelectedColor() {
        return (lineId, colorSku) => {
          var _a, _b;
          const line = (_a = this.currentImprint.textLines) == null ? void 0 : _a.find((l) => l.id === lineId);
          if (!line || line.customColor) return false;
          return ((_b = line.selectedColorObj) == null ? void 0 : _b.sku) === colorSku;
        };
      },
      // NEW: Check if Pantone is currently selected (applied) for a specific line
      isSelectedPantone() {
        return (lineId, pantoneValue) => {
          var _a;
          const line = (_a = this.currentImprint.textLines) == null ? void 0 : _a.find((l) => l.id === lineId);
          if (!line || !line.customColor) return false;
          return line.selectedColor === pantoneValue;
        };
      },
      // NEW: Get display name for color (pending or applied)
      getDisplayColorName() {
        return (line) => {
          if (this.pendingColorSelection.lineId === line.id) {
            if (this.pendingColorSelection.customColor) {
              return this.pendingColorSelection.color;
            } else if (this.pendingColorSelection.colorObj) {
              return this.pendingColorSelection.colorObj.desc;
            }
          }
          if (line.customColor && line.selectedColor) {
            return line.selectedColor;
          } else if (line.selectedColorObj) {
            return line.selectedColorObj.desc;
          }
          return `(${getColorName()} Name)`;
        };
      }
    },
    // REMOVED: watch imprintKey - causes conflicts with multiple imprints
    // Each component should use its own imprintKey prop directly
    // watch: {
    //   imprintKey: {
    //     immediate: true,
    //     handler(newKey) {
    //       if (newKey !== this.newImprintStore.currentImprintKey) {
    //         this.newImprintStore.switchToImprint(newKey);
    //       }
    //     }
    //   }
    // },
    watch: {
      // Auto-select single colour when an image line becomes available
      // (fires when user switches to Image Only or Text & Image)
      imageLineData(newVal) {
        if (newVal && !newVal.selectedColor) {
          this.$nextTick(() => {
            this.autoSelectIfSingleColor(newVal.id);
          });
        }
      }
    },
    methods: {
      handlePantoneInput(lineId, value) {
        this.pantoneInputs[lineId] = value;
      },
      // Check if Apply to All is active for specific line
      isApplyToAllActive(lineId) {
        var _a, _b;
        return ((_a = this.currentImprint.applyToAll) == null ? void 0 : _a.active) && ((_b = this.currentImprint.applyToAll) == null ? void 0 : _b.sourceLineId) === lineId;
      },
      // Imprint Method Selection
      handleImprintMethodSelected(method) {
        console.log("[StartNewImprintForm] Imprint method selected:", method);
        this.newImprintStore.setActiveImprintMethod(method.sku, this.imprintKey);
        this.$emit("method-changed", method);
      },
      // Location Selection
      handleLocationSelected(data) {
        var _a;
        console.log("[DEBUG handleLocationSelected] START - data:", data, "imprintKey:", this.imprintKey);
        if (!data || !data.sku) {
          console.log("[DEBUG handleLocationSelected] ABORT - No data or SKU");
          return;
        }
        const location2 = this.newImprintStore.availableLocations.find((loc) => loc.sku === data.sku);
        console.log("[DEBUG handleLocationSelected] Found location:", location2 == null ? void 0 : location2.title, "imprint_lines:", location2 == null ? void 0 : location2.imprint_lines);
        if (location2) {
          console.log("[DEBUG handleLocationSelected] Calling setLocation with imprintKey:", this.imprintKey);
          this.newImprintStore.setLocation(location2, this.imprintKey);
          console.log("[DEBUG handleLocationSelected] AFTER setLocation - textLines count:", (_a = this.currentImprint.textLines) == null ? void 0 : _a.length);
          this.$emit("location-changed", location2);
        } else {
          console.log("[DEBUG handleLocationSelected] ERROR - Location not found");
        }
      },
      // Message Type Selection
      selectMessageType(typeId, event2) {
        var _a, _b, _c, _d;
        console.log("%c[MSG-TYPE-CLICK] selectMessageType", "background: darkred; color: white; font-weight: bold", {
          typeId,
          imprintKey: this.imprintKey,
          currentMessageType: (_a = this.currentImprint) == null ? void 0 : _a.messageType,
          activeMethodSku: (_b = this.newImprintStore.imprints[this.imprintKey]) == null ? void 0 : _b.activeMethodSku,
          // isTrusted=true = real user click; isTrusted=false = programmatic/synthetic click
          isTrusted: event2 == null ? void 0 : event2.isTrusted,
          targetTag: (_c = event2 == null ? void 0 : event2.target) == null ? void 0 : _c.tagName,
          targetClass: (_d = event2 == null ? void 0 : event2.target) == null ? void 0 : _d.className
        });
        if (event2 && !event2.isTrusted) {
          console.error("%c[MSG-TYPE-CLICK] ⚠️ SYNTHETIC CLICK BLOCKED (isTrusted=false)", "background: red; color: white; font-size: 14px");
          return;
        }
        this.newImprintStore.setMessageType(typeId, this.imprintKey);
        this.$emit("message-type-changed", typeId);
      },
      // Text Line Management - Lines are auto-managed by setLocation() in store
      // addTextLine() and removeLine() removed - not needed on desktop (all lines shown automatically)
      handleLineTextChange(lineId, text) {
        this.newImprintStore.updateLineText(lineId, text, this.imprintKey);
        this.$emit("lines-changed", this.currentImprint.textLines);
      },
      // Color Selection - NEW FLOW with Add Colour button
      toggleColorPicker(lineId) {
        var _a, _b;
        console.log("[StartNewImprintForm] toggleColorPicker called:", {
          lineId,
          imprintKey: this.imprintKey,
          imprint: (_b = (_a = this.currentImprint) == null ? void 0 : _a.textLines) == null ? void 0 : _b.map((l) => ({ id: l.id, type: l.type, showColorPicker: l.showColorPicker }))
        });
        this.newImprintStore.toggleColorPicker(lineId, this.imprintKey);
      },
      // Select color and apply immediately (Add Colour button removed)
      selectPendingColor(lineId, color) {
        if (color.disabled) return;
        this.newImprintStore.selectPendingColor(lineId, color, false, this.imprintKey);
        this.applyPendingColor(lineId);
      },
      // Select Pantone and apply immediately (Add Colour button removed)
      selectPendingPantone(lineId, pantoneValue) {
        this.newImprintStore.selectPendingColor(lineId, pantoneValue, true, this.imprintKey);
        this.applyPendingColor(lineId);
      },
      // Apply pending color (triggered by Add Colour button)
      applyPendingColor(lineId) {
        this.newImprintStore.applyPendingColor(lineId, this.imprintKey);
        this.$emit("lines-changed", this.currentImprint.textLines);
      },
      // Submit new Pantone color (save to list)
      submitPantone(lineId) {
        const inputRef = this.$refs[`pantone_${lineId}`];
        if (!inputRef || !inputRef[0]) return;
        const pantoneValue = (this.pantoneInputs[lineId] || "").trim();
        if (!pantoneValue) {
          alert("Please enter a PANTONE number");
          return;
        }
        if (this.savedPantoneColors.includes(pantoneValue)) {
          alert(`PANTONE ${pantoneValue} already exists in your color list`);
          return;
        }
        this.newImprintStore.addSavedPantoneColor(pantoneValue, this.imprintKey);
        this.selectPendingPantone(lineId, pantoneValue);
        const successMsg = `✅ PANTONE ${pantoneValue} added to your color list ($50.00 fee)`;
        console.log(successMsg);
        this.pantoneInputs[lineId] = "";
        inputRef[0].value = "";
      },
      // Apply to All - FIXED: Now passes imprintKey explicitly
      handleApplyToAll(sourceLineId) {
        this.newImprintStore.toggleApplyToAll(sourceLineId, this.imprintKey);
        this.$emit("lines-changed", this.currentImprint.textLines);
      },
      // Open colour picker when user focuses a text line input — always, regardless of
      // whether a colour has already been selected. The colour swatch toggle is separate.
      handleTextLineFocus(lineId) {
        var _a, _b;
        const line = (_b = (_a = this.currentImprint) == null ? void 0 : _a.textLines) == null ? void 0 : _b.find((l) => l.id === lineId);
        if (!line) return;
        this.newImprintStore.openColorPicker(lineId, this.imprintKey);
        this.autoSelectIfSingleColor(lineId);
      },
      // Hide the colour picker when a click lands outside this line's own DOM
      setLineRef(lineId, el) {
        if (el) {
          this.lineRefs[lineId] = el;
        } else {
          delete this.lineRefs[lineId];
        }
      },
      handleDocumentClick(event2) {
        var _a;
        const lines = ((_a = this.currentImprint) == null ? void 0 : _a.textLines) || [];
        lines.forEach((line) => {
          if (!line.showColorPicker) return;
          const el = this.lineRefs[line.id];
          if (!el) return;
          const clickedInsideLine = el.contains(event2.target) && !event2.target.closest(".line-header");
          if (!clickedInsideLine) {
            line.showColorPicker = false;
          }
        });
      },
      // If only one colour is available for the given line and no colour selected yet,
      // select and apply it automatically so the user doesn't have to click.
      autoSelectIfSingleColor(lineId) {
        var _a, _b;
        const line = (_b = (_a = this.currentImprint) == null ? void 0 : _a.textLines) == null ? void 0 : _b.find((l) => l.id === lineId);
        if (!line || line.selectedColor) return;
        const colors = this.availableColorsForLine(line).filter((c) => !c.disabled);
        if (colors.length !== 1) return;
        const singleColor = colors[0];
        this.newImprintStore.selectPendingColor(lineId, singleColor, false, this.imprintKey);
        this.newImprintStore.applyPendingColor(lineId, this.imprintKey);
        this.$emit("lines-changed", this.currentImprint.textLines);
        console.log("[StartNewImprintForm] Auto-selected single colour for line", lineId, ":", singleColor.desc);
      },
      clearAndCloseColor(lineId) {
        var _a;
        const imprint = this.currentImprint;
        const line = imprint.textLines.find((l) => l.id === lineId);
        if (!line) return;
        const isSourceApplyToAll = imprint.applyToAll.active && imprint.applyToAll.sourceLineId === lineId;
        if (isSourceApplyToAll) {
          imprint.applyToAll.active = false;
          imprint.applyToAll.sourceLineId = null;
          imprint.textLines.forEach((l) => {
            l.selectedColor = null;
            l.selectedColorObj = null;
            l.customColor = false;
          });
        } else {
          line.selectedColor = null;
          line.selectedColorObj = null;
          line.customColor = false;
        }
        imprint.pendingColorSelection = {
          lineId: null,
          color: null,
          colorObj: null,
          customColor: false
        };
        line.showColorPicker = false;
        (_a = imprint.errors) == null ? true : delete _a[`line${lineId}_color`];
        this.newImprintStore.recalculateUniqueColors(this.imprintKey);
        this.$emit("lines-changed", imprint.textLines);
      },
      // Get available colors for a specific line
      // Takes into account max colors logic and removes duplicates
      availableColorsForLine(line) {
        const allColors = this.newImprintStore.availableColors;
        const uniqueColorsBySku = [];
        const seenSkus = /* @__PURE__ */ new Set();
        allColors.forEach((color) => {
          if (!seenSkus.has(color.sku)) {
            seenSkus.add(color.sku);
            uniqueColorsBySku.push(color);
          }
        });
        const maxColorsTracking = this.currentImprint.maxColorsTracking || {};
        const isMaxReached = maxColorsTracking.isMaxReached || false;
        const uniqueColors = maxColorsTracking.uniqueColors || [];
        if (!isMaxReached || line.selectedColor) {
          return uniqueColorsBySku.map((color) => ({ ...color, disabled: false }));
        }
        return uniqueColorsBySku.map((color) => ({
          ...color,
          disabled: !uniqueColors.includes(color.sku)
        }));
      },
      getColorImageUrl(fileName) {
        return `${this.colorCatalogBaseUrl}${fileName}.png`;
      },
      // Image Upload
      handleImageUploadSuccess(data) {
        var _a;
        const imageData = {
          ...data,
          filename: ((_a = data.file) == null ? void 0 : _a.name) || "uploaded_image"
        };
        this.newImprintStore.setImageData(imageData, this.imprintKey);
        this.$emit("image-uploaded", imageData);
      },
      handleImageUploadError(error) {
        console.error("[StartNewImprintForm] Image upload failed:", error);
      },
      handleImageRemoved() {
        this.newImprintStore.setImageData(null, this.imprintKey);
        this.$emit("image-removed");
      },
      // Special Instructions
      handleSpecialInstructionsChange(text) {
        this.newImprintStore.setSpecialInstructions(text, this.imprintKey);
        this.$emit("special-instructions-changed", text);
      },
      // Validation
      validate() {
        return this.newImprintStore.validate(this.imprintKey);
      },
      // Get form data for submission
      getData() {
        return this.newImprintStore.getImprintData(this.imprintKey);
      }
    },
    mounted() {
      var _a, _b;
      this.newImprintStore.initializeFromProductData();
      document.addEventListener("click", this.handleDocumentClick);
      this.$nextTick(() => {
        if (this.imageLineData && !this.imageLineData.selectedColor) {
          this.autoSelectIfSingleColor(this.imageLineData.id);
        }
      });
      console.log("[StartNewImprintForm] Mounted with Pinia stores:", {
        imprintStore: this.imprintStore,
        newImprintStore: this.newImprintStore,
        currentImprint: this.currentImprint,
        maxColors: (_b = (_a = this.newImprintStore.currentImprint) == null ? void 0 : _a.maxColorsTracking) == null ? void 0 : _b.maxColors
      });
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleDocumentClick);
    }
  };
  const _hoisted_1$i = { class: "start-new-imprint-form" };
  const _hoisted_2$b = {
    key: 0,
    class: "form-section"
  };
  const _hoisted_3$9 = { class: "message-type-buttons" };
  const _hoisted_4$8 = {
    key: 0,
    class: "text-lines-section"
  };
  const _hoisted_5$8 = {
    key: 0,
    class: "warning-message"
  };
  const _hoisted_6$8 = { class: "line-header" };
  const _hoisted_7$8 = { class: "line-label" };
  const _hoisted_8$7 = { class: "line-content" };
  const _hoisted_9$7 = { class: "color-column" };
  const _hoisted_10$7 = ["data-error-field", "onClick"];
  const _hoisted_11$7 = ["data-full-text"];
  const _hoisted_12$7 = {
    key: 2,
    class: "no-color-preview"
  };
  const _hoisted_13$7 = {
    key: 0,
    class: "color-name"
  };
  const _hoisted_14$6 = { class: "text-column" };
  const _hoisted_15$6 = ["value", "data-error-field", "onInput", "onFocus"];
  const _hoisted_16$6 = {
    key: 0,
    class: "color-picker-dropdown"
  };
  const _hoisted_17$5 = { class: "color-picker-right" };
  const _hoisted_18$5 = { class: "color-info-header" };
  const _hoisted_19$5 = { class: "color-info-name" };
  const _hoisted_20$5 = { class: "apply-to-all-lines" };
  const _hoisted_21$5 = ["checked", "disabled", "onChange"];
  const _hoisted_22$5 = { class: "imprint-colour-actions" };
  const _hoisted_23$3 = ["onClick"];
  const _hoisted_24$3 = { class: "color-picker-left" };
  const _hoisted_25$3 = { class: "color-grid" };
  const _hoisted_26$3 = ["title", "onClick"];
  const _hoisted_27$3 = { class: "custom-color-section" };
  const _hoisted_28$3 = { class: "custom-color-presets" };
  const _hoisted_29$3 = ["onClick"];
  const _hoisted_30$3 = ["onClick"];
  const _hoisted_31$2 = { class: "pantone-input-wrapper" };
  const _hoisted_32$2 = ["value", "onInput", "onKeyup"];
  const _hoisted_33$2 = ["disabled", "onClick"];
  const _hoisted_34$1 = { class: "pantone-fee" };
  const _hoisted_35$1 = {
    key: 1,
    class: "error-message"
  };
  const _hoisted_36$1 = {
    key: 2,
    class: "error-message"
  };
  const _hoisted_37$1 = ["data-error-field"];
  const _hoisted_38$1 = {
    key: 0,
    class: "image-color-section"
  };
  const _hoisted_39$1 = { class: "color-selector" };
  const _hoisted_40$1 = ["data-error-field"];
  const _hoisted_41$1 = {
    key: 1,
    class: "custom-color-preview"
  };
  const _hoisted_42$1 = {
    key: 2,
    class: "no-color-preview"
  };
  const _hoisted_43$1 = {
    key: 0,
    class: "color-name"
  };
  const _hoisted_44$1 = { class: "color-picker-dropdown" };
  const _hoisted_45$1 = { class: "color-picker-right" };
  const _hoisted_46$1 = { class: "color-info-header" };
  const _hoisted_47$1 = { class: "color-info-name" };
  const _hoisted_48$1 = { class: "imprint-colour-actions" };
  const _hoisted_49$1 = { class: "color-picker-left" };
  const _hoisted_50$1 = {
    key: 0,
    class: "no-colors-message"
  };
  const _hoisted_51$1 = {
    key: 1,
    class: "color-grid"
  };
  const _hoisted_52$1 = ["title", "onClick"];
  const _hoisted_53$1 = {
    key: 1,
    class: "form-section"
  };
  const _hoisted_54$1 = ["value"];
  function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e;
    const _component_ImprintMethodSelector = resolveComponent("ImprintMethodSelector");
    const _component_ImprintLocationSelector = resolveComponent("ImprintLocationSelector");
    const _component_BaseButton = resolveComponent("BaseButton");
    const _component_ArtworkUpload = resolveComponent("ArtworkUpload");
    return openBlock(), createElementBlock("div", _hoisted_1$i, [
      (openBlock(), createBlock(_component_ImprintMethodSelector, {
        key: `method-${$props.imprintKey}`,
        "initial-method": (_a = $setup.imprintStore.selectedImprintMethod) == null ? void 0 : _a.sku,
        "imprint-index": $props.imprintKey,
        onMethodSelected: $options.handleImprintMethodSelected
      }, null, 8, ["initial-method", "imprint-index", "onMethodSelected"])),
      (openBlock(), createBlock(_component_ImprintLocationSelector, {
        key: `location-${$props.imprintKey}`,
        label: "2. Choose a Location",
        "initial-location": (_c = (_b = $setup.newImprintStore.imprints[$props.imprintKey]) == null ? void 0 : _b.selectedLocation) == null ? void 0 : _c.sku,
        "imprint-key": $props.imprintKey,
        "auto-select-first": $props.imprintKey === 0,
        "show-help": true,
        "has-error": !!($options.currentImprint.errors && $options.currentImprint.errors.location),
        "error-message": (_d = $options.currentImprint.errors) == null ? void 0 : _d.location,
        onLocationSelected: $options.handleLocationSelected
      }, null, 8, ["initial-location", "imprint-key", "auto-select-first", "has-error", "error-message", "onLocationSelected"])),
      !$options.isEnvelopProduct ? (openBlock(), createElementBlock("div", _hoisted_2$b, [
        _cache[5] || (_cache[5] = createBaseVNode("label", { class: "section-label" }, "3. Add Your Imprint Message", -1)),
        createBaseVNode("div", _hoisted_3$9, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($data.messageTypes, (type) => {
            return openBlock(), createBlock(_component_BaseButton, {
              key: type.id,
              text: type.label,
              variant: $options.currentImprint.messageType === type.id ? "primary" : "secondary",
              size: "small",
              onClick: (e) => $options.selectMessageType(type.id, e)
            }, null, 8, ["text", "variant", "onClick"]);
          }), 128))
        ]),
        $options.shouldShowTextLines ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
          ((_e = $options.currentImprint.errors) == null ? void 0 : _e.maxLines) ? (openBlock(), createElementBlock("div", _hoisted_5$8, [
            createBaseVNode("p", null, toDisplayString($options.currentImprint.errors.maxLines), 1)
          ])) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.textLinesFiltered, (line, index) => {
            return openBlock(), createElementBlock("div", {
              key: `line-${$props.imprintKey}-${line.id}`,
              class: "text-line",
              ref_for: true,
              ref: (el) => $options.setLineRef(line.id, el)
            }, [
              createBaseVNode("div", _hoisted_6$8, [
                createBaseVNode("span", _hoisted_7$8, "Line " + toDisplayString(index + 1) + toDisplayString(index > 0 ? " (Optional)" : ""), 1)
              ]),
              createBaseVNode("div", _hoisted_8$7, [
                createBaseVNode("div", _hoisted_9$7, [
                  createBaseVNode("div", {
                    class: normalizeClass(["color-swatch", { "has-error": $options.currentImprint.errors && $options.currentImprint.errors[`line${line.id}_color`] }]),
                    "data-error-field": `imprint-${$props.imprintKey}-line-${index}-color`,
                    onClick: ($event) => $options.toggleColorPicker(line.id)
                  }, [
                    line.selectedColor && !line.customColor ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: "color-preview",
                      style: normalizeStyle({ backgroundImage: `url(${$options.getColorImageUrl(line.selectedColor)})` })
                    }, null, 4)) : line.customColor ? (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: "custom-color-preview",
                      "data-full-text": line.selectedColor
                    }, toDisplayString(line.selectedColor), 9, _hoisted_11$7)) : (openBlock(), createElementBlock("div", _hoisted_12$7))
                  ], 10, _hoisted_10$7),
                  line.selectedColorObj && !line.customColor ? (openBlock(), createElementBlock("span", _hoisted_13$7, toDisplayString(line.selectedColorObj.desc), 1)) : createCommentVNode("", true)
                ]),
                createBaseVNode("div", _hoisted_14$6, [
                  createBaseVNode("input", {
                    type: "text",
                    value: line.message,
                    class: normalizeClass({ "has-error": $options.currentImprint.errors && $options.currentImprint.errors[`line${line.id}_message`] }),
                    "data-error-field": `imprint-${$props.imprintKey}-line-${index}-text`,
                    placeholder: "Enter text",
                    onInput: ($event) => $options.handleLineTextChange(line.id, $event.target.value),
                    onFocus: ($event) => $options.handleTextLineFocus(line.id)
                  }, null, 42, _hoisted_15$6)
                ])
              ]),
              line.showColorPicker ? (openBlock(), createElementBlock("div", _hoisted_16$6, [
                createBaseVNode("div", _hoisted_17$5, [
                  createBaseVNode("div", _hoisted_18$5, "Line " + toDisplayString(index + 1) + " Imprint " + toDisplayString($options.getColorNameText), 1),
                  createBaseVNode("div", _hoisted_19$5, toDisplayString($options.getDisplayColorName(line)), 1),
                  createBaseVNode("div", _hoisted_20$5, [
                    createBaseVNode("label", null, [
                      createBaseVNode("input", {
                        type: "checkbox",
                        checked: $options.isApplyToAllActive(line.id),
                        disabled: !line.selectedColor && !$options.isApplyToAllActive(line.id) || $options.currentImprint.applyToAll.active && $options.currentImprint.applyToAll.sourceLineId !== line.id,
                        onChange: ($event) => $options.handleApplyToAll(line.id)
                      }, null, 40, _hoisted_21$5),
                      _cache[3] || (_cache[3] = createTextVNode(" Apply to all lines ", -1))
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_22$5, [
                    createBaseVNode("a", {
                      class: "btn-clear-colour",
                      onClick: ($event) => $options.clearAndCloseColor(line.id)
                    }, " Clear & Close ", 8, _hoisted_23$3)
                  ])
                ]),
                createBaseVNode("div", _hoisted_24$3, [
                  createBaseVNode("div", _hoisted_25$3, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($options.availableColorsForLine(line), (color) => {
                      return openBlock(), createElementBlock("button", {
                        key: color.sku,
                        class: normalizeClass(["color-option", {
                          "is-pending": $options.isPendingColor(line.id, color.sku),
                          "is-selected": $options.isSelectedColor(line.id, color.sku),
                          "is-disabled": color.disabled
                        }]),
                        style: normalizeStyle({ backgroundImage: `url(${$options.getColorImageUrl(color.file_name)})` }),
                        title: color.disabled ? `${color.desc} (max colours reached)` : color.desc,
                        onClick: ($event) => $options.selectPendingColor(line.id, color)
                      }, null, 14, _hoisted_26$3);
                    }), 128))
                  ]),
                  _cache[4] || (_cache[4] = createBaseVNode("div", { class: "color-divider" }, "— or —", -1)),
                  createBaseVNode("div", _hoisted_27$3, [
                    createBaseVNode("div", _hoisted_28$3, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList($data.customColorPresets, (preset) => {
                        return openBlock(), createElementBlock("button", {
                          key: preset,
                          class: normalizeClass(["custom-color-preset", {
                            "is-pending": $options.isPendingPantone(line.id, preset),
                            "is-selected": $options.isSelectedPantone(line.id, preset)
                          }]),
                          onClick: ($event) => $options.selectPendingPantone(line.id, preset)
                        }, toDisplayString(preset), 11, _hoisted_29$3);
                      }), 128)),
                      (openBlock(true), createElementBlock(Fragment, null, renderList($options.savedPantoneColors, (pantone) => {
                        return openBlock(), createElementBlock("button", {
                          key: pantone,
                          class: normalizeClass(["custom-color-preset", {
                            "is-pending": $options.isPendingPantone(line.id, pantone),
                            "is-selected": $options.isSelectedPantone(line.id, pantone)
                          }]),
                          onClick: ($event) => $options.selectPendingPantone(line.id, pantone)
                        }, toDisplayString(pantone), 11, _hoisted_30$3);
                      }), 128))
                    ]),
                    createBaseVNode("div", _hoisted_31$2, [
                      createBaseVNode("input", {
                        type: "text",
                        ref_for: true,
                        ref: `pantone_${line.id}`,
                        placeholder: "Enter PANTONE© name",
                        class: "pantone-input",
                        value: $data.pantoneInputs[line.id] || "",
                        onInput: ($event) => $options.handlePantoneInput(line.id, $event.target.value),
                        onKeyup: withKeys(($event) => $options.submitPantone(line.id), ["enter"])
                      }, null, 40, _hoisted_32$2),
                      createBaseVNode("button", {
                        class: "pantone-submit-btn",
                        disabled: !($data.pantoneInputs[line.id] || "").trim(),
                        onClick: ($event) => $options.submitPantone(line.id)
                      }, " submit ", 8, _hoisted_33$2)
                    ]),
                    createBaseVNode("div", _hoisted_34$1, "$" + toDisplayString($setup.newImprintStore.customColorFee.toFixed(2)), 1)
                  ])
                ])
              ])) : createCommentVNode("", true),
              $options.currentImprint.errors && $options.currentImprint.errors[`line${line.id}_color`] ? (openBlock(), createElementBlock("p", _hoisted_35$1, toDisplayString($options.currentImprint.errors[`line${line.id}_color`]), 1)) : createCommentVNode("", true),
              $options.currentImprint.errors && $options.currentImprint.errors[`line${line.id}_message`] ? (openBlock(), createElementBlock("p", _hoisted_36$1, toDisplayString($options.currentImprint.errors[`line${line.id}_message`]), 1)) : createCommentVNode("", true)
            ]);
          }), 128))
        ])) : createCommentVNode("", true),
        withDirectives(createBaseVNode("div", {
          class: normalizeClass(["image-upload-section", { "has-error": $options.currentImprint.errors && $options.currentImprint.errors.image }]),
          "data-error-field": `imprint-${$props.imprintKey}-image-upload`
        }, [
          createVNode(_component_ArtworkUpload, {
            "initial-image-data": $options.currentImprint.imageData,
            onUploadSuccess: $options.handleImageUploadSuccess,
            onUploadError: $options.handleImageUploadError,
            onFileRemoved: $options.handleImageRemoved
          }, null, 8, ["initial-image-data", "onUploadSuccess", "onUploadError", "onFileRemoved"]),
          $options.imageLineData && ($options.currentImprint.messageType === "text_image" || $options.currentImprint.messageType === "image") ? (openBlock(), createElementBlock("div", _hoisted_38$1, [
            createBaseVNode("label", null, "Image " + toDisplayString($options.getColorNameText), 1),
            createBaseVNode("div", _hoisted_39$1, [
              createBaseVNode("button", {
                type: "button",
                class: normalizeClass(["color-swatch image-color-swatch", { "has-error": $options.currentImprint.errors && $options.currentImprint.errors.imageColor }]),
                "data-error-field": `imprint-${$props.imprintKey}-image-color`,
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $options.toggleColorPicker($options.imageLineData.id), ["prevent"]))
              }, [
                $options.imageLineData.selectedColor && !$options.imageLineData.customColor ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "color-preview",
                  style: normalizeStyle({ backgroundImage: `url(${$options.getColorImageUrl($options.imageLineData.selectedColor)})` })
                }, null, 4)) : $options.imageLineData.customColor ? (openBlock(), createElementBlock("div", _hoisted_41$1, toDisplayString($options.imageLineData.selectedColor), 1)) : (openBlock(), createElementBlock("div", _hoisted_42$1))
              ], 10, _hoisted_40$1),
              $options.imageLineData.selectedColorObj && !$options.imageLineData.customColor ? (openBlock(), createElementBlock("span", _hoisted_43$1, toDisplayString($options.imageLineData.selectedColorObj.desc), 1)) : createCommentVNode("", true)
            ]),
            createBaseVNode("div", _hoisted_44$1, [
              createBaseVNode("div", _hoisted_45$1, [
                createBaseVNode("div", _hoisted_46$1, "Image Imprint " + toDisplayString($options.getColorNameText), 1),
                createBaseVNode("div", _hoisted_47$1, toDisplayString($options.getDisplayColorName($options.imageLineData)), 1),
                createBaseVNode("div", _hoisted_48$1, [
                  createBaseVNode("a", {
                    class: "btn-clear-colour",
                    onClick: _cache[1] || (_cache[1] = ($event) => $options.clearAndCloseColor($options.imageLineData.id))
                  }, " Clear Selection ")
                ])
              ]),
              createBaseVNode("div", _hoisted_49$1, [
                $options.availableColorsForLine($options.imageLineData).length === 0 ? (openBlock(), createElementBlock("div", _hoisted_50$1, " No colours available. Please select an imprint location first. ")) : (openBlock(), createElementBlock("div", _hoisted_51$1, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($options.availableColorsForLine($options.imageLineData), (color) => {
                    return openBlock(), createElementBlock("button", {
                      key: color.sku,
                      class: normalizeClass(["color-option", {
                        "is-pending": $options.isPendingColor($options.imageLineData.id, color.sku),
                        "is-selected": $options.isSelectedColor($options.imageLineData.id, color.sku),
                        "is-disabled": color.disabled
                      }]),
                      style: normalizeStyle({ backgroundImage: `url(${$options.getColorImageUrl(color.file_name)})` }),
                      title: color.disabled ? `${color.desc} (max colours reached)` : color.desc,
                      onClick: ($event) => $options.selectPendingColor($options.imageLineData.id, color)
                    }, null, 14, _hoisted_52$1);
                  }), 128))
                ]))
              ])
            ])
          ])) : createCommentVNode("", true)
        ], 10, _hoisted_37$1), [
          [vShow, $options.shouldShowImageUpload]
        ])
      ])) : createCommentVNode("", true),
      $setup.debugConfig.showSpecialInstructionsStep2 ? (openBlock(), createElementBlock("div", _hoisted_53$1, [
        _cache[6] || (_cache[6] = createBaseVNode("label", { class: "section-label" }, "Special Instructions", -1)),
        createBaseVNode("textarea", {
          value: $options.currentImprint.specialInstructions,
          rows: "5",
          placeholder: "Enter any special instructions here...",
          onInput: _cache[2] || (_cache[2] = ($event) => $options.handleSpecialInstructionsChange($event.target.value))
        }, null, 40, _hoisted_54$1)
      ])) : createCommentVNode("", true)
    ]);
  }
  const StartNewImprintForm = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$h], ["__scopeId", "data-v-86d08613"]]);
  const _sfc_main$h = {
    name: "AddImprintLocationButton",
    computed: {
      hasAdditionalLocationFeeData() {
        return useImprintStore().hasAdditionalLocationFeeData;
      }
    },
    methods: {
      handleClick() {
        if (!this.hasAdditionalLocationFeeData) return;
        this.$emit("add-imprint");
      }
    }
  };
  const _hoisted_1$h = { class: "button-container" };
  const _hoisted_2$a = ["disabled", "title"];
  function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$h, [
      createBaseVNode("button", {
        class: "add-imprint-btn",
        disabled: !$options.hasAdditionalLocationFeeData,
        title: !$options.hasAdditionalLocationFeeData ? "Additional location pricing is not available for this product" : "",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
      }, " + Add Another Imprint Location ", 8, _hoisted_2$a)
    ]);
  }
  const AddImprintLocationButton = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$g], ["__scopeId", "data-v-57dbe14b"]]);
  const _sfc_main$g = {
    name: "StateDebuggerNewImprint",
    setup() {
      const newImprintStore = useNewImprintStore();
      const imprintStore = useImprintStore();
      const isExpanded = /* @__PURE__ */ ref(false);
      const currentImprint = computed(() => newImprintStore.currentImprint);
      const maxColorsTracking = computed(
        () => newImprintStore.maxColorsTracking[newImprintStore.currentImprintKey]
      );
      const uniqueColorsCount = computed(
        () => newImprintStore.currentUniqueColorsCount
      );
      const availableLocations = computed(() => newImprintStore.availableLocations);
      const availableColors = computed(() => newImprintStore.availableColors);
      const exportData = computed(() => newImprintStore.getImprintData());
      const toggleExpanded = () => {
        isExpanded.value = !isExpanded.value;
      };
      const testValidation = () => {
        var _a;
        const isValid = newImprintStore.validate();
        console.log("[StateDebugger] Validation result:", isValid);
        console.log("[StateDebugger] Validation errors:", (_a = currentImprint.value) == null ? void 0 : _a.errors);
      };
      const testAddLine = () => {
        if (newImprintStore.canAddLine) {
          newImprintStore.addTextLine();
          console.log("[StateDebugger] Line added");
        } else {
          console.log("[StateDebugger] Cannot add line - max lines reached");
        }
      };
      const testResetImprint = () => {
        if (confirm("Reset current imprint?")) {
          newImprintStore.resetCurrentImprint();
          console.log("[StateDebugger] Imprint reset");
        }
      };
      return {
        newImprintStore,
        imprintStore,
        isExpanded,
        currentImprint,
        maxColorsTracking,
        uniqueColorsCount,
        availableLocations,
        availableColors,
        exportData,
        toggleExpanded,
        testValidation,
        testAddLine,
        testResetImprint
      };
    }
  };
  const _hoisted_1$g = { class: "state-debugger" };
  const _hoisted_2$9 = { class: "toggle-icon" };
  const _hoisted_3$8 = {
    key: 0,
    class: "debugger-content"
  };
  const _hoisted_4$7 = { class: "debug-section" };
  const _hoisted_5$7 = { class: "debug-section" };
  const _hoisted_6$7 = { class: "debug-section" };
  const _hoisted_7$7 = { class: "debug-subsection" };
  const _hoisted_8$6 = { class: "debug-subsection" };
  const _hoisted_9$6 = { class: "debug-subsection" };
  const _hoisted_10$6 = { class: "debug-subsection" };
  const _hoisted_11$6 = { class: "debug-subsection" };
  const _hoisted_12$6 = { class: "debug-subsection" };
  const _hoisted_13$6 = { class: "debug-subsection" };
  const _hoisted_14$5 = { class: "debug-section" };
  const _hoisted_15$5 = { class: "debug-section" };
  const _hoisted_16$5 = { class: "debug-subsection" };
  const _hoisted_17$4 = { class: "debug-subsection" };
  const _hoisted_18$4 = { class: "debug-subsection" };
  const _hoisted_19$4 = { class: "debug-subsection" };
  const _hoisted_20$4 = { class: "debug-section" };
  const _hoisted_21$4 = { class: "debug-section" };
  const _hoisted_22$4 = { class: "debug-section" };
  const _hoisted_23$2 = { class: "debug-section" };
  const _hoisted_24$2 = { class: "debug-section" };
  const _hoisted_25$2 = { class: "debug-section" };
  const _hoisted_26$2 = { class: "debug-subsection" };
  const _hoisted_27$2 = { class: "debug-subsection" };
  const _hoisted_28$2 = { class: "debug-subsection" };
  const _hoisted_29$2 = { class: "debug-section" };
  const _hoisted_30$2 = { class: "debug-section actions" };
  function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    return openBlock(), createElementBlock("div", _hoisted_1$g, [
      createBaseVNode("div", {
        class: "debugger-header",
        onClick: _cache[0] || (_cache[0] = (...args) => $setup.toggleExpanded && $setup.toggleExpanded(...args))
      }, [
        _cache[4] || (_cache[4] = createBaseVNode("h3", null, "🔍 State Debugger - New Imprint", -1)),
        createBaseVNode("span", _hoisted_2$9, toDisplayString($setup.isExpanded ? "−" : "+"), 1)
      ]),
      $setup.isExpanded ? (openBlock(), createElementBlock("div", _hoisted_3$8, [
        createBaseVNode("section", _hoisted_4$7, [
          _cache[5] || (_cache[5] = createBaseVNode("h4", null, "Current Imprint Key", -1)),
          createBaseVNode("pre", null, toDisplayString($setup.newImprintStore.currentImprintKey), 1)
        ]),
        createBaseVNode("section", _hoisted_5$7, [
          _cache[6] || (_cache[6] = createBaseVNode("h4", null, "Total Imprints", -1)),
          createBaseVNode("pre", null, toDisplayString($setup.newImprintStore.imprints.length), 1)
        ]),
        createBaseVNode("section", _hoisted_6$7, [
          _cache[13] || (_cache[13] = createBaseVNode("h4", null, "Current Imprint Data", -1)),
          createBaseVNode("div", _hoisted_7$7, [
            _cache[7] || (_cache[7] = createBaseVNode("strong", null, "Location:", -1)),
            createBaseVNode("pre", null, toDisplayString(JSON.stringify((_a = $setup.currentImprint) == null ? void 0 : _a.selectedLocation, null, 2)), 1)
          ]),
          createBaseVNode("div", _hoisted_8$6, [
            _cache[8] || (_cache[8] = createBaseVNode("strong", null, "Message Type:", -1)),
            createBaseVNode("pre", null, toDisplayString((_b = $setup.currentImprint) == null ? void 0 : _b.messageType), 1)
          ]),
          createBaseVNode("div", _hoisted_9$6, [
            _cache[9] || (_cache[9] = createBaseVNode("strong", null, "Max Lines:", -1)),
            createBaseVNode("pre", null, toDisplayString((_c = $setup.currentImprint) == null ? void 0 : _c.maxLines), 1)
          ]),
          createBaseVNode("div", _hoisted_10$6, [
            createBaseVNode("strong", null, "Text Lines (" + toDisplayString(((_e = (_d = $setup.currentImprint) == null ? void 0 : _d.textLines) == null ? void 0 : _e.length) || 0) + "):", 1),
            createBaseVNode("pre", null, toDisplayString(JSON.stringify((_f = $setup.currentImprint) == null ? void 0 : _f.textLines, null, 2)), 1)
          ]),
          createBaseVNode("div", _hoisted_11$6, [
            _cache[10] || (_cache[10] = createBaseVNode("strong", null, "Image Data:", -1)),
            createBaseVNode("pre", null, toDisplayString(JSON.stringify((_g = $setup.currentImprint) == null ? void 0 : _g.imageData, null, 2)), 1)
          ]),
          createBaseVNode("div", _hoisted_12$6, [
            _cache[11] || (_cache[11] = createBaseVNode("strong", null, "Special Instructions:", -1)),
            createBaseVNode("pre", null, toDisplayString(((_h = $setup.currentImprint) == null ? void 0 : _h.specialInstructions) || "(empty)"), 1)
          ]),
          createBaseVNode("div", _hoisted_13$6, [
            _cache[12] || (_cache[12] = createBaseVNode("strong", null, "Errors:", -1)),
            createBaseVNode("pre", null, toDisplayString(JSON.stringify((_i = $setup.currentImprint) == null ? void 0 : _i.errors, null, 2)), 1)
          ])
        ]),
        createBaseVNode("section", _hoisted_14$5, [
          _cache[14] || (_cache[14] = createBaseVNode("h4", null, "Apply to All State", -1)),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($setup.newImprintStore.applyToAll, null, 2)), 1)
        ]),
        createBaseVNode("section", _hoisted_15$5, [
          _cache[19] || (_cache[19] = createBaseVNode("h4", null, "Max Colors Tracking (Current Imprint)", -1)),
          createBaseVNode("div", _hoisted_16$5, [
            _cache[15] || (_cache[15] = createBaseVNode("strong", null, "Unique Colors Count:", -1)),
            createBaseVNode("pre", null, toDisplayString($setup.uniqueColorsCount), 1)
          ]),
          createBaseVNode("div", _hoisted_17$4, [
            _cache[16] || (_cache[16] = createBaseVNode("strong", null, "Max Colors Allowed:", -1)),
            createBaseVNode("pre", null, toDisplayString(((_j = $setup.maxColorsTracking) == null ? void 0 : _j.maxColors) || "N/A"), 1)
          ]),
          createBaseVNode("div", _hoisted_18$4, [
            _cache[17] || (_cache[17] = createBaseVNode("strong", null, "Is Max Reached:", -1)),
            createBaseVNode("pre", null, toDisplayString((_k = $setup.maxColorsTracking) == null ? void 0 : _k.isMaxReached), 1)
          ]),
          createBaseVNode("div", _hoisted_19$4, [
            _cache[18] || (_cache[18] = createBaseVNode("strong", null, "Unique Color SKUs:", -1)),
            createBaseVNode("pre", null, toDisplayString(JSON.stringify((_l = $setup.maxColorsTracking) == null ? void 0 : _l.uniqueColors, null, 2)), 1)
          ])
        ]),
        createBaseVNode("section", _hoisted_20$4, [
          _cache[20] || (_cache[20] = createBaseVNode("h4", null, "All Imprints Array", -1)),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($setup.newImprintStore.imprints, null, 2)), 1)
        ]),
        createBaseVNode("section", _hoisted_21$4, [
          _cache[21] || (_cache[21] = createBaseVNode("h4", null, "Selected Imprint Method (from useImprintStore)", -1)),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($setup.imprintStore.selectedImprintMethod, null, 2)), 1)
        ]),
        createBaseVNode("section", _hoisted_22$4, [
          _cache[22] || (_cache[22] = createBaseVNode("h4", null, "Selected Artwork Method (from useImprintStore)", -1)),
          createBaseVNode("pre", null, toDisplayString($setup.imprintStore.selectedArtworkMethod || "Not selected"), 1)
        ]),
        createBaseVNode("section", _hoisted_23$2, [
          createBaseVNode("h4", null, "Available Locations (" + toDisplayString(((_m = $setup.availableLocations) == null ? void 0 : _m.length) || 0) + ")", 1),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($setup.availableLocations, null, 2)), 1)
        ]),
        createBaseVNode("section", _hoisted_24$2, [
          createBaseVNode("h4", null, "Available Colors (" + toDisplayString(((_n = $setup.availableColors) == null ? void 0 : _n.length) || 0) + ")", 1),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify((_o = $setup.availableColors) == null ? void 0 : _o.slice(0, 5), null, 2)) + toDisplayString(((_p = $setup.availableColors) == null ? void 0 : _p.length) > 5 ? "\n... and " + ($setup.availableColors.length - 5) + " more" : ""), 1)
        ]),
        createBaseVNode("section", _hoisted_25$2, [
          _cache[26] || (_cache[26] = createBaseVNode("h4", null, "Computed Getters", -1)),
          createBaseVNode("div", _hoisted_26$2, [
            _cache[23] || (_cache[23] = createBaseVNode("strong", null, "Can Add Line:", -1)),
            createBaseVNode("pre", null, toDisplayString($setup.newImprintStore.canAddLine), 1)
          ]),
          createBaseVNode("div", _hoisted_27$2, [
            _cache[24] || (_cache[24] = createBaseVNode("strong", null, "Has Image Line:", -1)),
            createBaseVNode("pre", null, toDisplayString($setup.newImprintStore.hasImageLine), 1)
          ]),
          createBaseVNode("div", _hoisted_28$2, [
            _cache[25] || (_cache[25] = createBaseVNode("strong", null, "Custom Color Fee:", -1)),
            createBaseVNode("pre", null, toDisplayString($setup.newImprintStore.customColorFee), 1)
          ])
        ]),
        createBaseVNode("section", _hoisted_29$2, [
          _cache[27] || (_cache[27] = createBaseVNode("h4", null, "Export Data (getImprintData())", -1)),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($setup.exportData, null, 2)), 1)
        ]),
        createBaseVNode("section", _hoisted_30$2, [
          _cache[28] || (_cache[28] = createBaseVNode("h4", null, "Debug Actions", -1)),
          createBaseVNode("button", {
            onClick: _cache[1] || (_cache[1] = (...args) => $setup.testValidation && $setup.testValidation(...args))
          }, "Test Validation"),
          createBaseVNode("button", {
            onClick: _cache[2] || (_cache[2] = (...args) => $setup.testAddLine && $setup.testAddLine(...args))
          }, "Add Line"),
          createBaseVNode("button", {
            onClick: _cache[3] || (_cache[3] = (...args) => $setup.testResetImprint && $setup.testResetImprint(...args))
          }, "Reset Imprint")
        ])
      ])) : createCommentVNode("", true)
    ]);
  }
  const StateDebuggerNewImprint = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$f], ["__scopeId", "data-v-f05a789a"]]);
  const _sfc_main$f = {
    name: "CartPayloadTester",
    data() {
      return {
        selectedMethod: "new",
        currentPayload: null,
        error: null,
        stats: null
      };
    },
    setup() {
      const newImprintStore = useNewImprintStore();
      const imprintStore = useImprintStore();
      return {
        newImprintStore,
        imprintStore
      };
    },
    methods: {
      /**
       * Generate payload based on selected method
       */
      generatePayload() {
        this.error = null;
        this.currentPayload = null;
        this.stats = null;
        try {
          let payload;
          if (this.selectedMethod === "new") {
            payload = this.newImprintStore.transformToCartPayload();
            if (payload) {
              const imprint = this.newImprintStore.currentImprint;
              this.stats = {
                method: "Start New Imprint",
                uniqueColors: imprint.maxColorsTracking.uniqueColors.length,
                hasCustomColor: imprint.textLines.some((l) => l.customColor),
                setupFee: payload.properties._price_details.setup_fee,
                runningFee: payload.properties._price_details.running_fee,
                customColorFee: payload.properties._price_details.customColourFee,
                totalFees: payload.properties._price_details.setup_fee + payload.properties._price_details.running_fee + payload.properties._price_details.customColourFee + payload.properties._price_details.proof_fee
              };
            }
          } else if (this.selectedMethod === "send") {
            const parent = this.getParentComponent();
            if (parent && typeof parent.transformSendArtworkToCart === "function") {
              payload = parent.transformSendArtworkToCart();
            } else {
              payload = this.createMockSendArtworkPayload();
            }
            if (payload) {
              this.stats = {
                method: "Send Us Your Artwork",
                uniqueColors: 0,
                hasCustomColor: false,
                setupFee: payload.properties._price_details.setup_fee,
                runningFee: payload.properties._price_details.running_fee,
                customColorFee: payload.properties._price_details.customColourFee,
                totalFees: payload.properties._price_details.setup_fee + payload.properties._price_details.proof_fee
              };
            }
          } else if (this.selectedMethod === "previous") {
            const parent = this.getParentComponent();
            if (parent && typeof parent.transformPreviousArtworkToCart === "function") {
              payload = parent.transformPreviousArtworkToCart();
            } else {
              payload = this.createMockPreviousArtworkPayload();
            }
            if (payload) {
              this.stats = {
                method: "Use My Previous Artwork",
                uniqueColors: 0,
                hasCustomColor: false,
                setupFee: payload.properties._price_details.setup_fee,
                runningFee: payload.properties._price_details.running_fee,
                customColorFee: payload.properties._price_details.customColourFee,
                totalFees: payload.properties._price_details.setup_fee + payload.properties._price_details.proof_fee
              };
            }
          }
          if (!payload) {
            this.error = "No payload generated. Make sure to fill in required fields first.";
            return;
          }
          this.currentPayload = payload;
          console.log("[CartPayloadTester] Generated payload:", payload);
        } catch (err) {
          this.error = err.message;
          console.error("[CartPayloadTester] Error:", err);
        }
      },
      /**
       * Get parent component (CustomizeProductSection)
       */
      getParentComponent() {
        let parent = this.$parent;
        while (parent) {
          if (parent.$options.name === "CustomizeProductSection") {
            return parent;
          }
          parent = parent.$parent;
        }
        return null;
      },
      /**
       * Create mock Send Artwork payload for testing
       */
      createMockSendArtworkPayload() {
        return {
          imprint_lines: {},
          properties: {
            "Imprint location": "FULL FRONT, 8″W X 13″H",
            "_Imprint Location SKU": "IMP_LOC_FF",
            "Imprint Method": "Screenprint",
            "_Imprint Method SKU": "G640_SCRE",
            "Special Instruction": "Send Us Your Artwork After Ordering. \r\n\r\nComment: Test comment",
            "_price_details": {
              setup_fee: 30,
              proof_fee: 5,
              image_fee: 0,
              customColourFee: 0,
              running_fee: 0
            }
          }
        };
      },
      /**
       * Create mock Previous Artwork payload for testing
       */
      createMockPreviousArtworkPayload() {
        return {
          imprint_lines: {},
          properties: {
            "Imprint location": "LEFT SLEEVE, 3.5″W X 3.5″H",
            "_Imprint Location SKU": "IMP_LOC_LS",
            "Imprint Method": "Embroidered",
            "_Imprint Method SKU": "G640_EMBR",
            "Special Instruction": "Use My Previous Artwork.\r\n\r\nComment: Test comment",
            "_Previous Artwork ID": "ARTWORK_123",
            "_Reference Order": "#ORD12345",
            "_price_details": {
              setup_fee: 0,
              proof_fee: 0,
              image_fee: 0,
              customColourFee: 0,
              running_fee: 0
            }
          }
        };
      },
      /**
       * Update payload when method changes
       */
      updatePayload() {
        this.currentPayload = null;
        this.error = null;
        this.stats = null;
      },
      /**
       * Copy payload to clipboard
       */
      async copyToClipboard() {
        if (!this.currentPayload) return;
        try {
          const text = JSON.stringify(this.currentPayload, null, 2);
          await navigator.clipboard.writeText(text);
          alert("Payload copied to clipboard!");
        } catch (err) {
          console.error("Failed to copy:", err);
          alert("Failed to copy to clipboard");
        }
      }
    },
    mounted() {
      console.log("[CartPayloadTester] Mounted");
      console.log("[CartPayloadTester] Available stores:", {
        newImprintStore: !!this.newImprintStore,
        imprintStore: !!this.imprintStore
      });
    }
  };
  const _hoisted_1$f = { class: "cart-payload-tester" };
  const _hoisted_2$8 = { class: "method-selector" };
  const _hoisted_3$7 = { class: "action-buttons" };
  const _hoisted_4$6 = ["disabled"];
  const _hoisted_5$6 = {
    key: 0,
    class: "payload-display"
  };
  const _hoisted_6$6 = { class: "section" };
  const _hoisted_7$6 = { class: "section" };
  const _hoisted_8$5 = { class: "properties-table" };
  const _hoisted_9$5 = { class: "property-key" };
  const _hoisted_10$5 = { class: "property-value" };
  const _hoisted_11$5 = { key: 0 };
  const _hoisted_12$5 = { key: 1 };
  const _hoisted_13$5 = { class: "section" };
  const _hoisted_14$4 = { class: "json-display" };
  const _hoisted_15$4 = {
    key: 1,
    class: "error-message"
  };
  const _hoisted_16$4 = {
    key: 2,
    class: "stats"
  };
  function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$f, [
      _cache[19] || (_cache[19] = createBaseVNode("div", { class: "tester-header" }, [
        createBaseVNode("h2", null, "🧪 Cart Payload Tester"),
        createBaseVNode("p", null, "Test transform methods and view generated properties")
      ], -1)),
      createBaseVNode("div", _hoisted_2$8, [
        _cache[5] || (_cache[5] = createBaseVNode("label", null, "Select Artwork Method:", -1)),
        withDirectives(createBaseVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.selectedMethod = $event),
          onChange: _cache[1] || (_cache[1] = (...args) => $options.updatePayload && $options.updatePayload(...args))
        }, [..._cache[4] || (_cache[4] = [
          createBaseVNode("option", { value: "new" }, "Start New Imprint", -1),
          createBaseVNode("option", { value: "send" }, "Send Us Your Artwork", -1),
          createBaseVNode("option", { value: "previous" }, "Use My Previous Artwork", -1)
        ])], 544), [
          [vModelSelect, $data.selectedMethod]
        ])
      ]),
      createBaseVNode("div", _hoisted_3$7, [
        createBaseVNode("button", {
          onClick: _cache[2] || (_cache[2] = (...args) => $options.generatePayload && $options.generatePayload(...args)),
          class: "btn-generate"
        }, " Generate Payload "),
        createBaseVNode("button", {
          onClick: _cache[3] || (_cache[3] = (...args) => $options.copyToClipboard && $options.copyToClipboard(...args)),
          class: "btn-copy",
          disabled: !$data.currentPayload
        }, " 📋 Copy JSON ", 8, _hoisted_4$6)
      ]),
      $data.currentPayload ? (openBlock(), createElementBlock("div", _hoisted_5$6, [
        createBaseVNode("div", _hoisted_6$6, [
          _cache[6] || (_cache[6] = createBaseVNode("h3", null, "📝 imprint_lines", -1)),
          createBaseVNode("pre", null, toDisplayString(JSON.stringify($data.currentPayload.imprint_lines, null, 2)), 1)
        ]),
        createBaseVNode("div", _hoisted_7$6, [
          _cache[8] || (_cache[8] = createBaseVNode("h3", null, "🏷️ properties", -1)),
          createBaseVNode("div", _hoisted_8$5, [
            createBaseVNode("table", null, [
              _cache[7] || (_cache[7] = createBaseVNode("thead", null, [
                createBaseVNode("tr", null, [
                  createBaseVNode("th", null, "Property Name"),
                  createBaseVNode("th", null, "Value")
                ])
              ], -1)),
              createBaseVNode("tbody", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList($data.currentPayload.properties, (value, key) => {
                  return openBlock(), createElementBlock("tr", { key }, [
                    createBaseVNode("td", _hoisted_9$5, toDisplayString(key), 1),
                    createBaseVNode("td", _hoisted_10$5, [
                      typeof value === "object" ? (openBlock(), createElementBlock("span", _hoisted_11$5, [
                        createBaseVNode("pre", null, toDisplayString(JSON.stringify(value, null, 2)), 1)
                      ])) : (openBlock(), createElementBlock("span", _hoisted_12$5, toDisplayString(value), 1))
                    ])
                  ]);
                }), 128))
              ])
            ])
          ])
        ]),
        createBaseVNode("div", _hoisted_13$5, [
          _cache[9] || (_cache[9] = createBaseVNode("h3", null, "📦 Complete Payload JSON", -1)),
          createBaseVNode("pre", _hoisted_14$4, toDisplayString(JSON.stringify($data.currentPayload, null, 2)), 1)
        ])
      ])) : createCommentVNode("", true),
      $data.error ? (openBlock(), createElementBlock("div", _hoisted_15$4, [
        _cache[10] || (_cache[10] = createBaseVNode("strong", null, "Error:", -1)),
        createTextVNode(" " + toDisplayString($data.error), 1)
      ])) : createCommentVNode("", true),
      $data.stats ? (openBlock(), createElementBlock("div", _hoisted_16$4, [
        _cache[18] || (_cache[18] = createBaseVNode("h3", null, "📊 Stats", -1)),
        createBaseVNode("ul", null, [
          createBaseVNode("li", null, [
            _cache[11] || (_cache[11] = createBaseVNode("strong", null, "Method:", -1)),
            createTextVNode(" " + toDisplayString($data.stats.method), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[12] || (_cache[12] = createBaseVNode("strong", null, "Unique Colors:", -1)),
            createTextVNode(" " + toDisplayString($data.stats.uniqueColors), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[13] || (_cache[13] = createBaseVNode("strong", null, "Has Custom Color:", -1)),
            createTextVNode(" " + toDisplayString($data.stats.hasCustomColor ? "Yes" : "No"), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[14] || (_cache[14] = createBaseVNode("strong", null, "Setup Fee:", -1)),
            createTextVNode(" $" + toDisplayString($data.stats.setupFee), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[15] || (_cache[15] = createBaseVNode("strong", null, "Running Fee:", -1)),
            createTextVNode(" $" + toDisplayString($data.stats.runningFee), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[16] || (_cache[16] = createBaseVNode("strong", null, "Custom Color Fee:", -1)),
            createTextVNode(" $" + toDisplayString($data.stats.customColorFee), 1)
          ]),
          createBaseVNode("li", null, [
            _cache[17] || (_cache[17] = createBaseVNode("strong", null, "Total Fees:", -1)),
            createTextVNode(" $" + toDisplayString($data.stats.totalFees), 1)
          ])
        ])
      ])) : createCommentVNode("", true)
    ]);
  }
  const CartPayloadTester = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$e], ["__scopeId", "data-v-beecdcbf"]]);
  const DIALOG_DEFAULTS = {
    add_imprint_location: {
      title: "Please Note",
      message: "Adding more than one imprint location will incur additional fees to your total. You can review the updated breakdown before adding to the cart.",
      subMessage: "Do you wish to continue?",
      confirmText: "Continue",
      cancelText: "Cancel"
    }
  };
  function resolveConfig(dialogKey) {
    var _a;
    const defaults2 = DIALOG_DEFAULTS[dialogKey] || {
      title: "Please Note",
      message: "",
      subMessage: "",
      confirmText: "Continue",
      cancelText: "Cancel"
    };
    const ts = ((_a = window.PXUTheme) == null ? void 0 : _a.theme_settings) || {};
    const p2 = `dialog__${dialogKey}__`;
    return {
      title: ts[`${p2}title`] || defaults2.title,
      message: ts[`${p2}message`] || defaults2.message,
      subMessage: ts[`${p2}sub_message`] || defaults2.subMessage,
      confirmText: ts[`${p2}confirm`] || defaults2.confirmText,
      cancelText: ts[`${p2}cancel`] || defaults2.cancelText
    };
  }
  const useDialogStore = /* @__PURE__ */ defineStore("dialog", {
    state: () => ({
      visible: false,
      title: "",
      message: "",
      subMessage: "",
      confirmText: "Continue",
      cancelText: "Cancel",
      // Internal resolver — set when a dialog is opened
      _resolve: null
    }),
    actions: {
      /**
       * Open a confirm dialog and return a Promise<boolean>.
       * true  = user clicked Confirm
       * false = user clicked Cancel or closed the dialog
       *
       * @param {string} dialogKey - matches a key in DIALOG_DEFAULTS
       * @returns {Promise<boolean>}
       */
      confirm(dialogKey) {
        const cfg = resolveConfig(dialogKey);
        this.title = cfg.title;
        this.message = cfg.message;
        this.subMessage = cfg.subMessage;
        this.confirmText = cfg.confirmText;
        this.cancelText = cfg.cancelText;
        this.visible = true;
        return new Promise((resolve2) => {
          this._resolve = resolve2;
        });
      },
      /** User clicked the confirm button */
      onConfirm() {
        this.visible = false;
        if (this._resolve) {
          this._resolve(true);
          this._resolve = null;
        }
      },
      /** User clicked cancel or pressed Escape */
      onCancel() {
        this.visible = false;
        if (this._resolve) {
          this._resolve(false);
          this._resolve = null;
        }
      }
    }
  });
  const _sfc_main$e = {
    name: "ConfirmDialog",
    setup() {
      const dialogStore = useDialogStore();
      return { dialogStore };
    },
    computed: {
      titleId() {
        return "confirm-dialog-title";
      },
      msgId() {
        return "confirm-dialog-message";
      }
    }
  };
  const _hoisted_1$e = ["aria-labelledby", "aria-describedby"];
  const _hoisted_2$7 = { class: "dialog-header" };
  const _hoisted_3$6 = ["id"];
  const _hoisted_4$5 = { class: "dialog-body" };
  const _hoisted_5$5 = ["id"];
  const _hoisted_6$5 = {
    key: 0,
    class: "dialog-sub-message"
  };
  const _hoisted_7$5 = { class: "dialog-buttons" };
  function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createBlock(Teleport, { to: "body" }, [
      createVNode(Transition, { name: "dialog-fade" }, {
        default: withCtx(() => [
          $setup.dialogStore.visible ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "dialog-overlay",
            onClick: _cache[2] || (_cache[2] = withModifiers((...args) => $setup.dialogStore.onCancel && $setup.dialogStore.onCancel(...args), ["self"])),
            onKeydown: _cache[3] || (_cache[3] = withKeys((...args) => $setup.dialogStore.onCancel && $setup.dialogStore.onCancel(...args), ["esc"]))
          }, [
            createBaseVNode("div", {
              class: "dialog-box",
              role: "dialog",
              "aria-labelledby": $options.titleId,
              "aria-describedby": $options.msgId
            }, [
              createBaseVNode("div", _hoisted_2$7, [
                createBaseVNode("span", {
                  id: $options.titleId,
                  class: "dialog-title"
                }, toDisplayString($setup.dialogStore.title), 9, _hoisted_3$6)
              ]),
              createBaseVNode("div", _hoisted_4$5, [
                createBaseVNode("p", {
                  id: $options.msgId,
                  class: "dialog-message"
                }, toDisplayString($setup.dialogStore.message), 9, _hoisted_5$5),
                $setup.dialogStore.subMessage ? (openBlock(), createElementBlock("p", _hoisted_6$5, toDisplayString($setup.dialogStore.subMessage), 1)) : createCommentVNode("", true)
              ]),
              createBaseVNode("div", _hoisted_7$5, [
                createBaseVNode("button", {
                  class: "btn-confirm",
                  onClick: _cache[0] || (_cache[0] = (...args) => $setup.dialogStore.onConfirm && $setup.dialogStore.onConfirm(...args))
                }, toDisplayString($setup.dialogStore.confirmText), 1),
                createBaseVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[1] || (_cache[1] = (...args) => $setup.dialogStore.onCancel && $setup.dialogStore.onCancel(...args))
                }, toDisplayString($setup.dialogStore.cancelText), 1)
              ])
            ], 8, _hoisted_1$e)
          ], 32)) : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]);
  }
  const ConfirmDialog = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$d], ["__scopeId", "data-v-24e5308f"]]);
  const ARTWORK_METHODS = [
    {
      id: "new",
      label: "Start New Imprint",
      iconName: "IconNewImprint",
      // Reference to icon component
      description: "Choose imprint type, location, and add your custom message or artwork.",
      isDefault: true
      // Selected by default
    },
    {
      id: "send",
      label: "Send Us Your Artwork",
      iconName: "IconSendArtwork",
      description: "Email your artwork files to artwork@comda.com with your Order Number in the subject line.",
      email: "artwork@comda.com",
      isDefault: false
    },
    {
      id: "previous",
      label: "Use My Previous Artwork",
      iconName: "IconPreviousArtwork",
      description: "Select from your previously uploaded artwork files.",
      requiresAuth: true,
      // User must be logged in
      isDefault: false
    },
    {
      id: "design",
      label: "Design Online",
      iconName: "IconDesignOnline",
      description: "Use our online design tool to create your custom imprint.",
      isDefault: false
    }
  ];
  const ARTWORK_INSTRUCTION_TEXT = `
You can choose to start a new imprint, or if you are a returning customer you can select “Use My Previous Artwork” - we keep your previous files on record. If you would like to make any changes to a previous imprint please comment any specifics in the “Special Instructions” box.
`;
  function getArtworkInstructionTextAdditional() {
    const appStore = useAppStore();
    const email = !appStore.isComda ? "mlcs@mapleleafpromotions.com" : "artwork@comda.com";
    return `
Alternatively, if you would like to send your art files after placing your order, select “Send Us Your Artwork After Ordering”. After placing your order, send an email to <a href="mailto:${email}">${email}</a> with your art files attached and Order Number in the subject line. Please provide artwork promptly so that our team can create a Digital Proof prior to production.
`;
  }
  const _hoisted_1$d = { class: "design-online-simple" };
  const _hoisted_2$6 = {
    key: 0,
    class: "loading-state"
  };
  const _hoisted_3$5 = {
    key: 1,
    class: "error-state"
  };
  const _hoisted_4$4 = { class: "error-message" };
  const _hoisted_5$4 = {
    key: 2,
    class: "chooser-state"
  };
  const _hoisted_6$4 = { class: "button-group" };
  const _hoisted_7$4 = {
    key: 0,
    class: "warning-note"
  };
  const _hoisted_8$4 = {
    key: 3,
    class: "template-select-state"
  };
  const _hoisted_9$4 = { class: "template-grid" };
  const _hoisted_10$4 = ["onClick"];
  const _hoisted_11$4 = ["src", "alt"];
  const _hoisted_12$4 = {
    key: 1,
    class: "template-card__placeholder"
  };
  const _hoisted_13$4 = { class: "template-card__title" };
  const _hoisted_14$3 = {
    key: 4,
    class: "preview-state"
  };
  const _hoisted_15$3 = {
    key: 0,
    class: "preview-image-wrapper"
  };
  const _hoisted_16$3 = ["src"];
  const _hoisted_17$3 = { class: "approval-section" };
  const _hoisted_18$3 = { class: "approval-checkbox" };
  const _hoisted_19$3 = ["checked"];
  const _hoisted_20$3 = { class: "action-buttons" };
  const _hoisted_21$3 = {
    key: 1,
    class: "test-controls"
  };
  const _hoisted_22$3 = {
    key: 2,
    class: "debug-info"
  };
  const _sfc_main$d = {
    __name: "DesignOnlineSimple",
    props: {
      sku: String,
      debugMode: {
        type: Boolean,
        default: false
      }
    },
    emits: ["design-returned"],
    setup(__props, { emit: __emit }) {
      const store2 = useDesignOnlineStore();
      const newImprintStore = useNewImprintStore();
      const selectionStore = useSelectionStore();
      const emit2 = __emit;
      onMounted(async () => {
        console.log("[DO_NAV] 🎬 DesignOnlineSimple.mounted() START");
        const opsProductId = store2.initProductId();
        if (!opsProductId) {
          console.warn("[DesignOnlineSimple] No OPS product ID — Design Online unavailable");
          return;
        }
        console.log("[DO_NAV] Initial store state:", {
          stage: store2.stage,
          hasDesign: store2.hasDesign,
          isReady: store2.isReady,
          isApproved: store2.isApproved,
          tokenId: store2.tokenId,
          supportCheckDone: store2.supportCheckDone,
          supportCheckProductKey: store2.supportCheckProductKey,
          isSupported: store2.isSupported,
          hasCustomizeUrl: !!store2.customizeStudioUrl
        });
        const { tokenId, exParam } = store2.readReturnParamsFromUrl();
        let finalExParam = exParam;
        if (tokenId && !finalExParam) {
          if (!store2.exResponseParam) {
            store2.restoreFromStorage();
          }
          finalExParam = store2.exResponseParam;
        }
        if (tokenId && finalExParam) {
          console.log("[DesignOnlineSimple] Detected return from studio");
          console.log("[AddToCart] 🔄 Calling handleReturn() with tokenId:", tokenId);
          const success = await store2.handleReturn(tokenId, finalExParam);
          console.log("[AddToCart] handleReturn() result:", success);
          console.log("[AddToCart] Store state after return:", {
            stage: store2.stage,
            hasDesign: store2.hasDesign,
            isReady: store2.isReady,
            isApproved: store2.isApproved,
            tokenId: store2.tokenId,
            hasPreview: !!store2.previewImage,
            hasPdfPreview: !!store2.pdfPreviewUrl,
            hasPrintReady: !!store2.printReadyFileUrl
          });
          if (success && store2.hasDesign) {
            console.log("[DesignOnlineSimple] 🎉 Emitting design-returned event");
            console.log("[AddToCart] ⚠️ Note: Design loaded but NOT approved yet - user must check the checkbox!");
            emit2("design-returned");
          }
        } else {
          if (store2.stage === "preview" && store2.hasDesign) {
            console.log("[DO_NAV] ✅ Store already has design (back navigation) - preserving state");
            console.log("[DO_NAV] Current state:", {
              stage: store2.stage,
              hasDesign: store2.hasDesign,
              isApproved: store2.isApproved
            });
          } else {
            console.log("[DO_NAV] No URL params, trying to restore from storage...");
            const restored = store2.restoreFromStorage();
            console.log("[DO_NAV] Restore from storage result:", restored);
            if (!restored) {
              if (store2.stage === "idle") {
                console.log("[DO_NAV] No saved data, calling initialize()...");
                store2.initialize();
                console.log("[DO_NAV] After initialize(), stage:", store2.stage);
              } else {
                console.log("[DO_NAV] Stage is", store2.stage, "- skipping initialize() to preserve state");
              }
            } else if (store2.hasDesign) {
              console.log("[DO_NAV] ✅ Design restored from storage, emitting design-returned");
              emit2("design-returned");
            }
          }
        }
        const currentKey = store2.getStableProductKey();
        if (!store2.supportCheckDone || store2.supportCheckProductKey !== currentKey) {
          console.log("[DO_NAV] Phase 1: running support check (was not done yet)...");
          await store2.checkSupport(opsProductId, props.sku, { design_enabled: true, force_probe: false });
        } else {
          console.log("[DO_NAV] Phase 1 already done, skipping");
        }
        console.log("[DO_NAV] ✅ DesignOnlineSimple.mounted() END - Final state:", {
          stage: store2.stage,
          hasDesign: store2.hasDesign,
          isReady: store2.isReady,
          isApproved: store2.isApproved,
          supportCheckDone: store2.supportCheckDone,
          isSupported: store2.isSupported
        });
      });
      onBeforeUnmount(() => {
        console.log("[DesignOnlineSimple] Unmounted");
      });
      const props = __props;
      async function handleCreateClick() {
        console.log("[DO_NAV] 🎨 handleCreateClick() START");
        console.log("[DO_NAV] Current store state before create:", {
          stage: store2.stage,
          hasCustomizeUrl: !!store2.customizeStudioUrl,
          supportCheckDone: store2.supportCheckDone
        });
        const productId = store2.studioConfig.productId;
        if (!productId) {
          console.error("[DesignOnlineSimple] Cannot create — no OPS product ID");
          return;
        }
        newImprintStore.saveToSessionStorage();
        selectionStore.saveToSessionStorage();
        console.log("[DO_NAV] 💾 Saved New Imprint + Selection data before redirect");
        if (!store2.customizeStudioUrl) {
          console.log("[DO_NAV] Phase 2: Fetching URLs (force_probe=true)...");
          await store2.checkSupport(productId, props.sku, {
            design_enabled: true,
            force_probe: true
            // Call Studio API to get URLs
          });
          console.log("[DO_NAV] Phase 2 complete. hasCustomizeUrl:", !!store2.customizeStudioUrl);
        } else {
          console.log("[DO_NAV] customizeStudioUrl already available, skipping Phase 2");
        }
        store2.startCreate(props.sku);
        console.log("[DO_NAV] handleCreateClick() END - startCreate called");
      }
      async function handleUploadClick() {
        console.log("[DesignOnlineSimple] 📤 Upload button clicked");
        const productId = store2.studioConfig.productId;
        if (!productId) {
          console.error("[DesignOnlineSimple] Cannot upload — no OPS product ID");
          return;
        }
        newImprintStore.saveToSessionStorage();
        selectionStore.saveToSessionStorage();
        console.log("[DesignOnlineSimple] 💾 Saved New Imprint + Selection data before redirect");
        if (!store2.uploadCenterUrl) {
          console.log("[DesignOnlineSimple] Phase 2: Fetching URLs (force_probe)");
          await store2.checkSupport(productId, props.sku, {
            design_enabled: true,
            force_probe: true
            // Call Studio API to get URLs
          });
        }
        store2.startUpload(productId, props.sku);
      }
      function handleApprovalChange(event2) {
        const isChecked = event2.target.checked;
        console.log("[AddToCart] ☑️ Approval checkbox changed:", isChecked);
        store2.setApproval(isChecked);
        console.log("[AddToCart] Store state after approval change:", {
          isApproved: store2.isApproved,
          isReady: store2.isReady,
          hasDesign: store2.hasDesign,
          tokenId: store2.tokenId
        });
        if (isChecked) {
          console.log("[AddToCart] ✅ Design approved! User can now add to cart.");
        } else {
          console.log("[AddToCart] ❌ Design NOT approved. User must check the box before adding to cart.");
        }
      }
      function handleEdit() {
        store2.openEdit();
      }
      function handleDownload() {
        store2.openDownload();
      }
      function handleReset() {
        if (confirm("Reset to chooser state?")) {
          store2.resetToChooser();
        }
      }
      function handleTemplateSelect(tpl) {
        console.log("[DO_NAV] Template selected:", tpl);
        store2.redirectWithTemplate(props.sku, tpl);
      }
      const debugInfo = computed(() => {
        return {
          stage: store2.stage,
          hasDesign: store2.hasDesign,
          isReady: store2.isReady,
          isApproved: store2.isApproved,
          tokenId: store2.tokenId,
          source: store2.source
        };
      });
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock("div", _hoisted_1$d, [
          unref(store2).isLoading ? (openBlock(), createElementBlock("div", _hoisted_2$6, [..._cache[2] || (_cache[2] = [
            createBaseVNode("div", { class: "spinner" }, null, -1),
            createBaseVNode("p", null, "Loading...", -1)
          ])])) : unref(store2).error ? (openBlock(), createElementBlock("div", _hoisted_3$5, [
            createBaseVNode("p", _hoisted_4$4, toDisplayString(unref(store2).error), 1),
            createVNode(BaseButton, {
              text: "Try Again",
              variant: "secondary",
              onClick: _cache[0] || (_cache[0] = ($event) => unref(store2).error = null)
            })
          ])) : unref(store2).stage === "chooser" ? (openBlock(), createElementBlock("div", _hoisted_5$4, [
            _cache[4] || (_cache[4] = createBaseVNode("p", { class: "description" }, " Use our online design tool to create your custom imprint. ", -1)),
            createBaseVNode("div", _hoisted_6$4, [
              createVNode(BaseButton, {
                text: "Create Design Online",
                variant: "primary",
                size: "large",
                disabled: unref(store2).isLoading,
                onClick: handleCreateClick
              }, null, 8, ["disabled"]),
              createVNode(BaseButton, {
                text: "Upload Your Artwork",
                variant: "secondary",
                size: "large",
                disabled: unref(store2).isLoading,
                onClick: handleUploadClick
              }, null, 8, ["disabled"])
            ]),
            !unref(store2).isSupported ? (openBlock(), createElementBlock("div", _hoisted_7$4, [..._cache[3] || (_cache[3] = [
              createBaseVNode("p", null, [
                createBaseVNode("strong", null, "⚠️ Not Available:"),
                createTextVNode(" Design Online is not available for this product. ")
              ], -1)
            ])])) : createCommentVNode("", true)
          ])) : unref(store2).stage === "template-select" ? (openBlock(), createElementBlock("div", _hoisted_8$4, [
            _cache[5] || (_cache[5] = createBaseVNode("p", { class: "description" }, "Choose a template to start your design:", -1)),
            createBaseVNode("div", _hoisted_9$4, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(store2).templates, (tpl) => {
                return openBlock(), createElementBlock("button", {
                  key: tpl.tempid,
                  class: "template-card",
                  onClick: ($event) => handleTemplateSelect(tpl)
                }, [
                  tpl.preview_url ? (openBlock(), createElementBlock("img", {
                    key: 0,
                    src: tpl.preview_url,
                    alt: tpl.title,
                    class: "template-card__img"
                  }, null, 8, _hoisted_11$4)) : (openBlock(), createElementBlock("div", _hoisted_12$4, "No preview")),
                  createBaseVNode("span", _hoisted_13$4, toDisplayString(tpl.title), 1)
                ], 8, _hoisted_10$4);
              }), 128))
            ]),
            createVNode(BaseButton, {
              text: "Back",
              variant: "secondary",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event) => {
                unref(store2).resetToChooser();
                unref(store2).initialize();
              })
            })
          ])) : unref(store2).stage === "preview" ? (openBlock(), createElementBlock("div", _hoisted_14$3, [
            unref(store2).previewImage ? (openBlock(), createElementBlock("div", _hoisted_15$3, [
              createBaseVNode("img", {
                src: unref(store2).previewImage,
                alt: "Design preview",
                class: "preview-image"
              }, null, 8, _hoisted_16$3)
            ])) : createCommentVNode("", true),
            createBaseVNode("div", _hoisted_17$3, [
              createBaseVNode("label", _hoisted_18$3, [
                createBaseVNode("input", {
                  type: "checkbox",
                  checked: unref(store2).isApproved,
                  onChange: handleApprovalChange
                }, null, 40, _hoisted_19$3),
                _cache[6] || (_cache[6] = createBaseVNode("span", { class: "checkbox-label" }, " I confirm I have reviewed & approve my design. ", -1))
              ])
            ]),
            createBaseVNode("div", _hoisted_20$3, [
              createVNode(BaseButton, {
                text: "Edit Design",
                variant: "primary",
                size: "medium",
                disabled: !unref(store2).editUrl,
                onClick: handleEdit
              }, null, 8, ["disabled"]),
              createVNode(BaseButton, {
                text: "Download PDF",
                variant: "outline",
                size: "medium",
                disabled: !unref(store2).downloadUrl,
                onClick: handleDownload
              }, null, 8, ["disabled"])
            ]),
            __props.debugMode ? (openBlock(), createElementBlock("div", _hoisted_21$3, [
              createVNode(BaseButton, {
                text: "🔄 Reset (Test)",
                variant: "outline",
                size: "small",
                onClick: handleReset
              })
            ])) : createCommentVNode("", true),
            __props.debugMode ? (openBlock(), createElementBlock("div", _hoisted_22$3, [
              createBaseVNode("details", null, [
                _cache[7] || (_cache[7] = createBaseVNode("summary", null, "🔍 Debug Info", -1)),
                createBaseVNode("pre", null, toDisplayString(debugInfo.value), 1)
              ])
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]);
      };
    }
  };
  const DesignOnlineSimple = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["__scopeId", "data-v-0ffc7b43"]]);
  const IMPRINT_TYPES = [
    {
      id: 1,
      value: "text",
      label: "Text Only",
      description: "Add text lines with custom colors for your imprint",
      maxLines: 5
    },
    {
      id: 2,
      value: "image",
      label: "Image Only",
      description: "Upload your artwork or logo",
      maxLines: 0
    },
    {
      id: 3,
      value: "text_and_image",
      label: "Text & Image",
      description: "Combine text and images for your imprint",
      maxLines: 5
    }
  ];
  const _sfc_main$c = {
    name: "IconNewImprint"
  };
  const _hoisted_1$c = {
    width: "35",
    height: "35",
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "icon-new-imprint"
  };
  function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("svg", _hoisted_1$c, [..._cache[0] || (_cache[0] = [
      createBaseVNode("path", {
        d: "M32.0833 15.2542L28.525 11.2L29.0208 5.83333L23.7563 4.6375L21 0L16.0417 2.12917L11.0833 0L8.32708 4.6375L3.0625 5.81875L3.55833 11.1854L0 15.2542L3.55833 19.3083L3.0625 24.6896L8.32708 25.8854L11.0833 30.5229L16.0417 28.3792L21 30.5083L23.7563 25.8708L29.0208 24.675L28.525 19.3083L32.0833 15.2542ZM17.5 22.5458H14.5833V19.6292H17.5V22.5458ZM17.5 16.7125H14.5833V7.9625H17.5V16.7125Z",
        fill: "currentColor"
      }, null, -1)
    ])]);
  }
  const IconNewImprint = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__scopeId", "data-v-eda80093"]]);
  const _sfc_main$b = {
    name: "IconSendArtwork"
  };
  const _hoisted_1$b = {
    width: "35",
    height: "35",
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "icon-send-artwork"
  };
  function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("svg", _hoisted_1$b, [..._cache[0] || (_cache[0] = [
      createBaseVNode("path", {
        d: "M18.0026 18.7048V13.2658H20.2529V17.4224L23.9134 19.5007L22.7883 21.4169L18.0026 18.7048ZM0 23.5837V14.7398L10.6665 12.1161C10.7866 11.9245 10.9216 11.7476 11.0566 11.556L0 8.84387V0L18.0476 7.47307C18.5277 7.36989 19.0077 7.36989 19.5028 7.36989C22.2932 7.36989 24.9636 8.46064 26.9289 10.3916C27.3039 10.76 27.649 11.158 27.949 11.5707L28.5041 11.7918L28.2041 11.9097C29.664 14.0361 30.2656 16.6203 29.8917 19.1588C29.5177 21.6972 28.195 24.0079 26.1815 25.6403C24.1679 27.2726 21.6077 28.1098 19.0001 27.9884C16.3925 27.8671 13.9243 26.796 12.0767 24.9839C10.6215 23.5837 9.63139 21.7264 9.21133 19.7661L0 23.5837ZM26.7789 17.6877C26.7789 13.7375 23.5084 10.5389 19.5028 10.5389C17.5675 10.5389 15.7523 11.2907 14.3571 12.632C12.9919 14.0028 12.2268 15.7863 12.2268 17.6877C12.2268 21.638 15.4822 24.8365 19.5028 24.8365C20.4629 24.8365 21.4081 24.6597 22.2932 24.3207C23.1633 23.9374 24.0035 23.4068 24.6486 22.7435C25.3236 22.1097 25.8637 21.2843 26.2538 20.4293C26.5988 19.5597 26.7789 18.6311 26.7789 17.6877Z",
        fill: "currentColor"
      }, null, -1)
    ])]);
  }
  const IconSendArtwork = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__scopeId", "data-v-14f81148"]]);
  const _sfc_main$a = {
    name: "IconPreviousArtwork"
  };
  const _hoisted_1$a = {
    width: "35",
    height: "35",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "icon-previous-artwork"
  };
  function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("svg", _hoisted_1$a, [..._cache[0] || (_cache[0] = [
      createBaseVNode("path", {
        d: "M14.5833 26.25C17.6775 26.25 20.645 25.0208 22.8329 22.8329C25.0208 20.645 26.25 17.6775 26.25 14.5833C26.25 11.4891 25.0208 8.52168 22.8329 6.33375C20.645 4.14583 17.6775 2.91667 14.5833 2.91667C11.4891 2.91667 8.52168 4.14583 6.33375 6.33375C4.14583 8.52168 2.91667 11.4891 2.91667 14.5833C2.91667 17.6775 4.14583 20.645 6.33375 22.8329C8.52168 25.0208 11.4891 26.25 14.5833 26.25ZM14.5833 0C16.4984 0 18.3948 0.377209 20.1641 1.11009C21.9335 1.84297 23.5411 2.91717 24.8953 4.27136C26.2495 5.62555 27.3237 7.2332 28.0566 9.00253C28.7895 10.7719 29.1667 12.6682 29.1667 14.5833C29.1667 18.4511 27.6302 22.1604 24.8953 24.8953C22.1604 27.6302 18.4511 29.1667 14.5833 29.1667C6.51875 29.1667 0 22.6042 0 14.5833C0 10.7156 1.53645 7.00626 4.27136 4.27136C7.00626 1.53645 10.7156 0 14.5833 0ZM15.3125 7.29167V14.9479L21.875 18.8417L20.7812 20.6354L13.125 16.0417V7.29167H15.3125Z",
        fill: "currentColor"
      }, null, -1)
    ])]);
  }
  const IconPreviousArtwork = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__scopeId", "data-v-540b1d12"]]);
  const _sfc_main$9 = {
    name: "IconDesignOnline"
  };
  const _hoisted_1$9 = {
    width: "35",
    height: "35",
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "icon-design-online"
  };
  function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("svg", _hoisted_1$9, [..._cache[0] || (_cache[0] = [
      createBaseVNode("path", {
        d: "M7.89372 17.37C5.27301 17.37 3.15749 19.4856 3.15749 22.1063C3.15749 24.1744 1.32615 25.2638 0 25.2638C1.45244 27.1898 3.93107 28.4213 6.31498 28.4213C9.804 28.4213 12.63 25.5953 12.63 22.1063C12.63 19.4856 10.5144 17.37 7.89372 17.37ZM29.5383 2.57721L27.4228 0.461694C27.2767 0.315339 27.1032 0.199226 26.9123 0.120003C26.7213 0.0407789 26.5165 0 26.3098 0C26.103 0 25.8983 0.0407789 25.7073 0.120003C25.5163 0.199226 25.3428 0.315339 25.1968 0.461694L11.0512 14.6072L15.3928 18.9488L29.5383 4.80324C29.6847 4.65719 29.8008 4.4837 29.88 4.29271C29.9592 4.10173 30 3.89699 30 3.69023C30 3.48346 29.9592 3.27873 29.88 3.08774C29.8008 2.89675 29.6847 2.72327 29.5383 2.57721Z",
        fill: "currentColor"
      }, null, -1)
    ])]);
  }
  const IconDesignOnline = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-775b5db5"]]);
  const _sfc_main$8 = {
    name: "CustomizeProductSection",
    components: {
      BaseButton,
      NewImprintModule,
      StartNewImprintForm,
      AddImprintLocationButton,
      ImprintMethodSelector,
      ImprintLocationSelector,
      StateDebuggerNewImprint,
      CartPayloadTester,
      DesignOnlineSimple,
      // ✅ NEW
      ConfirmDialog
    },
    props: {
      productData: {
        type: Object,
        default: () => ({})
      }
    },
    setup() {
      const newImprintStore = useNewImprintStore();
      const imprintStore = useImprintStore();
      const selectionStore = useSelectionStore();
      const appStore = useAppStore();
      const designOnlineStore = useDesignOnlineStore();
      const dialogStore = useDialogStore();
      const { step2Validation } = useSectionValidation();
      return {
        newImprintStore,
        imprintStore,
        selectionStore,
        appStore,
        designOnlineStore,
        // ✅ ISSUE 1: Expose to component
        dialogStore,
        step2Validation,
        debugConfig: DEBUG_CONFIG
      };
    },
    data() {
      const defaultMethod = ARTWORK_METHODS.find((m) => m.isDefault);
      return {
        selectedArtworkMethod: defaultMethod ? defaultMethod.id : null,
        imprintTypes: IMPRINT_TYPES,
        instructionText: ARTWORK_INSTRUCTION_TEXT.trim(),
        instructionTextAdditional: getArtworkInstructionTextAdditional().trim(),
        // Counter: how many times "Add Another Imprint Location" was clicked.
        // Resets on page reload (in-memory only, not persisted).
        // Dialog is shown only on the first click.
        addImprintClickCount: 0,
        // Send Us Your Artwork data
        sendArtworkData: {
          imprintMethod: null,
          location: null,
          instructions: ""
        },
        sendArtworkInstructions: "",
        // Use My Previous Artwork data
        previousArtworkData: {
          imprintMethod: null,
          location: null,
          previousArtwork: null,
          // TODO: from PreviousArtworkSelector
          referenceOrderNumber: null,
          instructions: ""
        },
        previousArtworkInstructions: "",
        // Map icon names to components
        iconComponents: {
          IconNewImprint,
          IconSendArtwork,
          IconPreviousArtwork,
          IconDesignOnline
        }
      };
    },
    computed: {
      // Filter out 'Design Online' if isSupported is explicitly false (no metafield or API said no)
      artworkMethods() {
        if (this.designOnlineStore.isSupported === false) {
          return ARTWORK_METHODS.filter((m) => m.id !== "design");
        }
        return ARTWORK_METHODS;
      },
      currentMethodData() {
        return this.artworkMethods.find((m) => m.id === this.selectedArtworkMethod) || {};
      },
      /**
       * Check if can add more imprints.
       * Hide "Add Another Imprint Location" button if:
       * - Product supports only 1 location total
       * - All available locations are already used across existing imprints
       */
      canAddMoreImprints() {
        var _a, _b, _c;
        const totalLocations = ((_a = this.imprintStore.availableLocations) == null ? void 0 : _a.length) || 0;
        const availableForNew = ((_b = this.newImprintStore.availableLocationsForNewImprint) == null ? void 0 : _b.length) || 0;
        const currentImprints = ((_c = this.newImprintStore.imprints) == null ? void 0 : _c.length) || 0;
        console.log("[CustomizeProductSection] canAddMoreImprints check:", {
          totalLocations,
          availableForNew,
          currentImprints
        });
        if (totalLocations <= 1) return false;
        if (currentImprints >= totalLocations) return false;
        return availableForNew > 0;
      },
      /**
       * Dynamic text for Next Step button
       * Changes based on whether Add-Ons section is visible
       */
      nextStepButtonText() {
        if (this.debugConfig.showAddOnsSection) {
          return "Next Step: Add-Ons";
        }
        return "Next Step: Review";
      },
      previousStepText() {
        return `Previous Step: ${getColorName()} & Quantity`;
      }
    },
    methods: {
      /**
       * Get imprint title based on index
       */
      getImprintTitle(index) {
        const titles = ["First Imprint", "Second Imprint", "Third Imprint", "Fourth Imprint", "Fifth Imprint"];
        return titles[index] || `Imprint ${index + 1}`;
      },
      /**
       * Select artwork method
       */
      selectMethod(methodId) {
        this.newImprintStore.imprints.forEach((imprint) => {
          imprint.textLines.forEach((line) => {
            line.showColorPicker = false;
          });
          imprint.pendingColorSelection = { lineId: null, color: null, colorObj: null, customColor: false };
        });
        this.selectedArtworkMethod = methodId;
        const imprintStore = useImprintStore();
        imprintStore.setSelectedArtworkMethod(methodId);
        this.$emit("artwork-method-selected", methodId);
        console.log("[CustomizeProductSection] Artwork method selected:", methodId);
      },
      /**
       * Add new imprint.
       * Shows a confirm dialog (text from theme settings) before adding the second+ location.
       * First imprint is added without a dialog (no extra fees incurred).
       */
      async handleAddImprint() {
        var _a, _b;
        const totalLocations = ((_a = this.imprintStore.availableLocations) == null ? void 0 : _a.length) || 0;
        const currentImprints = ((_b = this.newImprintStore.imprints) == null ? void 0 : _b.length) || 0;
        if (totalLocations > 0 && currentImprints >= totalLocations) {
          console.log("[CustomizeProductSection] Add imprint blocked: reached max imprints for available locations", {
            totalLocations,
            currentImprints
          });
          return;
        }
        this.addImprintClickCount++;
        const isFirstClick = this.addImprintClickCount === 1;
        if (currentImprints >= 1 && isFirstClick) {
          const confirmed = await this.dialogStore.confirm("add_imprint_location");
          if (!confirmed) {
            this.addImprintClickCount--;
            console.log("[CustomizeProductSection] Add imprint cancelled by user");
            return;
          }
        }
        this.newImprintStore.addNewImprint();
        console.log(
          "[CustomizeProductSection] New imprint added, total:",
          this.newImprintStore.imprints.length,
          "| click #",
          this.addImprintClickCount
        );
      },
      /**
       * Delete imprint
       */
      handleDeleteImprint(imprintKey) {
        console.log("[CustomizeProductSection] Delete imprint requested:", imprintKey);
        this.newImprintStore.deleteImprint(imprintKey);
      },
      // Send Artwork Handlers
      handleSendArtworkInstructionsChange() {
        this.sendArtworkData.instructions = this.sendArtworkInstructions;
        console.log("[CustomizeProductSection] Send artwork instructions:", this.sendArtworkInstructions);
        if (this.newImprintStore.imprints[0] !== void 0) {
          this.newImprintStore.imprints[0].specialInstructions = this.sendArtworkInstructions;
        }
        this.$emit("special-instructions-changed", {
          method: "send",
          instructions: this.sendArtworkInstructions
        });
      },
      // Previous Artwork Handlers  
      handlePreviousArtworkInstructionsChange() {
        this.previousArtworkData.instructions = this.previousArtworkInstructions;
        console.log("[CustomizeProductSection] Previous artwork instructions:", this.previousArtworkInstructions);
        if (this.newImprintStore.imprints[0] !== void 0) {
          this.newImprintStore.imprints[0].specialInstructions = this.previousArtworkInstructions;
        }
        this.$emit("special-instructions-changed", {
          method: "previous",
          instructions: this.previousArtworkInstructions
        });
      },
      /**
       * Transform Send Us Your Artwork data to cart payload format
       * Returns imprint_lines and properties objects ready for cart
       * @returns {Object} { imprint_lines, properties }
       */
      transformSendArtworkToCart() {
        if (!this.sendArtworkData.imprintMethod || !this.sendArtworkData.location) {
          console.warn("[CustomizeProductSection] Send Artwork: Missing required data");
          return null;
        }
        const properties = {
          "Imprint location": this.sendArtworkData.location.title || "",
          "_Imprint Location SKU": this.sendArtworkData.location.sku || "",
          "Imprint Method": this.sendArtworkData.imprintMethod.name || "",
          "_Imprint Method SKU": this.sendArtworkData.imprintMethod.sku || "",
          "Special Instruction": `Send Us Your Artwork After Ordering. \r
\r
Comment: ${this.sendArtworkData.instructions} \r
\r
 ${this.selectionStore.specialInstructions}`,
          "_price_details": {
            setup_fee: 30,
            // Base setup fee
            proof_fee: 5,
            // Standard proof fee
            image_fee: 0,
            // May be 25 if image expected
            customColourFee: 0,
            // No custom colors yet
            running_fee: 0
            // No running fee (colors unknown)
          }
        };
        console.log("[CustomizeProductSection] Send Artwork transform:", properties);
        return {
          imprint_lines: {},
          // Empty - artwork will be sent later
          properties
        };
      },
      /**
       * Transform Use My Previous Artwork data to cart payload format
       * Returns imprint_lines and properties objects ready for cart
       * @returns {Object} { imprint_lines, properties }
       */
      transformPreviousArtworkToCart() {
        if (!this.previousArtworkData.imprintMethod || !this.previousArtworkData.location) {
          console.warn("[CustomizeProductSection] Previous Artwork: Missing required data");
          return null;
        }
        const properties = {
          "Imprint location": this.previousArtworkData.location.title || "",
          "_Imprint Location SKU": this.previousArtworkData.location.sku || "",
          "Imprint Method": this.previousArtworkData.imprintMethod.name || "",
          "_Imprint Method SKU": this.previousArtworkData.imprintMethod.sku || "",
          "Special Instruction": `Use My Previous Artwork.\r
\r
Comment: ${this.previousArtworkData.instructions}`,
          "_price_details": {
            setup_fee: 0,
            // May be 0 if setup already exists
            proof_fee: 0,
            // May be 0 if proof not needed
            image_fee: 0,
            // Artwork already exists
            customColourFee: 0,
            running_fee: 0
            // Colors already known from previous
          }
        };
        if (this.previousArtworkData.previousArtwork) {
          properties["_Previous Artwork ID"] = this.previousArtworkData.previousArtwork.id || "";
        }
        if (this.previousArtworkData.referenceOrderNumber) {
          properties["_Reference Order"] = this.previousArtworkData.referenceOrderNumber;
        }
        console.log("[CustomizeProductSection] Previous Artwork transform:", properties);
        return {
          imprint_lines: {},
          // Empty - artwork already exists
          properties
        };
      },
      /**
       * ✅ Transform Design Online data to cart payload format
       * Returns imprint_lines and properties objects ready for cart
       * @returns {Object|null} { imprint_lines, properties } or null if not ready
       */
      transformDesignOnlineToCart() {
        const store2 = this.designOnlineStore;
        console.log("[AddToCart] 🎨 transformDesignOnlineToCart() called");
        console.log("[AddToCart] Design Online store state:", {
          stage: store2.stage,
          hasDesign: store2.hasDesign,
          isReady: store2.isReady,
          isApproved: store2.isApproved,
          tokenId: store2.tokenId,
          hasPreview: !!store2.previewImage,
          hasPdfPreview: !!store2.pdfPreviewUrl,
          hasPrintReady: !!store2.printReadyFileUrl
        });
        if (!store2.isReady) {
          console.error("[AddToCart] ❌ Design Online: Not ready!");
          console.error("[AddToCart] isReady breakdown:", {
            hasTokenId: !!store2.tokenId,
            hasPreview: !!(store2.previewImage || store2.pdfPreviewUrl),
            isApproved: store2.isApproved,
            allConditions: `tokenId=${!!store2.tokenId} && preview=${!!(store2.previewImage || store2.pdfPreviewUrl)} && approved=${store2.isApproved}`
          });
          console.error("[AddToCart] 💡 User must approve design by checking the checkbox!");
          return null;
        }
        const props = store2.lineItemProperties;
        console.log("[AddToCart] lineItemProperties:", props);
        if (!props || !props.token_id) {
          console.error("[AddToCart] ❌ Missing token_id!");
          console.error("[AddToCart] lineItemProperties:", props);
          return null;
        }
        const sizeUpchargeObj = {};
        const colorUpchargeObj = {};
        if (this.imprintStore.sizeUpcharge) {
          Object.keys(this.imprintStore.sizeUpcharge).forEach((size) => {
            if (this.imprintStore.sizeUpcharge[size] !== 0) {
              sizeUpchargeObj[size] = this.imprintStore.sizeUpcharge[size];
            }
          });
        }
        if (this.imprintStore.colorUpcharge) {
          Object.keys(this.imprintStore.colorUpcharge).forEach((colorKey) => {
            const colorData = this.imprintStore.colorUpcharge[colorKey];
            if (colorData && colorData.price !== 0) {
              colorUpchargeObj[colorKey] = {
                price: colorData.price || 0,
                price_type: colorData.price_type || ""
              };
            }
          });
        }
        console.log("[AddToCart] Design Online upcharges:", {
          sizeUpcharge: sizeUpchargeObj,
          colorUpcharge: colorUpchargeObj
        });
        const properties = {
          // ✅ REQUIRED: Design Online specific properties (with underscore prefix)
          "_token_id": props.token_id,
          "_pdf_preview_url": props.pdf_preview_url || "",
          "_print_ready_file_url": props.print_ready_file_url || "",
          // ✅ OPTIONAL: Additional design data
          "_design_url": store2.editUrl || "",
          "_preview_image": props.preview_image || "",
          // Standard imprint properties
          "Imprint Method": "Design Online",
          "_Imprint Method SKU": "DESIGN_ONLINE",
          // ✅ NEW: Size and Color upcharges (from Step 1)
          "_sizeUpcharge": sizeUpchargeObj,
          "_colorUpcharge": colorUpchargeObj,
          // Price details (no setup/proof fees for Design Online)
          "_price_details": {
            setup_fee: 0,
            // No setup fee - design is ready
            proof_fee: 0,
            // No proof fee - user approved design
            image_fee: 0,
            // Included in design
            customColourFee: 0,
            // No custom colors
            running_fee: 0
            // Included in design
          }
        };
        console.log("[AddToCart] ✅ Design Online payload created:", properties);
        return {
          imprint_lines: {},
          // Empty - no separate lines for Design Online
          properties
        };
      },
      /**
       * Get cart payload based on selected artwork method
       * @returns {Object|null} Cart payload or null if invalid
       */
      getCartPayload() {
        var _a, _b;
        console.log("[AddToCart] 📦 getCartPayload() called, method:", this.selectedArtworkMethod);
        let payload = null;
        if (this.selectedArtworkMethod === "new") {
          console.log("[AddToCart] ➡️ Using Start New Imprint transform");
          payload = this.newImprintStore.transformToCartPayload();
        } else if (this.selectedArtworkMethod === "send") {
          console.log("[AddToCart] ➡️ Using Send Artwork transform");
          payload = this.transformSendArtworkToCart();
        } else if (this.selectedArtworkMethod === "previous") {
          console.log("[AddToCart] ➡️ Using Previous Artwork transform");
          payload = this.transformPreviousArtworkToCart();
        } else if (this.selectedArtworkMethod === "design") {
          console.log("[AddToCart] ➡️ Using Design Online transform");
          payload = this.transformDesignOnlineToCart();
        } else {
          console.error("[AddToCart] ❌ Unknown artwork method:", this.selectedArtworkMethod);
          return null;
        }
        if (payload) {
          console.log("[AddToCart] ✅ Payload generated successfully");
          console.log("[AddToCart] Payload preview:", {
            hasImprintLines: !!payload.imprint_lines,
            imprintLinesCount: Object.keys(payload.imprint_lines || {}).length,
            hasProperties: !!payload.properties,
            propertiesCount: Object.keys(payload.properties || {}).length,
            method: (_a = payload.properties) == null ? void 0 : _a["Imprint Method"],
            methodSku: (_b = payload.properties) == null ? void 0 : _b["_Imprint Method SKU"]
          });
        } else {
          console.error("[AddToCart] ❌ Payload is NULL - cannot add to cart!");
        }
        return payload;
      },
      // Start New Imprint Form Handlers
      handleImprintMethodChanged(method) {
        console.log("[CustomizeProductSection] Imprint method changed:", {
          sku: method == null ? void 0 : method.sku,
          name: method == null ? void 0 : method.name,
          currentArtworkMethod: this.selectedArtworkMethod
        });
        if (this.selectedArtworkMethod === "send") {
          this.sendArtworkData.imprintMethod = method;
          this.imprintStore.setSelectedImprintMethod(method);
          console.log("[CustomizeProductSection] Saved to sendArtworkData + imprintStore");
        } else if (this.selectedArtworkMethod === "previous") {
          this.previousArtworkData.imprintMethod = method;
          this.imprintStore.setSelectedImprintMethod(method);
          console.log("[CustomizeProductSection] Saved to previousArtworkData + imprintStore");
        }
      },
      handleLocationChanged(data) {
        var _a;
        console.log("[CustomizeProductSection] Location changed:", {
          sku: data == null ? void 0 : data.sku,
          locationTitle: (_a = data == null ? void 0 : data.location) == null ? void 0 : _a.title,
          currentMethod: this.selectedArtworkMethod
        });
        const location2 = (data == null ? void 0 : data.location) || data;
        if (this.selectedArtworkMethod === "send") {
          this.sendArtworkData.location = location2;
          this.newImprintStore.setLocation(location2, 0);
          console.log("[CustomizeProductSection] Saved to sendArtworkData + newImprintStore:", location2 == null ? void 0 : location2.title);
        } else if (this.selectedArtworkMethod === "previous") {
          this.previousArtworkData.location = location2;
          this.newImprintStore.setLocation(location2, 0);
          console.log("[CustomizeProductSection] Saved to previousArtworkData + newImprintStore:", location2 == null ? void 0 : location2.title);
        }
      },
      handleMessageTypeChanged(type) {
        console.log("[CustomizeProductSection] Message type changed:", type);
      },
      handleLinesChanged(lines) {
        console.log("[CustomizeProductSection] Lines changed:", lines);
      },
      handleImageUploaded(data) {
        console.log("[CustomizeProductSection] Image uploaded:", data);
      },
      handleImageRemoved() {
        console.log("[CustomizeProductSection] Image removed");
      },
      handleSpecialInstructionsChanged(text) {
        console.log("[CustomizeProductSection] Special instructions changed:", text);
      },
      /**
       * Handle Previous Step button click
       * Navigate back to Colour & Quantity section
       */
      handlePreviousStep() {
        console.log("[CustomizeProductSection] Previous step clicked");
        this.$emit("previous-step");
      },
      /**
       * Handle Next Step button click
       * Validate current section and proceed to Add-Ons
       */
      handleNextStep() {
        console.log("[CustomizeProductSection] Next step clicked");
        this.$emit("next-step");
      },
      /**
       * ✅ NEW: Handle design-returned event from DesignOnlineSimple
       * Called when user returns from Studio with created design
       */
      handleDesignReturned() {
        console.log("[AUTO_SWITCH] 📨 handleDesignReturned() event received from DesignOnlineSimple");
        this.selectedArtworkMethod = "design";
        console.log('[AUTO_SWITCH] Set selectedArtworkMethod = "design"');
        const imprintStore = useImprintStore();
        imprintStore.setSelectedArtworkMethod("design");
        console.log("[AUTO_SWITCH] Emitting design-online-returned to parent");
        this.$emit("design-online-returned");
        console.log("[AUTO_SWITCH] ✅ handleDesignReturned() complete");
      }
    },
    watch: {
      // ✅ Watch for Design Online data changes
      "designOnlineStore.stage": {
        handler(newStage, oldStage) {
          console.log("[AUTO_SWITCH] 👀 Stage changed:", { oldStage, newStage, hasDesign: this.designOnlineStore.hasDesign });
          if (newStage === "preview" && this.designOnlineStore.hasDesign) {
            console.log("[AUTO_SWITCH] 🎨 Design data detected - auto-switching to Design Online tab");
            if (this.selectedArtworkMethod === "design") {
              console.log("[AUTO_SWITCH] Already on Design Online tab, skipping");
              return;
            }
            this.selectedArtworkMethod = "design";
            const imprintStore = useImprintStore();
            imprintStore.setSelectedArtworkMethod("design");
            this.$emit("design-online-returned");
            console.log("[AUTO_SWITCH] ✅ Switched to Design Online tab");
          }
        },
        immediate: false
      }
    },
    mounted() {
      console.log("[AUTO_SWITCH] CustomizeProductSection.mounted() - START");
      const opsProductId = this.designOnlineStore.initProductId();
      if (opsProductId) {
        this.designOnlineStore.checkSupport(opsProductId, null, {
          design_enabled: true,
          force_probe: false
        }).then(() => {
          console.log("[AUTO_SWITCH] Design Online support check done, isSupported:", this.designOnlineStore.isSupported);
        });
      }
      const restoredImprint = this.newImprintStore.restoreFromSessionStorage();
      const restoredSelection = this.selectionStore.restoreFromSessionStorage();
      if (restoredImprint || restoredSelection) {
        console.log("[AUTO_SWITCH] ✅ Restored imprint/selection data");
      }
      console.log("[AUTO_SWITCH] 🔍 Manually restoring Design Online data...");
      const restoredDesign = this.designOnlineStore.restoreFromStorage();
      console.log("[AUTO_SWITCH] Design Online restore result:", restoredDesign);
      const { tokenId, exParam } = this.designOnlineStore.readReturnParamsFromUrl();
      if (tokenId && exParam) {
        console.log("[AUTO_SWITCH] 🔗 Detected URL parameters from Studio return:", { tokenId, exParam });
        console.log("[AUTO_SWITCH] 🔄 Calling handleReturn() to fetch design data from API...");
        this.designOnlineStore.handleReturn(tokenId, exParam).then((success) => {
          console.log("[AUTO_SWITCH] handleReturn() completed:", success);
        }).catch((error) => {
          console.error("[AUTO_SWITCH] handleReturn() failed:", error);
        });
      }
      console.log("[AUTO_SWITCH] Checking Design Online state:", {
        stage: this.designOnlineStore.stage,
        hasDesign: this.designOnlineStore.hasDesign
      });
      if (this.designOnlineStore.stage === "preview" && this.designOnlineStore.hasDesign) {
        console.log("[AUTO_SWITCH] 🎨 Detected existing Design Online data - auto-switching tab");
        this.selectedArtworkMethod = "design";
        const imprintStore = useImprintStore();
        imprintStore.setSelectedArtworkMethod("design");
        this.$nextTick(() => {
          console.log("[AUTO_SWITCH] Emitting design-online-returned event");
          this.$emit("design-online-returned");
        });
        console.log("[AUTO_SWITCH] ✅ Switched to Design Online tab");
      } else {
        console.log("[AUTO_SWITCH] No Design Online data found, using default method:", this.selectedArtworkMethod);
        if (this.selectedArtworkMethod) {
          const imprintStore = useImprintStore();
          imprintStore.setSelectedArtworkMethod(this.selectedArtworkMethod);
          this.$emit("artwork-method-selected", this.selectedArtworkMethod);
        }
      }
      console.log("[AUTO_SWITCH] CustomizeProductSection.mounted() - END:", {
        imprints: this.newImprintStore.imprints.length,
        selectedMethod: this.selectedArtworkMethod,
        designStage: this.designOnlineStore.stage
      });
    },
    created() {
      console.log("[CustomizeProductSection] Available transform methods:", {
        transformToCartPayload: typeof this.newImprintStore.transformToCartPayload,
        transformSendArtworkToCart: typeof this.transformSendArtworkToCart,
        transformPreviousArtworkToCart: typeof this.transformPreviousArtworkToCart,
        transformDesignOnlineToCart: typeof this.transformDesignOnlineToCart,
        // ✅ ISSUE 1: Added
        getCartPayload: typeof this.getCartPayload
      });
    }
  };
  const _hoisted_1$8 = { class: "customize-product-section" };
  const _hoisted_2$5 = { class: "imprint-selection" };
  const _hoisted_3$4 = { class: "instruction-text" };
  const _hoisted_4$3 = ["innerHTML"];
  const _hoisted_5$3 = { class: "method-buttons" };
  const _hoisted_6$3 = {
    key: 0,
    class: "method-content"
  };
  const _hoisted_7$3 = {
    key: 0,
    class: "start-new-imprint"
  };
  const _hoisted_8$3 = {
    key: 1,
    class: "method-panel"
  };
  const _hoisted_9$3 = { class: "special-instructions-section" };
  const _hoisted_10$3 = {
    key: 2,
    class: "method-panel"
  };
  const _hoisted_11$3 = { class: "special-instructions-section" };
  const _hoisted_12$3 = {
    key: 3,
    class: "method-panel"
  };
  const _hoisted_13$3 = { class: "navigation-buttons" };
  function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BaseButton = resolveComponent("BaseButton");
    const _component_StartNewImprintForm = resolveComponent("StartNewImprintForm");
    const _component_NewImprintModule = resolveComponent("NewImprintModule");
    const _component_AddImprintLocationButton = resolveComponent("AddImprintLocationButton");
    const _component_ImprintMethodSelector = resolveComponent("ImprintMethodSelector");
    const _component_ImprintLocationSelector = resolveComponent("ImprintLocationSelector");
    const _component_DesignOnlineSimple = resolveComponent("DesignOnlineSimple");
    const _component_StateDebuggerNewImprint = resolveComponent("StateDebuggerNewImprint");
    const _component_CartPayloadTester = resolveComponent("CartPayloadTester");
    const _component_ConfirmDialog = resolveComponent("ConfirmDialog");
    return openBlock(), createElementBlock("div", _hoisted_1$8, [
      createBaseVNode("div", _hoisted_2$5, [
        _cache[4] || (_cache[4] = createBaseVNode("div", { class: "divider-line" }, null, -1)),
        createBaseVNode("div", _hoisted_3$4, [
          createBaseVNode("p", null, toDisplayString($data.instructionText), 1),
          createBaseVNode("p", { innerHTML: $data.instructionTextAdditional }, null, 8, _hoisted_4$3)
        ]),
        createBaseVNode("div", _hoisted_5$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.artworkMethods, (method) => {
            return openBlock(), createBlock(_component_BaseButton, {
              key: method.id,
              text: method.label,
              variant: $data.selectedArtworkMethod === method.id ? "primary" : "secondary",
              size: "medium",
              icon: $data.iconComponents[method.iconName],
              "icon-position": "top",
              class: "method-button",
              onClick: ($event) => $options.selectMethod(method.id)
            }, null, 8, ["text", "variant", "icon", "onClick"]);
          }), 128))
        ]),
        _cache[5] || (_cache[5] = createBaseVNode("div", { class: "divider-line" }, null, -1))
      ]),
      $data.selectedArtworkMethod ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
        $data.selectedArtworkMethod === "new" ? (openBlock(), createElementBlock("div", _hoisted_7$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($setup.newImprintStore.imprints, (imprint, index) => {
            return openBlock(), createBlock(_component_NewImprintModule, {
              key: index,
              title: $options.getImprintTitle(index),
              "imprint-key": index,
              collapsible: true,
              "initial-collapsed": false,
              deletable: index > 0,
              onDeleteRequested: $options.handleDeleteImprint
            }, {
              default: withCtx(() => [
                createVNode(_component_StartNewImprintForm, {
                  "imprint-key": index,
                  onMethodChanged: $options.handleImprintMethodChanged,
                  onLocationChanged: $options.handleLocationChanged,
                  onMessageTypeChanged: $options.handleMessageTypeChanged,
                  onLinesChanged: $options.handleLinesChanged,
                  onImageUploaded: $options.handleImageUploaded,
                  onImageRemoved: $options.handleImageRemoved,
                  onSpecialInstructionsChanged: $options.handleSpecialInstructionsChanged
                }, null, 8, ["imprint-key", "onMethodChanged", "onLocationChanged", "onMessageTypeChanged", "onLinesChanged", "onImageUploaded", "onImageRemoved", "onSpecialInstructionsChanged"])
              ]),
              _: 2
            }, 1032, ["title", "imprint-key", "deletable", "onDeleteRequested"]);
          }), 128)),
          !$setup.appStore.isEnvelopProduct && $options.canAddMoreImprints ? (openBlock(), createBlock(_component_AddImprintLocationButton, {
            key: 0,
            onAddImprint: $options.handleAddImprint
          }, null, 8, ["onAddImprint"])) : createCommentVNode("", true)
        ])) : $data.selectedArtworkMethod === "send" ? (openBlock(), createElementBlock("div", _hoisted_8$3, [
          createVNode(_component_NewImprintModule, {
            title: "Send Us Your Artwork",
            collapsible: false,
            deletable: false
          }, {
            default: withCtx(() => [
              createVNode(_component_ImprintMethodSelector, { onMethodSelected: $options.handleImprintMethodChanged }, null, 8, ["onMethodSelected"]),
              createVNode(_component_ImprintLocationSelector, {
                label: "2. Choose an Imprint Location",
                onLocationSelected: $options.handleLocationChanged
              }, null, 8, ["onLocationSelected"]),
              createBaseVNode("div", _hoisted_9$3, [
                _cache[6] || (_cache[6] = createBaseVNode("label", { class: "section-label" }, "3. Imprint Details", -1)),
                withDirectives(createBaseVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.sendArtworkInstructions = $event),
                  rows: "5",
                  placeholder: "Provide any details you would like the art team to know about your artwork to create your proof",
                  onInput: _cache[1] || (_cache[1] = (...args) => $options.handleSendArtworkInstructionsChange && $options.handleSendArtworkInstructionsChange(...args))
                }, null, 544), [
                  [vModelText, $data.sendArtworkInstructions]
                ])
              ])
            ]),
            _: 1
          })
        ])) : $data.selectedArtworkMethod === "previous" ? (openBlock(), createElementBlock("div", _hoisted_10$3, [
          createVNode(_component_NewImprintModule, {
            title: "Use My Previous Artwork",
            collapsible: false,
            deletable: false
          }, {
            default: withCtx(() => [
              createVNode(_component_ImprintMethodSelector, { onMethodSelected: $options.handleImprintMethodChanged }, null, 8, ["onMethodSelected"]),
              createVNode(_component_ImprintLocationSelector, {
                label: "2. Choose an Imprint Location",
                onLocationSelected: $options.handleLocationChanged
              }, null, 8, ["onLocationSelected"]),
              createBaseVNode("div", _hoisted_11$3, [
                _cache[7] || (_cache[7] = createBaseVNode("label", { class: "section-label" }, "3. Imprint Details", -1)),
                withDirectives(createBaseVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.previousArtworkInstructions = $event),
                  rows: "5",
                  placeholder: "Provide any details you would like the art team to know about your artwork to create your proof",
                  onInput: _cache[3] || (_cache[3] = (...args) => $options.handlePreviousArtworkInstructionsChange && $options.handlePreviousArtworkInstructionsChange(...args))
                }, null, 544), [
                  [vModelText, $data.previousArtworkInstructions]
                ])
              ])
            ]),
            _: 1
          })
        ])) : $data.selectedArtworkMethod === "design" ? (openBlock(), createElementBlock("div", _hoisted_12$3, [
          createVNode(_component_NewImprintModule, {
            title: "Design Online",
            collapsible: false,
            deletable: false
          }, {
            default: withCtx(() => [
              createVNode(_component_DesignOnlineSimple, {
                "product-id": $setup.appStore.mainProductId,
                sku: $setup.appStore.productSku,
                onDesignReturned: $options.handleDesignReturned
              }, null, 8, ["product-id", "sku", "onDesignReturned"])
            ]),
            _: 1
          })
        ])) : createCommentVNode("", true)
      ])) : createCommentVNode("", true),
      createBaseVNode("div", _hoisted_13$3, [
        createVNode(_component_BaseButton, {
          text: $options.previousStepText,
          variant: "outline",
          size: "medium",
          onClick: $options.handlePreviousStep
        }, null, 8, ["text", "onClick"]),
        createVNode(_component_BaseButton, {
          text: $options.nextStepButtonText,
          variant: "primary",
          size: "medium",
          onClick: $options.handleNextStep
        }, null, 8, ["text", "onClick"])
      ]),
      $setup.debugConfig.showStateDebugger ? (openBlock(), createBlock(_component_StateDebuggerNewImprint, { key: 1 })) : createCommentVNode("", true),
      $setup.debugConfig.showCartPayloadTester ? (openBlock(), createBlock(_component_CartPayloadTester, { key: 2 })) : createCommentVNode("", true),
      createVNode(_component_ConfirmDialog)
    ]);
  }
  const CustomizeProductSection = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-dfabd23c"]]);
  const _sfc_main$7 = {
    name: "CustomizeSection",
    data() {
      return {
        location: null,
        artwork: null,
        text: ""
      };
    },
    methods: {
      handleLocationChange(location2) {
        this.location = location2;
        this.$emit("location-changed", location2);
      },
      handleArtworkUpload(file) {
        this.artwork = file;
        this.$emit("artwork-uploaded", file);
      }
    }
  };
  const _hoisted_1$7 = { class: "customize-section" };
  function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$7, [..._cache[0] || (_cache[0] = [
      createBaseVNode("h3", { class: "section-title" }, "Customize Your Product", -1),
      createBaseVNode("div", { class: "customization-options" }, [
        createBaseVNode("p", { class: "placeholder" }, "Customization options will go here"),
        createBaseVNode("div", { class: "migration-notes" }, [
          createBaseVNode("h4", null, "Components to migrate:"),
          createBaseVNode("ul", null, [
            createBaseVNode("li", null, "ImprintLocation.vue - Choose imprint location"),
            createBaseVNode("li", null, "UploadImage.vue - Upload artwork"),
            createBaseVNode("li", null, "Text input fields"),
            createBaseVNode("li", null, "Preview functionality")
          ])
        ])
      ], -1)
    ])]);
  }
  const CustomizeSection = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__scopeId", "data-v-78d11845"]]);
  const _sfc_main$6 = {
    name: "AddOnsSection",
    data() {
      return {
        selectedAddons: []
      };
    },
    methods: {
      toggleAddon(addonId) {
        const index = this.selectedAddons.indexOf(addonId);
        if (index > -1) {
          this.selectedAddons.splice(index, 1);
        } else {
          this.selectedAddons.push(addonId);
        }
        this.$emit("addons-changed", this.selectedAddons);
      }
    }
  };
  const _hoisted_1$6 = { class: "addons-section" };
  function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$6, [..._cache[0] || (_cache[0] = [
      createBaseVNode("h3", { class: "section-title" }, "Add-Ons", -1),
      createBaseVNode("div", { class: "addons-list" }, [
        createBaseVNode("p", { class: "placeholder" }, "Add-ons and extras will go here"),
        createBaseVNode("div", { class: "migration-notes" }, [
          createBaseVNode("h4", null, "Potential add-ons:"),
          createBaseVNode("ul", null, [
            createBaseVNode("li", null, "Rush production"),
            createBaseVNode("li", null, "Additional imprint locations"),
            createBaseVNode("li", null, "Packaging options"),
            createBaseVNode("li", null, "Proof services")
          ])
        ])
      ], -1)
    ])]);
  }
  const AddOnsSection = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__scopeId", "data-v-58b50a9d"]]);
  const _sfc_main$5 = {
    name: "ImprintSummary",
    props: {
      title: {
        type: String,
        default: "Imprint"
      },
      imprintData: {
        type: Object,
        required: true
      },
      imprintIndex: {
        type: Number,
        default: 0
      }
    },
    computed: {
      textLines() {
        return (this.imprintData.textLines || []).filter((line) => line.type === "message");
      }
    }
  };
  const _hoisted_1$5 = { class: "imprint-summary-debug" };
  const _hoisted_2$4 = { class: "debug-header" };
  const _hoisted_3$3 = { class: "debug-title" };
  const _hoisted_4$2 = { class: "debug-index" };
  const _hoisted_5$2 = { class: "debug-content" };
  const _hoisted_6$2 = { class: "debug-section" };
  const _hoisted_7$2 = { class: "debug-value" };
  const _hoisted_8$2 = { class: "debug-section" };
  const _hoisted_9$2 = { class: "debug-value" };
  const _hoisted_10$2 = { key: 0 };
  const _hoisted_11$2 = {
    key: 1,
    class: "null-value"
  };
  const _hoisted_12$2 = { class: "debug-section" };
  const _hoisted_13$2 = { class: "debug-value" };
  const _hoisted_14$2 = { class: "debug-section" };
  const _hoisted_15$2 = { class: "debug-label" };
  const _hoisted_16$2 = { class: "type-badge" };
  const _hoisted_17$2 = { class: "debug-value" };
  const _hoisted_18$2 = { key: 0 };
  const _hoisted_19$2 = {
    key: 1,
    class: "empty-array"
  };
  const _hoisted_20$2 = { class: "debug-section" };
  const _hoisted_21$2 = { class: "debug-value" };
  const _hoisted_22$2 = { key: 0 };
  const _hoisted_23$1 = {
    key: 1,
    class: "null-value"
  };
  const _hoisted_24$1 = { class: "debug-section" };
  const _hoisted_25$1 = { class: "debug-value" };
  const _hoisted_26$1 = { key: 0 };
  const _hoisted_27$1 = {
    key: 1,
    class: "empty-value"
  };
  const _hoisted_28$1 = { class: "debug-section" };
  const _hoisted_29$1 = { class: "debug-value" };
  const _hoisted_30$1 = { key: 0 };
  const _hoisted_31$1 = {
    key: 1,
    class: "null-value"
  };
  const _hoisted_32$1 = {
    key: 0,
    class: "debug-section error-section"
  };
  const _hoisted_33$1 = { class: "debug-value" };
  function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$5, [
      createBaseVNode("div", _hoisted_2$4, [
        createBaseVNode("span", _hoisted_3$3, toDisplayString($props.title), 1),
        createBaseVNode("span", _hoisted_4$2, "[Index: " + toDisplayString($props.imprintIndex) + "]", 1)
      ]),
      createBaseVNode("div", _hoisted_5$2, [
        createBaseVNode("div", _hoisted_6$2, [
          _cache[0] || (_cache[0] = createBaseVNode("div", { class: "debug-label" }, "Raw imprintData:", -1)),
          createBaseVNode("pre", _hoisted_7$2, toDisplayString(JSON.stringify($props.imprintData, null, 2)), 1)
        ]),
        createBaseVNode("div", _hoisted_8$2, [
          _cache[6] || (_cache[6] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("location "),
            createBaseVNode("span", { class: "type-badge" }, "Object")
          ], -1)),
          createBaseVNode("div", _hoisted_9$2, [
            $props.imprintData.location ? (openBlock(), createElementBlock("div", _hoisted_10$2, [
              createTextVNode(' sku: "' + toDisplayString($props.imprintData.location.sku) + '" ', 1),
              _cache[1] || (_cache[1] = createBaseVNode("span", { class: "type-badge" }, "string", -1)),
              _cache[2] || (_cache[2] = createBaseVNode("br", null, null, -1)),
              createTextVNode(' title: "' + toDisplayString($props.imprintData.location.title) + '" ', 1),
              _cache[3] || (_cache[3] = createBaseVNode("span", { class: "type-badge" }, "string", -1)),
              _cache[4] || (_cache[4] = createBaseVNode("br", null, null, -1)),
              createTextVNode(" imprintLines: " + toDisplayString($props.imprintData.location.imprintLines) + " ", 1),
              _cache[5] || (_cache[5] = createBaseVNode("span", { class: "type-badge" }, "number", -1))
            ])) : (openBlock(), createElementBlock("div", _hoisted_11$2, "null"))
          ])
        ]),
        createBaseVNode("div", _hoisted_12$2, [
          _cache[7] || (_cache[7] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("messageType "),
            createBaseVNode("span", { class: "type-badge" }, "string")
          ], -1)),
          createBaseVNode("div", _hoisted_13$2, '"' + toDisplayString($props.imprintData.messageType) + '"', 1)
        ]),
        createBaseVNode("div", _hoisted_14$2, [
          createBaseVNode("div", _hoisted_15$2, [
            _cache[8] || (_cache[8] = createTextVNode("textLines ", -1)),
            createBaseVNode("span", _hoisted_16$2, "Array[" + toDisplayString($options.textLines.length) + "]", 1)
          ]),
          createBaseVNode("div", _hoisted_17$2, [
            $options.textLines.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_18$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.textLines, (line, index) => {
                return openBlock(), createElementBlock("div", {
                  key: line.id,
                  class: "array-item"
                }, [
                  createTextVNode(" [" + toDisplayString(index) + "] {", 1),
                  _cache[9] || (_cache[9] = createBaseVNode("br", null, null, -1)),
                  createTextVNode("   id: " + toDisplayString(line.id) + " ", 1),
                  _cache[10] || (_cache[10] = createBaseVNode("span", { class: "type-badge" }, "number", -1)),
                  _cache[11] || (_cache[11] = createTextVNode(",", -1)),
                  _cache[12] || (_cache[12] = createBaseVNode("br", null, null, -1)),
                  createTextVNode('   type: "' + toDisplayString(line.type) + '" ', 1),
                  _cache[13] || (_cache[13] = createBaseVNode("span", { class: "type-badge" }, "string", -1)),
                  _cache[14] || (_cache[14] = createTextVNode(",", -1)),
                  _cache[15] || (_cache[15] = createBaseVNode("br", null, null, -1)),
                  createTextVNode('   message: "' + toDisplayString(line.message) + '" ', 1),
                  _cache[16] || (_cache[16] = createBaseVNode("span", { class: "type-badge" }, "string", -1)),
                  _cache[17] || (_cache[17] = createTextVNode(",", -1)),
                  _cache[18] || (_cache[18] = createBaseVNode("br", null, null, -1)),
                  createTextVNode('   selectedColor: "' + toDisplayString(line.selectedColor) + '" ', 1),
                  _cache[19] || (_cache[19] = createBaseVNode("span", { class: "type-badge" }, "string", -1)),
                  _cache[20] || (_cache[20] = createTextVNode(",", -1)),
                  _cache[21] || (_cache[21] = createBaseVNode("br", null, null, -1)),
                  createTextVNode("   selectedColorObj: " + toDisplayString(line.selectedColorObj ? `{sku: "${line.selectedColorObj.sku}", desc: "${line.selectedColorObj.desc}"}` : "null") + " ", 1),
                  _cache[22] || (_cache[22] = createBaseVNode("span", { class: "type-badge" }, "Object|null", -1)),
                  _cache[23] || (_cache[23] = createTextVNode(",", -1)),
                  _cache[24] || (_cache[24] = createBaseVNode("br", null, null, -1)),
                  createTextVNode("   customColor: " + toDisplayString(line.customColor) + " ", 1),
                  _cache[25] || (_cache[25] = createBaseVNode("span", { class: "type-badge" }, "boolean", -1)),
                  _cache[26] || (_cache[26] = createBaseVNode("br", null, null, -1)),
                  _cache[27] || (_cache[27] = createTextVNode(" } ", -1))
                ]);
              }), 128))
            ])) : (openBlock(), createElementBlock("div", _hoisted_19$2, "[]"))
          ])
        ]),
        createBaseVNode("div", _hoisted_20$2, [
          _cache[28] || (_cache[28] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("imageData "),
            createBaseVNode("span", { class: "type-badge" }, "Object|null")
          ], -1)),
          createBaseVNode("div", _hoisted_21$2, [
            $props.imprintData.imageData ? (openBlock(), createElementBlock("div", _hoisted_22$2, toDisplayString(JSON.stringify($props.imprintData.imageData, null, 2)), 1)) : (openBlock(), createElementBlock("div", _hoisted_23$1, "null"))
          ])
        ]),
        createBaseVNode("div", _hoisted_24$1, [
          _cache[29] || (_cache[29] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("specialInstructions "),
            createBaseVNode("span", { class: "type-badge" }, "string")
          ], -1)),
          createBaseVNode("div", _hoisted_25$1, [
            $props.imprintData.specialInstructions ? (openBlock(), createElementBlock("div", _hoisted_26$1, ' "' + toDisplayString($props.imprintData.specialInstructions) + '" ', 1)) : (openBlock(), createElementBlock("div", _hoisted_27$1, '""'))
          ])
        ]),
        createBaseVNode("div", _hoisted_28$1, [
          _cache[38] || (_cache[38] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("applyToAll "),
            createBaseVNode("span", { class: "type-badge" }, "Object")
          ], -1)),
          createBaseVNode("div", _hoisted_29$1, [
            $props.imprintData.applyToAll ? (openBlock(), createElementBlock("div", _hoisted_30$1, [
              _cache[30] || (_cache[30] = createTextVNode(" {", -1)),
              _cache[31] || (_cache[31] = createBaseVNode("br", null, null, -1)),
              createTextVNode("   active: " + toDisplayString($props.imprintData.applyToAll.active) + " ", 1),
              _cache[32] || (_cache[32] = createBaseVNode("span", { class: "type-badge" }, "boolean", -1)),
              _cache[33] || (_cache[33] = createTextVNode(",", -1)),
              _cache[34] || (_cache[34] = createBaseVNode("br", null, null, -1)),
              createTextVNode("   sourceLineId: " + toDisplayString($props.imprintData.applyToAll.sourceLineId) + " ", 1),
              _cache[35] || (_cache[35] = createBaseVNode("span", { class: "type-badge" }, "number|null", -1)),
              _cache[36] || (_cache[36] = createBaseVNode("br", null, null, -1)),
              _cache[37] || (_cache[37] = createTextVNode(" } ", -1))
            ])) : (openBlock(), createElementBlock("div", _hoisted_31$1, "null"))
          ])
        ]),
        $props.imprintData.errors && Object.keys($props.imprintData.errors).length > 0 ? (openBlock(), createElementBlock("div", _hoisted_32$1, [
          _cache[39] || (_cache[39] = createBaseVNode("div", { class: "debug-label" }, [
            createTextVNode("errors "),
            createBaseVNode("span", { class: "type-badge" }, "Object")
          ], -1)),
          createBaseVNode("div", _hoisted_33$1, [
            createBaseVNode("pre", null, toDisplayString(JSON.stringify($props.imprintData.errors, null, 2)), 1)
          ])
        ])) : createCommentVNode("", true)
      ])
    ]);
  }
  const ImprintSummary = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-ab8edc89"]]);
  const _sfc_main$4 = {
    name: "ReviewSection",
    components: {
      ImprintSummary
    },
    data() {
      return {
        specialInstructions: "",
        validationErrors: {
          specialInstructions: ""
        }
      };
    },
    setup() {
      const imprintStore = useImprintStore();
      const newImprintStore = useNewImprintStore();
      const selectionStore = useSelectionStore();
      const addToCartStore = useAddToCartStore();
      const appStore = useAppStore();
      const calendarStore = useCalendarStore();
      const colorName = getColorName();
      const sectionValidation = useSectionValidation();
      console.log("SETUP");
      console.log(selectionStore);
      return {
        newImprintStore,
        imprintStore,
        selectionStore,
        addToCartStore,
        appStore,
        calendarStore,
        debugConfig: DEBUG_CONFIG,
        colorName,
        sectionValidation
      };
    },
    computed: {
      /**
       * Dynamic text for Previous Step button
       * Changes based on whether Add-Ons section is visible
       */
      previousStepButtonText() {
        if (this.debugConfig.showAddOnsSection) {
          return "← Previous Step: Add-Ons";
        }
        return "← Previous Step: Customize";
      },
      // Get selected artwork method data
      selectedArtworkMethodData() {
        const methodId = this.imprintStore.selectedArtworkMethod;
        console.log("[ReviewSection] Computing selectedArtworkMethodData, methodId:", methodId);
        if (!methodId) {
          console.log("[ReviewSection] No methodId");
          return null;
        }
        const found = ARTWORK_METHODS.find((m) => m.id === methodId);
        console.log("[ReviewSection] Found artwork method:", found);
        return found;
      },
      // Get selected imprint method data
      selectedImprintMethodData() {
        var _a, _b, _c;
        const selected = this.imprintStore.selectedImprintMethod;
        console.log("[ReviewSection] Computing selectedImprintMethodData:", selected);
        if (!selected || !selected.sku) {
          console.log("[ReviewSection] No selected.sku");
          return null;
        }
        const enhancedData = getImprintMethodBySku(selected.sku);
        console.log("[ReviewSection] Enhanced data:", enhancedData);
        let imagePath = null;
        if (enhancedData == null ? void 0 : enhancedData.image) {
          imagePath = this.getImagePath(enhancedData.image);
        } else if ((_a = selected.data) == null ? void 0 : _a.image) {
          imagePath = selected.data.image;
        }
        return {
          name: (enhancedData == null ? void 0 : enhancedData.name) || selected.name,
          sku: selected.sku,
          description: (enhancedData == null ? void 0 : enhancedData.description) || ((_b = selected.data) == null ? void 0 : _b.description) || "",
          image: imagePath,
          // Will be null if no image
          price: ((_c = selected.data) == null ? void 0 : _c.price) || 0
        };
      },
      // Check if any selections have been made
      hasSelections() {
        return this.selectedArtworkMethodData || this.selectedImprintMethodData;
      },
      // Get color lines from store
      colorLines() {
        const imprintKey = this.imprintStore.getImprintMethodKey;
        if (!imprintKey) return [];
        return this.selectionStore.getLinesByImprintKey(imprintKey) || [];
      },
      // Get calendar products for calendar bundle mode
      calendarProducts() {
        if (!this.appStore.isCalendarMode) return [];
        console.log("[🎯 CALENDAR-PRICING] ReviewSection.calendarProducts called");
        const tierUnitPrice = this.calendarStore.unitPriceByTotalQty;
        const result = (this.calendarStore.products || []).map((product) => ({
          ...product,
          unitPrice: tierUnitPrice
        }));
        console.log("[🎯 CALENDAR-PRICING] ReviewSection result:", result);
        return result;
      },
      // Get extra charges (fees, upcharges, add-ons)
      extraCharges() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const charges = [];
        const sku = this.imprintStore.selectedImprintMethod.sku;
        if (!sku) return charges;
        const artworkMethod = this.imprintStore.selectedArtworkMethod || "new";
        const imprintKey = this.imprintStore.getImprintMethodKey;
        const totalQty = this.appStore.isCalendarMode ? this.calendarStore.totalQuantity : this.selectionStore.getTotalQtyByImprintKey(imprintKey);
        const isComda = this.isComdaStore;
        const backendConfig = this.backendFeeConfig;
        const allImprints = artworkMethod === "new" ? this.newImprintStore.imprints : [{ messageType: "text", textLines: [], imageData: null }];
        let totalSetupFee = 0;
        let totalSetupFeeQty = 0;
        let setupFeeUnitPrice = 0;
        let totalProofFee = 0;
        let totalRunningFee = 0;
        let totalImageFee = 0;
        let totalImageFeeQty = 0;
        let imageFeeUnitPrice = 0;
        let totalCustomColorFee = 0;
        let totalCustomColorFeeQty = 0;
        let customColorFeeUnitPrice = 0;
        const imprintsFees = [];
        const additionalColorRunCharges = [];
        console.log("[ReviewSection] Calculating fees for", allImprints.length, "imprints");
        const feesArray = ((_c = (_b = (_a = this.imprintStore.fullJson) == null ? void 0 : _a.configurable_array) == null ? void 0 : _b[sku]) == null ? void 0 : _c.fees) || [];
        const proofFeeUnit = getFeeUnit(feesArray, "PROOF", "per order");
        const runningFeeRate = backendConfig.running_fee || 0;
        allImprints.forEach((imprint, index) => {
          var _a2;
          const uniqueColorsCount = getUniqueColorsCount(imprint);
          const uniqueCustomColorsCount = getUniqueCustomColorsCount(imprint);
          const imageDataExists = hasUploadedImage(imprint);
          const messageType = (imprint == null ? void 0 : imprint.messageType) || "text";
          const messageTypeAllowsImage = messageType === "image" || messageType === "text_image";
          const hasImage = imageDataExists && messageTypeAllowsImage;
          getUniqueColorsCount(imprint);
          const isFirstImprintLocation = index === 0;
          const fees = calculateAllFees({
            uniqueColorsCount,
            totalQuantity: totalQty,
            hasPantoneColor: uniqueCustomColorsCount,
            hasImage,
            artworkMethod,
            isComda,
            backendConfig,
            isFirstImprintLocation
          });
          console.log(`[ReviewSection] Imprint ${index} (${((_a2 = imprint.selectedLocation) == null ? void 0 : _a2.title) || "No location"}) fees:`, {
            uniqueColorsCount,
            uniqueCustomColorsCount,
            hasImage,
            fees
          });
          imprintsFees.push(fees);
          totalSetupFee += fees.setup_fee || 0;
          totalSetupFeeQty += fees.setup_fee_qty || 0;
          setupFeeUnitPrice = fees.setup_fee_unit_price || setupFeeUnitPrice;
          totalImageFee += fees.image_fee || 0;
          totalImageFeeQty += fees.image_fee_qty || 0;
          imageFeeUnitPrice = fees.image_fee_unit_price || imageFeeUnitPrice;
          totalCustomColorFee += fees.customColourFee || 0;
          totalCustomColorFeeQty += fees.customColourFee_qty || 0;
          customColorFeeUnitPrice = fees.customColourFee_unit_price || customColorFeeUnitPrice;
          if (runningFeeRate > 0 && artworkMethod === "new") {
            const allColorsInImprint = [];
            const messageTypeLocal = (imprint == null ? void 0 : imprint.messageType) || "text";
            if (messageTypeLocal === "text" || messageTypeLocal === "text_image") {
              (imprint.textLines || []).forEach((line) => {
                if (!line || line.type === "image") return;
                const hasText = typeof line.message === "string" && line.message.trim().length > 0;
                if (!hasText) return;
                if (line.selectedColor) {
                  allColorsInImprint.push({
                    color: line.selectedColor,
                    isCustom: line.customColor === true
                  });
                }
              });
            }
            if (messageTypeLocal === "image" || messageTypeLocal === "text_image") {
              (imprint.textLines || []).forEach((line) => {
                var _a3;
                if (!line || line.type !== "image") return;
                const color = line.selectedColor || ((_a3 = line.selectedColorObj) == null ? void 0 : _a3.file_name);
                if (color) {
                  allColorsInImprint.push({ color, isCustom: false });
                }
              });
            }
            const seen = /* @__PURE__ */ new Set();
            const uniqueAll = allColorsInImprint.filter((c) => {
              const key = (c.isCustom ? "custom:" : "std:") + c.color;
              if (seen.has(key)) return false;
              seen.add(key);
              return true;
            });
            if (uniqueAll.length > 1) {
              uniqueAll.slice(1).forEach((c) => {
                const colorLabel = c.color.replace(/-/g, " ").trim();
                const chargeId = `running_fee_${index}_${c.color}`;
                additionalColorRunCharges.push({
                  id: chargeId,
                  name: `Additional Colour Run Fee (${colorLabel})`,
                  quantity: totalQty,
                  unitPrice: runningFeeRate,
                  subTotal: runningFeeRate * totalQty
                });
                totalRunningFee += runningFeeRate * totalQty;
              });
            }
          }
        });
        totalProofFee = combineProofFee(imprintsFees, proofFeeUnit);
        console.log("[ReviewSection] Total fees (sum of all imprints):", {
          totalSetupFee,
          totalProofFee,
          totalRunningFee,
          totalImageFee,
          totalCustomColorFee
        });
        if (totalSetupFee > 0 || !isComda) {
          charges.push({
            id: "setup_fee",
            name: `Setup Fee`,
            quantity: totalSetupFeeQty,
            unitPrice: setupFeeUnitPrice,
            subTotal: totalSetupFee
          });
        }
        if (totalProofFee > 0 || !isComda) {
          charges.push({
            id: "proof_fee",
            name: `Proof Fee`,
            quantity: totalProofFee > 0 ? 1 : 0,
            unitPrice: totalProofFee,
            subTotal: totalProofFee
          });
        }
        additionalColorRunCharges.forEach((charge) => {
          charges.push(charge);
        });
        if (totalImageFee > 0 || !isComda) {
          charges.push({
            id: "image_fee",
            name: `Image Upload Fee`,
            quantity: totalImageFeeQty,
            unitPrice: imageFeeUnitPrice,
            subTotal: totalImageFee
          });
        }
        if (totalCustomColorFee > 0 || !isComda) {
          charges.push({
            id: "custom_colour_fee",
            name: `Custom Color Fee`,
            quantity: totalCustomColorFeeQty,
            unitPrice: customColorFeeUnitPrice,
            subTotal: totalCustomColorFee
          });
        }
        if (this.imprintStore.sizeUpcharge && Object.keys(this.imprintStore.sizeUpcharge).length > 0) {
          const imprintKey2 = this.imprintStore.getImprintMethodKey;
          const totalSizesQty = this.selectionStore.getTotalSizesQtyByImprintKey(imprintKey2);
          for (const [size, qty] of Object.entries(totalSizesQty)) {
            const upcharge = this.imprintStore.sizeUpcharge[size];
            if (upcharge && Number(upcharge) > 0 && Number(qty) > 0) {
              charges.push({
                id: `size_upcharge_${size}`,
                name: `Apparel Upsize (${size})`,
                quantity: Number(qty),
                unitPrice: Number(upcharge),
                subTotal: Number(upcharge) * Number(qty)
              });
            }
          }
        }
        if (this.imprintStore.colorUpcharge && Object.keys(this.imprintStore.colorUpcharge).length > 0) {
          const imprintKey2 = this.imprintStore.getImprintMethodKey;
          const colorLines = this.selectionStore.getLinesByImprintKey(imprintKey2) || [];
          for (const line of colorLines) {
            const colorName = ((_e = (_d = line.slectedColor) == null ? void 0 : _d.title) == null ? void 0 : _e.toLowerCase()) || "";
            const colorUpchargeData = this.imprintStore.colorUpcharge[colorName];
            if (colorUpchargeData && line.totalQty > 0) {
              const qty = Number(line.totalQty);
              let upchargeAmount = 0;
              const priceType = colorUpchargeData.price_type;
              const isFixed = !priceType || priceType === "fixed" || priceType === "";
              if (isFixed) {
                upchargeAmount = Number(colorUpchargeData.price || 0);
              } else if (priceType === "percent") {
                const basePrice = this.getColorPrice(line);
                const percent = Number(colorUpchargeData.price || 0);
                upchargeAmount = basePrice * (percent / 100);
              }
              if (upchargeAmount !== 0) {
                const colorTitle = ((_g = (_f = line.slectedColor) == null ? void 0 : _f.title) == null ? void 0 : _g.replace(/-/g, " ")) || colorName;
                const chargeType = upchargeAmount < 0 ? "Downcharge" : "Upcharge";
                charges.push({
                  id: `color_upcharge_${colorName}`,
                  name: `Color ${chargeType} (${colorTitle})`,
                  quantity: qty,
                  unitPrice: upchargeAmount,
                  subTotal: upchargeAmount * qty
                });
              }
            }
          }
        }
        if (allImprints.length > 1) {
          const additionalLocationsCount = allImprints.length - 1;
          const feePerPiece = this.imprintStore.getAdditionalLocationFeePerPiece(totalQty);
          if (feePerPiece > 0) {
            for (let i = 0; i < additionalLocationsCount; i++) {
              const locationTitle = ((_i = (_h = allImprints[i + 1]) == null ? void 0 : _h.selectedLocation) == null ? void 0 : _i.title) || `Location ${i + 2}`;
              charges.push({
                id: `additional_location_fee_${i + 1}`,
                name: `Additional Location Fee (${locationTitle})`,
                quantity: totalQty,
                unitPrice: feePerPiece,
                subTotal: feePerPiece * totalQty
              });
            }
          }
          console.log("[ReviewSection] Additional location fees:", {
            additionalLocationsCount,
            feePerPiece,
            totalQty
          });
        }
        return charges;
      },
      // Validation - check if can proceed to cart
      // Get all imprints data
      allImprints() {
        return this.newImprintStore.imprints.map((imprint, index) => {
          return this.newImprintStore.imprints[index] ? {
            ...this.newImprintStore.getImprintData(),
            location: imprint.selectedLocation,
            messageType: imprint.messageType,
            textLines: imprint.textLines,
            imageData: imprint.imageData,
            specialInstructions: imprint.specialInstructions
          } : null;
        }).filter(Boolean);
      },
      // Check if has any imprint data
      hasImprintData() {
        return this.newImprintStore.imprints.length > 0 && this.newImprintStore.imprints.some(
          (imp) => {
            var _a, _b;
            return ((_a = imp.selectedLocation) == null ? void 0 : _a.sku) || ((_b = imp.textLines) == null ? void 0 : _b.length) > 0 || imp.imageData;
          }
        );
      },
      // Validation - uses unified sectionValidation
      isValid() {
        console.log("[ReviewSection] Computing isValid");
        if (!this.addToCartStore.isReadyToAddToCart) {
          console.log("[ReviewSection] Store not ready");
          return false;
        }
        if (this.addToCartStore.loader) {
          console.log("[ReviewSection] Currently loading");
          return false;
        }
        if (Object.values(this.validationErrors).some((error) => error !== "")) {
          console.log("[ReviewSection] Has local validation errors");
          return false;
        }
        if (this.storeValidationErrors.length > 0) {
          console.log("[ReviewSection] Has sectionValidation errors:", this.storeValidationErrors.length);
          return false;
        }
        console.log("[ReviewSection] isValid: true");
        return true;
      },
      // Check if currently loading
      isLoading() {
        return this.addToCartStore.loader;
      },
      // Get validation errors - using unified sectionValidation (same as StepIndicator)
      // Each error prefixed with Step number
      // Note: For calendar mode, Step 1 (Colour & Quantity) is skipped, so numbering starts from Step 1 = Customize
      storeValidationErrors() {
        const allErrors = [];
        const isCalendarMode = this.appStore.applicationType === "calendar";
        if (!isCalendarMode) {
          const step1Errors = this.sectionValidation.step1Validation.value.errors;
          step1Errors.forEach((error) => {
            allErrors.push(`Step 1: ${error}`);
          });
        }
        const step2Errors = this.sectionValidation.step2Validation.value.errors;
        const customizeStepNumber = isCalendarMode ? 1 : 2;
        step2Errors.forEach((error) => {
          allErrors.push(`Step ${customizeStepNumber}: ${error}`);
        });
        const step3Errors = this.sectionValidation.step3Validation.value.errors;
        const addOnsStepNumber = isCalendarMode ? 2 : 3;
        step3Errors.forEach((error) => {
          allErrors.push(`Step ${addOnsStepNumber}: ${error}`);
        });
        return allErrors;
      },
      // Check if this is a Comda store
      isComdaStore() {
        var _a;
        const domain = ((_a = window.Shopify) == null ? void 0 : _a.shop) || "";
        return domain.includes("comda");
      },
      // Get backend fee configuration
      backendFeeConfig() {
        var _a, _b;
        const sku = this.imprintStore.selectedImprintMethod.sku;
        if (!sku || !this.imprintStore.fullJson) {
          console.warn("[ReviewSection] No SKU or fullJson for backend config");
          return {};
        }
        const methodData = (_a = this.imprintStore.fullJson.configurable_array) == null ? void 0 : _a[sku];
        if (!((_b = methodData == null ? void 0 : methodData.configurable_2_data) == null ? void 0 : _b.imprint_data)) {
          console.warn("[ReviewSection] No imprint_data for SKU:", sku);
          return {};
        }
        const imprintData = methodData.configurable_2_data.imprint_data;
        const config = {
          setup_fee: imprintData.setup_fee || 0,
          running_fee: imprintData.running_fee || 0,
          custom_colour_fee: imprintData.custom_colour_fee || 0,
          image_fee: imprintData.image_fee || 0,
          proof_fee: imprintData.proof_fee || 0
        };
        console.log("[ReviewSection] Backend fee config:", config);
        return config;
      }
    },
    methods: {
      /**
       * Map error text to section ID for scroll navigation.
       * Returns null if no scroll target available.
       * @param {string} error
       * @returns {string|null}
       */
      sectionForError(error) {
        const isCalendar = this.appStore.isCalendarMode;
        if (error.startsWith("Step 1:") && !isCalendar) return "colourQuantity";
        if (error.startsWith("Step 1:") && isCalendar) return "imprintSelection";
        if (error.startsWith("Step 2:")) return "imprintSelection";
        return null;
      },
      /**
       * Parse error text → CSS selector for the specific DOM field.
       * Returns null when no specific field can be targeted (e.g. Step 1 errors).
       *
       * Supported error patterns (after stripping "Step N: " prefix):
       *   "Imprint 1, Line 1: Please enter text"       → text input
       *   "Imprint 1, Line 1: Please select a colour"  → colour swatch
       *   "Imprint 1: Please upload an image"           → image upload zone
       *   "Imprint 1: Please select image colour"       → image colour swatch
       *   "Imprint 1: Please select a location"         → location selector (section only)
       * @param {string} error
       * @returns {string|null}
       */
      fieldSelectorForError(error) {
        if (!error.startsWith("Step 2:")) return null;
        const text = error.replace(/^Step \d+:\s*/, "");
        const lineMatch = text.match(/^Imprint (\d+), Line (\d+):/);
        if (lineMatch) {
          const imprintIdx = parseInt(lineMatch[1]) - 1;
          const lineIdx = parseInt(lineMatch[2]) - 1;
          if (text.includes("enter text")) {
            return `[data-error-field="imprint-${imprintIdx}-line-${lineIdx}-text"]`;
          }
          return `[data-error-field="imprint-${imprintIdx}-line-${lineIdx}-color"]`;
        }
        const imprintMatch = text.match(/^Imprint (\d+):/);
        if (imprintMatch) {
          const imprintIdx = parseInt(imprintMatch[1]) - 1;
          if (text.toLowerCase().includes("upload an image")) {
            return `[data-error-field="imprint-${imprintIdx}-image-upload"]`;
          }
          if (text.toLowerCase().includes("image")) {
            return `[data-error-field="imprint-${imprintIdx}-image-color"]`;
          }
        }
        return null;
      },
      /**
       * Handle click on error item — emit scroll-to-field (or scroll-to-section as fallback).
       * Also triggers field-level validation so red borders appear on form fields.
       * @param {string} error
       */
      handleErrorClick(error) {
        if (this.imprintStore.selectedArtworkMethod === "new") {
          this.newImprintStore.imprints.forEach((_, index) => {
            this.newImprintStore.validate(index);
          });
        }
        const fieldSelector = this.fieldSelectorForError(error);
        const sectionId = this.sectionForError(error);
        if (fieldSelector && sectionId) {
          this.$emit("scroll-to-field", { sectionId, fieldSelector });
        } else if (sectionId) {
          this.$emit("scroll-to-section", sectionId);
        }
      },
      getImprintTitle(index) {
        const titles = ["First Imprint", "Second Imprint", "Third Imprint", "Fourth Imprint", "Fifth Imprint"];
        return titles[index] || `Imprint ${index + 1}`;
      },
      /**
       * Returns tooltip text for a given extra charge name.
       * Handles exact matches (case-insensitive) and prefix matches (e.g. "Apparel Upsize (3XL)").
       * @param {string} name - charge name from extraCharges array
       * @returns {string|null}
       */
      getFeeTooltip(name) {
        const FEE_TOOLTIPS = {
          "setup fee": "The industry standard cost associated with setting up the screen, die, laser, or other necessary items to imprint your specific logo.",
          "proof fee": "The cost to digitize your artwork (company name/logo/message) and digitally render it on a product for review prior to production.",
          "image fee": "The fees associated with formatting, retouching, and/or redrawing custom logos.",
          "image upload fee": "The fees associated with formatting, retouching, and/or redrawing custom logos.",
          "custom color fee": "PMS (Pantone) color match fee, applied when creating non-standard imprint colors (matching to existing logo, etc.).",
          "colour fee": "PMS (Pantone) color match fee, applied when creating non-standard imprint colors (matching to existing logo, etc.).",
          "color fee": "PMS (Pantone) color match fee, applied when creating non-standard imprint colors (matching to existing logo, etc.).",
          "running fee": "Pricing varies by product color, size, and material. Standard pricing includes 1 color imprint on standard products. 2XL sizes, different fabrics, etc. may be customized for additional fees.",
          "shipping fee": "The cost to cover the shipping and handling fees from our freight provider. To simplify the order process, all MLP orders qualify for free shipping!",
          "apparel upsize": "Pricing based on extra sizes."
        };
        const key = (name || "").toLowerCase().trim();
        if (FEE_TOOLTIPS[key]) return FEE_TOOLTIPS[key];
        for (const prefix of Object.keys(FEE_TOOLTIPS)) {
          if (key.startsWith(prefix)) return FEE_TOOLTIPS[prefix];
        }
        if (key.includes("run fee")) return FEE_TOOLTIPS["running fee"];
        return null;
      },
      handleImageError(event2) {
        console.warn("[ReviewSection] Failed to load image:", event2.target.src);
        event2.target.style.display = "none";
      },
      getImagePath(filename) {
        try {
          return new URL((/* @__PURE__ */ Object.assign({ "../../../assets/imprint-methods/cmyk.png": __vite_glob_0_0, "../../../assets/imprint-methods/dtg.png": __vite_glob_0_1, "../../../assets/imprint-methods/embroidery.png": __vite_glob_0_2, "../../../assets/imprint-methods/screenprint.png": __vite_glob_0_3 }))[`../../../assets/imprint-methods/${filename}`], _documentCurrentScript && _documentCurrentScript.tagName.toUpperCase() === "SCRIPT" && _documentCurrentScript.src || new URL("js/app.js", document.baseURI).href).href;
        } catch (e) {
          console.warn("[ReviewSection] Failed to load imprint method image:", filename, e);
          return null;
        }
      },
      formatPrice(price) {
        return Number(price).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      /**
       * Check if sale price is valid based on current date
       * @param {Object} tier - Tier price object
       * @returns {boolean} - True if sale price is valid
       */
      isSalePriceValid(tier) {
        if (!tier.sale_price) {
          return false;
        }
        if (!tier.sale_price_effectivedate || !tier.sale_price_terminationdate) {
          console.warn("[ReviewSection] Sale price missing dates, using regular price", tier);
          return false;
        }
        const today = /* @__PURE__ */ new Date();
        today.setHours(0, 0, 0, 0);
        const effectiveDate = new Date(tier.sale_price_effectivedate);
        effectiveDate.setHours(0, 0, 0, 0);
        const terminationDate = new Date(tier.sale_price_terminationdate);
        terminationDate.setHours(23, 59, 59, 999);
        const isValid = today >= effectiveDate && today <= terminationDate;
        console.log("[ReviewSection] Sale price date check:", {
          today: today.toISOString().split("T")[0],
          effectiveDate: tier.sale_price_effectivedate,
          terminationDate: tier.sale_price_terminationdate,
          isValid
        });
        return isValid;
      },
      // Get base price for color line
      getColorPrice(line) {
        var _a, _b, _c, _d, _e, _f, _g;
        const colorName = ((_b = (_a = line.slectedColor) == null ? void 0 : _a.title) == null ? void 0 : _b.toLowerCase()) || "";
        const colorUpcharge = (_c = this.imprintStore.colorUpcharge) == null ? void 0 : _c[colorName];
        const sku = this.imprintStore.selectedImprintMethod.sku;
        if (!sku) {
          console.warn("[ReviewSection] getColorPrice: No SKU");
          return 0;
        }
        const methodData = (_e = (_d = this.imprintStore.fullJson) == null ? void 0 : _d.configurable_array) == null ? void 0 : _e[sku];
        if (!methodData) {
          console.warn("[ReviewSection] getColorPrice: No method data for SKU:", sku);
          return 0;
        }
        const imprintKey = this.imprintStore.getImprintMethodKey;
        const quantity = this.selectionStore.getTotalQtyByImprintKey(imprintKey);
        let basePrice = 0;
        const tierPrices = ((_f = methodData.prices_2) == null ? void 0 : _f.tier_price) || [];
        console.log("[ReviewSection] getColorPrice:", {
          colorName,
          quantity,
          hasTierPrices: tierPrices.length > 0,
          tierPricesCount: tierPrices.length,
          min_price: (_g = methodData.prices_2) == null ? void 0 : _g.min_price
        });
        if (tierPrices.length > 0) {
          const sortedTiers = [...tierPrices].sort((a, b) => Number(b.QtyMin || 0) - Number(a.QtyMin || 0));
          const b2bTiers = this.appStore.getB2BTierForSku(sku);
          for (const tier of sortedTiers) {
            if (quantity >= Number(tier.QtyMin || 0)) {
              const b2bEntry = b2bTiers ? b2bTiers.find((t) => Number(t.QtyMin) === Number(tier.QtyMin)) : null;
              if (b2bEntry) {
                basePrice = Number(b2bEntry.price);
                console.log("[ReviewSection] Using B2B price:", basePrice, "for qty:", quantity);
              } else if (this.isSalePriceValid(tier)) {
                basePrice = Number(tier.sale_price);
                console.log("[ReviewSection] Using VALID sale_price:", basePrice, "for qty:", quantity);
              } else {
                basePrice = Number(tier.price || 0);
                console.log("[ReviewSection] Using regular price:", basePrice, "for qty:", quantity, "(sale not valid)");
              }
              break;
            }
          }
          if (basePrice === 0 && tierPrices.length > 0) {
            const lowestTier = tierPrices[0];
            const b2bEntry = b2bTiers ? b2bTiers.find((t) => Number(t.QtyMin) === Number(lowestTier.QtyMin)) : null;
            if (b2bEntry) {
              basePrice = Number(b2bEntry.price);
            } else if (this.isSalePriceValid(lowestTier)) {
              basePrice = Number(lowestTier.sale_price);
              console.log("[ReviewSection] Using lowest tier VALID sale_price:", basePrice);
            } else {
              basePrice = Number(lowestTier.price || 0);
              console.log("[ReviewSection] Using lowest tier regular price:", basePrice, "(sale not valid)");
            }
          }
        } else {
          const pricesData = methodData.prices_2;
          if (pricesData.sale_min_price && pricesData.sale_min_price_effectivedate && pricesData.sale_min_price_terminationdate) {
            const today = /* @__PURE__ */ new Date();
            today.setHours(0, 0, 0, 0);
            const effectiveDate = new Date(pricesData.sale_min_price_effectivedate);
            effectiveDate.setHours(0, 0, 0, 0);
            const terminationDate = new Date(pricesData.sale_min_price_terminationdate);
            terminationDate.setHours(23, 59, 59, 999);
            if (today >= effectiveDate && today <= terminationDate) {
              basePrice = Number(pricesData.sale_min_price);
              console.log("[ReviewSection] Using VALID sale_min_price as fallback:", basePrice);
            } else {
              basePrice = Number(pricesData.min_price || 0);
              console.log("[ReviewSection] Using min_price as fallback:", basePrice, "(sale_min_price not valid)");
            }
          } else {
            basePrice = Number(pricesData.min_price || 0);
            console.log("[ReviewSection] Using min_price as fallback:", basePrice, "(no sale_min_price)");
          }
        }
        if (colorUpcharge) {
          console.log("[ReviewSection] Color upcharge found for", colorName, ":", colorUpcharge);
          console.log("[ReviewSection] Color upcharge will be shown as separate line in Extra Charges");
        }
        console.log("[ReviewSection] Final price:", basePrice);
        return basePrice;
      },
      // Calculate total for color line
      getColorLineTotal(line) {
        const unitPrice = this.getColorPrice(line);
        const quantity = Number(line.totalQty || 0);
        return unitPrice * quantity;
      },
      // Calculate grand total
      calculateTotal() {
        let total = 0;
        if (this.appStore.isCalendarMode) {
          this.calendarProducts.forEach((calendar) => {
            total += (calendar.qty || 0) * (calendar.unitPrice || 0);
          });
        } else {
          this.colorLines.forEach((line) => {
            total += this.getColorLineTotal(line);
          });
        }
        this.extraCharges.forEach((charge) => {
          total += Number(charge.subTotal || 0);
        });
        return total;
      },
      // Handle special instructions change
      onSpecialInstructionsChange() {
        if (this.specialInstructions.length > 500) {
          this.validationErrors.specialInstructions = "Instructions cannot exceed 500 characters";
        } else {
          this.validationErrors.specialInstructions = "";
        }
        this.selectionStore.setSpecialInstructions(this.specialInstructions);
      },
      // Validate all fields
      validateAll() {
        let isValid = true;
        if (this.specialInstructions.length > 500) {
          this.validationErrors.specialInstructions = "Instructions cannot exceed 500 characters";
          isValid = false;
        }
        if (!this.appStore.isCalendarMode) {
          if (this.colorLines.length === 0) {
            console.warn("[ReviewSection] No color selections");
            isValid = false;
          }
        }
        return isValid;
      },
      async handleAddToCart() {
        if (this.appStore.isOutOfStock) {
          console.warn("[ReviewSection] Add to Cart blocked: product is Out of Stock");
          return;
        }
        if (this.storeValidationErrors.length > 0) {
          if (this.imprintStore.selectedArtworkMethod === "new") {
            this.newImprintStore.imprints.forEach((_, index) => {
              this.newImprintStore.validate(index);
            });
          }
          const sectionsWithErrors = [];
          if (!this.appStore.isCalendarMode && this.sectionValidation.step1Validation.value.hasErrors) {
            sectionsWithErrors.push("colourQuantity");
          }
          if (this.sectionValidation.step2Validation.value.hasErrors) {
            sectionsWithErrors.push("imprintSelection");
          }
          this.$emit("validation-failed", sectionsWithErrors);
          return;
        }
        if (!this.validateAll()) {
          console.warn("[ReviewSection] Validation failed");
          return;
        }
        if (!this.isValid) {
          console.warn("[ReviewSection] Cannot add to cart - validation failed");
          return;
        }
        this.selectionStore.setSpecialInstructions(this.specialInstructions);
        console.log("[ReviewSection] Adding to cart with selections:", {
          artworkMethod: this.imprintStore.selectedArtworkMethod,
          imprintMethod: this.imprintStore.selectedImprintMethod,
          specialInstructions: this.specialInstructions,
          total: this.calculateTotal()
        });
        this.$emit("add-to-cart");
      }
    },
    mounted() {
      if (!document.querySelector('link[href*="Open+Sans"]')) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap";
        document.head.appendChild(link);
      }
      console.log("[ReviewSection] Mounted - Store data:", {
        artworkMethod: this.imprintStore.selectedArtworkMethod,
        imprintMethod: this.imprintStore.selectedImprintMethod,
        availableMethods: this.imprintStore.availableImprintMethods
      });
      this.specialInstructions = this.selectionStore.specialInstructions || "";
    }
  };
  const _hoisted_1$4 = { class: "review-section" };
  const _hoisted_2$3 = {
    key: 0,
    class: "validation-errors"
  };
  const _hoisted_3$2 = { class: "error-list" };
  const _hoisted_4$1 = ["onClick"];
  const _hoisted_5$1 = {
    key: 0,
    class: "error-arrow"
  };
  const _hoisted_6$1 = {
    key: 1,
    class: "debug-info",
    style: { "background": "#f0f0f0", "padding": "10px", "margin-bottom": "20px", "font-size": "12px" }
  };
  const _hoisted_7$1 = { class: "review-summary" };
  const _hoisted_8$1 = {
    key: 0,
    class: "selected-methods-summary"
  };
  const _hoisted_9$1 = {
    key: 0,
    class: "method-info"
  };
  const _hoisted_10$1 = { class: "method-value" };
  const _hoisted_11$1 = {
    key: 0,
    class: "method-description"
  };
  const _hoisted_12$1 = {
    key: 1,
    class: "method-info"
  };
  const _hoisted_13$1 = { class: "method-value" };
  const _hoisted_14$1 = {
    key: 0,
    class: "method-image"
  };
  const _hoisted_15$1 = ["src", "alt"];
  const _hoisted_16$1 = {
    key: 1,
    class: "method-description"
  };
  const _hoisted_17$1 = {
    key: 2,
    class: "no-selections"
  };
  const _hoisted_18$1 = { class: "price-summary" };
  const _hoisted_19$1 = { class: "summary-table-container" };
  const _hoisted_20$1 = { class: "summary-table" };
  const _hoisted_21$1 = { class: "col-item calendar-product" };
  const _hoisted_22$1 = { class: "calendar-product-info" };
  const _hoisted_23 = ["src", "alt"];
  const _hoisted_24 = { class: "calendar-title" };
  const _hoisted_25 = { class: "col-qty" };
  const _hoisted_26 = { class: "col-price" };
  const _hoisted_27 = { class: "col-subtotal" };
  const _hoisted_28 = { class: "col-item" };
  const _hoisted_29 = { class: "col-item" };
  const _hoisted_30 = { class: "col-qty" };
  const _hoisted_31 = { class: "col-price" };
  const _hoisted_32 = { class: "col-subtotal" };
  const _hoisted_33 = { key: 2 };
  const _hoisted_34 = { key: 3 };
  const _hoisted_35 = { class: "col-item" };
  const _hoisted_36 = { class: "charge-name-cell" };
  const _hoisted_37 = {
    key: 0,
    class: "fee-tooltip-wrap"
  };
  const _hoisted_38 = { class: "fee-tooltip-content" };
  const _hoisted_39 = { class: "col-qty" };
  const _hoisted_40 = { class: "col-price" };
  const _hoisted_41 = { class: "col-subtotal" };
  const _hoisted_42 = { class: "total-row" };
  const _hoisted_43 = { class: "total-amount" };
  const _hoisted_44 = { class: "special-instructions" };
  const _hoisted_45 = {
    key: 0,
    class: "error-message"
  };
  const _hoisted_46 = {
    key: 1,
    class: "imprint-details-section"
  };
  const _hoisted_47 = {
    key: 2,
    class: "order-summary-placeholder"
  };
  const _hoisted_48 = { class: "action-buttons" };
  const _hoisted_49 = ["disabled"];
  const _hoisted_50 = { class: "add-to-cart-wrap" };
  const _hoisted_51 = {
    key: 0,
    class: "loader",
    src: "https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/opc-ajax-loader.gif",
    alt: "Adding to Cart...",
    title: "Adding to Cart..."
  };
  const _hoisted_52 = ["disabled"];
  const _hoisted_53 = { key: 0 };
  const _hoisted_54 = { key: 1 };
  function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    const _component_ImprintSummary = resolveComponent("ImprintSummary");
    return openBlock(), createElementBlock("div", _hoisted_1$4, [
      $options.storeValidationErrors.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
        _cache[5] || (_cache[5] = createBaseVNode("div", { class: "error-header" }, [
          createBaseVNode("svg", {
            class: "error-icon",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            createBaseVNode("path", {
              "fill-rule": "evenodd",
              d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
              "clip-rule": "evenodd"
            })
          ]),
          createBaseVNode("span", null, "Please resolve the following issues before adding to cart:")
        ], -1)),
        createBaseVNode("ul", _hoisted_3$2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.storeValidationErrors, (error, index) => {
            return openBlock(), createElementBlock("li", { key: index }, [
              createBaseVNode("button", {
                class: normalizeClass(["error-item-btn", { "is-clickable": !!$options.sectionForError(error) }]),
                onClick: ($event) => $options.handleErrorClick(error)
              }, [
                createTextVNode(toDisplayString(error) + " ", 1),
                $options.sectionForError(error) ? (openBlock(), createElementBlock("span", _hoisted_5$1, "→")) : createCommentVNode("", true)
              ], 10, _hoisted_4$1)
            ]);
          }), 128))
        ])
      ])) : createCommentVNode("", true),
      $setup.debugConfig.showReviewDebugInfo ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
        _cache[6] || (_cache[6] = createBaseVNode("strong", null, "Debug Info:", -1)),
        _cache[7] || (_cache[7] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" selectedArtworkMethod: " + toDisplayString($setup.imprintStore.selectedArtworkMethod), 1),
        _cache[8] || (_cache[8] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" selectedImprintMethod.sku: " + toDisplayString($setup.imprintStore.selectedImprintMethod.sku), 1),
        _cache[9] || (_cache[9] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" selectedImprintMethod.name: " + toDisplayString($setup.imprintStore.selectedImprintMethod.name), 1),
        _cache[10] || (_cache[10] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" hasSelections: " + toDisplayString($options.hasSelections), 1),
        _cache[11] || (_cache[11] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" selectedArtworkMethodData: " + toDisplayString((_a = $options.selectedArtworkMethodData) == null ? void 0 : _a.label), 1),
        _cache[12] || (_cache[12] = createBaseVNode("br", null, null, -1)),
        createTextVNode(" selectedImprintMethodData: " + toDisplayString((_b = $options.selectedImprintMethodData) == null ? void 0 : _b.name) + " ", 1),
        _cache[13] || (_cache[13] = createBaseVNode("p", null, "----selectionStore----", -1)),
        createBaseVNode("p", null, "colorSizeLines Full: " + toDisplayString($setup.selectionStore.colorSizeLines), 1),
        createBaseVNode("p", null, "selected Colors Qty: " + toDisplayString($setup.selectionStore.getLinesByImprintKey($setup.imprintStore.getImprintMethodKey).length), 1),
        createBaseVNode("p", null, "selected Colors id: " + toDisplayString($setup.selectionStore.getSelectedColorsByImprintKey($setup.imprintStore.getImprintMethodKey)), 1),
        createBaseVNode("p", null, "selected sizes: " + toDisplayString($setup.selectionStore.getTotalSizesQtyByImprintKey($setup.imprintStore.getImprintMethodKey)), 1),
        createBaseVNode("p", null, "Special Instructions: " + toDisplayString($data.specialInstructions), 1)
      ])) : createCommentVNode("", true),
      createBaseVNode("div", _hoisted_7$1, [
        $setup.debugConfig.showCustomizationMethodInfo ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
          _cache[17] || (_cache[17] = createBaseVNode("h4", { class: "subsection-title" }, "Customization Method", -1)),
          $options.selectedArtworkMethodData ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
            _cache[14] || (_cache[14] = createBaseVNode("div", { class: "method-label" }, "Artwork Method:", -1)),
            createBaseVNode("div", _hoisted_10$1, toDisplayString($options.selectedArtworkMethodData.label), 1),
            $options.selectedArtworkMethodData.description ? (openBlock(), createElementBlock("div", _hoisted_11$1, toDisplayString($options.selectedArtworkMethodData.description), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          $options.selectedImprintMethodData ? (openBlock(), createElementBlock("div", _hoisted_12$1, [
            _cache[15] || (_cache[15] = createBaseVNode("div", { class: "method-label" }, "Imprint Method:", -1)),
            createBaseVNode("div", _hoisted_13$1, toDisplayString($options.selectedImprintMethodData.name), 1),
            $options.selectedImprintMethodData.image ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
              createBaseVNode("img", {
                src: $options.selectedImprintMethodData.image,
                alt: $options.selectedImprintMethodData.name,
                onError: _cache[0] || (_cache[0] = (...args) => $options.handleImageError && $options.handleImageError(...args))
              }, null, 40, _hoisted_15$1)
            ])) : createCommentVNode("", true),
            $options.selectedImprintMethodData.description ? (openBlock(), createElementBlock("div", _hoisted_16$1, toDisplayString($options.selectedImprintMethodData.description), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          !$options.hasSelections ? (openBlock(), createElementBlock("div", _hoisted_17$1, [..._cache[16] || (_cache[16] = [
            createBaseVNode("p", null, "No customization methods selected yet.", -1),
            createBaseVNode("p", { class: "note" }, "Please complete Step 2 to select your customization preferences.", -1)
          ])])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_18$1, [
          createBaseVNode("div", _hoisted_19$1, [
            createBaseVNode("table", _hoisted_20$1, [
              $setup.appStore.isCalendarMode ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                _cache[18] || (_cache[18] = createBaseVNode("thead", null, [
                  createBaseVNode("tr", null, [
                    createBaseVNode("th", { class: "col-item" }, "Selected Calendar Products"),
                    createBaseVNode("th", { class: "col-qty" }, "Quantity"),
                    createBaseVNode("th", { class: "col-price" }, "Unit Price"),
                    createBaseVNode("th", { class: "col-subtotal" }, "Sub Total")
                  ])
                ], -1)),
                createBaseVNode("tbody", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($options.calendarProducts, (calendar) => {
                    return openBlock(), createElementBlock("tr", {
                      key: "calendar-" + calendar.id
                    }, [
                      createBaseVNode("td", _hoisted_21$1, [
                        createBaseVNode("div", _hoisted_22$1, [
                          calendar.image ? (openBlock(), createElementBlock("img", {
                            key: 0,
                            src: calendar.image,
                            alt: calendar.title,
                            class: "calendar-image"
                          }, null, 8, _hoisted_23)) : createCommentVNode("", true),
                          createBaseVNode("span", _hoisted_24, toDisplayString(calendar.title), 1)
                        ])
                      ]),
                      createBaseVNode("td", _hoisted_25, toDisplayString(calendar.qty), 1),
                      createBaseVNode("td", _hoisted_26, "$" + toDisplayString($options.formatPrice(calendar.unitPrice)), 1),
                      createBaseVNode("td", _hoisted_27, "$" + toDisplayString($options.formatPrice(calendar.unitPrice * calendar.qty || 0)), 1)
                    ]);
                  }), 128))
                ])
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createBaseVNode("thead", null, [
                  createBaseVNode("tr", null, [
                    createBaseVNode("th", _hoisted_28, toDisplayString($setup.colorName), 1),
                    _cache[19] || (_cache[19] = createBaseVNode("th", { class: "col-qty" }, "Quantity", -1)),
                    _cache[20] || (_cache[20] = createBaseVNode("th", { class: "col-price" }, "Unit Price", -1)),
                    _cache[21] || (_cache[21] = createBaseVNode("th", { class: "col-subtotal" }, "Sub Total", -1))
                  ])
                ]),
                createBaseVNode("tbody", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList($options.colorLines, (line) => {
                    return openBlock(), createElementBlock("tr", {
                      key: "color-" + line.id
                    }, [
                      createBaseVNode("td", _hoisted_29, toDisplayString(line.slectedColor.title.replace(/-/g, " ")), 1),
                      createBaseVNode("td", _hoisted_30, toDisplayString(line.totalQty), 1),
                      createBaseVNode("td", _hoisted_31, "$" + toDisplayString($options.formatPrice($options.getColorPrice(line))), 1),
                      createBaseVNode("td", _hoisted_32, "$" + toDisplayString($options.formatPrice($options.getColorLineTotal(line))), 1)
                    ]);
                  }), 128))
                ])
              ], 64)),
              $options.extraCharges.length > 0 ? (openBlock(), createElementBlock("thead", _hoisted_33, [..._cache[22] || (_cache[22] = [
                createBaseVNode("tr", null, [
                  createBaseVNode("th", { class: "col-item" }, "Extra Charges"),
                  createBaseVNode("th", { class: "col-qty" }, "Quantity"),
                  createBaseVNode("th", { class: "col-price" }, "Unit Price"),
                  createBaseVNode("th", { class: "col-subtotal" }, "Sub Total")
                ], -1)
              ])])) : createCommentVNode("", true),
              $options.extraCharges.length > 0 ? (openBlock(), createElementBlock("tbody", _hoisted_34, [
                (openBlock(true), createElementBlock(Fragment, null, renderList($options.extraCharges, (charge) => {
                  return openBlock(), createElementBlock("tr", {
                    key: "charge-" + charge.id
                  }, [
                    createBaseVNode("td", _hoisted_35, [
                      createBaseVNode("span", _hoisted_36, [
                        createBaseVNode("span", null, toDisplayString(charge.name), 1),
                        $options.getFeeTooltip(charge.name) ? (openBlock(), createElementBlock("span", _hoisted_37, [
                          _cache[23] || (_cache[23] = createBaseVNode("span", { class: "fee-tooltip-icon" }, "?", -1)),
                          createBaseVNode("span", _hoisted_38, toDisplayString($options.getFeeTooltip(charge.name)), 1)
                        ])) : createCommentVNode("", true)
                      ])
                    ]),
                    createBaseVNode("td", _hoisted_39, toDisplayString(charge.quantity), 1),
                    createBaseVNode("td", _hoisted_40, "$" + toDisplayString($options.formatPrice(charge.unitPrice)), 1),
                    createBaseVNode("td", _hoisted_41, "$" + toDisplayString($options.formatPrice(charge.subTotal)), 1)
                  ]);
                }), 128))
              ])) : createCommentVNode("", true)
            ])
          ]),
          createBaseVNode("div", _hoisted_42, [
            _cache[24] || (_cache[24] = createBaseVNode("span", { class: "total-label" }, "Total", -1)),
            createBaseVNode("span", _hoisted_43, "$" + toDisplayString($options.formatPrice($options.calculateTotal())), 1)
          ])
        ]),
        createBaseVNode("div", _hoisted_44, [
          _cache[25] || (_cache[25] = createBaseVNode("label", { class: "instructions-label" }, "Special Instructions", -1)),
          withDirectives(createBaseVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.specialInstructions = $event),
            class: normalizeClass(["instructions-textarea", { "has-error": $data.validationErrors.specialInstructions }]),
            placeholder: "Add your instructions here",
            rows: "3",
            maxlength: "500",
            onInput: _cache[2] || (_cache[2] = (...args) => $options.onSpecialInstructionsChange && $options.onSpecialInstructionsChange(...args))
          }, null, 34), [
            [vModelText, $data.specialInstructions]
          ]),
          $data.validationErrors.specialInstructions ? (openBlock(), createElementBlock("div", _hoisted_45, toDisplayString($data.validationErrors.specialInstructions), 1)) : createCommentVNode("", true),
          _cache[26] || (_cache[26] = createBaseVNode("div", { class: "char-counter" }, null, -1))
        ]),
        $options.hasImprintData && $setup.debugConfig.showRawImprintData ? (openBlock(), createElementBlock("div", _hoisted_46, [
          _cache[27] || (_cache[27] = createBaseVNode("h4", { class: "subsection-title" }, "Your Customization", -1)),
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.allImprints, (imprint, index) => {
            return openBlock(), createBlock(_component_ImprintSummary, {
              key: index,
              title: $options.getImprintTitle(index),
              "imprint-data": imprint,
              "imprint-index": index
            }, null, 8, ["title", "imprint-data", "imprint-index"]);
          }), 128))
        ])) : createCommentVNode("", true),
        $setup.debugConfig.showMigrationInfo ? (openBlock(), createElementBlock("div", _hoisted_47, [..._cache[28] || (_cache[28] = [
          createBaseVNode("h4", { class: "subsection-title" }, "Order Details", -1),
          createBaseVNode("div", { class: "migration-notes" }, [
            createBaseVNode("h4", null, "Components to migrate:"),
            createBaseVNode("ul", null, [
              createBaseVNode("li", null, "imprintAppSummary.vue - Order summary"),
              createBaseVNode("li", null, "Color & quantity selections"),
              createBaseVNode("li", null, "Add-ons selection"),
              createBaseVNode("li", null, "Final price calculation"),
              createBaseVNode("li", null, "Validation before checkout")
            ])
          ], -1)
        ])])) : createCommentVNode("", true)
      ]),
      createBaseVNode("div", _hoisted_48, [
        createBaseVNode("button", {
          class: "btn-back",
          onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("go-back")),
          disabled: $options.isLoading
        }, toDisplayString($options.previousStepButtonText), 9, _hoisted_49),
        createBaseVNode("div", _hoisted_50, [
          $options.isLoading ? (openBlock(), createElementBlock("img", _hoisted_51)) : createCommentVNode("", true),
          createBaseVNode("button", {
            class: normalizeClass(["btn-next btn-add-to-cart", { "loading": $options.isLoading, "btn-disabled": $setup.appStore.isOutOfStock }]),
            disabled: $options.isLoading || $setup.appStore.isOutOfStock,
            onClick: _cache[4] || (_cache[4] = (...args) => $options.handleAddToCart && $options.handleAddToCart(...args))
          }, [
            !$options.isLoading ? (openBlock(), createElementBlock("span", _hoisted_53, "Add to Cart")) : (openBlock(), createElementBlock("span", _hoisted_54, "Adding..."))
          ], 10, _hoisted_52)
        ])
      ])
    ]);
  }
  const ReviewSection = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-2350b910"]]);
  function useDataCleanup() {
    function clearAllData() {
      console.log("[useDataCleanup] 🗑️ Clearing all stored data...");
      let success = true;
      try {
        const newImprintStore = useNewImprintStore();
        newImprintStore.clearSessionStorage();
        console.log("[useDataCleanup] ✅ NewImprintStore sessionStorage cleared");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to clear NewImprintStore:", error);
        success = false;
      }
      try {
        const selectionStore = useSelectionStore();
        selectionStore.clearSessionStorage();
        console.log("[useDataCleanup] ✅ SelectionStore sessionStorage cleared");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to clear SelectionStore:", error);
        success = false;
      }
      try {
        const calendarStore = useCalendarStore();
        calendarStore.clear();
        console.log("[useDataCleanup] ✅ CalendarStore localStorage cleared");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to clear CalendarStore:", error);
        success = false;
      }
      try {
        const designOnlineStore = useDesignOnlineStore();
        designOnlineStore.stage = "idle";
        designOnlineStore.clearStorage();
        designOnlineStore.tokenId = null;
        designOnlineStore.previewImage = null;
        designOnlineStore.editUrl = null;
        designOnlineStore.pdfPreviewUrl = null;
        designOnlineStore.printReadyFileUrl = null;
        designOnlineStore.isApproved = false;
        designOnlineStore.error = null;
        designOnlineStore.source = null;
        console.log("[useDataCleanup] ✅ DesignOnlineStore cleared (stage = idle, no auto-scroll)");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to clear DesignOnlineStore:", error);
        success = false;
      }
      if (success) {
        console.log("[useDataCleanup] ✅ All data cleared successfully");
      } else {
        console.warn("[useDataCleanup] ⚠️ Some data failed to clear");
      }
      return success;
    }
    function fullCleanup() {
      console.log("[useDataCleanup] 🧹 Full cleanup (storage + reset stores)...");
      let success = true;
      try {
        const newImprintStore = useNewImprintStore();
        newImprintStore.clearSessionStorage();
        newImprintStore.$reset();
        console.log("[useDataCleanup] ✅ NewImprintStore cleared and reset ($reset)");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to cleanup NewImprintStore:", error);
        success = false;
      }
      try {
        const selectionStore = useSelectionStore();
        selectionStore.clearSessionStorage();
        selectionStore.$reset();
        console.log("[useDataCleanup] ✅ SelectionStore cleared and reset");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to cleanup SelectionStore:", error);
        success = false;
      }
      try {
        const calendarStore = useCalendarStore();
        calendarStore.clear();
        console.log("[useDataCleanup] ✅ CalendarStore cleared");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to cleanup CalendarStore:", error);
        success = false;
      }
      try {
        const designOnlineStore = useDesignOnlineStore();
        designOnlineStore.fullReset();
        console.log("[useDataCleanup] ✅ DesignOnlineStore cleared and reset (fullReset)");
      } catch (error) {
        console.error("[useDataCleanup] ❌ Failed to cleanup DesignOnlineStore:", error);
        success = false;
      }
      if (success) {
        console.log("[useDataCleanup] ✅ Full cleanup completed successfully");
      } else {
        console.warn("[useDataCleanup] ⚠️ Some cleanup failed");
      }
      return success;
    }
    return {
      clearAllData,
      // After Add to Cart
      fullCleanup
      // When navigating to different product
    };
  }
  const _sfc_main$3 = {
    name: "ImprintNavigationController",
    components: {
      ImprintPriceMatrix,
      BaseButton,
      CalendarProductList,
      CalendarSinglePage,
      ColorSizeSection,
      CustomizeProductSection,
      CustomizeSection,
      AddOnsSection,
      ReviewSection
    },
    setup() {
      const sectionValidation = useSectionValidation();
      return {
        sectionValidation,
        debugConfig: DEBUG_CONFIG
      };
    },
    data() {
      return {
        // Tracks sections where Next Step was clicked (to show errors only after attempt)
        validatedSections: /* @__PURE__ */ new Set(),
        // When true, show errors in ALL sections (triggered by opening Review tab or Add to Cart click)
        showAllSectionErrors: false,
        // Section IDs currently playing shake animation
        shakingSections: [],
        colorSectionResetTrigger: 0
      };
    },
    computed: {
      imprintStore() {
        return useImprintStore();
      },
      selectionStore() {
        return useSelectionStore();
      },
      appStore() {
        return useAppStore();
      },
      addToCartStore() {
        return useAddToCartStore();
      },
      calendarStore() {
        return useCalendarStore();
      },
      sections() {
        return this.imprintStore.sections;
      },
      fullProductData() {
        return this.imprintStore.fullJson || {};
      },
      currentImprintKey() {
        return this.imprintStore.getImprintMethodKey || "default-imprint";
      },
      /**
       * Get retail value (tierMSRP) from prices_2 for current imprint method
       * @returns {number|null}
       */
      retailValue() {
        const selectedMethod = this.imprintStore.selectedImprintMethod;
        if (!selectedMethod || !selectedMethod.sku) return null;
        const methodData = this.imprintStore.configurableArray[selectedMethod.sku];
        if (!methodData || !methodData.prices_2) return null;
        const msrp = methodData.prices_2.msrp;
        return msrp ? Number(msrp) : null;
      }
    },
    methods: {
      /**
       * Trigger field-level validation for all imprints (artworkMethod === 'new').
       * Fills imprint.errors so has-error CSS class appears on fields
       * in StartNewImprintForm_Pinia.vue at the same moment error badges become visible.
       */
      triggerFieldLevelValidation() {
        if (this.imprintStore.selectedArtworkMethod === "new") {
          const newImprintStore = useNewImprintStore();
          newImprintStore.imprints.forEach((_, index) => {
            newImprintStore.validate(index);
          });
        }
      },
      /**
       * Load mock data for development
       */
      loadMockDataFullJson() {
        try {
          const fullJson = mockProduct.full_json;
          this.imprintStore.setFullJson(JSON.parse(fullJson));
          this.$log("[MOCK]-----> Start Full Json // ImprintNavigationController.vue");
        } catch (e) {
          this.$log("[MOCK]-----> Not set");
          this.imprintStore.setFullJson(null);
        }
      },
      initFullJson() {
        if (this.imprintStore.fullJson) {
          console.log("[ImprintNavigationController] fullJson already loaded");
          return;
        }
        if (this.appStore.isCalendarMode && this.appStore.full_product) {
          console.log("[ImprintNavigationController] Loading fullJson from appStore.full_product (calendar mode)");
          this.imprintStore.setFullJson(this.appStore.full_product);
          this.$log("-----> Start Full Json (Calendar) // ImprintNavigationController.vue");
          console.warn("-----> Start Full Json (Calendar) // ImprintNavigationController.vue");
          console.log(this.appStore.full_product);
          console.warn("-----> End Full Json");
          return;
        }
        if (!useMockData()) {
          const el = document.getElementById("full_product_info_json");
          if (!el) {
            console.warn("[Imprint] full_product_info_json element not found");
            this.imprintStore.setFullJson(null);
            return;
          }
          try {
            const raw = (el.textContent || "").trim();
            const fullJson = raw ? JSON.parse(raw) : null;
            this.imprintStore.setFullJson(fullJson);
            this.$log("-----> Start Full Json // ImprintNavigationController.vue");
            console.warn("-----> Start Full Json // ImprintNavigationController.vue");
            console.log(fullJson);
            console.warn("-----> End Full Json");
          } catch (e) {
            console.warn("[Imprint] Failed to parse full_product_info_json:", e);
            this.imprintStore.setFullJson(null);
          }
        } else {
          this.loadMockDataFullJson();
        }
      },
      onSectionClick(id) {
        if (this.canOpenSection(id)) {
          this.imprintStore.toggleSectionOpen(id);
          if (id === "review") {
            this.showAllSectionErrors = true;
            this.triggerFieldLevelValidation();
          }
        }
      },
      isSectionOpen(id) {
        return this.imprintStore.isSectionOpen(id);
      },
      canOpenSection(id) {
        return this.imprintStore.canOpenSection(id);
      },
      /**
       * Check if section should be hidden
       * @param {string} id - Section ID
       * @returns {boolean}
       */
      shouldHideSection(id) {
        if (id === "colourQuantity" && this.appStore.isCalendarMode) {
          return true;
        }
        if (id === "addons" && !this.debugConfig.showAddOnsSection) {
          return true;
        }
        return false;
      },
      // Event Handlers
      handleRequestSample() {
        console.log("Request sample clicked");
      },
      handleBeginCustomizing() {
        console.log("[ImprintNavigationController] Begin customizing clicked");
        let firstSectionId = "colourQuantity";
        if (this.appStore.isCalendarMode) {
          firstSectionId = "imprintSelection";
          console.log("[ImprintNavigationController] Calendar mode - opening imprintSelection");
        }
        if (firstSectionId === "colourQuantity") {
          this.colorSectionResetTrigger++;
        }
        if (!this.isSectionOpen(firstSectionId)) {
          this.imprintStore.toggleSectionOpen(firstSectionId);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const firstSection = document.querySelector(`[data-section-id="${firstSectionId}"]`);
            if (firstSection) {
              const currentScroll = window.pageYOffset;
              const rect = firstSection.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
            }
          }, 500);
        });
      },
      handleMethodSelected(method) {
        console.log("Imprint method selected:", method);
        this.imprintStore.unlockSection("addons");
      },
      /**
       * Handle Design Online return from Studio
       * Open Step 2 and scroll to it
       */
      handleDesignOnlineReturned() {
        console.log("[AUTO_SWITCH] 🎯 handleDesignOnlineReturned() - Opening Step 2 and scrolling");
        console.log("[AUTO_SWITCH] Unlocking imprintSelection section");
        this.imprintStore.unlockSection("imprintSelection");
        if (this.isSectionOpen("colourQuantity")) {
          console.log("[AUTO_SWITCH] Closing colourQuantity section");
          this.imprintStore.toggleSectionOpen("colourQuantity");
        }
        if (!this.isSectionOpen("imprintSelection")) {
          console.log("[AUTO_SWITCH] Opening imprintSelection section");
          this.imprintStore.toggleSectionOpen("imprintSelection");
        } else {
          console.log("[AUTO_SWITCH] imprintSelection already open");
        }
        this.$nextTick(() => {
          setTimeout(() => {
            console.log("[AUTO_SWITCH] Attempting to scroll to Step 2...");
            const section = document.querySelector('[data-section-id="imprintSelection"]');
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              console.log("[AUTO_SWITCH] 📍c Scrolling to Step 2:", {
                currentScroll,
                sectionTop,
                scrollToPosition
              });
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
              console.log("[AUTO_SWITCH] ✅ Scroll initiated");
            } else {
              console.error("[AUTO_SWITCH] ❌ Step 2 section not found!");
            }
          }, 500);
        });
      },
      /**
       * Handle Next Step button from Colour & Quantity section
       * Close Step 1 and open Step 2 (Customize Your Product)
       */
      handleColorQuantityComplete() {
        console.log("[ImprintNavigationController] Color & Quantity complete");
        this.markSectionValidated("colourQuantity");
        this.imprintStore.unlockSection("imprintSelection");
        if (this.isSectionOpen("colourQuantity")) {
          this.imprintStore.toggleSectionOpen("colourQuantity");
        }
        if (!this.isSectionOpen("imprintSelection")) {
          this.imprintStore.toggleSectionOpen("imprintSelection");
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const section = document.querySelector('[data-section-id="imprintSelection"]');
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              console.log("[ImprintNavigationController] Scrolling to Customize section:", {
                sectionId: "imprintSelection",
                currentScroll,
                sectionTop,
                scrollToPosition
              });
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
            } else {
              console.warn("[ImprintNavigationController] Customize section not found");
            }
          }, 500);
        });
      },
      /**
       * Handle Previous Step button from Customize Product section
       * Close current section and open Colour & Quantity
       */
      handleCustomizePreviousStep() {
        console.log("[ImprintNavigationController] Customize Previous Step clicked");
        this.colorSectionResetTrigger++;
        if (this.isSectionOpen("imprintSelection")) {
          this.imprintStore.toggleSectionOpen("imprintSelection");
        }
        if (!this.isSectionOpen("colourQuantity")) {
          this.imprintStore.toggleSectionOpen("colourQuantity");
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const section = document.querySelector('[data-section-id="colourQuantity"]');
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              console.log("[ImprintNavigationController] Scrolling to previous section:", {
                sectionId: "colourQuantity",
                currentScroll,
                sectionTop,
                scrollToPosition
              });
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
            } else {
              console.warn("[ImprintNavigationController] Previous section not found");
            }
          }, 500);
        });
      },
      /**
       * Handle Next Step button from Customize Product section
       * Close current section and open Add-Ons or Review (if Add-Ons hidden)
       */
      handleCustomizeNextStep() {
        console.log("[ImprintNavigationController] Customize Next Step clicked");
        this.markSectionValidated("imprintSelection");
        this.triggerFieldLevelValidation();
        if (this.isSectionOpen("imprintSelection")) {
          this.imprintStore.toggleSectionOpen("imprintSelection");
        }
        let nextSectionId = "addons";
        if (!this.debugConfig.showAddOnsSection) {
          nextSectionId = "review";
          console.log("[ImprintNavigationController] Skipping Add-Ons section (hidden), going to Review");
        }
        this.imprintStore.unlockSection(nextSectionId);
        if (!this.isSectionOpen(nextSectionId)) {
          this.imprintStore.toggleSectionOpen(nextSectionId);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const section = document.querySelector(`[data-section-id="${nextSectionId}"]`);
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              console.log("[ImprintNavigationController] Scrolling to section:", {
                sectionId: nextSectionId,
                currentScroll,
                sectionTop,
                offset,
                scrollToPosition,
                maxScroll,
                windowHeight: window.innerHeight,
                documentHeight: document.documentElement.scrollHeight
              });
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
            } else {
              console.warn("[ImprintNavigationController] Section not found:", nextSectionId);
            }
          }, 500);
        });
      },
      handleLocationChange(location2) {
        console.log("Location changed:", location2);
      },
      handleArtworkUpload(file) {
        console.log("Artwork uploaded:", file);
      },
      handleAddonsChange(addons) {
        console.log("Addons changed:", addons);
      },
      /**
       * Handle validation failure from ReviewSection.
       * Shows errors in all steps, shakes sections with errors,
       * and scrolls to the first section that needs attention.
       * @param {string[]} sectionIds - IDs of sections with errors
       */
      handleValidationFailed(sectionIds) {
        console.log("[ImprintNavigationController] Validation failed, sections:", sectionIds);
        this.showAllSectionErrors = true;
        this.shakingSections = [...sectionIds];
        setTimeout(() => {
          this.shakingSections = [];
        }, 700);
        if (sectionIds.length > 0) {
          this.handleScrollToSection(sectionIds[0]);
        }
      },
      /**
       * Open a section and scroll to it.
       * Used for error navigation from clickable error items.
       * @param {string} sectionId
       */
      /**
       * Open a section, scroll to it, then scroll to a specific field element.
       * Used when clicking a Step 2 error in the Review error list.
       * @param {{ sectionId: string, fieldSelector: string }}
       */
      handleScrollToField({ sectionId, fieldSelector }) {
        console.log("[ImprintNavigationController] Scrolling to field:", fieldSelector, "in section:", sectionId);
        this.imprintStore.unlockSection(sectionId);
        if (!this.isSectionOpen(sectionId)) {
          this.imprintStore.toggleSectionOpen(sectionId);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const el = document.querySelector(fieldSelector);
            if (el) {
              const currentScroll = window.pageYOffset;
              const rect = el.getBoundingClientRect();
              const elTop = currentScroll + rect.top;
              const offset = 140;
              let scrollTo = elTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollTo = Math.min(scrollTo, maxScroll);
              scrollTo = Math.max(0, scrollTo);
              window.scrollTo({ top: scrollTo, behavior: "smooth" });
              el.classList.add("error-field-flash");
              setTimeout(() => el.classList.remove("error-field-flash"), 1200);
            } else {
              console.warn("[ImprintNavigationController] Field element not found:", fieldSelector);
              this.handleScrollToSection(sectionId);
            }
          }, 400);
        });
      },
      handleScrollToSection(sectionId) {
        console.log("[ImprintNavigationController] Scrolling to section:", sectionId);
        if (sectionId === "colourQuantity") {
          this.colorSectionResetTrigger++;
        }
        this.imprintStore.unlockSection(sectionId);
        if (!this.isSectionOpen(sectionId)) {
          this.imprintStore.toggleSectionOpen(sectionId);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const section = document.querySelector(`[data-section-id="${sectionId}"]`);
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
            }
          }, 300);
        });
      },
      handleGoBack() {
        console.log("[ImprintNavigationController] Go back from Review clicked");
        let previousSectionId = "addons";
        if (!this.debugConfig.showAddOnsSection) {
          previousSectionId = "imprintSelection";
          console.log("[ImprintNavigationController] Add-Ons hidden, going back to Customize");
        }
        if (this.isSectionOpen("review")) {
          this.imprintStore.toggleSectionOpen("review");
        }
        if (!this.isSectionOpen(previousSectionId)) {
          this.imprintStore.toggleSectionOpen(previousSectionId);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            const section = document.querySelector(`[data-section-id="${previousSectionId}"]`);
            if (section) {
              const currentScroll = window.pageYOffset;
              const rect = section.getBoundingClientRect();
              const sectionTop = currentScroll + rect.top;
              const offset = 80;
              let scrollToPosition = sectionTop - offset;
              const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
              scrollToPosition = Math.min(scrollToPosition, maxScroll);
              scrollToPosition = Math.max(0, scrollToPosition);
              console.log("[ImprintNavigationController] Scrolling back to section:", {
                sectionId: previousSectionId,
                currentScroll,
                scrollToPosition
              });
              window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth"
              });
            } else {
              console.warn("[ImprintNavigationController] Previous section not found:", previousSectionId);
            }
          }, 500);
        });
      },
      getSectionErrorCount(sectionId) {
        return this.sectionValidation.getSectionErrorCount(sectionId);
      },
      getSectionErrors(sectionId) {
        return this.sectionValidation.getSectionErrors(sectionId);
      },
      /**
       * Whether errors should be shown for a given section.
       * Errors are shown if:
       * 1) The user clicked "Next Step" in that section, OR
       * 2) The Review section was opened (showAllSectionErrors = true)
       */
      isSectionValidated(sectionId) {
        return this.showAllSectionErrors || this.validatedSections.has(sectionId);
      },
      /**
       * Mark a section as validated (user clicked Next Step)
       */
      markSectionValidated(sectionId) {
        this.validatedSections.add(sectionId);
      },
      async handleAddToCart() {
        console.log("[ImprintNavigationController] handleAddToCart triggered");
        try {
          const { clearAllData } = useDataCleanup();
          await this.addToCartStore.addToCart({ onAfterSuccess: clearAllData });
        } catch (error) {
          console.error("[ImprintNavigationController] Error adding to cart:", error);
          console.warn("There was an issue adding the product to cart. Please check your selections and try again.");
        }
      }
    },
    watch: {
      // ✅ Watch for route changes to different products (using productId param)
      "$route.params.productId": {
        handler(newProductId, oldProductId) {
          if (oldProductId && newProductId && newProductId !== oldProductId) {
            console.log("[ROUTE_CHANGE] Product ID changed:", oldProductId, "→", newProductId);
            console.log("[ROUTE_CHANGE] Clearing all data from previous product...");
            const { fullCleanup } = useDataCleanup();
            const cleaned = fullCleanup();
            if (cleaned) {
              console.log("[ROUTE_CHANGE] ✅ Data cleared and stores reset");
            } else {
              console.warn("[ROUTE_CHANGE] ⚠️ Cleanup may have failed");
            }
          }
        }
      },
      // ✅ FALLBACK: Watch for pathname changes (for Shopify URLs without route.params)
      "$route.path": {
        handler(newPath, oldPath) {
          if (!oldPath || newPath === oldPath) return;
          const extractHandle = (path) => {
            const match = path.match(/\/products\/([^\/\?#]+)/);
            return match ? match[1] : null;
          };
          const oldHandle = extractHandle(oldPath);
          const newHandle = extractHandle(newPath);
          if (oldHandle && newHandle && oldHandle !== newHandle) {
            console.log("[ROUTE_CHANGE] Product path changed:", oldHandle, "→", newHandle);
            console.log("[ROUTE_CHANGE] Clearing all data from previous product...");
            const { fullCleanup } = useDataCleanup();
            const cleaned = fullCleanup();
            if (cleaned) {
              console.log("[ROUTE_CHANGE] ✅ Data cleared and stores reset (path watcher)");
            } else {
              console.warn("[ROUTE_CHANGE] ⚠️ Cleanup may have failed (path watcher)");
            }
          }
        }
      }
    },
    async mounted() {
      var _a;
      console.log("[ImprintNavigationController] Starting initialization...");
      try {
        await this.appStore.initialize();
        console.log("[ImprintNavigationController] App store initialized successfully");
        console.log("[ImprintNavigationController] App store state:", {
          mainProductID: this.appStore.mainProductID,
          applicationType: this.appStore.applicationType,
          isCustomBundlePage: this.appStore.isCustomBundlePage,
          isEnvelopProduct: this.appStore.isEnvelopProduct,
          productType: this.appStore.productType,
          isComda: this.appStore.isComda,
          storeID: this.appStore.storeID,
          isCalendarSingle: this.appStore.isCalendarSingle,
          isCalendarMode: this.appStore.isCalendarMode
        });
      } catch (error) {
        console.error("[ImprintNavigationController] Failed to initialize app store:", error);
      }
      if (this.appStore.isCalendarMode) {
        console.log("[ImprintNavigationController] Calendar mode detected, loading calendar store...");
        try {
          await this.calendarStore.loadFromLocalStorage();
          console.log("[ImprintNavigationController] Calendar store loaded:", {
            productsCount: this.calendarStore.products.length,
            totalQuantity: this.calendarStore.totalQuantity,
            isValid: this.calendarStore.isValid
          });
        } catch (error) {
          console.error("[ImprintNavigationController] Failed to load calendar store:", error);
        }
      }
      this.initFullJson();
      this.imprintStore.initAdditionalLocationFees();
      console.log("[ImprintNavigationController] fullJson loaded:", !!this.imprintStore.fullJson);
      this.imprintStore.initializeSections(this.appStore.applicationType);
      console.log("[ImprintNavigationController] Sections initialized for:", this.appStore.applicationType);
      console.log("[ImprintNavigationController] Sections loaded:", this.sections);
      console.log("[ImprintNavigationController] First section isOpen:", (_a = this.sections[0]) == null ? void 0 : _a.isOpen);
    }
  };
  const _hoisted_1$3 = { class: "imprint-navigation" };
  const _hoisted_2$2 = {
    class: "imprint-navigation__product",
    id: "pricing-section"
  };
  const _hoisted_3$1 = {
    key: 0,
    class: "retail-value"
  };
  const _hoisted_4 = { class: "retail-value__price" };
  const _hoisted_5 = {
    key: 1,
    class: "product-actions"
  };
  const _hoisted_6 = { key: 2 };
  const _hoisted_7 = {
    key: 0,
    style: { "display": "none" },
    class: "calendar-products-section"
  };
  const _hoisted_8 = {
    key: 1,
    class: "imprint-navigation__sections"
  };
  const _hoisted_9 = ["data-section-id"];
  const _hoisted_10 = { class: "section-header-wrap" };
  const _hoisted_11 = ["disabled", "onClick"];
  const _hoisted_12 = { class: "section-header-left" };
  const _hoisted_13 = { class: "section-title" };
  const _hoisted_14 = {
    key: 0,
    class: "section-errors-wrapper"
  };
  const _hoisted_15 = { class: "section-errors" };
  const _hoisted_16 = { class: "error-count" };
  const _hoisted_17 = { class: "error-tooltip" };
  const _hoisted_18 = { class: "error-tooltip-header" };
  const _hoisted_19 = { class: "error-tooltip-list" };
  const _hoisted_20 = {
    key: 1,
    class: "section-meta"
  };
  const _hoisted_21 = { class: "imprint-navigation__panel" };
  const _hoisted_22 = {
    key: 1,
    class: "loading-state"
  };
  function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImprintPriceMatrix = resolveComponent("ImprintPriceMatrix");
    const _component_BaseButton = resolveComponent("BaseButton");
    const _component_CalendarSinglePage = resolveComponent("CalendarSinglePage");
    const _component_CalendarProductList = resolveComponent("CalendarProductList");
    const _component_ColorSizeSection = resolveComponent("ColorSizeSection");
    const _component_CustomizeProductSection = resolveComponent("CustomizeProductSection");
    const _component_CustomizeSection = resolveComponent("CustomizeSection");
    const _component_AddOnsSection = resolveComponent("AddOnsSection");
    const _component_ReviewSection = resolveComponent("ReviewSection");
    return openBlock(), createElementBlock("div", _hoisted_1$3, [
      createBaseVNode("section", _hoisted_2$2, [
        createVNode(_component_ImprintPriceMatrix),
        $options.retailValue ? (openBlock(), createElementBlock("div", _hoisted_3$1, [
          _cache[0] || (_cache[0] = createBaseVNode("span", { class: "retail-value__tooltip-wrap" }, [
            createBaseVNode("span", { class: "retail-value__tooltip-icon" }, "?"),
            createBaseVNode("span", { class: "retail-value__tooltip-content" }, [
              createBaseVNode("b", null, "Retail Value"),
              createTextVNode(" The cost to buy one of these products, fully customized, at a retail store. ")
            ])
          ], -1)),
          _cache[1] || (_cache[1] = createBaseVNode("span", { class: "retail-value__label" }, "Retail Value:", -1)),
          createBaseVNode("span", _hoisted_4, "$" + toDisplayString($options.retailValue.toFixed(2)), 1)
        ])) : createCommentVNode("", true),
        $options.appStore.applicationType !== "calendar_single" ? (openBlock(), createElementBlock("div", _hoisted_5, [
          createVNode(_component_BaseButton, {
            text: "Request a Sample",
            variant: "outline-yellow",
            size: "medium",
            onClick: $options.handleRequestSample
          }, null, 8, ["onClick"]),
          createVNode(_component_BaseButton, {
            text: "Begin Customizing",
            variant: "primary",
            size: "medium",
            onClick: $options.handleBeginCustomizing
          }, null, 8, ["onClick"])
        ])) : (openBlock(), createElementBlock("div", _hoisted_6, [
          createVNode(_component_CalendarSinglePage)
        ]))
      ]),
      $options.appStore.applicationType !== "calendar_single" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $options.appStore.isCalendarMode ? (openBlock(), createElementBlock("section", _hoisted_7, [
          createVNode(_component_CalendarProductList)
        ])) : createCommentVNode("", true),
        $options.sections.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_8, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.sections, (section) => {
            return openBlock(), createElementBlock("div", {
              key: section.id,
              "data-section-id": section.id,
              class: normalizeClass(["imprint-navigation__section", {
                "is-open": $options.isSectionOpen(section.id),
                "is-disabled": !$options.canOpenSection(section.id),
                "is-hidden": $options.shouldHideSection(section.id),
                "is-shaking": $data.shakingSections.includes(section.id)
              }])
            }, [
              createBaseVNode("div", _hoisted_10, [
                createBaseVNode("button", {
                  type: "button",
                  class: normalizeClass(["imprint-navigation__section-header", { "is-disabled": !$options.canOpenSection(section.id) }]),
                  disabled: !$options.canOpenSection(section.id),
                  onClick: ($event) => $options.onSectionClick(section.id)
                }, [
                  createBaseVNode("div", _hoisted_12, [
                    createBaseVNode("span", _hoisted_13, toDisplayString(section.label), 1)
                  ]),
                  $options.getSectionErrorCount(section.id) > 0 && section.id != "review" && $options.isSectionValidated(section.id) ? (openBlock(), createElementBlock("div", _hoisted_14, [
                    createBaseVNode("div", _hoisted_15, [
                      _cache[2] || (_cache[2] = createBaseVNode("svg", {
                        class: "error-icon",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        createBaseVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)),
                      createBaseVNode("span", _hoisted_16, toDisplayString($options.getSectionErrorCount(section.id)) + " " + toDisplayString($options.getSectionErrorCount(section.id) === 1 ? "issue" : "issues"), 1)
                    ]),
                    createBaseVNode("div", _hoisted_17, [
                      createBaseVNode("div", _hoisted_18, " Please fix the following " + toDisplayString($options.getSectionErrorCount(section.id)) + " " + toDisplayString($options.getSectionErrorCount(section.id) === 1 ? "issue" : "issues") + ": ", 1),
                      createBaseVNode("ul", _hoisted_19, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList($options.getSectionErrors(section.id), (error, index) => {
                          return openBlock(), createElementBlock("li", { key: index }, toDisplayString(error), 1);
                        }), 128))
                      ])
                    ])
                  ])) : section.meta ? (openBlock(), createElementBlock("div", _hoisted_20, toDisplayString(section.meta), 1)) : createCommentVNode("", true)
                ], 10, _hoisted_11)
              ]),
              createVNode(Transition, { name: "slide-fade" }, {
                default: withCtx(() => [
                  withDirectives(createBaseVNode("section", _hoisted_21, [
                    section.id === "colourQuantity" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                      $options.currentImprintKey && $options.currentImprintKey !== "default-imprint" ? (openBlock(), createBlock(_component_ColorSizeSection, {
                        key: 0,
                        ref_for: true,
                        ref: "colorSizeSection",
                        "imprint-key": $options.currentImprintKey,
                        description: section.description,
                        "reset-trigger": $data.colorSectionResetTrigger,
                        onNextStep: $options.handleColorQuantityComplete
                      }, null, 8, ["imprint-key", "description", "reset-trigger", "onNextStep"])) : (openBlock(), createElementBlock("div", _hoisted_22, [..._cache[3] || (_cache[3] = [
                        createBaseVNode("p", null, "Loading product data...", -1)
                      ])]))
                    ], 64)) : section.id === "imprintSelection" ? (openBlock(), createBlock(_component_CustomizeProductSection, {
                      key: 1,
                      "product-data": $options.fullProductData,
                      onMethodSelected: $options.handleMethodSelected,
                      onPreviousStep: $options.handleCustomizePreviousStep,
                      onNextStep: $options.handleCustomizeNextStep,
                      onDesignOnlineReturned: $options.handleDesignOnlineReturned
                    }, null, 8, ["product-data", "onMethodSelected", "onPreviousStep", "onNextStep", "onDesignOnlineReturned"])) : section.id === "customize" ? (openBlock(), createBlock(_component_CustomizeSection, {
                      key: 2,
                      onLocationChanged: $options.handleLocationChange,
                      onArtworkUploaded: $options.handleArtworkUpload
                    }, null, 8, ["onLocationChanged", "onArtworkUploaded"])) : section.id === "addons" ? (openBlock(), createBlock(_component_AddOnsSection, {
                      key: 3,
                      onAddonsChanged: $options.handleAddonsChange
                    }, null, 8, ["onAddonsChanged"])) : section.id === "review" ? (openBlock(), createBlock(_component_ReviewSection, {
                      key: 4,
                      onGoBack: $options.handleGoBack,
                      onAddToCart: $options.handleAddToCart,
                      onValidationFailed: $options.handleValidationFailed,
                      onScrollToSection: $options.handleScrollToSection,
                      onScrollToField: $options.handleScrollToField
                    }, null, 8, ["onGoBack", "onAddToCart", "onValidationFailed", "onScrollToSection", "onScrollToField"])) : createCommentVNode("", true)
                  ], 512), [
                    [vShow, $options.isSectionOpen(section.id)]
                  ])
                ]),
                _: 2
              }, 1024)
            ], 10, _hoisted_9);
          }), 128))
        ])) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true)
    ]);
  }
  const ImprintNavigationController = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__scopeId", "data-v-715a82d7"]]);
  const _sfc_main$2 = {
    name: "StateDebuggerOptions",
    data() {
      return {
        visible: true,
        stateHtml: "",
        stores: [
          { name: "ImprintStore", store: useImprintStore() },
          { name: "NewImprintStore", store: useNewImprintStore() },
          { name: "SelectionStore", store: useSelectionStore() },
          { name: "AppStore", store: useAppStore() },
          { name: "AddToCart", store: useAddToCartStore() }
        ]
      };
    },
    mounted() {
      this.stores.forEach((s) => {
        watch(
          () => s.store.$state,
          () => this.updateStateHtml(),
          { deep: true, immediate: true }
        );
      });
    },
    methods: {
      toggleVisible() {
        this.visible = !this.visible;
      },
      // Recursive function for <details>
      objToHtml(obj) {
        if (typeof obj !== "object" || obj === null) return `<span>${obj}</span>`;
        let html = "<ul>";
        for (const key in obj) {
          const value = obj[key];
          if (typeof value === "object" && value !== null) {
            html += `<li><details><summary>${key}</summary>${this.objToHtml(value)}</details></li>`;
          } else {
            html += `<li>${key}: ${value}</li>`;
          }
        }
        html += "</ul>";
        return html;
      },
      updateStateHtml() {
        let html = "";
        this.stores.forEach((s) => {
          html += `<details open><summary style="font-weight:bold">${s.name} Store</summary>${this.objToHtml(s.store.$state)}</details>`;
        });
        this.stateHtml = html;
      }
    }
  };
  const _hoisted_1$2 = {
    class: "debugger-wrapper",
    id: "debugger-state"
  };
  const _hoisted_2$1 = { class: "debugger" };
  const _hoisted_3 = ["innerHTML"];
  function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_1$2, [
      createBaseVNode("button", {
        class: "toggle-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleVisible && $options.toggleVisible(...args))
      }, toDisplayString($data.visible ? "+" : "-"), 1),
      withDirectives(createBaseVNode("div", _hoisted_2$1, [
        _cache[1] || (_cache[1] = createBaseVNode("h3", null, "🔍 Pinia State Debugger (Multi-Store)", -1)),
        createBaseVNode("div", { innerHTML: $data.stateHtml }, null, 8, _hoisted_3)
      ], 512), [
        [vShow, $data.visible]
      ])
    ]);
  }
  const StateDebugger = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-f3eb3f95"]]);
  const _sfc_main$1 = {
    name: "App",
    methods: { useMockData: useMockData$1 },
    components: {
      StepNavigstion,
      ImprintNavigationController,
      StateDebugger
    },
    data() {
      return {
        // 'steps' | 'tabs' type of imprint
        imprintVersion: "tabs"
      };
    },
    computed: {
      useNewImprintFlow() {
        return this.imprintVersion === "tabs";
      }
    },
    created() {
      const root = document.getElementById("section-image-with-text-c");
      if (root && root.dataset && root.dataset.imprintVersion) {
        this.imprintVersion = root.dataset.imprintVersion;
      }
    }
  };
  const _hoisted_1$1 = { key: 2 };
  function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ErrorModal = resolveComponent("ErrorModal");
    const _component_ImprintNavigationController = resolveComponent("ImprintNavigationController");
    const _component_StepNavigstion = resolveComponent("StepNavigstion");
    const _component_StateDebugger = resolveComponent("StateDebugger");
    return openBlock(), createElementBlock(Fragment, null, [
      createVNode(_component_ErrorModal),
      $options.useNewImprintFlow ? (openBlock(), createBlock(_component_ImprintNavigationController, { key: 0 })) : (openBlock(), createBlock(_component_StepNavigstion, { key: 1 })),
      $options.useMockData() ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
        createVNode(_component_StateDebugger)
      ])) : createCommentVNode("", true)
    ], 64);
  }
  const App = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
  const customStyles = {
    install: (app) => {
      app.config.globalProperties.$getCustomColorClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaColor";
        if (storeName.includes("mlp")) return "mlpColor";
        return "";
      };
      app.config.globalProperties.$getTranslatedColorWord = (str) => {
        if (window.Shopify.country && str == "color") {
          return window.Shopify.country == "US" ? "color" : "colour";
        }
        return "";
      };
      app.config.globalProperties.$getCustomColorBeforeClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaColorBefore";
        if (storeName.includes("mlp")) return "mlpColorBefore";
        return "";
      };
      app.config.globalProperties.$getCustomColorAfterClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaColorAfter";
        if (storeName.includes("mlp")) return "mlpColorAfter";
        return "";
      };
      app.config.globalProperties.$getCustomBackgroundColorClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaBackgroundColor";
        if (storeName.includes("mlp")) return "mlpBackgroundColor";
        return "";
      };
      app.config.globalProperties.$getCustomBackgroundColorHoverClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaBackgroundColorHover";
        if (storeName.includes("mlp")) return "mlpBackgroundColorHover";
        return "";
      };
      app.config.globalProperties.$getCustomFontClass = (storeName) => {
        if (!storeName) return "";
        if (storeName.includes("comda")) return "comdaFont";
        if (storeName.includes("mlp")) return "mlpFont";
        return "";
      };
    }
  };
  const PERSIST_KEYS = [
    "imprintMethod",
    "imprintLocation",
    "selectedColors",
    "selectedImprint",
    "selectedSizes",
    "customQty",
    "specialPrice",
    "imprintStep",
    "prices",
    "imprintKey",
    "sizesQty",
    "colorSizeLines",
    "totalSizesQty",
    "selectedColorsList",
    "selectedLastStep",
    "imprintMessageColorLines"
    // check
    // 'calendar',     // тільки якщо поки що НЕ робимо pick-поля (див. варіант B)
    //'mainVariantId', // if not receive from DOM after reload
  ];
  function makeSnapshot(store2) {
    const toJSONSafe = (val) => {
      if (Array.isArray(val)) {
        const ownKeys = Object.keys(val);
        const onlyIndexes = ownKeys.every((k) => String(+k) === k);
        if (onlyIndexes) return val;
        const obj = {};
        for (const k in val) {
          obj[k] = toJSONSafe(val[k]);
        }
        return obj;
      } else if (val && typeof val === "object") {
        const out = {};
        for (const k of Object.keys(val)) out[k] = toJSONSafe(val[k]);
        return out;
      }
      return val;
    };
    const plain = {};
    for (const k of PERSIST_KEYS) {
      if (k in store2) plain[k] = toJSONSafe(store2[k]);
    }
    return plain;
  }
  function typeOf(v) {
    if (Array.isArray(v)) return "array";
    if (v === null) return "null";
    return typeof v;
  }
  function logSnapshotDebug(label, obj) {
    try {
      const json = JSON.stringify(obj);
      const bytes = new Blob([json]).size;
      const summary = {};
      for (const k of Object.keys(obj)) {
        summary[k] = {
          type: typeOf(obj[k]),
          // короткий індикатор "наповненості"
          sizeHint: typeOf(obj[k]) === "string" ? obj[k].length : typeOf(obj[k]) === "array" ? obj[k].length : typeOf(obj[k]) === "object" ? Object.keys(obj[k] || {}).length : ""
        };
      }
      console.groupCollapsed(`🧪 [Persist] ${label} snapshot (${bytes} bytes)`);
      console.table(summary);
      console.log("raw:", obj);
      console.groupEnd();
    } catch (e) {
      console.warn("[Persist] logSnapshotDebug failed:", e);
    }
  }
  const LS_KEY = "imprintUserDataV1";
  const _sfc_main = {
    name: "ErrorModal",
    props: {
      modelValue: { type: Boolean, default: false }
    },
    data() {
      return {
        store,
        visible: this.modelValue,
        jqHandler: null,
        title: "Something went wrong!",
        message: "The imprint builder ran into an issue. Please reload the page and start again.",
        primaryLabel: "Reload",
        reloadOnPrimary: true,
        reloadWithoutSave: true,
        storeName: ""
      };
    },
    watch: {
      modelValue(val) {
        this.visible = val;
      }
    },
    methods: {
      handlePrimary() {
        if (!this.reloadWithoutSave) {
          try {
            const snapshot = makeSnapshot(this.store);
            logSnapshotDebug("BEFORE SAVE", snapshot);
            localStorage.setItem(LS_KEY, JSON.stringify(snapshot));
            console.log("[Persist] Saved to", LS_KEY, snapshot);
            console.log("[Persist] store.js data: ", this.store);
          } catch (e) {
            console.warn("[Persist] Save failed:", e);
          }
        }
        if (this.reloadOnPrimary) {
          window.location.reload();
        } else {
          this.close();
        }
      },
      handleEvent(e) {
        console.log("[ErrorModal] handleEvent", e == null ? void 0 : e.type, e == null ? void 0 : e.detail);
        const d = (e == null ? void 0 : e.detail) || {};
        this.title = d.title || "Something went wrong!";
        if (d.message) this.message = d.message;
        this.primaryLabel = d.primaryLabel || "Reload";
        this.reloadOnPrimary = typeof d.reloadOnPrimary === "boolean" ? d.reloadOnPrimary : true;
        this.open();
      },
      reload() {
        try {
          const plain = {};
          PERSIST_KEYS.forEach((k) => {
            if (k in store) plain[k] = store[k];
          });
          const snapshot = JSON.stringify(plain);
          localStorage.setItem("imprintUserDataV1", snapshot);
        } catch (err) {
          console.error("[ErrorModal] Failed to persist data:", err);
        }
        if (this.reloadOnPrimary) {
          window.location.reload();
        } else {
          this.close();
        }
      },
      open() {
        this.visible = true;
        this.$emit("update:modelValue", true);
      },
      close() {
        this.visible = false;
        this.$emit("update:modelValue", false);
      }
    },
    mounted() {
      console.log("[ErrorModal] mounted, subscribing to events");
      window.addEventListener("add-to-cart-error", this.handleEvent);
      window.addEventListener("imprint-error", this.handleEvent);
      this.storeName = window.PXUTheme.theme_settings.project_store_name;
    },
    unmounted() {
      window.removeEventListener("add-to-cart-error", this.handleEvent);
      window.removeEventListener("imprint-error", this.handleEvent);
    }
  };
  const _hoisted_1 = {
    class: "modal-container",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "modal-title",
    "aria-describedby": "modal-desc"
  };
  const _hoisted_2 = { class: "modal-message" };
  function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createBlock(Teleport, { to: "body" }, [
      withDirectives(createBaseVNode("div", {
        class: "modal-backdrop",
        onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.close && $options.close(...args), ["self"]))
      }, [
        createBaseVNode("div", _hoisted_1, [
          _cache[2] || (_cache[2] = createBaseVNode("div", {
            class: "modal-icon",
            "aria-hidden": "true"
          }, [
            createBaseVNode("svg", {
              viewBox: "0 0 48 48",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              createBaseVNode("circle", {
                cx: "24",
                cy: "24",
                r: "24",
                fill: "#FF0000"
              }),
              createBaseVNode("path", {
                d: "M16 16l16 16M32 16L16 32",
                stroke: "#FFFFFF",
                "stroke-width": "4",
                "stroke-linecap": "round"
              })
            ])
          ], -1)),
          createBaseVNode("h2", {
            class: normalizeClass(["modal-title", "modal-title-" + $data.storeName])
          }, toDisplayString($data.title), 3),
          createBaseVNode("p", _hoisted_2, toDisplayString($data.message), 1),
          createBaseVNode("button", {
            class: normalizeClass(["modal-btn", "modal-btn-" + $data.storeName]),
            onClick: _cache[0] || (_cache[0] = (...args) => $options.handlePrimary && $options.handlePrimary(...args))
          }, toDisplayString($data.primaryLabel), 3)
        ])
      ], 512), [
        [vShow, $data.visible]
      ])
    ]);
  }
  const ErrorModal = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-e32915b4"]]);
  const STORAGE_KEY = "vue_component_logger";
  const LoggerConfig = {
    /**
     * Manual disable flag for logging
     * @type {boolean}
     */
    disableLog: true,
    /**
     * Check if logging is enabled
     * Logging is enabled only on localhost or dev environments
     * @returns {boolean}
     */
    enabled() {
      if (this.disableLog) return false;
      const host = window.location.hostname;
      return host === "localhost" || host.includes("dev");
    },
    /**
     * Maximum number of log entries to store
     * @type {number}
     */
    maxEntries: 500,
    /**
     * Whether to show logs in console immediately
     * @type {boolean}
     */
    showInConsole: false,
    /**
     * Log all components regardless of logComponents list
     * @type {boolean}
     */
    logAllComponents: true,
    /**
     * List of specific components to log (when logAllComponents is false)
     * @type {string[]}
     */
    logComponents: [
      "StepNavigstion.vue"
      // 'imprintAppSummary.vue'
    ]
  };
  function generateId() {
    var _a;
    return ((_a = crypto == null ? void 0 : crypto.randomUUID) == null ? void 0 : _a.call(crypto)) || `${Date.now()}-${Math.random()}`;
  }
  function loadLogs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      console.warn("Failed to load logs from localStorage:", error);
      return [];
    }
  }
  function saveLogs(logs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
    } catch (error) {
      console.error("Failed to save logs to localStorage:", error);
    }
  }
  function getCallerLine() {
    var _a;
    try {
      const stack2 = ((_a = new Error().stack) == null ? void 0 : _a.split("\n")) || [];
      for (const row of stack2) {
        if (row.includes("Proxy.")) {
          const match = row.match(/Proxy\.([^(]+)/);
          if (match == null ? void 0 : match[1]) return match[1];
        }
      }
      return "unknown";
    } catch {
      return "unknown";
    }
  }
  const StorageLogger = {
    /**
     * Log custom message with payload
     * @param {string} message - Log message
     * @param {any} payload - Additional data to log
     * @param {string} component - Component name
     */
    logCustom(message2, payload = null, component) {
      if (!LoggerConfig.enabled()) return;
      const dataLog = {
        id: generateId(),
        ts: Date.now(),
        type: "custom",
        component,
        line: getCallerLine(),
        message: message2,
        payload
      };
      const logs = loadLogs();
      logs.push(dataLog);
      if (logs.length > LoggerConfig.maxEntries) {
        logs.shift();
      }
      saveLogs(logs);
    },
    /**
     * Render logs to console with formatting
     * @param {Array|null} logs - Logs to render, or null to render all
     */
    render(logs = null) {
      const logsToRender = logs || this.getAll();
      if (!logsToRender.length) {
        console.log("📝 No logs to display");
        return;
      }
      logsToRender.forEach((log, index) => {
        console.log(
          `%c#${index + 1} %c${new Date(log.ts).toLocaleTimeString()} %c${log.component} %c@ ${log.line} →`,
          "color: #999",
          "color: #888",
          "color: #42b883; font-weight: bold",
          "color: #888; font-style: italic",
          log.message,
          log.payload
        );
      });
    },
    /**
     * Get all logs from localStorage
     * @returns {Array} All stored log entries
     */
    getAll() {
      return loadLogs();
    },
    /**
     * Clear all logs from localStorage and console
     */
    clear() {
      localStorage.removeItem(STORAGE_KEY);
      console.clear();
      console.log("🧹 Logs cleared");
    },
    /**
     * Enable logging
     */
    enable() {
      LoggerConfig.disableLog = false;
      console.log("✅ Logging enabled");
    },
    /**
     * Disable logging
     */
    disable() {
      LoggerConfig.disableLog = true;
      console.log("❌ Logging disabled");
    },
    /**
     * Filter and render logs by component name
     * @param {string} name - Component name to filter by
     */
    filterByComponent(name) {
      const filtered = this.getAll().filter((log) => log.component === name);
      this.render(filtered);
    }
  };
  const LoggerPlugin = {
    /**
     * Install plugin to Vue app
     * @param {App} app - Vue application instance
     */
    install(app) {
      StorageLogger.clear();
      app.config.globalProperties.$log = function(message2, payload) {
        const component = getComponentName(this);
        StorageLogger.logCustom(message2, payload, component);
      };
      app.config.globalProperties.$logger = StorageLogger;
      app.provide("log", StorageLogger);
    },
    /**
     * Check if logger is enabled
     * @returns {boolean}
     */
    isEnabled() {
      return LoggerConfig.enabled();
    }
  };
  function getComponentName(instance) {
    var _a, _b;
    if ((_a = instance == null ? void 0 : instance.$options) == null ? void 0 : _a.name) {
      return instance.$options.name;
    }
    if ((_b = instance == null ? void 0 : instance.$options) == null ? void 0 : _b.__file) {
      return instance.$options.__file.split("/").pop();
    }
    return "UnknownComponent";
  }
  const mockData = {
    theme_settings: {
      theme_settings: {
        project_store_name: "comda",
        api_beckend_url: "/"
      }
    },
    Shopify: {
      country: "USA",
      routes: {
        root: "/"
      },
      shop: "devcomda.myshopify.com"
    }
  };
  const THEME_CONFIG = {
    comda: {
      "--brand-primary": "#0D72B1",
      "--brand-primary-dark": "#0052a3",
      "--brand-primary-light": "#0072BC",
      "--brand-primary-lighter": "#F0F8FF",
      "--brand-secondary": "#0054a3",
      "--brand-accent": "#0066cc",
      "--font-family-brand": "'Open Sans', sans-serif",
      "--shadow-color": "rgba(13, 114, 177, 0.1)",
      "--title-section": "#034EA2"
    },
    mlp: {
      "--brand-primary": "#009444",
      "--brand-primary-dark": "#007a38",
      "--brand-primary-light": "#00a84f",
      "--brand-primary-lighter": "#e8f5e9",
      "--brand-secondary": "#009444",
      "--brand-accent": "#00b853",
      "--font-family-brand": "'museo-sans', sans-serif",
      "--shadow-color": "rgba(0, 148, 68, 0.1)",
      "--title-section": "#009444"
    }
  };
  function detectBrand() {
    const url = window.location.href.toLowerCase();
    const isComda = url.includes("comda");
    return isComda ? "comda" : "mlp";
  }
  function applyTheme(brand) {
    const root = document.documentElement;
    const theme = THEME_CONFIG[brand];
    if (!theme) {
      console.error(`[Theme] Unknown brand: ${brand}, falling back to 'comda'`);
      brand = "comda";
    }
    root.setAttribute("data-brand", brand);
    Object.entries(THEME_CONFIG[brand]).forEach(([property, value]) => {
      root.style.setProperty(property, value);
    });
    console.log(`🎨 [Theme] Initialized ${brand.toUpperCase()} theme`);
  }
  function initializeTheme() {
    const brand = detectBrand();
    applyTheme(brand);
    return brand;
  }
  const CLARITY_BACKEND_HOST = "api-customapp.comda.com";
  function readClaritySessionId() {
    try {
      const cookie = document.cookie.split("; ").find((c) => c.startsWith("_clsk="));
      if (!cookie) return null;
      return decodeURIComponent(cookie.split("=")[1]).split("^")[0] || null;
    } catch (e) {
      return null;
    }
  }
  axios.interceptors.request.use((config) => {
    try {
      const url = config.url || "";
      const isOurBackend = url.indexOf(CLARITY_BACKEND_HOST) !== -1;
      const isStudio = url.indexOf("/apps/studio") !== -1;
      if (isOurBackend && !isStudio) {
        const clarityId = readClaritySessionId();
        if (clarityId) {
          config.headers = config.headers || {};
          config.headers["X-Clarity-Session-Id"] = clarityId;
        }
      }
    } catch (e) {
    }
    return config;
  });
  if (LoggerPlugin.isEnabled()) {
    window.$vueLogs = {
      print() {
        console.group("📜 Vue Components Logs");
        StorageLogger.render();
        console.groupEnd();
      },
      clear() {
        StorageLogger.clear();
      },
      filterByComponent(name) {
        console.group(`📜 Component "${name}" Logs`);
        StorageLogger.filterByComponent(name);
        console.groupEnd();
      },
      enable() {
        StorageLogger.enable();
      },
      disable() {
        StorageLogger.disable();
      }
    };
  }
  if (!window.PXUTheme && useMockData$1()) {
    window.PXUTheme = mockData.theme_settings;
    window.Shopify = mockData.Shopify;
  }
  initializeTheme();
  function isPlainObject(v) {
    return Object.prototype.toString.call(v) === "[object Object]";
  }
  function safeMerge(target, source, depth = 0) {
    console.warn("safeMerge begin", source);
    console.warn("safeMerge is plain object", !isPlainObject(source));
    if (!isPlainObject(target) || !isPlainObject(source)) return target;
    console.warn("safeMerge after first if", source);
    for (const k of Object.keys(source)) {
      if (depth === 0 && !(k in target)) continue;
      const sv = source[k], tv = target[k];
      if (k == "selectedLastStep") {
        console.warn("safeMerge if(depth === 0 && !(k in target)) continue;", k);
        console.warn("safeMerge const sv = source[k], tv = target[k]", sv);
        console.warn("safeMerge tvtvtv  Array.isArray(tv)", Array.isArray(tv));
        console.warn("safeMerge svsvsv Array.isArray(sv)", Array.isArray(sv));
        console.warn("safeMerge tvtvtv isPlainObject(tv)", isPlainObject(tv));
        console.warn("safeMerge svsvsv isPlainObject(tv)", isPlainObject(sv));
      }
      if (tv === void 0) {
        target[k] = sv;
        continue;
      }
      if (Array.isArray(tv)) {
        if (Array.isArray(sv) || isPlainObject(sv)) {
          target[k] = sv;
          if (k == "selectedLastStep") {
            console.warn("safeMerge  target[k] = sv;", sv);
          }
        } else {
          target[k] = tv;
          if (k == "selectedLastStep") {
            console.warn("safeMerge target[k] = tv;", sv);
          }
        }
      } else if (isPlainObject(tv)) {
        if (k == "selectedLastStep") {
          console.warn("safeMerge 1111 tv", tv);
          console.warn("safeMerge 1111 { ...tv }", { ...tv });
          console.warn("safeMerge 1111 const sv = source[k], tv = target[k]", isPlainObject(sv));
        }
        target[k] = safeMerge({ ...tv }, isPlainObject(sv) ? sv : {}, depth + 1);
      } else if (typeof tv === "number") {
        const n = typeof sv === "number" ? sv : typeof sv === "string" ? Number(sv) : NaN;
        target[k] = Number.isFinite(n) ? n : tv;
      } else if (typeof tv === "string") {
        target[k] = typeof sv === "string" ? sv : tv;
      } else if (typeof tv === "boolean") {
        target[k] = typeof sv === "boolean" ? sv : tv;
      }
    }
    console.log(
      "[Persist][MERGE][after]",
      "store.selectedLastStep=",
      target.selectedLastStep,
      "type=",
      typeof target.selectedLastStep,
      "store.colorSizeLines.type=",
      Array.isArray(target.colorSizeLines) ? "array" : typeof target.colorSizeLines,
      "store.colorSizeLines.len=",
      Array.isArray(target.colorSizeLines) ? target.colorSizeLines.length : "n/a"
    );
    return target;
  }
  function _typeOf(v) {
    return Array.isArray(v) ? "array" : v === null ? "null" : typeof v;
  }
  function _shape(obj) {
    const out = {};
    for (const k of Object.keys(obj || {})) {
      const v = obj[k];
      out[k] = {
        type: _typeOf(v),
        sizeHint: Array.isArray(v) ? v.length : v && typeof v === "object" ? Object.keys(v).length : typeof v === "string" ? v.length : ""
      };
    }
    return out;
  }
  (function hydrate() {
    const LS_KEY2 = "imprintUserDataV1";
    try {
      const raw = localStorage.getItem(LS_KEY2);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!isPlainObject(parsed)) return;
      const slice = {};
      for (const k of PERSIST_KEYS) if (k in parsed) slice[k] = parsed[k];
      console.groupCollapsed("🧪 [Hydrate] LS parsed (full) shape");
      console.table(_shape(parsed));
      console.groupEnd();
      console.groupCollapsed("🧪 [Hydrate] whitelist slice shape");
      console.table(_shape(slice));
      console.log("slice raw:", slice);
      console.groupEnd();
      console.groupCollapsed("🧪 [Hydrate] store BEFORE merge shape");
      console.table(_shape(store));
      console.groupEnd();
      console.log(
        "🧪 Hydrate check key presence:",
        "selectedLastStep" in store,
        store.selectedLastStep
      );
      safeMerge(store, slice);
      console.groupCollapsed("🧪 [Hydrate] store AFTER merge shape");
      console.table(_shape(store));
      console.log("store raw:", store);
      console.groupEnd();
      console.log("♻️ [Vue Imprint] Restored user data (safe whitelist merge)");
      console.log("♻️ [Vue Imprint] Store data", store);
    } catch (e) {
      console.warn("[Vue Imprint] Restore failed:", e);
    }
  })();
  function mountVue() {
    const targetSel = "#section-image-with-text-c";
    const target = document.querySelector(targetSel);
    if (!target) {
      console.warn("[Vue Imprint] Mount target not found:", targetSel, "readyState=", document.readyState);
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", mountVue, { once: true });
      } else {
        setTimeout(mountVue, 200);
      }
      return;
    }
    const app = createApp(App);
    const pinia = createPinia();
    app.use(pinia);
    app.use(customStyles);
    app.component("ErrorModal", ErrorModal);
    app.use(LoggerPlugin);
    app.mount(targetSel);
    console.log("✅ [Vue Imprint] Vue mounted on", targetSel);
    window.__testErr = () => {
      window.dispatchEvent(new CustomEvent("add-to-cart-error", { detail: { message: "Test from __testErr" } }));
    };
  }
  mountVue();
})();
//# sourceMappingURL=app.js.map
